<template>
    <div class="app has-header" v-bind:class="{'loading-roster': loading, 'day-mode' : dayMode, 'day-spot-icon-switch': rosterVisibilityState.daySpotColorSwitch}">


        <div class="mockup" v-bind:style="{display : (mockupToggle ? 'inline-block' : 'none')}"></div>

        <div class="header buttonheader" style="z-index: 10">


            <div class="align-left">
                <dateselectionheader
                        :label="monthDisplay"
                        @PrevDate="setDateSelection(dateSelectionStart.add(-1, 'month'), true)"
                        @NextDate="setDateSelection(dateSelectionStart.add(1, 'month'), true)"
                        @CalendarOpen="toggleDatePicker"
                        @SetToday="setDateSelection($helpers.getCurrentMonthMomentTZ(), true)"/>
            </div>

            <div class="align-middle">
                <headerbuttonstack :state="headerButtons"/>
            </div>

            <div class="align-right">
                <headerbuttonstack :state="sideButtons"/>

            </div>


        </div>




        <div id="rosterscrollcontainer" v-bind:style="{'overflow-x': dayMode? 'hidden' : 'auto'}" class="scrollbar-container" v-bind:class="{show: employeeSelected !== null, 'show-unassigned': showUnassigned, 'business-sort': businessSortToggle, 'pd-expanded': displayPdChart && renderPdChart, 'pd-minimized': !displayPdChart && renderPdChart}" v-on:scroll="ShiftFixedElements($event)">
            <div class="sub-header" v-show="dayMode">
                <div class="title" v-bind:style="{width: GetWidthFirstTitle()}">
                    <div class="label ">{{dayModeDate.format("ddd DD.MM.")}}</div>
                </div>
                <div class="title second" v-bind:style="{width: GetWidthSecondTitle(), display: dayModeHours < 36 ? 'none' : ''}">
                    <div class="label ">{{dayModeDate.clone().add(1,'day').format("ddd DD.MM.")}}</div>
                </div>
            </div>
            <div class="sub-header-button-container" v-bind:style="{ height: rosterVisibilityState.visibilityKeyFigures ? 'calc(' + keyFiguresHeight + ' + 113px)' : '113px'}">
                <table class="key-figure key-figure-table" v-if="rosterVisibilityState.visibilityKeyFigures">
                    <tbody v-bind:key="keyFigure.name" v-for="keyFigure in getKeyFigures(gridWeekInfo[firstDay].date)">
                    <tr>
                        <td class="key-figure">{{ keyFigure.name }}</td>
                    </tr>
                    </tbody>
                </table>
                <div class="sub-header-row">
                    <buttonc type="square" icon="fa-filter" @click="OpenFilterPopup"/>
                    <buttonc type="square" icon="fa-chart-line" @click="OpenStatisticsPopup"/>
                    <buttonc type="square" :icon="employeeSelected ? 'fa-angle-left' : 'fa-angle-right'"
                        @click="employeeSelected == null? SelectEmployee($event,employees[0]) : employeeSelected = null" v-if="!dayMode"
                        v-tooltip="$t('roster.view.toggleHourOverview')"
                        v-bind:class="{'plannedActual-active': employeeSelected != null}"
                    />
                </div>
                <div class="sub-header-row expand-productivity"
                     v-if="rosterVisibilityState.visibilityProductivity && !dayMode && rosterVisibilityState.visibilityProductivityNew "
                     @click="employeeSelected == null ? productivityExpanded = !productivityExpanded : null">
                    <span class="productivity-header">{{ $t('roster.view.productivity') }}:</span>
                    <i class="fas fa-angle-right productivity-expand-icon" :class="{expanded: productivityExpanded}"  v-if="employeeSelected == null"/>
                </div>
            </div>
            <div class="grid" v-bind:style="{ top: rosterVisibilityState.visibilityKeyFigures ? keyFiguresHeight : '2px' }" v-bind:class="{show: employeeSelected !== null}" v-if="!loading">

                <div class="entry header" v-if="!loading" v-bind:style="{ height: rosterVisibilityState.visibilityKeyFigures ? 'calc(' + keyFiguresHeight + ' + 113px)' : '113px' }">
                    <div class="week" v-for="indexweek in gridWeekInfo.weeks" :key="indexweek">
                        <div class="day-outer" v-for="index in gridWeekInfo['w'+indexweek].indices" :key="(indexweek-1)*7+index" v-show="!dayMode">
                            <div class="day"
                                @contextmenu.prevent.stop="openDateContextMenu($event, indexweek, index)"
                                 v-on:click="ToggleDayMode(indexweek, index)"
                                 v-bind:id="'header' + (((indexweek - 1) * 7) + index)"
                                 v-bind:day="gridWeekInfo[indexweek+'-'+index].dayString"
                                 v-bind:month="gridWeekInfo[indexweek+'-'+index].monthString"
                                 v-bind:style="{transition: dayMode ? '0s' : ''}"
                                 v-bind:date="gridWeekInfo[indexweek+'-'+index].date.format('MM-DD')"
                                 v-bind:class="{unnassigned: GetDayUnassignedShifts(indexweek, index).length > 0, 'weekend-cell': [6, 0].includes(gridWeekInfo[indexweek+'-'+index].date.day()), today: gridWeekInfo[indexweek+'-'+index].date.format('DD.MM') == $helpers.getMomentTZ().format('DD.MM')}"
                            >
                                <div class="weather" v-if="GetWeatherFromDateFormat(gridWeekInfo[indexweek+'-'+index].date.format('MM-DD'))"
                                     v-on:mouseenter="OpenWeatherPopup($event, gridWeekInfo[indexweek+'-'+index].date, false)"
                                     v-on:mouseleave="CloseWeatherPopup($event)"
                                     v-on:click="OpenWeatherPopup($event, gridWeekInfo[indexweek+'-'+index].date, true)">
                                    <img class="picture"  v-bind:style="{filter: nightMode && GetWeatherIcon(gridWeekInfo[indexweek+'-'+index].date.format('MM-DD')) === '../img/Warnung.svg' ? 'invert(1)' : ''}" v-bind:src="GetWeatherIcon(gridWeekInfo[indexweek+'-'+index].date.format('MM-DD'))"/>
                                    <div class="label">{{GetWeatherTemp(gridWeekInfo[indexweek+'-'+index].date.format('MM-DD'))}}°</div>
                                </div>
                                <div class="unnassigned-marker" @mouseover="OpenUnassignedShiftSpotListPopup($event, gridWeekInfo[indexweek+'-'+index].dateString)" @mouseleave="CloseUnassignedShiftSpotListPopup">{{GetDayUnassignedShifts(indexweek, index).length}}</div>
                                <div class="event-marker fas fa-flag" v-if="HasEventsOnThatDay(indexweek, index)" v-bind:style="GetEventsColor(indexweek, index)" @mouseover="OpenEventHover(indexweek, index,$event)" @mouseleave="CloseEventHover()"></div>

                                <div class="day-text" v-bind:class="{'colored': framedPlannedActualCalculation(gridWeekInfo[indexweek+'-'+index].date)}">
                                    <div class="name">
                                        {{ $helpers.translateDayShort(gridWeekInfo[indexweek+'-'+index].date.format('dddd').substring(0,2)) }}
                                    </div>
                                    <div class="date">
                                        {{gridWeekInfo[indexweek+'-'+index].date.format('DD').substring(0,2)}}.{{gridWeekInfo[indexweek+'-'+index].date.format('MM').substring(0,2) }}
                                    </div>
                                </div>

                                <div v-if="!rosterVisibilityState.visibilityKeyFigures">
                                    <div class="income" v-if="planningIndicator[gridWeekInfo[indexweek+'-'+index].dateString] && !rosterVisibilityState.visibilityProductivityNew" v-tooltip="GetIndicatorAmountWrapper(gridWeekInfo[indexweek+'-'+index].date)">
                                        <div class="income-bar red" v-if="planningIndicator[gridWeekInfo[indexweek+'-'+index].dateString].planned && planningIndicator[gridWeekInfo[indexweek+'-'+index].dateString].actual" v-bind:style="{width: 'calc(100% - 10px)', 'margin-left': '1px'}"></div>
                                        <div class="income-bar green" v-if="planningIndicator[gridWeekInfo[indexweek+'-'+index].dateString].actual && planningIndicator[gridWeekInfo[indexweek+'-'+index].dateString].planned" v-bind:style="{width: GetDailyIndicatorBarWidth(gridWeekInfo[indexweek+'-'+index].date)}"></div>
                                        <div class="income-bar green" v-if="!planningIndicator[gridWeekInfo[indexweek+'-'+index].dateString].planned" v-bind:style="{width: 'calc(100% - 10px)'}"></div>
                                        <div class="income-bar red" v-if="!planningIndicator[gridWeekInfo[indexweek+'-'+index].dateString].actual" v-bind:style="{width: 'calc(100% - 10px)'}"></div>
                                    </div>
                                    <div class="income" v-if="!planningIndicator[gridWeekInfo[indexweek+'-'+index].dateString]" v-tooltip="GetIndicatorAmountWrapper(gridWeekInfo[indexweek+'-'+index].date)">
                                        <div class="income-bar gray" style="width: calc(100% - 10px); margin-left: 1px;"></div>
                                    </div>
                                </div>
                                <div v-if="rosterVisibilityState.visibilityKeyFigures" :style="'height: ' + keyFiguresHeight">
                                    <table style="text-align: center; width: 100%">
                                        <tbody v-bind:key="keyFigure.name" v-for="keyFigure in getKeyFigures(gridWeekInfo[indexweek+'-'+index].date)">
                                            <tr>
                                                <td v-if="keyFigure.actual" style="height: 15.6px" class="key-figure orange-c">{{ keyFigure.actual }}</td>
                                                <td v-else style="height: 15.6px" class="key-figure green-c">{{ keyFigure.planned }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="total-unassigned-hours"  v-if="!rosterVisibilityState.visibilityProductivity"
                                     v-bind:class="{actual: shiftTimeByDayMap[gridWeekInfo[indexweek+'-'+index].dateString] && shiftTimeByDayMap[gridWeekInfo[indexweek+'-'+index].dateString].totalActual}"
                                     v-bind:style="{ top: rosterVisibilityState.visibilityKeyFigures ? 'calc(' + keyFiguresHeight + ' + 70px)' : '70px' }"
                                     @mouseover="OpenAssignedShiftSpotListPopup($event, gridWeekInfo[indexweek+'-'+index].dateString)" @mouseleave="CloseAssignedShiftSpotListPopup">
                                        {{GetSummedShiftHours(gridWeekInfo[indexweek+'-'+index].dateString)}}
                                </div>
                                <div v-if="rosterVisibilityState.visibilityProductivity && !rosterVisibilityState.visibilityProductivityNew"
                                    v-bind:style="{position: 'absolute', left: '20px',
                                    top: rosterVisibilityState.visibilityKeyFigures ? 'calc(' + keyFiguresHeight + ' + 40px)' : '40px'}">
                                    <div class="total-productivity"
                                         v-bind:style="GetProductivityStyleForDate(gridWeekInfo[indexweek+'-'+index].dateString)"
                                         @mouseover="OpenAssignedShiftSpotListPopup($event, gridWeekInfo[indexweek+'-'+index].dateString)"
                                         @mouseleave="CloseAssignedShiftSpotListPopup">
                                        {{ GetProductivityForDate(gridWeekInfo[indexweek + '-' + index].dateString) }}
                                    </div>
                                </div>
                                <div class="border-day" v-bind:class="{light: gridWeekInfo[indexweek+'-'+index].date.isoWeekday() !== 7}"></div>
                                <div class="today-box"></div>
                                <div class="shadow" v-show="dayMode"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="entry header borders" v-if="!loading">
                    <div class="week" v-for="indexweek in gridWeekInfo.weeks" :key="indexweek">
                        <div class="day-outer" v-for="index in gridWeekInfo['w'+indexweek].indices" :key="(indexweek-1)*7+index" v-show="!dayMode">
                            <div class="day">
                                <div class="border-day" v-bind:class="{light: gridWeekInfo[indexweek+'-'+index].date.isoWeekday() !== 7}"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="entry group business" v-bind:style="{height: '25px'}" v-for="(businessGroup, indexBGroup) in businessGroupsBefore" :key="indexBGroup" v-bind:class="{'collapsed' : businessGroup.collapsed}">
                        <div class="header">
                            <div class="label">{{businessGroup.label}}</div>
                            <div class="fa-stack">
                                <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fas fa-stack-2x" v-bind:class="{'fa-angle-down' : businessGroup.collapsed, 'fa-angle-up' : !businessGroup.collapsed}"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <!-- ********************************************************* -->
                    <!-- ************** EMPLOYEE GROUPS ************************** -->
                    <!-- ********************************************************* -->
                    <div class="entry group h-employee-groups" v-bind:groupindex="indexGroup"
                    v-if="draggingBusinessUnit || draggingEmployee || employeeGroup.showMajor"
                    v-bind:style="{height: employeeGroup.collapsed ? (showSpotPlanningNumbers ? '75px' : '25px') : (((50 * employeeGroup.employeesFiltered.length) + (showSpotPlanningNumbers ? 50 : 0)) + 'px'), /*'margin-bottom': (indexGroup == Object.values(employeeGroups).length - 1)? '150px':''*/}"
                    v-for="(employeeGroup, indexGroup) in employeeGroups" :key="indexGroup"
                    v-bind:class="{'collapsed' : employeeGroup.collapsed}"
                    >
                        <!-- Start EmployeeGroups, green header (label, etc) -->
                        <div class="header">
                            <div class="label" v-bind:class="[dropIndexBusinessUnit == indexGroup ? 'helperDroppable' : [employeeGroup.helper ? 'helper' : ''],employeeGroup.indentationLevel == 0 ? 'indentationLevel0' : 'indentationLevel1']"
                                v-bind:style="{background: (employeeGroup.spot && spotMap[employeeGroup.spot.id]) ? spotMap[employeeGroup.spot.id].color + ' !important' : '', color: (employeeGroup.spot && spotMap[employeeGroup.spot.id]) ? GetContrastingColor(spotMap[employeeGroup.spot.id].color) : ''}">

                                <div class="fa-stack" v-if="employeeGroup.draggable" v-on:mousedown="DragStartBusinessUnit($event, employeeGroup,indexGroup)" v-bind:style="{'margin-left': employeeGroup.indentationLevel == 0 ? '0px' : '23px'}">
                                    <i class="fas fa-circle fa-stack-2x"></i>
                                    <i class="fas fa-stack-2x fa-arrows-alt" v-bind:style="{color: (employeeGroup.spot && spotMap[employeeGroup.spot.id]) ? GetContrastingColor(spotMap[employeeGroup.spot.id].color) : ''}"></i>
                                </div>
                                {{employeeGroup.label}} <span v-if="employeeGroup.helper && dropIndexBusinessUnit == indexGroup">&gt;&gt;</span>
                            </div>


                            <div class="fa-stack add" v-on:click="OpenBusinessUnitPopup($event)" v-if="!employeeGroup.helper">
                                <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fas fa-stack-2x fa-plus"></i>
                            </div>


                            <div class="fa-stack" v-on:click="employeeGroup.collapsed = !employeeGroup.collapsed" v-if="!employeeGroup.helper">
                                <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fas fa-stack-2x" v-bind:class="{'fa-angle-down' : employeeGroup.collapsed, 'fa-angle-up' : !employeeGroup.collapsed}"></i>
                            </div>
                        </div>
                        <div class="employee-hours buheader" v-bind:class="{show: employeeSelected !== null}" v-if="employeeSelected !== null">
                            <div class="full">

                            </div>
                        </div>
                        <!-- TODO -->
                        <div v-if="showSpotPlanningNumbers" class="hour-grid-group" v-bind:class="{'full-two': dayModeHours === 48,'full-half': dayModeHours === 36, full: dayModeHours === 24, half: dayModeHours === 12 ,quarter: dayModeHours === 6, 'show-unassigned': showUnassigned}">
                            <div class="time-marks">
                               <div class="mark" v-for="indexHour in dayModeHours" style="padding-top: 15px" v-bind:class="{am: parseInt(dayModeDate.clone().add(indexHour, 'hours').format('HH')) < 13, 'day-split': parseInt(dayModeDate.clone().add(indexHour - 1, 'hours').format('HH')) === 0}" :key="indexHour">
                                    <div v-show="dayModeShowPlanningSums && !rosterVisibilityState.visibilityProductivity && storeSettings.enableVlh && useVlhForForecast" class="daymode-hourinfo indicator" style="font-size: 12px; !important" v-tooltip="$t('shift.main.vlh')">
                                        {{ (employeeGroup.spot && dayModePlanningInfoMap[''+indexHour] && dayModePlanningInfoMap[''+indexHour].spots && dayModePlanningInfoMap[''+indexHour].spots.find(s => s.spotId == employeeGroup.spot.id)) ? dayModePlanningInfoMap[''+indexHour].spots.find(s => s.spotId == employeeGroup.spot.id).planned : '0.00' }}
                                    </div>
                                    <div v-show="dayModeShowPlanningSums && !rosterVisibilityState.visibilityProductivity && storeSettings.enableMeo && !useVlhForForecast" class="daymode-hourinfo indicator" style="font-size: 12px; !important" v-tooltip="$t('shift.main.meo')">
                                        {{ (employeeGroup.spot && dayModePlanningInfoMap[''+indexHour] && dayModePlanningInfoMap[''+indexHour].spots && dayModePlanningInfoMap[''+indexHour].spots.find(s => s.spotId == employeeGroup.spot.id)) ? dayModePlanningInfoMap[''+indexHour].spots.find(s => s.spotId == employeeGroup.spot.id).planned : '0.00' }}
                                    </div>
                                    <div v-show="!dayModeShowPlanningSums || rosterVisibilityState.visibilityProductivity || !(storeSettings.enableVlh || storeSettings.enableMeo)" class="daymode-hourinfo indicator" style="font-size: 12px; !important" v-tooltip="''">
                                        -
                                    </div>
                                    <div class="daymode-hourinfo planned" style="font-size: 12px; !important" v-tooltip="$t('roster.view.shiftPlanned')">
                                        {{ (employeeGroup.spot && dayModeInfoMap[''+indexHour] && dayModeInfoMap[''+indexHour].spots && dayModeInfoMap[''+indexHour].spots[employeeGroup.spot.id]) ? dayModeInfoMap[''+indexHour].spots[employeeGroup.spot.id].planned : '0.00h' }}
                                    </div>
                                    <div v-show="actualShiftDateMap[dayModeDate.format('YYYY-MM-DD')] && actualShiftDateMap[dayModeDate.format('YYYY-MM-DD')].length > 0" class="daymode-hourinfo actual" style="font-size: 12px; !important" v-tooltip="$t('roster.view.punchedTimes')">
                                        {{ (employeeGroup.spot && dayModeInfoMap[''+indexHour] && dayModeInfoMap[''+indexHour].spots && dayModeInfoMap[''+indexHour].spots[employeeGroup.spot.id]) ? dayModeInfoMap[''+indexHour].spots[employeeGroup.spot.id].assigned : '0.00h' }}
                                    </div>
                                    <div v-show="!(actualShiftDateMap[dayModeDate.format('YYYY-MM-DD')] && actualShiftDateMap[dayModeDate.format('YYYY-MM-DD')].length > 0)" class="daymode-hourinfo" style="font-size: 12px; !important" v-tooltip="$t('roster.view.assignedShifts')">
                                        {{ (employeeGroup.spot && dayModeInfoMap[''+indexHour] && dayModeInfoMap[''+indexHour].spots && dayModeInfoMap[''+indexHour].spots[employeeGroup.spot.id]) ? dayModeInfoMap[''+indexHour].spots[employeeGroup.spot.id].assigned : '0.00h' }}
                                    </div>

                                </div>
                            </div>

                        </div>
                        <!-- End EmployeeGroups, green header (label, etc) -->


                        <div class="entry" v-if="employeeGroup.show && !(employeeGroup.collapsed)" v-for="(employee, index) in employeeGroup.employees" :key="employee.id"
                        v-bind:style="{display: !employeeGroup.employeesFiltered.find(e => e === employee) ? 'none !important' : ''}">
                            <div class="employee"
                            v-bind:id="employee.id"
                            v-bind:style="GetEmployeeStyles()"
                            v-bind:class="{'showSpotPlanningNumbers': showSpotPlanningNumbers, indentationLevelEmployee0: employeeGroup.indentationLevel == 0, indentationLevelEmployee1 : employeeGroup.indentationLevel == 1, show: employeeSelected != null}">
                                <div class="picture" v-bind:style="{ background: (employee !== null && !anonMode ? employee.picture : 'url(../img/default.jpg)')}" v-on:mousedown="DragStartEmployee($event, employeeGroup,indexGroup,employee)"></div>
                                <div class="namefirst" @click="navigateToEmployee(employee)" v-bind:style="{'max-width' : (employeeGroup.indentationLevel == 0) ? '120px' : '100px', 'color': $helpers.isUnderage(employee.dob, startOfMonth, true) ? 'red' : ''}">{{anonMode ? $t('roster.view.anonymousEmployee') : employee.lastName + ' ' + employee.firstName}}</div>
                                <div class="namefirst shadow" v-bind:style="{'width' : (employeeGroup.indentationLevel == 0) ? '115px' : '95px'}">{{anonMode ? $t('roster.view.anonymousEmployee') : employee.lastName + ' ' + employee.firstName}}</div>
                                                                <!-- <div class="namelast"> TEST </div> -->

                                <div v-on:click.stop="OpenPlannedActualPopup($event, employee)" style="cursor:pointer;">
                                    <plannedActualbar ref="plannedActualbars"
                                        :firstName="employee ? employee.firstName : null"
                                        :lastName="employee ? employee.lastName : null"
                                        :employee="employee"
                                        :indentationLevel="employeeGroup.indentationLevel"/>
                                </div>
                                <!--
                                <div v-if="employeePlannedActual[employee.id].vertrag > 0 && !employeePlannedActual[employee.id].balance_found" style="width: 200px; font-size: 9px; color: #000; text-align: left; height: 15px; white-space: nowrap; font-weight: 800; margin-top: -13px; margin-left: 5px; text-shadow: 2px 2px 4px #fff;">
                                    Kein Monatsabschluss
                                </div>--><!-- #e5154f -->


                                <div
                                v-bind:style="{'margin-left' : (employeeGroup.indentationLevel == 0) ? '174px' : '154px' }"
                                style="width: 30px; height: 30px; margin-top:-31px;">
                                    <div class="fa-stack detail"
                                    v-bind:style="{'left' : (employeeGroup.indentationLevel == 0) ? '218px' : '198px', 'z-index': 99}" v-on:click="OpenEmployeeDetails($event, employee)">
                                        <i style="font-size:25px; right:0px;" class="fas fa-circle fa-stack-2x"></i>
                                        <i style="font-size:25px; margin-left:-1px;" class="fas fa-tasks-alt fa-stack-2x"></i>
                                    </div>
                                    <div class="fa-stack skill"
                                    v-bind:style="{'left' : (employeeGroup.indentationLevel == 0) ? '218px' : '198px', 'z-index': 99}">
                                        <i style="font-size:25px; right:0px;" class="fas fa-circle fa-stack-2x"></i>
                                        <i v-bind:style="getStarStyles(employee)" class="fas fa-star fa-stack-2x"></i>
                                    </div>
                                </div>

                                <div class="employee-hours entry show" style=" cursor:default;"
                                    v-bind:style="{'margin-left' : (employeeGroup.indentationLevel == 0) ? '-5px' : '-25px' }"
                                    v-if="employeeSelected">
                                    <div class="full hourstableentry" style="overflow: hidden; cursor:default;" v-bind:class="{last: index == employeeGroup.employees.length - 1}">
                                        <div class="fourth exact hourstableentry" style="overflow: hidden;" @mouseover="OpenPlannedActualHover(employee,'soll', $event)" @mouseleave="ClosePlannedActualHover()">
                                            <div class="label">{{ (employeePlannedActual[employee.id].sumSollWorkTime/1000/3600).toFixed(2) }}</div>
                                        </div>
                                        <div class="fourth exact hourstableentry border-left" style="overflow: hidden;" @mouseover="OpenPlannedActualHover(employee,'productive', $event)" @mouseleave="ClosePlannedActualHover()">
                                            <div class="label">{{ (employeePlannedActual[employee.id].sumWorkTimeProduktiv/1000/3600).toFixed(2) }}</div>
                                        </div>
                                        <div class="fourth exact hourstableentry border-left" style="overflow: hidden;" @mouseover="OpenPlannedActualHover(employee,'unproductive', $event)" @mouseleave="ClosePlannedActualHover()">
                                            <div class="label">{{ (employeePlannedActual[employee.id].sumWorkTimeUnproduktiv/1000/3600).toFixed(2) }}</div>
                                        </div>
                                        <div class="fourth exact hourstableentry border-left" style="overflow: hidden;" @mouseover="OpenPlannedActualHover(employee,'federalholiday', $event)" @mouseleave="ClosePlannedActualHover()">
                                            <div class="label">{{ (employeePlannedActual[employee.id].sumFtWorkTime/1000/3600 + employeePlannedActual[employee.id].deltaFtWorkTime/1000/3600).toFixed(2) }}</div>
                                        </div>
                                    </div>
                                </div>

                            </div>



                            <div class="week" v-for="indexweek in gridWeekInfo.weeks" :key="indexweek">

                                <div class="day-outer" style="border-radius:0px;"

                                     v-bind:weekday="gridWeekInfo[indexweek+'-'+index].weekday"
                                    v-show="!dayMode" v-for="index in gridWeekInfo['w'+indexweek].indices" :key="(indexweek-1)*7+index">

                                    <div class="day" v-on:mouseover="Hovering((indexweek-1)*7+index, employee)" v-on:mouseleave="EndHovering((indexweek-1)*7+index, employee)"
                                         v-bind:employeeId="employee.id"
                                        v-bind:class="[{ Green: !employeeDayStatusMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].hasPreview && rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].showInRoster == 'plan' && !rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].external},
                                                       { Yellow: employeeDayStatusMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].hasPreview && rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].showInRoster == 'plan'},
                                                       { Orange: rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].showInRoster == 'ist' && true /* && confirmed */},

                                                       { Undesired: rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].showInRoster == 'undesired'},
                                                       { Desired: rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].showInRoster == 'desired'},

                                                       {'in-range': employeeDayStatusMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].inRange},
                                                       {'out-of-range': !employeeDayStatusMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].inRange}]"
                                        v-bind:date="gridWeekInfo[indexweek+'-'+index].dateString"
                                        v-bind:day="gridWeekInfo[indexweek+'-'+index].dayString"
                                        v-bind:month="gridWeekInfo[indexweek+'-'+index].monthString"
                                         v-bind:year="gridWeekInfo[indexweek+'-'+index].yearString"
                                        v-on:mousedown="DragStartShift($event, rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].planShifts)"
                                        v-on:mouseup.left="OpenDayPopup($event,employee.id,indexweek, index)"
                                        v-if="rosterContentMap[employee.id] && employeeDayStatusMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString]"
                                        v-tooltip="rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].tooltip">

                                        <div @contextmenu.prevent.stop="openShiftContextMenu($event, indexweek, index, employee)" v-if="(rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].showInRoster == 'plan')">
                                            <i class="fas fa-eye-slash" v-if="employeeDayStatusMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].hasUnpublished"
                                               v-bind:style="{background: switchedColor ? GetSwitchedShiftColor(employee, gridWeekInfo[indexweek+'-'+index].dateString) + '!important' : ''}"></i>
                                            <i class="lock-icon fas fa-lock" v-if="employeeDayStatusMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].hasLocked"
                                               v-bind:style="{background: switchedColor ? GetSwitchedShiftColor(employee, gridWeekInfo[indexweek+'-'+index].dateString) + '!important' : ''}"></i>

                                            <i class="pin-icon fas fa-thumbtack" v-else-if="employeeDayStatusMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].hasPinned"
                                               v-bind:style="{background: switchedColor ? GetSwitchedShiftColor(employee, gridWeekInfo[indexweek+'-'+index].dateString) + '!important' : ''}"></i>
                                            <i class="exclamation fas fa-exclamation" v-if="employeeDayStatusMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].hasEnforced"
                                               v-bind:style="{background: switchedColor ? GetSwitchedShiftColor(employee, gridWeekInfo[indexweek+'-'+index].dateString) + '!important' : '',
                                               right: employeeDayStatusMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].hasUnpublished ? '6px !important' : ''}"></i>

                                            <div class="spot-icon" v-if="employeeDayStatusMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].hasShift" v-bind:style="{background: GetDayBottomLeftIconColor(employee, gridWeekInfo[indexweek+'-'+index].dateString), border: switchedColor ? ('1px solid ' + GetSwitchedShiftColor(employee, gridWeekInfo[indexweek+'-'+index].dateString, true)) : ''}"></div>
                                            <div class="fas bottom-right fa-thumbs-up" v-if="rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString] && rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].desiredPreferenceMatched"></div>
                                            <div class="fas bottom-right fa-tilde" v-if="rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString] && rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].desiredPreferenceNotMatched"></div>
                                            <div class="fas bottom-right fa-thumbs-down" v-if="rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString] && rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].undesiredPreferenceMatched"></div>
                                            <div class="fas bottom-right fa-birthday-cake" v-if="rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString] && rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].isBirthDay"></div>
                                            <div class="fas bottom-right fa-sack" v-if="rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString] && rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].hasExtraPayment"></div>

                                            <div class="name" v-if="rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].planLow != null"
                                                 v-bind:style="{background: switchedColor && !employeeDayStatusMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].hasPreview ? GetSwitchedShiftColor(employee, gridWeekInfo[indexweek+'-'+index].dateString) + '!important' : ''}">
                                                {{rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].planLowText}}
                                            </div>
                                            <div class="date" v-if="rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].planHigh != null"
                                                 v-bind:style="{background: switchedColor && !employeeDayStatusMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].hasPreview ? GetSwitchedShiftColor(employee, gridWeekInfo[indexweek+'-'+index].dateString, true) + '!important' : ''}">
                                                {{rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].planHighText}}
                                            </div>

                                        </div>

                                        <div v-if="rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].showInRoster == 'ist'">
                                            <div class="spot-icon" v-if="employeeDayStatusMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].hasShift" v-bind:style="{background: GetDayBottomLeftIconColor(employee, gridWeekInfo[indexweek+'-'+index].dateString), border: switchedColor ? ('1px solid ' + GetSwitchedShiftColor(employee, gridWeekInfo[indexweek+'-'+index].dateString, true)) : ''}"></div>
                                            <div class="confirmed fas fa-lock" v-if="checkIfConfirmedActual(employee, indexweek, index)"></div>
                                            <div class="name" v-if="rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].actualLow != null"
                                                 v-bind:style="{background: switchedColor ? GetSwitchedShiftColor(employee, gridWeekInfo[indexweek+'-'+index].dateString) + '!important' : ''}">
                                                {{rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].actualLowText}}
                                            </div>
                                            <div class="date" v-if="rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].actualHigh != null"
                                                 v-bind:style="{background: rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].hasEndMissing ? '#879d53 !important': (switchedColor ? GetSwitchedShiftColor(employee, gridWeekInfo[indexweek+'-'+index].dateString, true) + '!important' : '')}">
                                                {{rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].actualHighText}}
                                            </div>
                                        </div>


                                        <div v-if="rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].showInRoster == 'icon' && employeeDayStatusMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].iconState.visible" class="icon-container">
                                            <div v-bind:class="[employeeDayStatusMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].iconState.class]">
                                                <i v-bind:class="employeeDayStatusMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].iconState.icon" v-tooltip="employeeDayStatusMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].iconState.tooltip"></i>

                                            </div>
                                        </div>



                                        <div class="shift-count" v-if="rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].actualShifts.length > 1"
                                             v-bind:style="{background: switchedColor ? GetSwitchedShiftColor(employee, gridWeekInfo[indexweek+'-'+index].dateString, true) + '!important' : ''}">
                                             {{rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].actualShifts.length}}
                                        </div>
                                        <div class="shift-count" v-else-if="rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].planShifts.length > 1"
                                             v-bind:style="{background: switchedColor ? GetSwitchedShiftColor(employee, gridWeekInfo[indexweek+'-'+index].dateString, true) + '!important' : ''}">
                                             {{rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].planShifts.length}}
                                        </div>
                                        <div class="template-flag fas fa-plus" v-if="rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].showInRoster == 'plan' && rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].planShifts.filter(s => !s.templateId).length > 0" v-bind:style="{left: employeeDayStatusMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].hasLocked || employeeDayStatusMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].hasPinned? '8px': ''}">
                                        </div>
                                        <div class="template-flag fas fa-plus" v-if="rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].showInRoster == 'ist' && rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].actualShifts.filter(s => s.shiftMissing).length > 0" v-bind:style="{left: employeeDayStatusMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].hasLocked? '8px': ''}">
                                        </div>
                                    </div>

                                    <div class="weekend-shadow"></div>
                                    <div v-if="HasHolidayEventsOnThatDay(indexweek, index)" class="holiday-bg"></div>
                                    <div class="legal-check" v-if="rosterContentMap[employee.id] && rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString] && rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].bgColor !== ''" v-bind:style="{'background' : rosterContentMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].bgColor}"></div>
                                </div>
                            </div>
                            <div class="table" v-if="dayMode" v-bind:class="[employee.dayModeClasses]" v-bind:style="GetTableStyles()">
                                <timebar :visibilityState="visibilityState" :eventProp="GetTimeBarProp(employee, dayModeDate)" :employeeId="employee ? employee.id : null" :spot="employeeGroup.spot" @timebar-update-shift="onTimebarUpdateShift" />
                            </div>
                        </div>
                    </div>
                    <!-- ********************************************************* -->
                    <!-- ************** END EMPLOYEE GROUPS ********************** -->
                    <!-- ********************************************************* -->

                    <!-- EXTERNAL SHIFTS -->
                    <div class="entry group h-employee-groups"
                    v-bind:style="{height: ((50 * Object.values(externalEmployeeGroup).length) + 'px')}"
                    v-if="Object.values(externalEmployeeGroup).length > 0">
                        <!-- Start EmployeeGroups, green header (label, etc) -->
                        <div class="header">
                            <div class="label" v-bind:class="'indentationLevel0'">
                                {{ $t('global.general.externalEmployee') }}
                            </div>
                        </div>

                        <!-- End EmployeeGroups, green header (label, etc) -->


                        <div class="entry" v-for="(employee, index) in Object.values(externalEmployeeGroup)" :key="employee.id" >
                            <div class="employee"
                            v-bind:id="employee.id"
                            v-bind:style="GetEmployeeStyles()"
                            v-bind:class="{indentationLevelEmployee0: true, show: true}">
                                <div class="picture" v-bind:style="{ background: (employee !== null && !anonMode ? employee.picture : 'url(../img/default.jpg)')}"></div>
                                <div class="namefirst" v-bind:style="{'max-width' :  '120px'}">{{anonMode ? $t('roster.view.anonymousEmployee') : employee.lastName + ' ' + employee.firstName}}</div>
                                <div class="namefirst shadow" v-bind:style="{'width' : '115px'}">{{anonMode ? $t('roster.view.anonymousEmployee') : employee.lastName + ' ' + employee.firstName}}</div>
                                <div class="externalstore">{{employee.storeName}}</div>
                            </div>



                            <div class="week" v-for="indexweek in gridWeekInfo.weeks" :key="indexweek">

                                <div class="day-outer" style="border-radius:0px;" v-bind:weekday="gridWeekInfo[indexweek+'-'+index].weekday" v-show="!dayMode" v-for="index in gridWeekInfo['w'+indexweek].indices" :key="(indexweek-1)*7+index">

                                    <div class="day" v-bind:employeeId="employee.id"
                                         v-bind:class="[{'in-range': employeeDateExternalShiftMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].inRange},
                                                       {'out-of-range': !employeeDateExternalShiftMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].inRange}]"
                                        v-bind:date="gridWeekInfo[indexweek+'-'+index].dateString"
                                        v-bind:day="gridWeekInfo[indexweek+'-'+index].dayString"
                                        v-bind:month="gridWeekInfo[indexweek+'-'+index].monthString"
                                        v-bind:year="gridWeekInfo[indexweek+'-'+index].yearString"
                                        v-texttooltip="employeeDateExternalShiftMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].tooltip"

                                        >
                                        <!-- v-on:mouseup.left="OpenDayPopup($event,employee.id,indexweek, index)"-->
                                        <div>
                                            <i class="fas fa-eye-slash" v-if="!employeeDateExternalShiftMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].published"></i>
                                            <i class="lock-icon fas fa-lock" v-if="employeeDateExternalShiftMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].confirmed"></i>

                                            <i class="pin-icon fas fa-thumbtack" v-else-if="employeeDateExternalShiftMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].pinned"></i>

                                            <div class="name" v-if="employeeDateExternalShiftMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].min != null">
                                                {{employeeDateExternalShiftMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].min.format("HH:mm")}}
                                            </div>
                                            <div class="date" v-if="employeeDateExternalShiftMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].max != null">
                                                {{employeeDateExternalShiftMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].max.format("HH:mm")}}
                                            </div>

                                        </div>


                                        <div class="shift-count" v-if="employeeDateExternalShiftMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].planshifts.length > 1">
                                             {{employeeDateExternalShiftMap[employee.id][gridWeekInfo[indexweek+'-'+index].dateString].planshifts.length}}
                                        </div>


                                    </div>

                                    <div class="weekend-shadow"></div>
                                    <div v-if="HasHolidayEventsOnThatDay(indexweek, index)" class="holiday-bg"></div>

                                </div>
                            </div>
                            <div class="table" v-if="dayMode"  v-bind:style="GetExternalTableStyles()">
                                <timebar :visibilityState="visibilityState" :eventProp="GetTimeBarProp(employee, dayModeDate)" />
                            </div>
                        </div>
                    </div>



                <div>
                    <div class="entry group business" v-bind:style="{height: '25px'}" v-for="(businessGroup, indexBAGroup) in businessGroupsAfter" :key="indexBAGroup" v-bind:class="{'collapsed' : businessGroup.collapsed}">
                        <div class="header">
                            <div class="label">{{businessGroup.label}}</div>
                            <div class="fa-stack">
                                <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fas fa-stack-2x" v-bind:class="{'fa-angle-down' : businessGroup.collapsed, 'fa-angle-up' : !businessGroup.collapsed}"></i>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>


            <productivity-popup v-if="rosterVisibilityState.visibilityProductivity && !dayMode && rosterVisibilityState.visibilityProductivityNew"
                                :productivities-daily="productivitiesDaily"
                                :expanded="productivityExpanded"
                                :display-indicator-type="displayIndicatorType"
                                :round-productivity="rosterVisibilityState.visibilityRoundProductivity"
                                :style="{left: '261px', marginTop: rosterVisibilityState.visibilityKeyFigures ? 'calc(' + keyFiguresHeight + ' + 145px)' : '145px', zIndex: employeeSelected == null ? 11 : 9}"
                                @cell-mouse-over="(event, date) => OpenAssignedShiftSpotListPopup(event, date, 28)"
                                @cell-mouse-leave="CloseAssignedShiftSpotListPopup"
            ></productivity-popup>


            <div class="hour-grid" v-bind:class="{'full-two': dayModeHours === 48,'full-half': dayModeHours === 36, full: dayModeHours === 24, half: dayModeHours === 12 ,quarter: dayModeHours === 6}" v-if="dayMode">
                <div class="time-marks">
                    <div class="mark" v-for="indexHour in dayModeHours" v-bind:class="{am: parseInt(dayModeDate.clone().add(indexHour, 'hours').format('HH')) < 13, 'day-split': parseInt(dayModeDate.clone().add(indexHour - 1, 'hours').format('HH')) === 0}" :key="indexHour">

                    </div>
                </div>

            </div>
            <div class="hour-grid labels" v-bind:class="{'full-two': dayModeHours === 48,'full-half': dayModeHours === 36, full: dayModeHours === 24, half: dayModeHours === 12 ,quarter: dayModeHours === 6}" v-if="dayMode">
                <div class="time-marks">
                    <div class="mark" v-for="indexHour in dayModeHours" v-bind:class="{am: parseInt(dayModeDate.clone().add(indexHour, 'hours').format('HH')) < 13, 'day-split': parseInt(dayModeDate.clone().add(indexHour - 1, 'hours').format('HH')) === 0}" :key="indexHour">
                        <div v-show="rosterVisibilityState.visibilityProductivity">

                            <div class="daymode-hourinfo indicator" style="font-size: 12px; !important" v-tooltip="''">
                                -
                            </div>

                            <div class="daymode-hourinfo planned" style="font-size: 12px; !important" v-tooltip="planningIndicatorTypeMap[displayIndicatorType] ? planningIndicatorTypeMap[displayIndicatorType].name: $t('roster.view.keyFigure') ">
                                {{dayModeInfoMap[''+indexHour] && dayModeInfoMap[''+indexHour].planned ? dayModeInfoMap[''+indexHour].indicatorValue : '-' }}
                            </div>
                            <div v-show="actualShiftDateMap[dayModeDate.format('YYYY-MM-DD')] && actualShiftDateMap[dayModeDate.format('YYYY-MM-DD')].length > 0" class="daymode-hourinfo actual" style="font-size: 12px; !important" v-tooltip="$t('roster.view.targetProductivity')">
                                {{dayModeInfoMap[''+indexHour] && dayModeInfoMap[''+indexHour].assigned ? dayModeInfoMap[''+indexHour].productivity : '-' }}
                            </div>
                            <div v-show="!(actualShiftDateMap[dayModeDate.format('YYYY-MM-DD')] && actualShiftDateMap[dayModeDate.format('YYYY-MM-DD')].length > 0)" class="daymode-hourinfo" style="font-size: 12px; !important" v-tooltip="$t('roster.view.planProductivity')">
                                {{dayModeInfoMap[''+indexHour] && dayModeInfoMap[''+indexHour].assigned ? dayModeInfoMap[''+indexHour].productivity : '-' }}
                            </div>
                        </div>
                        <div v-show="!rosterVisibilityState.visibilityProductivity">
                            <div v-show="dayModeShowPlanningSums && storeSettings.enableVlh && useVlhForForecast" class="daymode-hourinfo indicator" style="font-size: 12px; !important" v-tooltip="$t('shift.main.vlh')">
                                {{ dayModePlanningInfoMap[''+indexHour] ? dayModePlanningInfoMap[''+indexHour].planned : '0.00' }}
                            </div>
                            <div v-show="dayModeShowPlanningSums && storeSettings.enableMeo && !useVlhForForecast" class="daymode-hourinfo indicator" style="font-size: 12px; !important" v-tooltip="$t('shift.main.meo')">
                                {{ dayModePlanningInfoMap[''+indexHour] ? dayModePlanningInfoMap[''+indexHour].planned : '0.00' }}
                            </div>
                            <div v-show="!dayModeShowPlanningSums || !(storeSettings.enableVlh || storeSettings.enableMeo)" class="daymode-hourinfo indicator" style="font-size: 12px; !important" v-tooltip="''">
                                -
                            </div>

                            <div class="daymode-hourinfo planned" style="font-size: 12px; !important" v-tooltip="$t('roster.view.shiftPlanned')">
                                {{dayModeInfoMap[''+indexHour] && dayModeInfoMap[''+indexHour].planned ? dayModeInfoMap[''+indexHour].planned : '0.00h' }}
                            </div>
                            <div v-show="actualShiftDateMap[dayModeDate.format('YYYY-MM-DD')] && actualShiftDateMap[dayModeDate.format('YYYY-MM-DD')].length > 0" class="daymode-hourinfo actual" style="font-size: 12px; !important" v-tooltip="$t('roster.view.punchedTimes')">
                                {{dayModeInfoMap[''+indexHour] && dayModeInfoMap[''+indexHour].assigned ? dayModeInfoMap[''+indexHour].assigned : '0.00h' }}
                            </div>
                            <div v-show="!(actualShiftDateMap[dayModeDate.format('YYYY-MM-DD')] && actualShiftDateMap[dayModeDate.format('YYYY-MM-DD')].length > 0)" class="daymode-hourinfo" style="font-size: 12px; !important" v-tooltip="$t('roster.view.assignedShifts')">
                                {{dayModeInfoMap[''+indexHour] && dayModeInfoMap[''+indexHour].assigned ? dayModeInfoMap[''+indexHour].assigned : '0.00h' }}
                            </div>
                        </div>

                        <!-- <div class="indicator quarter" v-on:mouseleave="HideQuarterlyHover()" v-on:mouseenter="PositionQuarterlyHover($event)" v-bind:amount="GetQuarterlyIndicatorAmount(dayModeDate.clone().add(indexHour - 1, 'hours').minutes(0))" v-bind:class="GetQuarterlyIndicator(dayModeDate.clone().add(indexHour - 1, 'hours').minutes(0))"></div>
                        <div class="indicator quarter" v-on:mouseleave="HideQuarterlyHover()" v-on:mouseenter="PositionQuarterlyHover($event)" v-bind:amount="GetQuarterlyIndicatorAmount(dayModeDate.clone().add(indexHour - 1, 'hours').minutes(15))" v-bind:class="GetQuarterlyIndicator(dayModeDate.clone().add(indexHour - 1, 'hours').minutes(15))"></div>
                        <div class="indicator quarter" v-on:mouseleave="HideQuarterlyHover()" v-on:mouseenter="PositionQuarterlyHover($event)" v-bind:amount="GetQuarterlyIndicatorAmount(dayModeDate.clone().add(indexHour - 1, 'hours').minutes(30))" v-bind:class="GetQuarterlyIndicator(dayModeDate.clone().add(indexHour - 1, 'hours').minutes(30))"></div>
                        <div class="indicator quarter" v-on:mouseleave="HideQuarterlyHover()" v-on:mouseenter="PositionQuarterlyHover($event)" v-bind:amount="GetQuarterlyIndicatorAmount(dayModeDate.clone().add(indexHour - 1, 'hours').minutes(45))" v-bind:class="GetQuarterlyIndicator(dayModeDate.clone().add(indexHour - 1, 'hours').minutes(45))"></div> -->

                        <div class="label">{{dayModeDate.clone().add(indexHour -  1, 'hours').format('HH')}}</div>
                    </div>

                </div>
                <div class="amount"></div>
            </div>
            <div class="shifts" v-if="dayMode">
                <div class="return backward">
                    <div class="fa-stack" v-on:click="ShiftTimeBarsBack()">
                        <i class="fas fa-circle fa-stack-2x"></i>
                        <i class="fas fa-stack-2x fa-angle-left"></i>
                    </div>
                </div>
                <div class="return forward" v-if="dayMode">
                    <div class="fa-stack" v-on:click="ShiftTimeBarsForwards()">
                        <i class="fas fa-circle fa-stack-2x"></i>
                        <i class="fas fa-stack-2x fa-angle-right"></i>
                    </div>
                </div>
                <div class="shifts-toggle" v-on:click="showUnassigned = !showUnassigned">❮</div>
                <div class="label">{{ $t('roster.view.unfilledShifts') }}</div>
                <div class="shift add" v-on:click="OpenCreateShiftPopup($event, dayModeDate)">
                    <div class="label">{{ $t('roster.view.addShift') }}</div>
                </div>
                <div class="shift" style="margin-top: 0px; margin-bottom: 20px; width: 100%;" v-if="dynamicFilterActive">
                    <div class="label" style="background-color: #6d8d23; color:#fff;">{{ $t('roster.view.dynamicFilterActive') }}</div>
                </div>
                <shiftcontainer :header="this.$tc('pages.employeeContract.template')" :date="dayModeDate.clone()" :state="{shifts: GetUnassignedShiftsByDate(dayModeDate.format('YYYY-MM-DD')).filter(s => s.templateId), spotMap: spotMap}" :dayModeShiftsSelected="shiftsSelected" @DragStart="DragStartShiftUnassigned" @ShiftSelect="SelectShiftUnassigned"/>
                <shiftcontainer :header="$t('pages.employeeContract.noTemplate')" :date="dayModeDate.clone()" :state="{shifts: GetUnassignedShiftsByDate(dayModeDate.format('YYYY-MM-DD')).filter(s => !s.templateId), spotMap: spotMap}" :dayModeShiftsSelected="shiftsSelected" @DragStart="DragStartShiftUnassigned" @ShiftSelect="SelectShiftUnassigned"/>
            </div>
            <div class="shift-drag-overlay left"></div>
            <div class="shift-drag-overlay right"></div>


            <div class="employee-hours show interactive" v-bind:style="{left: EmployeeDataScroll()}" v-if="employeeSelected !== null">
                <div class="section title">
                    <div class="entry">
                        <div class="label">{{ $t('roster.view.hourOverview') }}</div>
                    </div>
                </div>

                <div style="font-size:10px;">
                    <div style="width: 100%; padding-left: 0px; text-align: center;">
                        <label for="modelSelect" style="position: absolute; left: 15px;"><strong>{{ $t('pages.employeeContract.model') }}: </strong>&nbsp;</label>
                        <select id="modelSelect" disabled v-model="storeSettings.workTimeMode">
                            <option value="0">{{ $t('roster.view.weeklyAverage') }}</option>
                            <option value="1">{{ $t('roster.view.inWorkDays') }}</option>
                            <option value="2">{{ $t('roster.view.inCalendarDays') }}</option>
                        </select>
                    </div>
                    <div class="full-min split-flat"></div>
                    <!-- <div style="margin-left: 4px; width: 213px;"> -->
                        <div class="full hourstableheader">
                            <div class="fourth exact hourstableheader">
                                <div class="label">{{ $t('workBalance.summary.target') }}</div>
                            </div>
                            <div class="fourth exact hourstableheader border-left">
                                <div class="label">{{ $t('roster.view.prodShort') }}</div>
                            </div>
                            <div class="fourth exact hourstableheader border-left">
                                <div class="label">{{ $t('roster.view.unProdShort') }}</div>
                            </div>
                            <div class="fourth exact hourstableheader border-left">
                                <div class="label">{{ $t('workBalance.payroll.holidayShort') }}</div>
                            </div>
                        </div>
                    <!-- </div> -->
                    <div class="full-min split-superflat"></div>
                </div>
            </div>
        </div>

        <div v-if="infoVideoOpened" class="info-video-container" @click="infoVideoOpened = false">
            <div class="info-video-sheet">
                <button class="close-video-button" @click="infoVideoOpened = false">
                    <i class="fas fa-times"></i>
                </button>
                <iframe src="https://player.vimeo.com/video/827163413?h=7a1add82af&autoplay=1&color=6d8d23&title=0&byline=0&portrait=0"
                        style="width:100%;height:100%;"
                        frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
                </iframe>
            </div>
        </div>

        <div class="pd-container" :class="{'pd-collapsed': !displayPdChart}" v-if="renderPdChart"
             :style="{ width: (dayMode && showUnassigned) ? 'calc(100% - 300px - 20px)' : null }">
            <personnel-deployment-detail class="pd-detail"
                                         :title="$t('roster.view.personnel') + ':' + $t('roster.view.usage')"
                                         @titleBarClick="togglePDSection"
                                         @openInfoVideo="infoVideoOpened = true"
                                         v-if="!loading">
                <template v-slot:before-title>
                    <i class="fa fa-chevron-up pd-section-toggle"
                       :class="{'pd-toggle-up': displayPdChart}"/>
                </template>
            </personnel-deployment-detail>

            <personnel-deployment-chart ref="pdChart"
                                        class="pd-chart"
                                        :consider-previous-month="considerPreviousMonth"
                                        :init-bar-width="getPDBarWidth()"
                                        :day="dayMode ? dayModeDate : null"
                                        :day-mode-hours="dayModeHours"
                                        :style="{width: dayMode ? 'calc(100% - 265px)' : null}"
                                        @onDayDblClick="onChartDayDblClick"
                                        v-if="!loading && displayPdChart"/>
        </div>

        <dropdown v-for="(dropdown, i) in dropdowns" :dropdown="dropdown" :key="i"/>
        <drag ref="drag"/>
        <dragbusinessunit ref="dragbusinessunit"/>
        <dragemployee ref="dragemployee"/>
        <dropdowncontainer ref="dropdowncontainer"/>
        <userselect ref="userselect"/>
        <weatherpopup ref="weatherpopup"/>
        <filterpopup ref="filterpopup"/>
        <eventhover ref="eventhover"/>
        <plannedActualhover ref="plannedActualhover"/>
        <shiftspotlistpopup ref="shiftspotlistpopup"/>
        <statisticspopup ref="statisticspopup"/>
        <dailyrosterpopup ref="dailyrosterpopup"/>
        <daypopup ref="daypopup" @update-shift="onTimebarUpdateShift" :employeePreferenceAvailabilityMap="employeePreferenceAvailabilityMap" :employeeUnapprovedPreferenceAvailabilityMap="employeeUnapprovedPreferenceAvailabilityMap"
           :employeeInfos="employeeInfos"/>
        <fta ref="fta"/>
        <plannedActualpopup ref="plannedActualpopup"/>
        <shiftcreationwithtemplate ref="planshiftcreation" :ready="ready" @refreshShifts ="refresh(true, false)"></shiftcreationwithtemplate>
        <employeeworkbalancecreation ref="employeeworkbalancecreation" ></employeeworkbalancecreation>
        <employeedetailmain ref="employeedetailpopup"></employeedetailmain>
        <rostermpexport></rostermpexport>
        <rosterbackup></rosterbackup>

        <rostersummary v-if="!hideSummary" @MountedAll="SummarySnapShot" :roster="roster" ref="rostersummary"/>
        <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
            </div>
        </div>

        <div v-if="!hideSummary" class="loading-md bg snapshots">
            <i class="fas fa-spinner" style="color: white !important"></i>
            <div class="loading-text">
            {{ $t('roster.view.createSnapshot') }}
            </div>
        </div>

        <div class="discarder" v-if="modalPublishshiftsNotification"
             @click="modalPublishshiftsNotification = false">
        </div>
        <div class="md-card" v-if="modalPublishshiftsNotification">
            <h6 class="md-card-header">
                {{ $tc('global.general.notification').toUpperCase() }}
                    {{ $t('roster.view.send').toUpperCase() }}
                <i class="fas fa-times" style="float: right" @click="modalPublishshiftsNotification = false"></i>
            </h6>
            <div class="md-card-body">
                {{ $t('roster.view.informEmployeesQuery') }}
            </div>
            <div class="right mright35">
                <buttonc type="no-border green" :label="$t('roster.view.sendNotification')" @click="sendShiftsPublishedNotification()"/>
                <buttonc type="no-border red" :label="$t('roster.view.dontSend')" @click="modalPublishshiftsNotification = false"/>
            </div>
        </div>

        <contextmenu
            :elementId="'datecontextmenu'"
            :options="dateContextMenuOptions"
            :ref="'datecontextmenu'"
            @option-clicked="dateContextMenuOptionClicked">
        </contextmenu>
        <contextmenu
            :elementId="'shiftcontextmenu'"
            :options="shiftContextMenuOptions"
            :ref="'shiftcontextmenu'"
            @option-clicked="shiftContextMenuOptionClicked">
        </contextmenu>
    </div>
</template>


<script>

import shiftcontainer from './ShiftContainer.vue';
import userselect from './UserSelect.vue';
import dropdown from '../uicomponents/dropdown.vue';
import dropdowncontainer from '../uicomponents/dropdowncontainer.vue';
import timebar from '../testroster/TimeBar.vue';
import weatherpopup from '../weathercontext/WeatherPopup.vue';
import filterpopup from '../testroster/FilterPopup.vue';
import eventhover from '../testroster/EventHover.vue';
import plannedActualhover from '../testroster/PlannedActualHover.vue';
import statisticspopup from '../testroster/StatisticsPopup.vue';
import shiftspotlistpopup from './ShiftSpotListPopup.vue';
import dailyrosterpopup from '../testroster/dailyrosterpopup.vue';
import daypopup from '../testroster/DayPopup.vue';
import fta from '../testroster/FTA.vue';
import drag from './drag.vue';
import dragbusinessunit from './dragBusinessUnit.vue';
import dragemployee from './dragEmployee.vue';
import rosterbackup from '../rostercontext/RosterBackup.vue';
import rostermpexport from '../rostercontext/RosterMPExport.vue';
import employeedetailmain from '../employeecontext/employeedetail/EmployeeDetailMain.vue';
import employeeworkbalancecreation from '../workbalancecontext/EmployeeWorkBalanceCreation.vue';

import plannedActualbar from '../testroster/PlannedActualBars.vue';
import plannedActualpopup from '../testroster/PlannedActualPopup.vue';
import rostersummary from '../testroster/RosterSummary.vue';
import shiftcreationwithtemplate from '../shiftcontext/ShiftCreationWithTemplate.vue';
import VueEventBus from '../../vue-event-bus';

import contextmenu from '../uicomponents/contextmenu.vue';

import PersonnelDeploymentChart from '../uicomponents/charts/PersonnelDeploymentChart';
import PersonnelDeploymentDetail from '../uicomponents/charts/PersonnelDeploymentDetail';

import { mapGetters } from 'vuex';
import ProductivityPopup from '@/components/testroster/ProductivityPopup.vue';


export default {
        name: 'Roster',
        components: {
            ProductivityPopup,
            dropdown,
            userselect,
            dropdowncontainer,
            timebar,
            drag,
            dragbusinessunit,
            dragemployee,
            weatherpopup,
            filterpopup,
            eventhover,
            plannedActualhover,
            statisticspopup,
            shiftspotlistpopup,
            daypopup,
            fta,
            plannedActualbar,
            plannedActualpopup,
            shiftcreationwithtemplate,
            employeedetailmain,
            employeeworkbalancecreation,
            rostermpexport,
            rostersummary,
            shiftcontainer,
            rosterbackup,
            contextmenu,
            dailyrosterpopup,
            PersonnelDeploymentChart,
            PersonnelDeploymentDetail,
        },
        data() {
            return {
                viewMode: 1,
                plannedActualMode: 1, // 0 = auflaufend , 1 = monatlich neu (überschuss immer auf 0 setzen)
                plannedActualDragging: {
                    employeeIdOld: null,
                    employeeIdNew: null,
                    shiftTimeinMinutes: 0
                },
                dragPlannedActualSnap: null,
                dragSollSnappedTime: 0,

                visibilityKVErrors: true,
                visibilityPlanErrors: true,
                visibilityShiftStatusErrors: true,
                calculatePastPlanning: false,
                visibilityOverlappingErrors: true,
                visibilityActualShifts: true,
                visibilityPlanShifts: true,
                visibilityUndesired: true,
                visibilityDesired: true,
                visibilityNotAvailable: true,
                visibilityOnlyAvailable: true,
                visibilityVacation: true,
                visibilitySick: true,
                visibilityHolidayAdjustment: true,
                visibilityEducation: true,
                visibilityWageContinuation: true,
                visibilityProductivity: true,

                productivityExpanded: false,

                dragShift: null,
                dragShiftTarget: null,
                employeeStundenToggled: false,

                clearFilterDelay: 1200,

                openRumpfWocheImg: '../img/month_open_rumpf_image.png',
                openRumpfWocheHoverImg: '../img/month_open_rumpf_image_hover.png',
                visibleRumpfImage: '../img/month_open_rumpf_image.png',

                rumpfWocheImg: '../img/month_rumpf_image.png',
                rumpfWocheHoverImg: '../img/month_rumpf_image_hover.png',
                nonVisibleRumpfImage: '../img/month_rumpf_image.png',
                employeeInfos: {},

                plannedActualMap: {},

                businessUnitColor: [
                    '#e5154f',
                    '#e5c41f',
                    '#6d8d23',
                    '#3061ad',
                    '#5fe701',
                    '#e76e13',
                    '#00c8d0',
                    '#a200b8',
                    '#808080',
                    '#e5154f',
                    '#e5c41f',
                    '#6d8d23',
                    '#3061ad',
                    '#5fe701',
                    '#e76e13',
                    '#00c8d0',
                    '#a200b8',
                    '#808080',
                    '#e5154f',
                    '#e5c41f',
                    '#6d8d23',
                    '#3061ad',
                    '#5fe701',
                    '#e76e13',
                    '#00c8d0',
                    '#a200b8',
                    '#808080',
                ],
                businessUnits: {
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: [],
                    onceSelected: function ($event, item, searchbar){
                    }
                },
                spots: {
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: [],
                    onceSelected: function ($event, item, searchbar){
                    }
                },
                loading: false,
                ready: false,
                loadingText: "",
                dateSelectionStart: undefined,
                posx: 0,
                employeeSelected: null,
                mockupToggle: false,

                dropdowns: [],
                styles: '.employee \n { \n background: black; \n }',
                dragging: false,
                dynamicFilterActive: false,
                draggingBusinessUnit: false,
                draggingEmployee: false,
                initialShowMajorDone: false,
                employees: [],
                softSkills: [],
                employeeContracts:[],
                employeeSkills:[],

                shiftChangeMap: {},
                planshifts: [],
                shiftSkills: [],
                planShiftId:"",

                shiftChangeId: "",
                employeesFiltered: [],
                dayMode: false,
                dayModeDate: null,
                dayModeShiftSelected: {},

                // this flag is used to load/show planning sums (meo/vlh) in day mode
                dayModeShowPlanningSums: false,
                useVlhForForecast: false,
                forecastData: {},
                refreshDayModePlanningInfoMap: 0,
                selectedPlanningIndicator: null,


                gridStack: [],
                employeeGroups: [],
                businessGroups: [],
                businessGroupsBefore: [],
                businessGroupsAfter: [],
                businessSortToggle: false,
                selectedUnit: null,
                dayModeHours: 24,
                showUnassigned: false,
                shiftsSelected: [],

                rawWeatherData: [],
                weather: {
                      data:[],

                },
                weatherPopupOpen: false,
                filterPopupOpen: false,
                plannedActualPopupOpen: false,
                allPlanningIndicators: {},
                planningIndicator: {},
                planningIndicatorDaily: [],
                productivitiesDaily: {},

                modalPublishshiftsNotification: false,

                sortedSpotGroups: [],
                displayedSpots: [],
                displayedSkills: [],

                softSkillsFiltered: [],
                dynamicSkillsFiltered: [],
                dropIndexBusinessUnit: 0,
                dynamicFiltering: (this.$store.state.accountPreference == null) ? false : this.$store.state.accountPreference.dynamicFilterEnabled,
                templateDaySelection: 1,
                customSpotMap: {},
                customHolidayMap: {},
                customEmployeeMap: {},
                customPlanShiftMap: {},
                customPlanShiftMapUpdated: 1,
                customShiftSkillMap:{},

                employeeDayStatusMap: {},
                rosterContentMap: {},
                legalErrorMap: {},

                mz_maxDate: 0,
                employeePlannedActual: {},

                employeeHover: {},
                hideSummary: true,
                dayModeUnassignedShiftPageTemplate: 0,
                dayModeUnassignedShiftPageNoTemplate: 0,
                dayModeUnassignedShiftsPerPage: 12,
                planningIndicatorTypeMap: {},
                assignedShiftSpotListTooltipMap: {},
                assignedShiftSpotListPopupDataMap: {},
                unassignedShiftSpotListTooltipMap: {},
                unassignedShiftSpotListPopupDataMap: {},
                planShiftMomentMap: {},
                actualShiftMomentMap: {},
                unassignedShiftsDateMap: {},
                unpublishedShiftsWeeklyMap: {total: 0, weekEntries: {}, dayEntries: {}},
                publishedShiftsWeeklyMap: {total: 0, weekEntries: {}, dayEntries: {}},
                unassignShiftsWeeklyMap: {total: 0, weekEntries: {}, dayEntries: {}},
                employeeDatePlannedShiftMap: {},
                employeePreferenceAvailabilityMap: {},
                employeeUnapprovedPreferenceAvailabilityMap: {},
                employeePreferenceMomentMap: {},
                planShiftDateMap: {},
                actualShiftDateMap: {},
                employeeDateActualShiftMap: {},
                employeeDateActualShiftMarkedMap: {},
                employeeDateCombinedShiftMap: {},
                actualBreakShiftIdMap: {},
                actualBreakMomentMap: {},
                employeeContractStatusMap: {},
                employeeIdContractMap: {},
                employeeContractMomentMap: {},
                employeeEmployeeSkillMap: {},
                shiftTemplateMap: {},
                displayIndicatorType: "",
                timeZone: '',
                storeEventMap: {},
                storeEventMomentMap: {},
                dateContextMenuDate: null,
                liveDataTimer: null,
                plannedActualCalculationSetting: {
                    contractPlannedPercentage: 100,
                    considerPreviousMonth: true,
                    fullMonth: true,
                    limitToEmployees: false,
                    enableWorkTimeFactorOverride: false,
                    enforcedWorkTimeFactor: null,
                    employees: []
                },
                dateContextMenuOptions: [
                    {
                        name: this.$t('roster.view.dayRoster'),
                        icon: 'fa-calendar-alt',
                        key: 'dailyroster'
                    },
                    {
                        name: this.$t('roster.comp.openShifts'),
                        icon: 'fa-clock',
                        key: 'unassignedshifts'
                    },
                    {
                        name: this.$t('roster.view.staffMealBlankForm'),
                        icon: 'fa-sack',
                        key: 'mealcosts'
                    },
                    {
                        name: this.$t('roster.view.breakSchedule'),
                        icon: 'fa-clock',
                        key: 'breakform'
                    },
                    {
                        name: this.$t('roster.view.notes'),
                        icon: 'fa-pencil',
                        key: 'rosternotice'
                    },
                    {
                        name: this.$t('roster.view.taskOverview'),
                        icon: 'fa-tasks',
                        key: 'taskoverview'
                    }
                ],
                shiftContextMenuOptions: [
                    {
                        name: this.$t('global.ui.edit'),
                        icon: 'fa-edit',
                        key: 'edit'
                    }
                ],
                refreshingData: false,
                refreshingDelta: false,

                infoVideoOpened: false,
                daysShort: {
                    'Mo': this.$t('store.openingHours.weekDay1Short'),
                    'Di': this.$t('store.openingHours.weekDay2Short'),
                    'Mi': this.$t('store.openingHours.weekDay3Short'),
                    'Do': this.$t('store.openingHours.weekDay4Short'),
                    'Fr': this.$t('store.openingHours.weekDay5Short'),
                    'Sa': this.$t('store.openingHours.weekDay6Short'),
                    'So': this.$t('store.openingHours.weekDay7Short'),
                },
            }
        },
        watch: {
            rosterFromTo(newVal, oldVal) {
                if(newVal != null){
                    //console.log("Watch triggered -rosterFromTo- : Refresh Page data: "+JSON.stringify(newVal));
                    this.productivityExpanded = false;
                    this.refresh(false, true, true);
                }
            },
            dayModeDate(newVal, oldVal) {
                if(newVal != null){




                    if(this.dayMode){
                        let ty= performance.now();
                        let view = this;
                        this.$rosterhelper.calculateShiftTimeByHourMapDelta(
                                                                this.shiftTimeByHourMap,
                                                                [newVal.format('YYYY-MM-DD')],
                                                                [],
                                                                view.planShiftDateMap, view.actualShiftDateMap,
                                                                view.planShiftMap, view.planShiftMomentMap,
                                                                view.actualShiftMap, view.actualShiftMomentMap,
                                                                view.actualBreakMap, view.actualBreakMomentMap,
                                                                view.actualBreakShiftIdMap,
                                                                view.employeeMap,
                                                                view.spotMap, this.$helpers);

                        let tz= performance.now();

                        console.log("SHIFT TIME BY HOUR DELTA TOOK " + ((tz-ty) / 1000.0) + " seconds.");

                        if (this.dayModeShowPlanningSums) {
                            let dateFormat = newVal.format('YYYY-MM-DD');
                            this.loadVlhAndMeoData(newVal, !(view.actualShiftDateMap[dateFormat] && view.actualShiftDateMap[dateFormat].length > 0));
                        }

                        if (this.rosterSortState.showShiftSpots) {
                            this.updateSpots();
                            this.sortEmployeeGroups();
                            this.RefreshRosterContentMap();
                        }
                    }
                }
            },
            dayModeHours(newVal, oldVal) {
                if (this.rosterSortState.showShiftSpots) {
                    this.updateSpots();
                    this.sortEmployeeGroups();
                    this.RefreshRosterContentMap();
                }
            },
            useVlhForForecast(newVal, oldVal) {
                if (this.dayModeShowPlanningSums) {
                    let dateFormat = this.dayModeDate.format('YYYY-MM-DD');
                    this.loadVlhAndMeoData(this.dayModeDate, !(this.actualShiftDateMap[dateFormat] && this.actualShiftDateMap[dateFormat].length > 0));
                }
            },
            selectedPlanningIndicator(newVal, oldVal) {
                if (this.dayModeShowPlanningSums) {
                    let dateFormat = this.dayModeDate.format('YYYY-MM-DD');
                    this.loadVlhAndMeoData(this.dayModeDate, !(this.actualShiftDateMap[dateFormat] && this.actualShiftDateMap[dateFormat].length > 0));
                }
            },
            dayModeShowPlanningSums(newVal, oldVal) {
                if (newVal) {
                    let dateFormat = this.dayModeDate.format('YYYY-MM-DD');
                    this.loadVlhAndMeoData(this.dayModeDate, !(this.actualShiftDateMap[dateFormat] && this.actualShiftDateMap[dateFormat].length > 0));
                }
            },
            storeId(newVal, oldVal) {
                //console.log("Roster storeId change: "+newVal);
                this.refresh(false, true, true);
            },
            loggedIn(newVal, oldVal){
                //console.log("Roster loggedin change: "+newVal);
                this.refresh(false, true, true);
            },
            planShiftMap(newVal, oldVal){

                if(!this.refreshingDelta){
                    console.log('planShiftMap update');
                    this.RefreshVeryImportantData();
                }

            },
            employeePreferenceMap(newVal, oldVal){
                if(!this.refreshingDelta){
                    console.log('employeePreferenceMap update');
                    this.RefreshVeryImportantData();
                }

            },
            actualShiftMap(newVal, oldVal){
                let view = this;
                console.log('actualShiftMap update');
                view.RefreshVeryImportantData();
            },

            employeeSkillMap(newVal, oldVal){
                if(!this.loading){
                    this.updateEmployeeSkills();
                    let prefMaps = this.RefreshEmployeePreferenceMaps();
                    let shiftMaps = this.RefreshShiftMaps();


                    //must be after refresh shiftmaps
                    this.RefreshLegalMap(shiftMaps, prefMaps);
                    this.RefreshRosterContentMap();
                }

            },
            employeeAvailabilityMap(newVal, oldVal){
                let view = this;
                console.log('employeeAvailabilityMap update');
                view.RefreshVeryImportantData();
            },
            employeeExtraPaymentMap(newVal, oldVal){
                let view = this;
                console.log('employeeExtraPaymentMap update');
                view.RefreshVeryImportantData();
            },
            rosterVisibilityState(newVal, oldVal){
                if(newVal != oldVal){
                    this.RefreshRosterContentMap();
                }
            },
        },


        updated(){
            let view = this;
            let last = null;

            $('.entry.group').each(function(i, e){
                $(this).css('margin-top', '');
                if(last && !last.hasClass('collapsed') && !last.hasClass('business')) $(this).css('margin-top', '18px');
                last = $(this);
            });

        },
        created(){

            this.GenerateDates();
            window.roster = this;

            VueEventBus.$on("preview-autoroster-result", this.onPreviewAutoRosterResult);
            VueEventBus.$on("apply-autoroster-result", this.onApplyAutoRosterResult);
            VueEventBus.$on("roster-refresh", this.forceRefresh);

        },
        beforeDestroy(){
            VueEventBus.$off("preview-autoroster-result", this.onPreviewAutoRosterResult);
            VueEventBus.$off("apply-autoroster-result", this.onApplyAutoRosterResult);
            VueEventBus.$off("roster-refresh", this.forceRefresh);
            if(this.$refs.weatherpopup && this.$refs.weatherpopup.$el) $(this.$refs.weatherpopup.$el).remove();
            if(this.$refs.filterpopup && this.$refs.filterpopup.$el) $(this.$refs.filterpopup.$el).remove();
            if(this.$refs.eventhover && this.$refs.eventhover.$el) $(this.$refs.eventhover.$el).remove();
            if(this.$refs.plannedActualhover && this.$refs.plannedActualhover.$el) $(this.$refs.plannedActualhover.$el).remove();
            if(this.$refs.statisticspopup && this.$refs.statisticspopup.$el) $(this.$refs.statisticspopup.$el).remove();
            if(this.$refs.shiftspotlistpopup && this.$refs.shiftspotlistpopup.$el) $(this.$refs.shiftspotlistpopup.$el).remove();
            if(this.$refs.daypopup && this.$refs.daypopup.$el) $(this.$refs.daypopup.$el).remove();
            if(this.$refs.fta && this.$refs.fta.$el) $(this.$refs.fta.$el).remove();
            if(this.$refs.plannedActualpopup && this.$refs.plannedActualpopup.$el) $(this.$refs.plannedActualpopup.$el).remove();
            if(this.$refs.dropdowncontainer && this.$refs.dropdowncontainer.$el) $(this.$refs.dropdowncontainer.$el).remove();
            if(this.$refs.userselect && this.$refs.userselect.$el) $(this.$refs.userselect.$el).remove();
            window.removeEventListener('mousemove', this.CheckDragScroll);
            this.stopLiveDataTimer();
        },
        mounted() {
            let view = this;
            $('.app .scrollbar-container .grid').on('scroll', this.EmployeeDataScroll);
            this.SetWeatherSliderOffset();
            $('.app .scrollbar-container .grid').on('scroll', this.SetWeatherSliderOffset);
            //$('.app .scrollbar-container .grid').on('scroll', this.SetDayViewDayOffset);

            window.addEventListener('mousemove', this.CheckDragScroll);
            
        },



        computed: {
            ...mapGetters([
                'anonMode',
                'imgCacheTimestamp',
                'actualBreakMap',
                'actualShiftMap',
                'businessUnitMap',
                'loggedIn',
                'collectiveContractMap',
                'allowedContractMap',
                'employeeMap',
                'employeeContractMap',
                'currentMonthEmployeeContractMap',
                'employeePreferenceMap',
                'employeeAvailabilityMap',
                'employeeRulesMap',
                'employeeSkillMap',
                'employeeTypeMap',
                'employeeWorkbalanceMap',
                'holidayMap',
                'isSuperUser',
                'planShiftMap',
                'rosterFromTo',
                'shiftSkillMap',
                'skillMap',
                'spotMap',
                'storeId',
                'storeSettings',
                'validMpLicense',
                'validMzLicense',
                'validAsLicense',
                'validStatsLicense',
                'userUnitSortMap',
                'nightMode',
                'rosterVisibilityState',
                'rosterSortState',
                'userInfo',
                'uiDataMap',
                'permissions',
                'externalServicesMap',
                'externalApiAccessMap',
                'projectMap',
                'locationMap',
                'employeeMissingExternalIdMap',
                'employeeSortState',
                'shiftTimeByDayMap',
                'shiftTimeByHourMap',
                'notificationBellConfigState',
                'renderPdChart',
                'displayPdChart',
                'notificationBellConfigState',
                'externalShiftMap',
                'employeeExtraPaymentMap',
                'youthWorkConfigMap',
                'shiftStatusLogMap',
                'employeeAvgWorktimeMap',
                'crewLaborConfig',
                'sotecWebcockpitConfig',
                'mlCostCenterMap',
                'positioningTaskMap',
                'positioningEntryMap',
                'positioningTaskAssignmentMap',
            ]),
            prefSubtypeMap() {
                let map = {};
                for(let i = 0; i < this.uiDataMap.employeeAvailabilitySubtypes.length; i++){
                    let employeeAvailabilitySubtype = this.uiDataMap.employeeAvailabilitySubtypes[i];
                    map[employeeAvailabilitySubtype.id] = employeeAvailabilitySubtype;

                }
                return map;
            },
            showSpotPlanningNumbers() {
                return this.dayMode && this.dayModeShowPlanningSums && this.rosterSortState.showSpotPlanningNumbersSwitch && this.rosterSortState.showShiftSpots;
            },
            considerPreviousMonth() {
                return this.plannedActualCalculationSetting ? this.plannedActualCalculationSetting.considerPreviousMonth : null;
            },
            licExpiry() {
                return this.storeSettings.licExpiry ? this.$helpers.getMomentFromStringTZ(this.storeSettings.licExpiry) : null;
            },
            allowFutureAssignment(){
                if(this.storeSettings.allowFutureAssignment){
                    return true;
                } else {
                    return false; //this.licExpiry ? (this.licExpiry > this.startOfMonth.clone().add(10, 'days')) : false;
                }
            },
            userUnitSortMapByUnitId(){
                let map = {};
                Object.values(this.userUnitSortMap).forEach(sort => {
                    map[sort.unitId] = sort;
                })
                return map;
            },
            userFullname: function(){
                if(this.userInfo.firstname && this.userInfo.lastname){
                    return this.userInfo.firstname + ' ' + this.userInfo.lastname
                } else {
                    return 'User';
                }

            },
            roster(){
                return this;
            },
            switchedColor(){
                return this.rosterVisibilityState.daySpotColorSwitch || this.rosterVisibilityState.dayProjectColorSwitch;

            },
            sideButtons() {
                let view = this;

                let state= {
                    buttons: []
                };
                state.buttons.push({
                    type: "block border-r",
                    icon: "fa-eye",
                    tooltip: this.$t('global.ui.viewOptions'),
                    click: ($event) => {view.OpenMenuDetails($event, this.displayMenuState)}
                });
                if(!this.dayMode){
                    state.buttons.push({
                        type: "block border-r",
                        icon: "fa-print",
                        tooltip: this.$t('global.ui.reportsExports'),
                        click: ($event) => {view.OpenMenuDetails($event, this.reportMenuState)}
                    });
                    state.buttons.push({
                        type: "block",
                        icon: "fa-bars",
                        tooltip: this.$t('global.ui.additionalOptions'),
                        click: ($event) => {view.OpenMenuDetails($event, this.burgerMenuState)}
                    });
                }
                //<buttonc type="block"  v-tooltip="'Anzeige Optionen'" icon="fa-bars" @click="OpenDisplayMenuDetails"/>
                //<buttonc type="" icon="fa-camera"  v-tooltip="'Snapshot'" @click="hideSummary = false"/>
                return state;
            },
            burgerMenuState(){
                let view = this;
                let state = {};
                const validMzLicense = this.validMzLicense;
                const validMpLicense = this.validMpLicense;

                if(!this.dayMode){
                    state = {
                        componentref: 'burgermenustate',
                        groups: [],
                        items: []
                    };
                    let backupGroup = {
                        label: this.$t('roster.view.rosterBackup'),
                        items: [
                            {
                                closeOnClick: true,
                                icon: 'fa-cloud-upload-alt',
                                text: this.$t('roster.main.saveRoster'),
                                click: () => { VueEventBus.$emit('saveRosterBackup', {});}
                            },
                            {
                                closeOnClick: true,
                                icon: 'fa-cloud-download-alt',
                                text: this.$t('roster.main.restoreRoster'),
                                click: () => { VueEventBus.$emit('openRosterBackup', {});}
                            },

                        ]
                    };
                    state.groups.push(backupGroup);

                    if(validMpLicense || validMzLicense){
                        let publishGroup = {
                            label: this.$t('roster.view.publication'),
                            items: [

                            ]
                        }
                        if(validMpLicense){
                            publishGroup.items.push(
                                {
                                    closeOnClick: true,
                                    icon: 'fa-desktop',
                                    text: this.$t('roster.main.publishMp'),
                                    click: () => { view.PublishToMP(true);}
                                }
                            );
                        }
                        if(validMzLicense){
                            publishGroup.items.push(
                                {
                                    closeOnClick: true,
                                    icon: 'fa-desktop',
                                    text: this.$t('roster.view.publishMz'),
                                    click: ($event) => { view.OpenPublishAllShiftsToMZModal($event);}
                                }
                            );
                            publishGroup.items.push(
                                {
                                    closeOnClick: true,
                                    icon: 'fa-retweet',
                                    text: this.$t('roster.view.syncFromMz'),
                                    click: ($event) => { view.OpenSynchFromMZModal($event);}
                                }
                            );

                        }
                        state.groups.push(publishGroup);
                    }
                    let planningSettingGroup = {
                        label: this.$t('roster.view.adjustPlanning'),
                        items: [
                            {
                                closeOnClick: true,
                                icon: 'fa-ruler-horizontal',
                                text: this.$t('roster.view.adjustTargetPlanning'),
                                click: () => {view.OpenPlannedActualCalculationSettingPopup();}
                            }
                        ]
                    };
                    state.groups.push(planningSettingGroup);
                    let extraButtonGroup = {
                        label: this.$t('roster.view.shiftChanges'),
                        items: [
                            {
                                closeOnClick: true,
                                icon: 'fa-random',
                                text: this.$t('roster.main.transferShifts'),
                                disabled: false,
                                click: () => { view.OpenTransferShiftsPopup();}
                            },
                            {
                                closeOnClick: true,
                                icon: 'fa-plus-circle',
                                text: this.$t('roster.view.createShifts'),
                                click: () => {view.showShiftCreationWithTemplate();}
                            },
                            {
                                closeOnClick: true,
                                icon: 'fa-file-csv',
                                text: this.$t('roster.view.importShiftsFromCsv'),
                                click: () => {view.showShiftCreationWithCSV();}
                            },
                            {
                                closeOnClick: true,
                                icon: 'fa-trash',
                                disabled: view.leftOverShifts.length <= 0,
                                text: this.$t('roster.view.deleteUnfilledShifts'),
                                click: ($event) => {view.OpenDeleteLeftoverShiftsModal($event);}
                            },
                            {
                                closeOnClick: true,
                                icon: 'fa-trash',
                                text: this.$t('roster.view.deleteInvalidShifts'),
                                click: ($event) => {view.OpenDeleteInvalidShiftsModal($event);}
                            },
                            {
                                closeOnClick: true,
                                icon: 'fa-trash',
                                text: this.$t('roster.view.deleteAdditionalShifts'),
                                click: ($event) => {view.OpenDeleteShiftsWithoutTemplateModal($event);}
                            }

                        ]
                    }
                    if(this.storeSettings && this.storeSettings.simpleMode){
                        extraButtonGroup.items.splice(0,1) // remove shift creation
                    }

                    if(this.isSuperUser){
                        extraButtonGroup.items.push({
                            closeOnClick: true,
                            icon: 'fa-user-shield',
                            text: this.$t('roster.view.deleteAllShifts'),
                            click: () => {view.DeleteAllShifts();}
                        })

                    }
                    state.groups.push(extraButtonGroup);
                }

                return state;
            },
            reportMenuState() {
                let view = this;
                let state = {
                    componentref: 'burgermenustate',
                    groups: [],
                    items: []
                };

                let exportGroup = {
                    label: this.$t('roster.view.dataExport'),
                    items: [
                        {
                            closeOnClick: true,
                            icon: 'fa-file-pdf',
                            text: this.$t('roster.view.exportShiftData'),
                            disabled: !view.CheckCanPublishShifts,
                            click: () => { view.OpenShiftDataExportPopup();}
                        },{
                            closeOnClick: true,
                            icon: 'fa-file-csv',
                            text: this.$t('roster.view.exportDataForExternalServices'),
                            //disabled: !view.CheckCanPublishShifts,
                            click: () => { view.OpenExportExternalServiceCSV();}
                        },{
                            closeOnClick: true,
                            icon: 'fa-file-csv',
                            text: this.$t('roster.view.exportPlanHourOverviewAsCsv'),
                            disabled: !view.CheckCanPublishShifts,
                            click: () => { view.OpenPlanshiftsByHourCSVPopup();}
                        },

                    ]
                };

                // Frontend Report for testing stores "Testumgebung Kunde 1", "Testumgebung Kunde 2", "Testumgebung Kunde 3"
                if([65,474,475,481].includes(this.$store.state.storeId)){
                    exportGroup.items.push({
                        closeOnClick: true,
                        icon: 'fa-file-pdf',
                        text: this.$t('roster.view.shiftNumberReport'),
                        click: () => { view.OpenShiftCountReportPopup();}
                    });
                }

                state.groups.push(exportGroup);
                let rosterExportGroup = {
                    label: this.$t('roster.view.rosterExport'),
                    items: [
                        {
                            closeOnClick: true,
                            icon: 'fa-file-pdf',
                            text: this.$t('roster.view.exportRosterAsPdf'),
                            disabled: !view.CheckCanPublishShifts,
                            click: () => { view.OpenRosterToPDFPopup();}
                        },
                        {
                            closeOnClick: true,
                            icon: 'fa-file-csv',
                            text: this.$t('roster.view.exportRosterAsCsv'),
                            disabled: !view.CheckCanPublishShifts,
                            click: () => { view.OpenRosterToCSVPopup();}
                        },
                        {
                            closeOnClick: true,
                            icon: 'fa-file-csv',
                            text: this.$t('roster.view.exportCompanyRosterCsv'),
                            disabled: !view.CheckCanPublishShifts,
                            click: () => { view.OpenCompanyRosterCSVPopup();}
                        },
                        {
                            closeOnClick: true,
                            icon: 'fa-camera',
                            text: this.$t('roster.view.rosterSnapshot'),
                            disabled: !view.CheckCanPublishShifts,
                            click: () => {view.hideSummary = false;}
                        }
                    ]
                };
                state.groups.push(rosterExportGroup);
                let reportGroup = {
                    label: this.$t('roster.view.report'),
                    items: [
                        {
                            closeOnClick: true,
                            icon: 'fa-file-pdf',
                            text: this.$t('roster.view.lostHoursReport'),
                            click: () => {view.OpenLossReportPopup();}
                        },
                        {
                            closeOnClick: true,
                            icon: 'fa-file-pdf',
                            text: this.$t('roster.view.hourBalanceReport'),
                            click: () => {view.OpenSaldoReportPopup();}
                        },
                        {
                            closeOnClick: true,
                            icon: 'fa-file-pdf',
                            text: this.$t('roster.view.weeklyHoursReport'),
                            click: () => {view.OpenWeekWorkTimeReportPopup();}
                        },
                        {
                            closeOnClick: true,

                            icon: 'fa-file-pdf',
                            text: this.$t('roster.view.crewLaborHoursReport'),
                            click: () => {view.OpenDayCrewLaborReportPopup();}
                        },
                        {
                            closeOnClick: true,

                            icon: 'fa-file-pdf',
                            text: this.$t('roster.view.hourKeyFiguresReport'),
                            click: () => {view.OpenKPIExportPopup();}
                        },

                        {
                            closeOnClick: true,
                            icon: 'fa-file-pdf',
                            text: this.$t('roster.view.substituteRestReport'),
                            click: () => {view.OpenSpareTimeViolationsReportPopup();}
                        },
                        {
                            closeOnClick: true,
                            icon: 'fa-file-pdf',
                            text: this.$t('roster.view.rosterTimeReport'),
                            disabled: (view.rosterFromTo.month < 9 && view.rosterFromTo.year == 2023) || view.rosterFromTo.year < 2023,
                            click: () => {view.OpenRosterLogPopup();}
                        },
                        {
                            closeOnClick: true,
                            icon: 'fa-file-pdf',
                            text: this.$t('roster.view.rosterChangesReport'),
                            disabled: (view.rosterFromTo.month < 9 && view.rosterFromTo.year == 2023) || view.rosterFromTo.year < 2023,
                            click: () => {view.OpenRosterLogDeltaPopup();}
                        },



                    ]
                };
                console.log("AA "+view.rosterFromTo.month)
                state.groups.push(reportGroup);

                return state;
            },
            displayMenuState(){
                let view = this;
                let state = {};
                const validMzLicense = this.validMzLicense;
                const validMpLicense = this.validMpLicense;

                if(!this.dayMode){
                    let group0 = {
                        label: this.$t('global.ui.view'),
                        items: [
                            {
                                closeOnClick: true,
                                icon: view.rosterVisibilityState.visibilityMonthOnly ? 'fa-toggle-off' : 'fa-toggle-on',
                                text: view.rosterVisibilityState.visibilityMonthOnly ? this.$t('roster.view.showWholeWeeks') : this.$t('roster.view.hideWholeWeeks'),
                                click: () => { view.$store.commit('setRosterVisibilityStateToggle', 'visibilityMonthOnly');}
                            },
                            {
                                closeOnClick: true,
                                icon: view.rosterVisibilityState.visibilityProductivity ? 'fa-business-time' : 'fa-chart-bar',
                                text: view.rosterVisibilityState.visibilityProductivity ? this.$t('roster.view.showDailyHours') : this.$t('roster.view.showDailyProductivity'),
                                click: () => { view.$store.commit('setRosterVisibilityStateToggle', 'visibilityProductivity');}
                            },
                            {
                                closeOnClick: true,
                                show: view.rosterVisibilityState.visibilityProductivity,
                                icon: view.rosterVisibilityState.visibilityProductivityNew ? 'fa-toggle-on' : 'fa-toggle-off',
                                text: this.$t('roster.view.newProductivityView'),
                                click: () => {
                                    view.$store.commit('setRosterVisibilityStateToggle', 'visibilityProductivityNew');
                                    view.RefreshRosterContentMap();
                                }
                            },
                            {
                                closeOnClick: true,
                                show: view.rosterVisibilityState.visibilityProductivity,
                                icon: view.rosterVisibilityState.visibilityRoundProductivity ? 'fa-toggle-on' : 'fa-toggle-off',
                                text: view.rosterVisibilityState.visibilityRoundProductivity ? this.$t('roster.view.roundProductivity') : this.$t('roster.view.dontRoundProductivity'),
                                click: () => {
                                    view.$store.commit('setRosterVisibilityStateToggle', 'visibilityRoundProductivity');
                                },
                            },
                            {
                                closeOnClick: true,
                                icon: view.rosterVisibilityState.visibilityProductivityIncludeMgmt ? 'fa-toggle-on' : 'fa-toggle-off',
                                text: view.rosterVisibilityState.visibilityProductivityIncludeMgmt ? this.$t('roster.view.ignoreManagement') : this.$t('roster.view.considerManagement'),
                                click: () => {
                                    view.$store.commit('setRosterVisibilityStateToggle', 'visibilityProductivityIncludeMgmt');
                                    view.RefreshRosterContentMap();
                                    view.LoadAssignedShiftSpotListToolTipMap();
                                    view.$forceUpdate();
                                },
                            },
                            {
                                closeOnClick: true,
                                icon: view.rosterVisibilityState.visibilityKeyFigures ? 'fa-toggle-on' : 'fa-toggle-off',
                                text: view.rosterVisibilityState.visibilityKeyFigures ? this.$t('global.ui.hideX', [this.$t('global.ui.keyFigureTable')]) : this.$t('global.ui.showX', [this.$t('global.ui.keyFigureTable')]),
                                click: () => { view.$store.commit('setRosterVisibilityStateToggle', 'visibilityKeyFigures');}
                            },

                        ]
                    };
                    let group1 = {
                        label: this.$t('roster.view.balanceCalcBars'),
                        items: [
                            {
                                closeOnClick: true,
                                icon: view.rosterVisibilityState.calculatePastPlanning ? 'fa-toggle-on' : 'fa-toggle-off',
                                text: view.rosterVisibilityState.calculatePastPlanning ? this.$t('roster.comp.ignorePastPlans') : this.$t('roster.comp.considerPastPlans'),
                                click: () => {
                                    view.$store.commit('setRosterVisibilityStateToggle', 'calculatePastPlanning');
                                    view.RefreshEmployeePlannedActual();
                                }
                            },
                            {
                                closeOnClick: true,
                                icon: view.rosterVisibilityState.addHolidayTimeToWorkTime ? 'fa-toggle-on' : 'fa-toggle-off',
                                styleIcon: {transform: 'scaleX(-1)'},
                                text: view.rosterVisibilityState.addHolidayTimeToWorkTime ? this.$t('roster.view.splitHolidayBalanceFromWorkTime') : this.$t('roster.view.addHolidayBalanceWorkTime'),
                                click: () => {
                                    view.$store.commit('setRosterVisibilityStateToggle', 'addHolidayTimeToWorkTime');
                                    view.RefreshEmployeePlannedActual();
                                }
                            },
                        ]
                    };
                    let group2 = {
                        label: this.$t('roster.view.displayOptions'),
                        items: [
                            {
                                closeOnClick: true,
                                icon: view.rosterVisibilityState.visibilityKVErrors ? 'fa-toggle-on' : 'fa-toggle-off',
                                text: view.rosterVisibilityState.visibilityKVErrors ? this.$t('roster.view.hideViolations') : this.$t('roster.view.showViolations'),
                                click: () => {
                                    view.$store.commit('setRosterVisibilityStateToggle', 'visibilityKVErrors');
                                    view.$store.commit('setRosterVisibilityStateToggle', 'visibilityOverlappingErrors');
                                    view.RefreshRosterContentMap();
                                }
                            },
                            {
                                closeOnClick: true,
                                icon: view.rosterVisibilityState.visibilityPlanErrors ? 'fa-toggle-on' : 'fa-toggle-off',
                                text: view.rosterVisibilityState.visibilityPlanErrors ? this.$t('roster.view.hidePlanViolations') : this.$t('roster.view.showPlanViolations'),
                                click: () => {

                                    view.$store.commit('setRosterVisibilityStateToggle', 'visibilityPlanErrors');

                                    view.RefreshRosterContentMap();
                                }
                            },
                            {
                                closeOnClick: true,
                                icon: view.rosterVisibilityState.visibilityShiftStatusErrors ? 'fa-toggle-on' : 'fa-toggle-off',
                                text: view.rosterVisibilityState.visibilityShiftStatusErrors ? this.$t('roster.view.hideShiftWarnings') : this.$t('roster.view.showShiftWarnings'),
                                click: () => {

                                    view.$store.commit('setRosterVisibilityStateToggle', 'visibilityShiftStatusErrors');

                                    view.RefreshRosterContentMap();
                                }
                            },
                            {
                                closeOnClick: true,
                                icon: view.rosterVisibilityState.visibilityActualShifts ? 'fa-toggle-on' : 'fa-toggle-off',
                                text: view.rosterVisibilityState.visibilityActualShifts ? this.$t('roster.view.hidePunchTimes') : this.$t('roster.view.showPunchTimes'),
                                click: () => {
                                    view.$store.commit('setRosterVisibilityStateToggle', 'visibilityActualShifts');
                                    view.RefreshRosterContentMap();
                                }
                            },
                            {
                                closeOnClick: true,
                                icon: view.rosterVisibilityState.visibilityPlanShifts ? 'fa-toggle-on' : 'fa-toggle-off',
                                text: view.rosterVisibilityState.visibilityPlanShifts ? this.$t('roster.view.hidePlanTimes') : this.$t('roster.view.showPlanTimes'),
                                click: () => {
                                    view.$store.commit('setRosterVisibilityStateToggle', 'visibilityPlanShifts');
                                    view.RefreshRosterContentMap();
                                }
                            },
                            {
                                closeOnClick: true,
                                icon: view.rosterVisibilityState.visibilityUndesired ? 'fa-toggle-on' : 'fa-toggle-off',
                                text: view.rosterVisibilityState.visibilityUndesired ? this.$t('roster.view.hidePrefDislikes') : this.$t('roster.view.showPrefDislikes'),
                                click: () => {
                                    view.$store.commit('setRosterVisibilityStateToggle', 'visibilityDesired');
                                    view.$store.commit('setRosterVisibilityStateToggle', 'visibilityUndesired');
                                    view.RefreshEmployeeDayStatusMap();
                                }
                            },
                            {
                                closeOnClick: true,
                                icon: view.rosterVisibilityState.visibilityNotAvailable ? 'fa-toggle-on' : 'fa-toggle-off',
                                text: view.rosterVisibilityState.visibilityNotAvailable ? this.$t('roster.view.hideUnavailability') : this.$t('roster.view.showUnavailability'),
                                click: () => {
                                    view.$store.commit('setRosterVisibilityStateToggle', 'visibilityNotAvailable');
                                    view.RefreshEmployeeDayStatusMap();
                                }
                            },
                        ]
                    };
                    let group3 = {
                        label: this.$t('roster.view.colorDisplay'),
                        items: [
                            {
                                closeOnClick: true,
                                icon: view.rosterVisibilityState.daySpotColorSwitch ? 'fa-toggle-on' : 'fa-toggle-off',
                                styleIcon: {transform: 'scaleX(-1)'},
                                text: view.rosterVisibilityState.daySpotColorSwitch ? this.$t('roster.view.hideSpotColors') : this.$t('roster.view.showSpotColors'),
                                click: () => {
                                    view.$store.commit('setRosterVisibilityStateToggle', 'daySpotColorSwitch');

                                }
                            },
                            {
                                closeOnClick: true,
                                icon: view.rosterVisibilityState.dayProjectColorSwitch ? 'fa-toggle-on' : 'fa-toggle-off',
                                styleIcon: {transform: 'scaleX(-1)'},
                                text: view.rosterVisibilityState.dayProjectColorSwitch ? this.$t('roster.view.hideProjectColors') : this.$t('roster.view.showProjectColors'),
                                click: () => {
                                    view.$store.commit('setRosterVisibilityStateToggle', 'dayProjectColorSwitch');

                                }
                            },
                        ]
                    };

                    state = {
                        componentref: 'burgermenustate',
                        groups: [],
                        items: []
                    };

                    state.groups.push(group0);
                    state.groups.push(group1);
                    state.groups.push(group2);
                    state.groups.push(group3);
                    if(this.isSuperUser || this.userInfo.id == 'fcb00167-c770-42a6-9336-6c2a53e32210'){
                        state.groups.push({
                            label: 'Superuser',
                            items: [
                                {
                                    closeOnClick: true,
                                    icon: view.displayPdChart ? 'fa-toggle-on' : 'fa-toggle-off',
                                    styleIcon: {transform: 'scaleX(-1)'},
                                    text: view.displayPdChart ? this.$t('roster.view.hidePersonnelDeployment') : this.$t('roster.view.showPersonnelDeployment'),
                                    click: () => {
                                        view.togglePDSection();
                                    }
                                }
                            ]
                        });
                    }

                } else {
                    state = {
                        componentref: 'burgermenustate',
                        groups: [
                            {
                                label: this.$t('global.ui.viewOptions'),
                                items: [
                                    {
                                        closeOnClick: true,
                                        icon: view.rosterVisibilityState.visibilityActualShifts ? 'fa-eye-slash' : 'fa-eye',
                                        text: view.rosterVisibilityState.visibilityActualShifts ? this.$t('roster.view.hidePunchTimes') : this.$t('roster.view.showPunchTimes'),
                                        click: () => { view.$store.commit('setRosterVisibilityStateToggle', 'visibilityActualShifts');}
                                    },
                                    {
                                        closeOnClick: true,
                                        icon: view.rosterVisibilityState.visibilityPlanShifts ? 'fa-eye-slash' : 'fa-eye',
                                        text: view.rosterVisibilityState.visibilityPlanShifts ? this.$t('roster.view.hidePlanTimes') : this.$t('roster.view.showPlanTimes'),
                                        click: () => { view.$store.commit('setRosterVisibilityStateToggle', 'visibilityPlanShifts');}
                                    },
                                    {
                                        closeOnClick: true,
                                        icon: view.rosterVisibilityState.visibilityUndesired ? 'fa-eye-slash' : 'fa-eye',
                                        text: view.rosterVisibilityState.visibilityUndesired ? this.$t('roster.view.hidePrefDislikes') : this.$t('roster.view.showPrefDislikes'),
                                        click: () => {
                                            view.$store.commit('setRosterVisibilityStateToggle', 'visibilityUndesired');
                                            view.$store.commit('setRosterVisibilityStateToggle', 'visibilityDesired');
                                        }
                                    },
                                    {
                                        closeOnClick: true,
                                        icon: view.rosterVisibilityState.visibilityNotAvailable ? 'fa-eye-slash' : 'fa-eye',
                                        text: view.rosterVisibilityState.visibilityNotAvailable ? this.$t('roster.view.hideAvailabilities') : this.$t('roster.view.showAvailabilities'),
                                        click: () => {
                                            view.$store.commit('setRosterVisibilityStateToggle', 'visibilityNotAvailable');
                                            view.$store.commit('setRosterVisibilityStateToggle', 'visibilityOnlyAvailable');
                                        }
                                    },
                                    {
                                        closeOnClick: true,
                                        icon: view.rosterVisibilityState.visibilityVacation ? 'fa-eye-slash' : 'fa-eye',
                                        text: view.rosterVisibilityState.visibilityVacation ? this.$t('roster.view.hideAbsences') : this.$t('roster.view.showAbsences'),
                                        click: () => {
                                            view.$store.commit('setRosterVisibilityStateToggle', 'visibilityVacation');
                                            view.$store.commit('setRosterVisibilityStateToggle', 'visibilitySick');
                                            view.$store.commit('setRosterVisibilityStateToggle', 'visibilityEducation');
                                            view.$store.commit('setRosterVisibilityStateToggle', 'visibilityHolidayAdjustment');
                                            view.$store.commit('setRosterVisibilityStateToggle', 'visibilityWageContinuation');
                                        }
                                    },
                                    {
                                        closeOnClick: true,
                                        icon: view.rosterVisibilityState.daySpotColorSwitch ? 'fa-toggle-on' : 'fa-toggle-off',
                                        styleIcon: {transform: 'scaleX(-1)'},
                                        text: view.rosterVisibilityState.daySpotColorSwitch ? this.$t('roster.view.hideSpotColors') : this.$t('roster.view.showSpotColors'),
                                        click: () => {
                                            view.$store.commit('setRosterVisibilityStateToggle', 'daySpotColorSwitch');

                                        }
                                    },
                                    {
                                        closeOnClick: true,
                                        icon: view.rosterVisibilityState.dayProjectColorSwitch ? 'fa-toggle-on' : 'fa-toggle-off',
                                        styleIcon: {transform: 'scaleX(-1)'},
                                        text: view.rosterVisibilityState.dayProjectColorSwitch ? this.$t('roster.view.hideProjectColors') : this.$t('roster.view.showProjectColors'),
                                        click: () => {
                                            view.$store.commit('setRosterVisibilityStateToggle', 'dayProjectColorSwitch');

                                        }
                                    },
                                    {
                                        closeOnClick: true,
                                        icon: view.rosterVisibilityState.rosterDailyShiftTimeSort == true ||  view.rosterVisibilityState.rosterDailyShiftTimeSort == null ? 'fa-toggle-on' : 'fa-toggle-off',
                                        styleIcon: {transform: 'scaleX(-1)'},
                                        text: view.rosterVisibilityState.rosterDailyShiftTimeSort == true ||  view.rosterVisibilityState.rosterDailyShiftTimeSort == null ? this.$t('roster.view.sortEmployeeByName') : this.$t('roster.view.sortEmployeeByShift'),
                                        click: () => {
                                            if(view.rosterVisibilityState.rosterDailyShiftTimeSort == false){
                                                view.SortGroupEmployeesByPlanLowest(this.dayModeDate);
                                            } else {
                                                view.SortGroupEmployeesByLastNameFirstName();
                                            }
                                            view.$store.commit('setRosterVisibilityStateToggle', 'rosterDailyShiftTimeSort');

                                        }
                                    },
                                    {
                                        closeOnClick: true,
                                        icon: view.rosterVisibilityState.addHolidayTimeToWorkTime ? 'fa-toggle-on' : 'fa-toggle-off',
                                        styleIcon: {transform: 'scaleX(-1)'},
                                        text: view.rosterVisibilityState.addHolidayTimeToWorkTime ? this.$t('roster.view.addHolidayBalanceWorkTime') : this.$t('roster.view.splitHolidayBalanceFromWorkTime'),
                                        click: () => {
                                            view.$store.commit('setRosterVisibilityStateToggle', 'addHolidayTimeToWorkTime');
                                            view.RefreshEmployeePlannedActual();
                                        }
                                    },
                                ]
                            },
                            {
                                label: this.$t('pages.employeeContract.planning'),
                                items: [
                                    {
                                        closeOnClick: true,
                                        icon: view.rosterVisibilityState.visibilityProductivity ? 'fa-business-time' : 'fa-chart-bar',
                                        text: view.rosterVisibilityState.visibilityProductivity ? this.$t('roster.view.showHours') : this.$t('roster.view.showProductivity'),
                                        click: () => { view.$store.commit('setRosterVisibilityStateToggle', 'visibilityProductivity');}
                                    },
                                    {
                                        closeOnClick: true,
                                        show: view.rosterVisibilityState.visibilityProductivity,
                                        icon: view.rosterVisibilityState.visibilityProductivityIncludeMgmt ? 'fa-toggle-on' : 'fa-toggle-off',
                                        text: view.rosterVisibilityState.visibilityProductivityIncludeMgmt ? this.$t('roster.view.ignoreManagement') : this.$t('roster.view.considerManagement'),
                                        click: () => {
                                            view.$store.commit('setRosterVisibilityStateToggle', 'visibilityProductivityIncludeMgmt');
                                            view.RefreshRosterContentMap();
                                            view.LoadAssignedShiftSpotListToolTipMap();
                                            view.$forceUpdate();
                                        },
                                    },
                                    {
                                        closeOnClick: true,
                                        icon: view.rosterVisibilityState.dayHourlyValuesWithPauseSwitch ? 'fa-toggle-on' : 'fa-toggle-off',
                                        styleIcon: {transform: 'scaleX(-1)'},
                                        show: !view.rosterVisibilityState.visibilityProductivity,
                                        text: view.rosterVisibilityState.dayHourlyValuesWithPauseSwitch ? this.$t('roster.view.showHourlyValuesWithoutBreak') : this.$t('roster.view.showHourlyValuesWithBreak'),
                                        click: () => {
                                            view.$store.commit('setRosterVisibilityStateToggle', 'dayHourlyValuesWithPauseSwitch');

                                        }
                                    },
                                    {
                                        closeOnClick: true,
                                        icon: !view.dayModeShowPlanningSums ? 'fa-toggle-off' : 'fa-toggle-on',
                                        text: view.storeSettings.enableVlh && view.storeSettings.enableMeo ? this.$t('roster.view.showVlhMeo') :
                                            view.storeSettings.enableVlh ? this.$t('roster.view.showVlh') : this.$t('roster.view.showMeo'),
                                        show: (view.storeSettings.enableVlh || view.storeSettings.enableMeo) && !view.rosterVisibilityState.visibilityProductivity,
                                        click: () => {
                                            view.dayModeShowPlanningSums = !view.dayModeShowPlanningSums;
                                        },
                                    },
                                    {
                                        closeOnClick: true,
                                        icon: !view.useVlhForForecast ? 'fa-toggle-off' : 'fa-toggle-on',
                                        text: this.$t('shift.template.vlhNotMeo'),
                                        show: view.dayModeShowPlanningSums && view.storeSettings.enableVlh && view.storeSettings.enableMeo
                                            && !view.rosterVisibilityState.visibilityProductivity, // don't show if productivity is selected
                                        click: () => {
                                            view.useVlhForForecast = !view.useVlhForForecast;
                                        },
                                    },
                                    {
                                        closeOnClick: true,
                                        icon: !view.rosterSortState.showSpotPlanningNumbersSwitch ? 'fa-toggle-off' : 'fa-toggle-on',
                                        text: this.$t('roster.view.showPlanningPerSpot'),
                                        show: view.dayModeShowPlanningSums && !view.rosterVisibilityState.visibilityProductivity,
                                        click: () => {
                                            //view.showSpotPlanningNumbersSwitch = !view.showSpotPlanningNumbersSwitch;
                                            view.$store.commit('setRosterSortStateToggle', 'showSpotPlanningNumbersSwitch');
                                            if (view.rosterSortState.showSpotPlanningNumbersSwitch && !view.rosterSortState.showShiftSpots) {
                                                view.rosterSortState.filterByShiftSpot = false;
                                                view.rosterSortState.showSpots = false;
                                                view.rosterSortState.showBusinessUnits = false;
                                                view.rosterSortState.showShiftSpots = true;

                                                view.$store.commit('setRosterSortState', {rosterSortState: view.rosterSortState});
                                                view.updateSpots();
                                                view.sortEmployeeGroups();
                                                view.RefreshRosterContentMap();
                                            }
                                            view.refreshDayModePlanningInfoMap++;
                                        },
                                    },
                                ]
                            }
                        ],
                        items: []
                    };
                }

                if (view.dayMode && view.dayModeShowPlanningSums && (view.storeSettings.enableVlh || view.storeSettings.enableMeo)
                    && !view.rosterVisibilityState.visibilityProductivity) {

                    let indicatorItems = [];
                    Object.values(view.planningIndicatorTypeMap).forEach(indicator => {
                        indicatorItems.push({
                            closeOnClick: true,
                            icon: view.selectedPlanningIndicator.id !== indicator.id ? 'fa-toggle-off' : 'fa-toggle-on',
                            text: indicator.name,
                            click: () => {
                                view.selectedPlanningIndicator = indicator;
                            }
                        });
                    });

                    state.groups.push({
                        label: (view.useVlhForForecast ? this.$t('shift.main.vlh') : this.$t('shift.main.meo')) + " " + this.$t('roster.view.keyFigures'),
                        items: indicatorItems
                    });
                }

                return state;
            },
            headerButtons(){

                let view = this;

                let state= {
                    buttons: []
                };
                const validAsLicense = this.validAsLicense;
                if(this.dayMode){
                    state.buttons.push({
                        type: "block border-r",
                        icon: "fa-chevron-left",
                        click: () => {view.ToggleDayMode()},
                        tooltip: this.$t('roster.view.backToMonthlyView')
                    });
                }
                state.buttons.push({
                    type: "block",
                    icon: "fa-sync-alt",
                    click: () => {view.refresh(true)},
                    tooltip: this.$t('global.general.refreshData'),
                    title: this.$t('global.general.refreshData'),
                    helperText: this.$t('roster.view.refreshEverything')
                });

                let publishButtonActive = view.selectedPublishableShifts.length > 0 || (view.unpublishedShiftsTotal > 0 && view.selectedPublishableShifts.length == 0)
                   ||view.selectedUnpublishableShifts.length > 0 || (view.publishedShiftsTotal > 0 && view.selectedUnpublishableShifts.length == 0);
                if(!this.dayMode){
                    if(this.storeSettings && !this.storeSettings.simpleMode){
                        if(validAsLicense){
                            state.buttons.push({type: "block red label-center",label: "A",icon: "fa-undo-alt",click: () => {view.OpenRequestWizard();},tooltip: this.$t('roster.main.automaticRoster'), title: this.$t('roster.main.automaticRoster'), helperText: this.$t('roster.view.openWizardHelp') });
                        }
                    }
                   state.buttons.push({type: publishButtonActive ? "block" : "block border-r",icon: "fa-gift",click: () => {view.OpenFTAPopup()},tooltip: this.$t('roster.view.automaticHolidayCompensation'), helperText: this.$t('roster.view.automaticCompensationHelp')});

                }

                if(publishButtonActive){
                    if(view.selectedPublishableShifts.length > 0){
                        state.buttons.push({type: "block green",icon: "fa-eye",
                                            click: () => {view.PublishSelectedShifts()},
                                            disabled: !view.allowFutureAssignment || !view.CheckCanPublishShifts,
                                            tooltip: this.$t('roster.view.publishSelectedShifts'),
                                            helperText: this.$t('roster.view.publishSelectedShiftsHelp')});
                    } else if(view.unpublishedShiftsTotal > 0){
                         state.buttons.push({type: "block green", icon: "fa-eye",
                                             click: ($event) => {view.OpenPublishAllShiftsModal($event)},
                                             disabled: !view.allowFutureAssignment || !view.CheckCanPublishShifts,
                                             tooltip: this.$t('roster.view.publishShifts'),
                                             helperText: this.$t('roster.view.publishShiftsHelp')});
                    }
                    if(view.selectedUnpublishableShifts.length > 0){
                        state.buttons.push({
                            type: "block orange",
                            icon: "fa-eye-slash",
                            click: () => {view.UnpublishSelectedShifts()},
                            tooltip: this.$t('roster.comp.revokePublish'),
                            helperText: this.$t('roster.view.revokeSelectedPublishHelp')
                        });
                    } else if(view.publishedShiftsTotal > 0){
                         state.buttons.push({
                            type: "block orange",
                            icon: "fa-eye-slash",
                            click: ($event) => {view.OpenUnpublishAllShiftsModal($event)},
                            tooltip: this.$t('roster.comp.revokePublish'),
                            helperText: this.$t('roster.view.revokePublishHelp')
                        });
                    }
                } else {
                    state.buttons.push({type: view.validMpLicense ? "block" : "block border-r",icon: "fa-eye",click: () => {}, disabled: true, tooltip: this.$t('roster.view.publishShifts')});
                }


                state.buttons.push({
                    type: "block border-r",
                    disabled: (view.unassignableShiftsTotal <= 0),
                    icon: "fa-minus-circle",
                    click: ($event) => {view.OpenClearAllShiftsModal($event)},
                    tooltip: this.$t('roster.view.deleteAssignments'),
                    helperText: this.$t('roster.view.deleteAssignmentsHelp')
                });
                state.buttons.push({
                    type: "block border-r",
                    icon: "fas fa-thumbtack",
                    click: ($event) => {view.OpenPinAllShiftsModal($event)},
                    tooltip: this.$t('roster.view.pinAssignments'),
                    helperText: this.$t('roster.view.pinAssignmentsHelp')
                });
                state.buttons.push({
                    type: "block border-r",
                    icon: "fas fa-thumbtack",
                    styleIcon: {'transform':"scaleY(-1.25) scaleX(1.25) translateY(2px)"},
                    click: ($event) => {view.OpenUnpinAllShiftsModal($event)},
                    tooltip: this.$t('roster.comp.unpinShift'),
                    helperText: this.$t('roster.view.unpinShiftsHelp')
                });

                if(view.shiftsSelected.length > 0) {
                    state.buttons.push({
                        type: "block",
                        disabled: (view.shiftsSelected.length <= 0),
                        icon: "fa-trash",
                        click: () => {view.DeleteSelectedShifts()},
                        tooltip: this.$t('roster.view.deleteSelectedShifts'),
                        helperText: this.$t('roster.view.deleteSelectedShiftsHelp')
                    });
                }

                state.helperLinks = [
                {
                    icon: "fa-video",
                    title: this.$t('roster.view.trainingVideoRosterInterface'),
                    helperText: this.$t('store.structure.watchTrainingVideoHelp'),
                    externalUrl: "https://www.youtube.com/watch_popup?v=m7UlccR9b1k",
                    externalLabel: this.$t('roster.view.trainingVideoRosterInterfaceHelp'),
                    cancelLabel: this.$t('global.ui.close'),
                },
                {
                    icon: "fa-video",
                    title: this.$t('roster.view.trainingVideoPlanning'),
                    helperText: this.$t('store.structure.watchTrainingVideoHelp'),
                    externalUrl: "https://www.youtube.com/watch_popup?v=fmrvOfZqfLk",
                    externalLabel: this.$t('roster.view.trainingVideoPlanningHelp'),
                    cancelLabel: this.$t('global.ui.close'),
                },
                    {
                        title:  this.$t('store.structure.getSupport'),
                        helperText:  this.$t('store.structure.getSupportHelp'),
                        externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/12",
                        externalLabel:  this.$t('store.structure.getSupportLabel'),
                        cancelLabel: this.$t('global.ui.close'),
                    }
                ];




                return state;
            },
            CheckCanPublishShifts(){
                if(this.isSuperUser) {
                    return true;
                }
                let res = false;
                Object.values(this.permissions).forEach(perms => {
                    if(perms.map(perm => perm.id).includes(15)) { //permission to ignore law
                        res = true;
                    }
                })

                return res;
            },
            extraCostTypeMap() {
                let map = {};
                this.uiDataMap.extraCostTypes.forEach(type => {
                    map[type.id] = type;
                })
                return map;
            },
            employeeDateEmployeeExtraPaymentMap(){
                let map = {};
                Object.values(this.employeeExtraPaymentMap).forEach(es => {
                    if(!map[es.employeeId]){
                        map[es.employeeId] = {};
                    }
                    let m = map[es.employeeId];
                    if(!m[es.date]){
                        m[es.date] = [];
                    }
                    m[es.date].push(es);
                });


                return map;
            },
            externalEmployeeGroup(){
                let view = this;
                let result = {};
                const visibilityMonthOnly = view.rosterVisibilityState.visibilityMonthOnly ? true : false;
                Object.values(this.externalShiftMap).forEach(shift => {
                    if(!result[shift.employeeId]){
                        let entry = {
                            id: shift.employeeId,
                            firstName: shift.employeeFirstName,
                            lastName: shift.employeeLastName,
                            storeName: shift.sourceStoreName,
                            picture: view.GetProfilePictureUrl(shift),
                            hasShiftInMonth: false,

                        }
                        result[shift.employeeId] = entry;

                    }
                    let from = view.$helpers.getMomentFromStringTZ(shift.from);
                    if(from.month() == this.rosterFromTo.month){
                        result[shift.employeeId].hasShiftInMonth = true;
                    }
                })
                let filteredResult = {};
                Object.values(result).forEach(entry => {
                    if(entry.hasShiftInMonth || !visibilityMonthOnly){
                        filteredResult[entry.id] = entry;
                    }
                })
                return filteredResult;
            },
            employeeDateExternalShiftMap() {
                let view = this;
                let result = {};
                Object.values(this.externalShiftMap).forEach(shift => {
                    if(!result[shift.employeeId]){
                        let entry = {
                        }
                        let rosterFrom = view.$helpers.getMomentFromStringTZ(this.rosterFromTo.from).add(-1, 'days');
                        let rosterTo = view.$helpers.getMomentFromStringTZ(this.rosterFromTo.to).add(1, 'days');
                        let currentDate = rosterFrom.clone();
                        while (currentDate < rosterTo) {
                            let dateKey = currentDate.format("YYYY-MM-DD");

                            entry[dateKey] = {
                                inRange: currentDate.month() == this.rosterFromTo.month,
                                planshifts: [],
                                min: null,
                                max: null,
                                pinned: false,
                                published: true,
                                confirmed: false
                            };
                            currentDate.add(1, 'days');
                        }
                        result[shift.employeeId] = entry;

                    }
                    let from = view.$helpers.getMomentFromStringTZ(shift.from);
                    let to = view.$helpers.getMomentFromStringTZ(shift.to);
                    let dateKey = from.format("YYYY-MM-DD");
                    let s = Object.assign({}, shift);
                    s.fromDate = from;
                    s.toDate = to;

                    let entry = result[shift.employeeId][dateKey];
                    entry.planshifts.push(s);
                    if(entry.min == null || from < entry.min){
                        entry.min = from;
                    }
                    if(entry.max == null || to > entry.max){
                        entry.max = to;
                    }
                    if(!s.published){
                        entry.published = false;
                    }
                    if(s.confirmed){
                        entry.confirmed = true;
                    }
                    if(s.pinned){
                        entry.pinned = true;
                    }
                    if(s.spotName != null){
                        entry.tooltip = this.$tc('shift.main.position') + ": "+s.spotName;
                    }
                })
                return result;
            },

            visibilityState() {
                let state = {
                    visibilityActualShifts: this.rosterVisibilityState.visibilityActualShifts,
                    visibilityPlanShifts: this.rosterVisibilityState.visibilityPlanShifts,
                    visibilityUndesired: this.rosterVisibilityState.visibilityUndesired,
                    visibilityDesired: this.rosterVisibilityState.visibilityDesired,
                    visibilityNotAvailable: this.rosterVisibilityState.visibilityNotAvailable,
                    visibilityOnlyAvailable:this.rosterVisibilityState.visibilityOnlyAvailable,
                    visibilityVacation: this.rosterVisibilityState.visibilityVacation,
                    visibilitySick: this.rosterVisibilityState.visibilitySick,
                    visibilityHolidayAdjustment: this.rosterVisibilityState.visibilityHolidayAdjustment,
                    visibilityEducation: this.rosterVisibilityState.visibilityEducation,
                    visibilityWageContinuation: this.rosterVisibilityState.visibilityWageContinuation,

                };
                console.log("visibilityState changed")
                return state;
            },
            holidayMomentMap() {
                let map = {};
                Object.values(this.holidayMap).forEach(entry => {
                    let fromDate = this.$helpers.getMomentFromStringTZ(entry.from);
                    let toDate = this.$helpers.getMomentFromStringTZ(entry.to);
                    map[entry.id] = {fromDate: fromDate, toDate: toDate};

                });
                return map;
            },
            startOfMonth(){
                return this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
            },
            employeeWorkBalanceMomentMap() {

                let map = {};
                Object.values(this.employeeWorkbalanceMap).forEach(entry => {
                    let dateMoment = this.$helpers.getMomentFromStringTZ(entry.date);
                    map[entry.id] = {dateMoment: dateMoment};

                });
                return map;
            },
            employeeIdWorkBalanceMap() {
                let view = this;
                let map = {};

                Object.values(this.employeeWorkbalanceMap).forEach(w => {
                    map[w.employeeId] = w;
                });
                return map;
            },





            gridWeekInfo: function(){
                let t0 = performance.now();
                let gridWeekInfo =  {
                    weeks: 0,
                };

                 let from = this.dateSelectionStart.clone().startOf('isoWeek');
                let to = this.dateSelectionStart.clone().endOf('month');
                if(from.format() == this.dateSelectionStart.format()){
                        from = from.add(-1, 'weeks').startOf('isoWeek')
                }
                if(to.isoWeekday() == 7){
                    to = to.endOf('isoWeek').add(2,'weeks').startOf('isoWeek');
                } else {
                    to = to.endOf('isoWeek').add(1,'weeks').startOf('isoWeek');
                }

                let weeks = to.diff(from, 'weeks');
                gridWeekInfo.weeks = weeks;

                let startIndex = this.dateSelectionStart.isoWeekday();

                for (let i = 1; i <= gridWeekInfo.weeks; i++){
                    gridWeekInfo['w'+i] = {indices: []};
                    for(let j = 1; j <= 7; j++){
                        //index week goes from 1 to 6, index from 1 to 7
                        //we know that dateSelectionStart must be in first week

                        let indexTotal = (i-1)*7 + j;

                        let currentDate;

                        //currentDate = this.dateSelectionStart.clone().add(indexTotal - startIndex, 'days')
                        currentDate = from.clone().add(i-1, 'weeks').add(j-1, 'days');
                        let gridWeekEntry = {
                            index: j,
                            date: currentDate,
                            dateString: currentDate.format('YYYY-MM-DD'),
                            dayString: currentDate.format('DD'),
                            monthString: currentDate.format('MM'),
                            yearString: currentDate.format('YYYY'),
                            weekday: currentDate.isoWeekday(),
                        }


                        if((!this.dayMode || (this.dayMode && gridWeekEntry.dateString === this.dayModeDate.format('YYYY-MM-DD')))
                                && (!this.rosterVisibilityState.visibilityMonthOnly || (this.rosterVisibilityState.visibilityMonthOnly && currentDate.month() === this.dateSelectionStart.month()))) {

                                gridWeekInfo['w'+i].indices.push(gridWeekEntry.index);
                                gridWeekInfo['w'+i]['e'+gridWeekEntry.index] = gridWeekEntry
                                gridWeekInfo[i + '-' + gridWeekEntry.index] = gridWeekEntry;
                        }


                    }
                }

                let t1 = performance.now();
                let seconds = (t1-t0) / 1000.0;
                console.log("GRIDWEEKINFO TOOK " + seconds + " seconds.");
                return gridWeekInfo;
            },

            dayModeInfo(){
                let dayModeInfo = {
                    name: this.dayModeDate.format("dddd"),
                    date: this.dayModeDate.format("DD.MMMM")
                }
                return dayModeInfo;
            },
            dayModeInfoMap(){
                let map = {};
                const hourMap = this.shiftTimeByHourMap;
                const dayModeDate = this.dayModeDate;
                const dailyIndicators = this.planningIndicatorDaily;
                if(this.dayMode && dayModeDate){
                    console.log("dayModeInfoMap")
                    let dateFormat = dayModeDate.format('YYYY-MM-DD');

                    for(let hourIndex = 1; hourIndex <= this.dayModeHours; hourIndex++) {
                        let date = dayModeDate.clone().add(hourIndex-1, 'hours');
                        let key = date.format('YYYY-MM-DD HH');

                        if(!hourMap[key]){
                            map['' + hourIndex] = {
                                assigned: "-",
                                planned: "-",
                                productivity: "-",
                                indicatorValue: "-",
                                spots: {}
                            };
                        } else {
                            map['' + hourIndex] = {
                                assigned: "-",
                                planned: "-",
                                productivity: "-",
                                indicatorValue: "-",
                                spots: {}
                            };

                            //calc productivity
                            let productiveHours = 0;
                            let totalIndicatorAmount = 0;
                            let prod = '-'

                            if(this.actualShiftDateMap[dateFormat] && this.actualShiftDateMap[dateFormat].length > 0){

                                productiveHours = !this.rosterVisibilityState.visibilityProductivityIncludeMgmt ? hourMap[key].productiveActualCrewOnly : hourMap[key].productiveActual;


                                let quarterHours = [date.unix(), date.add(15, 'minutes').unix(), date.add(15, 'minutes').unix(), date.add(15, 'minutes').unix()];
                                let indicators =  dailyIndicators.filter(s => s.typeId == this.displayIndicatorType && !s.planned && quarterHours.includes(s.dateMoment.unix()));
                                let fractional = this.planningIndicatorTypeMap[this.displayIndicatorType] ? this.planningIndicatorTypeMap[this.displayIndicatorType].fractional : 7;
                                if(indicators.length > 0) {

                                    indicators.forEach(s => totalIndicatorAmount += s.amount);
                                    totalIndicatorAmount = totalIndicatorAmount/Math.pow(10, fractional);
                                }
                            } else {

                                productiveHours = !this.rosterVisibilityState.visibilityProductivityIncludeMgmt ? hourMap[key].productiveAssignedCrewOnly : hourMap[key].productiveAssigned;


                                let quarterHours = [date.unix(), date.add(15, 'minutes').unix(), date.add(15, 'minutes').unix(), date.add(15, 'minutes').unix()];
                                let indicators =  dailyIndicators.filter(s => s.typeId == this.displayIndicatorType && s.planned && quarterHours.includes(s.dateMoment.unix()));
                                let fractional = this.planningIndicatorTypeMap[this.displayIndicatorType] ? this.planningIndicatorTypeMap[this.displayIndicatorType].fractional : 7;
                                if(indicators.length > 0) {

                                    indicators.forEach(s => totalIndicatorAmount += s.amount);
                                    totalIndicatorAmount = totalIndicatorAmount/Math.pow(10, fractional);
                                }
                            }


                            if(productiveHours > 0){
                                prod = (totalIndicatorAmount / (productiveHours/(60 * 60 * 1000))).toFixed(2);

                            }
                            map['' + hourIndex].productivity = prod
                            map['' + hourIndex].indicatorValue = totalIndicatorAmount.toFixed(2);

                            //calc assigned and planned

                            let totalAssigned = 0;
                            if(this.actualShiftDateMap[dateFormat] && this.actualShiftDateMap[dateFormat].length > 0){
                                totalAssigned = this.rosterVisibilityState.dayHourlyValuesWithPauseSwitch ? hourMap[key].totalActual : hourMap[key].totalActualFull;
                            } else {
                                totalAssigned = this.rosterVisibilityState.dayHourlyValuesWithPauseSwitch ? hourMap[key].totalAssigned : hourMap[key].totalAssignedFull;
                            }
                            let totalPlanned = this.rosterVisibilityState.dayHourlyValuesWithPauseSwitch ? hourMap[key].totalAssigned + hourMap[key].totalPlanned : hourMap[key].totalAssignedFull + hourMap[key].totalPlannedFull;
                            map['' + hourIndex].assigned = this.$helpers.GetHourMinuteFormatFromMilliseconds(totalAssigned, true);
                            map['' + hourIndex].planned = this.$helpers.GetHourMinuteFormatFromMilliseconds(totalPlanned, true);

                            Object.entries(hourMap[key].spots).forEach(entry => {

                                let spot = {id: entry[0]};

                                let totalAssigned = 0;
                                if(this.actualShiftDateMap[dateFormat] && this.actualShiftDateMap[dateFormat].length > 0){
                                    totalAssigned = this.rosterVisibilityState.dayHourlyValuesWithPauseSwitch ? entry[1].totalActual : entry[1].totalActualFull;
                                } else {
                                    totalAssigned = this.rosterVisibilityState.dayHourlyValuesWithPauseSwitch ? entry[1].totalAssigned : entry[1].totalAssignedFull;
                                }
                                let totalPlanned = this.rosterVisibilityState.dayHourlyValuesWithPauseSwitch ? entry[1].totalAssigned + entry[1].totalPlanned : entry[1].totalAssignedFull + entry[1].totalPlannedFull;

                                spot.assigned = this.$helpers.GetHourMinuteFormatFromMilliseconds(totalAssigned, true);
                                spot.planned = this.$helpers.GetHourMinuteFormatFromMilliseconds(totalPlanned, true);

                                map['' + hourIndex].spots[spot.id] = spot;
                            });



                        }

                    }
                }

                return map;
            },
            dayModePlanningInfoMap(){
                let view = this;

                view.refreshDayModePlanningInfoMap;

                let map = {};
                let dateFormat = view.dayModeDate.format('YYYY-MM-DD');

                if(view.dayMode && view.dayModeDate){
                    console.log("dayModePlanningInfoMap");

                    for(let hourIndex = 1; hourIndex <= view.dayModeHours; hourIndex++) {
                        let date = view.dayModeDate.clone().add(hourIndex-1, 'hours');
                        let key = date.format('YYYY-MM-DDTHH:mm');

                        if(!view.forecastData[key]){
                            map['' + hourIndex] = {
                                planned: "0.00"
                            };
                        } else {
                            map['' + hourIndex] = {
                                planned: "0.00"
                            };

                            let totalPlanned = 0;
                            let spots = [];

                            if (view.actualShiftDateMap[dateFormat] && view.actualShiftDateMap[dateFormat].length > 0) {
                                // actual values
                                if (view.useVlhForForecast) {
                                    totalPlanned = view.forecastData[key][view.selectedPlanningIndicator.id]['vlh']['actual'].totalWorktime;
                                    spots = JSON.parse(JSON.stringify(view.forecastData[key][view.selectedPlanningIndicator.id]['vlh']['actual'].spots));
                                } else {
                                    totalPlanned = view.forecastData[key][view.selectedPlanningIndicator.id]['meo']['actual'].totalWorktime;
                                    spots = JSON.parse(JSON.stringify(view.forecastData[key][view.selectedPlanningIndicator.id]['meo']['actual'].spots));
                                }
                            } else {
                                // planned values
                                if (view.useVlhForForecast) {
                                    totalPlanned = view.forecastData[key][view.selectedPlanningIndicator.id]['vlh']['planned'].totalWorktime;
                                    spots = JSON.parse(JSON.stringify(view.forecastData[key][view.selectedPlanningIndicator.id]['vlh']['planned'].spots));
                                } else {
                                    totalPlanned = view.forecastData[key][view.selectedPlanningIndicator.id]['meo']['planned'].totalWorktime;
                                    spots = JSON.parse(JSON.stringify(view.forecastData[key][view.selectedPlanningIndicator.id]['meo']['planned'].spots));
                                }
                            }

                            map['' + hourIndex].planned = (totalPlanned / 60.0).toFixed(2);
                            // console.log(this.spotMap);
                            if (this.rosterSortState.showBusinessUnits) {
                                spots.forEach(s => {
                                    let spot = this.spotMap[s.spotId];
                                    if (!spot.isMain) {
                                        // console.log("not main spot", spot);
                                        let mainSpot = Object.values(this.spotMap).find(ms => ms.isMain && ms.unitId === spot.unitId);
                                        // console.log("mainSpot", mainSpot);
                                        if (mainSpot && spots.find(s2 => s2.spotId === mainSpot.id)) {
                                            spots.find(s2 => s2.spotId === mainSpot.id).workTime += s.workTime;
                                        }
                                    }
                                });
                            }
                            spots.forEach(s => {
                                s.planned = (s.workTime / 60.0).toFixed(2);
                            });
                            map['' + hourIndex].spots = spots;
                        }

                    }
                }

                //console.log("map", map);
                return map;
            },
            previousMonth(){
                let prev = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1).subtract(1, 'months').startOf('month');
                return prev;
            },
            previousMonthUTC(){
                let prev = this.$helpers.getMomentFromValuesUTC(this.rosterFromTo.year, this.rosterFromTo.month, 1).subtract(1, 'months').startOf('month');
                return prev;
            },
            monthDisplay: function() {
                if(this.dateSelectionStart != null){
                    return this.dateSelectionStart.format('MMM YYYY');
                } else {
                    return '-';
                }
            },
            loginStatus() {
                return this.$store.state.loggedIn;
            },

            leftOverShifts() {
                if(this.dayMode) {
                    return this.planshifts.filter(s => s.employeeId == null && s.date.date() === this.dayModeDate.date());
                } else {
                    return this.planshifts.filter(s => s.employeeId == null);
                }
            },
            unpublishedShiftsTotal() {
                let res = 0;
                if(this.dayMode){
                    let key = this.dayModeDate.format("DD.MM.YYYY");
                    res = this.unpublishedShiftsWeeklyMap.dayEntries[key] ? this.unpublishedShiftsWeeklyMap.dayEntries[key].length : 0;
                } else {
                    res =  this.unpublishedShiftsWeeklyMap.total;
                }
                return res;
            },
            unassignableShiftsTotal() {
                let res = 0;
                if(this.dayMode){
                    let key = this.dayModeDate.format("DD.MM.YYYY");
                    res = this.unassignShiftsWeeklyMap.dayEntries[key] ? this.unassignShiftsWeeklyMap.dayEntries[key].length : 0;
                } else {
                    res =  this.unassignShiftsWeeklyMap.total;
                }
                return res;
            },
            publishedShiftsTotal() {
                let res = 0;
                if(this.dayMode){
                    let key = this.dayModeDate.format("DD.MM.YYYY");
                    res = this.publishedShiftsWeeklyMap.dayEntries[key] ? this.publishedShiftsWeeklyMap.dayEntries[key].length : 0;
                } else {
                    res =  this.publishedShiftsWeeklyMap.total;
                }
                return res;
            },
            shiftsTotal() {
                let res = 0;
                if(this.dayMode){
                    let key = this.dayModeDate.format("DD.MM.YYYY");
                    res = this.shiftsWeeklyMap.dayEntries[key] ? this.shiftsWeeklyMap.dayEntries[key].length : 0;
                } else {
                    res =  this.shiftsWeeklyMap.total;
                }
                return res;
            },
            selectedPublishableShifts() {
                let view = this;
                if(this.dayMode) {
                    return this.shiftsSelected.filter(s => !s.published && s.employeeId != null && view.employeeMap[s.employeeId] && !view.employeeMap[s.employeeId].dummy && s.fromDate.date() === this.dayModeDate.date());
                } else {
                    return this.shiftsSelected.filter(s => !s.published && s.employeeId != null && view.employeeMap[s.employeeId] && !view.employeeMap[s.employeeId].dummy);
                }

            },
            selectedUnpublishableShifts() {
                if(this.dayMode) {
                    return this.shiftsSelected.filter(s => s.published && s.fromDate.date() === this.dayModeDate.date());
                } else {
                    return this.shiftsSelected.filter(s => s.published);
                }

            },
            dayModeShifts() {
                return Object.values(this.customPlanShiftMap).filter(s => !s.employeeId && this.dayModeDate.format('YYYY-MM-DD') === s.fromDate.format('YYYY-MM-DD'));
            },
            unassignedShiftDateTotalMap() {
                let view = this;
                let rosterFrom = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.from);
                let rosterTo = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.to);
                let dateKeys = [];
                let currentDate = rosterFrom.clone();
                let endDate = rosterTo.clone().add(1, 'days');
                let endOfDayFormatMomentMap = {};
                while (currentDate < endDate) {
                    dateKeys.push(currentDate.format("YYYY-MM-DD"));
                    endOfDayFormatMomentMap[currentDate.format("YYYY-MM-DD")] = currentDate.clone().endOf('day');
                    currentDate.add(1, 'days');
                }
                let map = {};
                for(let key = 0; key < dateKeys.length - 1; key++) { //it's dateKeys.length - 1 because the last dateKey is just to prevent null error from assigning totals for days after rosterTo
                    let dateKey = dateKeys[key];
                    map[dateKey] = 0;
                    let shifts = view.GetUnassignedShiftsByDate(dateKey);
                    let totalObject = view.GetMillisecondTotalObjectFromShifts(shifts, endOfDayFormatMomentMap[dateKey]);
                    map[dateKey] += totalObject.total - totalObject.totalBreak;
                    if(totalObject.totalOutOfRange) map[dateKeys[key + 1]] += totalObject.totalOutOfRange; //assign remainder to nextDay
                }
                return map;
            },
            keyFiguresHeight() {
                let infoElement = this.gridWeekInfo[this.firstDay];
                if (!infoElement) return '15.6px';
                return this.getKeyFigures(infoElement.date).length * 15.6 + 'px';
            },
            firstDay() {
                return Object.keys(this.gridWeekInfo)[2];
            }
        },
        methods: {
            setLiveDataTimer() {
                let view = this;
                view.stopLiveDataTimer();
                if(this.sotecWebcockpitConfig && !this.sotecWebcockpitConfig.disabled && this.storeId <= 100){
                    this.liveDataTimer = setTimeout(view.doLiveDataImport, 20*60*1000)

                }

            },
            doLiveDataImport(){
                let view = this;
                view.RefreshCurrentDayLiveIndicator()
                .then((res) => {
                    if(res.validImport){
                        view.loading = true;
                        view.RefreshPlanningIndicator()
                        .then(() => {
                            view.loading = false;

                            view.RefreshVeryImportantData();
                            view.$helpers.success(view.$t('global.notifications.success'), view.$tc('roster.view.keyFigureUpdated'));
                            view.setLiveDataTimer();
                        }).catch(error => {
                            console.log(error);
                            view.loading = false;
                            view.setLiveDataTimer();
                        });
                    } else {
                        view.setLiveDataTimer();
                    }
                })


            },
            stopLiveDataTimer() {
                console.log("stopLiveDataTimer")
                if(this.liveDataTimer != null){
                    clearTimeout(this.liveDataTimer);
                }

            },
            Hovering(col, employee){
                let emp = document.getElementById(employee.id);
                emp.classList.add("hovered");
                let header = document.getElementById('header' + col);
                header.classList.add("hovered");
            },
            EndHovering(col, employee){
                let emp = document.getElementById(employee.id);
                emp.classList.remove("hovered");
                let header = document.getElementById('header' + col);
                header.classList.remove("hovered");
            },
            getStarStyles(employee) {
              let skillValue = 0;
              if(employee.spotId){
                  let emplSkill = Object.values(this.employeeSkillMap).find(empSkill => empSkill.employeeId === employee.id && empSkill.skillId === this.spotMap[employee.spotId].requiredSkill);
                  if(emplSkill != undefined) skillValue = emplSkill.value;
              }

              let background = '';

              if (skillValue === 10) {
                background = '#ffc107';
                return {'font-size' : '25px', 'margin-left' : '-1px', '-webkit-text-fill-color' : 'transparent',
                  'background-color' : background, '-webkit-background-clip' : 'text'};
              } else if (skillValue === 0) {
                background = 'var(--contrast-1)';
                return {'font-size' : '25px', 'margin-left' : '-1px', '-webkit-text-fill-color' : 'transparent',
                  'background-color' : background, '-webkit-background-clip' : 'text'};
              } else {
                let degree = 360 / 10 * skillValue;
                background = 'conic-gradient(#ffc107 ' + (degree - 2) + 'deg, #ffc107 ' + (degree - 1) + 'deg, var(--contrast-1) ' + (degree) + 'deg, var(--contrast-1) 360deg)';
                return {'font-size' : '25px', 'margin-left' : '-1px', '-webkit-text-fill-color' : 'transparent',
                  'background-image' : background, '-webkit-background-clip' : 'text'};
              }
            },
            framedPlannedActualCalculation(date){
                if(this.plannedActualCalculationSetting && !this.plannedActualCalculationSetting.fullMonth){
                    let result = this.plannedActualCalculationSetting.from._d.getTime() <= date._d.getTime() && this.plannedActualCalculationSetting.to._d.getTime() >= date._d.getTime();
                    return result;
                }
                return false;
            },
            generateDateSelectionEntries(endOfDay = false) {
                let entries =  [];
                let rosterFrom = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.from);
                let rosterTo = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.to);
                let currentDate = rosterFrom.clone();
                let rosterDateKeys = [];
                let rosterDateKeyBoundaries = {};
                while (currentDate < rosterTo) {
                    let dateKey = currentDate.format("DD.MM.YYYY");
                    let val = currentDate.clone();
                    if(endOfDay){
                        val = val.endOf('day');
                    }
                    entries.push( {label: dateKey, value: val});
                    currentDate.add(1, 'days');
                }
                return entries;
            },
            loadPlannedActualCalculationSetting(){
                let setting = {
                    contractPlannedPercentage: 100,
                    considerPreviousMonth: true,
                    limitToEmployees: false,
                    employees: [],
                    fullMonth: true,
                    workTimeMode: this.storeSettings.workTimeMode,
                    enableWorkTimeFactorOverride: false,
                    enforcedWorkTimeFactor: this.storeSettings.workTimeFactor,
                    saldoMode: 0,
                }
                try {
                    let key = this.storeId+"-"+this.rosterFromTo.month+"-"+this.rosterFromTo.year;
                    let plannedActualCalcSettings = localStorage.getItem("plannedActualCalcSettings");

                    if(plannedActualCalcSettings){
                        plannedActualCalcSettings = JSON.parse(plannedActualCalcSettings);
                    }

                    if(plannedActualCalcSettings && plannedActualCalcSettings[key]){

                        if(plannedActualCalcSettings[key].contractPlannedPercentage){
                            setting.contractPlannedPercentage = plannedActualCalcSettings[key].contractPlannedPercentage;
                        }
                        if(plannedActualCalcSettings[key].limitToEmployees != null){
                            setting.limitToEmployees = plannedActualCalcSettings[key].limitToEmployees;
                        }
                        if(plannedActualCalcSettings[key].employees != null){
                            setting.employees = plannedActualCalcSettings[key].employees;
                        }
                        if(plannedActualCalcSettings[key].fullMonth != null){
                            setting.fullMonth = plannedActualCalcSettings[key].fullMonth
                        }
                        if(plannedActualCalcSettings[key].from != null){
                            setting.from = this.$helpers.getMomentFromStringTZ(plannedActualCalcSettings[key].from);
                        }
                        if(plannedActualCalcSettings[key].to != null){
                            setting.to = this.$helpers.getMomentFromStringTZ(plannedActualCalcSettings[key].to);
                        }
                        if(plannedActualCalcSettings[key].workTimeMode != null){
                            setting.workTimeMode = plannedActualCalcSettings[key].workTimeMode;
                        }
                        if(plannedActualCalcSettings[key].saldoMode != null){
                            setting.saldoMode = plannedActualCalcSettings[key].saldoMode;
                        }
                        if(plannedActualCalcSettings[key].enableWorkTimeFactorOverride != null){
                            setting.enableWorkTimeFactorOverride = plannedActualCalcSettings[key].enableWorkTimeFactorOverride;
                        }
                        if(plannedActualCalcSettings[key].enforcedWorkTimeFactor != null){
                            setting.enforcedWorkTimeFactor = plannedActualCalcSettings[key].enforcedWorkTimeFactor;
                        }
                        setting.considerPreviousMonth = plannedActualCalcSettings[key].considerPreviousMonth

                    }
                    this.plannedActualCalculationSetting = setting;
                } catch(error){
                    console.log(error);
                    this.plannedActualCalculationSetting = setting;
                }


            },
            savePlannedActualCalculationSetting(setting){
                let key = this.storeId+"-"+this.rosterFromTo.month+"-"+this.rosterFromTo.year;
                let plannedActualCalcSettings = localStorage.getItem("plannedActualCalcSettings");

                if(!plannedActualCalcSettings){
                    plannedActualCalcSettings = {}
                } else {
                    plannedActualCalcSettings = JSON.parse(plannedActualCalcSettings);
                }
                let newSettings = {}
                //store max 50 in local storage
                let count = 0;
                for(let x in plannedActualCalcSettings){
                    if(count < 50 && x.length > 4){
                        newSettings[x] = plannedActualCalcSettings[x];
                    }
                    if(x.length > 4){
                        count+=1;
                    }

                }
                newSettings[key] = setting;
                this.plannedActualCalculationSetting = setting;
                localStorage.setItem("plannedActualCalcSettings", JSON.stringify(newSettings));
                this.RefreshEmployeePlannedActual();
            },
            OpenPlannedActualCalculationSettingPopup(){
                let view = this;
                let selectedEmployees = this.plannedActualCalculationSetting.employees ? this.plannedActualCalculationSetting.employees : null;
                let employees = [];
                Object.values(view.employeeMap).filter(e => e.active).forEach(i => {

                        employees.push({label: i.lastName + " "+i.firstName, value: i.id, selected: selectedEmployees == null ? true : selectedEmployees.includes(i.id)});

                });
                employees.sort((a,b)=> {
                    if(a.label.toLowerCase() < b.label.toLowerCase()){
                        return -1;
                    } else if (a.label.toLowerCase() < b.label.toLowerCase()){
                        return 1;
                    }
                    return 0;
                })
                let workTimeModes = [{label: this.$t('store.settings.average'), value: 0}, {label: this.$t('store.settings.workingDays'), value: 1}, {label: this.$tc('store.settings.weekdays', 2), value: 2}, {label: this.$t('store.settings.workWithoutHolidays'), value: 3}];
                let selectedWorkTimeMode = this.plannedActualCalculationSetting.workTimeMode != null ? workTimeModes.find(item => item.value == this.plannedActualCalculationSetting.workTimeMode) : workTimeModes.find(item => item.value == this.storeSettings.workTimeMode);

                let saldoModes = [{label: this.$t('roster.view.wholeMonth'), value: 0}, {label: this.$t('roster.view.withinTimePeriod'), value: 1}]
                let selectedSaldoMode = this.plannedActualCalculationSetting.saldoMode != null ? saldoModes.find(item => item.value == this.plannedActualCalculationSetting.saldoMode) : saldoModes[0];


                if(selectedWorkTimeMode == null){
                    selectedWorkTimeMode = workTimeModes[0];
                }
                if(selectedSaldoMode == null){
                    selectedSaldoMode = saldoModes[0];
                }

                let dataEntries = [
                    {label: this.$t('workBalance.summary.target') + ' %', key: 'contractPlannedPercentage', hidden: false, type: 'slider', value: this.plannedActualCalculationSetting.contractPlannedPercentage, min: 0, max: 150,
                        slider: {min: 0, max: 150, value: this.plannedActualCalculationSetting.contractPlannedPercentage, step: 1,
                        inputControl: true, sliderInput: (x) => {return x}}},
                    {label: this.$t('roster.view.considerPreviousMonthBalance'), key: 'considerPreviousMonth', hidden: false, type: 'bool', value: this.plannedActualCalculationSetting.considerPreviousMonth},
                    {label: this.$t('roster.view.limitToIndividualEmployees'), key: 'limitToEmployees', hidden: false, type: 'bool', value: this.plannedActualCalculationSetting.limitToEmployees},

                ];
                dataEntries.push({label: this.$tc('global.general.employee'), key: 'employees', type: 'dropdownsearch', hidden: !this.plannedActualCalculationSetting.limitToEmployees,
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        items: employees,
                        selectedItems: employees.filter(i => i.selected),
                    },
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let employeeFlag = datafill.entries.find(i => i.key == 'limitToEmployees').value;
                        if(employeeFlag){
                            entryBeforeUpdate.hidden = false;
                        } else {
                            entryBeforeUpdate.hidden = true;
                        }

                        return entryBeforeUpdate;
                    }
                });
                dataEntries.push({label: this.$t('roster.view.adjustEntireMonth'), key: 'fullMonth', hidden: false, type: 'bool', value: this.plannedActualCalculationSetting.fullMonth})

                let startDate = this.$helpers.getMomentTZ().month(this.rosterFromTo.month).year(this.rosterFromTo.year).startOf('month');
                let endDate = startDate.clone().endOf('month').add(1, 'days').startOf('day');
                let items = [];
                while(endDate > startDate){
                    let item = {label: startDate.format("dddd DD.MM.YYYY"), value: startDate.clone().startOf('day')};
                    items.push(item);
                    startDate = startDate.add(1, 'days');
                }

                dataEntries.push({label: this.$t('roster.view.startDate'), key: 'from', type: 'dropdownsearch', hidden: this.plannedActualCalculationSetting.fullMonth,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        items: items,
                        selectedItem: this.plannedActualCalculationSetting.fullMonth? items[0] : items.find((i) => i.value._d.getTime() == this.plannedActualCalculationSetting.from._d.getTime())
                    },
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let flag = datafill.entries.find(i => i.key == 'fullMonth').value;
                        if(flag){
                            entryBeforeUpdate.hidden = true;
                        } else {
                            entryBeforeUpdate.hidden = false;
                        }

                        return entryBeforeUpdate;
                    }
                });

                dataEntries.push({label: this.$t('roster.view.endDate'), key: 'to', type: 'dropdownsearch', hidden: this.plannedActualCalculationSetting.fullMonth,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        items: items,
                        selectedItem: this.plannedActualCalculationSetting.fullMonth? items[items.length - 1] : items.find((i) => i.value._d.getTime() == this.plannedActualCalculationSetting.to._d.getTime())
                    },
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let flag = datafill.entries.find(i => i.key == 'fullMonth').value;
                        if(flag){
                            entryBeforeUpdate.hidden = true;
                        } else {
                            entryBeforeUpdate.hidden = false;
                        }

                        return entryBeforeUpdate;
                    }
                });

                dataEntries.push({label: this.$t('roster.view.balancePeriod'), key: 'saldoMode', type: 'dropdownsearch', hidden: this.plannedActualCalculationSetting.fullMonth,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        items: saldoModes,
                        selectedItem: selectedSaldoMode
                    },
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let flag = datafill.entries.find(i => i.key == 'fullMonth').value;
                        if(flag){
                            entryBeforeUpdate.hidden = true;
                        } else {
                            entryBeforeUpdate.hidden = false;
                        }

                        return entryBeforeUpdate;
                    }
                });

                dataEntries.push({label: this.$t('roster.view.calcMethod'), key: 'workTimeMode', type: 'dropdownsearch', hidden: false, value: selectedWorkTimeMode.value,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        items: workTimeModes,
                        selectedItem: selectedWorkTimeMode
                    }
                });

                dataEntries.push(
                    {label: this.$t('roster.view.overwriteAverageFactor'), key: 'enableWorkTimeFactorOverride', hidden: selectedWorkTimeMode.value != 0, type: 'bool',
                    value: this.plannedActualCalculationSetting.enableWorkTimeFactorOverride,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let flag = datafill.entries.find(i => i.key == 'workTimeMode').value;
                        if(flag == 0){
                            entryBeforeUpdate.hidden = false;
                        } else {
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;
                        }

                        return entryBeforeUpdate;
                    }
                });

                dataEntries.push(
                    {label: this.$t('store.allowedContracts.averageFactor'), key: 'enforcedWorkTimeFactor', hidden: !(selectedWorkTimeMode.value == 0 && this.plannedActualCalculationSetting.enableWorkTimeFactorOverride), type: 'slider',
                     value: this.plannedActualCalculationSetting.enforcedWorkTimeFactor, min: 4*Math.pow(10,7), max: 5*Math.pow(10,7),
                     slider: {min: 4*Math.pow(10,7), max: 5*Math.pow(10,7), value: this.plannedActualCalculationSetting.enforcedWorkTimeFactor,
                         step: 0.005 *Math.pow(10,7), DisplayLabel: (x) => {return (x/Math.pow(10,7)).toFixed(4)},
                         inputControl: true, sliderInput: (x) => {return x * Math.pow(10,7)}},
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let flag = datafill.entries.find(i => i.key == 'enableWorkTimeFactorOverride').value;
                        if(flag){
                            entryBeforeUpdate.hidden = false;
                        } else {
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = this.storeSettings.workTimeFactor;
                        }

                        return entryBeforeUpdate;
                    }
                    });





                this.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        errorCheck: [
                            (entries) => {
                               if(entries.hasOwnProperty('to') && entries['fullMonth'] == false && entries['to'] <= entries['from']){
                                   return {key: 'to', type: 'error', label: this.$t('roster.view.endDate'), text: this.$t('roster.view.endDateError')}
                               } else {
                                   return null
                               }
                           },
                       ],
                        selectCallback: function (item) {
                            if(!item.limitToEmployees){
                                item.employees = [];
                            }
                            if(item.fullMonth){
                                item.from = items[0];
                                item.to = items[items.length - 1];
                            }

                            delete item.info;
                            view.savePlannedActualCalculationSetting(item);
                        }
                    },
                    header: this.$t('roster.view.adjustTargetPlanning'),
                    centered: true,
                    width: '600px',
                    expanded: true,
                });


            },
            openDateContextMenu($event, indexweek, index){
                let view = this;

                if(!indexweek){
                    return;
                }
                let date = this.gridWeekInfo[indexweek+'-'+index].date.clone();
                this.dateContextMenuDate = date;
                this.$refs.datecontextmenu.showMenu(event, {date: date});
            },
            openShiftContextMenu($event, indexweek, index, employee){

                let shifts = this.rosterContentMap[employee.id][this.gridWeekInfo[indexweek+'-'+index].dateString].planShifts;
                if(shifts.length > 0){
                    let shift = shifts[0];
                    if(!shift.published && !shift.locked){
                        if(!indexweek){
                            return;
                        }
                        let date = this.gridWeekInfo[indexweek+'-'+index].date.clone();
                        this.$refs.shiftcontextmenu.showMenu($event, {date: date, employee: employee, shift: shift});
                    }
                }
            },
            dateContextMenuOptionClicked(event){
                let optionKey = event.option.key;
                switch(optionKey){
                    case 'dailyroster':
                        this.OpenDailyRosterPopup(this.dateContextMenuDate);
                        break;
                    case 'unassignedshifts':
                        this.OpenDailyRosterPopup(this.dateContextMenuDate, true);
                        break;
                    case 'mealcosts':
                        this.generateEmployeeMealCostsReport(this.dateContextMenuDate);
                        break;
                    case 'breakform':
                        this.OpenEmployeeBreakReportPopup(this.dateContextMenuDate);
                        break;
                    case 'rosternotice':
                        this.OpenRosterNoticePopup(this.dateContextMenuDate);
                        break;
                    case 'taskoverview':
                        this.openTaskOverviewPopup(this.dateContextMenuDate);
                        break;
                }
            },
            openTaskOverviewPopup(date) {
                let view = this;

                this.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: [
                            {
                                label: this.$t('pages.positionOverview.sortChronological') + '?',
                                key: 'sortChronological',
                                hidden: false,
                                type: 'bool',
                                value: true
                            },
                            {
                                label: this.$t('pages.positionOverview.publishOnly') + '?',
                                key: 'publishedOnly',
                                hidden: false,
                                type: 'bool',
                                value: true
                            },],
                        selectCallback: function (data) {
                            view.exportTaskOverviewToFile(date, data);
                        }
                    },
                    header: view.$t('roster.view.taskOverview'),
                    expanded: true,
                    width: "700px",
                    centered: true
                });
            },
            OpenRosterNoticePopup(date){
                let view = this;

                let state =  {
                    date
                }
                view.$helpers.OpenPopup({
                    elRelative: null,
                    type: 'rosternoticeoverview',
                    componentState: state,
                    expanded: true,
                    centered: true,
                    scrolling: true,
                    remainAfterSelect: false,
                    width: '60vw',
                    header: this.$t('roster.view.notes') + ' - '+date.format('DD.MM.YYYY'),
                    customEventName:"modified-rosternoticeoverview",
                    customEventHandler:(data) => {

                    }
                });
            },
            shiftContextMenuOptionClicked(event){
                let optionKey = event.option.key;
                switch(optionKey){
                    case 'edit':
                        console.log('Show edit shift popup')
                        this.OpenEditShiftPopup(event.item.shift);
                        break;
                }
            },

            GenerateDates(){

                this.dayModeDate = this.$helpers.getMomentTZ();
                if(this.rosterFromTo != null){
                    let startDate = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
                     console.log("ROSTER GENERATE DATES A")
                    this.setDateSelection(startDate, true);
                } else {
                    console.log("ROSTER GENERATE DATES B")
                    this.setDateSelection(this.$helpers.getCurrentMonthMomentTZ(), true);
                }
            },
            GetSwitchedShiftColor(employee, dateFormat, darkState){
                if(this.employeeDayStatusMap[employee.id][dateFormat]){
                    if(this.employeeDayStatusMap[employee.id][dateFormat].hasActualShift && this.rosterVisibilityState.visibilityActualShifts) {
                        return darkState ? '#e86e13' : '#e0a374';
                    } else {
                        let color = '';
                        if(this.rosterVisibilityState.daySpotColorSwitch){
                            color = this.employeeDayStatusMap[employee.id][dateFormat].spotColor;
                        } else if(this.rosterVisibilityState.dayProjectColorSwitch) {
                            color = this.employeeDayStatusMap[employee.id][dateFormat].projectColor;
                        }
                        if(color != ''){
                            color = this.$helpers.hexToHSLObject(color);
                            if(color.s !== 0) color.s += (100 - color.s) * .9; //color.s === 0 means it's monochrome, adding more saturation would make it red
                            if(color.s !== 0) color.l += (100 - color.l) * .6;
                            else color.l += (100 - color.l) * .7;

                            if(darkState) {
                                color.l *= .85;
                                color.s *= .6;
                            }
                            return 'hsl(' + color.h + 'deg,' + color.s + '%,' + color.l + '%)';
                        } else {
                            return color;
                        }
                    }

                } else {
                    return '';
                }

            },
            GetDayBottomLeftIconColor(employee, dateFormat){
                return this.employeeDayStatusMap[employee.id][dateFormat].hasActualShift ? '#eba767' : this.employeeDayStatusMap[employee.id][dateFormat].spotColor + ' !important';
            },
            loadStoreEvents: function(storeId, rosterFromTo) {
                let url = '/api/sec/storeevent';

                let params = {
                    storeId: storeId,
                    active: true,
                    from: rosterFromTo.from,
                    to: rosterFromTo.to
                };

                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                });
            },
            loadShiftTemplatesPagedCompletely : function(payload, page = 1, data = []) {

                let url = '/api/sec/shifttemplate/any/event';
                let params = {
                        storeId: this.$store.state.storeId,
                        validFrom: this.rosterFromTo.from,
                        validTo: this.rosterFromTo.to,
                        page: page,
                        validGroup: true
                }

                return this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {

                    if (response.data.length < 1 ) {
                        return data;
                    } else {
                        data.push(...response.data);
                        return this.loadShiftTemplatesPagedCompletely (payload, page+1, data);
                    }


                })


            },

            CheckEmployeeDetailsHover($event){
                if(Object.keys(this.employeeHover).length === 0) return;
                if(window.mouse.x > 240 || window.mouse.y < 144) {
                    this.employeeHover = {};
                }
            },
            SetEmployeeDetailsHover(index, value){
                let view = this;
                if(value) {
                    view.employeeHover = {};
                    view.$set(view.employeeHover, index, value);
                }
            },
            GetContrastingColor(hex, lightcolor = 'white', darkcolor = '#444444', contrastLimit = 80) {
                return this.$helpers.GetContrastingColor(hex, lightcolor, darkcolor, contrastLimit);
            },
            plannedActualOverflow(employeeId) {
                let factor = 1;
                for (let i in this.employeePlannedActual) {
                    let obj = this.employeePlannedActual[i];
                    if(i == employeeId){
                        obj.overflow_factor = (obj.total > 0.0 && obj.sollWorkTime > 0.0) ? obj.sollWorkTime / (obj.sollWorkTime+obj.total) : 1;
                        factor = Math.min(factor,obj.overflow_factor);
                    }
                }
                return factor;
            },
            SummarySnapShot(){
                let view = this;
                let employees = Object.values(this.employeeMap).filter(emp => {
                    if(view.rosterSortState.showSpots){
                        return this.displayedSpots.includes(emp.spotId) || emp.spotId == null;
                    } else if(view.rosterSortState.showBusinessUnits) {
                        if(emp.spotId == null){
                            return true
                        } else {
                            let empSpot = view.spotMap[emp.spotId]
                            let mainSpot = Object.values(view.spotMap).find(s => s.isMain && s.unitId == empSpot.unitId);
                            return this.displayedSpots.includes(mainSpot.id);
                        }

                    } else if(view.rosterSortState.filterByShiftSpot){
                        let skills = this.employeeEmployeeSkillMap[emp.id];
                        let hasSkill = skills != null && skills.some(s => view.displayedSkills.includes(s.skillId));
                        let hasShift = Object.values(this.planShiftMap).some(p => p.employeeId == emp.id && view.displayedSpots.includes(p.spotId));
                        return (hasSkill && !view.rosterSortState.filterByOnlyShiftSpot) || hasShift;
                    } else {
                        return true;
                    }
                })

                view.$refs.rostersummary.GetSnapshots(employees, () => {
                    view.hideSummary = true;
                });
            },
            RefreshVeryImportantData(){
                if(this.loading || this.refreshingData) return; //this gets called 3 times while loading from the watches, you can't see anything while it loads so the maps the vue bindings depend on shouldn't be updated, I changed the refresh order so it sets .loading false then calls this function
                //ORDER MATTERS HERE DONT FUCK WITH IT UNLESS YOU KNOW WHAT YOU ARE DOING
                let t0 = performance.now();
                this.refreshingData = true;

                this.loadPlannedActualCalculationSetting();
                let prefMaps = this.RefreshEmployeePreferenceMaps();
                let shiftMaps = this.RefreshShiftMaps();

                //must be after refresh shiftmaps
                this.RefreshLegalMap(shiftMaps, prefMaps);
                this.RefreshEmployeePlannedActual();
                this.RefreshEmployeeDayStatusMap();
                this.RefreshRosterContentMap();
                this.LoadAssignedShiftSpotListToolTipMap();
                this.LoadUnassignedShiftSpotListToolTipMap();
                let t1 = performance.now();
                this.refreshingData = false;
                console.log("REFRESH OF IMPORTANT DATA TOOK: "+(t1-t0)/1000);
            },
            RefreshVeryImportantDataDelta(oldEmployeeId, newEmployeeId, oldDates, newDates){
                if(this.loading || this.refreshingData) return; //this gets called 3 times while loading from the watches, you can't see anything while it loads so the maps the vue bindings depend on shouldn't be updated, I changed the refresh order so it sets .loading false then calls this function
                //ORDER MATTERS HERE DONT FUCK WITH IT UNLESS YOU KNOW WHAT YOU ARE DOING
                let t0 = performance.now();
                this.refreshingData = true;

                this.loadPlannedActualCalculationSetting();
                let prefMaps = this.RefreshEmployeePreferenceMaps();
                let shiftMaps = this.RefreshShiftMaps();

                //must be after refresh shiftmaps
                let oldDateKeys = [];
                let newDateKeys = [];
                //in case a full week shift law was broken, we must update the whole week
                let oldWeekStartSet = new Set();
                let oldWeekKeys = [];
                let newWeekStartSet = new Set();
                let newWeekKeys = [];
                if(oldDates){
                     oldDates.forEach(d => {
                        let startOfWeek = d.clone().startOf('isoWeek')
                        oldWeekStartSet.add(startOfWeek.format("YYYY-MM-DD"));
                        oldDateKeys.push(d.format("YYYY-MM-DD"))

                        //need to check previous weeks too because rest time over sunday
                        let prevWeek = startOfWeek.add(-1, 'weeks').startOf('isoWeek');
                        oldWeekStartSet.add(prevWeek.format("YYYY-MM-DD"));

                    })
                }
                if(newDates){
                    newDates.forEach(d => {
                        let startOfWeek = d.clone().startOf('isoWeek')
                        newWeekStartSet.add(startOfWeek.format("YYYY-MM-DD"));
                        newDateKeys.push(d.format("YYYY-MM-DD"))
                        //need to check previous weeks too because rest time over sunday
                        let prevWeek = startOfWeek.add(-1, 'weeks').startOf('isoWeek');
                        newWeekStartSet.add(prevWeek.format("YYYY-MM-DD"));

                    })
                }

                oldWeekStartSet.forEach(d => {
                    let dayIter = this.$helpers.getMomentFromStringTZ(d, "YYYY-MM-DD");
                    let iterEnd = dayIter.clone().endOf('isoWeek');
                    while(dayIter <= iterEnd){
                        oldWeekKeys.push(dayIter.format("YYYY-MM-DD"));
                        dayIter = dayIter.add(1, 'days');
                    }
                });
                newWeekStartSet.forEach(d => {
                    let dayIter = this.$helpers.getMomentFromStringTZ(d, "YYYY-MM-DD");
                    let iterEnd = dayIter.clone().endOf('isoWeek');
                    while(dayIter <= iterEnd){
                        newWeekKeys.push(dayIter.format("YYYY-MM-DD"));
                        dayIter = dayIter.add(1, 'days');
                    }
                });

                this.RefreshLegalMapDelta(shiftMaps, prefMaps, oldEmployeeId, newEmployeeId);
                this.RefreshEmployeePlannedActualDelta(oldEmployeeId, newEmployeeId);
                this.RefreshEmployeeDayStatusMapDelta(oldEmployeeId, newEmployeeId, oldDateKeys, newDateKeys);
                this.RefreshRosterContentMapDelta(oldEmployeeId, newEmployeeId, oldWeekKeys, newWeekKeys);
                this.LoadAssignedShiftSpotListToolTipMap();
                this.LoadUnassignedShiftSpotListToolTipMap();
                let t1 = performance.now();
                this.refreshingData = false;
                this.refreshingDelta = false;
                this.$forceUpdate();
                console.log("REFRESH OF IMPORTANT DATA TOOK: "+(t1-t0)/1000);
            },
            RefreshEmployeePreferenceMaps() {
                let calculatedPreferenceMaps = this.$rosterhelper.getCalculatedPreferenceMaps(this.employeeMap, this.employeePreferenceMap, this.employeeAvailabilityMap, this.rosterFromTo);
                this.employeePreferenceMomentMap = calculatedPreferenceMaps.employeePreferenceMomentMap;
                this.employeePreferenceAvailabilityMap = calculatedPreferenceMaps.employeePreferenceAvailabilityMap;
                this.employeeUnapprovedPreferenceAvailabilityMap = calculatedPreferenceMaps.employeeUnapprovedPreferenceAvailabilityMap;
                return calculatedPreferenceMaps;
            },
            RefreshShiftMaps(){
                let t0 = performance.now();
                let view = this;
                let maps = this.$rosterhelper.getCalculatedShiftMaps(this.planShiftMap, this.actualShiftMap, this.actualBreakMap, this.employeeMap, this.currentMonthEmployeeContractMap /*this.employeeContractMap*/, this.spotMap, this.businessUnitMap, this.rosterFromTo, this.customSpotMap, this.externalShiftMap);

                view.unassignedShiftsDateMap = maps.unassignedShiftsDateMap;
                view.planShiftDateMap = maps.planShiftDateMap;
                view.actualShiftDateMap = maps.actualShiftDateMap;
                view.employeeDatePlannedShiftMap = maps.employeeDatePlannedShiftMap;
                view.employeeDateActualShiftMap = maps.employeeDateActualShiftMap;
                view.employeeDateActualShiftMarkedMap = maps.employeeDateActualShiftMarkedMap; //marks on which days the actual shifts were planned in order to hide planshifts on those days
                view.employeeDateCombinedShiftMap = maps.employeeDateCombinedShiftMap;
                view.employeeContractStatusMap = maps.employeeContractStatusMap;
                view.employeeIdContractMap = maps.employeeIdContractMap;
                view.employeeContractMomentMap = maps.employeeContractMomentMap;
                view.planshifts = maps.planshifts;
                view.customPlanShiftMap = maps.customPlanShiftMap;

                view.actualShiftMomentMap = maps.actualShiftMomentMap;
                view.actualBreakShiftIdMap = maps.actualBreakShiftIdMap;
                view.actualBreakMomentMap = maps.actualBreakMomentMap;
                view.planShiftMomentMap = maps.planShiftMomentMap;

                view.unpublishedShiftsWeeklyMap = maps.unpublishedShiftsWeeklyMap;
                view.unassignShiftsWeeklyMap = maps.unassignShiftsWeeklyMap;
                view.publishedShiftsWeeklyMap = maps.publishedShiftsWeeklyMap;
                view.shiftsWeeklyMap = maps.shiftsWeeklyMap;




                let t1 = performance.now();

                console.log("Refreshing of planshift datemaps took: "+(t1-t0)/1000);
                return maps;
            },
            RefreshEmployeePlannedActual(){
                let t0 = performance.now();
                //console.log("#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+");
                //console.log("#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+");
                let view = this;
                let map = this.$rosterhelper.calculatePlannedActualMap(view.employeeMap, view.planShiftMap, view.planShiftMomentMap,
                                                                       view.actualShiftMomentMap, view.actualBreakShiftIdMap, view.actualBreakMomentMap,
                                                                       view.employeeDatePlannedShiftMap, view.employeeDateActualShiftMap,
                                                                       view.employeeDateActualShiftMarkedMap, view.employeePreferenceAvailabilityMap,
                                                                       view.employeePreferenceMomentMap, view.customHolidayMap, view.employeeIdWorkBalanceMap,
                                                                       view.employeeIdContractMap, view.employeeContractMomentMap, view.allowedContractMap,
                                                                       view.rosterVisibilityState, view.plannedActualCalculationSetting,
                                                                       view.storeSettings,
                                                                       view.employeeAvgWorktimeMap,
                                                                       view.$helpers);


                this.employeePlannedActual = map;
                //console.log("#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+");
                //console.log("#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+");
                let t1 = performance.now();
                let seconds = (t1-t0) / 1000.0;
                console.log("RefreshEmployeePlannedActual TOOK " + seconds + " seconds.");
            },
            RefreshEmployeePlannedActualDelta(oldEmployeeId, newEmployeeId){
                let t0 = performance.now();
                //console.log("#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+");
                //console.log("#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+");
                let view = this;
                let map = this.$rosterhelper.calculatePlannedActualMapDelta(this.employeePlannedActual, oldEmployeeId, newEmployeeId, view.employeeMap, view.planShiftMap, view.planShiftMomentMap,
                                                                       view.actualShiftMomentMap, view.actualBreakShiftIdMap, view.actualBreakMomentMap,
                                                                       view.employeeDatePlannedShiftMap, view.employeeDateActualShiftMap,
                                                                       view.employeeDateActualShiftMarkedMap, view.employeePreferenceAvailabilityMap,
                                                                       view.employeePreferenceMomentMap, view.customHolidayMap, view.employeeIdWorkBalanceMap,
                                                                       view.employeeIdContractMap, view.employeeContractMomentMap, view.allowedContractMap,
                                                                       view.rosterVisibilityState, view.plannedActualCalculationSetting,
                                                                       view.storeSettings,
                                                                       view.employeeAvgWorktimeMap,
                                                                       view.$helpers);


                view.$set(this, 'employeePlannedActual', map);
                //console.log("#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+");
                //console.log("#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+#+");
                let t1 = performance.now();
                let seconds = (t1-t0) / 1000.0;
                console.log("RefreshEmployeePlannedActual TOOK " + seconds + " seconds.");
            },
            RefreshLegalMap(shiftMaps, prefMaps){
                 let t0 = performance.now();
                 this.legalErrorMap = this.$rosterhelper.performLegalAndPlantypeChecks(
                     this.employeeMap,
                     this.employeeTypeMap,
                     this.employeeSkillMap,
                     this.spotMap,
                     this.allowedContractMap,
                     this.collectiveContractMap,
                     this.storeSettings,
                     this.$store.state.rosterFromTo,
                     this.$helpers,
                     shiftMaps,
                     prefMaps,
                     this.youthWorkConfigMap,
                     this.employeeAvgWorktimeMap
                );
                let t1 = performance.now();
                let seconds = (t1 - t0) / 1000.0;
                //console.log("********************");
                //console.log("********************");
                console.log("Gesetzliche Checks calculation took " + seconds + " seconds.");
            },
            RefreshLegalMapDelta(shiftMaps, prefMaps, oldEmployeeId, newEmployeeId){
                let t0 = performance.now();
                let view = this;
                let rosterFrom = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.from).add(-1, 'days');
                let rosterTo = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.to).add(1, 'days');

                let monthFrom = rosterFrom.clone().date(1).month(this.rosterFromTo.month).year(this.rosterFromTo.year);
                let monthTo = monthFrom.clone().add(1, 'month');


                let mapTemplate = {};
                //sundays needed for the g*rmans
                let weekEndDayKeys = []
                let saturDayKeys = []
                let tRosterFrom = rosterFrom.clone();
                let tRosterTo = rosterTo.clone().add(1,'days');
                while (tRosterTo .diff(tRosterFrom) > 0) {
                    let dateString = tRosterFrom.format("YYYY-MM-DD");
                    if (tRosterFrom.isoWeekday() == 7 && tRosterFrom.month() == this.rosterFromTo.month && tRosterFrom.year() == this.rosterFromTo.year) {
                        let satKey = tRosterFrom.clone().add(-1, 'days').format("YYYY-MM-DD");
                        weekEndDayKeys.push({sunDay: dateString, satDay: satKey});
                    }
                    if (tRosterFrom.isoWeekday() == 6 && tRosterFrom.month() == this.rosterFromTo.month && tRosterFrom.year() == this.rosterFromTo.year) {

                        saturDayKeys.push(dateString);
                    }

                    mapTemplate[dateString] = {};
                    tRosterFrom.add(1, 'days');
                }


                let dateString = rosterFrom.format("YYYY-MM-DD");
                mapTemplate[dateString] = {};
                //template map creation end
                let momentDateBoundaryMap = {};
                let map = this.legalErrorMap;
                if(oldEmployeeId != null){
                    let employee = view.employeeMap[oldEmployeeId];
                    let legalDayMap = this.$rosterhelper.calculateLegalDayMapForEmployee(employee,
                                                            mapTemplate,
                                                            weekEndDayKeys,
                                                            saturDayKeys,
                                                            momentDateBoundaryMap,
                                                            monthFrom,
                                                            monthTo,
                                                            this.storeSettings,
                                                            this.rosterFromTo,
                                                            rosterFrom,
                                                            rosterTo,
                                                            shiftMaps,
                                                            prefMaps,
                                                            this.collectiveContractMap,
                                                            this.allowedContractMap,
                                                            this.spotMap,
                                                            this.employeeMap,
                                                            this.employeeSkillMap,
                                                            this.employeeTypeMap,
                                                            this.employeeAvgWorktimeMap,
                                                            this.youthWorkConfigMap,
                                                            this.$helpers);
                    map[employee.id] = legalDayMap;

                }
                if(newEmployeeId != null){
                    let employee = view.employeeMap[newEmployeeId];
                    let legalDayMap = this.$rosterhelper.calculateLegalDayMapForEmployee(employee,
                                                            mapTemplate,
                                                            weekEndDayKeys,
                                                            saturDayKeys,
                                                            momentDateBoundaryMap,
                                                            monthFrom,
                                                            monthTo,
                                                            this.storeSettings,
                                                            this.rosterFromTo,
                                                            rosterFrom,
                                                            rosterTo,
                                                            shiftMaps,
                                                            prefMaps,
                                                            this.collectiveContractMap,
                                                            this.allowedContractMap,
                                                            this.spotMap,
                                                            this.employeeMap,
                                                            this.employeeSkillMap,
                                                            this.employeeTypeMap,
                                                            this.employeeAvgWorktimeMap,
                                                            this.youthWorkConfigMap,
                                                            this.$helpers);
                    map[employee.id] = legalDayMap;

                }
                this.$set(this, 'legalErrorMap', map);
                let t1 = performance.now();
                let seconds = (t1 - t0) / 1000.0;
                //console.log("********************");
                //console.log("********************");
                console.log("Gesetzliche Checks calculation took " + seconds + " seconds.");
            },
            RefreshEmployeeDayStatusMap(){
                let t0 = performance.now();
                let view = this;
                let map = {};
                let rosterFrom = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.from);
                let rosterTo = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.to);
                Object.values(this.employeeMap).forEach(e => {
                    map[e.id] = {
                        classes: '',
                        hasShift: null,
                    };
                    let currentDate = rosterFrom.clone();
                    while (currentDate < rosterTo){
                        let dateKey = currentDate.format('YYYY-MM-DD')

                        map[e.id][dateKey] = this.calculcateEmployeeDayStatusMapEntry(e.id, dateKey, currentDate);

                        currentDate = currentDate.add(1,'days');
                    }

                });
                let t1 = performance.now();
                let seconds = (t1-t0) / 1000.0;
                console.log("EMPLOYEEDAYSTATUS TOOK " + seconds + " seconds.");

                this.employeeDayStatusMap = map;

            },
            RefreshEmployeeDayStatusMapDelta(oldEmployeeId, newEmployeeId, oldDateKeys, newDateKeys){
                let t0 = performance.now();
                let view = this;

                let map = this.employeeDayStatusMap;
                if(oldEmployeeId != null){
                    let usedKeys = new Set();
                    if(oldDateKeys != null){
                        oldDateKeys.forEach(dk => {
                            if(!usedKeys.has(dk)){
                                let currentDate = view.$helpers.getMomentFromStringTZ(dk, "YYYY-MM-DD");
                                map[oldEmployeeId][dk] = this.calculcateEmployeeDayStatusMapEntry(oldEmployeeId, dk, currentDate);
                                usedKeys.add(dk);
                            }

                        })

                    }
                    if(newDateKeys != null ){
                        newDateKeys.forEach(dk => {
                            if(!usedKeys.has(dk)){
                                let currentDate = view.$helpers.getMomentFromStringTZ(dk, "YYYY-MM-DD");
                                map[oldEmployeeId][dk] = this.calculcateEmployeeDayStatusMapEntry(oldEmployeeId, dk, currentDate);
                                usedKeys.add(dk);
                            }

                        })
                    }
                }
                if(newEmployeeId != null && newEmployeeId != oldEmployeeId){
                    let usedKeys = new Set();
                    if(oldDateKeys != null){
                        oldDateKeys.forEach(dk => {
                            if(!usedKeys.has(dk)){
                                let currentDate = view.$helpers.getMomentFromStringTZ(dk, "YYYY-MM-DD");
                                map[newEmployeeId][dk] = this.calculcateEmployeeDayStatusMapEntry(newEmployeeId, dk, currentDate);
                                usedKeys.add(dk);
                            }

                        })

                    }
                    if(newDateKeys != null ){
                        newDateKeys.forEach(dk => {
                            if(!usedKeys.has(dk)){
                                let currentDate = view.$helpers.getMomentFromStringTZ(dk, "YYYY-MM-DD");
                                map[newEmployeeId][dk] = this.calculcateEmployeeDayStatusMapEntry(newEmployeeId, dk, currentDate);
                                usedKeys.add(dk);
                            }

                        })
                    }
                }


                let t1 = performance.now();
                let seconds = (t1-t0) / 1000.0;
                console.log("EMPLOYEEDAYSTATUS TOOK " + seconds + " seconds.");
                view.$set(view, 'employeeDayStatusMap', map);


            },
            calculcateEmployeeDayStatusMapEntry(employeeId, dateKey, currentDate){
                let view = this;
                let employee = view.employeeMap[employeeId];
                let shifts = view.GetShiftsByDateAndEmployee(employeeId, dateKey);
                let hasShift = shifts.length > 0;
                let hasPreview = false;
                if(shifts.length > 0){
                    let shift = shifts[0];
                    if(shift.preview != null){
                        hasPreview = shift.preview;
                    }
                }
                let actualShifts = view.GetActualShiftsByDateAndEmployee(employeeId, dateKey);
                let hasActualShift = actualShifts.length > 0;
                let hasEndMissingActualShifts = actualShifts.filter(a => a.endMissing == true).length > 0
                let actualShiftMarked = (view.employeeDateActualShiftMarkedMap[employeeId] && view.employeeDateActualShiftMarkedMap[employeeId][dateKey]);


                let inRange = currentDate.month() == this.rosterFromTo.month;
                let dateIconState = view.GetDateIconState(employee, currentDate);
                let result = {
                    hasPreview: hasPreview,
                    inRange: inRange,
                    hasShift: hasShift,
                    hasActualShift: hasActualShift,
                    hasEndMissingActualShifts: hasEndMissingActualShifts,
                    actualShiftMarked: actualShiftMarked,
                    hasUnpublished: shifts && shifts.find(s => !s.published),
                    hasEnforced: shifts && shifts.find(s => s.status === 2),
                    hasPinned: shifts && shifts.find(s=> s.pinned),
                    hasLocked: shifts && shifts.find(s=> s.locked),
                    spotColor: hasShift ? view.customSpotMap[shifts[0].spotId].color : '',
                    projectColor: hasShift && shifts[0].projectId != null ? view.projectMap[shifts[0].projectId].color : '',
                    iconState: dateIconState,
                };

                return result;
            },
            RefreshRosterContentMap() {
                console.log("Refreshing roster content map")
                let t0 = performance.now();
                let view = this;
                let map = {};
                let rosterFrom = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.from);
                let rosterTo = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.to);

                this.$rosterhelper.calculateShiftTimeByDayMap(rosterFrom, rosterTo,
                                                             view.planShiftMap, view.planShiftMomentMap,
                                                             view.actualShiftMap, view.actualShiftMomentMap,
                                                             view.actualBreakMap, view.actualBreakMomentMap,
                                                             view.actualBreakShiftIdMap,
                                                             view.employeeMap,
                                                             view.spotMap, this.$helpers);

                /*
                if(this.dayMode){
                    let ty= performance.now();
                    this.$rosterhelper.calculateShiftTimeByHourMap(rosterFrom, rosterTo,
                                                             view.planShiftMap, view.planShiftMomentMap,
                                                             view.actualShiftMap, view.actualShiftMomentMap,
                                                             view.actualBreakMap, view.actualBreakMomentMap,
                                                             view.actualBreakShiftIdMap,
                                                             view.employeeMap,
                                                             view.spotMap, this.$helpers);
                    let tz= performance.now();
                    console.log("SHIFT TIME BY HOUR TOOK " + ((tz-ty) / 1000.0) + " seconds.");
                } */


                let dateKeys = [];
                let currentDate = rosterFrom.clone();
                let endDate = rosterTo.clone().add(1, 'days');

                while (currentDate < endDate) {
                    let dateKey = currentDate.format("YYYY-MM-DD");
                    dateKeys.push(dateKey);
                    currentDate.add(1, 'days');
                }


                Object.values(this.employeeMap).filter(emp => {
                    if(view.rosterSortState.showSpots){
                        return this.displayedSpots.includes(emp.spotId) || emp.spotId == null;
                    } else if(view.rosterSortState.showBusinessUnits) {
                        if(emp.spotId == null){
                            return true
                        } else {
                            let empSpot = view.spotMap[emp.spotId]
                            let mainSpot = Object.values(view.spotMap).find(s => s.isMain && s.unitId == empSpot.unitId);
                            return this.displayedSpots.includes(mainSpot.id);
                        }

                    } else if(view.rosterSortState.showShiftSpots) {
                        // if(emp.shifts == undefined || emp.shifts.length == 0){
                        //     return true
                        // } else {
                        //     let empSpots = emp.shifts.map(s => s.spotId);
                        //     return this.displayedSpots.includes(empSpots);
                        // }
                        return true;
                    } else if(view.rosterSortState.filterByShiftSpot){
                        let skills = this.employeeEmployeeSkillMap[emp.id];
                        let hasSkill = skills != null && skills.some(s => view.displayedSkills.includes(s.skillId));
                        let hasShift = Object.values(this.planShiftMap).some(p => p.employeeId == emp.id && view.displayedSpots.includes(p.spotId));
                        return (hasSkill && !view.rosterSortState.filterByOnlyShiftSpot) || hasShift;
                    } else {
                        return true;
                    }
                }).forEach(employee => {
                    map[employee.id] = {};
                    for(let key = 0; key < dateKeys.length - 1; key++) { //length -1 cause last one is for shift time aggregation calc overflow into date past rosterto
                        let dateKey = dateKeys[key];
                        let entry = view.calculateRosterContentEntry(employee, dateKey);
                        map[employee.id][dateKey] = entry;
                    }

                });




                let t1 = performance.now();
                let seconds = (t1-t0) / 1000.0;
                console.log("ROSTER CONTENT TOOK " + seconds + " seconds.");
                this.rosterContentMap = map;
            },
            RefreshRosterContentMapDelta(oldEmployeeId, newEmployeeId, oldDateKeys, newDateKeys) {
                console.log("Refreshing roster content map")
                let t0 = performance.now();
                let view = this;



                let map = this.rosterContentMap;
                if(oldEmployeeId != null){
                    let employee = view.employeeMap[oldEmployeeId];
                    let usedKeys = new Set();
                    if(oldDateKeys != null){
                        oldDateKeys.forEach(dk => {
                            if(!usedKeys.has(dk)){
                                map[oldEmployeeId][dk] = view.calculateRosterContentEntry(employee, dk);
                                usedKeys.add(dk);
                            }

                        })

                    }
                    if(newDateKeys != null ){
                        newDateKeys.forEach(dk => {
                            if(!usedKeys.has(dk)){
                                map[oldEmployeeId][dk] = view.calculateRosterContentEntry(employee, dk);
                                usedKeys.add(dk);
                            }

                        })
                    }
                }
                if(newEmployeeId != null){
                    let employee = view.employeeMap[newEmployeeId];
                    let usedKeys = new Set();
                    if(oldDateKeys != null){
                        oldDateKeys.forEach(dk => {
                            if(!usedKeys.has(dk)){
                                map[newEmployeeId][dk] = view.calculateRosterContentEntry(employee, dk);
                                usedKeys.add(dk);
                            }

                        })

                    }
                    if(newDateKeys != null ){
                        newDateKeys.forEach(dk => {
                            if(!usedKeys.has(dk)){
                                map[newEmployeeId][dk] = view.calculateRosterContentEntry(employee, dk);
                                usedKeys.add(dk);
                            }

                        })
                    }
                }

                let tx= performance.now();
                this.$rosterhelper.calculateShiftTimeByDayMapDelta(
                                                            this.shiftTimeByDayMap,
                                                            oldDateKeys,
                                                            newDateKeys,
                                                            view.planShiftDateMap, view.actualShiftDateMap,
                                                            view.planShiftMap, view.planShiftMomentMap,
                                                            view.actualShiftMap, view.actualShiftMomentMap,
                                                            view.actualBreakMap, view.actualBreakMomentMap,
                                                            view.actualBreakShiftIdMap,
                                                            view.employeeMap,
                                                            view.spotMap, this.$helpers);

                let ty= performance.now();

                console.log("SHIFT TIME BY DAY DELTA TOOK " + ((ty-tx) / 1000.0) + " seconds.");

                if(this.dayMode){
                    this.$rosterhelper.calculateShiftTimeByHourMapDelta(
                                                            this.shiftTimeByHourMap,
                                                            oldDateKeys,
                                                            newDateKeys,
                                                            view.planShiftDateMap, view.actualShiftDateMap,
                                                            view.planShiftMap, view.planShiftMomentMap,
                                                            view.actualShiftMap, view.actualShiftMomentMap,
                                                            view.actualBreakMap, view.actualBreakMomentMap,
                                                            view.actualBreakShiftIdMap,
                                                            view.employeeMap,
                                                            view.spotMap, this.$helpers);

                    let tz= performance.now();

                    console.log("SHIFT TIME BY HOUR DELTA TOOK " + ((tz-ty) / 1000.0) + " seconds.");
                }



                let t1 = performance.now();
                let seconds = (t1-t0) / 1000.0;
                console.log("ROSTER CONTENT TOOK " + seconds + " seconds.");
                this.$set(this, 'rosterContentMap', map);

            },
            calculateRosterContentEntry(employee, dateKey){
                let view = this;
                let entry = {
                            'planShifts' : [],
                            'planLow' : null,
                            'planLowText' : null,
                            'planHigh' : null,
                            'planHighText' : null,

                            'actualShifts' : [],
                            'actualLow' : null,
                            'actualLowText' : null,
                            'actualHigh' : null,
                            'actualHighText' : null,
                            'hasPlanError': false,
                            'hasLegalError': false,
                            'hasEndMissing': false,
                            'desiredPreferenceMatched': false,
                            'desiredPreferenceNotMatched': false,
                            'undesiredPreferenceMatched': false,
                            'isBirthDay': false,
                            'hasExtraPayment': false,
                            'showInRoster': 'icon',

                            'hasOverlappingError': false,
                            'confirmed': false,
                            'external': false,
                            'tooltip': () => {return null},

                            'hasShiftDeclinedError': false,
                            'hasShiftEnforcedWarning': false,
                            'hasShiftDurationWarning': false,
                            // Frontend Check for testing stores "Testumgebung Kunde 1", "Testumgebung Kunde 2", "Testumgebung Kunde 3"
                            'hasConsecutiveError': false,

                            bgColor: '',
                };

                entry.hasPlanError = view.HasPlanTypeError(employee, dateKey);
                entry.hasLegalError = view.HasLegalError(employee, dateKey);
                entry.hasOverlappingError = view.HasOverlappingError(employee, dateKey);
                entry.hasShiftDeclinedError = view.HasShiftDeclinedError(employee, dateKey);
                entry.hasShiftEnforcedWarning = view.HasShiftEnforcedWarning(employee, dateKey);
                entry.hasShiftDurationWarning = view.HasShiftDurationWarning(employee, dateKey);


                entry.hasExtraPayment = view.employeeDateEmployeeExtraPaymentMap[employee.id] && view.employeeDateEmployeeExtraPaymentMap[employee.id][dateKey] && view.employeeDateEmployeeExtraPaymentMap[employee.id][dateKey].length > 0;
                if(!entry.hasExtraPayment){
                    entry.undesiredPreferenceMatched = view.HasUndesiredPreferenceMatch(employee, dateKey);
                }
                if(!entry.hasExtraPayment && !entry.undesiredPreferenceMatched){
                    entry.desiredPreferenceMatched = view.HasDesiredPreferenceMatch(employee, dateKey);
                }
                if(!entry.hasExtraPayment && !entry.undesiredPreferenceMatched && !entry.desiredPreferenceMatched){
                    entry.desiredPreferenceNotMatched = view.HasDesiredPreferenceNotMatch(employee, dateKey)
                }
                if(!entry.hasExtraPayment && !entry.undesiredPreferenceMatched && !entry.desiredPreferenceMatched && !entry.desiredPreferenceNotMatched){
                    entry.isBirthDay =  (employee.dob ? (view.$helpers.getMomentFromStringTZ(employee.dob).format("MM-DD") == dateKey.substring(5)) : false);
                }

                // Frontend Check for testing stores "Testumgebung Kunde 1", "Testumgebung Kunde 2", "Testumgebung Kunde 3"
                // storeId of test stores 474, 475, 481 - add Teststore ID 65 for debugging
                if([65,474,475,481].includes(view.$store.state.storeId)){
                    entry.hasConsecutiveError = view.HasConsecutiveError(employee, dateKey);
                }

                if(this.employeeIdContractMap[employee.id].filter(c => c.probationTo && c.probationTo.substring(0,10) === dateKey).length > 0) {
                    entry.bgColor = "var(--info)";
                }
                if(this.rosterVisibilityState.visibilityPlanErrors && entry.hasPlanError){
                    entry.bgColor = "#eb8e23";
                }
                if(this.rosterVisibilityState.visibilityShiftStatusErrors && entry.hasShiftDurationWarning){
                    entry.bgColor = "#ff69b4";
                }
                if(this.rosterVisibilityState.visibilityOverlappingErrors && entry.hasOverlappingError){
                    entry.bgColor = "#a163db";
                }
                if(this.rosterVisibilityState.visibilityKVErrors && entry.hasLegalError){
                    entry.bgColor = "#e5154f";
                }
                if(this.rosterVisibilityState.visibilityShiftStatusErrors && entry.hasShiftDeclinedError){
                    entry.bgColor = "#e5154f";
                }
                // Frontend Check for testing stores "Testumgebung Kunde 1", "Testumgebung Kunde 2", "Testumgebung Kunde 3"
                if(entry.hasConsecutiveError){
                    entry.bgColor = "#0000ff";
                }

                let actualShifts = view.GetActualShiftsByDateAndEmployee(employee.id, dateKey);
                entry.actualShifts = actualShifts;
                let tooltip = null;
                if(actualShifts.length > 0){
                    let lowest = view.actualShiftMomentMap[actualShifts[0].id].fromDate;
                    let highest = view.actualShiftMomentMap[actualShifts[0].id].toDate;

                    let confirmed = true;
                    let comments = "";
                    actualShifts.forEach(s => {


                        let shiftMoment = view.actualShiftMomentMap[s.id];
                        let from = shiftMoment.fromDate;
                        let to = shiftMoment.toDate;

                        if(from.unix() < lowest.unix()) lowest = from;
                        if(to.unix() > highest.unix()) highest = to;
                        if(!s.confirmed) confirmed = false;
                        if(s.employeeComment != null && s.employeeComment != ''){
                            if(comments == ''){
                                comments = this.$t('roster.comp.punchTimeComment') + ': ';
                            }else{
                                comments += ", ";
                            }
                            comments += s.employeeComment.replace(/(?:\r\n|\r|\n)/g, '<br/>');
                        }
                    });
                    if(comments != ''){
                        tooltip = comments;
                    }
                    entry.actualLow = lowest;
                    entry.actualLowText = lowest.format('HH:mm');
                    entry.actualHigh = highest;
                    entry.actualHighText = highest.format('HH:mm');
                    entry.confirmed = confirmed;
                }

                let planShifts = view.GetShiftsByDateAndEmployee(employee.id, dateKey);
                entry.planShifts = planShifts;
                if(planShifts.length > 0){
                    let lowest = view.planShiftMomentMap[planShifts[0].id].fromDate;
                    let highest = view.planShiftMomentMap[planShifts[0].id].toDate;
                    planShifts.forEach(s => {
                        let shiftMoment = view.planShiftMomentMap[s.id];
                        let from = shiftMoment.fromDate;
                        let to = shiftMoment.toDate;
                        if (from.unix() < lowest.unix()) lowest = from;
                        if (to.unix() > highest.unix()) highest = to;
                        if(s.fromLocationId != null && view.locationMap[s.fromLocationId]){
                            entry.external = view.locationMap[s.fromLocationId].externalStoreId != null;
                            if(tooltip == null){
                                tooltip = "";
                            }
                            if(entry.external){
                                if(tooltip != ''){
                                    tooltip += "<br/>";
                                }
                                tooltip += this.$t('shift.location.externalOperation') + ": "
                            } else {
                                if(tooltip != ''){
                                    tooltip += "<br/>";
                                }
                                tooltip += this.$t('store.settings.location') + ": ";
                            }
                            tooltip+=" "+view.locationMap[s.fromLocationId].name+" ";
                        }
                        if(s.templateId != null && view.shiftTemplateMap[s.templateId] && !this.$helpers.isEmpty(view.shiftTemplateMap[s.templateId].description)){
                            if(tooltip == null){
                                tooltip = '';
                            }
                            if(tooltip != ''){
                                tooltip += "<br/>";
                            }
                            tooltip += this.$t('store.settings.info') + ": "+view.shiftTemplateMap[s.templateId].description;
                        }

                        if(view.rosterSortState.filterByShiftSpot && !view.displayedSpots.includes(s.spotId)){
                            entry.external = true;
                        }
                    });
                    entry.planLow = lowest;
                    entry.planLowText = lowest.format('HH:mm');
                    entry.planHigh = highest;
                    entry.planHighText = highest.format('HH:mm');
                }
                if(tooltip != null){
                    entry.tooltip = () => {
                        return tooltip
                    };
                }


                //What should be shown in roster (month)
                let dayStatus = this.employeeDayStatusMap[employee.id] ? (this.employeeDayStatusMap[employee.id][dateKey] ? this.employeeDayStatusMap[employee.id][dateKey] : {}) : {};

                if(this.rosterVisibilityState.visibilityActualShifts && dayStatus.hasActualShift){
                    entry.showInRoster = 'ist';
                    if(dayStatus.hasEndMissingActualShifts){
                        entry.hasEndMissing = true;
                    }

                } else if(this.rosterVisibilityState.visibilityPlanShifts && dayStatus.hasShift && (!dayStatus.actualShiftMarked || !this.rosterVisibilityState.visibilityActualShifts)){
                    entry.showInRoster = 'plan';
                } else {
                    entry.showInRoster = 'icon';
                }

                if (this.employeeIdContractMap[employee.id].filter(c => c.probationTo && c.probationTo.substring(0,10) === dateKey).length > 0) {
                    if (!this.employeeInfos[employee.id]) {
                        this.employeeInfos[employee.id] = {};
                    }
                    this.employeeInfos[employee.id][dateKey] = view.$t('shift.plan.probationEnd');
                }
                return entry;
            },

            CheckLegallyPublishable(ids){
                let legal = true;
                for(let i = 0; i<ids.length;i++){
                    let shift = this.planShiftMap[ids[i]];
                    let key = this.planShiftMomentMap[shift.id].fromDate.format("YYYY-MM-DD");
                    let employeeId = shift.employeeId;
                    let employee = this.employeeMap[employeeId];
                    let applyChecks = true;
                    if(employee){
                        applyChecks = employee.useRosterChecks;
                    }
                    let check = this.HasLegalError(this.employeeMap[employeeId], key, false)
                    if(check && applyChecks){
                        legal = false;
                        break;
                    }
                }

                return legal;
            },
            CheckDragScroll($event){
                if(!this.dragging) return;
                let scrollEl = this.$el.querySelector('.scrollbar-container');
                let scrollBox = scrollEl.getBoundingClientRect();
                if(window.mouse.y > scrollBox.bottom - 100){
                    this.AutoScroll('down');
                }
                if(window.mouse.y < scrollBox.top + 100){
                    this.AutoScroll('up');
                }
            },
            AutoScroll(direction){
                if(!this.dragging) return;
                let view = this;
                let scrollEl = this.$el.querySelector('.scrollbar-container');
                let scrollBox = scrollEl.getBoundingClientRect();

                if(direction === 'up' && scrollEl.scrollTop !== 0 && window.mouse.y < scrollBox.top + 100){
                    scrollEl.scrollTop -= 5;
                    requestAnimationFrame(function(){
                        view.AutoScroll(direction);
                    });
                    return;
                }

                let scrollTopMax = scrollEl.scrollHeight - scrollEl.offsetHeight;
                if(direction === 'down' && scrollEl.scrollTop < scrollTopMax && window.mouse.y > scrollBox.bottom - 100){
                    scrollEl.scrollTop += 5;
                    requestAnimationFrame(function(){
                        view.AutoScroll(direction);
                    });
                    return;
                }
            },
            GetUnassignedShiftsForSpotsByDate(date){
                let view = this;
                let result = [];
                let shifts = this.GetUnassignedShiftsByDate(date);
                if(shifts.length > 0){
                    shifts.forEach((s) => {
                        let spot = view.spotMap[s.spotId];
                        let add = true;
                        result.forEach((r) => {
                            if(r.spot.id == spot.id){
                                add = false;
                                r.shifts.push(s)
                            }
                        });
                        if(add){
                            result.push({
                                shifts: [s],
                                spot: spot
                            });
                        }
                    });
                }
                // sort shifts in each group
                result.forEach((k) => {
                    k.shifts.sort((a,b) => {
                        if(a.fromDate < b.fromDate) return -1;
                        if(a.fromDate > b.fromDate) return 1;
                        return 0;
                    });
                });

                // sort list by sport sorter priority
                result.sort((a,b) => {
                    if(a.spot.priority > b.spot.priority) return 1;
                    if(a.spot.priority < b.spot.priority) return -1;
                    return 0;
                });

                return result;
            },
            GetShiftsForSpotsByDate(date){
                let view = this;
                let result = [];
                Object.values(this.employeeMap).forEach((employee) => {
                    let shifts = this.GetShiftsByDateAndEmployee(employee.id, date);
                    if(shifts.length > 0){
                        shifts.forEach((s) => {
                            let spot = view.spotMap[s.spotId];
                            let add = true;
                            result.forEach((r) => {
                                if(r.spot.id == spot.id){
                                    add = false;
                                    r.shifts.push(s)
                                }
                            });
                            if(add){
                                result.push({
                                    shifts: [s],
                                    spot: spot
                                });
                            }
                        });
                    }
                });
                // sort shifts in each group
                result.forEach((k) => {
                    k.shifts.sort((a,b) => {
                        if(a.fromDate < b.fromDate) return -1;
                        if(a.fromDate > b.fromDate) return 1;
                        return 0;
                    });
                });

                // sort list by sport sorter priority
                result.sort((a,b) => {
                    if(a.spot.priority > b.spot.priority) return 1;
                    if(a.spot.priority < b.spot.priority) return -1;
                    return 0;
                });

                return result;
            },
            GetShiftsByDateAndEmployee(employeeId, date){
                return this.employeeDatePlannedShiftMap[employeeId] ? (this.employeeDatePlannedShiftMap[employeeId][date] ? this.employeeDatePlannedShiftMap[employeeId][date] : []) : [];
            },
            GetActualShiftsByDateAndEmployee(employeeId, date){
                return this.employeeDateActualShiftMap[employeeId] ? (this.employeeDateActualShiftMap[employeeId][date] ? this.employeeDateActualShiftMap[employeeId][date] : []) : [];
            },
            GetCombinedShiftsByDateAndEmployee(employeeId, date){
                return this.employeeDateCombinedShiftMap[employeeId] ? (this.employeeDateCombinedShiftMap[employeeId][date] ? this.employeeDateCombinedShiftMap[employeeId][date] : []) : [];
            },
            GetUnassignedShiftsByDate(date){
                return this.unassignedShiftsDateMap[date] ? this.unassignedShiftsDateMap[date] :  [];
            },
            GetPreferencesByDateAndEmployee(employeeId, date){
                return this.employeePreferenceAvailabilityMap[employeeId] ? (this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[date] ? this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[date].map(i => i.preference) : []) : [];
            },
            GetUnapprovedPreferencesByDateAndEmployee(employeeId, date){
                return this.employeeUnapprovedPreferenceAvailabilityMap[employeeId] ? (this.employeeUnapprovedPreferenceAvailabilityMap[employeeId].preferencesDate[date] ? this.employeeUnapprovedPreferenceAvailabilityMap[employeeId].preferencesDate[date].map(i => i.preference) : []) : [];
            },
            forceRefresh(){
                this.refresh(true);
            },
            refresh(force = false, switchReady = true, doUnpublishedShiftCheck = false) {
                let view = this;


                if (view.$store.state.jwt != undefined && view.$store.state.storeId != undefined && view.$store.state.rosterFromTo != null  && view.$store.state.rosterFromTo.from != null && view.$store.state.rosterFromTo.to != null && !view.loading) {
                    console.log("REFRESH "+this.$store.state.storeId)
                    let t0 = performance.now();
                    let tEwb = 0;
                    view.loading = true;
                    view.$store.commit("setAllowContentSwitch", {allowContentSwitch: false});
                    if(switchReady){
                        view.ready = false;
                    }
                    let storeId = this.$store.state.storeId;
                    let rosterFromTo = Object.assign({}, this.rosterFromTo);
                    //console.log("rosterFromTo Debug: "+JSON.stringify(rosterFromTo));
                    this.$helpers.GetExternalServicesMap().then(map=>{
                        return view.$helpers.GetExternalApiAccessMap(force);
                    }).then(map => {
                        return view.$helpers.GetEmployeeMissingExternalIdMap(force);
                    })

                    view.$helpers.GetActualShiftMax(force).then(response => {
                        view.mz_maxDate = response;
                    });

                    let employeePayload = {ids: []};
                    const requests = [
                      () => view.$helpers.GetStoreSettings(force),
                      () => view.$helpers.GetUiDataMap(force),
                      () => view.$helpers.GetUserUnitSort(force),
                      () => view.$helpers.GetSpotMap(force),
                      () => view.$helpers.GetSkillMap(force),
                      () => view.$helpers.GetAllowedContractMap(force),
                      () => view.$helpers.GetCollectiveContractMap(force),
                      () => view.$helpers.GetHolidayMap(force),
                      () => view.$helpers.GetBusinessUnitMap(force),
                      () => view.$helpers.GetEmployeeTypeMap(force),
                      () => view.$helpers.GetEmployeeRulesMap(force),
                      () => view.$helpers.GetEmployeeAvailabilityMap(force),
                      () => view.$helpers.GetEmployeePreferenceMap(force),
                      () => view.$helpers.GetActualShiftMap(force),
                      () => view.$helpers.GetActualBreakMap(force),
                      () => view.$helpers.GetProjectMap(force),
                      () => view.$helpers.GetLocationMap(force),
                      () => view.$helpers.GetExternalShiftMap(force),
                      () => view.$helpers.GetEmployeeExtraPaymentMap(force),
                      () => view.$helpers.GetYouthWorkConfigMap(force),
                      () => view.$helpers.GetShiftStatusLogMap(force),
                      () => view.$helpers.GetSotecWebcockpitConfig(force),
                      () => view.$helpers.GetMlCostCenterMap(force),
                      () => view.$helpers.GetPositioningTaskMap(force),
                      () => view.$helpers.GetPositioningEntryMap(force),
                      () => view.$helpers.GetPositioningTaskAssignmentMap(force),
                    ];
                    const makeRequests = (reqs, retryCount = 2) => Promise.allSettled(reqs.map(req => req()))
                        .then(results => {
                            //console.log(results);
                            let needsRetry = false;
                            const promises = results.map((result, i) => {
                                if (result.status === "rejected") {
                                    if (!needsRetry)
                                      needsRetry = true;
                                    return reqs[i];
                                }
                                return () => Promise.resolve(result);
                            });
                          if (needsRetry) {
                            if (retryCount > 0) {
                              return makeRequests(promises, retryCount - 1);
                            } else {
                              return Promise.reject(promises);
                            }
                          }
                          return promises;
                        });
                    makeRequests(requests).then(responses => {
                        view.forecastData = {};
                        view.rosterSortState.showSpotPlanningNumbersSwitch = false;
                        if(!view.dayMode && (view.rosterSortState.showShiftSpots)){
                            view.rosterSortState.filterByShiftSpot = false;
                            view.rosterSortState.showSpots = true;
                            view.rosterSortState.showBusinessUnits = false;

                        }
                        view.$store.commit('setRosterSortState', {rosterSortState: view.rosterSortState});

                        if(this.storeSettings && this.storeSettings.enableVlh && !this.storeSettings.enableMeo){
                            this.useVlhForForecast = true;
                        } else {
                            this.useVlhForForecast = false;
                        }


                        const employeeRequests = [

                            () => view.$helpers.GetActiveEmployeeMap(force, false, this.storeSettings.hideDeactivatedEmployees),
                            () => view.$helpers.GetCurrentMonthEmployeeContractMap(force, false, this.storeSettings.hideDeactivatedEmployees),

                        ];

                        return makeRequests(employeeRequests);
                    }).then(responses => {
                        view.updateSpots();
                        view.updateSoftSkills();
                        view.updateHolidays();
                        view.planningIndicator = {};

                        view.dayMode = false;
                        view.employeeGroups = [];
                        view.GetWeather();
                        let employeeRemoteIds = [];
                        for(let i in view.employeeMap){
                            let employee = view.employeeMap[i];
                            employeePayload.ids.push(employee.id);
                            if(employee.remoteId != null && employee.active){
                                employeeRemoteIds.push(employee.remoteId);
                            }

                        }
                        view.updateEmployees();
                        if(view.storeSettings.useAvgWorkTimeForPrefs){
                            const requests = [
                                () => view.$helpers.GetEmployeeSkillMapForEmployees(employeePayload, force),
                                () => view.$helpers.GetAvgEmployeeWorktimeMap(employeeRemoteIds, force),
                            ]
                            return makeRequests(requests);
                        } else {
                            return view.$helpers.GetEmployeeSkillMapForEmployees(employeePayload, force);
                        }

                    })
                    .then(response => {

                        view.updateEmployeeSkills();
                        return view.$helpers.GetPlanShiftMap(force)
                    }).then(map => {
                        let psCopy = Object.assign({}, map);
                        return view.$refs.planshiftcreation.doShiftLoadingAndCreationProcess(storeId, rosterFromTo, view.businessUnitMap, view.spotMap, view.skillMap, psCopy, view.employeePreferenceMap);
                    }).then(map => {
                        if(view.$store.state.storeId == storeId && view.rosterFromTo.year == rosterFromTo.year && view.rosterFromTo.month == rosterFromTo.month){
                            view.$store.commit('setPlanShiftMap', {
                                planShiftMap: map
                            });
                        }
                        let shiftPayload = {ids: []};
                        for (let i in view.planShiftMap) {
                            shiftPayload.ids.push(view.planShiftMap[i].id);
                        }

                        return view.$helpers.GetShiftSkillMap(shiftPayload,force)
                    }).then(response => {
                        tEwb = performance.now();
                        return view.RecalculatePreviousMonthWorkbalances(employeePayload.ids);
                    }).then(response => {

                        let seconds = (performance.now()-tEwb) / 1000.0;
                        console.log("EWB RECALC TOOK " + seconds + " seconds.");
                        console.log('loading previous month workbalances');
                        return view.$helpers.GetPreviousMonthEmployeeWorkbalanceMapForEmployees(employeePayload, force)
                    }).then(response => {

                        return view.loadStoreEvents(view.storeSettings.id, view.rosterFromTo)

                    }).then(response => {

                        view.storeEventMap = {};
                        view.storeEventMomentMap = {};
                        response.data.forEach(e => {
                            view.storeEventMap[e.id] = e;
                            let date = view.$helpers.getMomentFromStringTZ(e.from);
                            let dateKey = date.format('YYYY-MM-DD');
                            if(!view.storeEventMomentMap[dateKey]) view.storeEventMomentMap[dateKey] = [];
                            view.storeEventMomentMap[dateKey].push(e);
                        });
                        let eventPayload = {ids: []};
                        Object.values(view.storeEventMap).forEach(event => eventPayload.ids.push(event.id));
                        return view.loadShiftTemplatesPagedCompletely(eventPayload)
                    }).then(data => {
                        view.shiftTemplateMap = {};
                        data.forEach(s => {
                            view.shiftTemplateMap[s.id] = s;
                        });
                        return view.RefreshCurrentDayLiveIndicator()
                        .then(r => {
                            return view.RefreshPlanningIndicator()
                        });
                    }).then(response => {
                        view.selectedPlanningIndicator = Object.values(view.planningIndicatorTypeMap).find(p => p.isDefault == true);
                        view.updateShiftSkills();
                        view.updateSpots();
                        view.initializeDisplayedSpots();
                        view.sortEmployeeGroups();


                        view.loading = false;

                        view.RefreshVeryImportantData(); //moved under loading to prevent .loading return catch inside this function
                        view.setLiveDataTimer();

                        view.sortEmployeeGroups();

                        if(switchReady){
                            view.ready = true;
                        }
                        view.$store.commit("setAllowContentSwitch", {allowContentSwitch: true});
                        if(doUnpublishedShiftCheck){
                            view.DoUnpublishedShiftCheck();
                            view.DoEmployeeMissingExternalIdCheck();
                            view.DoEmployeeWorkbalanceCheck();
                        }
                        let t1 = performance.now();
                        let seconds = (t1-t0) / 1000.0;
                        console.log("REFRESH TOOK " + seconds + " seconds.");
                    }).catch(error => {
                        console.log(error)
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                        view.$store.commit("setAllowContentSwitch", {allowContentSwitch: true});
                    });
                }
            },
            GetMillisecondTotalObjectFromShifts(shifts, timeBorderMoment){
                if(!shifts) return 0;
                let view = this;
                let total = 0;
                let totalOutOfRange = 0;
                let totalBreak = 0;
                shifts.forEach(s => {
                    let shiftMoment = null;
                    if(view.planShiftMomentMap[s.id]){
                        //its a planned shift
                        shiftMoment = view.planShiftMomentMap[s.id];
                        let from = shiftMoment.fromDate;
                        let to = shiftMoment.toDate;
                        let timeAggregation = view.$helpers.GetMillisecondTotalObjectFromMoments(from, to, timeBorderMoment);
                        if (s.breakValue && s.breakValue > 0){
                            let breakFrom = null;
                            if(s.breakFrom != null){
                                breakFrom = this.$helpers.getMomentFromStringTZ(s.breakFrom);
                                let breakTo = breakFrom.clone().add(s.breakValue, 'minutes');
                                let check = this.$helpers.GetFromToCheckObject(breakFrom, breakTo, from, to);
                                if(check.isNonZeroDiff){
                                    let breakTimeAggregation = view.$helpers.GetMillisecondTotalObjectFromMoments(breakFrom, breakTo, timeBorderMoment);
                                    totalBreak += Math.max(0, breakTimeAggregation.total);
                                    totalOutOfRange -= Math.max(0, breakTimeAggregation.totalOutOfRange);

                                }
                            } else {
                                let tor = timeAggregation.totalOutOfRange > 0 ? timeAggregation.totalOutOfRange : 0
                                let bv = s.breakValue *60*1000;
                                let total = bv * (timeAggregation.total/(timeAggregation.total + tor));
                                let totalOutOfRange = bv * (tor/(timeAggregation.total + tor));
                                totalBreak += total;
                                totalOutOfRange -= totalOutOfRange;
                            }


                        }
                        total += timeAggregation.total;
                        totalOutOfRange += timeAggregation.totalOutOfRange;


                    } else if (view.actualShiftMomentMap[s.id]){
                        //its an actual shift
                        shiftMoment = view.actualShiftMomentMap[s.id];
                        let from = shiftMoment.fromDate;
                        let to = shiftMoment.toDate;
                        let timeAggregated = view.$helpers.GetMillisecondTotalObjectFromMoments(from, to, timeBorderMoment);
                        total += timeAggregated.total;
                        totalOutOfRange += timeAggregated.totalOutOfRange;
                        if (view.actualBreakShiftIdMap[s.id] && view.actualBreakShiftIdMap[s.id].length > 0){
                            let breaks = view.actualBreakShiftIdMap[s.id];
                            breaks.forEach(b => {
                                let breakMoment = view.actualBreakMomentMap[b.id];
                                let breakFrom = breakMoment.fromDate;
                                let breakTo = breakMoment.toDate;
                                let check = view.$helpers.GetFromToCheckObject(breakFrom, breakTo, from, to);
                                if(check.isNonZeroDiff){
                                    let breakTimeAggregation = view.$helpers.GetMillisecondTotalObjectFromMoments(check.from, check.to, timeBorderMoment);
                                    totalBreak += breakTimeAggregation.total;
                                    totalOutOfRange -= breakTimeAggregation.totalOutOfRange;
                                }

                            });

                        }
                    }

                });
                return {total: total, totalOutOfRange: totalOutOfRange, totalBreak: totalBreak};
            },


            GetSummedShiftHours(dateFormat){
                if(!this.shiftTimeByDayMap[dateFormat]) return '--.--h';
                //let totalHours = this.shiftTimeByDayMap[dateFormat].total + this.shiftTimeByDayMap[dateFormat].totalPreviousDay;
                let totalHours = 0;
                if(this.actualShiftDateMap[dateFormat] && this.actualShiftDateMap[dateFormat].length > 0){
                    totalHours += this.shiftTimeByDayMap[dateFormat].totalActual + this.shiftTimeByDayMap[dateFormat].totalActualPreviousDay;
                } else {
                   totalHours = this.shiftTimeByDayMap[dateFormat].totalAssigned + this.shiftTimeByDayMap[dateFormat].totalAssignedPreviousDay;
                }
                let hours = this.$helpers.GetHourMinuteFormatFromMilliseconds(totalHours, true);
                return hours;
            },
            GetSummedShiftHoursForHour(dayModeDate, hourIndex){
                let dateFormat = dayModeDate.format('YYYY-MM-DD');
                let key = dayModeDate.clone().add(hourIndex-1, 'hours').format('YYYY-MM-DD HH');
                if(!this.shiftTimeByHourMap[key]) return '--.--h';
                let totalHours = 0;


                if(this.actualShiftDateMap[dateFormat] && this.actualShiftDateMap[dateFormat].length > 0){
                    totalHours = this.shiftTimeByHourMap[key].totalActual;
                } else {
                    totalHours = this.shiftTimeByHourMap[key].totalAssigned;
                }
                let hours = this.$helpers.GetHourMinuteFormatFromMilliseconds(totalHours, true);
                return hours;
            },
            GetProductivityForDate(dateStr, m = null){
                let mapEntry = this.shiftTimeByDayMap[dateStr];
                if(mapEntry){
                    let workTimeMS = 0;
                    let mode = m;

                    if(mode == null && mapEntry.productiveActual > 0){
                        mode = 2;
                    } else if(mode == null) {
                        mode = 1;
                    }
                    if(mode == 1){
                        workTimeMS = mapEntry.productiveAssigned + mapEntry.productiveAssignedPreviousDay;
                    } else if(mode == 2){
                        workTimeMS = mapEntry.productiveActual + mapEntry.productiveActualPreviousDay
                    }
                    if(!this.rosterVisibilityState.visibilityProductivityIncludeMgmt){
                        if(mode == 1){
                            workTimeMS = mapEntry.productiveAssignedCrewOnly + mapEntry.productiveAssignedPreviousDayCrewOnly;
                        } else if(mode == 2){
                            workTimeMS = mapEntry.productiveActualCrewOnly + mapEntry.productiveActualPreviousDayCrewOnly;
                        }
                    }
                    let workTime = (workTimeMS) / 1000 / 60 / 60;


                    let prods = this.productivitiesDaily[dateStr];
                    let fractional = this.displayIndicatorType ? (this.planningIndicatorTypeMap[this.displayIndicatorType] ? this.planningIndicatorTypeMap[this.displayIndicatorType].fractional :7 ): 7
                    let divisor = Math.pow(10, fractional);

                    if(prods){
                        let amount = 0;
                        switch(mode){
                            case 1: // planned
                            amount = prods.amountPlanned / divisor;
                            break;
                            case 2: // actual
                            amount = prods.amountActual / divisor;
                            break;
                        }
                        if(workTime > 0){
                            return (amount / workTime).toFixed(2);
                        } else {
                            return 'n/a'
                        }

                    }
                }

                return '';
            },
            GetProductivityStyleForDate(dateStr){
                let styles = {color: 'var(--col-label-default'};

                let prods = this.productivitiesDaily[dateStr];
                if(prods){
                    if(prods.actual){
                        let planned = parseFloat(this.GetProductivityForDate(dateStr, 1));
                        let actual = parseFloat(this.GetProductivityForDate(dateStr, 2));


                        let col = 'var(--col-red-text)';
                        if(actual > planned) col = 'var(--md)';

                        styles.color = col;
                    }

                }
                return styles;
            },





        updateSoftSkills(){
            let view = this;
            this.softSkills = Object.values(view.skillMap).filter(skill => (Object.values(view.spotMap).find(spot => spot.requiredSkill === skill.id) === undefined));
            for (let i = 0; i < this.softSkills.length; i++) {
                this.softSkills[i].toggled = false;
            }
        },

        updateEmployees(){
            let customMap = {};
            let customArray = [];
            for(let i in this.employeeMap){
                let employee = this.employeeMap[i];
                customMap[employee.id] = employee;
                if(employee.active || (Object.values(this.currentMonthEmployeeContractMap).find(c => c.employeeId == employee.id) != null)){
                    employee.shiftsDate = {};
                    employee.picture = this.GetProfilePictureUrl(employee);
                    employee.pictureNoBackground = this.GetProfilePictureUrlNoBackground(employee);
                    customArray.push(employee);
                }


            }
            this.customEmployeeMap = customMap;

            this.employees = customArray;
            this.employees.sort((a, b) => this.sortEmployee(a,b,false));
            
            this.employeesFiltered = this.employees.slice();
        },

        OpenEmployeeDetails($event, employee){

            let employeeDetailState = {employeeId: employee.id, event: $event};
            this.$refs.employeedetailpopup.Init(employeeDetailState);

        },
        showShiftCreationWithTemplate(){
            VueEventBus.$emit('open-shiftcreationwithtemplate', {});
        },
        showShiftCreationWithCSV(){
            VueEventBus.$emit('open-shiftcreationwithcsv', {});
        },
        setDateSelection(date, calculateRosterFromTo){
                let fixedDate = this.$helpers.getMomentTZ().year(date.year()).month(date.month()).date(date.date()).startOf('day');
                this.dateSelectionStart = fixedDate;


                console.log("DS: "+this.dateSelectionStart.format());
                if(calculateRosterFromTo){
                    //update vuex store with calculated from to => triggers reload of data via refresh
                    // We need the last 2 months for the SOLL-IST Comparison, or a sophisticated check if the Monatsabschluss exists
                    let rosterFromTo = this.$helpers.CalculateRosterFromTo(date);
                    //console.log("ROSTER SET DATE SELECTION "+JSON.stringify(rosterFromTo));
                    this.$store.commit('setRosterFromTo', {rosterFromTo: rosterFromTo});
                } else {
                    //dont update vuex from to, only update client side view

                }

        },
        onDatePicked(date){
            this.setDateSelection(date, true);
        },
            toggleDatePicker($event) {
                let view = this;
                this.$helpers.OpenDatepickerPopup(
                    {viewsEnabled: ['M', 'D'], selectedTab: this.dayMode ? 'D' : 'M', date: this.dayMode ? this.dayModeDate : this.dateSelectionStart, hourlyEnabled: true, hourlySelection: [12, 24, 36], hourlySelected: view.dayModeHours != null ? view.dayModeHours: 24},
                    {
                        OnDateSelect: (date) => {
                            if(date.year() != this.rosterFromTo.year || date.month() != this.rosterFromTo.month){
                                console.log("DATE PICKED: "+date.startOf('month').format())
                                view.onDatePicked(date.startOf('month'));
                            }
                        },
                        OnMonthSelect: (date) => {
                            view.dayMode = false;
                        },
                        OnDaySelect: (date, hours) => {
                            if(!(date.year() != this.rosterFromTo.year || date.month() != this.rosterFromTo.month)){
                                view.ToggleDayModeWithDate(date, true);
                                view.dayModeHours = hours;
                                view.ChangeTimeBarLength();
                            }


                        }
                    }, {elRelative: $event.currentTarget});
            },
            onPreviewAutoRosterResult: function(shifts){
                this.replaceShifts(shifts, true);

            },
            onApplyAutoRosterResult(){
                this.refresh(true, false);
            },
            GetDailyIndicatorBarWidth(date){
                let format = date.format('YYYY-MM-DD');
                if(!this.planningIndicator[format] || !this.planningIndicator[format].planned || !this.planningIndicator[format].actual) return 'calc(0% - 10px)';
                let length = (this.planningIndicator[format].actual.sumAmount / this.planningIndicator[format].planned.sumAmount) * 100;
                if(length > 100) length = 100;
                let ratio = (this.planningIndicator[format].actual.sumAmount / this.planningIndicator[format].planned.sumAmount);
                let margin = 10 * ratio;
                return 'calc(' + length + '% - ' + margin + 'px)';


            },
            HideQuarterlyHover(){
                $(this.$el).find('.hour-grid.labels .amount').css('opacity', 0);
            },
            PositionQuarterlyHover($event){
                let target = $event.currentTarget;
                let box = target.getBoundingClientRect();
                $(this.$el).find('.hour-grid.labels .amount').css('opacity', 1);
                $(this.$el).find('.hour-grid.labels .amount').css('top', (box.bottom + 5) + 'px');
                $(this.$el).find('.hour-grid.labels .amount').css('left', (box.left + (box.width * .5)) + 'px');
                $(this.$el).find('.hour-grid.labels .amount').text($(target).attr('amount'));

            },
            GetIndicatorAmountWrapper(date){
                let view = this;
                return () => {
                    let defaultIndicatorAmount = view.anonMode ? '-/-' : view.GetIndicatorAmount(date);
                    let allIndicatorAmounts = view.anonMode ? '-/-' : view.GetAllNonDefaultIndicatorAmounts(date);
                    let amounts = defaultIndicatorAmount + allIndicatorAmounts;
                    let thStyle = 'style="background-color: var(--contrast-4); color: var(--bg); padding: 4px; font-weight: 800 !important; border-right: solid 1px var(--contrast-4); border-left: solid 1px var(--contrast-4);"';
                    return '<table style="margin-top: 20px; margin-bottom: 20px;"><th ' + thStyle + '>' + this.$t('roster.view.keyFigure') + '</th><th ' + thStyle + '>' + this.$t('roster.view.plan') + '</th><th ' + thStyle + '>' + this.$t('workBalance.summary.actual') + '</th>' + amounts + '</table>';
                };
            },
            GetIndicatorAmount(date){
                let format = date.format('YYYY-MM-DD');
                let indicator = this.planningIndicator[format];
                let amount = '';
                if(indicator){
                    let fractional = .01;
                    if(indicator.actual) fractional = this.planningIndicatorTypeMap[indicator.actual.typeId].fractional;
                    else if(indicator.planned) fractional = this.planningIndicatorTypeMap[indicator.planned.typeId].fractional;
                    let planned = '';
                    let actual = '';
                    if(indicator.planned){
                        planned = (indicator.planned.sumAmount/Math.pow(10, fractional)).toFixed(2);
                    }
                    if(indicator.actual){
                        actual = (indicator.actual.sumAmount/Math.pow(10, fractional)).toFixed(2);
                    }
                    let name = this.planningIndicatorTypeMap[this.displayIndicatorType].name;
                    amount = this.IndicatorValueStringFormatted(planned, actual, name, true, 'var(--md)', 'white');
                }else{
                    amount = this.IndicatorValueStringFormatted('', '', this.planningIndicatorTypeMap[this.displayIndicatorType].name, true, 'var(--md)', 'white');
                }
                return amount;
            },
            GetAllNonDefaultIndicatorAmounts(date){
                let view = this;
                let format = date.format('YYYY-MM-DD');
                let amounts = '';
                let typeIds = Object.keys(view.planningIndicatorTypeMap);
                let ind = 0;
                for(let typeId of typeIds){
                    if(typeId == this.displayIndicatorType) continue;
                    if(view.allPlanningIndicators[typeId]){
                        let indicatorMap = view.allPlanningIndicators[typeId];
                        let planned = '';
                        let actual = '';
                        if(indicatorMap.plannedDayMap[format]){
                            let fractional = .01;
                            if(indicatorMap.indicatorType) fractional = indicatorMap.indicatorType.fractional;
                            planned = (indicatorMap.plannedDayMap[format]/Math.pow(10, fractional)).toFixed(2);
                        }
                        if(indicatorMap.actualDayMap[format]){
                            let fractional = .01;
                            if(indicatorMap.indicatorType) fractional = indicatorMap.indicatorType.fractional;
                            actual = (indicatorMap.actualDayMap[format]/Math.pow(10, fractional)).toFixed(2);
                        }
                        let name = indicatorMap.indicatorType ? indicatorMap.indicatorType.name : '';
                        let curAmount = view.IndicatorValueStringFormatted(planned, actual, name, false, ind % 2? 'var(--bg)' : 'var(--contrast-1)', 'var(--contrast-4)', typeId == typeIds[typeIds.length-1]);
                        amounts += curAmount;
                    }else{
                        let name = view.planningIndicatorTypeMap[typeId].name;
                        let curAmount = view.IndicatorValueStringFormatted('', '', name, false, ind % 2? 'var(--bg)' : 'var(--contrast-1)', 'var(--contrast-4)', typeId == typeIds[typeIds.length-1]);
                        amounts += curAmount;
                    }

                    ind++;



                }
               return amounts;
            },
            formatKeyFigure(val){
                let res = val;
                if(val != null){
                    if(val > 1000){
                        res = (val/1000).toFixed(2) + 'k';
                    } else if (val > 1000000){
                        res = (val/1000000).toFixed(2) + 'm';
                    } else if (Number.isInteger(val)){
                        res = val.toFixed(0);
                    } else {
                        res = val.toFixed(2);
                    }
                }
                return res;
            },
            getKeyFigures(date) {
                let view = this;
                let format = date.format('YYYY-MM-DD');
                let keyFigures = [];
                let indicator = this.planningIndicator[format];
                let keyFigureName = '';
                let priority = 100;
                if (this.planningIndicatorTypeMap[this.displayIndicatorType]) {
                    keyFigureName = this.planningIndicatorTypeMap[this.displayIndicatorType].name;
                    priority = this.planningIndicatorTypeMap[this.displayIndicatorType].priority;
                }
                if (indicator) {
                    let fractional = indicator.actual ?
                        this.planningIndicatorTypeMap[indicator.actual.typeId].fractional : indicator.planned ?
                            this.planningIndicatorTypeMap[indicator.planned.typeId].fractional : .01;

                    let pValue = indicator.planned ? view.formatKeyFigure(indicator.planned.sumAmount / Math.pow(10, fractional)) : null;
                    let aValue = indicator.actual ? view.formatKeyFigure(indicator.actual.sumAmount / Math.pow(10, fractional)) : null;

                    keyFigures.push({
                        planned: pValue,
                        actual: aValue,
                        name: keyFigureName,
                        priority: priority
                    });
                } else {
                    keyFigures.push({ planned: null, actual: null, name: keyFigureName, priority: priority });
                }

                let typeIds = Object.keys(view.planningIndicatorTypeMap);
                let ind = 0;
                for (let typeId of typeIds) {
                    if (typeId == this.displayIndicatorType) continue;
                    if (view.allPlanningIndicators[typeId]) {
                        let indicatorMap = view.allPlanningIndicators[typeId];
                        let fractional = indicatorMap.indicatorType ? indicatorMap.indicatorType.fractional : .01;

                        let pValue = indicatorMap.plannedDayMap[format] ? view.formatKeyFigure(indicatorMap.plannedDayMap[format] / Math.pow(10, fractional)) : null;
                        let aValue = indicatorMap.actualDayMap[format] ? view.formatKeyFigure(indicatorMap.actualDayMap[format] / Math.pow(10, fractional)) : null;

                        keyFigures.push({
                            planned: pValue,
                            actual: aValue,
                            name: indicatorMap.indicatorType ? indicatorMap.indicatorType.name : '',
                            priority: indicatorMap.indicatorType ? indicatorMap.indicatorType.priority : 100,
                        });
                    } else {
                        keyFigures.push({ planned: null, actual: null, name: view.planningIndicatorTypeMap[typeId].name, priority: view.planningIndicatorTypeMap[typeId].priority });
                    }
                    ind++;
                }
                return keyFigures.sort((a, b) => {
                    let diff = a.priority - b.priority;
                    if(diff != 0){
                        return diff;
                    }  else {
                        return a.name.localeCompare(b.name);
                    }
                });
            },
            IndicatorValueStringFormatted(planned, actual, name, isDefault, backgroundColor, textColor, showBottomBorder = false){
                let plannedFormatted = '';
                let actualFormatted = '';
                let fontWeight = isDefault? '800 !important' : '400 !important';
                if(planned){
                    plannedFormatted = planned;
                }
                if(actual){
                    actualFormatted = actual;
                }
               let bottomBorder = showBottomBorder ? 'solid 1px var(--contrast-4);' : 'none';
               let tdStyle = 'style="min-width: 80px; padding: 4px; font-weight: ' + fontWeight + '; color: ' + textColor + ' !important; border-right: solid 1px var(--contrast-4); border-left: solid 1px var(--contrast-4); border-bottom: ' + bottomBorder + ';"';
               return '<tr style="background-color: ' + backgroundColor + ' !important"><td ' + tdStyle + '>' + name + '</td><td ' + tdStyle + '>' + plannedFormatted + '</td><td ' + tdStyle + '>' + actualFormatted + '</td></tr>';
            },
            GetQuarterlyIndicator(date){

                if(this.planningIndicatorDaily.find(s => s.typeId == this.displayIndicatorType && !s.planned && s.dateMoment.unix() === date.unix())) return 'green';
                return 'gray';
            },
            GetQuarterlyIndicatorAmount(date){
                let indicators =  this.planningIndicatorDaily.filter(s => s.typeId == this.displayIndicatorType && !s.planned && s.dateMoment.unix() === date.unix());
                let fractional = this.planningIndicatorTypeMap[this.displayIndicatorType] ? this.planningIndicatorTypeMap[this.displayIndicatorType].fractional : 0.01;
                if(indicators.length > 0) {
                    let total = 0;
                    indicators.forEach(s => total += s.amount);
                    total = total/Math.pow(10, fractional);
                    total+= ' '+this.planningIndicatorTypeMap[this.displayIndicatorType].name;
                    return  total;
                }
                return '0';
            },

            GetWeatherSliderOffset(){
                return $('.entry.header .day[date=' + this.$helpers.getMomentTZ().format('MM-DD') + ']')[0] ? $('.entry.header .day[date=' + this.$helpers.getMomentTZ().format('MM-DD') + ']')[0].getBoundingClientRect().left + 'px' : '1000 px';

            },
            SetDayViewDayOffset($event){
               /*$('.day-mode .grid .entry.header .day').css('margin-left', (1 * ($('.app .scrollbar-container .grid').scrollLeft() - 0) * 0.5) + 'px');
               $('.day-mode .grid .entry.header .day').css('margin-top', (1 * ($('.app .scrollbar-container .grid').scrollTop() - 0) * .5) + 'px');*/
            },
            SetWeatherSliderOffset($event){

               $('.weather-slider').css('margin-left', (-1 * ($('.app .scrollbar-container .grid').scrollLeft() - 0)) + 'px');
               $('.weather-slider').css('margin-top', (-1 * ($('.app .scrollbar-container .grid').scrollTop() - 0)) + 'px');
            },


            RecalculatePreviousMonthWorkbalances(employeeIds) {
                let prevM = this.previousMonthUTC.month();
                let prevY = this.previousMonthUTC.year();

                return this.$refs.employeeworkbalancecreation.doMonthYearRecalculation(prevM, prevY, employeeIds);
                //return this.$refs.employeeworkbalancecreation.recalculatePastInvalid(this.previousMonthUTC.clone(), employeeIds);
            },
            CheckIgnoreLaw(){
                if(this.isSuperUser){
                    return false; //super users can disable check anyway but have all permissions loaded so we do as if they dont have the perm
                }
                let res = false;
                Object.values(this.permissions).forEach(perms => {
                    if(perms.map(perm => perm.id).includes(69)) { //permission to ignore law
                        res = true;
                    }
                })

                return res;
            },

            PublishSelectedShifts(showNotificationModal = true){
                let view = this;
                if(!view.allowFutureAssignment){
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.shiftPlanningDeactivated'));
                    return;
                }
                if(!this.selectedPublishableShifts || this.selectedPublishableShifts.length === 0) return;

                let ids = [];
                let affectedEmployees = new Set();
                let shifts = [];
                this.selectedPublishableShifts.filter(s => !s.locked).forEach((s) => {
                    ids.push(s.id)
                    affectedEmployees.add(s.employeeId);
                    shifts.push(s);
                });

                if(this.storeSettings.strictlyLawAbiding && !this.CheckLegallyPublishable(ids) && !this.CheckIgnoreLaw()){
                    window.app.popupalerts.push(
                    {
                        header: this.$t('roster.view.lawViolated'),
                        description: this.$t('roster.view.lawViolatedWarn'),
                        hidden: false,
                        callbackAccept: function(popup){
                            popup.hidden = true;
                        }
                    });
                    return;
                } else if(this.storeSettings.regularWorkTimeLimit > -1){
                    let employeesWithTooMuchWorktime = [];
                    affectedEmployees.forEach(employeeId => {
                        if(this.employeePlannedActual[employeeId]){
                            let workTimeRegular = view.employeePlannedActual[employeeId].unmodifiedPlannedWorkTime;
                            let maxOvertime = workTimeRegular * (view.storeSettings.regularWorkTimeLimit /100);

                            let delta = (view.employeePlannedActual[employeeId].sumWorkTimeUnproduktiv + view.employeePlannedActual[employeeId].sumWorkTimeProduktiv)
                                    - (view.employeePlannedActual[employeeId].unmodifiedPlannedWorkTime - view.employeePlannedActual[employeeId].unmodifiedDeltaWorkTime);

                            if(delta > maxOvertime){
                                employeesWithTooMuchWorktime.push(employeeId);
                            }
                        }


                    })
                    if(employeesWithTooMuchWorktime.length > 0){
                        let description  = "";

                        description += this.$t('roster.view.violationEmp1', [this.storeSettings.regularWorkTimeLimit]);
                        description += "<ul >";
                        employeesWithTooMuchWorktime.forEach(employeeId => {
                            description +="<li><b>"+view.employeeMap[employeeId].lastName+"</b> "+view.employeeMap[employeeId].firstName+"</li>";
                        })
                        description += "</ul>";


                        let dataEntries = [];


                        view.$helpers.OpenPopup({
                            type: 'datafill',
                            componentState: {
                                entries: dataEntries,
                                description: description,
                                positiveButtonLabel: this.$t('global.ui.approve'),
                                selectCallback: function (data) {


                                },

                            },
                            header: this.$t('global.ui.warning') + this.$t('roster.view.tooPlusHours'),
                            expanded: true,
                            width: "700px",
                            centered: true
                        });

                        return;
                    }
                }


                let url = '/api/sec/planshift/publish/multi';

                let params = {
                    storeId: view.$store.state.storeId
                }

                let payload = {
                    storeId: view.$store.state.storeId,
                    ids: ids,
                };
                 view.axios({
                     method: 'put',
                     params: params,
                     headers: {
                         'AUTHORIZATION': "bearer "+view.$store.state.jwt
                     },
                     url: url,
                     data: payload
                 }).then(response => {
                    view.shiftsSelected = [];

                    let payload = [];
                    let publishDate = view.$helpers.getMomentTZ().format();
                    Object.values(view.planShiftMap).filter(s => response.data.data.find(r => r === s.id)).forEach(s => {s.published = true; s.publishDate = publishDate; let x = {mapName : 'planShiftMap', entity: s }; payload.push(x) });
                    view.$store.commit("updateMultiple",payload);

                    Object.values(view.planShiftMap).filter(s => response.data.data.find(r => r === s.id)).forEach(s => view.$set(view.customPlanShiftMap[s.id], 'published', true));
                    let publishedShiftsForMZ = [];
                    view.planshifts.filter(s => response.data.data.find(r => r === s.id)).forEach(s => {
                        s.published = true;
                        s.publishDate = publishDate;
                        publishedShiftsForMZ.push(s.id);
                    });
                    view.$forceUpdate();
                    view.$helpers.success(view.$t('global.notifications.success'), view.$t('roster.view.shiftsPublished'));
                    if(showNotificationModal){
                        view.showShiftsNotificationModal(shifts);
                    }

                    view.DoEmployeeMissingExternalIdCheck();

                    view.PublishToMP(false);
                 }).catch(function (error) {
                    view.shiftsSelected = [];
                    if(error.response.data != null && error.response.data.data != null && error.response.data.data.cause == 'Server is currently in maintenance Mode!'){
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.maintenanceError'));
                    } else {
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.publicationFailed'));
                    }
                 });
            },
            UnpublishSelectedShifts(showNotificationModal = true){
                let view = this;
                if(!this.selectedUnpublishableShifts || this.selectedUnpublishableShifts.length === 0) return;
                 let url = '/api/sec/planshift/unpublish/multi';

                let params = {
                    storeId: view.$store.state.storeId,
                }
                 let ids = [];
                 let shifts = [];
                 this.selectedUnpublishableShifts.filter(s => !s.locked).forEach(s => {
                    ids.push(s.id);
                    shifts.push(s);
                 });
                 let payload = {
                   storeId: view.$store.state.storeId,
                   ids: ids,
                 }
                 view.axios({
                     method: 'put',
                     params: params,
                     headers: {
                         'AUTHORIZATION': "bearer "+view.$store.state.jwt
                     },
                     url: url,
                     data: payload
                 }).then(response => {
                    view.shiftsSelected = [];

                    let payload = [];
                    let unpublishedShiftsForMZ = [];
                    Object.values(view.planShiftMap).filter(s => response.data.data.find(r => r === s.id)).forEach(s => {
                        s.published = false;
                        s.status = null;
                        unpublishedShiftsForMZ.push(s.id);
                        if(!s.pinned){
                            if(s.historicFrom != null && !s.pinned){
                                s.from = s.historicFrom;
                            }
                            if(s.historicTo != null && !s.pinned){
                                s.to = s.historicTo;
                            }
                            if(s.templateId != null && !s.pinned){
                                s.breakFrom = s.historicBreakFrom
                            }
                            if(s.historicBreakValue != null && !s.pinned){
                                s.breakValue = s.historicBreakValue
                            }

                        }


                        let x = {mapName : 'planShiftMap', entity: s };
                        payload.push(x)
                    });
                    view.$store.commit("updateMultiple",payload);

                    Object.values(view.planShiftMap).filter(s => response.data.data.find(r => r === s.id)).forEach(s => {
                        view.$set(view.customPlanShiftMap[s.id], 'published', false);
                        view.$set(view.customPlanShiftMap[s.id], 'status', null);
                        if(!s.pinned){
                            if(view.customPlanShiftMap[s.id].historicFrom != null){
                                view.$set(view.customPlanShiftMap[s.id], 'from', view.customPlanShiftMap[s.id].historicFrom);
                            }
                            if(view.customPlanShiftMap[s.id].historicTo != null){
                                view.$set(view.customPlanShiftMap[s.id], 'to', view.customPlanShiftMap[s.id].historicTo);
                            }
                            if(view.customPlanShiftMap[s.id].templateId != null){
                                view.$set(view.customPlanShiftMap[s.id], 'breakFrom', view.customPlanShiftMap[s.id].historicBreakFrom);
                            }
                            if(view.customPlanShiftMap[s.id].historicBreakValue != null){
                                view.$set(view.customPlanShiftMap[s.id], 'breakValue', view.customPlanShiftMap[s.id].historicBreakValue);
                            }
                            if(view.customPlanShiftMap[s.id].historicWorkValue != null){
                                view.$set(view.customPlanShiftMap[s.id], 'workValue', view.customPlanShiftMap[s.id].historicWorkValue);
                            }
                        }


                    });
                    view.planshifts.filter(s => response.data.data.find(r => r === s.id)).forEach(s => {
                        s.published = false;
                        s.status = null;
                        if(!s.pinned){
                            if(s.historicFrom != null){
                                s.from = s.historicFrom;
                            }
                            if(s.historicTo != null){
                                s.to = s.historicTo;
                            }
                            if(s.templateId != null){
                                s.breakFrom = s.historicBreakFrom
                            }
                            if(s.historicBreakValue != null){
                                s.breakValue = s.historicBreakValue
                            }
                            if(s.historicWorkValue != null){
                                s.workValue = s.historicWorkValue
                            }
                        }

                    });

                    Object.values(view.shiftStatusLogMap).filter(log => response.data.data.find(r => r === log.shiftId)).forEach(log => {
                      delete view.shiftStatusLogMap[log.id];
                    });
                    this.$store.commit("setShiftStatusLogMap", {shiftStatusLogMap: view.shiftStatusLogMap});

                    view.$forceUpdate();
                    view.$helpers.success(view.$t('global.notifications.success'), view.$t('roster.view.unpublished'));
                    if(showNotificationModal){
                        view.showShiftsNotificationModal(shifts);
                    }

                    view.PublishToMP(false);

                 }).catch(function (error) {
                    view.shiftsSelected = [];
                    if(error.response.data != null && error.response.data.data != null && error.response.data.data.cause == 'Server is currently in maintenance Mode!'){
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.maintenanceError'));
                    } else {
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.revokePublicationError'));
                    }
                 });
            },

            OpenRequestWizard(){
                this.$helpers.OpenPopup({
                    components: [{type: 'rosterrequestwizard'}],
                    expanded: true,
                    centered: true,
                    locked: (dropdowncontainer) => {
                        let requestwizardview = dropdowncontainer.$children[0];
                        if(requestwizardview)
                            return (requestwizardview.state == 0 && !requestwizardview.error);
                        return false;
                    },
                });
            },
            OpenMenuDetails($event, state){
                let view = this;

                this.$helpers.OpenPopup({
                    type: 'burgermenu',
                    componentState: state,
                    listStyle: true,
                    noScroll: true,
                    pointerDirection: 0,
                    elRelative: $event.currentTarget,
                    pointerOffset: -15,
                });
            },
            DoEmployeeMissingExternalIdCheck() {
                let view = this;
                let config = this.notificationBellConfigState;
                if(config.showMissingExternalIds && Object.values(view.employeeMissingExternalIdMap).length > 0 && Object.values(view.externalApiAccessMap).length > 0){
                    let externalServices = Object.values(view.externalServicesMap)
                                          .filter(service =>
                                                    Object.values(view.externalApiAccessMap)
                                                    .filter(apiAccess => apiAccess.externalServiceId == service.id).length > 0 && service.useExternalEmployeeIds
                                            ).map(service => service.name);
                    let description  = "";

                    description += "<p>" + this.$t('roster.view.externalIdsMissing') + "</p>"
                    description += "<p>" + this.$t('roster.view.externalIdsMissingHelp') + "</p>"
                    description += "<p>" + this.$t('roster.view.activeExternalServices') + ":</p>"
                    description += "<ul >";
                    externalServices.forEach(service => {
                        description +="<li><b>"+service+"</b></li>";
                    })
                    description += "</ul>";
                    description += "<p>" + this.$t('roster.view.affectedEmployees') + ":</p>"
                    description += "<ul "+(Object.values(view.employeeMissingExternalIdMap).length > 6 ? "style='height: 10em; overflow: scroll; overflow-x: hidden'>" : ">");
                    Object.values(view.employeeMissingExternalIdMap).forEach(employee => {
                        description +="<li><b>"+employee.lastName + "</b> "+employee.firstName +"</li>";
                    })
                    description += "</ul>";

                    let dataEntries = [];
                    dataEntries.push({label: this.$t('roster.view.dontShowOnThisDevice'), key: 'ignoreWarning', hidden: false, type: 'bool', value: false});


                    view.$helpers.OpenPopup({
                        type: 'datafill',
                        componentState: {
                            entries: dataEntries,
                            description: description,
                            positiveButtonLabel: this.$t('global.ui.approve'),
                            selectCallback: function (data) {
                                if(data.ignoreWarning){
                                    view.$store.commit('setNotificationBellConfigStateValue', {key: 'showMissingExternalIds', value: false});
                                }

                            },

                        },
                        header: this.$t('global.ui.warning') + this.$t('roster.view.employeeIdsMissing'),
                        expanded: true,
                        width: "700px",
                        centered: true
                    });
                }
            },
            DoUnpublishedShiftCheck(){
                let view = this;
                let config = this.notificationBellConfigState;
                if(config.showUnpublishedShifts){
                    let today = this.$helpers.getMomentTZ().startOf('day');
                    let limit = today.clone().add(8, 'days');

                    let resultMap = {};
                    Object.values(this.planShiftMap).forEach(shift => {
                        let date = view.planShiftMomentMap[shift.id] ? view.planShiftMomentMap[shift.id].fromDate : view.$helpers.getMomentFromStringTZ(shift.from);
                        if(!shift.published && shift.employeeId != null
                            && view.employeeMap[shift.employeeId]
                            && !view.employeeMap[shift.employeeId].dummy

                            && date >= today && date < limit){

                                let day = date.clone().startOf('day');
                                let key = day.format("DD.MM.YYYY");
                                if(!resultMap[key]){
                                    resultMap[key] = {day: day, value: 0};
                                }
                                resultMap[key].value += 1;
                        }
                    });

                    if(Object.values(resultMap).length > 0){
                        let description = "<b style='color: red'>" + this.$t('roster.view.sevenDaysWarning');
                        Object.values(resultMap).sort((a, b) => {return a.day - b.day}).forEach(entry => {
                            description +="<li><b>"+entry.day.format("DD.MM.YYYY")+":</b> " + entry.value + " " + this.$tc('roster.view.shifts', entry.value)
                        })


                        description+="</ul>"
                        let dataEntries = [];
                        dataEntries.push({label: this.$t('roster.view.dontShowOnThisDevice'), key: 'ignoreWarning', hidden: false, type: 'bool', value: false});


                        view.$helpers.OpenPopup({
                            elRelative: null,
                            type: 'datafill',
                            componentState: {
                                entries: dataEntries,
                                positiveButtonLabel: this.$t('global.ui.approve'),
                                description: description,

                                selectCallback: function (data) {
                                    if(data.ignoreWarning){
                                        view.$store.commit('setNotificationBellConfigStateValue', {key: 'showUnpublishedShifts', value: false});
                                    }
                                }
                            },
                            header: this.$t('global.ui.warning') + ': ' + this.$t('global.menubar.messages.notificationsUnpublishedShifts'),
                            expanded: true,
                            centered: true
                        });
                    }
                }

            },
            DoEmployeeWorkbalanceCheck(){
                let view = this;
                let config = this.notificationBellConfigState;
                if(config.showUnconfirmedWorkbalance){
                    let unconfirmedCount = 0;

                    Object.values(this.employeeWorkbalanceMap).forEach(wb => {
                        if(!wb.confirmed){
                            unconfirmedCount++;
                        }
                    });
                    let today = this.$helpers.getMomentTZ().startOf('day');
                    if(unconfirmedCount > 0 && this.rosterFromTo.year <= today.year() && this.rosterFromTo.month <= today.month()){
                        let description = "<b style='color: red'>" + this.$t('roster.view.unconfirmedClosingsWarn', [unconfirmedCount]);

                        description+=this.$t('roster.view.closeForCorrectnessHelp')
                        let dataEntries = [];
                        dataEntries.push({label: this.$t('roster.view.dontShowOnThisDevice'), key: 'ignoreWarning', hidden: false, type: 'bool', value: false});


                        view.$helpers.OpenPopup({
                            elRelative: null,
                            type: 'datafill',
                            componentState: {
                                entries: dataEntries,
                                positiveButtonLabel: this.$t('global.ui.approve'),
                                description: description,

                                selectCallback: function (data) {
                                    if(data.ignoreWarning){
                                        view.$store.commit('setNotificationBellConfigStateValue', {key: 'showUnconfirmedWorkbalance', value: false});
                                    }
                                }
                            },
                            header: this.$t('global.ui.warning') + ': ' + this.$t('global.menubar.messages.notificationsUnapprovedBalances'),
                            expanded: true,
                            centered: true
                        });
                    }
                }

            },

            DeleteSelectedShifts(){
                let view = this;
                if(!this.shiftsSelected) return;

                    let url = '/api/sec/planshift/any/delete';


                    let ids = [];
                    this.shiftsSelected.filter(s => !s.published && !s.locked).forEach(s => ids.push(s.id));
                    let payload = {
                       ids: ids,
                    }
                    if(ids.length > 0){
                        view.$helpers.RecursivePOSTAny(url, payload, [])
                        .then(result => {

                            view.shiftsSelected = [];
                            let deletedIds = result;

                            let payload = [];
                            deletedIds.forEach(i => { let x = {mapName : 'planShiftMap', id: i }; payload.push(x) });
                            view.$store.commit("deleteMultiple",payload);
                            deletedIds.forEach(i => view.$delete(view.customPlanShiftMap, i));

                            window.roster.planshifts = window.roster.planshifts.filter(s => !deletedIds.find(i => i === s.id));
                            if(window.timebars) window.timebars.forEach(t => t.Init());
                            requestAnimationFrame(function(){
                                window.roster.GenerateEmployeeShiftsFromMap();
                                if(view.dayMode){
                                    view.$rosterhelper.calculateShiftTimeByHourMapDelta(
                                                                view.shiftTimeByHourMap,
                                                                [view.dayModeDate.format('YYYY-MM-DD')],
                                                                [],
                                                                view.planShiftDateMap, view.actualShiftDateMap,
                                                                view.planShiftMap, view.planShiftMomentMap,
                                                                view.actualShiftMap, view.actualShiftMomentMap,
                                                                view.actualBreakMap, view.actualBreakMomentMap,
                                                                view.actualBreakShiftIdMap,
                                                                view.employeeMap,
                                                                view.spotMap, view.$helpers);
                                }
                                if (view.rosterSortState.showShiftSpots) {
                                    view.updateSpots();
                                    view.sortEmployeeGroups();
                                    view.RefreshRosterContentMap();
                                }
                                window.roster.$forceUpdate();
                                });
                            view.$helpers.success(view.$t('global.notifications.success'), view.$t('shift.main.shiftsDeleted'));
                        }).catch(function (error) {
                            console.log(error);
                            view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.main.deleteShiftsError'));
                        });
                    } else {
                        view.$helpers.success(view.$t('global.notifications.success'), view.$t('roster.view.noDeletableShifts'));
                    }


            },

            DeleteAllShifts() {
                let view = this;

                let shifts = Object.values(view.planShiftMap).filter(s => view.planShiftMomentMap[s.id].fromDate.month() == view.rosterFromTo.month);
                window.app.popupalerts.push({header: this.$t('roster.view.deleteAllShifts'), number: shifts.length, description: this.$t('roster.view.deleteAllShiftsQuery'), hidden: false, callbackAccept: function(popup){
                    popup.loading = true;
                    let url = '/api/sec/planshift/any/delete';



                    let ids = [];
                    shifts.forEach(s => ids.push(s.id));
                    let payload = {
                       storeId: view.$store.state.storeId,
                       ids: ids,
                    }
                    view.$helpers.RecursivePOSTAny(url, payload, [])
                    .then(result => {


                        popup.loading = false;
                        popup.hidden = true;
                        view.shiftsSelected = [];
                        let deletedIds = result;


                        let payload = [];
                        deletedIds.forEach(i => { let x = {mapName : 'planShiftMap', id: i }; payload.push(x) });
                        view.$store.commit("deleteMultiple",payload);
                        deletedIds.forEach(i => view.$delete(view.customPlanShiftMap, i));


                        view.planshifts = window.roster.planshifts.filter(s => deletedIds.filter(i => i === s.id).length == 0);
                        if(window.timebars) window.timebars.forEach(t => t.Init());
                        requestAnimationFrame(function(){
                            view.GenerateEmployeeShiftsFromMap();
                            if (view.rosterSortState.showShiftSpots) {
                                view.updateSpots();
                                view.sortEmployeeGroups();
                                view.RefreshRosterContentMap();
                            }
                            view.$forceUpdate();
                        });
                        view.$helpers.success(view.$t('global.notifications.success'), view.$t('shift.main.shiftsDeleted'));
                    }).catch(function (error) {
                        popup.loading = false;
                        popup.hidden = true;
                        console.log(error);
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.deleteAllShiftsError'));
                    });
                }, callbackCancel: function(popup){
                    popup.loading = false;
                    popup.hidden = true;

                }});
            },


            DeleteShifts(ids){
                let view = this;
                let url = '/api/sec/planshift/any/delete';

                let payload = {
                    storeId: view.$store.state.storeId,
                    ids: ids,
                }
                view.$helpers.RecursivePOSTAny(url, payload, [])
                .then(result => {


                    let deletedIds = result;

                    let payload = [];
                    deletedIds.forEach(i => { let x = {mapName : 'planShiftMap', id: i }; payload.push(x) });
                    view.$store.commit("deleteMultiple",payload);
                    deletedIds.forEach(i => view.$delete(view.customPlanShiftMap, i));

                    view.planshifts = view.planshifts.filter(s => deletedIds.filter(i => i === s.id).length == 0);
                    if(window.timebars) window.timebars.forEach(t => t.Init());
                    requestAnimationFrame(function(){
                        view.GenerateEmployeeShiftsFromMap();
                        if (view.rosterSortState.showShiftSpots) {
                            view.updateSpots();
                            view.sortEmployeeGroups();
                            view.RefreshRosterContentMap();
                        }
                        view.$forceUpdate();
                    });
                    view.$helpers.success(view.$t('global.notifications.success'), view.$t('shift.main.shiftsDeleted'));
                }).catch(function (error) {
                    console.log(error);
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.deleteAllShiftsError'));
                });
            },

            OpenDeleteLeftoverShiftsModal($event) {
                let view = this;
                let description = this.$t('roster.view.deleteWhichPeriods') + "<br/>"+
                                  "<b style='color: red'>" + this.$t('global.ui.warning') + ":</b> <ul>"+
                                  "<li>" + this.$t('roster.view.wontDeleteAssignments') + "</li>"+
                                  "<li>" + this.$t('roster.view.wontDeletePublishedShifts') + "</li></ul>";
                let dataEntries = [];
                let filterState = {spotId: Object.values(this.spotMap).map(s => s.id)};
                dataEntries.push({label: this.$t('pages.employeeCoreData.mainPosition'), key: 'spots', type: 'dropdownsearch',
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        items: Object.values(this.spotMap).map(s => {
                            return {
                                label: s.name,
                                value: s.id,
                                iconLeft: {icon: 'fa-circle', type: 'small',styleButton: {'margin-left': '-9px', 'margin-top': '1px'}, styleIcon: {color: s.color + ' !important', 'text-shadow': '0 0 1px black, 0 0 1px black, 0 0 1px black;'}},
                                selected: filterState.spotId.find(v => v === s.id)
                            }
                        }),
                    },
                    filterCheck: (data) => {
                        return  filterState.spotId.length === 0 || filterState.spotId.find(v => v === data.spotId)
                    }
                });
                if(view.dayMode){
                    let key = view.dayModeDate.format("DD.MM.YYYY")
                    dataEntries.push({label: key, key: key, hidden: false, type: 'bool', value: true});
                } else {
                    Object.keys(this.shiftsWeeklyMap.weekEntries).forEach(k => {
                        dataEntries.push({label: k, key: k, hidden: false, type: 'bool', value: true});
                    });
                }

                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: description,
                        selectCallback: function (data) {
                            let ids = [];
                            let spots = data.spots;
                            Object.keys(data).forEach(k => {
                                if(data[k] == true){
                                    let map = view.shiftsWeeklyMap.weekEntries;
                                    if(view.dayMode){
                                        map = view.shiftsWeeklyMap.dayEntries;
                                    }
                                    if(map[k]){
                                        map[k].forEach(s => {
                                            let spotId = view.employeeMap[s.employeeId] ? view.employeeMap[s.employeeId].spotId : s.spotId;
                                            if(spots.includes(spotId) && !s.published && s.employeeId == null && !s.locked){
                                                ids.push(s.id);
                                            }
                                        })
                                    }
                                }
                            });
                            view.DeleteShifts(ids);
                        }
                    },
                    header: this.$t('roster.view.deleteUnfilledShifts'),
                    expanded: true,
                    centered: true
                });

            },
            OpenDeleteInvalidShiftsModal($event) {
                let view = this;

                let description = this.$t('roster.view.deleteExtraShifts');

                let dataEntries = [];
                dataEntries.push({label: this.$t('roster.view.keepShiftsWithEmployees'), key: 'keepAssigned', hidden: false, type: 'bool', value: true});

                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: description,
                        selectCallback: function (data) {
                            VueEventBus.$emit('delete-invalidtemplateshifts', {keepAssigned: data.keepAssigned});
                        }
                    },
                    header: this.$t('roster.view.deleteInvalidShifts'),
                    expanded: true,
                    centered: true
                });


            },
            OpenDeleteShiftsWithoutTemplateModal($event){
                let view = this;
                let description = this.$t('roster.view.deleteWhichPeriods') + "<br/>"+
                                  "<b style='color: red'>"+ this.$t('global.ui.warning') + ":</b> <ul>"+
                                  "<li>" + this.$t('roster.view.wontDeletePublishedShifts') + "</li></ul>";
                let dataEntries = [];
                let filterState = {spotId: Object.values(this.spotMap).map(s => s.id)};
                dataEntries.push({label: this.$t('pages.employeeCoreData.mainPosition'), key: 'spots', type: 'dropdownsearch',
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        items: Object.values(this.spotMap).map(s => {
                            return {
                                label: s.name,
                                value: s.id,
                                iconLeft: {icon: 'fa-circle', type: 'small',styleButton: {'margin-left': '-9px', 'margin-top': '1px'}, styleIcon: {color: s.color + ' !important', 'text-shadow': '0 0 1px black, 0 0 1px black, 0 0 1px black;'}},
                                selected: filterState.spotId.find(v => v === s.id)
                            }
                        }),
                    },
                    filterCheck: (data) => {
                        return  filterState.spotId.length === 0 || filterState.spotId.find(v => v === data.spotId)
                    }
                });
                if(view.dayMode){
                    let key = view.dayModeDate.format("DD.MM.YYYY")
                    dataEntries.push({label: key, key: key, hidden: false, type: 'bool', value: true});
                } else {
                    Object.keys(this.shiftsWeeklyMap.weekEntries).forEach(k => {
                        dataEntries.push({label: k, key: k, hidden: false, type: 'bool', value: true});
                    });
                }
                dataEntries.push({divider: true});
                dataEntries.push({label: this.$t('roster.view.deleteAssignmentsQuery'), key: 'deleteWithEmployees', hidden: false, type: 'bool', value: false});

                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: description,
                        selectCallback: function (data) {
                            let ids = [];
                            let spots = data.spots;
                            Object.keys(data).forEach(k => {
                                if(data[k] == true){
                                    let map = view.shiftsWeeklyMap.weekEntries;
                                    if(view.dayMode){
                                        map = view.shiftsWeeklyMap.dayEntries;
                                    }
                                    if(map[k]){
                                        map[k].forEach(s => {
                                            let spotId = view.employeeMap[s.employeeId] ? view.employeeMap[s.employeeId].spotId : s.spotId;
                                            let deleteWithEmployees = data.deleteWithEmployees ? true : (s.employeeId == null);

                                            if(spots.includes(spotId) && !s.published && s.templateId == null && !s.locked && !s.pinned && deleteWithEmployees){
                                                ids.push(s.id);
                                            }
                                        })
                                    }
                                }
                            });
                            view.DeleteShifts(ids);
                        }
                    },
                    header: this.$t('roster.view.deleteAdditionalShifts'),
                    expanded: true,
                    centered: true
                });

            },
            OpenPublishAllShiftsModal($event){
                let view = this;
                let description = this.$t('roster.view.publishPeriods') + "<br/>"+
                                  "<b style='color: red'>" + this.$t('global.ui.warning') + ":</b> <ul>"+
                                  "<li>" + this.$t('roster.view.cantUnpublish') + "</li>";
                if(this.validMpLicense){
                    description+="<li>" + this.$t('roster.view.publishInMp') + "</li>"
                }
                if(this.validMzLicense){
                    description+="<li>" + this.$t('roster.view.publishInMz') + "</li>"
                }
                description+="</ul>"

                let dataEntries = [];
                let filterState = {spotId: Object.values(this.spotMap).map(s => s.id)};

                dataEntries.push({label: this.$t('global.ui.selectEmployee'), key: 'selectByEmployee', hidden: false, type: 'bool', value: false})
                dataEntries.push({label: this.$t('pages.employeeCoreData.mainPosition'), key: 'spots', type: 'dropdownsearch', hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('selectByEmployee'),
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        items: Object.values(this.spotMap).map(s => {
                            return {
                                label: s.name,
                                value: s.id,
                                iconLeft: {icon: 'fa-circle', type: 'small',styleButton: {'margin-left': '-9px', 'margin-top': '1px'}, styleIcon: {color: s.color + ' !important', 'text-shadow': '0 0 1px black, 0 0 1px black, 0 0 1px black;'}},
                                selected: filterState.spotId.find(v => v === s.id)
                            }
                        }),
                    },
                    filterCheck: (data) => {
                        return  filterState.spotId.length === 0 || filterState.spotId.find(v => v === data.spotId)
                    }
                });

                dataEntries.push({label: this.$tc('global.general.employee'), key: 'employees', type: 'dropdownsearch', hidden: this.$helpers.CheckDatafillKeysForHidden('selectByEmployee'),
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        items: Object.values(this.employeeMap).filter(e => e.active).sort((a, b) => a.lastName.localeCompare(b.lastName)).map(e => {
                            return {
                                label: e.lastName+" "+e.firstName,
                                value: e.id,
                                selected: false
                            }
                        }),
                    },

                });
                if(view.dayMode){
                    let key = view.dayModeDate.format("DD.MM.YYYY")
                    dataEntries.push({label: key, key: key, hidden: false, type: 'bool', value: true});
                } else {
                    dataEntries.push({label: this.$t('roster.view.selectByDays'), key: 'selectByDay', hidden: false, type: 'bool', value: false})
                    dataEntries.push({divider: true})
                    Object.keys(this.unpublishedShiftsWeeklyMap.weekEntries).forEach(k => {

                        dataEntries.push({label: k, key: k, hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('selectByDay'), type: 'bool', value: true});
                    });
                    let dateEntries = this.generateDateSelectionEntries();
                    dataEntries.push({label: this.$t('global.general.from'), key: 'from', hidden: this.$helpers.CheckDatafillKeysForHidden('selectByDay'), type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: dateEntries,
                            selectMultiple: false,
                            selectedItems: [dateEntries[0]],
                            selectedItem: dateEntries[0],
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: '',
                        }, styles: {width: '342px'}
                    });
                    dateEntries = this.generateDateSelectionEntries(true);
                    dataEntries.push({label: this.$t('global.general.to'), key: 'to', hidden: this.$helpers.CheckDatafillKeysForHidden('selectByDay'), type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: dateEntries,
                            selectMultiple: false,
                            selectedItems: [dateEntries[dateEntries.length-1]],
                            selectedItem: dateEntries[dateEntries.length-1],
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: '',
                        }, styles: {width: '342px'}
                    });
                }


                view.$helpers.OpenPopup({
                    elRelative: $event.currentTarget,
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: description,
                        selectCallback: function (data) {
                            let ids = [];
                            let spots = data.spots;
                            if(!data.selectByDay){
                                Object.keys(data).filter(k => k != 'selectByDay').forEach(k => {
                                    if(data[k] == true){
                                        let map = view.unpublishedShiftsWeeklyMap.weekEntries;
                                        if(view.dayMode){
                                            map = view.unpublishedShiftsWeeklyMap.dayEntries;
                                        }
                                        if(map[k]){
                                            map[k].forEach(s => {

                                                if(!data.selectByEmployee){
                                                    let employee = view.employeeMap[s.employeeId];
                                                    let spotId = employee ? (employee.spotId ? employee.spotId : s.spotId) : s.spotId;
                                                    if(spots.includes(spotId) && !s.locked){
                                                        ids.push(s.id);
                                                    }
                                                } else if(data.employees.includes(s.employeeId) && !s.locked) {
                                                    ids.push(s.id);
                                                }

                                            })
                                        }

                                    }
                                });
                            } else {
                                Object.values(view.planShiftMap)
                                .filter(s => !s.published && s.employeeId != null && view.planShiftMomentMap[s.id].fromDate >= data.from && view.planShiftMomentMap[s.id].fromDate < data.to)
                                .forEach(s => {
                                    if(!data.selectByEmployee){
                                        let employee = view.employeeMap[s.employeeId];
                                        let spotId = employee ? (employee.spotId ? employee.spotId : s.spotId) : s.spotId;
                                        if(spots.includes(spotId) && !s.locked){
                                            ids.push(s.id);
                                        }
                                    } else if(data.employees.includes(s.employeeId) && !s.locked) {
                                        ids.push(s.id);
                                    }
                                })

                            }

                            view.PublishShifts(ids, true);
                        }
                    },
                    header: this.$t('roster.view.publishShifts'),
                    expanded: true,
                    centered: true
                });
            },
            OpenPublishAllShiftsToMZModal($event){
                let view = this;
                let description = this.$t('roster.view.publishPeriodMz') + " <br/>"+
                                  "<b style='color: red'>" + this.$t('global.ui.warning') + ":</b> <ul>"+
                                  "<li>" + this.$t('roster.view.cantPublishPastMz') + "</li>";

                description+="</ul>"
                let dataEntries = [];
                let filterState = {spotId: Object.values(this.spotMap).map(s => s.id)};
                dataEntries.push({label: this.$t('global.ui.selectEmployee'), key: 'selectByEmployee', hidden: false, type: 'bool', value: false})
                dataEntries.push({label: this.$t('pages.employeeCoreData.mainPosition'), key: 'spots', type: 'dropdownsearch', hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('selectByEmployee'),
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        items: Object.values(this.spotMap).map(s => {
                            return {
                                label: s.name,
                                value: s.id,
                                iconLeft: {icon: 'fa-circle', type: 'small',styleButton: {'margin-left': '-9px', 'margin-top': '1px'}, styleIcon: {color: s.color + ' !important', 'text-shadow': '0 0 1px black, 0 0 1px black, 0 0 1px black;'}},
                                selected: filterState.spotId.find(v => v === s.id)
                            }
                        }),
                    },
                    filterCheck: (data) => {
                        return  filterState.spotId.length === 0 || filterState.spotId.find(v => v === data.spotId)
                    }
                });

                dataEntries.push({label: this.$tc('global.general.employee'), key: 'employees', type: 'dropdownsearch', hidden: this.$helpers.CheckDatafillKeysForHidden('selectByEmployee'),
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        items: Object.values(this.employeeMap).filter(e => e.active).sort((a, b) => a.lastName.localeCompare(b.lastName)).map(e => {
                            return {
                                label: e.lastName+" "+e.firstName,
                                value: e.id,
                                selected: false
                            }
                        }),
                    },

                });
                if(view.dayMode){
                    let key = view.dayModeDate.format("DD.MM.YYYY")
                    dataEntries.push({label: key, key: key, hidden: false, type: 'bool', value: true});
                } else {
                    dataEntries.push({label: this.$t('roster.view.selectByDays'), key: 'selectByDay', hidden: false, type: 'bool', value: false})
                    dataEntries.push({divider: true})
                    Object.keys(this.publishedShiftsWeeklyMap.weekEntries).forEach(k => {
                        dataEntries.push({label: k, key: k, hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('selectByDay'), type: 'bool', value: true});
                    });
                    let dateEntries = this.generateDateSelectionEntries();

                    dataEntries.push({label: this.$t('global.general.from'), key: 'from', hidden: this.$helpers.CheckDatafillKeysForHidden('selectByDay'), type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: dateEntries,
                            selectMultiple: false,
                            selectedItems: [dateEntries[0]],
                            selectedItem: dateEntries[0],
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: '',
                        }, styles: {width: '342px'}
                    });
                    dateEntries = this.generateDateSelectionEntries(true);
                    dataEntries.push({label: this.$t('global.general.to'), key: 'to', hidden: this.$helpers.CheckDatafillKeysForHidden('selectByDay'), type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: dateEntries,
                            selectMultiple: false,
                            selectedItems: [dateEntries[dateEntries.length-1]],
                            selectedItem: dateEntries[dateEntries.length-1],
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: '',
                        }, styles: {width: '342px'}
                    });

                }

                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: description,
                        selectCallback: function (data) {
                            let ids = [];
                            let spots = data.spots;
                            if(!data.selectByDay){
                                Object.keys(data).filter(k => k != 'selectByDay').forEach(k => {
                                    if(data[k] == true){
                                        let map = view.publishedShiftsWeeklyMap.weekEntries;
                                        if(view.dayMode){
                                            map = view.publishedShiftsWeeklyMap.dayEntries;
                                        }
                                        if(map[k]){
                                            map[k].forEach(s => {
                                                if(!data.selectByEmployee){
                                                    let employee = view.employeeMap[s.employeeId];
                                                    let spotId = employee ? (employee.spotId ? employee.spotId : s.spotId) : s.spotId;
                                                    if(spots.includes(spotId)){
                                                        ids.push(s.id);
                                                    }
                                                } else if(data.employees.includes(s.employeeId)) {
                                                    ids.push(s.id);
                                                }
                                            })
                                        }
                                    }
                                });
                            } else {
                                Object.values(view.planShiftMap)
                                .filter(s => s.published && s.employeeId != null && view.planShiftMomentMap[s.id].fromDate >= data.from && view.planShiftMomentMap[s.id].fromDate < data.to)
                                .forEach(s => {
                                    if(!data.selectByEmployee){
                                        let employee = view.employeeMap[s.employeeId];
                                        let spotId = employee ? (employee.spotId ? employee.spotId : s.spotId) : s.spotId;
                                        if(spots.includes(spotId)){
                                            ids.push(s.id);
                                        }
                                    } else if(data.employees.includes(s.employeeId)) {
                                        ids.push(s.id);
                                    }
                                })
                            }

                            view.PublishShiftsToMZ(ids);
                        }
                    },
                    header: this.$t('roster.view.publishShiftsMz'),
                    expanded: true,
                    centered: true
                });
            },
            OpenSynchFromMZModal($event){
                let view = this;
                let description = this.$t('roster.view.syncPunchDayQuery') + " <br/>";

                let dataEntries = [];
                let items = [];
                let startDate = this.$helpers.getMomentTZ().month(this.rosterFromTo.month).year(this.rosterFromTo.year).startOf('month');
                let endDate = startDate.clone().endOf('month').add(1, 'days').startOf('day');
                while(endDate > startDate){
                    let item = {label: startDate.format("dddd DD.MM. "), value: startDate.clone().startOf('day')};
                    items.push(item);
                    startDate = startDate.add(1, 'days');
                }

                dataEntries.push({label: this.$tc('global.general.day'), key: 'day', type: 'dropdownsearch',
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        items: items,
                    },

                });


                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: description,
                        selectCallback: function (data) {
                            if(data.day != null){
                                view.SynchShiftsFromMZ(data.day, data.day.clone().add(1, 'days'));
                            }

                        }
                    },
                    header: this.$t('roster.view.syncPunchMz'),
                    expanded: true,
                    centered: true
                });
            },
            OpenUnpublishAllShiftsModal($event){
                let view = this;
                let description = this.$t('roster.view.unpublishPeriods') + "<br/>"+
                                  "<b style='color: red'>" + this.$t('global.ui.warning') + ":</b> <ul>"+
                                  "<li>" + this.$t('roster.view.cant30minUnpublish') + "</li>";
                if(this.validMpLicense){
                    description+="<li>" + this.$t('roster.view.unpublishMp') + "</li>"
                }
                if(this.validMzLicense){
                    description+="<li>" + this.$t('roster.view.unpublishMz') + "</li>"
                }
                description+="</ul>"
                let dataEntries = [];
                let filterState = {spotId: Object.values(this.spotMap).map(s => s.id)};
                dataEntries.push({label: this.$t('global.ui.selectEmployee'), key: 'selectByEmployee', hidden: false, type: 'bool', value: false})
                dataEntries.push({label: this.$t('pages.employeeCoreData.mainPosition'), key: 'spots', type: 'dropdownsearch', hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('selectByEmployee'),
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        items: Object.values(this.spotMap).map(s => {
                            return {
                                label: s.name,
                                value: s.id,
                                iconLeft: {icon: 'fa-circle', type: 'small',styleButton: {'margin-left': '-9px', 'margin-top': '1px'}, styleIcon: {color: s.color + ' !important', 'text-shadow': '0 0 1px black, 0 0 1px black, 0 0 1px black;'}},
                                selected: filterState.spotId.find(v => v === s.id)
                            }
                        }),
                    },
                    filterCheck: (data) => {
                        return  filterState.spotId.length === 0 || filterState.spotId.find(v => v === data.spotId)
                    }
                });

                dataEntries.push({label: this.$tc('global.general.employee'), key: 'employees', type: 'dropdownsearch', hidden: this.$helpers.CheckDatafillKeysForHidden('selectByEmployee'),
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        items: Object.values(this.employeeMap).filter(e => e.active).sort((a, b) => a.lastName.localeCompare(b.lastName)).map(e => {
                            return {
                                label: e.lastName+" "+e.firstName,
                                value: e.id,
                                selected: false
                            }
                        }),
                    },

                });
                if(view.dayMode){
                    let key = view.dayModeDate.format("DD.MM.YYYY")
                    dataEntries.push({label: key, key: key, hidden: false, type: 'bool', value: true});
                } else {
                    dataEntries.push({label: this.$t('roster.view.selectByDays'), key: 'selectByDay', hidden: false, type: 'bool', value: false})
                    dataEntries.push({divider: true})
                    Object.keys(this.publishedShiftsWeeklyMap.weekEntries).forEach(k => {
                        dataEntries.push({label: k, key: k, hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('selectByDay'), type: 'bool', value: true});
                    });
                    let dateEntries = this.generateDateSelectionEntries();
                    dataEntries.push({label: this.$t('global.general.from'), key: 'from', hidden: this.$helpers.CheckDatafillKeysForHidden('selectByDay'), type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: dateEntries,
                            selectMultiple: false,
                            selectedItems: [dateEntries[0]],
                            selectedItem: dateEntries[0],
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: '',
                        }, styles: {width: '342px'}
                    });
                    dateEntries = this.generateDateSelectionEntries(true);
                    dataEntries.push({label: this.$t('global.general.to'), key: 'to', hidden: this.$helpers.CheckDatafillKeysForHidden('selectByDay'), type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: dateEntries,
                            selectMultiple: false,
                            selectedItems: [dateEntries[dateEntries.length-1]],
                            selectedItem: dateEntries[dateEntries.length-1],
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: '',
                        }, styles: {width: '342px'}
                    });
                }

                view.$helpers.OpenPopup({
                    elRelative: $event.currentTarget,
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: description,
                        selectCallback: function (data) {
                            let ids = [];
                            let spots = data.spots;
                            if(!data.selectByDay){
                                Object.keys(data).filter(k => k != 'selectByDay').forEach(k => {
                                    if(data[k] == true){
                                        let map = view.publishedShiftsWeeklyMap.weekEntries;
                                        if(view.dayMode){
                                            map = view.publishedShiftsWeeklyMap.dayEntries;
                                        }
                                        if(map[k]){
                                            map[k].forEach(s => {
                                                if(!data.selectByEmployee){
                                                    let employee = view.employeeMap[s.employeeId];
                                                    let spotId = employee ? (employee.spotId ? employee.spotId : s.spotId) : s.spotId;
                                                    if(spots.includes(spotId) && !s.locked){
                                                        ids.push(s.id);
                                                    }
                                                } else if(data.employees.includes(s.employeeId) && !s.locked) {
                                                    ids.push(s.id);
                                                }
                                            })
                                        }
                                    }
                                });
                            } else {
                                Object.values(view.planShiftMap)
                                .filter(s => s.published && s.employeeId != null && view.planShiftMomentMap[s.id].fromDate >= data.from && view.planShiftMomentMap[s.id].fromDate < data.to)
                                .forEach(s => {
                                   if(!data.selectByEmployee){
                                        let employee = view.employeeMap[s.employeeId];
                                        let spotId = employee ? (employee.spotId ? employee.spotId : s.spotId) : s.spotId;
                                        if(spots.includes(spotId) && !s.locked){
                                            ids.push(s.id);
                                        }
                                    } else if(data.employees.includes(s.employeeId) && !s.locked) {
                                        ids.push(s.id);
                                    }
                                })
                            }
                            view.UnpublishShifts(ids);
                        }
                    },
                    header: this.$t('roster.view.unpublishShifts'),
                    expanded: true,
                    centered: true
                });
            },
            OpenClearAllShiftsModal($event){
                let view = this;
                let description = this.$t('roster.view.removeEmployeesPeriods') + "<br/>"+
                                  "<b style='color: red'>" + this.$t('global.ui.warning') + ":</b> <br/>"+
                                  "<p style='color: red'>" + this.$t('roster.view.removeEmployeeQuery') + "</p>"+
                                  "<p style='color: red'>" + this.$t('roster.view.cantBeUndone') + "</p>";

                let dataEntries = [];
                let filterState = {spotId: Object.values(this.spotMap).map(s => s.id)};
                dataEntries.push({label: this.$t('global.ui.selectEmployee'), key: 'selectByEmployee', hidden: false, type: 'bool', value: false})
                dataEntries.push({label: this.$t('pages.employeeCoreData.mainPosition'), key: 'spots', type: 'dropdownsearch', hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('selectByEmployee'),
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        items: Object.values(this.spotMap).map(s => {
                            return {
                                label: s.name,
                                value: s.id,
                                iconLeft: {icon: 'fa-circle', type: 'small',styleButton: {'margin-left': '-9px', 'margin-top': '1px'}, styleIcon: {color: s.color + ' !important', 'text-shadow': '0 0 1px black, 0 0 1px black, 0 0 1px black;'}},
                                selected: filterState.spotId.find(v => v === s.id)
                            }
                        }),
                    },
                    filterCheck: (data) => {
                        return  filterState.spotId.length === 0 || filterState.spotId.find(v => v === data.spotId)
                    }
                });

                dataEntries.push({label: this.$tc('global.general.employee'), key: 'employees', type: 'dropdownsearch', hidden: this.$helpers.CheckDatafillKeysForHidden('selectByEmployee'),
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        items: Object.values(this.employeeMap).filter(e => e.active).sort((a, b) => a.lastName.localeCompare(b.lastName)).map(e => {
                            return {
                                label: e.lastName+" "+e.firstName,
                                value: e.id,
                                selected: false
                            }
                        }),
                    },

                });
                if(view.dayMode){
                    let key = view.dayModeDate.format("DD.MM.YYYY")
                    dataEntries.push({label: key, key: key, hidden: false, type: 'bool', value: true});
                } else {
                    dataEntries.push({label: this.$t('roster.view.selectByDays'), key: 'selectByDay', hidden: false, type: 'bool', value: false})
                    dataEntries.push({divider: true})
                    Object.keys(this.unassignShiftsWeeklyMap.weekEntries).forEach(k => {
                        dataEntries.push({label: k, key: k, hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('selectByDay'), type: 'bool', value: true});
                    });
                    let dateEntries = this.generateDateSelectionEntries();
                    dataEntries.push({label: this.$t('global.general.from'), key: 'from', hidden: this.$helpers.CheckDatafillKeysForHidden('selectByDay'), type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: dateEntries,
                            selectMultiple: false,
                            selectedItems: [dateEntries[0]],
                            selectedItem: dateEntries[0],
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: '',
                        }, styles: {width: '342px'}
                    });
                    dateEntries = this.generateDateSelectionEntries(true);
                    dataEntries.push({label: this.$t('global.general.to'), key: 'to', hidden: this.$helpers.CheckDatafillKeysForHidden('selectByDay'), type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: dateEntries,
                            selectMultiple: false,
                            selectedItems: [dateEntries[dateEntries.length-1]],
                            selectedItem: dateEntries[dateEntries.length-1],
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: '',
                        }, styles: {width: '342px'}
                    });
                }

                view.$helpers.OpenPopup({
                    elRelative: $event.currentTarget,
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: description,
                        selectCallback: function (data) {
                            let requests = [];
                            let spots = data.spots;
                            if(!data.selectByDay){
                                Object.keys(data).forEach(k => {
                                    if(data[k] == true){
                                        let map = view.unassignShiftsWeeklyMap.weekEntries;
                                        if(view.dayMode){
                                            map = view.unassignShiftsWeeklyMap.dayEntries;
                                        }
                                        if(map[k]){
                                            map[k].forEach(s => {
                                                if(!data.selectByEmployee){
                                                    let employee = view.employeeMap[s.employeeId];
                                                    let spotId = employee ? (employee.spotId ? employee.spotId : s.spotId) : s.spotId;
                                                    if(spots.includes(spotId) && !s.published && !s.pinned && !s.locked){
                                                        requests.push({id: s.id, updateFields: ["employeeId", "pinned"], employeeId: null, pinned: false});
                                                    }
                                                } else if(data.employees.includes(s.employeeId) && !s.published && !s.pinned && !s.locked) {
                                                    requests.push({id: s.id, updateFields: ["employeeId", "pinned"], employeeId: null, pinned: false});
                                                }

                                            })
                                        }

                                    }
                                });
                            } else {
                               Object.values(view.planShiftMap)
                                .filter(s => !s.published && s.employeeId != null && !s.pinned && !s.locked&& view.planShiftMomentMap[s.id].fromDate >= data.from && view.planShiftMomentMap[s.id].fromDate < data.to)
                                .forEach(s => {
                                    if(!data.selectByEmployee){
                                        let employee = view.employeeMap[s.employeeId];
                                        let spotId = employee ? (employee.spotId ? employee.spotId : s.spotId) : s.spotId;
                                        if(spots.includes(spotId) && !s.published && !s.pinned && !s.locked){
                                            requests.push({id: s.id, updateFields: ["employeeId", "pinned"], employeeId: null, pinned: false});
                                        }
                                    } else if(data.employees.includes(s.employeeId) && !s.published && !s.pinned && !s.locked) {
                                        requests.push({id: s.id, updateFields: ["employeeId", "pinned"], employeeId: null, pinned: false});
                                    }
                                })
                            }

                            view.ClearShifts(requests);
                        }
                    },
                    header: this.$t('roster.view.removeEmployeesFromShifts'),
                    expanded: true,
                    centered: true
                });
            },
            OpenPinAllShiftsModal($event){
                let view = this;

                if (Object.values(this.planShiftMap).filter(p => p.employeeId != null).length <= 0) {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.noShiftsToPin'));
                    return;
                }

                let description = this.$t('roster.view.pinShiftsPeriod') + "<br/>";


                let dataEntries = [];
                let filterState = {spotId: Object.values(this.spotMap).map(s => s.id)};
                dataEntries.push({label: this.$t('global.ui.selectEmployee'), key: 'selectByEmployee', hidden: false, type: 'bool', value: false})
                dataEntries.push({label: this.$t('pages.employeeCoreData.mainPosition'), key: 'spots', type: 'dropdownsearch', hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('selectByEmployee'),
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        items: Object.values(this.spotMap).map(s => {
                            return {
                                label: s.name,
                                value: s.id,
                                iconLeft: {icon: 'fa-circle', type: 'small',styleButton: {'margin-left': '-9px', 'margin-top': '1px'}, styleIcon: {color: s.color + ' !important', 'text-shadow': '0 0 1px black, 0 0 1px black, 0 0 1px black;'}},
                                selected: filterState.spotId.find(v => v === s.id)
                            }
                        }),
                    },
                    filterCheck: (data) => {
                        return  filterState.spotId.length === 0 || filterState.spotId.find(v => v === data.spotId)
                    }
                });

                dataEntries.push({label: this.$tc('global.general.employee'), key: 'employees', type: 'dropdownsearch', hidden: this.$helpers.CheckDatafillKeysForHidden('selectByEmployee'),
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        items: Object.values(this.employeeMap).filter(e => e.active).sort((a, b) => a.lastName.localeCompare(b.lastName)).map(e => {
                            return {
                                label: e.lastName+" "+e.firstName,
                                value: e.id,
                                selected: false
                            }
                        }),
                    },

                });
                if(view.dayMode){
                    let key = view.dayModeDate.format("DD.MM.YYYY")
                    dataEntries.push({label: key, key: key, hidden: false, type: 'bool', value: true});
                } else {
                    dataEntries.push({label: this.$t('roster.view.selectByDays'), key: 'selectByDay', hidden: false, type: 'bool', value: false})
                    dataEntries.push({divider: true})
                    Object.keys(this.shiftsWeeklyMap.weekEntries).forEach(k => {
                        dataEntries.push({label: k, key: k, hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('selectByDay'), type: 'bool', value: true});
                    });
                    let dateEntries = this.generateDateSelectionEntries();
                    dataEntries.push({label: this.$t('global.general.from'), key: 'from', hidden: this.$helpers.CheckDatafillKeysForHidden('selectByDay'), type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: dateEntries,
                            selectMultiple: false,
                            selectedItems: [dateEntries[0]],
                            selectedItem: dateEntries[0],
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: '',
                        }, styles: {width: '342px'}
                    });
                    dateEntries = this.generateDateSelectionEntries(true);
                    dataEntries.push({label: this.$t('global.general.to'), key: 'to', hidden: this.$helpers.CheckDatafillKeysForHidden('selectByDay'), type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: dateEntries,
                            selectMultiple: false,
                            selectedItems: [dateEntries[dateEntries.length-1]],
                            selectedItem: dateEntries[dateEntries.length-1],
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: '',
                        }, styles: {width: '342px'}
                    });
                }


                view.$helpers.OpenPopup({
                    elRelative: $event.currentTarget,
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: description,
                        selectCallback: function (data) {
                            let requests = [];
                            let spots = data.spots;
                            if(!data.selectByDay){
                                Object.keys(data).forEach(k => {
                                    if(data[k] == true){
                                        let map = view.shiftsWeeklyMap.weekEntries;
                                        if(view.dayMode){
                                            map = view.shiftsWeeklyMap.dayEntries;
                                        }
                                        if(map[k]){
                                            map[k].filter(s=>s.employeeId != null).forEach(s => {
                                                let preview = view.customPlanShiftMap[s.id] ? view.customPlanShiftMap[s.id].preview : false;
                                                if(!data.selectByEmployee){
                                                    let employee = view.employeeMap[s.employeeId];
                                                    let spotId = employee ? (employee.spotId ? employee.spotId : s.spotId) : s.spotId;
                                                    if(spots.includes(spotId) && !s.pinned && !s.locked && !preview){
                                                        requests.push({id: s.id, updateFields: ["pinned"], pinned: true});
                                                    }
                                                } else if(data.employees.includes(s.employeeId) && !s.pinned && !s.locked && !preview) {
                                                    requests.push({id: s.id, updateFields: ["pinned"], pinned: true});
                                                }

                                            })
                                        }

                                    }
                                });
                            } else {
                                Object.values(view.planShiftMap)
                                .filter(s => s.employeeId != null && !s.pinned && !s.locked&& view.planShiftMomentMap[s.id].fromDate >= data.from && view.planShiftMomentMap[s.id].fromDate < data.to)
                                .forEach(s => {
                                    let preview = view.customPlanShiftMap[s.id] ? view.customPlanShiftMap[s.id].preview : false;
                                    if(!data.selectByEmployee){
                                        let employee = view.employeeMap[s.employeeId];
                                        let spotId = employee ? (employee.spotId ? employee.spotId : s.spotId) : s.spotId;
                                        if(spots.includes(spotId) && !s.pinned && !s.locked && !preview){
                                            requests.push({id: s.id, updateFields: ["pinned"], pinned: true});
                                        }
                                    } else if(data.employees.includes(s.employeeId) && !s.pinned && !s.locked && !preview) {
                                        requests.push({id: s.id, updateFields: ["pinned"], pinned: true});
                                    }
                                })
                            }

                            view.PinShifts(requests);
                        }
                    },
                    header: this.$t('roster.view.pinShifts'),
                    expanded: true,
                    centered: true
                });
            },
            OpenUnpinAllShiftsModal($event){
                let view = this;

                if (Object.values(this.planShiftMap).filter(p => p.employeeId != null).length <= 0) {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.noShiftsToUnpin'));
                    return;
                }

                let description = this.$t('roster.view.unpinShifts') + "<br/>";


                let dataEntries = [];
                let filterState = {spotId: Object.values(this.spotMap).map(s => s.id)};
                dataEntries.push({label: this.$t('global.ui.selectEmployee'), key: 'selectByEmployee', hidden: false, type: 'bool', value: false})
                dataEntries.push({label: this.$t('pages.employeeCoreData.mainPosition'), key: 'spots', type: 'dropdownsearch', hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('selectByEmployee'),
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        items: Object.values(this.spotMap).map(s => {
                            return {
                                label: s.name,
                                value: s.id,
                                iconLeft: {icon: 'fa-circle', type: 'small',styleButton: {'margin-left': '-9px', 'margin-top': '1px'}, styleIcon: {color: s.color + ' !important', 'text-shadow': '0 0 1px black, 0 0 1px black, 0 0 1px black;'}},
                                selected: filterState.spotId.find(v => v === s.id)
                            }
                        }),
                    },
                    filterCheck: (data) => {
                        return  filterState.spotId.length === 0 || filterState.spotId.find(v => v === data.spotId)
                    }
                });

                dataEntries.push({label: this.$tc('global.general.employee'), key: 'employees', type: 'dropdownsearch', hidden: this.$helpers.CheckDatafillKeysForHidden('selectByEmployee'),
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        items: Object.values(this.employeeMap).filter(e => e.active).sort((a, b) => a.lastName.localeCompare(b.lastName)).map(e => {
                            return {
                                label: e.lastName+" "+e.firstName,
                                value: e.id,
                                selected: false
                            }
                        }),
                    },

                });
                if(view.dayMode){
                    let key = view.dayModeDate.format("DD.MM.YYYY")
                    dataEntries.push({label: key, key: key, hidden: false, type: 'bool', value: true});
                } else {
                    dataEntries.push({label: this.$t('roster.view.selectByDays'), key: 'selectByDay', hidden: false, type: 'bool', value: false})
                    dataEntries.push({divider: true})
                    Object.keys(this.shiftsWeeklyMap.weekEntries).forEach(k => {
                        dataEntries.push({label: k, key: k, hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('selectByDay'), type: 'bool', value: true});
                    });
                    let dateEntries = this.generateDateSelectionEntries();
                    dataEntries.push({label: this.$t('global.general.from'), key: 'from', hidden: this.$helpers.CheckDatafillKeysForHidden('selectByDay'), type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: dateEntries,
                            selectMultiple: false,
                            selectedItems: [dateEntries[0]],
                            selectedItem: dateEntries[0],
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: '',
                        }, styles: {width: '342px'}
                    });
                    dateEntries = this.generateDateSelectionEntries(true);
                    dataEntries.push({label: this.$t('global.general.to'), key: 'to', hidden: this.$helpers.CheckDatafillKeysForHidden('selectByDay'), type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: dateEntries,
                            selectMultiple: false,
                            selectedItems: [dateEntries[dateEntries.length-1]],
                            selectedItem: dateEntries[dateEntries.length-1],
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: '',
                        }, styles: {width: '342px'}
                    });
                }

                view.$helpers.OpenPopup({
                    elRelative: $event.currentTarget,
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: description,
                        selectCallback: function (data) {
                            let requests = [];
                            let spots = data.spots;
                            if(!data.selectByDay){
                                Object.keys(data).forEach(k => {
                                    if(data[k] == true){
                                        let map = view.shiftsWeeklyMap.weekEntries;

                                        if(view.dayMode){
                                            map = view.shiftsWeeklyMap.dayEntries;
                                        }
                                        if(map[k]){
                                            map[k].forEach(s => {
                                                let payload = {id: s.id, updateFields: ["pinned"], pinned: false};
                                                if(s.templateId && s.historicFrom && s.historicTo && !s.published){
                                                    payload.from = s.historicFrom;
                                                    payload.to = s.historicTo;
                                                    payload.breakFrom = s.historicBreakFrom;
                                                    payload.breakValue = s.historicBreakValue;
                                                    payload.workValue = s.historicWorkValue != null ? s.historicWorkValue : -1;
                                                    payload.updateFields = ["pinned", "from", "to", "breakFrom", "breakTo", "breakValue", "workValue"]
                                                }
                                                if(!data.selectByEmployee){
                                                    let employee = view.employeeMap[s.employeeId];
                                                    let spotId = employee ? (employee.spotId ? employee.spotId : s.spotId) : s.spotId;
                                                    if(spots.includes(spotId) && s.pinned && !s.locked){
                                                        requests.push(payload);
                                                    }
                                                } else if(data.employees.includes(s.employeeId) && s.pinned && !s.locked) {
                                                    requests.push(payload);
                                                }


                                            })
                                        }

                                    }
                                });
                            } else {
                                Object.values(view.planShiftMap)
                                .filter(s => s.pinned && !s.locked&& view.planShiftMomentMap[s.id].fromDate >= data.from && view.planShiftMomentMap[s.id].fromDate < data.to)
                                .forEach(s => {
                                    let payload = {id: s.id, updateFields: ["pinned"], pinned: false};
                                    if(s.templateId && s.historicFrom && s.historicTo && !s.published){
                                        payload.from = s.historicFrom;
                                        payload.to = s.historicTo;
                                        payload.breakFrom = s.historicBreakFrom;
                                        payload.breakValue = s.historicBreakValue;
                                        payload.workValue = s.historicWorkValue != null ? s.historicWorkValue : -1;
                                        payload.updateFields = ["pinned", "from", "to", "breakFrom", "breakTo", "breakValue", "workValue"]
                                    }
                                    if(!data.selectByEmployee){
                                        let employee = view.employeeMap[s.employeeId];
                                        let spotId = employee ? (employee.spotId ? employee.spotId : s.spotId) : s.spotId;
                                        if(spots.includes(spotId) && s.pinned && !s.locked){
                                            requests.push(payload);
                                        }
                                    } else if(data.employees.includes(s.employeeId) && s.pinned && !s.locked) {
                                        requests.push(payload);
                                    }
                                })
                            }

                            view.UnpinShifts(requests);
                        }
                    },
                    header: this.$t('roster.comp.unpinShift'),
                    expanded: true,
                    centered: true
                });
            },

            PinShifts(requests) {
                let view = this;
                if(!requests || requests.length == 0) return;
                let url = '/api/sec/planshift/multi';
                let params = {
                    storeId: view.$store.state.storeId
                }
                let payload = {
                    storeId: view.$store.state.storeId,
                    requests: requests,
                }

                view.axios({
                    method: 'put',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+view.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    view.shiftsSelected = [];

                    let payload = [];
                    Object.values(view.planShiftMap).filter(s => response.data.data.find(r => r === s.id)).forEach(s => {s.pinned = true; let x = {mapName : 'planShiftMap', entity: s }; payload.push(x) });
                    view.$store.commit("updateMultiple",payload);

                    view.$forceUpdate();
                    view.$helpers.success(view.$t('global.notifications.success'), view.$t('roster.view.shiftsPinned'));
                }).catch(function (error) {

                    console.log(error);
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.pinShiftsError'));
                });

            },
            UnpinShifts(requests) {
                let view = this;
                if(!requests || requests.length == 0) return;
                let url = '/api/sec/planshift/multi';
                let params = {
                    storeId: view.$store.state.storeId
                }
                let payload = {
                    storeId: view.$store.state.storeId,
                    requests: requests,
                }

                view.axios({
                    method: 'put',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+view.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    view.shiftsSelected = [];

                    let payload = [];
                    Object.values(view.planShiftMap).filter(s => response.data.data.find(r => r === s.id)).forEach(s =>
                    {
                        s.pinned = false;
                        if(s.templateId && !s.published){
                            s.from = s.historicFrom;
                            s.to = s.historicTo;
                            s.breakFrom = s.historicBreakFrom;
                            s.breakValue = s.historicBreakValue;
                            s.workValue = s.historicWorkValue != null ? s.historicWorkValue : -1;
                        }

                        let x = {mapName : 'planShiftMap', entity: s };
                        payload.push(x)

                    });
                    view.$store.commit("updateMultiple",payload);

                    view.$forceUpdate();
                    view.$helpers.success(view.$t('global.notifications.success'), view.$t('roster.view.shiftsPinned'));
                }).catch(function (error) {

                    console.log(error);
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.pinShiftsError'));
                });

            },
            ClearShifts(requests) {
                let view = this;
                if(!requests || requests.length == 0) return;
                let url = '/api/sec/planshift/assign/multi';
                let params = {
                    storeId: view.$store.state.storeId
                }
                let payload = {
                    storeId: view.$store.state.storeId,
                    requests: requests,
                }

                view.axios({
                    method: 'put',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+view.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    view.shiftsSelected = [];


                    response.data.data.forEach(id => view.removeShiftFromEmployee(id));

                    let payload = [];
                    Object.values(view.planShiftMap).filter(s => response.data.data.find(r => r === s.id)).forEach(s => {s.employeeId = null; s.pinned = false; let x = {mapName : 'planShiftMap', entity: s }; payload.push(x) });
                    view.$store.commit("updateMultiple",payload);
                    if(view.dayMode){
                        view.$rosterhelper.calculateShiftTimeByHourMapDelta(
                            view.shiftTimeByHourMap,
                            [view.dayModeDate.format('YYYY-MM-DD')],
                            [],
                            view.planShiftDateMap, view.actualShiftDateMap,
                            view.planShiftMap, view.planShiftMomentMap,
                            view.actualShiftMap, view.actualShiftMomentMap,
                            view.actualBreakMap, view.actualBreakMomentMap,
                            view.actualBreakShiftIdMap,
                            view.employeeMap,
                            view.spotMap, view.$helpers);
                    }
                    if (view.rosterSortState.showShiftSpots) {
                        view.updateSpots();
                        view.sortEmployeeGroups();
                        view.RefreshRosterContentMap();
                    }


                    view.$forceUpdate();
                    view.$helpers.success(view.$t('global.notifications.success'), view.$t('roster.view.removedEmployeesFromShifts'));
                }).catch(function (error) {

                    console.log(error);
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.removeEmployeesError'));
                });

            },
            PublishShifts(ids, autoSaveBackup = false){
                let view = this;
                if(!view.allowFutureAssignment){
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.shiftPlanningDeactivated'));
                    return;
                }
                if(!ids || ids.length == 0) return;
                let affectedEmployees = new Set();
                let shifts = [];
                ids.forEach((id) => {
                    if(view.planShiftMap[id] && view.planShiftMap[id].employeeId != null)
                    affectedEmployees.add(view.planShiftMap[id].employeeId);

                });
                if(this.storeSettings.strictlyLawAbiding && !this.CheckLegallyPublishable(ids) && !this.CheckIgnoreLaw()){
                    window.app.popupalerts.push(
                    {
                        header: this.$t('roster.view.lawViolated'),
                        description: this.$t('roster.view.lawViolatedWarn'),
                        hidden: false,
                        callbackAccept: function(popup){
                            popup.hidden = true;
                        }
                    });
                    return;
                } else if(this.storeSettings.regularWorkTimeLimit > -1){
                    let employeesWithTooMuchWorktime = [];
                    affectedEmployees.forEach(employeeId => {
                        if(this.employeePlannedActual[employeeId]){
                            let workTimeRegular = view.employeePlannedActual[employeeId].unmodifiedPlannedWorkTime;
                            let maxOvertime = workTimeRegular * (view.storeSettings.regularWorkTimeLimit /100);

                            let delta = (view.employeePlannedActual[employeeId].sumWorkTimeUnproduktiv + view.employeePlannedActual[employeeId].sumWorkTimeProduktiv)
                                    - (view.employeePlannedActual[employeeId].unmodifiedPlannedWorkTime - view.employeePlannedActual[employeeId].unmodifiedDeltaWorkTime);

                            if(delta > maxOvertime){
                                employeesWithTooMuchWorktime.push(employeeId);
                            }
                        }


                    })
                    if(employeesWithTooMuchWorktime.length > 0){
                        let description  = "";

                        description += this.$t('roster.view.violationEmp1', [this.storeSettings.regularWorkTimeLimit])
                        description += "<ul >";
                        employeesWithTooMuchWorktime.forEach(employeeId => {
                            description +="<li><b>"+view.employeeMap[employeeId].lastName+"</b> "+view.employeeMap[employeeId].firstName+"</li>";
                        })
                        description += "</ul>";


                        let dataEntries = [];


                        view.$helpers.OpenPopup({
                            type: 'datafill',
                            componentState: {
                                entries: dataEntries,
                                description: description,
                                positiveButtonLabel: this.$t('global.ui.approve'),
                                selectCallback: function (data) {


                                },

                            },
                            header: this.$t('global.ui.warning') + this.$t('roster.view.tooPlusHours'),
                            expanded: true,
                            width: "700px",
                            centered: true
                        });

                        return;
                    }
                }
                let url = '/api/sec/planshift/publish/multi';

                let params = {
                    storeId: view.$store.state.storeId
                }
                let payload = {
                    storeId: view.$store.state.storeId,
                    ids: ids,
                }
                view.axios({
                    method: 'put',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+view.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    view.shiftsSelected = [];

                    let payload = [];
                    let publishDate = view.$helpers.getMomentTZ().format();
                    Object.values(view.planShiftMap).filter(s => response.data.data.find(r => r === s.id)).forEach(s => {s.published = true;  s.publishDate = publishDate; let x = {mapName : 'planShiftMap', entity: s }; payload.push(x) });
                    view.$store.commit("updateMultiple",payload);

                    let publishedShiftsForNotifications = [];
                    let publishedShiftsForMZ = [];
                    Object.values(window.roster.planShiftMap).filter(s => response.data.data.find(r => r === s.id)).forEach((s) => {
                        view.$set(view.customPlanShiftMap[s.id], 'published', true)
                        publishedShiftsForNotifications.push(s);
                        publishedShiftsForMZ.push(s.id);
                    });

                    view.planshifts.filter(s => response.data.data.find(r => r === s.id)).forEach(s => {s.published = true;  s.publishDate = publishDate;});
                    view.$forceUpdate();
                    view.$helpers.success(view.$t('global.notifications.success'), view.$t('roster.view.shiftsPublished'));
                    view.PublishToMP(false);
                    view.DoEmployeeMissingExternalIdCheck();


                    if(autoSaveBackup){
                        VueEventBus.$emit('autosaveRosterBackup', {});
                    }
                    console.log('SHIFTS PUBLISHED - showing notification modal');
                    view.showShiftsNotificationModal(publishedShiftsForNotifications);
                }).catch(function (error) {
                    view.shiftsSelected = [];
                    if(error.response.data != null && error.response.data.data != null && error.response.data.data.cause == 'Server is currently in maintenance Mode!'){
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.maintenanceError'));
                    } else {
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.publicationFailed'));
                    }
                });

            },
            PublishShiftsToMZ(ids, modal = true){
                let view = this;
                if(!ids || ids.length == 0) return;
                let url = '/api/sec/planshift/publish/mz';

                let params = {
                    storeId: view.$store.state.storeId
                }
                let payload = {
                    storeId: view.$store.state.storeId,
                    ids: ids,
                }
                view.axios({
                    method: 'put',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+view.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    view.shiftsSelected = [];



                    view.$helpers.success(view.$t('global.notifications.success'), view.$t('roster.view.shiftsPublishedMz'));
                    if(modal){
                        console.log('SHIFTS PUBLISHED - showing notification modal');
                        view.modalPublishshiftsNotification = true;
                    }

                }).catch(function (error) {
                    view.shiftsSelected = [];
                    if(error.response.data != null && error.response.data.data != null && error.response.data.data.cause == 'Server is currently in maintenance Mode!'){
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.maintenanceError'));
                    } else {
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.publishShiftsMzError'));
                    }

                });

            },
            UnpublishShiftsToMZ(ids){
                let view = this;
                if(!ids || ids.length == 0) return;
                let url = '/api/sec/planshift/unpublish/mz';

                let params = {
                    storeId: view.$store.state.storeId
                }
                let payload = {
                    storeId: view.$store.state.storeId,
                    ids: ids,
                }
                view.axios({
                    method: 'put',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+view.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    view.shiftsSelected = [];
                    view.$helpers.success(view.$t('global.notifications.success'), view.$t('roster.view.unpublishShift'));

                }).catch(function (error) {
                    view.shiftsSelected = [];
                    if(error.response.data != null && error.response.data.data != null && error.response.data.data.cause == 'Server is currently in maintenance Mode!'){
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.maintenanceError'));
                    } else {
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.unpublishShiftError'));
                    }
                });

            },
            SynchShiftsFromMZ(dateFrom, dateTo){
                let view = this;

                let url = '/api/sec/mzshiftsync/do';

                let params = {
                    storeId: view.$store.state.storeId,
                    from: dateFrom.format(),
                    to: dateTo.format(),
                }

                view.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer "+view.$store.state.jwt
                    },
                    url: url,
                    params: params
                }).then(response => {
                    view.$store.commit("invalidateState", {states: ['actualShiftMapState', 'actualBreakMapState']});
                    view.$helpers.success(view.$t('global.notifications.success'), view.$t('roster.view.syncedFromMz'));
                    view.refresh();
                }).catch(function (error) {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.syncedFromMzError'));
                });

            },

            UnpublishShifts(ids){
                let view = this;
                if(!ids || ids.length == 0) return;
                let url = '/api/sec/planshift/unpublish/multi';

                let params = {
                    storeId: view.$store.state.storeId,
                }

                let payload = {
                    storeId: view.$store.state.storeId,
                    ids: ids,
                }
                view.axios({
                    method: 'put',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+view.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    view.shiftsSelected = [];

                    let payload = [];
                    let unpublishedShiftsForMZ = [];
                    let unpublishedShiftsForNotifications = [];
                    Object.values(view.planShiftMap).filter(s => response.data.data.find(r => r === s.id)).forEach(s => {
                        s.published = false;
                        s.status = null;
                        unpublishedShiftsForMZ.push(s.id);
                        unpublishedShiftsForNotifications.push(s);
                        if(!s.pinned){
                            if(s.historicFrom != null){
                                s.from = s.historicFrom;
                            }
                            if(s.historicTo != null){
                                s.to = s.historicTo;
                            }
                            if(s.templateId != null){
                                s.breakFrom = s.historicBreakFrom
                            }
                            if(s.historicBreakValue != null){
                                s.breakValue = s.historicBreakValue
                            }
                            if(s.historicWorkValue != null){
                                s.workValue = s.historicWorkValue;
                            }
                        }

                        let x = {mapName : 'planShiftMap', entity: s };
                        payload.push(x)
                    });
                    view.$store.commit("updateMultiple",payload);

                    Object.values(view.planShiftMap).filter(s => response.data.data.find(r => r === s.id)).forEach(s => {
                        view.$set(view.customPlanShiftMap[s.id], 'published', false);
                        view.$set(view.customPlanShiftMap[s.id], 'status', null);
                        if(!s.pinned){
                            if(view.customPlanShiftMap[s.id].historicFrom != null){
                                view.$set(view.customPlanShiftMap[s.id], 'from', view.customPlanShiftMap[s.id].historicFrom);
                            }
                            if(view.customPlanShiftMap[s.id].historicTo != null){
                                view.$set(view.customPlanShiftMap[s.id], 'to', view.customPlanShiftMap[s.id].historicTo);
                            }
                            if(view.customPlanShiftMap[s.id].templateId != null){
                                view.$set(view.customPlanShiftMap[s.id], 'breakFrom', view.customPlanShiftMap[s.id].historicBreakFrom);
                            }
                            if(view.customPlanShiftMap[s.id].historicBreakValue != null){
                                view.$set(view.customPlanShiftMap[s.id], 'breakValue', view.customPlanShiftMap[s.id].historicBreakValue);
                            }
                            if(view.customPlanShiftMap[s.id].historicWorkValue != null){
                                view.$set(view.customPlanShiftMap[s.id], 'workValue', view.customPlanShiftMap[s.id].historicWorkValue);
                            }
                        }


                    });
                    view.planshifts.filter(s => response.data.data.find(r => r === s.id)).forEach(s => {
                        s.published = false;
                        s.status = null;
                        if(!s.pinned){
                            if(s.historicFrom != null){
                                s.from = s.historicFrom;
                            }
                            if(s.historicTo != null){
                                s.to = s.historicTo;
                            }
                            if(s.templateId != null){
                                s.breakFrom = s.historicBreakFrom
                            }
                            if(s.historicBreakValue != null){
                                s.breakValue = s.historicBreakValue
                            }
                            if(s.historicWorkValue != null){
                                s.workValue = s.historicWorkValue
                            }
                        }

                    });

                    Object.values(view.shiftStatusLogMap).filter(log => response.data.data.find(r => r === log.shiftId)).forEach(log => {
                      delete view.shiftStatusLogMap[log.id];
                    });
                    this.$store.commit("setShiftStatusLogMap", {shiftStatusLogMap: view.shiftStatusLogMap});

                    view.$forceUpdate();
                    view.$helpers.success(view.$t('global.notifications.success'), view.$t('roster.view.unpublished'));
                    view.showShiftsNotificationModal(unpublishedShiftsForNotifications);

                    view.PublishToMP(false);
                }).catch(function (error) {
                    view.shiftsSelected = [];
                    if(error.response.data != null && error.response.data.data != null && error.response.data.data.cause == 'Server is currently in maintenance Mode!'){
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.maintenanceError'));
                    } else {
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.revokePublicationError'));
                    }
                });

            },
            loadPushTokens(employees){
                console.log('loading pushtokens for employees');
                let view = this;
                let url = '/api/sec/user/devicetoken';
                url = view.$helpers.appendParam("storeId", view.$store.state.storeId, url, '/api/sec/user/devicetoken');
                let ids = [];
                employees.forEach((e) => {
                    if(e.accountId != null && e.accountId != undefined){
                        ids.push(e.accountId);
                    }
                });
                let payload = {
                    "ids": ids
                };
                return view.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer "+view.$store.state.jwt
                    },
                    url: url,
                    data: payload
                });
            },

            /*
             * NOTE: Some information how the showShiftsNotificationModal() function behaves.
             *
             * This method creates some lists for processing:
             *     sEmployees --> employees for which shifts were published
             *     nEmployees --> all employees from aEmployees that have a pushToken on MD Auth
             *
             *     aAllEmployees --> all employees from store that have an accountId
             *     nAllEmployees --> all employees from aAllEmployees that have a pushToken on MD Auth
             *
             * Strategies:
             *     1) sEmployees.length == 1 && nEmployees.length == 1
             *         shifts published for a single employee that has a pushToken --> offer popup to send
             *         personalized notification to this employee
             *     2) sEmployees.length == 1 && nEmployees.length == 0
             *         shifts published for a single employee that has no pushToken --> show info
             *     3) nAllEmployees.length > 1
             *         a) offer option to send notification to all employees that have a pushToken (nAllEmployees)
             *            --> show info with number of employees that can receive a push notification
             *         b) offer list with nAllEmployees (all employees that have a pushToken)
             *            --> show info with number of employees that can receive a push notification
             *
             *     if nAllEmployees.length > 0 || nEmployees.length > 0
             *         --> show Popup according to strategy
             *     else
             *         --> show Popup with info that no affected employee can receive notifications
             *
             *     --> NOTE:
             *           #1) Strategy 3.b) currently offers all employees with pushToken to be able to include those with changes
             *               that are currently not covered, in a future version that covers the missing changes too this step
             *               should only provide nEmployees (employees with changes that have a pushToken)
             *               Current strategies only cover those employees for which new shifts were published
             */
            showShiftsNotificationModal(shifts){
                console.log('Preparing notifications popup for shifts:');
                //console.log(shifts);
                let view = this;
                let shiftEmployees = [];
                let aAllEmployees = [];
                let sEmployeesWithAccountID = [];
                let allEmployees = [];
                let updatedDatesAccountIdMap = {};
                shifts.forEach((s) => {
                    let empl = view.employeeMap[s.employeeId];
                    if(empl.accountId != null && empl.accountId != undefined){
                        if(!updatedDatesAccountIdMap[empl.accountId]) updatedDatesAccountIdMap[empl.accountId] = [];
                        updatedDatesAccountIdMap[empl.accountId].push(s.from);
                    }

                    if(shiftEmployees.filter(es => es.id === empl.id).length == 0 && empl.active) shiftEmployees.push(empl);
                    if(!sEmployeesWithAccountID.includes(empl.id) && empl.active) sEmployeesWithAccountID.push(empl.id);
                });

                let emplAccMap = {};
                Object.values(view.employeeMap).filter(e => e.active).forEach((e) => {
                    if(allEmployees.filter(ea => ea.id === e.id).length == 0) allEmployees.push(e);
                    if(e.accountId != null && e.accountId != undefined){
                        if(aAllEmployees.filter(ea => ea.id === e.id).length == 0) aAllEmployees.push(e);
                        emplAccMap[e.accountId] = e;
                    }
                });

                view.loadPushTokens(aAllEmployees).then((response) => {
                    let nEmployees = [];
                    let nAllEmployees = [];
                    let allPushTokenData = response.data;
                    let accountIdsProcessed = [];
                    let pushTokenData = [];
                    // each account id can have multiple tokens (multiple devices), re-installs, invalidated device ID due to logouts or store changes, etc.
                    // push token response is ordered by the last usage date --> the first push token is the one of the device, that has been used most recently
                    // --> thats the token we want to use, ignore all other tokens for the same account id to avoid multiple notifications to the same user
                    allPushTokenData.forEach((elem) => {
                        let accId = elem.account_id;
                        if(!accountIdsProcessed.includes(accId)){
                            let token = elem.token;
                            let employee = emplAccMap[accId];
                            employee.pushToken = token;
                            if(sEmployeesWithAccountID.includes(employee.id) && nEmployees.filter(en => en.id === employee.id).length == 0){
                                nEmployees.push(employee);
                            }
                            if(nAllEmployees.filter(en => en.id === employee.id).length == 0){
                                nAllEmployees.push(employee);
                            }
                            pushTokenData.push(elem);
                            accountIdsProcessed.push(accId);
                        }
                    });
                    //console.log(shifts.length + ' shifts published for ' + sEmployees.length + ' employees :: ' + aEmployees.length + ' of them have an accountId :: ' + nEmployees.length + ' of those have a pushToken');
                    console.log('Store has a total of ' + allEmployees.length + ' employees :: ' + aAllEmployees.length + ' of them have an accountId :: ' + nAllEmployees.length + ' of those have a pushToken');
                    let description = "";
                    let dataEntries = [];

                    if(shiftEmployees.length == 1){
                        // shift(s) for single employee published
                        if(nEmployees.length == 1){
                            let empl = nEmployees[0];
                            description = this.$t('roster.view.sendRosterChangeNotification', [empl.firstName, empl.lastName]);
                        }else if(nEmployees.length == 0){
                            let empl = shiftEmployees[0];
                            description = this.$t('roster.view.noDeviceForNotification', [empl.firstName, empl.lastName]);
                        }
                    }else{
                        // shifts for multiple employees published
                        description = this.$t('roster.view.notifyWhoRosterChange');
                    }



                    if(!(nEmployees.length == 1 && shiftEmployees.length == 1) && nAllEmployees.length > 1){
                        dataEntries.push({divider: true});
                        let options = [];

                        options.push({label: this.$t('global.ui.allEmployees'), value: 1});
                        if(nEmployees.length > 0){
                            options.push({label: this.$t('roster.view.affectedEmployeesOnly'), value: 2});
                        }

                        options.push({label: this.$t('roster.view.selectedEmployees'), value: 3});

                        dataEntries.push({label: this.$t('roster.view.sendNotificationTo'), key: 'sendOption', hidden: false, type: 'dropdownsearch', value: 1,
                            dropdownSearchState: {
                                selectMultiple: false,
                                styleLight: true,
                                selectFirst: true,
                                items: options
                            },
                        });

                        let filterState = {employeeId: nEmployees.map(s => s.id)};

                        dataEntries.push({label: this.$t('global.ui.selectEmployee'), key: 'employees', hidden: true, type: 'dropdownsearch',
                            dropdownSearchState: {
                                selectMultiple: true, styleLight: true,
                                items: nAllEmployees.map(s => {
                                    return {
                                        label: s.lastName + ' ' + s.firstName,
                                        value: s.id,
                                        iconLeft: {icon: 'fa-circle', type: 'small',styleButton: {'margin-left': '-9px', 'margin-top': '1px'}, styleIcon: {color: s.color + ' !important', 'text-shadow': '0 0 1px black, 0 0 1px black, 0 0 1px black;'}},
                                        selected: filterState.employeeId.find(v => v === s.id)
                                    }
                                }),
                            },
                            computed: (datafill, lastVal, entryBeforeUpdate) => {
                                let state = datafill.entries.find(i => i.key == 'sendOption').value;

                                if(state != 3){

                                    entryBeforeUpdate.hidden = true;
                                } else {
                                    entryBeforeUpdate.hidden = false;
                                }
                                return entryBeforeUpdate;

                            },
                            filterCheck: (data) => {
                                return  filterState.employeeId.length === 0 || filterState.employeeId.find(v => v === data.employeeId)
                            }
                        });
                        //dataEntries.push({label: '', value: nEmployees.length + ' von jenen ' + sEmployees.length + ' Mitarbeitern für die Schichten veröffentlich wurden können Benachrichtigungen empfangen', type: 'output', hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('sendToAll')});
                        dataEntries.push({divider: true});
                        dataEntries.push({label: '', value: this.$t('roster.view.canReceiveNotifications', [nAllEmployees.length, allEmployees.length]), type: 'output', hidden: (shiftEmployees.length == 1 && nEmployees.length == 1 || nAllEmployees.length < 2) && this.$helpers.CheckDatafillKeysForHidden('sendToAll')});

                    }

                    if(shiftEmployees.length == 1 && nEmployees.length == 0 || nAllEmployees.length == 0 && nEmployees.length == 0){
                        dataEntries = [];
                        if(shiftEmployees.length > 1){
                            description = this.$t('roster.view.noEmployeeReceivesNotifications');
                        }
                        view.$helpers.OpenPopup({
                            elRelative: null,
                            type: 'datafill',
                            componentState: {
                                entries: dataEntries,
                                description: description,
                                selectCallback: function (data) {
                                    console.log('No notifications to no employees makes no work :-D');
                                },
                                positiveButtonLabel: $t('global.ui.ok')
                            },
                            header: this.$tc('global.general.notification'),
                            expanded: true,
                            centered: true
                        });
                    }else{
                        console.log('Showing popup');
                        view.$helpers.OpenPopup({
                            elRelative: null,
                            type: 'datafill',
                            componentState: {
                                entries: dataEntries,
                                description: description,
                                selectCallback: function (data) {
                                    if(data.sendOption == 1){
                                        view.sendShiftsPublishedNotification();
                                    } else if(data.sendOption == 2) {
                                        view.sendPublishedShiftsNotificationToEmployees(nEmployees, pushTokenData, updatedDatesAccountIdMap);
                                    }else{
                                        if(nEmployees.length == 1){
                                            view.sendPublishedShiftsNotificationToEmployees(nEmployees, pushTokenData, updatedDatesAccountIdMap);
                                        }else{
                                            if(data.employees.length > 0){
                                                let employees = [];
                                                data.employees.forEach(employeeId => employees.push(view.employeeMap[employeeId]));
                                                view.sendPublishedShiftsNotificationToEmployees(employees, pushTokenData, updatedDatesAccountIdMap);
                                            }
                                        }
                                    }
                                },
                                deleteCallback: function () {
                                    console.log('Notification popup cancelled');
                                },
                                positiveButtonLabel: this.$t('roster.view.send'),
                                negativeButtonLabel: this.$t('roster.view.dontSend')
                            },
                            header: this.$tc('global.general.notification'),
                            width: '700px',
                            expanded: true,
                            centered: true
                        });
                    }
                });
            },
            sendPublishedShiftsNotificationToEmployees(employees, pushTokenData, updatedDatesAccountIdMap = {}){
                console.log('Sending notification to employees');
                let emplAccMap = {};
                let accountIds = [];

                /*
                 * NOTE: employees includes all employees which should receive a notification, pushTokenData may contain token data for all accountIDs,
                 *       thus we throw accountIds of all receiving employees in a list to be able to check when composing the notifications below
                 */
                employees.forEach((e) => {
                    if(!accountIds.includes(e.accountId)) accountIds.push(e.accountId);
                    if(e.accountId != null && e.accountId != undefined){
                        emplAccMap[e.accountId] = e;
                    }
                });
                let view = this;
                let url = '/api/sec/externalnotification';
                url = view.$helpers.appendParam("storeId", view.$store.state.storeId, url, '/api/sec/externalnotification');
                let msg = this.$t('roster.view.updatedYourRoster', [view.$store.state.storeData.label])
                if(this.dateSelectionStart != null){
                    msg = this.$t('roster.view.updatedYourRosterFor', [view.$store.state.storeData.label, this.dateSelectionStart.format('MMMM YYYY')]);
                }

                let notifications = [];

                /*
                 * NOTE: pushTokenData is a list of {account_id: "ABCD", token: "XYZ"} objects, thus it's more convenient for composing the notifications
                 *       to iterate over pushTokenData and check back with the accountIds list if a notification should be composed and pushed to the list
                 *       for the current account/token object
                 */
                pushTokenData.forEach((elem) => {
                    let accId = elem.account_id;
                    if(accountIds.includes(accId)){
                        let token = elem.token;
                        let employee = emplAccMap[accId];
                        let payload = {
                            "title": "Hi " + employee.firstName + "!",
                            "message": msg,
                            "targetType": "token",
                            "target": token
                        };
                        if(accId in updatedDatesAccountIdMap){
                            let udates = updatedDatesAccountIdMap[accId];
                            if(udates.length < 15){
                                let pdata = {"updatedDates": udates.join(",")};
                                payload["data"] = pdata;
                            }

                        }
                        if(notifications.filter(n => n.target === token).length == 0){
                            notifications.push(payload);
                        }else{
                            console.log('Notification for ' + employee.firstName + ' ' + employee.lastName + ' already in list');
                        }

                    }
                });
                view.sendNotificationsMulti(notifications);
            },
            sendNotificationsMulti(notifications){
                let view = this;
                let url = '/api/sec/externalnotification/multi';
                url = view.$helpers.appendParam("storeId", view.$store.state.storeId, url, '/api/sec/externalnotification/multi');
                this.$helpers.log(this, 'publish multi notification', notifications, false);
                let payload = {
                    "notifications": notifications
                };
                view.axios({
                         method: 'post',
                         headers: {
                             'AUTHORIZATION': "bearer "+view.$store.state.jwt
                         },
                         url: url,
                         data: payload
                     }).then(response => {
                        view.$helpers.success(view.$t('roster.view.notificationSent'), '');
                     }).catch(function (error) {
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.sendNotificationError'));
                     });
            },
            sendShiftsPublishedNotification(){
                let view = this;
                let url = '/api/sec/externalnotification';
                url = view.$helpers.appendParam("storeId", view.$store.state.storeId, url, '/api/sec/externalnotification');
                var topic = "store_" + view.$store.state.storeId;
                var monthStr = "";
                var title = this.$t('roster.view.rosterUpdated')
                if(this.dateSelectionStart != null){
                    title = this.$t('roster.view.rosterUpdatedFor', [this.dateSelectionStart.format('MMMM YYYY')]);
                }
                if(!document.location.host.startsWith('web.meindienstplan')){
                    topic = topic + "_dev";
                }
                let payload = {
                    "title": title,
                    "message": this.$t('roster.view.updateYourRosters', [view.$store.state.storeData.label]),
                    "targetType": "topic",
                    "target": topic
                }
                this.$helpers.log(this, 'publish notification for store', view.$store.state.storeData);
                this.$helpers.log(this, 'publish shifts notification', payload, false);
                view.axios({
                         method: 'post',
                         headers: {
                             'AUTHORIZATION': "bearer "+view.$store.state.jwt
                         },
                         url: url,
                         data: payload
                     }).then(response => {
                        view.$helpers.success(view.$t('roster.view.notificationSent'), '');
                     }).catch(function (error) {
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.sendNotificationError'));
                     });
            },

            PublishToMP(modal) {
                if(this.validMpLicense){
                    VueEventBus.$emit('publishToMP', {modal: modal});
                }

            },
            GetWeather(){
                let view = this;
                view.rawWeatherData = [];
                view.weather.data = [];
                let url = '/api/sec/weather';
                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.$store.state.rosterFromTo.from,
                    to: this.$store.state.rosterFromTo.to
                };
                //url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/weather');
                //url = this.$helpers.appendParam("from", this.$store.state.rosterFromTo.from, url, '/api/sec/weather');
                //url = this.$helpers.appendParam("to", this.$store.state.rosterFromTo.to, url, '/api/sec/weather');

                this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                }).then(response => {
                    for(let x in response.data){
                                (function(data){
                                    view.rawWeatherData.push(data);
                                    let last = view.rawWeatherData[view.rawWeatherData.length - 1];
                                    last.date = view.$helpers.getActualMoment().unix(data.dt);
                                    last.dateTz =  view.$helpers.getMomentTZFromUnix(data.dt);

                                    // 3HOURLY DATA - START
                                    last.temp = Math.round(data.temp - 273.15);
                                    last.tempMin = Math.round(data.tempMin - 273.15);
                                    last.tempMax = Math.round(data.tempMax - 273.15);
                                    last.humidity = data.humidity;
                                    last.windspeed = data.windspeed;
                                    //last.pop = data.pop; //The 3hourly weather API does not return the Prob of Precipitation. But it returns the rain in millimeters. We need a workaround to calculate some kind of percentage from the mm information.
                                    last.weatherCode = view.GetWeatherCode(data.weatherId);
                                    // 3HOURLY DATA - END


                                    // DAY DATA - START
                                    last.dTemp = Math.round(data.dTemp - 273.15);
                                    last.dMinTemp = Math.round(data.dMinTemp - 273.15);
                                    last.dMaxTemp = Math.round(data.dMaxTemp - 273.15);
                                    last.dPop = data.dProbOfPrecipitation;
                                    last.dHumidity = data.dHumidity;
                                    last.dWindSpd = Math.round(data.dWindSpd * 3.6);
                                    last.dWeatherCode = view.GetWeatherCode(data.dWeatherCode);
                                    // DAY DATA - END

                                    if(last.date.date() >= view.$helpers.getMomentTZ().date() && !view.weather.data.find(d => d.date.date() === last.date.date()))
                                    {
                                        let hasDTemp = view.rawWeatherData.find(d => d.date.date() == last.date.date() && d.dTemp);
                                        if(hasDTemp) view.weather.data.push(hasDTemp);
                                        else view.weather.data.push(last);
                                    }
                                    //console.log(last.date.format('LLLL'));
                                    })(response.data[x]);

                    }
                }).catch(function (error) {
                    //TODO error handling
                })
            },

            GetWeatherCode(id){
                                switch (id){
                                    case 201: // thunderstorm with rain
                                    case 202: // thunderstorm with heavy rain
                                    case 211: // thunderstorm
                                    case 212: // heavy thunderstorm
                                    case 221: // ragged thunderstorm
                                    case 230: // thunderstorm with light drizzle
                                    case 231: // thunderstorm with drizzle
                                    case 232: // thunderstorm with heavy drizzle
                                    case 233: // thunderstorm with hail
                                        return "Thunderstorm_Rain";
                                    case 200: // thunderstorm with light rain
                                    case 210: // light thunderstorm
                                        return "Thunderstorm";


                                    case 300: // light intensity drizzle
                                    case 301: // drizzle
                                    case 302: // heavy intensity drizzle
                                    case 310: // light intensity drizzle rain
                                    case 311: // drizzle rain
                                    case 312: // heavy intensity drizzle rain
                                    case 313: // shower rain and drizzle
                                    case 314: // heavy shower rain and drizzle
                                    case 321: // shower drizzle
                                    case 520: // light intensity shower rain
                                    case 521: // shower rain
                                    case 522: // heavy intensity shower rain
                                    case 531: // ragged shower rain
                                        return "Rain_Medium";

                                    case 500: // light rain
                                    case 501: // moderate rain
                                    case 502: // heavy intensity rain
                                    case 503: // very heavy rain
                                    case 504: // extreme rain
                                        return "Sun_Rain";

                                    case 511: // freezing rain
                                        return "Snow_Rain";
                                    case 600: // light snow
                                    case 601: // Snow
                                    case 602: // Heavy snow
                                    case 610: // Mix snow/rain
                                    case 611: // Sleet
                                    case 612: // Light shower sleet
                                    case 613: // Shower sleet
                                    case 615: // Light rain and snow
                                    case 616: // Rain and snow
                                    case 620: // Light shower snow
                                    case 621: // Shower snow
                                    case 622: // Heavy shower snow
                                    case 623: // Flurries
                                        return "Snow_Medium";

                                    case 700: // mist
                                    case 701: // mist
                                    case 711: // Smoke
                                    case 721: // Haze
                                    case 731: // sand/ dust whirls
                                    case 741: // fog
                                    case 751: // sand
                                    case 761: // dust
                                    case 762: // volcanic ash
                                    case 771: // squalls
                                    case 781: // tornado
                                        return "Fog";
                                    case 800: // clear sky
                                        return "Sunny";
                                    case 801: // few clouds: 11-25%
                                        return "Little_Cloudy";
                                    case 802: // scattered clouds: 25-50%
                                        return "Cloudy_Medium";
                                    case 803: // broken clouds: 51-84%
                                    case 804: // overcast clouds: 85-100%
                                        return "Very_Cloudy";
                                    case 900: // Unknown Precipitation
                                        return this.$t('global.ui.warning');
                                    default:
                                        return this.$t('global.ui.warning');
                                }
            },

            OpenWeatherPopup($event, day, dontClose){
                if(!this.rawWeatherData.find(d => d.dateTz.format("DD-MM-YYYY") === day.format("DD-MM-YYYY"))) return;
                this.$refs.weatherpopup.Init({
                    date: day,
                    data: this.rawWeatherData.slice(),
                    elRelative: $event.currentTarget,
                    dontClose: dontClose,
                });
            },
            GetWidthFirstTitle(){
                let width = 100;
                if(this.dayModeHours === 36) width = 66.6666;
                if(this.dayModeHours === 48) width = 50;
                width += '%';
                return width;
            },
            GetWidthSecondTitle(){
                let width = 100;
                if(this.dayModeHours === 36) width = 66.6666;
                if(this.dayModeHours === 48) width = 50;
                width = 100 - width;
                width += '%';
                return width;
            },
            ShiftFixedElements($event){
                let offsetx = -1 * $event.currentTarget.scrollLeft;
                let offsety = -1 * $event.currentTarget.scrollTop;

                $(this.$el).find('.grid > .entry.header').css({
                    'margin-left': (offsetx) + 'px',
                    'width': 'calc(100% -  ' + (275 + offsetx) + 'px)',
                });
                $(this.$el).find('.entry.group > .header').css({
                    'left': (-45 - offsetx) + 'px',
                });
                $(this.$el).find('.grid .employee').css({
                    'left': (-45 - offsetx) + 'px',
                });
                $(this.$el).find('.employee-hours.interactive').css({
                    'margin-left': (-1 * offsetx) + 'px',
                    'margin-top': (-1 * offsety) + 'px',
                });
                $(this.$el).find('.employee-hours.buheader').css({
                    'margin-left': (-50 - offsetx) + 'px',
                });

                // Adjusts PersonnelDeploymentChart
                 $(this.$el).find('.pd-container > .pd-chart').css({
                    'left': (265 + offsetx) + 'px'
                });
                 // Adjusts ProductivityPopup
                $(this.$el).find('.productivity-container').css({
                    'left': (261 + offsetx) + 'px'
                });
                let container = this.$el.querySelector('.productivity-container .table-left');
                if(container){
                    container.style.setProperty('--box-shadow-offset', (offsetx));
                }

            },
            CloseWeatherPopup($event){
                if(!this.$refs.weatherpopup.dontClose) this.$refs.weatherpopup.toggled = false;
            },
            OpenFilterPopup($event){
                this.$refs.filterpopup.Init();
            },
            OpenDayPopup($event,employeeId,indexweek, index, external = false){
                if(this.dragShift != null || this.$helpers.DragOpenedCheck()){
                    return;
                }
                let day = '0000-00-00';
                let entry = this.gridWeekInfo[indexweek+'-'+index];
                if(entry){
                    day = entry.date.format('YYYY-MM-DD');
                }
                this.$refs.daypopup.Init($event.currentTarget, employeeId, day, external = false);
            },
            OpenFTAPopup(){
                console.log("Open FTA popup");
                this.$refs.fta.Init();
            },
            OpenEventHover(indexweek, index, $event){
                let events = [];
                let entry = this.gridWeekInfo[indexweek+'-'+index];
                if(entry){
                    let day = entry.date;
                    let dateKey = day.format('YYYY-MM-DD');
                    if(this.storeEventMomentMap[dateKey] && this.storeEventMomentMap[dateKey].length > 0){
                        for (let i in this.storeEventMomentMap[dateKey]) {
                            let event = this.storeEventMomentMap[dateKey][i];
                            if(event.federalHoliday){
                                let myEvent = {'name' : event.name, 'color' : "#76ac9c"};
                                events.push(myEvent);
                            }else{
                                let myEvent = {'name' : event.name, 'color' : "rgb(137, 197, 232)"};
                                events.push(myEvent);
                            }
                        }
                        this.$refs.eventhover.Init($event.currentTarget,events);
                    }
                }
            },
            CloseEventHover(){
                this.$refs.eventhover.Close();
            },
            OpenPlannedActualHover(employee, mode, $event){

                $event.stopPropagation();
                this.$refs.plannedActualhover.Init(employee, mode, $event.currentTarget);
            },
            ClosePlannedActualHover(){
                this.$refs.plannedActualhover.Close();
            },
            OpenStatisticsPopup($event, hoverOnly = true){
                $event.stopPropagation();
                this.$refs.statisticspopup.Init($event.currentTarget);
            },
            CloseStatisticsPopup(){
                this.$refs.statisticspopup.Close();
            },
            OpenUnassignedShiftSpotListPopup($event, date){
                if(this.unassignedShiftSpotListPopupDataMap[date]) {
                    this.$refs.shiftspotlistpopup.Init(this.UnassignedShiftSpotListPopupData(date), $event.currentTarget);
                }
            },
            CloseUnassignedShiftSpotListPopup(){
                this.$refs.shiftspotlistpopup.Close();
            },
            OpenAssignedShiftSpotListPopup($event, date, offsetY = 0){
                if(this.assignedShiftSpotListPopupDataMap[date]) {
                    let elRelative = $event.currentTarget;

                    this.$refs.shiftspotlistpopup.Init(this.AssignedShiftSpotListPopupData(date), elRelative, offsetY);
                }
            },
            CloseAssignedShiftSpotListPopup(){
                this.$refs.shiftspotlistpopup.Close();
            },
            UnassignedShiftSpotListPopupData(date){
                let data = this.unassignedShiftSpotListPopupDataMap[date];
                data.date = this.$helpers.extractDateStringTZ(date, "DD.MM.YYYY");
                return data;
            },
            AssignedShiftSpotListPopupData(date){
                let data = this.assignedShiftSpotListPopupDataMap[date];
                data.date = this.$helpers.extractDateStringTZ(date, "DD.MM.YYYY");
                return data;
            },
            OpenDailyRosterPopup(date, unassignedShifts = false){

                this.$refs.dailyrosterpopup.Init(date, unassignedShifts);
            },
            CloseDailyRosterPopup(){
                this.$refs.dailyrosterpopup.Close();
            },
            OpenPlannedActualPopup($event , employee){
                var xoffset = 0;
                if(this.employeeSelected != null){
                    xoffset = -230;
                }
                this.$refs.plannedActualpopup.Init(this , employee, $event.currentTarget, xoffset);
            },

            OpenBusinessUnitPopup($event) {
                let view = this;

                let dataEntries = [
                    {
                        label: view.$t('pages.employeeData.name'),
                        key: 'newBusinessUnitName',
                        hidden: false,
                        type: 'text',
                    },
                ]

                view.$helpers.OpenPopup({
                    elRelative: $event.currentTarget,
                    type: 'datafill',
                    pointerDirection: 0,
                    componentState: {
                        entries: dataEntries,
                        selectCallback: function (data) {
                            view.$rosterhelper.createBusinessUnit(data.newBusinessUnitName, view);
                        }
                    },
                    header: view.$t('roster.comp.addBusinessUnit'),
                    expanded: true
                });
            },
            GetWeatherIcon(MMDD){
                let weather = this.GetWeatherFromDateFormat(MMDD);
                if(weather){
                    let code = weather.dWeatherCode;
                    if(code === 'Warnung') code = weather.weatherCode;
                    return '../img/' + code + '.svg';
                } else {
                     return '../img/Warnung.svg';
                }


            },
            GetWeatherTemp(MMDD){
                let weather = this.GetWeatherFromDateFormat(MMDD);
                if(weather && weather.dTemp !== -273) return weather.dTemp;
                return '- ';

            },
            GetWeatherFromDateFormat(MMDD){
                return this.rawWeatherData.find(d => d.dateTz.format('MM-DD') === MMDD && !isNaN(d.dTemp) && d.dTemp > -273);
            },
            GetIndexWeekFromDate(date){
                if(!date) return -1;
                return date.week() - date.clone().date(0).week();
            },
            GetIndexDayFromDate(date){
                if(!date) return -1;
                return date.isoWeekday();
            },
            EmployeeDataScroll(){
                $('.employee-data').css('left', (-1 * $('.app .scrollbar-container .grid').scrollLeft()) + 260 + 'px');
            },
            ShiftTimeBarsBack(){
                let view = this;
                if(this.dayModeHours < 24) {
                    this.dayModeDate = this.dayModeDate.clone().add('hours', this.dayModeHours * -1);
                } else {
                    this.dayModeDate = this.dayModeDate.clone().hours(0).add(-1, 'days');
                }
                if(view.rosterVisibilityState.rosterDailyShiftTimeSort == true || view.rosterVisibilityState.rosterDailyShiftTimeSort == null) {
                    this.SortGroupEmployeesByPlanLowest(view.dayModeDate);
                } else {
                    this.SortGroupEmployeesByLastNameFirstName();
                }
                this.refreshDayMode();

            },
            ShiftTimeBarsForwards(){
                let view = this;
                if(this.dayModeHours < 24) {
                    this.dayModeDate = this.dayModeDate.clone().add('hours', this.dayModeHours);
                } else {
                    this.dayModeDate = this.dayModeDate.clone().hours(0).add(1, 'days');
                }
                if(view.rosterVisibilityState.rosterDailyShiftTimeSort == true || view.rosterVisibilityState.rosterDailyShiftTimeSort == null) {
                    this.SortGroupEmployeesByPlanLowest(view.dayModeDate);
                } else {
                    this.SortGroupEmployeesByLastNameFirstName();
                }
                this.refreshDayMode();

            },
            refreshDayMode() {
                let view = this;

                for(let x in window.timebars){
                    (function(timebar){
                        if(!timebar.eventProp.relative)
                        {
                            timebar.day = view.dayModeDate.clone();
                            timebar.timeDisplayLengthInMilliseconds = view.dayModeHours * 1000 * 60 * 60;

                            timebar.Init(timebar.day);
                        }
                    })(window.timebars[x]);
                }
            },
            ChangeTimeBarLength(){
                let view = this;
                this.dayModeDate.hour(0);
                for(let x in window.timebars){
                    (function(timebar){
                        if(!timebar.eventProp.relative)
                        {
                            timebar.timeDisplayLengthInMilliseconds = view.dayModeHours * 1000 * 60 * 60;
                            timebar.Init();
                        }
                    })(window.timebars[x]);
                }
            },
            GetEmployeeStyles(){
                let styles = {};
                return styles;

            },
            navigateToEmployee(employee){
                if(employee != null){
                    this.$router.push({ name: 'employees', params: { view: 'employeedata', selectedEmployeeId: employee.id } });
                    // re-render MenuBar to get proper nav selection
                    let menuBar = this.$parent.$parent.$refs["MenuBar"];
                    menuBar.$forceUpdate();
                }
            },
            GetTableStyles(){
                let styles = {};
                if (this.showSpotPlanningNumbers) {
                    styles["margin-top"] = "50px";
                }
                return styles;

            },
            GetExternalTableStyles(){
                let styles = {};
                return styles;

            },
            IsToday(indexweek, index){
                let date = this.dateSelectionStart.clone().add((parseInt(indexweek - 1) * 7) + parseInt(index - 1) - this.dateSelectionStart.isoWeekday(), 'day');
                return (this.$helpers.getMomentTZ().date() === date.date());
            },
            FilterSpot(spotId,option){
                console.log("FILTER");
                let spot = this.spots.items.find(i => i.id === spotId);
                //console.log(this.spots);
                //console.log(spot);

                if(this.dragging){
                    let index = this.dynamicSkillsFiltered.indexOf(spot.requiredSkill);
                    if(option){
                        //drag start -> add
                        if (index === -1){
                            this.dynamicSkillsFiltered.push(spot.requiredSkill);
                        }
                    }else{
                        //drag end -> remove
                        if (index !== -1){
                            this.dynamicSkillsFiltered.splice(index, 1);
                        }
                    }
                }else{
                    let index = this.dynamicSkillsFiltered.indexOf(spot.requiredSkill);
                    if (index === -1){
                        this.dynamicSkillsFiltered.push(spot.requiredSkill);
                    }else{
                         this.dynamicSkillsFiltered.splice(index, 1);
                    }
                }
                this.filterEmployees();
                this.$forceUpdate();

                let view = this;
                if(spot && spot.requiredSkill)
                {
                    this.spots.input = spot.label;
                    this.$forceUpdate();
                }
            },
            ToggleDayMode(indexweek, index, toggle){

                if($(window.mouse.element).closest('.income').length > 0) return;
                if($(window.mouse.element).closest('.weather').length > 0) return;

                let view = this;

                if(!indexweek){
                    this.dayMode = false;
                    if(this.rosterSortState.filterByShiftSpot != false || this.rosterSortState.showSpots != true || this.rosterSortState.showBusinessUnits != false){

                        this.rosterSortState.filterByShiftSpot = false;
                        this.rosterSortState.showSpots = true;
                        this.rosterSortState.showBusinessUnits = false;
                        this.$store.commit('setRosterSortState', {rosterSortState: this.rosterSortState});
                        this.updateSpots();
                        this.sortEmployeeGroups();

                    }
                    this.RefreshRosterContentMap();
                    this.SortGroupEmployeesByLastNameFirstName();
                    requestAnimationFrame(function(){ view.$forceUpdate() });
                    return;
                }
                let date = this.gridWeekInfo[indexweek+'-'+index].date.clone();

                view.ToggleDayModeWithDate(date, true);
                view.dayModeHours = 24;
                view.ChangeTimeBarLength();


            },
            ToggleDayModeWithDate(date, toggle){


                let view = this;


                let tempDate = date.clone().startOf("day").minutes(0).seconds(0);

                if(toggle) this.dayMode = toggle;
                else this.dayMode = !this.dayMode;


                if(!this.dayMode){
                    requestAnimationFrame(function(){ view.$forceUpdate() });
                    if(this.rosterSortState.filterByShiftSpot != false || this.rosterSortState.showSpots != true || this.rosterSortState.showBusinessUnits != false){
                        this.rosterSortState.filterByShiftSpot = false;
                        this.rosterSortState.showSpots = true;
                        this.rosterSortState.showBusinessUnits = false;
                        this.$store.commit('setRosterSortState', {rosterSortState: this.rosterSortState});

                        this.updateSpots();
                        this.sortEmployeeGroups();

                    }
                    this.RefreshRosterContentMap();
                    this.SortGroupEmployeesByLastNameFirstName();
                    return;
                }

                this.dayModeDate = tempDate;
                let dateKey = tempDate.format('YYYY-MM-DD');


                this.employeesFiltered.sort((a, b) => { return a.dayModeClasses < b.dayModeClasses ? -1 : +1});
                let group = this.employeeGroups.find(g => !g.collapsed);


                if(this.dayMode){
                    console.log("DayMode")


                    if(view.rosterVisibilityState.rosterDailyShiftTimeSort == true || view.rosterVisibilityState.rosterDailyShiftTimeSort == null) {

                        this.rosterSortState.filterByShiftSpot = false;
                        this.rosterSortState.showSpots = false;
                        this.rosterSortState.showBusinessUnits = false;
                        this.$store.commit('setRosterSortState', {rosterSortState: this.rosterSortState});

                        this.updateSpots();
                        this.sortEmployeeGroups();
                        this.RefreshRosterContentMap();
                        this.SortGroupEmployeesByPlanLowest(view.dayModeDate);


                    } else {
                        this.SortGroupEmployeesByLastNameFirstName();
                    }



                }

                this.loadPlanningIndicatorDaily(this.dayModeDate).then(response => {
                    view.planningIndicatorDaily = response.data;
                    view.planningIndicatorDaily.forEach(s => {
                        s.dateMoment = this.$helpers.getMomentFromStringUTC(s.from, 'YYYY-MM-DDTHH:mmZ');

                    });
                    view.$forceUpdate();
                }).catch(function (error) {

                })


                this.refreshDayMode();
            },
            SortGroupEmployeesByLastNameFirstName(){
                let view = this;
                for (let group in view.employeeGroups) {
                    view.employeeGroups[group].employees.sort((a, b) => {
                        return a.lastName.toLowerCase() + ' ' + a.firstName.toLowerCase() < b.lastName.toLowerCase() + ' ' + b.firstName.toLowerCase() ? -1 : +1
                    });
                }
            },
            SortGroupEmployeesByPlanLowest(date){
                let view = this;
                let dateKey = date.format('YYYY-MM-DD');
                let rosterTo = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.to);
                for (let group in view.employeeGroups) {
                    view.employeeGroups[group].employees.sort((a, b) => {
                        let dateA = rosterTo;
                        if (view.rosterContentMap[a.id][dateKey].planLow) dateA = view.rosterContentMap[a.id][dateKey].planLow;
                        let dateB = rosterTo;
                        if (view.rosterContentMap[b.id][dateKey].planLow) dateB = view.rosterContentMap[b.id][dateKey].planLow;
                        return dateA._d.getTime() < dateB._d.getTime() ? -1 : +1
                    })
                }
            },
            LoadAssignedShiftSpotListToolTipMap(dateFormat){
                if(!dateFormat){
                    this.assignedShiftSpotListPopupDataMap = {};
                    this.assignedShiftSpotListTooltipMap = {};
                    let rosterFrom = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.from);
                    let rosterTo = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.to);
                    let currentDate = rosterFrom.clone();
                    let endDate = rosterTo.clone();
                    while (currentDate < endDate) {
                        this.LoadAssignedShiftSpotListToolTipMap(currentDate.format("YYYY-MM-DD"));
                        currentDate.add(1, 'days');
                    }
                    return;
                }
                let popupData = {
                    assigned: true,
                    plannedTotal: {
                        label: this.$t('shift.template.total'),
                        value: 0
                    },
                    planned: [],
                    actualTotal: {
                        label: this.$t('shift.template.total'),
                        value: 0
                        },
                    actual: [],
                    crewvsmanagement: {
                        plannedCrew: '',
                        plannedManagement: '',
                        actualCrew: '',
                        actualManagement: '',
                    },
                    productivity: {
                        indicator: '',
                        planned: '',
                        actual: ''
                    }
                };
                let labels = [];
                let view = this;
                let shiftsPlanned = this.planShiftDateMap[dateFormat].filter(s => s.employeeId && view.employeeMap[s.employeeId] && view.employeeGroups.filter(group => ((group.spot && group.spot.id == view.employeeMap[s.employeeId].spotId) || (view.employeeMap[s.employeeId].spotId == null && !group.spot)) && group.showMajor).length > 0);
                let shiftsActual = this.actualShiftDateMap[dateFormat].filter(s => s.employeeId && view.employeeMap[s.employeeId] && view.employeeGroups.filter(group => ((group.spot && group.spot.id == view.employeeMap[s.employeeId].spotId) || (view.employeeMap[s.employeeId].spotId == null && !group.spot)) && group.showMajor).length > 0);
                //shiftsPlanned = shiftsPlanned.filter(s => !shiftsActual.find(sa => sa.employeeId === s.employeeId));
                let sumStyle = {fontSize: "14px", fontWeight: 1600, marginLeft: "10px"};
                let dateLimit = this.$helpers.getMomentFromStringTZ(dateFormat).endOf('day');
                let shiftWorkTimeEntry = view.shiftTimeByDayMap[dateFormat];

                if(shiftsPlanned.length > 0) {
                    let totalObjectPlanned = view.GetMillisecondTotalObjectFromShifts(shiftsPlanned, dateLimit);

                    let total = totalObjectPlanned.total - totalObjectPlanned.totalBreak;
                    let pre = 0;
                    if(shiftWorkTimeEntry.totalAssignedPreviousDay){
                        pre = shiftWorkTimeEntry.totalAssignedPreviousDay;
                    }
                    labels.push({
                        text: this.$t('shift.plan.plannedShifts') + ':',
                        type: 'space-content centered thick',
                        iconRight: {type: '', label: view.$helpers.GetHourMinuteFormatFromMilliseconds(total+pre, true), styleLabel: sumStyle},
                    });
                    popupData.plannedTotal = {
                        label: this.$t('shift.template.total'),
                        value: view.$helpers.GetHourMinuteFormatFromMilliseconds(total+pre, true)
                    }


                    Object.values(this.spotMap).filter(s => shiftsPlanned.find(sh => s.id === sh.spotId)).forEach(s => {
                        let spotColor = view.customSpotMap[s.id] != undefined ? view.customSpotMap[s.id].color : '#6d8d23';
                        let totalObjectPlanned = view.GetMillisecondTotalObjectFromShifts(shiftsPlanned.filter(sh => sh.spotId === s.id), dateLimit);
                        let totalAssigned = view.$helpers.GetHourMinuteFormatFromMilliseconds(totalObjectPlanned.total - totalObjectPlanned.totalBreak, true);
                        labels.push({
                            text: s.name,
                            type: 'space-content',
                            iconLeft: {
                                type: 'label-center smaller round',
                                label: shiftsPlanned.filter(sh => sh.spotId === s.id).length,
                                styleButton: {
                                    background: spotColor,
                                    color: view.GetContrastingColor(spotColor),
                                    'margin-right': '5px'
                                }
                            },
                            iconRight: {type: '', label: totalAssigned},
                        });
                        popupData.planned.push({
                            label: s.name + ' [' + shiftsPlanned.filter(sh => sh.spotId === s.id).length + ']',
                            value: totalAssigned
                        });
                    });
                    if(shiftWorkTimeEntry.totalAssignedPreviousDay) {
                        labels.push({
                            text: this.$t('roster.view.fromPreviousDay'),
                            type: 'space-content centered',
                            iconRight: {type: '', label: view.$helpers.GetHourMinuteFormatFromMilliseconds(pre, true)},
                        });
                        popupData.planned.push({
                            label: this.$t('roster.view.fromPreviousDay'),
                            value: view.$helpers.GetHourMinuteFormatFromMilliseconds(pre, true)
                        });
                    }

                    /*if(mode == 1){
                        workTimeMS = mapEntry.totalAssigned + mapEntry.totalAssignedPreviousDay;
                    } else if(mode == 2){
                        workTimeMS = mapEntry.totalActual + mapEntry.totalActualPreviousDay
                    }
                    if(!this.rosterVisibilityState.visibilityProductivityIncludeMgmt){
                        if(mode == 1){
                            workTimeMS = mapEntry.totalAssignedCrewOnly + mapEntry.totalAssignedPreviousDayCrewOnly;
                        } else if(mode == 2){
                            workTimeMS = mapEntry.totalActualCrewOnly + mapEntry.totalActualPreviousDayCrewOnly;
                        }
                    } */
                } else {

                    if(view.shiftTimeByDayMap[dateFormat].totalAssignedPreviousDay) {
                        let pre = view.shiftTimeByDayMap[dateFormat].totalAssignedPreviousDay;

                        labels.push({
                            text: this.$t('shift.plan.plannedShifts') + ':',
                            type: 'space-content centered thick',
                            iconRight: {type: '', label: view.$helpers.GetHourMinuteFormatFromMilliseconds(pre, true), styleLabel: sumStyle},
                        });

                        popupData.plannedTotal = {
                            label: this.$t('shift.template.total'),
                            value: view.$helpers.GetHourMinuteFormatFromMilliseconds(pre, true)
                        }

                        labels.push({
                            text: this.$t('roster.view.fromPreviousDay'),
                            type: 'space-content centered',
                            iconRight: {type: '', label: view.$helpers.GetHourMinuteFormatFromMilliseconds(pre, true)},
                        });

                        popupData.planned.push({
                            label: this.$t('roster.view.fromPreviousDay'),
                            value: view.$helpers.GetHourMinuteFormatFromMilliseconds(pre, true)
                        });


                    }
                }
                if(shiftsActual.length > 0) {
                    let totalObjectActual = view.GetMillisecondTotalObjectFromShifts(shiftsActual, dateLimit);

                    let total = totalObjectActual.total - totalObjectActual.totalBreak;
                    let pre = 0;
                    if(view.shiftTimeByDayMap[dateFormat].totalActualPreviousDay){
                        pre = view.shiftTimeByDayMap[dateFormat].totalActualPreviousDay;
                    }
                    labels.push({
                        text: this.$t('shift.plan.punchTimes') + ':',
                        type: 'space-content centered thick',
                        iconRight: {type: 'thick', label: view.$helpers.GetHourMinuteFormatFromMilliseconds(total+pre, true), styleLabel: sumStyle},
                    });

                    popupData.actualTotal = {
                        label: this.$t('shift.template.total'),
                        value: view.$helpers.GetHourMinuteFormatFromMilliseconds(total+pre, true)
                    }

                    labels.push({
                        text: this.$t('roster.view.punchTime'),
                        type: 'space-content',
                        iconLeft: {
                            type: 'label-center smaller round',
                            label: shiftsActual.length,
                            styleButton: {
                                background: '#e9a66c',
                                color: view.GetContrastingColor('#e9a66c'),
                                'margin-right': '5px'
                            }
                        },
                        iconRight: {type: '', label: view.$helpers.GetHourMinuteFormatFromMilliseconds(total, true)},
                    });

                    popupData.actual.push({
                        label: this.$t('shift.plan.punchTimes') + ' [' + shiftsActual.length + ']',
                        value: view.$helpers.GetHourMinuteFormatFromMilliseconds(total, true)
                    });

                    if(pre > 0) {
                        labels.push({
                            text: this.$t('roster.view.fromPreviousDay'),
                            type: 'space-content centered',
                            iconRight: {type: '', label: view.$helpers.GetHourMinuteFormatFromMilliseconds(pre, true)},
                        });

                        popupData.actual.push({
                            label: this.$t('roster.view.fromPreviousDay'),
                            value: view.$helpers.GetHourMinuteFormatFromMilliseconds(pre, true)
                        });
                    }
                } else {
                    if(view.$helpers.GetHourMinuteFormatFromMilliseconds(view.shiftTimeByDayMap[dateFormat].totalActualPreviousDay, true)){
                        let pre = view.shiftTimeByDayMap[dateFormat].totalActualPreviousDay;
                        labels.push({
                            text: this.$t('shift.plan.punchTimes') + ':',
                            type: 'space-content centered thick',
                            iconRight: {type: 'thick', label: view.$helpers.GetHourMinuteFormatFromMilliseconds(pre, true), styleLabel: sumStyle},
                        });

                        popupData.actualTotal = {
                            label: this.$t('shift.template.total'),
                            value: view.$helpers.GetHourMinuteFormatFromMilliseconds(pre, true)
                        }

                        labels.push({
                            text: this.$t('roster.view.fromPreviousDay'),
                            type: 'space-content centered',
                            iconRight: {type: '', label: view.$helpers.GetHourMinuteFormatFromMilliseconds(pre, true)},
                        });

                        popupData.actual.push({
                            label: this.$t('roster.view.fromPreviousDay'),
                            value: view.$helpers.GetHourMinuteFormatFromMilliseconds(pre, true)
                        });
                    }
                }
                if(shiftWorkTimeEntry){
                    let plannedCrew = shiftWorkTimeEntry.totalAssignedCrewOnly + shiftWorkTimeEntry.totalAssignedPreviousDayCrewOnly;
                    let plannedMgmt = (shiftWorkTimeEntry.totalAssigned + shiftWorkTimeEntry.totalAssignedPreviousDay) - plannedCrew;

                    let actualCrew = shiftWorkTimeEntry.totalActualCrewOnly + shiftWorkTimeEntry.totalActualPreviousDayCrewOnly;
                    let actualMgmt = (shiftWorkTimeEntry.totalActual + shiftWorkTimeEntry.totalActualPreviousDay) - actualCrew;


                    popupData.crewvsmanagement.plannedCrew = view.$helpers.GetHourMinuteFormatFromMilliseconds(plannedCrew, true);
                    popupData.crewvsmanagement.plannedManagement = view.$helpers.GetHourMinuteFormatFromMilliseconds(plannedMgmt, true);
                    popupData.crewvsmanagement.actualCrew = view.$helpers.GetHourMinuteFormatFromMilliseconds(actualCrew, true);
                    popupData.crewvsmanagement.actualManagement = view.$helpers.GetHourMinuteFormatFromMilliseconds(actualMgmt, true);
                }

                //productivity
                if(this.displayIndicatorType && this.planningIndicatorTypeMap[this.displayIndicatorType]){
                    let name = this.planningIndicatorTypeMap[this.displayIndicatorType].name;
                    labels.push({
                        text: this.$t('roster.view.productivity') + ':',
                        type: 'space-content centered thick',
                        iconRight: {type: 'thick', label: name, styleLabel: sumStyle},
                    });

                    labels.push({
                        text: this.$t('roster.view.plan'),
                        type: 'space-content centered',
                        iconRight: {type: '', label: view.GetProductivityForDate(dateFormat, 1)},
                    });
                    labels.push({
                        text: this.$t('workBalance.summary.actual'),
                        type: 'space-content centered',
                        iconRight: {type: '', label: view.GetProductivityForDate(dateFormat, 2)},
                    });

                    popupData.productivity.indicator = name;
                    popupData.productivity.planned = view.GetProductivityForDate(dateFormat, 1);
                    popupData.productivity.actual = view.GetProductivityForDate(dateFormat, 2);
                }

                this.assignedShiftSpotListPopupDataMap[dateFormat] = popupData;

                this.assignedShiftSpotListTooltipMap[dateFormat] = labels;
            },
            UnnassignedShiftTooltipWrapper(dateFormat){
                let view = this;
                return () => {
                    return {
                        components: [{
                            type: 'listlabel',
                            state: {labels: view.unassignedShiftSpotListTooltipMap[dateFormat] ? view.unassignedShiftSpotListTooltipMap[dateFormat] : []},
                            pinTopRight: true,
                        }],
                    };
                };
            },
            AssignedShiftTooltipWrapper(dateFormat){
                let view = this;
                return () => {
                    return {
                        components: [{
                            type: 'listlabel',
                            state: {labels: view.assignedShiftSpotListTooltipMap[dateFormat] ? view.assignedShiftSpotListTooltipMap[dateFormat] : []},
                            pinTopRight: true,
                        }],
                    };
                };
            },
            LoadUnassignedShiftSpotListToolTipMap(dateFormat){
                if(!dateFormat){
                    this.unassignedShiftSpotListTooltipMap = {};
                    let rosterFrom = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.from);
                    let rosterTo = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.to);
                    let currentDate = rosterFrom.clone();
                    let endDate = rosterTo.clone();
                    while (currentDate < endDate) {
                        this.LoadUnassignedShiftSpotListToolTipMap(currentDate.format("YYYY-MM-DD"));
                        currentDate.add(1, 'days');
                    }
                    return;
                }

                let labels = [];
                let popupData = {
                    assigned: false,
                    unassignedTotal: {
                        label: this.$t('shift.template.total'),
                        value: 0
                    },
                    unassigned: []
                };
                let total = 0
                let allShifts = [];
                let view = this;
                let shifts = this.GetUnassignedShiftsByDate(dateFormat);
                Object.values(this.spotMap).filter(s => shifts.find(sh => s.id === sh.spotId)).forEach(s => {
                    let spotColor = view.customSpotMap[s.id] != undefined? view.customSpotMap[s.id].color : '#6d8d23';
                    let totalObject = view.GetMillisecondTotalObjectFromShifts(shifts.filter(sh => sh.spotId === s.id));
                    /* labels.push({
                        text: s.name,
                        type: 'space-content',
                        iconLeft: {type: 'label-center smaller round', label: shifts.filter(sh => sh.spotId === s.id).length, styleButton: {background: spotColor, color: view.GetContrastingColor(spotColor), 'margin-right': '5px'}},
                        iconRight: {type: '', label: view.$helpers.GetHourMinuteFormatFromMilliseconds(totalObject.total - totalObject.totalBreak, true)},
                    }); */
                    popupData.unassigned.push({
                        bold: true,
                        label: s.name + ' [' + shifts.filter(sh => sh.spotId === s.id).length + ']',
                        value: view.$helpers.GetHourMinuteFormatFromMilliseconds(totalObject.total - totalObject.totalBreak, true)
                    });
                    total += (totalObject.total - totalObject.totalBreak);

                    shifts.filter(sh => sh.spotId === s.id).forEach((shift) => {
                        let tObj = view.GetMillisecondTotalObjectFromShifts([shift]);
                        let valueTxt = view.$helpers.GetHourMinuteFormatFromMilliseconds(tObj.total - tObj.totalBreak, true);
                        let fromtxt = view.$helpers.formatDateStringTZ(shift.from, 'HH:mm');
                        let totxt = view.$helpers.formatDateStringTZ(shift.to, 'HH:mm');
                        let fromtotxt = fromtxt + "-" + totxt;
                        labels.push({
                            label: fromtotxt,
                            type: 'space-content',
                            iconLeft: {type: 'label-center smaller round', label: shifts.filter(sh => sh.spotId === s.id).length, styleButton: {background: spotColor, color: view.GetContrastingColor(spotColor), 'margin-right': '5px'}},
                            iconRight: {type: '', label: valueTxt},
                        });
                        popupData.unassigned.push({
                            bold: false,
                            label: fromtotxt,
                            value: valueTxt
                        });
                    });
                });
                popupData.unassignedTotal.value = view.$helpers.GetHourMinuteFormatFromMilliseconds(total, true);
                this.unassignedShiftSpotListPopupDataMap[dateFormat] = popupData;

                this.unassignedShiftSpotListTooltipMap[dateFormat] = labels;
            },



            GetDayUnassignedShifts(indexweek, index){
                let entry = this.gridWeekInfo[indexweek+'-'+index];
                if(entry){
                    let day = entry.date;
                    return this.GetUnassignedShiftsByDate(day.format('YYYY-MM-DD'));
                } else {
                    return [];
                }

            },



            /**
             * return: boolean
             */
            HasEventsOnThatDay(indexweek, index){
                let entry = this.gridWeekInfo[indexweek+'-'+index];
                if(entry){
                    let day = entry.date;
                    let dateKey = day.format('YYYY-MM-DD');
                    return this.storeEventMomentMap[dateKey] && this.storeEventMomentMap[dateKey].length > 0;
                    /*if(this.customHolidayMap[day.format('YYYY-MM-DD')] != undefined && this.customHolidayMap[day.format('YYYY-MM-DD')] != null){
                        return (this.customHolidayMap[day.format('YYYY-MM-DD')].length > 0) ? true : false;
                    }*/
                }
                return false;
            },
            HasHolidayEventsOnThatDay(indexweek, index){
                let entry = this.gridWeekInfo[indexweek+'-'+index];
                if(entry){
                    let day = entry.date;
                    let dateKey = day.format('YYYY-MM-DD');
                    let events = this.storeEventMomentMap[dateKey]? this.storeEventMomentMap[dateKey] : [];
                    if(events.length > 0){
                        let result = false;
                        events.forEach((e) => {
                            if(e.federalHoliday) result = true;
                        });
                        return result;
                    }
                }
                return false;
            },

            GetEventsColor(indexweek, index){
                let styles = {};
                let color = "rgb(255, 255, 255)";

                let entry = this.gridWeekInfo[indexweek+'-'+index];
                if(entry){
                    let day = entry.date;
                    let dateKey = entry.dateString;
                    if(this.storeEventMomentMap[dateKey] && this.storeEventMomentMap[dateKey].length > 0){
                        color = "rgb(137, 197, 232)";
                        styles["left"] = '';
                        let event = this.storeEventMomentMap[dateKey][0];
                        if(event.federalHoliday) {
                            color = "var(--col-holiday-bg)";
                            styles["left"] = 'calc(100% - 5px)';
                            //color = this.storeEventMap[event.id].color;
                        }
                    }
                }
                styles["color"] = color;
                return styles;
            },




            GetTimeBarProp(employee, dateStart, relative, startTime)
            {

                let eventProp = {
                    day: dateStart.clone(),
                    employee: employee,
                    relative: relative,
                    timeDisplayLengthInMilliseconds: this.dayModeHours * 1000 * 3600,
                };

                return eventProp;
            },
            GetTimeBarShiftProp(dateStart, shift)
            {

                let date = dateStart.clone();
                let eventProp = {
                    hideBar: true,
                    rota: {show: false, id: null, start: date.format('x'), startDate: date, end: date.clone().add(8, 'hours').format('x'), endDate: date.clone().add(8, 'hours')},
                    workHours: {id: -1, start: date.clone().add(-2, 'hours').format('x'), startDate: date.clone().add(-2, 'hours'), end: date.clone().add(12, 'hours').format('x'), endDate: date.clone().add(12, 'hours')},
                    //desired: {id: -1, start: date.clone().add(0, 'hours').format('x'), startDate: date.clone().add(0, 'hours'), end: date.clone().add(8, 'hours').format('x'), endDate: date.clone().add(8, 'hours')},
                    shifts: [],
                    timeFrames: [],
                    info: [],
                    errors: [],
                    warnings: [],
                    relative: true,
                    day: dateStart.clone(),
                    isShift: true,
                };
                if(shift)
                {
                    eventProp.timeFrames = [{classes: 'shift', show: shift, id: -1, start: shift.fromDate.format('x'), startDate: shift.fromDate, end: shift.toDate.format('x'), endDate: shift.toDate, shift: shift}];
                    eventProp.rota = {show: shift, id: null, start: shift.fromDate.format('x'), startDate: shift.fromDate, end: shift.toDate.format('x'), endDate: shift.toDate};
                    eventProp.info.push({label: 'Shift', data: shift.fromDate.format('HH:mm') + ' - ' +  shift.toDate.format('HH:mm')});
                    eventProp.info.push({label: 'Skill:', data: shift.spotId ? this.customSpotMap[shift.spotId].unitName : '', half: true});
                    eventProp.info.push({label: 'Spot:', data: shift.spotId ? this.customSpotMap[shift.spotId].name : '', half: true});
                    eventProp.day = shift.fromDate.clone().hours(0).minutes(0);
                }
                return eventProp;
            },
            GetProfilePictureUrl(employee){
                if(this.anonMode || !employee || !employee.employeePicture || !employee.employeePicture.server) return 'var(--contrast-1) no-repeat center/cover  url(../img/default.jpg)';
                return 'var(--contrast-1) no-repeat center/cover  url(' + employee.employeePicture.server + '/api/file?id='+ employee.employeePicture.fileId +'&accessToken='+employee.employeePicture.accessToken +"&thumb=small"+ '&time='+this.imgCacheTimestamp+')';
            },
            GetProfilePictureUrlNoBackground(employee){
                if(this.anonMode || !employee || !employee.employeePicture || !employee.employeePicture.server) return '../img/default.jpg';
                return employee.employeePicture.server + '/api/file?id='+ employee.employeePicture.fileId +'&accessToken='+employee.employeePicture.accessToken +"&thumb=small"+ '&time='+this.imgCacheTimestamp;
            },
            GetDayAvailability(employee, dayOfWeek)
            {
                if(!this.employeeMap[employee.id] || !this.employeePreferenceAvailabilityMap[employee.id].availabilities) return false;
                let available = this.employeePreferenceAvailabilityMap[employee.id].availabilities[2];
                let unavailable = this.employeePreferenceAvailabilityMap[employee.id].availabilities[1];
                let result = false;
                if(available && available.map(a => a.weekDays).reduce((a, b) => a.concat(b), []).find(w => w === dayOfWeek)) result = true;
                if(unavailable && !unavailable.map(a => a.weekDays).reduce((a, b) => a.concat(b), []).find(w => w === dayOfWeek)) result = true;
                return result;
            },
            HasSkill(employee, skill)
            {
                return skill && this.employeeMap[employee.id] && this.employeeEmployeeSkillMap[employee.id] && this.employeeEmployeeSkillMap[employee.id].find(s => s.skillId === skill.id)
            },
            HasSkillById(employeeId, skillId)
            {
                return this.employeeMap[employeeId] && this.employeeEmployeeSkillMap[employeeId] && this.employeeEmployeeSkillMap[employeeId].find(s => s.skillId === skillId)
            },
            HasSkillByName(employeeId, name)
            {
                let view = this;
                return this.employeeMap[employeeId] && this.employeeEmployeeSkillMap[employeeId] && this.employeeEmployeeSkillMap[employeeId].find(s => view.skillMap[s.skillId].name === name)
            },


            HasOverlappingError(employee, date){
                let view = this;
                if(!employee) return false;
                let employeeId = employee.id;
                let returnValue = false;

                let shifts = [];
                let actualShifts = [];
                let prefs = [];
                let datePrev = this.$helpers.getMomentFromString(date).clone().add(-1, 'days').format('YYYY-MM-DD');
                let dateNext = this.$helpers.getMomentFromString(date).clone().add(1, 'days').format('YYYY-MM-DD');

                if(view.HasActualShift(employee.id, date)){
                    actualShifts = shifts.concat(this.employeeDateActualShiftMap[employeeId][date]);
                }
                if(view.HasActualShift(employee.id, datePrev)){
                    actualShifts = shifts.concat(this.employeeDateActualShiftMap[employeeId][datePrev]);
                }

                if(view.HasShift(employee.id, date)){
                    shifts = shifts.concat(this.employeeDatePlannedShiftMap[employeeId][date]);
                }
                if(view.HasShift(employee.id, datePrev)){
                    shifts = shifts.concat(this.employeeDatePlannedShiftMap[employeeId][datePrev]);
                }

                if(view.HasUnavailable(employeeId, date)) {
                    prefs = prefs.concat(this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[date]);
                }
                if(view.HasUnavailable(employeeId, dateNext)) {
                    prefs = prefs.concat(this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[dateNext]);
                }
                if(actualShifts.length > 0 && prefs.length > 0){
                    let unavailablePrefs = prefs.filter(item => item.preference.state == 1).map(item => item.preference);
                    actualShifts.forEach(shift => {
                        let shiftFrom = this.actualShiftMomentMap[shift.id].fromDate;
                        let shiftTo = this.actualShiftMomentMap[shift.id].toDate;
                        unavailablePrefs.forEach(pref => {

                            let prefFrom = this.employeePreferenceMomentMap[pref.id].fromDate;
                            let prefTo = this.employeePreferenceMomentMap[pref.id].toDate;
                            if((shiftFrom < prefTo) && (shiftTo > prefFrom) ){
                                returnValue = true;
                                return returnValue;
                            }
                        })
                    })
                }
                if(actualShifts.length > 0 && view.HasUnavailableAvailabilities(employeeId)){
                    let dateMoment = this.$helpers.getMomentFromStringTZ(date, 'YYYY-MM-DD');
                    let yesterDay = dateMoment.clone().add(-1, 'days');
                    let tmrw = dateMoment.clone().add(1, 'days');
                    let unavailabilities = this.employeePreferenceAvailabilityMap[employeeId].availabilities['1'];
                    unavailabilities.forEach(unavail => {
                        if(unavail.weekDays.includes(dateMoment.isoWeekday())){
                            let availFromUTC = this.$helpers.getMomentFromStringUTC(unavail.from, 'HH:mm');
                            let availFrom = dateMoment.clone().hours(availFromUTC.hours()).minutes(availFromUTC.minutes());
                            let availToUTC = this.$helpers.getMomentFromStringUTC(unavail.to, 'HH:mm')
                            let availTo = dateMoment.clone().hours(availToUTC.hours()).minutes(availToUTC.minutes());
                            if(availTo <= availFrom){
                                availTo = availTo.add(1, 'days');
                            }
                            actualShifts.forEach(shift => {
                                let shiftFrom = this.actualShiftMomentMap[shift.id].fromDate;
                                let shiftTo = this.actualShiftMomentMap[shift.id].toDate;
                                if((shiftFrom < availTo) && (shiftTo > availFrom) && (shiftFrom.format("YYYY-MM-DD") == date || availFrom.format("YYYY-MM-DD") == date)){
                                    returnValue = true;
                                    return returnValue;
                                }
                            })
                        }
                        if(unavail.weekDays.includes(yesterDay.isoWeekday())){
                            let availFromUTC = this.$helpers.getMomentFromStringUTC(unavail.from, 'HH:mm');
                            let availFrom = yesterDay.clone().hours(availFromUTC.hours()).minutes(availFromUTC.minutes());
                            let availToUTC = this.$helpers.getMomentFromStringUTC(unavail.to, 'HH:mm')
                            let availTo = yesterDay.clone().hours(availToUTC.hours()).minutes(availToUTC.minutes());
                            if(availTo <= availFrom){
                                availTo = availTo.add(1, 'days');
                            }
                            if(availFrom < tmrw && availTo > dateMoment){
                                actualShifts.forEach(shift => {
                                    let shiftFrom = this.actualShiftMomentMap[shift.id].fromDate;
                                    let shiftTo = this.actualShiftMomentMap[shift.id].toDate;
                                    if((shiftFrom < availTo) && (shiftTo > availFrom) && (shiftFrom.format("YYYY-MM-DD") == date || availFrom.format("YYYY-MM-DD") == date)){
                                        returnValue = true;
                                        return returnValue;
                                    }
                                })
                            }

                        }
                    })

                }
                if(shifts.length > 0 && prefs.length > 0){
                    let unavailablePrefs = prefs.filter(item => item.preference.state == 1).map(item => item.preference);
                    shifts.forEach(shift => {
                        let shiftFrom = this.planShiftMomentMap[shift.id].fromDate;
                        let shiftTo = this.planShiftMomentMap[shift.id].toDate;
                        unavailablePrefs.forEach(pref => {

                            let prefFrom = this.employeePreferenceMomentMap[pref.id].fromDate;
                            let prefTo = this.employeePreferenceMomentMap[pref.id].toDate;
                            if((shiftFrom < prefTo) && (shiftTo > prefFrom)){
                                returnValue = true;
                                return returnValue;
                            }
                        })
                    })
                }
                if(shifts.length > 0 && view.HasUnavailableAvailabilities(employeeId)){
                    let dateMoment = this.$helpers.getMomentFromStringTZ(date, 'YYYY-MM-DD');
                    let yesterDay = dateMoment.clone().add(-1, 'days');
                    let tmrw = dateMoment.clone().add(1, 'days');
                    let unavailabilities = this.employeePreferenceAvailabilityMap[employeeId].availabilities['1'];
                    unavailabilities.forEach(unavail => {
                        if(unavail.weekDays.includes(dateMoment.isoWeekday())){
                            let availFromUTC = this.$helpers.getMomentFromStringUTC(unavail.from, 'HH:mm');
                            let availFrom = dateMoment.clone().hours(availFromUTC.hours()).minutes(availFromUTC.minutes());
                            let availToUTC = this.$helpers.getMomentFromStringUTC(unavail.to, 'HH:mm')
                            let availTo = dateMoment.clone().hours(availToUTC.hours()).minutes(availToUTC.minutes());
                            if(availTo <= availFrom){
                                availTo = availTo.add(1, 'days');
                            }
                            shifts.forEach(shift => {
                                let shiftFrom = this.planShiftMomentMap[shift.id].fromDate;
                                let shiftTo = this.planShiftMomentMap[shift.id].toDate;
                                if((shiftFrom < availTo) && (shiftTo > availFrom) && (shiftFrom.format("YYYY-MM-DD") == date || availFrom.format("YYYY-MM-DD") == date)){
                                    returnValue = true;
                                    return returnValue;
                                }
                            })
                        }
                        if(unavail.weekDays.includes(yesterDay.isoWeekday())){
                            let availFromUTC = this.$helpers.getMomentFromStringUTC(unavail.from, 'HH:mm');
                            let availFrom = yesterDay.clone().hours(availFromUTC.hours()).minutes(availFromUTC.minutes());
                            let availToUTC = this.$helpers.getMomentFromStringUTC(unavail.to, 'HH:mm')
                            let availTo = yesterDay.clone().hours(availToUTC.hours()).minutes(availToUTC.minutes());
                            if(availTo <= availFrom){
                                availTo = availTo.add(1, 'days');
                            }
                            if(availFrom < tmrw && availTo > dateMoment){
                                shifts.forEach(shift => {
                                    let shiftFrom = this.planShiftMomentMap[shift.id].fromDate;
                                    let shiftTo = this.planShiftMomentMap[shift.id].toDate;
                                    if((shiftFrom < availTo) && (shiftTo > availFrom) && (shiftFrom.format("YYYY-MM-DD") == date || availFrom.format("YYYY-MM-DD") == date)){
                                        returnValue = true;
                                        return returnValue;
                                    }
                                })
                            }

                        }
                    })

                }


                return returnValue;
            },

            HasUndesiredPreferenceMatch(employee, date){
                let view = this;
                if(!employee) return false;
                let employeeId = employee.id;
                let returnValue = false;

                let shifts = [];

                if(view.HasShift(employee.id, date)){
                    shifts = this.employeeDatePlannedShiftMap[employeeId][date];
                }
                if(shifts.length > 0 && view.HasUndesired(employeeId, date)){
                    let undesiredPrefs = this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[date].filter(item => item.preference.state == 3).map(item => item.preference);
                    shifts.forEach(shift => {
                        let shiftFrom = this.planShiftMomentMap[shift.id].fromDate;
                        let shiftTo = this.planShiftMomentMap[shift.id].toDate;
                        undesiredPrefs.forEach(pref => {

                            let prefFrom = this.employeePreferenceMomentMap[pref.id].fromDate;
                            let prefTo = this.employeePreferenceMomentMap[pref.id].toDate;
                            if((shiftFrom < prefTo) && (shiftTo > prefFrom) ){
                                returnValue = true;
                                return returnValue;
                            }
                        })
                    })
                }
                return returnValue;
            },

            HasDesiredPreferenceMatch(employee, date){
                let view = this;
                if(!employee) return false;
                let employeeId = employee.id;
                let returnValue = false;

                let shifts = [];

                if(view.HasShift(employee.id, date)){
                    shifts = this.employeeDatePlannedShiftMap[employeeId][date];
                }
                if(shifts.length > 0 && view.HasDesired(employeeId, date)){
                    let desiredPrefs = this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[date].filter(item => item.preference.state == 4).map(item => item.preference);
                    shifts.forEach(shift => {
                        let shiftFrom = this.planShiftMomentMap[shift.id].fromDate;
                        let shiftTo = this.planShiftMomentMap[shift.id].toDate;
                        desiredPrefs.forEach(pref => {

                            let prefFrom = this.employeePreferenceMomentMap[pref.id].fromDate;
                            let prefTo = this.employeePreferenceMomentMap[pref.id].toDate;
                            if((shiftFrom < prefTo) && (shiftTo > prefFrom) ){
                                returnValue = true;
                                return returnValue;
                            }
                        })
                    })
                }
                return returnValue;
            },

            HasDesiredPreferenceNotMatch(employee, date){
                let view = this;
                if(!employee) return false;
                let employeeId = employee.id;
                let returnValue = false;

                let shifts = [];

                if(view.HasShift(employee.id, date)){
                    shifts = this.employeeDatePlannedShiftMap[employeeId][date];
                }
                if(shifts.length > 0 && view.HasDesired(employeeId, date)){
                    let desiredPrefs = this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[date].filter(item => item.preference.state == 4).map(item => item.preference);
                    shifts.forEach(shift => {
                        let shiftFrom = this.planShiftMomentMap[shift.id].fromDate;
                        let shiftTo = this.planShiftMomentMap[shift.id].toDate;
                        desiredPrefs.forEach(pref => {

                            let prefFrom = this.employeePreferenceMomentMap[pref.id].fromDate;
                            let prefTo = this.employeePreferenceMomentMap[pref.id].toDate;
                            if(!((shiftFrom < prefTo) && (shiftTo > prefFrom)) ){
                                returnValue = true;
                                return returnValue;
                            }
                        })
                    })
                }
                return returnValue;
            },

            // Frontend Check for testing stores "Testumgebung Kunde 1", "Testumgebung Kunde 2", "Testumgebung Kunde 3"
            HasConsecutiveError(employee, date){
                let view = this;
                if(!employee) return false;
                let employeeId = employee.id;
                let returnValue = false;

                if( this.legalErrorMap[employeeId] && this.legalErrorMap[employeeId][date]){
                    let x = this.legalErrorMap[employeeId][date];
                    returnValue = x.consecutiveLongShiftsError || x.consecutiveWeekendsError;
                }

                return returnValue;
            },


            HasLegalError(employee, date, checkForBreaks = true){
                let view = this;
                if(!employee) return false;
                let employeeId = employee.id;
                let returnValue = false;

                if( this.legalErrorMap[employeeId] && this.legalErrorMap[employeeId][date]){
                    let x = this.legalErrorMap[employeeId][date];

                    returnValue = x.shiftError || x.weekError || x.restError || (x.legalRestingError && checkForBreaks)
                        || x.restWeekError || x.pregnantError || x.underageError || x.outsideContractError
                        || x.shiftOvertimeError || x.weeklyOvertimeError || x.traineeError || x.daysConsecutiveMax
                        || x.majorityOfWeekends;

                }

                return returnValue;
            },

            HasPlanTypeError(employee, date){
                let view = this;
                if(!employee) return false;
                let employeeId = employee.id;
                let returnValue = false;

                if( view.legalErrorMap[employeeId] && view.legalErrorMap[employeeId][date]){
                    let x = view.legalErrorMap[employeeId][date];
                    returnValue = x.plan_dayError || x.plan_weekError || x.plan_restError || x.plan_restWeekError
                        || x.plan_skillError || x.plan_underageError || x.plan_daysConsecutiveMax;
                }
                return returnValue;

            },

            HasShiftDeclinedError(employee, date){
                let view = this;
                if(!employee) return false;
                let employeeId = employee.id;
                let returnValue = false;

                if( view.legalErrorMap[employeeId] && view.legalErrorMap[employeeId][date]){
                    let x = view.legalErrorMap[employeeId][date];
                     returnValue = x.shiftDeclinedError;
                }
                return returnValue;

            },

            HasShiftEnforcedWarning(employee, date){
                let view = this;
                if(!employee) return false;
                let employeeId = employee.id;
                let returnValue = false;

                if( view.legalErrorMap[employeeId] && view.legalErrorMap[employeeId][date]){
                    let x = view.legalErrorMap[employeeId][date];
                     returnValue = x.shiftEnforced;
                }
                return returnValue;

            },

            HasShiftDurationWarning(employee, date){
                let view = this;
                if(!employee) return false;
                let employeeId = employee.id;
                let returnValue = false;

                if( view.legalErrorMap[employeeId] && view.legalErrorMap[employeeId][date]){
                    let x = view.legalErrorMap[employeeId][date];
                     returnValue = x.shiftLongerThanTenHours;
                }
                return returnValue;

            },

            HasNoContract(employeeId, date){
                return this.employeeContractStatusMap[date] && this.employeeContractStatusMap[date][employeeId];

            },
            HasUnavailableAvailabilities(employeeId){
                return this.employeePreferenceAvailabilityMap[employeeId]
                    && this.employeePreferenceAvailabilityMap[employeeId].availabilities['1'];
            },
            HasMiscUnavailable(employeeId, date, unapproved = false){
                let prefs = [];
                if(unapproved){
                    prefs = this.GetUnapprovedPreferencesByDateAndEmployee(employeeId, date)
                }else{
                    prefs = this.GetPreferencesByDateAndEmployee(employeeId, date)
                }

                return prefs.filter(item => item.state == 1 && item.type == 4).length > 0
            },
            HasUnavailable(employeeId, date, unapproved = false){
                let prefs = [];
                if(unapproved){
                    prefs = this.GetUnapprovedPreferencesByDateAndEmployee(employeeId, date)
                }else{
                    prefs = this.GetPreferencesByDateAndEmployee(employeeId, date)
                }

                return prefs.filter(item => item.state == 1).length > 0
            },
            HasDesired(employeeId, date, unapproved = false){
                let prefs = [];
                if(unapproved){
                    prefs = this.GetUnapprovedPreferencesByDateAndEmployee(employeeId, date)
                }else{
                    prefs = this.GetPreferencesByDateAndEmployee(employeeId, date)
                }

                return prefs.filter(item => item.state == 4).length > 0
            },
            HasUndesired(employeeId, date, unapproved = false){
                let prefs = [];
                if(unapproved){
                    prefs = this.GetUnapprovedPreferencesByDateAndEmployee(employeeId, date)
                }else{
                    prefs = this.GetPreferencesByDateAndEmployee(employeeId, date)
                }

                return prefs.filter(item => item.state == 3).length > 0
            },

            HasVacation(employeeId, date, unapproved = false){
                let prefs = [];
                if(unapproved){
                    prefs = this.GetUnapprovedPreferencesByDateAndEmployee(employeeId, date)
                }else{
                    prefs = this.GetPreferencesByDateAndEmployee(employeeId, date)
                }

                return prefs.filter(item => item.type == 1).length > 0
            },
            HasHoliday(key){
                let events = this.storeEventMomentMap[key]? this.storeEventMomentMap[key] : [];
                let result = false;
                if(events.length > 0){
                    events.forEach((e) => {
                        if(e.federalHoliday){
                            result= true;
                        }
                    });
                 }
                return result;
            },
            HasNursingVacation(employeeId, date, unapproved = false){
                let prefs = [];
                if(unapproved){
                    prefs = this.GetUnapprovedPreferencesByDateAndEmployee(employeeId, date)
                }else{
                    prefs = this.GetPreferencesByDateAndEmployee(employeeId, date)
                }

                return prefs.filter(item => item.type == 6).length > 0
            },

            HasSchooling(employeeId, date, unapproved = false){
                let prefs = [];
                if(unapproved){
                    prefs = this.GetUnapprovedPreferencesByDateAndEmployee(employeeId, date)
                }else{
                    prefs = this.GetPreferencesByDateAndEmployee(employeeId, date)
                }

                return prefs.filter(item => item.type == 7).length > 0
            },

            HasWageContinuation(employeeId, date, unapproved = false){
                let prefs = [];
                if(unapproved){
                    prefs = this.GetUnapprovedPreferencesByDateAndEmployee(employeeId, date)
                }else{
                    prefs = this.GetPreferencesByDateAndEmployee(employeeId, date)
                }

                return prefs.filter(item => item.type == 8).length > 0
            },

            HasHolidayAdjustment(employeeId, date, unapproved = false){
                let prefs = [];
                if(unapproved){
                    prefs = this.GetUnapprovedPreferencesByDateAndEmployee(employeeId, date)
                }else{
                    prefs = this.GetPreferencesByDateAndEmployee(employeeId, date)
                }

                return prefs.filter(item => item.type == 3).length > 0
            },

            HasSickness(employeeId, date, unapproved = false){
                let prefs = [];
                if(unapproved){
                    prefs = this.GetUnapprovedPreferencesByDateAndEmployee(employeeId, date)
                }else{
                    prefs = this.GetPreferencesByDateAndEmployee(employeeId, date)
                }

                return prefs.filter(item => item.type == 2).length > 0

            },
            HasShift(employeeId, date)
            {
                return this.employeeDatePlannedShiftMap[employeeId]
                    && this.employeeDatePlannedShiftMap[employeeId][date]
                    && this.employeeDatePlannedShiftMap[employeeId][date].length > 0;
            },
            HasActualShift(employeeId, date){
                return this.employeeDateActualShiftMap[employeeId]
                    && this.employeeDateActualShiftMap[employeeId][date]
                    && this.employeeDateActualShiftMap[employeeId][date].length > 0;
            },

            CheckForAlwaysWork(employeeId, key, type){
                let alwaysWork = false;
                if(this.employeePreferenceAvailabilityMap[employeeId] && this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[key] && this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[key].length > 0) {
                    let unavails =  this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[key].filter(e => e.preference.state == 1 && e.preference.type == type);
                    if(unavails.length > 0){
                        alwaysWork = unavails[0].preference.alwaysWork;
                    }
                }
                return alwaysWork;
            },
            CheckForComment(employeeId, key, type, unapproved = false){
                let comment = false;
                if(unapproved){
                    if(this.employeeUnapprovedPreferenceAvailabilityMap[employeeId] && this.employeeUnapprovedPreferenceAvailabilityMap[employeeId].preferencesDate[key] && this.employeeUnapprovedPreferenceAvailabilityMap[employeeId].preferencesDate[key].length > 0) {
                        let unavails =  this.employeeUnapprovedPreferenceAvailabilityMap[employeeId].preferencesDate[key].filter(e => e.preference.state == 1 && e.preference.type == type);
                        if(unavails.length > 0){
                            comment = unavails[0].preference.comment;
                        }
                    }
                } else {
                    if(this.employeePreferenceAvailabilityMap[employeeId] && this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[key] && this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[key].length > 0) {
                        let unavails =  this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[key].filter(e => e.preference.state == 1 && e.preference.type == type);
                        if(unavails.length > 0){
                            comment = unavails[0].preference.comment;
                        }
                    }
                }

                return comment;
            },
            CheckForSubtype(employeeId, key, type, unapproved = false){
                let subtype = null;
                if(unapproved){
                    if(this.employeeUnapprovedPreferenceAvailabilityMap[employeeId] && this.employeeUnapprovedPreferenceAvailabilityMap[employeeId].preferencesDate[key] && this.employeeUnapprovedPreferenceAvailabilityMap[employeeId].preferencesDate[key].length > 0) {
                        let unavails =  this.employeeUnapprovedPreferenceAvailabilityMap[employeeId].preferencesDate[key].filter(e => e.preference.state == 1 && e.preference.type == type);
                        if(unavails.length > 0){
                            let s = unavails[0].preference.subtype;
                            if(s != null && this.prefSubtypeMap[s]){
                                subtype = this.prefSubtypeMap[s];
                            }

                        }
                    }
                } else {
                    if(this.employeePreferenceAvailabilityMap[employeeId] && this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[key] && this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[key].length > 0) {
                        let unavails =  this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[key].filter(e => e.preference.state == 1 && e.preference.type == type);
                        if(unavails.length > 0){
                            let s = unavails[0].preference.subtype;
                            if(s != null && this.prefSubtypeMap[s]){
                                subtype = this.prefSubtypeMap[s];
                            }
                        }
                    }
                }

                return subtype;
            },
            CheckForZeroWorkValue(employeeId, key, type, unapproved = false){
                let result = false;
                if(unapproved){
                    if(this.employeeUnapprovedPreferenceAvailabilityMap[employeeId] && this.employeeUnapprovedPreferenceAvailabilityMap[employeeId].preferencesDate[key] && this.employeeUnapprovedPreferenceAvailabilityMap[employeeId].preferencesDate[key].length > 0) {
                        let unavails =  this.employeeUnapprovedPreferenceAvailabilityMap[employeeId].preferencesDate[key].filter(e => e.preference.state == 1 && e.preference.type == type && e.preference.workValue == 0);
                        if(unavails.length > 0){
                            result = true;
                        }
                    }
                }else{
                    if(this.employeePreferenceAvailabilityMap[employeeId] && this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[key] && this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[key].length > 0) {
                        let unavails =  this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[key].filter(e => e.preference.state == 1 && e.preference.type == type && e.preference.workValue == 0);
                        if(unavails.length > 0){
                            result = true;
                        }
                    }
                }

                return result;
            },

            GetDateIconState(employee, date){
                let dateClass = "";
                let dateIcon = "";
                let dateTooltip = "";
                let visible = false;

                let key = date.format("YYYY-MM-DD");
                let datePrefs = this.GetPreferencesByDateAndEmployee(employee.id, key);

                let unapprovedDatePrefs = this.GetUnapprovedPreferencesByDateAndEmployee(employee.id, key);
                //only show undenied
                unapprovedDatePrefs = unapprovedDatePrefs.filter(p => !p.denied);
                if(datePrefs.length > 0){
                    let firstUnavail = datePrefs.find(p => p.state == 1);
                    let currentContract = this.employeeIdContractMap[employee.id] ? Object.values(this.employeeIdContractMap[employee.id]).find(contract => {
                        if(date >= this.employeeContractMomentMap[contract.id].fromDate && (this.employeeContractMomentMap[contract.id].toDate == null || date < this.employeeContractMomentMap[contract.id].toDate)){
                            return true;
                        } else {
                            return false;
                        }
                    }) : null;
                    let workDays = currentContract ? currentContract.workDays : this.storeSettings.workDays;
                    let isWeekend = !workDays.includes(date.isoWeekday()) || (firstUnavail && firstUnavail.workValue == 0);
                    let alwaysWork = false;
                    let comment = false;
                    let zeroWorkValue = false;
                    let subtype = null;
                    if(!visible /*&& this.rosterVisibilityState.visibilitySick*/) {
                        if(this.HasSickness(employee.id, key)){
                            alwaysWork = this.CheckForAlwaysWork(employee.id, key, 2);
                            comment = this.CheckForComment(employee.id, key, 2);
                            subtype = this.CheckForSubtype(employee.id, key, 2);
                            if(subtype != null ){

                                if(comment && subtype.label_de != comment){
                                    comment = subtype.label_de + ', ' + comment;
                                } else {
                                    comment = subtype.label_de;
                                }
                            }
                            zeroWorkValue = this.CheckForZeroWorkValue(employee.id, key, 2);
                            dateClass = 'clear-bg contains sickness';
                            dateIcon = "fas fa-briefcase-medical";
                            dateTooltip = this.$t('workBalance.summary.sickLeave')+ (comment ? (': '+comment) : (zeroWorkValue ? ': 0h' : ''));
                            if((isWeekend && !alwaysWork) || zeroWorkValue){
                                dateClass = 'clear-bg contains unavailable';
                                dateIcon = "fas fa-briefcase-medical";
                            }
                            visible = true;
                        }
                    }

                    if(!visible /*&& this.rosterVisibilityState.visibilityVacation*/) {
                        if(this.HasVacation(employee.id, key)){
                            let holiday = this.HasHoliday(key);

                            alwaysWork = this.CheckForAlwaysWork(employee.id, key, 1);
                            comment = this.CheckForComment(employee.id, key, 1)
                            subtype = this.CheckForSubtype(employee.id, key, 1);
                            if(subtype != null ){

                                if(comment && subtype.label_de != comment){
                                    comment = subtype.label_de + ', ' + comment;
                                } else {
                                    comment = subtype.label_de;
                                }
                            }
                            dateClass = 'clear-bg contains vacation';
                            dateIcon = "fas fa-umbrella-beach";
                            dateTooltip = this.$t('workBalance.summary.vacation')+ (comment ? (': '+comment) : (zeroWorkValue ? ': 0h' : ''));
                            if(!alwaysWork){
                                if(isWeekend){
                                    dateClass = 'clear-bg contains unavailable';
                                    dateIcon = "fas fa-umbrella-beach";
                                } else if(holiday){
                                    dateClass = 'clear-bg contains holidayvacation';
                                    dateIcon = "fas fa-umbrella-beach";
                                }
                            }

                            visible = true;
                        }
                    }

                    if(!visible /*&& this.rosterVisibilityState.visibilityVacation*/) {
                        if(this.HasNursingVacation(employee.id, key)){
                            alwaysWork = this.CheckForAlwaysWork(employee.id, key, 6);
                            comment = this.CheckForComment(employee.id, key, 6)
                            subtype = this.CheckForSubtype(employee.id, key, 6);
                            if(subtype != null ){
                                if(comment && subtype.label_de != comment){
                                    comment = subtype.label_de + ', ' + comment;
                                } else {
                                    comment = subtype.label_de;
                                }
                            }
                            zeroWorkValue = this.CheckForZeroWorkValue(employee.id, key, 6);
                            dateClass = 'clear-bg contains nursingvacation';
                            dateIcon = "fas fa-umbrella-beach";
                            dateTooltip = this.$t('workBalance.summary.nursingLeave')+ (comment ? (': '+comment) : (zeroWorkValue ? ': 0h' : ''));
                            if((isWeekend && !alwaysWork) || zeroWorkValue){
                                dateClass = 'clear-bg contains unavailable';
                                dateIcon = "fas fa-umbrella-beach";
                            }
                            visible = true;
                        }
                    }

                    if(!visible /*&& this.rosterVisibilityState.visibilityEducation*/) {
                        if(this.HasSchooling(employee.id, key)){
                            alwaysWork = this.CheckForAlwaysWork(employee.id, key, 7);
                            comment = this.CheckForComment(employee.id, key, 7)
                            subtype = this.CheckForSubtype(employee.id, key, 7);
                            if(subtype != null ){
                                if(comment && subtype.label_de != comment){
                                    comment = subtype.label_de + ', ' + comment;
                                } else {
                                    comment = subtype.label_de;
                                }
                            }
                            zeroWorkValue = this.CheckForZeroWorkValue(employee.id, key, 7);
                            dateClass = 'clear-bg contains schooling';
                            dateIcon = "fas fa-user-graduate";
                            dateTooltip = this.$t('workBalance.summary.trainee')+ (comment ? (': '+comment) : (zeroWorkValue ? ': 0h' : ''));
                            if((isWeekend && !alwaysWork) || zeroWorkValue){
                                dateClass = 'clear-bg contains unavailable';
                                dateIcon = "fas fa-user-graduate";
                            }
                            visible = true;
                        }
                    }

                    if(!visible /*&& this.rosterVisibilityState.visibilityWageContinuation*/) {
                        if(this.HasWageContinuation(employee.id, key)){
                            alwaysWork = this.CheckForAlwaysWork(employee.id, key, 8);
                            comment = this.CheckForComment(employee.id, key, 8)
                            subtype = this.CheckForSubtype(employee.id, key, 8);
                            if(subtype != null ){
                                if(comment && subtype.label_de != comment){
                                    comment = subtype.label_de + ', ' + comment;
                                } else {
                                    comment = subtype.label_de;
                                }
                            }
                            zeroWorkValue = this.CheckForZeroWorkValue(employee.id, key, 8);
                            dateClass = 'clear-bg contains wagecontinuation';
                            dateIcon = "fas fa-wallet";
                            dateTooltip = this.$tc('workBalance.summary.sickPay') + (comment ? (': '+comment) : (zeroWorkValue ? ': 0h' : ''));
                            if((isWeekend && !alwaysWork) || zeroWorkValue){
                                dateClass = 'clear-bg contains unavailable';
                                dateIcon = "fas fa-wallet";
                            }
                            visible = true;
                        }
                    }

                    if(!visible /*&& this.rosterVisibilityState.visibilityHolidayAdjustment*/) {
                        if(this.HasHolidayAdjustment(employee.id, key)){
                            alwaysWork = this.CheckForAlwaysWork(employee.id, key, 3);
                            comment = this.CheckForComment(employee.id, key, 3)
                            subtype = this.CheckForSubtype(employee.id, key, 3);
                            if(subtype != null ){
                                if(comment && subtype.label_de != comment){
                                    comment = subtype.label_de + ', ' + comment;
                                } else {
                                    comment = subtype.label_de;
                                }
                            }
                            zeroWorkValue = this.CheckForZeroWorkValue(employee.id, key, 3);
                            dateClass = 'clear-bg contains holidayadjustment';
                            dateIcon = "fas fa-gift";
                            dateTooltip = this.$t('workBalance.payroll.holidayCompensation') + (comment ? (': '+comment) : (zeroWorkValue ? ': 0h' : ''));
                            if((isWeekend && !alwaysWork) || zeroWorkValue){
                                dateClass = 'clear-bg contains unavailable';
                                dateIcon = "fas fa-gift";
                            }
                            visible = true;
                        }
                    }

                    if(!visible && this.rosterVisibilityState.visibilityNotAvailable) {
                        if(this.HasMiscUnavailable(employee.id, key)){
                            alwaysWork = this.CheckForAlwaysWork(employee.id, key, 4);
                            comment = this.CheckForComment(employee.id, key, 4)
                            subtype = this.CheckForSubtype(employee.id, key, 4);
                            if(subtype != null ){
                                if(comment && subtype.label_de != comment){
                                    comment = subtype.label_de + ', ' + comment;
                                } else {
                                    comment = subtype.label_de;
                                }
                            }
                            zeroWorkValue = this.CheckForZeroWorkValue(employee.id, key, 4);
                            dateClass = 'clear-bg contains unavailable';
                            dateIcon = "fas fa-times";
                            dateTooltip = this.$t('roster.comp.notAvailable') + (comment ? (': '+comment) : (zeroWorkValue ? ': 0h' : ''));
                            if(alwaysWork && !zeroWorkValue){
                                dateClass = 'clear-bg contains miscunavailable';
                            }

                            visible = true;
                        }
                    }

                    if(!visible && this.rosterVisibilityState.visibilityNotAvailable) {
                        if(this.HasUnavailable(employee.id, key)){
                            comment = this.CheckForComment(employee.id, key, 4)
                            subtype = this.CheckForSubtype(employee.id, key, 4);
                            if(subtype != null ){
                                if(comment && subtype.label_de != comment){
                                    comment = subtype.label_de + ', ' + comment;
                                } else {
                                    comment = subtype.label_de;
                                }
                            }
                            dateClass = 'clear-bg contains unavailable';
                            dateIcon = "fas fa-times";
                            dateTooltip = this.$t('roster.comp.notAvailable') + (comment ? (': '+comment) : '');
                            visible = true;
                        }
                    }


                    if(!visible && this.rosterVisibilityState.visibilityUndesired) {
                        if(this.HasUndesired(employee.id, key)){
                            dateClass = 'slot-bg contains undesired';
                            dateIcon = "fas fa-thumbs-down";
                            dateTooltip = this.$t('roster.comp.undesired');
                            visible = true;
                        }
                    }

                    if(!visible && this.rosterVisibilityState.visibilityDesired) {
                        if(this.HasDesired(employee.id, key)){
                            dateClass = 'slot-bg contains desired';
                            dateIcon = "fas fa-thumbs-up";
                            dateTooltip = this.$t('roster.comp.preference');
                            visible = true;
                        }
                    }


                } else if(unapprovedDatePrefs.length > 0){
                    let comment = false;
                    if(!visible /*&& this.rosterVisibilityState.visibilitySick*/) {
                        if(this.HasSickness(employee.id, key, true)){
                            comment = this.CheckForComment(employee.id, key, 2, true);
                            dateClass = 'clear-bg contains unavailable';
                            dateIcon = "far fa-briefcase-medical";
                            dateTooltip = this.$t('workBalance.summary.sickLeave') + this.$t('roster.comp.unconfirmed') + (comment ? (': '+comment) : '');
                            visible = true;
                        }
                    }

                    if(!visible /*&& this.rosterVisibilityState.visibilityVacation*/) {
                        if(this.HasVacation(employee.id, key, true)){
                            let holiday = this.HasHoliday(key);

                            comment = this.CheckForComment(employee.id, key, 1, true)
                            dateClass = 'clear-bg contains unavailable';
                            dateIcon = "far fa-umbrella-beach";
                            dateTooltip = this.$t('workBalance.summary.vacation') + this.$tc('roster.comp.unconfirmed') + (comment ? (': '+comment) : '');
                            visible = true;
                        }
                    }

                    if(!visible /*&& this.rosterVisibilityState.visibilityVacation*/) {
                        if(this.HasNursingVacation(employee.id, key, true)){
                            comment = this.CheckForComment(employee.id, key, 1, true)
                            dateClass = 'clear-bg contains unavailable';
                            dateIcon = "far fa-hand-holding-medical";
                            dateTooltip = this.$tc('workBalance.summary.nursingLeave') + this.$tc('roster.comp.unconfirmed') + (comment ? (': '+comment) : '');
                            visible = true;
                        }
                    }

                    if(!visible /*&& this.rosterVisibilityState.visibilityEducation*/) {
                        if(this.HasSchooling(employee.id, key, true)){
                            comment = this.CheckForComment(employee.id, key, 7, true)
                            dateClass = 'clear-bg contains unavailable';
                            dateIcon = "far fa-user-graduate";
                            dateTooltip = this.$t('workBalance.summary.trainee') + this.$tc('roster.comp.unconfirmed') + (comment ? (': '+comment) : '');
                            visible = true;
                        }
                    }

                    if(!visible /*&& this.rosterVisibilityState.visibilityWageContinuation*/) {
                        if(this.HasWageContinuation(employee.id, key, true)){
                            comment = this.CheckForComment(employee.id, key, 8, true)
                            dateClass = 'clear-bg contains unavailable';
                            dateIcon = "far fa-wallet";
                            dateTooltip = this.$t('workBalance.summary.sickPay') + this.$t('roster.comp.unconfirmed') + (comment ? (': '+comment) : '');
                            visible = true;
                        }
                    }

                    if(!visible /*&& this.rosterVisibilityState.visibilityHolidayAdjustment*/) {
                        if(this.HasHolidayAdjustment(employee.id, key, true)){
                            comment = this.CheckForComment(employee.id, key, 3, true)
                            dateClass = 'clear-bg contains unavailable';
                            dateIcon = "far fa-gift";
                            dateTooltip = this.$t('workBalance.payroll.holidayCompensation') + this.$t('roster.comp.unconfirmed')+ (comment ? (': '+comment) : '');
                            visible = true;
                        }
                    }

                    if(!visible && this.rosterVisibilityState.visibilityNotAvailable) {
                        if(this.HasMiscUnavailable(employee.id, key, true)){
                            comment = this.CheckForComment(employee.id, key, 4, true)
                            dateClass = 'clear-bg contains unavailable';
                            dateIcon = "far fa-times";
                            dateTooltip = this.$t('roster.comp.notAvailable') + this.$t('roster.comp.unconfirmed')+ (comment ? (': '+comment) : '');
                            visible = true;
                        }
                    }

                    if(!visible && this.rosterVisibilityState.visibilityNotAvailable) {
                        if(this.HasUnavailable(employee.id, key, true)){
                            comment = this.CheckForComment(employee.id, key, 4, true)
                            dateClass = 'clear-bg contains unavailable';
                            dateIcon = "far fa-times";
                            dateTooltip = this.$t('roster.comp.notAvailable') + this.$t('roster.comp.unconfirmed')+ (comment ? (': '+comment) : '');
                            visible = true;
                        }
                    }


                    if(!visible && this.rosterVisibilityState.visibilityUndesired) {
                        if(this.HasUndesired(employee.id, key, true)){
                            dateClass = 'slot-bg contains unavailable';
                            dateIcon = "far fa-thumbs-down";
                            dateTooltip = this.$t('roster.comp.undesired') + this.$t('roster.comp.unconfirmed');
                            visible = true;
                        }
                    }

                    if(!visible && this.rosterVisibilityState.visibilityDesired) {
                        if(this.HasDesired(employee.id, key, true)){
                            dateClass = 'slot-bg contains unavailable';
                            dateIcon = "far fa-thumbs-up";
                            dateTooltip = this.$t('roster.comp.preference') + this.$t('roster.comp.unconfirmed');
                            visible = true;
                        }
                    }


                }  else if(this.employeeDateEmployeeExtraPaymentMap[employee.id] && this.employeeDateEmployeeExtraPaymentMap[employee.id][key] && this.employeeDateEmployeeExtraPaymentMap[employee.id][key].length > 0){
                    dateClass = 'slot-bg contains extrapayment';
                    dateIcon = "fas fa-sack-dollar";
                    dateTooltip = this.$t('roster.view.extraPayment');
                    visible = true;
                }  else if(employee.dob){
                    let dob = this.$helpers.getMomentFromStringTZ(employee.dob);
                    if(dob.month() == date.month() && dob.date() == date.date()){
                        dateClass = 'slot-bg contains birthday';
                        dateIcon = "fas fa-birthday-cake";
                        dateTooltip = this.$t('roster.view.birthday');
                        visible = true;
                    }
                }
                if(!visible && this.HasNoContract(employee.id, key)){
                    dateClass = 'clear-bg contains contract';
                    dateIcon = "fas fa-slash";
                    dateTooltip = this.$t('workBalance.payroll.noContract');
                    visible = true;
                }


                return {
                    class: dateClass,
                    icon: dateIcon,
                    tooltip: dateTooltip,
                    visible: visible
                }
            },



            HighestShiftTime(employee, date)
            {
                if(!employee) return null;
                let shiftsInDay =  this.employeeMap[employee.id] && this.employeeMap[employee.id].shiftsDate && this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')] && this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')].length > 0 ?  this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')] : null;
                if(shiftsInDay)
                {
                    let max = shiftsInDay.reduce(function(prev, current) {
                        if (current.toDate > prev.toDate) {
                            return current;
                        } else {
                            return prev;
                        }
                    });
                    return max.toDate.format('HH') + ':' + max.toDate.format('mm');
                }
                return '';
            },
            LowestShiftTime(employee, date)
            {
                if(!employee) return null;
                let shiftsInDay =  this.employeeMap[employee.id] && this.employeeMap[employee.id].shiftsDate && this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')] && this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')].length > 0 ?  this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')] : null;
                if(shiftsInDay)
                {
                    let max = shiftsInDay.reduce(function(prev, current) {
                        if (current.fromDate < prev.fromDate) {
                            return current;
                        } else {
                            return prev;
                        }
                    });
                    return max.fromDate.format('HH') + ':' + max.fromDate.format('mm');
                }
                return '';
            },
            LowestShiftTimeDate(employee, date)
            {
                if(!employee) return this.$helpers.getMomentFromStringTZ(0, 'x');
                let shiftsInDay =  this.employeeMap[employee.id] && this.employeeMap[employee.id].shiftsDate && this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')] && this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')].length > 0 ?  this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')] : null;
                if(shiftsInDay)
                {
                    let max = shiftsInDay.reduce(function(prev, current) {
                        if (current.fromDate < prev.fromDate) {
                            return current;
                        } else {
                            return prev;
                        }
                    });
                    return max.fromDate.clone();
                }
                return this.$helpers.getMomentFromStringTZ(0, 'x');
            },
            GetShiftsInDay(employee, date)
            {
                if(!employee) return null;
                let shiftsInDay =  this.employeeMap[employee.id] && this.employeeMap[employee.id].shiftsDate && this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')] && this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')].length > 0 ?  this.employeeMap[employee.id].shiftsDate[date.format('YYYY-MM-DD')] : null;
                if(shiftsInDay) shiftsInDay = shiftsInDay.slice();
                return shiftsInDay;
            },



            CheckTimeFrameIntersectHours(startA, endA, startB, endB)
            {
                if(!startA || !endA || !startB || !endB) return NaN;
                let startAMilliseconds = (startA.hours() * 60 * 60 * 1000) + (startA.minutes() * 60 * 1000);
                let startBMilliseconds = (startB.hours() * 60 * 60 * 1000) + (startB.minutes() * 60 * 1000);
                let endAMilliseconds = (endA.hours() * 60 * 60 * 1000) + (endA.minutes() * 60 * 1000);
                let endBMilliseconds = (endB.hours() * 60 * 60 * 1000) + (endB.minutes() * 60 * 1000);
                if(startAMilliseconds > endAMilliseconds) endAMilliseconds += (24 * 60 * 60 * 1000);
                if(startBMilliseconds > endBMilliseconds) endBMilliseconds += (24 * 60 * 60 * 1000);
                return startAMilliseconds < endBMilliseconds && startBMilliseconds < endAMilliseconds;
            },
            CheckTimeFrameIntersect(startA, endA, startB, endB)
            {
                return startA < endB && startB < endA;
            },
            CheckTimeFrameEncapsulated(startInner, endInner, startOuter, endOuter)
            {
                return startInner > startOuter && endInner < endOuter;
            },
            CheckTimeFrameEncapsulatedHours(startInner, endInner, startOuter, endOuter)
            {
                if(!startInner || !endInner || !startOuter || !endOuter) return NaN;
                let startAMilliseconds = (startInner.hours() * 60 * 60 * 1000) + (startInner.minutes() * 60 * 1000);
                let startBMilliseconds = (startOuter.hours() * 60 * 60 * 1000) + (startOuter.minutes() * 60 * 1000);
                let endAMilliseconds = (endInner.hours() * 60 * 60 * 1000) + (endInner.minutes() * 60 * 1000);
                let endBMilliseconds = (endOuter.hours() * 60 * 60 * 1000) + (endOuter.minutes() * 60 * 1000);
                if(startAMilliseconds > endAMilliseconds) endAMilliseconds += (24 * 60 * 60 * 1000);
                if(startBMilliseconds > endBMilliseconds) endBMilliseconds += (24 * 60 * 60 * 1000);
                return startAMilliseconds > startBMilliseconds && endAMilliseconds < startBMilliseconds;
            },

    updateEmployeeSkills: function(){

        this.employeeEmployeeSkillMap = {};
        Object.values(this.employeeSkillMap).forEach(eSkill => {
            if(!this.employeeEmployeeSkillMap[eSkill.employeeId]){
               this.employeeEmployeeSkillMap[eSkill.employeeId] = [];
            }
            this.employeeEmployeeSkillMap[eSkill.employeeId].push(eSkill);
        })

        //this.employeeGroups = [];
        this.businessGroups = [];
        this.businessGroups.push({label: 'All', unit: null, collapsed: false});
        let units = Object.values(this.businessUnitMap);
        let view = this;
        for(let x in units)
        {
            (function(unit){
                view.businessGroups.push({label: unit.name, unit: unit, collapsed: true});
            })(units[x]);

        }/*
        this.selectedUnit = units[0];
        this.businessGroupsBefore = this.businessGroups.filter(b => view.businessGroups.indexOf(b) < view.businessGroups.indexOf(view.selectedUnit));
        this.businessGroupsAfter = this.businessGroups.filter(b => view.businessGroups.indexOf(b) > view.businessGroups.indexOf(view.selectedUnit));*/
        let spots = Object.values(view.customSpotMap);
        spots.unshift({name: 'All'});
        for(let x in spots)
        {
            let spot = spots[x]
            let group = {};
            group.label = spot.name;
            group.spot = spot;
            //group.collapsed = (spot.name !== 'All');
            group.collapsed = true;
            group.employees = spot.requiredSkill && spot.requiredSkill !== '' ? view.employees.filter(e => view.HasSkillById(e.id, spot.requiredSkill)) : this.employees.slice();
            group.employeesFiltered = group.employees.slice();
            //this.employeeGroups.push(group);
        }


        $('.dropdown-search.employee-sort input').val('Skill');

    },
    updateEmployeeTypes: function(data){
        let i;
        let ttypes = {}
        for (i = 0; i < data.length; i++) {
            ttypes[data[i].id] =data[i];
        }
        this.employeeTypeMap = ttypes;
    },
    updateSpots: function(){
        let data = Object.values(this.spotMap);

        let i;
        let tspots = {}
        for (i = 0; i < data.length; i++) {
            let priority = 0;

            let tmp = Object.values(this.userUnitSortMap).filter(x => (x.unitId === data[i].id));
            if(tmp != undefined && tmp.length > 0){
                priority = tmp[0].priority;
            }
            tspots[data[i].id] =data[i];

            //Each spot has a required business unit, since we drop spots to employeeGroups, we add the businessUnit now to the spot
            for(let j in this.businessUnitMap){
                if(data[i].unitId == this.businessUnitMap[j].id){
                    tspots[data[i].id].bunit = this.businessUnitMap[j];
                }
            }


            tspots[data[i].id].toggled = false;
            tspots[data[i].id].userPriority = priority;
            data[i].label = data[i].name
        }
        this.customSpotMap = tspots;

        data.push({name: 'All', label:'All'});
        let view = this;
        let spots = Object.values(view.customSpotMap);
        spots.push({name: 'All', label:'All'});
        //if(item.label !== 'All') spots.filter(s => s.unitName === item.label);
        view.spots = {
            toggled: false,
            displayedItems: [],
            input: 'All',
            items: spots,
            onceSelected: function ($event, item, searchbar){
                if(item.label === 'All')
                {
                    let selectedUnit = $('.dropdown-search.unit input').val();
                    if(selectedUnit === 'All')
                        view.employeesFiltered = view.employees.slice();
                    else
                        view.employeesFiltered = view.employees.filter(e => (view.HasSkillByName(e.id, selectedUnit)) || (view.employeeMap[e.id] && view.employeeMap[e.id].shifts && view.employeeMap[e.id].shifts.find(s => s.spotId)));

                }
                else
                {
                    view.employeesFiltered = view.employees.filter(e => (view.HasSkillById(e.id, item.requiredSkill)) || (view.employeeMap[e.id] && view.employeeMap[e.id].shifts && view.employeeMap[e.id].shifts.find(s => s.spotId && s.spotId === item.id)));
                }
                view.$forceUpdate();
            }
        }
    },

    ShiftInDayIsPublished(employee){
        if(!employee) return false;
        let shifts = this.GetShiftsInDay(employee, this.dayModeDate);
        if(!shifts || shifts.length === 0) return false;
        return shifts.filter(s => s.published).length > 0;
    },


    sortByPriorityAndName: function(a,b){
        const userUnitSortMap = this.userUnitSortMapByUnitId;
        let userunitsortA = userUnitSortMap[a.id];
        let userunitsortB = userUnitSortMap[b.id];

        let prioA = userunitsortA != null ? userunitsortA.priority : a.priority;
        let prioB = userunitsortB != null ? userunitsortB.priority : b.priority;

        if(prioA == null) return 1;
        if(prioB == null) return -1;
        if(prioA != prioB) return prioA - prioB;


        return a.name.toUpperCase().localeCompare(b.name.toUpperCase());

    },
    sortEmployees: function(a, b){
        let sortByPriority = false;
        if(this.employeeSortState && this.employeeSortState.sortByPriority){
            sortByPriority = true;
        }
        if(this.employeeSortState && this.employeeSortState.sortByContractType){
            let aContract = this.employeeIdContractMap[a.id] ? this.employeeIdContractMap[a.id].length > 0 ? this.employeeIdContractMap[a.id][0] : null : null;
            let bContract = this.employeeIdContractMap[b.id] ? this.employeeIdContractMap[b.id].length > 0 ? this.employeeIdContractMap[b.id][0] : null : null;

            if(aContract != null && bContract != null){

                let res = bContract.weekTimeRegular - aContract.weekTimeRegular;
                if(res == 0){
                    return this.sortEmployee(a, b, sortByPriority);
                } else {
                    return res;
                }
            } else if(aContract != null){
                return -1;
            } else if(bContract != null){
                return 1;
            } else {
                return this.sortEmployee(a, b, sortByPriority);
            }
        } else {
            return this.sortEmployee(a, b, sortByPriority);
        }
    },
    sortEmployee: function(a,b, sortByPriority = false){
        if(sortByPriority){
            if(a.sortPriority != b.sortPriority){
                return a.sortPriority - b.sortPriority;
            } else {
                let aName = a.lastName + " " + a.firstName;
                let bName = b.lastName + " " + b.firstName;
                return aName.toUpperCase().localeCompare(bName.toUpperCase());
            }
        } else {
            let aName = a.lastName + " " + a.firstName;
            let bName = b.lastName + " " + b.firstName;
            return aName.toUpperCase().localeCompare(bName.toUpperCase());
        }
        
    },
    sortSpotMap: function(){
        let majorGroups = [];
        for(let i in this.customSpotMap){
            if(this.customSpotMap[i].isMain){
                majorGroups.push(this.customSpotMap[i]);
            }
        }
        majorGroups.sort(this.sortByPriorityAndName);

        // The employeeGroups with a BusinessUnit are now sorted

        let childGroups = [];
        for(let i in this.customSpotMap){
            if(!this.customSpotMap[i].isMain){
                childGroups.push(this.customSpotMap[i]);
            }
        }
        childGroups.sort(this.sortByPriorityAndName);
        // The employeeGroups with indentation are now sorted

        // Loop to PUSH the child groups after the parent, BUT in the same array like the parent group
        let groups = [];
        for(let i = 0; i < majorGroups.length; i++){
            groups.push(majorGroups[i]);
            for(let j in childGroups){
                if(childGroups[j].unitId == majorGroups[i].unitId){
                    groups.push(childGroups[j]);
                }
            }
        }
        return groups;
    },
    initializeDisplayedSpots(){
        this.sortedSpotGroups = this.sortSpotMap();
        this.displayedSpots = this.sortedSpotGroups.filter(s => Object.values(this.employeeMap).some(e => e.spotId == s.id)).map(s => s.id);
        this.displayedSkills = this.displayedSpots.filter(spotId => this.spotMap[spotId] != null).map(spotId => this.spotMap[spotId].requiredSkill);


    },
    updateDisplayedSpots(spots){
        this.displayedSpots = this.sortedSpotGroups.filter(s => spots.includes(s.id)).map(s => s.id);
        this.displayedSkills = this.displayedSpots.filter(spotId => this.spotMap[spotId] != null).map(spotId => this.spotMap[spotId].requiredSkill);
        this.sortEmployeeGroups();
        this.RefreshRosterContentMap();
    },
    computeEmployeeGroup: function(spot, mainOnly = false){
        let view = this;
        let group = {};
        group.label = (spot == null) ? this.$t('indicator.eval.notAssigned') : spot.label; // Needed for employeeGroups that don't have a spot but need a label
        group.spot = spot; // set the spot to have all infos about the spot this employeeGroup represents
        let employees = [];
        if(spot == null){
            employees = view.employees.filter(e => view.employeeMap[e.id].spotId == null);
        } else if (mainOnly){
            employees = view.employees.filter(e => {
                if(view.employeeMap[e.id].spotId != null){
                    let empSpot = view.spotMap[view.employeeMap[e.id].spotId];
                    let mainSpot = Object.values(view.spotMap).find(s => s.isMain && s.unitId == empSpot.unitId);
                    return mainSpot.id == spot.id;
                } else {
                    return false;
                }
            })
        } else {
            employees = view.employees.filter(e => (view.employeeMap[e.id].spotId != null && view.employeeMap[e.id].spotId == spot.id));
        }
        group.employees = employees
        
        group.employeesFiltered = group.employees.slice();//copy the employees for now, for filtering later
        group.collapsed = group.employeesFiltered.length <= 0; // auto collapse, if no employees in this group
        group.draggable = (spot == null) ? false : (spot.isMain ? true : false); // this employeeGroup is draggable?
        group.helper = false; // its a existing emplyoee group and not a helper element for dragging
        group.show = (spot == null) ? group.employees.length > 0 : true;
        group.showMajor = group.show; // possibility to override the show mechanism if the user overrules it, right now just set it the same as show
        if(spot == null || this.$helpers.isBlank(spot.parentId)){
            group.indentationLevel = 0;
        }else{
            group.indentationLevel = 1;
        }
        return group;
    },
    computeEmployeeGroupByShifts: function(spot, employeeShifts) {
        let view = this;

        let group = {};
        group.label = (spot == null) ? this.$t('indicator.eval.notAssigned') : spot.label; // Needed for employeeGroups that don't have a spot but need a label
        group.spot = spot ? spot : {id: "0"}; // set the spot to have all infos about the spot this employeeGroup represents
        let employees = [];

        let startDate = this.dayModeDate.clone().startOf('day');
        let endDate = startDate.clone().add(this.dayModeHours, 'hours');

        if(spot == null){
            employees = view.employees.filter(e =>
                // no shifts
                (employeeShifts[e.id] == undefined
                // no planshifts
                || (employeeShifts[e.id].planShifts.length == 0
                // no actual shifts
                && employeeShifts[e.id].actualShifts.length == 0
                    // or actual shifts have no planshift
                    || (employeeShifts[e.id].actualShifts).filter(s => !s.planShiftId).length == employeeShifts[e.id].actualShifts.length))
                && (e.spotId == null)
                );
        } else {
            employees = view.employees.filter(e => {
                let planShifts = employeeShifts[e.id] ? employeeShifts[e.id].planShifts : [];
                let actualShifts = employeeShifts[e.id] ? employeeShifts[e.id].actualShifts : [];
                return ((planShifts.length == 0 && actualShifts.length == 0 && e.spotId == spot.id)
                    || (planShifts.filter(s => (s.spotId == spot.id)).length > 0)
                    || (actualShifts.filter(s => (s.planShiftId && view.planShiftMap[s.planShiftId] && view.planShiftMap[s.planShiftId].spotId == spot.id)).length > 0));
            });
        }
        group.employees = employees
       
        group.employeesFiltered = group.employees.slice();//copy the employees for now, for filtering later
        group.collapsed = group.employeesFiltered.length <= 0; // auto collapse, if no employees in this group
        group.draggable = (spot == null) ? false : (spot.isMain ? true : false); // this employeeGroup is draggable?
        group.helper = false; // its a existing emplyoee group and not a helper element for dragging
        group.show = (spot == null) ? group.employees.length > 0 : true;
        group.showMajor = group.show; // possibility to override the show mechanism if the user overrules it, right now just set it the same as show
        if(spot == null || this.$helpers.isBlank(spot.parentId)){
            group.indentationLevel = 0;
        }else{
            group.indentationLevel = 1;
        }

        return group;
    },

    sortEmployeeGroups: function(){
        this.loadingText = "Arbeitsbereiche werden sortiert";
        let view = this;
        this.employeeGroups = [];
        if(this.rosterSortState.showBusinessUnits){
            //Sortierung nach Bereichen
            for (let i = 0; i < this.sortedSpotGroups.length; i++) {
                let spot = this.sortedSpotGroups[i];
                if(this.displayedSpots.includes(spot.id) && spot.isMain){
                    this.employeeGroups.push(view.computeEmployeeGroup(spot, true));
                }

            }
            this.employeeGroups.push(view.computeEmployeeGroup(null));
        } else if(this.rosterSortState.showSpots){
            //Sortierung nach Positionen


            for (let i = 0; i < this.sortedSpotGroups.length; i++) {
                let spot = this.sortedSpotGroups[i];
                if(this.displayedSpots.includes(spot.id)){
                    this.employeeGroups.push(view.computeEmployeeGroup(spot));
                }

            }
            this.employeeGroups.push(view.computeEmployeeGroup(null));
        } else if(this.rosterSortState.showShiftSpots){
            //Sortierung nach Schicht Positionen

            // prepare shifts for better performance in computeEmployeeGroupByShifts
            let employeeShifts = {};
            Object.values(this.planShiftMap).filter(s =>
                this.$helpers.getMomentFromStringTZ(s.from).isBetween(this.dayModeDate.clone().startOf('day'), this.dayModeDate.clone().add(this.dayModeHours, 'hours'))
                || this.$helpers.getMomentFromStringTZ(s.to).isBetween(this.dayModeDate.clone().startOf('day'), this.dayModeDate.clone().add(this.dayModeHours, 'hours'))
            ).forEach(s => {
                if(!employeeShifts[s.employeeId]){
                    employeeShifts[s.employeeId] = {
                        planShifts: [],
                        actualShifts: []
                    };
                }
                employeeShifts[s.employeeId]['planShifts'].push(s);
            });
            Object.values(this.actualShiftMap).filter(s =>
                this.$helpers.getMomentFromStringTZ(s.from).isBetween(this.dayModeDate.clone().startOf('day'), this.dayModeDate.clone().add(this.dayModeHours, 'hours'))
                || this.$helpers.getMomentFromStringTZ(s.to).isBetween(this.dayModeDate.clone().startOf('day'), this.dayModeDate.clone().add(this.dayModeHours, 'hours'))
            ).forEach(s => {
                if(!employeeShifts[s.employeeId]){
                    employeeShifts[s.employeeId] = {
                        planShifts: [],
                        actualShifts: []
                    };
                }
                employeeShifts[s.employeeId]['actualShifts'].push(s);
            });

            for (let i = 0; i < this.sortedSpotGroups.length; i++) {
                let spot = this.sortedSpotGroups[i];
                if(this.displayedSpots.includes(spot.id)){
                    this.employeeGroups.push(view.computeEmployeeGroupByShifts(spot, employeeShifts));
                }

            }
            this.employeeGroups.push(view.computeEmployeeGroupByShifts(null, employeeShifts));
        } else if(this.rosterSortState.filterByShiftSpot) {
            let group = {};
            group.label = 'Gefilterte Mitarbeiter';
            group.spot = null;
            group.collapsed = false;
            group.employees = view.employees.filter(emp => {
                let skills = this.employeeEmployeeSkillMap[emp.id];

                let hasSkill = skills != null && skills.some(s => view.displayedSkills.includes(s.skillId));
                let hasShift = Object.values(this.planShiftMap).some(p => p.employeeId == emp.id && view.displayedSpots.includes(p.spotId));
                return (hasSkill && !view.rosterSortState.filterByOnlyShiftSpot) || hasShift;
            });
            group.employeesFiltered = group.employees.slice();
            group.draggable = false;
            group.helper = false;
            group.show = true;
            group.showMajor = true;
            group.indentationLevel = 0;
            this.employeeGroups.push(group);
        }else{
            //Keine Sortierung nach Bereichen
            let group = {};
            group.label = this.$t('global.ui.allEmployees');
            group.spot = null;
            group.collapsed = false;
            group.employees = view.employees.slice();
            group.employeesFiltered = group.employees.slice();
            group.draggable = false;
            group.helper = false;
            group.show = true;
            group.showMajor = true;
            group.indentationLevel = 0;
            this.employeeGroups.push(group);
        }
        for(let i in view.employeeGroups){
            view.employeeGroups[i].employees.sort(this.sortEmployees);
            view.employeeGroups[i].employeesFiltered.sort(this.sortEmployees);
        }

        for(let i in view.employeeGroups){
            let hasChilds = false;
            if(view.employeeGroups[i].spot != null){
                 for(let x in view.employeeGroups){
                    if(view.employeeGroups[x].spot != null && view.employeeGroups[x].spot.parentId === view.employeeGroups[i].spot.id){
                        view.employeeGroups[i].show = true;
                        view.employeeGroups[i].showMajor = true;
                        break;
                    }
                }
            }

        }

        this.filterEmployees();
        return;
    },
    ClearEmployeeFilter(){
         this.dynamicSkillsFiltered = [];
         this.filterEmployees();
    },

    filterEmployees: function(){
        this.loadingText = this.$t('roster.main.filterEmployees');
        let view = this;
        this.dynamicFilterActive = false;
        if(this.dynamicFiltering){
            if(this.dragging){
                this.dynamicFilterActive = true;
            }
            for (let i = 0; i < this.employeeGroups.length; i++) {
                this.employeeGroups[i].employeesFiltered = this.dynamicSkillsFiltered.length > 0 ? this.employeeGroups[i].employees.filter(e => this.dynamicSkillsFiltered.every(elem => view.HasSkillById(e.id, elem))) : this.employeeGroups[i].employees.slice();
            }
        }else{
            for (let i = 0; i < this.employeeGroups.length; i++) {
                this.employeeGroups[i].employeesFiltered = this.softSkillsFiltered.length > 0 ? this.employeeGroups[i].employees.filter(e => this.softSkillsFiltered.every(elem => view.HasSkillById(e.id, elem))) : this.employeeGroups[i].employees.slice();
            }
            // CODE TO UPDATE EMPLOYEE COUNT BELOW
            let tmp = this.softSkillsFiltered.slice();
            for (let i in this.spotcustomSpotMapMap) {
                let sum = 0;
                let skillId = this.customSpotMap[i].requiredSkill;
                let index = tmp.indexOf(skillId);
                if (index !== -1){
                    tmp.splice(index, 1);
                    for (let j = 0; j < this.employeeGroups.length; j++) {
                        sum = sum + (tmp.length > 0 ? this.employeeGroups[j].employees.filter(e => tmp.every(elem => view.HasSkillById(e.id, elem))).length : this.employeeGroups[j].employees.slice().length);
                    }
                    tmp.push(skillId);
                }else{
                    tmp.push(skillId);
                    for (let j = 0; j < this.employeeGroups.length; j++) {
                        sum = sum + (tmp.length > 0 ? this.employeeGroups[j].employees.filter(e => tmp.every(elem => view.HasSkillById(e.id, elem))).length : this.employeeGroups[j].employees.slice().length);
                    }
                    tmp.splice(index, 1);
                }
                this.customSpotMap[i].employeeCount = sum;
            }

            let helperArray = this.softSkills.slice();
            for (let i = 0; i < this.softSkills.length; i++) {
                let sum = 0;
                let skillId = this.softSkills[i].id;
                let index = tmp.indexOf(skillId);
                if (index !== -1){
                    tmp.splice(index, 1);
                    for (let j = 0; j < this.employeeGroups.length; j++) {
                        sum = sum + (tmp.length > 0 ? this.employeeGroups[j].employees.filter(e => tmp.every(elem => view.HasSkillById(e.id, elem))).length : this.employeeGroups[j].employees.slice().length);
                    }
                    tmp.push(skillId);
                }else{
                    tmp.push(skillId);
                    for (let j = 0; j < this.employeeGroups.length; j++) {
                        sum = sum + (tmp.length > 0 ? this.employeeGroups[j].employees.filter(e => tmp.every(elem => view.HasSkillById(e.id, elem))).length : this.employeeGroups[j].employees.slice().length);
                    }
                    tmp.splice(index, 1);
                }
                helperArray[i].employeeCount = sum;
            }
            this.softSkills = helperArray.slice();
            this.$forceUpdate();

            if(window.timebars) {
                window.timebars.forEach(t => t.$refs.overlay.toggled = false);
            }
            //console.log(this.employeeGroups);
            // CODE TO UPDATE EMPLOYEE COUNT END
        }
    },




    updateHolidays: function(){
        let tholidays = {}
        for (let i in this.holidayMap) {
            let holiday = this.holidayMap[i];
            let key = this.$helpers.getMomentFromStringTZ(holiday.from).format('YYYY-MM-DD');
            if(!tholidays[key]){
                tholidays[key] = [];
            }
            tholidays[key].push(holiday);
        }
        this.customHolidayMap = tholidays;
    },

    RefreshCurrentDayLiveIndicator(){
        let view = this;
        let now = this.$helpers.getMomentTZ();
        if(now.hours() >= 8  && now.month() == this.rosterFromTo.month && now.year() == this.rosterFromTo.year
            && view.sotecWebcockpitConfig != null && !view.sotecWebcockpitConfig.disabled){


            let url = window.location.host
            let parts = url != null ? url.split('.') : ['development'];
            let subdomain = parts[0];

            if(subdomain == 'development'){
                return new Promise((resolve, reject) => {
                    resolve({validImport: false, succesfulImport: false})
                });
            } else {
                console.log("IMPORTING CURRENT DAY KPI DATA");
                return new Promise((resolve, reject) => {
                    view.$helpers.DoSotecLiveDataImport()
                    .then(() => {
                        resolve({validImport: true, succesfulImport: true})
                    })
                    .catch(error => {
                        resolve({validImport: true, succesfulImport: false})
                    })
                });
            }

        } else {
            return new Promise((resolve, reject) => {
                resolve({validImport: false, succesfulImport: false})
            });
        }

    },

    RefreshPlanningIndicator(){
        let view = this;

        view.allPlanningIndicators = {};
        view.productivitiesDaily = {};
        return new Promise((resolve, reject) => {
            view.loadPlanningIndicatorTypes()
            .then(response => {
                view.planningIndicatorTypeMap = {};
                response.data.forEach(ind => view.planningIndicatorTypeMap[ind.id] = ind);
                view.$store.commit('setPlanningIndicatorTypeMap', { planningIndicatorTypeMap: view.planningIndicatorTypeMap });
                return view.loadPlanningIndicator();
            }).then(response => {
                view.planningIndicator = {};
                view.AddPlanningIndicator(response.data, false);
                return view.loadPlanningIndicatorPlanned();
            }).then(response => {
                view.AddPlanningIndicator(response.data, true);
                resolve('Ok');
            }).catch(function (error) {
                console.log(error)
                view.$helpers.error(view.$t('global.notifications.error'), 'Fehler beim Laden der Kennzahlen!');
                resolve('Ok');
            })
        })




    },
    AddPlanningIndicator(indicators, planned){
        let view = this;

        let nowMoment = view.$helpers.getCurrentMoment();
        let dayBeforeMoment = nowMoment.clone().startOf('day');
        let viewingCurrentMonth = (nowMoment.year() == this.dateSelectionStart.year() && nowMoment.month() == this.dateSelectionStart.month());
        let salesIndicatorType = null;
        Object.values(view.planningIndicatorTypeMap).forEach(it => {
            if(it.isDefault){
                salesIndicatorType = it;
                this.displayIndicatorType = it.id;
            }
        });

        //no default found => fall back to sales trial n error
        if(salesIndicatorType == null){
           Object.values(view.planningIndicatorTypeMap).forEach(it => {
                if(['umsatz', 'sales', 'umsätze'].includes(it.name.toLowerCase()) || ['eur, euro, €'].includes(it.unit.toLowerCase)){
                    salesIndicatorType = it;
                    this.displayIndicatorType = it.id;
                }
            });
        }
        //if still none found, default to first type
        if(indicators.length > 0){
            if(salesIndicatorType == null){
                salesIndicatorType = view.planningIndicatorTypeMap[indicators[0].typeId];
                this.displayIndicatorType = indicators[0].typeId;
            }
        }
        let indicatorCountMap = {}
        indicators.forEach(i => {
            let type = view.planningIndicatorTypeMap[i.typeId];
            let sumKey = "sumAmount";
            if(type.sumBehavior == 2){
                sumKey = "avgAmount"
            }
            if(!view.allPlanningIndicators[i.typeId]){
                view.allPlanningIndicators[i.typeId] = {
                    indicatorType: view.planningIndicatorTypeMap[i.typeId],
                    currentMonth: viewingCurrentMonth,
                    plannedUntilTodaySum: 0,
                    actualUntilTodaySum: 0,
                    plannedSum: 0,
                    actualSum: 0,
                    sumBehavior: type.sumBehavior,
                    plannedDayMap: {},
                    actualDayMap: {}
                };
            }
            if(!indicatorCountMap[i.typeId]){
                indicatorCountMap[i.typeId] = {
                    plannedUntilTodayCount: 0,
                    actualUntilTodayCount: 0,
                    plannedTotalCount: 0,
                    actualTotalCount: 0
                };
            }
            let iMoment = view.$helpers.getMomentFromStringTZ(i.date, 'YYYY-MM-DD');
            if(planned){
                if(this.dateSelectionStart != null && this.dateSelectionStart.month() == iMoment.month()){
                    view.allPlanningIndicators[i.typeId].plannedSum += i[sumKey];
                    view.allPlanningIndicators[i.typeId].plannedDayMap[i.date] = i[sumKey];
                    indicatorCountMap[i.typeId].plannedTotalCount +=1;
                    if(viewingCurrentMonth && iMoment < dayBeforeMoment){
                        view.allPlanningIndicators[i.typeId].plannedUntilTodaySum += i[sumKey];
                        indicatorCountMap[i.typeId].plannedUntilTodayCount +=1;
                    }
                }
            }else{
                if(this.dateSelectionStart != null && this.dateSelectionStart.month() == iMoment.month()){
                    view.allPlanningIndicators[i.typeId].actualSum += i[sumKey];
                    view.allPlanningIndicators[i.typeId].actualDayMap[i.date] = i[sumKey];
                    indicatorCountMap[i.typeId].actualTotalCount +=1;
                    if(viewingCurrentMonth && iMoment < dayBeforeMoment){
                        view.allPlanningIndicators[i.typeId].actualUntilTodaySum += i[sumKey];
                        indicatorCountMap[i.typeId].actualUntilTodayCount +=1;
                    }
                }
            }

            if(i.typeId == salesIndicatorType.id){
                if(!view.productivitiesDaily[i.date]) view.productivitiesDaily[i.date] = {
                    amount: 0,
                    amountPlanned: 0,
                    amountActual: 0
                };
                if(planned) view.productivitiesDaily[i.date].amountPlanned += i.sumAmount;
                if(!planned) view.productivitiesDaily[i.date].amountActual += i.sumAmount;
                if(!planned || view.productivitiesDaily[i.date].amount == 0){
                    view.productivitiesDaily[i.date].amount += i.sumAmount;
                    view.productivitiesDaily[i.date].actual = !planned;
                }
            }

            if(i.typeId == this.displayIndicatorType){
                if(!view.planningIndicator[i.date]) view.planningIndicator[i.date] = {};
                if(planned) view.planningIndicator[i.date].planned = i;
                if(!planned) view.planningIndicator[i.date].actual = i;
                i.dateMoment = iMoment;
            }
        });
        Object.values(view.planningIndicatorTypeMap).forEach(it => {
            if(it.sumBehavior == 2 && view.allPlanningIndicators[it.id] && indicatorCountMap[it.id]){
                let stats = view.allPlanningIndicators[it.id];
                let counts = indicatorCountMap[it.id];

                if(counts.actualUntilTodayCount > 0){
                    stats.actualUntilTodaySum = Math.round(stats.actualUntilTodaySum/counts.actualUntilTodayCount)
                }
                if(counts.plannedUntilTodayCount > 0){
                    stats.plannedUntilTodaySum = Math.round(stats.plannedUntilTodaySum/counts.plannedUntilTodayCount)
                }
                if(counts.actualUntilTodayCount > 0){
                    stats.actualSum = Math.round(stats.actualSum/counts.actualTotalCount)
                }
                if(counts.plannedTotalCount > 0){
                    stats.plannedSum = Math.round(stats.plannedSum/counts.plannedTotalCount)
                }

            }

        });
    },
    loadPlanningIndicatorDaily(date) {

        let url = '/api/sec/planningindicator';

        let params = {
            storeId: this.$store.state.storeId,
            from: date.clone().startOf('day').format(),
            to: date.clone().startOf('day').add(1,'days').format()
        }
        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })


    },
    loadPlanningIndicatorGroupedByHour(date) {

        let url = '/api/sec/planningindicator/grouped/hour';

        let params = {
            storeId: this.$store.state.storeId,
            from: date.clone().startOf('day').format(),
            to: date.clone().startOf('day').add(1,'days').format()
        }
        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })


    },
    loadPlanningIndicator : function() {

        let url = '/api/sec/planningindicator/grouped';

        let params = {
                    storeId: this.$store.state.storeId,
                    from: this.$store.state.rosterFromTo.from,
                    to: this.$store.state.rosterFromTo.to,
                    planned: false
        };

        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })

    },
    loadPlanningIndicatorPlanned : function() {

        let url = '/api/sec/planningindicator/grouped';

        let params = {
            storeId: this.$store.state.storeId,
            from: this.$store.state.rosterFromTo.from,
            to: this.$store.state.rosterFromTo.to,
            planned: true
        };

        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })


    },
    loadPlanningIndicatorTypes : function() {

        let url = '/api/sec/planningindicatortype';

        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planningindicatortype');


        return this.axios({
            method: 'get',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })

    },


    updateShiftSkills: function(){
        let tskills = {}
        for (let i in this.shiftSkillMap) {
            let data = this.shiftSkillMap[i];
            if(!tskills[data.shiftId]){
               tskills[data.shiftId] = [];
            }
            tskills[data.shiftId].push(data);
        }
        this.customShiftSkillMap = tskills;
    },
    loadEmployeeRules : function() {
        this.loadingText = "Mitarbeiterregeln werden geladen";

      let url = '/api/sec/employeerules';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeerules');

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })


    },

    removeShiftFromEmployee(shiftId){
        let oldShift = this.planShiftMap[shiftId];
        if(oldShift){
            let oldShiftDate = this.$helpers.getMomentFromStringTZ(oldShift.from);
            let fromDateKey = oldShift.fromDate.format('YYYY-MM-DD');
            if(oldShift.employeeId && this.employeeMap[oldShift.employeeId]){

                if(this.employeeMap[oldShift.employeeId].shifts){
                    let index = this.employeeMap[oldShift.employeeId].shifts.findIndex(shift => shift.id == oldShift.id)
                    if (~index) {
                        this.employeeMap[oldShift.employeeId].shifts.splice(index, 1);
                    }
                }
                if(this.employeeMap[oldShift.employeeId].shiftsDate && this.employeeMap[oldShift.employeeId].shiftsDate[fromDateKey]){
                    let index = this.employeeMap[oldShift.employeeId].shiftsDate[fromDateKey].findIndex(shift => shift.id == oldShift.id)
                    if (~index) {
                        this.employeeMap[oldShift.employeeId].shiftsDate[fromDateKey].splice(index, 1);
                    }
                }

            }
            let index = this.planshifts.findIndex(shift => shift.id == oldShift.id)
            if (~index) {
                this.planshifts[index].employeeId = null;
                this.planshifts[index].pinned = false;
                this.planshifts[index].employee = "";
            }
            this.$set(this.customPlanShiftMap[oldShift.id], 'employeeId', null);
            this.$set(this.customPlanShiftMap[oldShift.id], 'pinned', false);
            this.$set(this.customPlanShiftMap[oldShift.id], 'preview', false);

        }
    },
    replaceShifts(newShifts, preview){
        for(let i = 0; i<newShifts.length; i++){
            let newShift = newShifts[i];
            let oldShift = this.customPlanShiftMap[newShift.id];


            if(oldShift != null && !oldShift.published){


                let fromDateKey = oldShift.fromDate.format('YYYY-MM-DD');
                if(oldShift.employeeId && this.employeeMap[oldShift.employeeId]){

                    if(this.employeeMap[oldShift.employeeId].shifts){
                        let index = this.employeeMap[oldShift.employeeId].shifts.findIndex(shift => shift.id == oldShift.id)
                        if (~index) {
                            this.employeeMap[oldShift.employeeId].shifts.splice(index, 1);
                        }
                    }
                    if(this.employeeMap[oldShift.employeeId].shiftsDate && this.employeeMap[oldShift.employeeId].shiftsDate[fromDateKey]){
                        let index = this.employeeMap[oldShift.employeeId].shiftsDate[fromDateKey].findIndex(shift => shift.id == oldShift.id)
                        if (~index) {
                            this.employeeMap[oldShift.employeeId].shiftsDate[fromDateKey].splice(index, 1);
                        }
                    }

                }

                let index = this.planshifts.findIndex(shift => shift.id == oldShift.id)
                //let newFromDate = this.$helpers.getMomentFromStringTZ(newShift.from, 'YYYY-MM-DDTHH:mmZ')
                //let newToDate = this.$helpers.getMomentFromStringTZ(newShift.to, 'YYYY-MM-DDTHH:mmZ')
                if (~index) {
                    this.planshifts[index].employeeId = newShift.employeeId;
                    //this.planshifts[index].from = newShift.from;
                    //this.planshifts[index].to = newShift.to;
                    //this.planshifts[index].fromDate = newFromDate;
                    //this.planshifts[index].toDate = newToDate;
                    if(!this.$helpers.isBlank(newShift.employeeId) && this.employeeMap[newShift.employeeId]){
                        this.planshifts[index].employee = this.employeeMap[newShift.employeeId].firstName+" "+this.employeeMap[newShift.employeeId].lastName;
                    } else {
                        this.planshifts[index].employee = "";
                    }

                }
                oldShift.employeeId = newShift.employeeId;
                this.$set(this.customPlanShiftMap[oldShift.id], 'employeeId', newShift.employeeId);
                //this.$set(this.customPlanShiftMap[oldShift.id], 'from', newShift.from);
                //this.$set(this.customPlanShiftMap[oldShift.id], 'to', newShift.to);
                //this.$set(this.customPlanShiftMap[oldShift.id], 'fromDate', newFromDate);
                //this.$set(this.customPlanShiftMap[oldShift.id], 'toDate', newToDate);
                fromDateKey = this.customPlanShiftMap[oldShift.id].fromDate.format('YYYY-MM-DD');
                if(preview){
                    this.$set(this.customPlanShiftMap[oldShift.id], 'preview', true);
                }

                let employee = this.employeeMap[newShift.employeeId];



                if(employee)
                {
                        if(!employee.shifts) employee.shifts = [];
                        if(!employee.shiftsDate) employee.shiftsDate = {};
                        employee.shifts.push(this.customPlanShiftMap[oldShift.id]);
                        if(!employee.shiftsDate[fromDateKey]) employee.shiftsDate[fromDateKey] = [];
                        employee.shiftsDate[fromDateKey].push(this.customPlanShiftMap[oldShift.id]);
                }
            }
        }
        this.customPlanShiftMapUpdated = this.customPlanShiftMapUpdated*-1;
        console.log("REPLACE SHIfTS")
        this.RefreshVeryImportantData();


    },
    UpdatePlannedActualMapEntry(employee,shift){
        //remove shift from the employee which the shift is safed to.
        //update the employee where the shift was moved to
    },

    UpdateHoverPlannedActual(employeeId){
        this.plannedActualDragging.employeeIdNew = employeeId;
    },



    sortHelper(a,b){
        return (this.$helpers.getMomentFromStringTZ(a.date) <= b.date) ? 1 : -1; // sort desc

    },




    GenerateEmployeeShiftsFromMap(){ //TODO Check if this method can be killed
        let view = this;
        let planShiftMap = Object.values(this.planShiftMap);
        Object.values(view.employeeMap).forEach(function(e){
            e.shifts = [];
            e.shiftsDate = {};
        });
        for (let i = 0; i < planShiftMap.length; i++) {
            (function(planShiftMap){
                let employee = view.employeeMap[planShiftMap.employeeId];
                if(employee)
                {
                    if(!employee.shifts) employee.shifts = [];
                    if(!employee.shiftsDate) employee.shiftsDate = {};
                    employee.shifts.push(planShiftMap);
                    if(!employee.shiftsDate[planShiftMap.fromDate.format('YYYY-MM-DD')]) employee.shiftsDate[planShiftMap.fromDate.format('YYYY-MM-DD')] = [];
                        if(!employee.shiftsDate[planShiftMap.fromDate.format('YYYY-MM-DD')]) employee.shiftsDate[planShiftMap.fromDate.format('YYYY-MM-DD')] = [];
                    employee.shiftsDate[planShiftMap.fromDate.format('YYYY-MM-DD')].push(planShiftMap);
                }
            })(planShiftMap[i]);
        }
        this.$forceUpdate();
    },
    loadCollectiveContracts : function() {
        this.loadingText = "Vertragsmodelle werden geladen";

      let url = '/api/semi/collectivecontract';

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })


    },

    loadEmployeeWorkBalances : function(payload) {
        this.loadingText = "Monatsabschlüsse werden geladen";
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let view = this;
            let url = '/api/sec/employeeworkbalance/any/employee';
            //load from 2 months ago and from 1 month ago
            let currentMonthStart = this.$helpers.getMomentFromValuesUTC(this.rosterFromTo.year, this.rosterFromTo.month, 1);

            let pastMonthDateStart = currentMonthStart.clone().subtract(2, 'month');
            let pastMonthDateEnd = pastMonthDateStart.clone().date(2).add(1,'month');
            let params = {
                storeId: this.$store.state.storeId,
                from: pastMonthDateStart.format(),
                to: pastMonthDateEnd.format()
            };

            return this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            })
        }


    },
    hideModal(ref) {
        this.$refs[ref].hide();
    },
    showModal(ref) {
        this.$refs[ref].show()
    },

    CloseEmployeeDetails: function () {
        this.employeeSelected = null;
    },
    SelectEmployee: function ($event, employee) {
                if(window.mouse.element.classList.contains('detail')) {
                    return;
                } else {

                    if (!employee || !employee.id || employee.id === '') return;
                    if(this.employeeSelected === employee){
                        this.employeeSelected = null;
                    } else {
                        this.employeeSelected = employee;
                        this.productivityExpanded = false;
                        let view = this;
                        requestAnimationFrame(function(){

                            let element = view.$el.querySelector('.scrollbar-container');
                            let offsetx = -1 * element.scrollLeft;
                            let offsety = -1 * element.scrollTop;
                            $(view.$el).find('.employee-hours.interactive').css({
                                'margin-left': (-1 * offsetx) + 'px',
                                'margin-top': (-1 * offsety) + 'px',
                            });
                            $(view.$el).find('.employee-hours.buheader').css({
                                'margin-left': (-50 - offsetx) + 'px',
                            });
                        });
                    }

                }
            },
            UpdateMouse: function () {
                this.posx = event.pageX;
            },
            DragStartEmployee: function ($event, employeeGroup,indexGroup,employee){
                let view = this;
                setTimeout(function(){
                    if(!window.mouse.click) return;

                    //show all units and collapse all units
                    for(let x in view.employeeGroups){
                        view.employeeGroups[x].collapsed = true;
                        view.employeeGroups[x].show = true;
                    }


                    //add helper units for easier dropping of a dragged item
                    let helperArray = [];
                    for(let i = 0; i < view.employeeGroups.length;i++){
                        if(view.employeeGroups[i].show){
                            let group = {};
                            group.label = '';
                            group.bUnit = null;
                            group.collapsed = true;
                            group.employees = [];
                            group.employeesFiltered = [];
                            group.draggable = false;
                            group.show = true;
                            group.helper = true;
                            group.indentationLevel = view.employeeGroups[i].indentationLevel;

                            helperArray.push(view.employeeGroups[i]);
                            helperArray.push(group);
                        }
                    }
                    view.employeeGroups = helperArray.slice();

                    view.draggingEmployee = true;
                    let event = $event;
                    view.$refs.dragemployee.DragStart(event.pageX, event.pageY, indexGroup,employee);
                    view.$refs.dragemployee.callbackEnd = view.DragEndEmployee;
                }, 200);
            },
            DragEndEmployee: function (closest,employee) {
                let view = this;
                view.draggingEmployee = false;

                for(let i = 0; i < this.employeeGroups.length; i++){
                    if(i == (view.dropIndexBusinessUnit-1)){
                        let spotId = null;
                        let unitName = null;
                        if(this.employeeGroups[i].spot != null){
                            spotId = this.employeeGroups[i].spot.id;
                        }

                        let url = '/api/sec/employee/linkspot';
                        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/linkspot');

                        let payload = {id: employee.id, spotId: spotId, deleteOldSkill: false, skillValue: 10}
                        //ToDo : alter Skill bleibt bestehen, Skill in neuem Spot default 10
                        this.axios({
                            method: 'put',
                            headers: {
                                'AUTHORIZATION': "bearer "+this.$store.state.jwt
                            },
                            url: url,
                            data: payload
                        }).then(response => {
                            employee.spotId = spotId;
                            view.employeeMap[employee.id].spotId = spotId;
                            view.$helpers.GetEmployeeSkillMap(true).then(response => {
                                view.updateEmployeeSkills();
                                view.updateSpots();
                                view.initializeDisplayedSpots();
                                view.sortEmployeeGroups();
                                let prefMaps = view.RefreshEmployeePreferenceMaps();
                                let shiftMaps = view.RefreshShiftMaps();


                                //must be after refresh shiftmaps
                                view.RefreshLegalMap(shiftMaps, prefMaps);
                                view.RefreshRosterContentMap();
                                view.LoadAssignedShiftSpotListToolTipMap();

                            });



                            //console.log(response);
                        }).catch(function (error) {
                            console.log(error)
                            view.updateSpots();
                            view.initializeDisplayedSpots();
                            view.sortEmployeeGroups();
                            view.RefreshRosterContentMap();
                            view.LoadAssignedShiftSpotListToolTipMap();
                        })
                        break;
                    }
                }


            },

            GetDayClasses(employeeId, dateKey){
            return {
                    Green: !this.employeeDayStatusMap[employeeId][dateKey].hasPreview && this.rosterContentMap[employeeId][dateKey].showInRoster == 'plan',
                    Yellow: this.employeeDayStatusMap[employeeId][dateKey].hasPreview && this.rosterContentMap[employeeId][dateKey].showInRoster == 'plan',
                    Orange: this.rosterContentMap[employeeId][dateKey].showInRoster == 'ist' && true /* && confirmed */,
                    Undesired: this.rosterContentMap[employeeId][dateKey].showInRoster == 'undesired',
                    Desired: this.rosterContentMap[employeeId][dateKey].showInRoster == 'desired',
                    'in-range': this.employeeDayStatusMap[employeeId][dateKey].inRange,
                    'out-of-range': !this.employeeDayStatusMap[employeeId][dateKey].inRange
                }
            },

            DragStartBusinessUnit: function ($event, employeeGroup,indexGroup){
                let view = this;
                setTimeout(function(){
                    if(!window.mouse.click) return;
                    //hide logical units and collapse all units
                    for(let x in view.employeeGroups){
                        view.employeeGroups[x].collapsed = true;
                        if(view.employeeGroups[x].spot == null || view.employeeGroups[x].spot.id === employeeGroup.spot.id){
                            view.employeeGroups[x].show = false;
                        }else{
                            view.employeeGroups[x].show = true;
                        }
                    }
                    let helperArray = [];


                    if(employeeGroup.spot.isMain){
                        // Haupt Spot - Business Unit
                        //add helper units for easier dropping of a dragged item
                        for(let i = 0; i < view.employeeGroups.length;i++){
                            if(view.employeeGroups[i].show){
                                if(view.employeeGroups[i].spot.isMain){
                                    let group = {};
                                    group.label = '';
                                    group.spot = null;
                                    group.collapsed = true;
                                    group.employees = [];
                                    group.employeesFiltered = [];
                                    group.draggable = false;
                                    group.show = true;
                                    group.helper = true;
                                    group.indentationLevel = 0;
                                    helperArray.push(group);
                                }
                                helperArray.push(view.employeeGroups[i]);
                            }
                        }
                        let group = {};
                        group.label = '';
                        group.spot = null;
                        group.collapsed = true;
                        group.employees = [];
                        group.employeesFiltered = [];
                        group.draggable = false;
                        group.show = true;
                        group.helper = true;
                        group.indentationLevel = 0;
                        helperArray.push(group);
                    }else{
                        // Neben Spot - also Child
                        //add helper units for easier dropping of a dragged item
                        for(let i = 0; i < view.employeeGroups.length;i++){
                            if(view.employeeGroups[i].show){
                                helperArray.push(view.employeeGroups[i]);// We need to show every employeeGroup Entry. but helpers only to childs

                                if(employeeGroup.spot.unitId == view.employeeGroups[i].spot.unitId){
                                    //now we are in the same unit ID
                                    //You can only drop the childs to the same unit id
                                    let group = {};
                                    group.label = '';
                                    group.spot = null;
                                    group.collapsed = true;
                                    group.employees = [];
                                    group.employeesFiltered = [];
                                    group.draggable = false;
                                    group.show = true;
                                    group.helper = true;
                                    group.indentationLevel = 1;
                                    helperArray.push(group);
                                }
                            }
                        }
                    }
                    view.employeeGroups = helperArray.slice();//This line also removes the "not categorized group"

                    view.draggingBusinessUnit = true;
                    let event = $event;
                    view.$refs.dragbusinessunit.DragStart(view,event.pageX, event.pageY, employeeGroup,indexGroup);
                    view.$refs.dragbusinessunit.callbackEnd = view.DragEndBusinessUnit;
                }, 500);
            },
            DragEndBusinessUnit: function (dragging,closest) {
                this.draggingBusinessUnit = false;
                let newSorted = [];

                let skip = [];
                if(dragging.indentationLevel == 0){
                    for(let j = 0; j < this.employeeGroups.length; j++){
                        if(!this.employeeGroups[j].helper && dragging.spot.unitId == this.employeeGroups[j].spot.unitId){
                            skip.push(j);
                        }
                    }
                }

                for(let i = 0; i < this.employeeGroups.length; i++){
                    if(skip.includes(i)){
                        continue;
                    }
                    if(!this.employeeGroups[i].helper){
                        //IF the employeeGroup is not helper, then copy
                        newSorted.push(this.employeeGroups[i]);
                    }
                    if(i == this.dropIndexBusinessUnit){
                        //We found the helper, where we want to drop
                        newSorted.push(dragging);//First drop the major group
                        if(this.employeeGroups[i].indentationLevel == 0){
                            for(let j = 0; j < this.employeeGroups.length; j++){
                                if(!this.employeeGroups[j].helper && dragging.spot.unitId == this.employeeGroups[j].spot.unitId){
                                    newSorted.push(this.employeeGroups[j]);
                                }
                            }
                        }
                    }
                }

                for(let i = 0; i < newSorted.length; i++){
                    newSorted[i].collapsed = newSorted[i].employeesFiltered.length <= 0;
                    newSorted[i].helper = false;
                    newSorted[i].show = newSorted[i].employees.length > 0;
                }
                newSorted.push(this.computeEmployeeGroup(null));//Push the not categorized group

                this.employeeGroups = newSorted.slice();
                this.filterEmployees();
                this.$forceUpdate();

                //SEND POST REQUEST TO UPDATE NEW SORTING
                let toSendArray = [];
                for(let i = 0; i < this.employeeGroups.length; i++){
                    if(this.employeeGroups[i].spot != null){
                        let id = this.employeeGroups[i].spot.id;
                        toSendArray.push({unitId: id,priority: i});
                    }
                }
                this.SendBusinessUnitsPriorityUpdate(toSendArray);
            },
            updateParentFromSpot: function(spotId,parentId){
                let view = this;
                let url = '/api/sec/spot';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/spot');

                let payload = {
                id: spotId,
                parentId: parentId,
                updateFields: ["parentId"]
                }

                this.axios({
                    method: 'put',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                }).catch(function (error) {
                    console.log(error)
                })

            },



            SendBusinessUnitsPriorityUpdate: function(data){
                let view = this;

                let map = {};
                for(let x in data){
                    map[x] = data[x];
                }
                this.$store.commit('setUserUnitSortMap', {'userUnitSortMap' : map});

                let url = '/api/sec/userunitsortupdate';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/userunitsortupdate');
                let payload = {
                  data: data
                }
                this.axios({
                    method: 'put',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    view.$helpers.success(view.$t('global.notifications.saved'), view.$t('shift.template.newOrderSaved'));
                }).catch(function (error) {
                    view.$helpers.warning(view.$t('global.notifications.error'), view.$t('global.notifications.errorMessage'));
                    view.error=true;
                    console.log(error)
                })
            },




            DragStart: function ($event, employee, indexweek, index) {
                let roster = this;
                /*let mousetemp = {x: window.mouse.x, y: window.mouse.y};
            || Math.abs(mousetemp.x - window.mouse.x) < 10 || Math.abs(mousetemp.y - window.mouse.y) < 10*/
                setTimeout(function(){
                    if(!window.mouse.click) return;
                    roster.dragging = true;
                    let event = $event;
                    roster.$refs.drag.htmlContent = '';
                    roster.$refs.drag.DragStart(event.pageX, event.pageY, {employee: employee, date: ''});
                }, 200);
            },
            SelectShiftUnassigned(shift){
                this.dayModeShiftSelected = this.dayModeShiftSelected === shift ? null : shift;
                this.shiftsSelected = [];
                if(this.dayModeShiftSelected) {
                    this.shiftsSelected.push(shift);
                }
            },
            DragStartShiftUnassigned ($event, shifts) {
                this.$helpers.DragShift(shifts, this);
                return;

            },
            DragStartShift: function ($event, shifts) {
                this.$helpers.DragShift(shifts, this, $event.currentTarget);
                return;
            },
            DragEndShift: function (shift) {
                let view = this;
                //this.plannedActualDragging.employeeIdOld = null;
                view.dragShift = null;

                if(!this.dragging) return;
                requestAnimationFrame(function(){
                    view.dragging = false;
                });

                let shiftDragSuccess = false;

                let timebar = $(window.mouse.element).closest('.time-bar-new');
                if(timebar && timebar.length > 0){
                    let timebarComponent = window.timebars ? window.timebars.find(t => t.$el === timebar[0]) : false;
                    if(timebarComponent){
                        //if((parseInt(this.$helpers.getMomentTZ().hours(0).minutes(0).format('x')) >= parseInt(timebarComponent.day.format('x')))) return;
                        let employee = timebarComponent.eventProp.employee;
                        if(employee){
                            shiftDragSuccess = true;
                            let employeePrev = this.employeeMap[shift.employeeId];
                            view.UpdateShift(shift, {employeeId: employee.id}, function(){

                                if(employeePrev)
                                {
                                    employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')] = employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')].filter(s => s !== shift);
                                    employeePrev.shifts = employeePrev.shifts.filter(s => s !== shift);
                                }
                                shift.employeeId = employee.id;

                                if(!employee.shiftsDate) employee.shiftsDate = {};
                                if(!employee.shifts) employee.shifts = [];
                                if(!employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')]) employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')] = [];
                                employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')].push(shift);
                                employee.shifts.push(shift);

                                view.UpdatePlannedActualMapEntry(employee,shift);
                                let mapShift = view.customPlanShiftMap[shift.id];
                                mapShift.from = shift.from = view.$helpers.convertDateStringTZ(shift.fromDate);
                                mapShift.to = shift.to = view.$helpers.convertDateStringTZ(shift.toDate);
                                view.$set(view.customPlanShiftMap, mapShift.id, mapShift);
                                setTimeout(function(){ view.ClearEmployeeFilter(); }, view.clearFilterDelay);
                                requestAnimationFrame(function(){
                                    window.timebars.forEach(t => t.Init());
                                });


                            }, function(){
                                setTimeout(function(){ view.ClearEmployeeFilter(); }, view.clearFilterDelay);
                            },
                            null,
                            true);
                        }
                    }
                }
                let day = $(window.mouse.element).closest('.day');
                if(day && day.length > 0){
                    let el = day[0];
                    let dayDate = this.$helpers.getMomentFromStringTZ(el.attributes['year'].value + '-' +el.attributes['month'].value + '-' +el.attributes['day'].value, 'YYYY-MM-DD');

                    let entry = day.closest('.entry');
                    let index = entry.parent().find('.entry').toArray().indexOf(entry[0]) - 1;

                    let employee = view.employeeMap[day.attr('employeeId')];
                    if(employee){
                        let employeePrev = view.employeeMap[shift.employeeId];
                            if(employeePrev && employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')].length > 1){
                                let shiftList = [];
                                for(let x in employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')])
                                {
                                    let shiftTemp = employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')][x];
                                    shiftList.push({label: shiftTemp.fromDate.format('HH') + ':' + shiftTemp.fromDate.format('mm') + ' - ' + shiftTemp.toDate.format('HH') + ':' + shiftTemp.toDate.format('mm'), shift: shiftTemp, employee: employee, dayDate: dayDate});
                                }
                                view.ToggleDropdownPickShift({currentTarget: el, pageY: window.mouse.y, pageX:window.mouse.x}, shiftList, 0, 10);
                            }
                            else
                            {
                                shiftDragSuccess = true;
                                view.UpdateShift(shift, {employeeId: employee.id}, function(){
                                    if(employeePrev)
                                    {
                                        employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')] = employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')].filter(s => s !== shift);
                                        employeePrev.shifts = employeePrev.shifts.filter(s => s !== shift);
                                    }
                                    shift.employeeId = employee.id;

                                    if(!employee.shiftsDate) employee.shiftsDate = {};
                                    if(!employee.shifts) employee.shifts = [];
                                    //shift.fromDate = shift.fromDate.clone().date(dayDate.date()).month(dayDate.month()).year(dayDate.year());
                                    //shift.toDate = shift.toDate.clone().date(dayDate.date()).month(dayDate.month()).year(dayDate.year());
                                    if(!employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')]) employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')] = [];
                                    employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')].push(shift);
                                    employee.shifts.push(shift);

                                    view.UpdatePlannedActualMapEntry(employee,shift);

                                    setTimeout(function(){ view.ClearEmployeeFilter(); }, view.clearFilterDelay);
                                }, function(){
                                    setTimeout(function(){ view.ClearEmployeeFilter(); }, view.clearFilterDelay);
                                },
                                null,
                                true);
                            }
                    }

                }
                if(window.timebars) {
                    window.timebars.forEach(t => t.$refs.overlay.toggled = false);
                }
                if(!shiftDragSuccess){
                    setTimeout(function(){ view.ClearEmployeeFilter(); }, view.clearFilterDelay);
                }
                this.$forceUpdate();
            },
            DragEnd: function ($event, employee, indexweek, index) {

                if(!this.dragging) return;
                let roster = this;
                requestAnimationFrame(function(){roster.dragging = false});
                let daynum = this.$helpers.getMomentFromStringTZ(this.dateSelectionStart, 'x').add((parseInt(indexweek) * 7) + parseInt(index), 'day').format('DD').substring(0, 2);
                let monthnum = this.$helpers.getMomentFromStringTZ(this.dateSelectionStart, 'x').add((parseInt(indexweek) * 7) + parseInt(index), 'day').format('MM').substring(0, 2);
                let exists = employee.calendar.filter(c => c.day === parseInt(daynum) && c.month === parseInt(monthnum));
                if (exists.length === 0) {

                    if (employee === this.$refs.drag.appendedData.employee) {
                        this.$refs.drag.appendedData.date.day = parseInt(daynum);
                        this.$refs.drag.appendedData.date.month = parseInt(monthnum);
                        this.$refs.drag.appendedData = {};
                    } else {
                        this.$refs.drag.appendedData.date.day = parseInt(daynum);
                        this.$refs.drag.appendedData.date.month = parseInt(monthnum);
                        employee.calendar.push(this.$refs.drag.appendedData.date);
                        this.$refs.drag.appendedData.employee.calendar = this.$refs.drag.appendedData.employee.calendar.filter(c => c !== this.$refs.drag.appendedData.date);

                        this.$refs.drag.appendedData = {};
                    }
                    this.$forceUpdate()
                }
            },
            GetSelectedDay: function () {
                return this.dateSelectionStart.format('DD').substring(0, 2);
            },
            GetSelectedMonth: function () {
                return this.dateSelectionStart.format('MM').substring(0, 2);
            },
            GetSelectedYear: function () {
                return this.dateSelectionStart.format('YYYY').substring(0, 4);
            },
            moment: function () {
                return this.$helpers.getMomentTZ();
            },

            hasPreference: function (employee, indexweek, index){
                let gridWeekEntry = this.gridWeekInfo[indexweek+'-'+index];
                if(!employee || !gridWeekEntry) return false;
                let currentDate = gridWeekEntry.date;



            },


            GetDayOptions(employee, indexweek, index) {
                let daynum = this.$helpers.getMomentFromStringTZ(this.dateSelectionStart, 'x').add((parseInt(indexweek) * 7) + parseInt(index), 'day').format('DD').substring(0, 2);
                let monthnum = this.$helpers.getMomentFromStringTZ(this.dateSelectionStart, 'x').add((parseInt(indexweek) * 7) + parseInt(index), 'day').format('MM').substring(0, 2);
                return [
                    {label: 'Green', color: '#6d8d23', employee: employee, daynum: daynum, monthnum: monthnum},
                    {label: 'Yellow', color: '#e3c423', employee: employee, daynum: daynum, monthnum: monthnum},
                    {label: 'Sick', color: '#e5154f', employee: employee, daynum: daynum, monthnum: monthnum},
                    {label: 'Vacations', color: '#e76e13', employee: employee, daynum: daynum, monthnum: monthnum},
                    {label: 'Remove', color: 'var(--contrast-3)', employee: employee, daynum: daynum, monthnum: monthnum}
                ];
            },
            toggleDropdownDate: function ($event, employee, indexweek, index) {
                let event = $event;
                let daynum = this.$helpers.getMomentFromStringTZ(this.dateSelectionStart, 'x').add((parseInt(indexweek) * 7) + parseInt(index), 'day').format('DD').substring(0, 2);
                let monthnum = this.$helpers.getMomentFromStringTZ(this.dateSelectionStart, 'x').add((parseInt(indexweek) * 7) + parseInt(index), 'day').format('MM').substring(0, 2);

                this.$refs.dropdown.posx = event.pageX;
                this.$refs.dropdown.posy = event.pageY;
                this.$refs.dropdown.items = [{label: 'Green', color: '#6d8d23'}, {label: 'Yellow', color: '#e3c423'}
                    , {label: 'Sick', color: '#e5154f'}, {label: 'Vacations', color: '#e76e13'}, {
                        label: 'Remove',
                        color: 'var(--contrast-3)'
                    }];
                this.$refs.dropdown.selectCallback = function (item) {
                    if (item.label !== 'Remove') employee.calendar.push({
                        day: parseInt(daynum),
                        month: parseInt(monthnum),
                        year: 2019,
                        status: item
                    });
                    else employee.calendar = employee.calendar.filter(c => c.day !== parseInt(daynum) && c.month !== parseInt(monthnum))
                    this.$forceUpdate()
                };
                this.$refs.dropdown.toggle();
            },
            OpenEditShiftPopup(shift, daypopup = null, responseCallback = null, errorCallback = null){
                let view = this;
                let from = this.planShiftMomentMap[shift.id].fromDate.clone();
                let to = this.planShiftMomentMap[shift.id].toDate.clone();
                let breakFrom = shift.breakFrom ? this.$helpers.getMomentFromStringTZ(shift.breakFrom) : from.clone();
                let CheckDatafillKeysForHiddenInverted = (...entryKeys) => {
                    if(!entryKeys.find) {
                        let temp = [];
                        temp.push(entryKeys);
                        entryKeys = temp;
                    }
                    return (entries, entry) => {
                        let value = false;
                        if(!entries){
                            return value;
                        }
                        if(!entries.length){
                            entries = Object.values(entries);
                        }
                        if(entries.length){
                            value = !entryKeys.every(k => entries.find(e => e.key === k && !e.value));
                        }
                        return value;
                    }
                };

                let defaultWorkValueRegular = null;
                if(view.storeSettings.autoResizeShifts && shift.employeeId != null){
                    let employee = this.employeeMap[shift.employeeId];

                    if(employee != null ){

                        let contract = this.employeeIdContractMap[employee.id] ? Object.values(this.employeeIdContractMap[employee.id]).find(contract => {
                            if(from >= this.employeeContractMomentMap[contract.id].fromDate && (this.employeeContractMomentMap[contract.id].toDate == null || to < this.employeeContractMomentMap[contract.id].toDate)){
                                return true;
                            } else {
                                return false;
                            }
                        }) : null;
                        if(contract != null && contract.weekWorkDaysRegular > 0 && contract.weekTimeRegular > 0){
                            defaultWorkValueRegular = contract.weekTimeRegular / contract.weekWorkDaysRegular;
                            if(defaultWorkValueRegular > 360){
                                defaultWorkValueRegular += 30;
                            }

                        }


                    }
                }


                let dataEntries = [];
                let spotItems = Object.values(this.spotMap).map(spot =>{return {value: spot.id, label: spot.name}});
                let selectedSpotItem = spotItems.find(i => i.value == shift.spotId);

                dataEntries.push({label: this.$tc('shift.main.position'), key: 'spotId', disabled: shift.templateId != null, type: 'dropdownsearch', value: shift.spotId, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: spotItems,
                            selectMultiple: false,
                            selectedItems: [selectedSpotItem],
                            selectedItem: selectedSpotItem,
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: '',
                }});


                let projectItems = [{ value: null, label: this.$t('shift.template.noProject') }];
                Object.values(view.projectMap).forEach(s => projectItems.push({label: s.name, value: s.id}));

                let locationItems = [{ value: null, label: this.$t('shift.template.ownStore')}];
                Object.values(view.locationMap).forEach(s => locationItems.push({label: s.name, value: s.id}));

                let costCenterItems = [{ value: null, label: this.$t('shift.template.ownStore') }];
                Object.values(view.mlCostCenterMap).filter(s => s.name != this.storeSettings.name).forEach(s => costCenterItems.push({label: s.name, value: s.id}));

                let selectedProjectItem = projectItems.find(i => i.value == shift.projectId);
                if(selectedProjectItem){
                    selectedProjectItem.selected = true;
                }
                let selectedLocationItem = locationItems.find(i => i.value == shift.fromLocationId);
                if(selectedLocationItem){
                    selectedLocationItem.selected = true;
                }
                let selectedCostCenterItem = costCenterItems.find(i => i.value == shift.costCenterId);
                if(selectedCostCenterItem){
                    selectedCostCenterItem.selected = true;
                }
                
                dataEntries.push({
                        label: this.$t('shift.plan.project'), key: 'projectId', hidden: false, disabled: shift.templateId != null, type: 'dropdownsearch', value: selectedProjectItem != null ? selectedProjectItem.value : null, selectMultiple: false,
                        dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: projectItems,
                            selectFirst: false,
                            selectMultiple: false,
                            selectedItems: selectedProjectItem ? [selectedProjectItem] : [],
                            selectedItem: selectedProjectItem,
                            onceSelected: function ($event, item, searchbar){
                        },
                            styleLight: true,
                        }}
                );
                dataEntries.push({
                        label: this.$t('store.settings.location'), key: 'locationId', hidden: false, disabled: shift.templateId != null, type: 'dropdownsearch', value: selectedLocationItem != null ? selectedLocationItem.value: null, selectMultiple: false,
                        dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: locationItems,
                            selectFirst: false,
                            selectMultiple: false,
                            electedItems: selectedLocationItem ? [selectedLocationItem] : [],
                            selectedItem: selectedLocationItem,
                            onceSelected: function ($event, item, searchbar){
                        },
                            styleLight: true,
                        }}
                );
                dataEntries.push({
                        label: this.$t('store.settings.costCenter'), key: 'costCenterId', hidden: false, disabled: shift.templateId != null, type: 'dropdownsearch', value: selectedCostCenterItem != null ? selectedCostCenterItem.value: null, selectMultiple: false,
                        dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: costCenterItems,
                            selectFirst: false,
                            selectMultiple: false,
                            electedItems: selectedCostCenterItem ? [selectedCostCenterItem] : [],
                            selectedItem: selectedCostCenterItem,
                            onceSelected: function ($event, item, searchbar){
                        },
                            styleLight: true,
                        }}
                );


                let dateKey = from.format("DD.MM.YYYY");
                let dateEntries = this.generateDateSelectionEntries();
                let selectedDate = dateEntries.find(item => item.label == dateKey);
                let filteredDateSelection = dateEntries.filter(item => item.value.month() == this.rosterFromTo.month);
                dataEntries.push({label: this.$t('store.settings.date'), key: 'date', hidden: false, disabled: shift.templateId != null, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: filteredDateSelection,
                            selectMultiple: false,
                            selectedItems: [selectedDate],
                            selectedItem: selectedDate,
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: '',
                }});


                dataEntries.push({label: this.$t('global.general.from'), key: 'from', hidden: false, type: 'timeframe', value: from, focusProceedKey: 'to'});
                dataEntries.push({label: this.$t('shift.main.manuallySetTo'), key: 'manuallySetTo', hidden: !view.storeSettings.autoResizeShifts, type: 'bool', value: true})
                dataEntries.push({label: this.$t('global.general.to'), key: 'to', hidden: false, disabled: !view.storeSettings.autoResizeShifts, type: 'timeframe', value: to, focusProceedKey: 'from',
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let manuallySet = datafill.entries.find(i => i.key == 'manuallySetTo').value;
                        if(manuallySet || defaultWorkValueRegular == null){
                            entryBeforeUpdate.disabled = false;
                        } else {
                            let nFrom = datafill.entries.find(i => i.key == 'from').value;
                            let nTo = nFrom.clone().add(defaultWorkValueRegular, 'minutes');
                            entryBeforeUpdate.disabled = true;
                            entryBeforeUpdate.value = nTo;
                            entryBeforeUpdate.hours = nTo.hours();
                            if(entryBeforeUpdate.hours.toString().length < 2) {
                                entryBeforeUpdate.hours = '0' + entryBeforeUpdate.hours;
                            }
                            entryBeforeUpdate.minutes = nTo.minutes();
                            if(entryBeforeUpdate.minutes.toString().length < 2) {
                                entryBeforeUpdate.minutes = '0' + entryBeforeUpdate.minutes;
                            }


                        }
                        return entryBeforeUpdate;
                    }
                });

                dataEntries.push({label: this.$t('shift.template.automaticWorkTime'), key: 'autoWorkValue', hidden: false, type: 'bool', value: shift.workValue == -1});
                dataEntries.push({divider: true, hidden: CheckDatafillKeysForHiddenInverted('autoWorkValue')});
                dataEntries.push({label: this.$t('shift.template.workTime'), key: 'workValue', hidden: shift.workValue == -1, value: shift.workValue,
                        slider: {
                            min: 0,
                            max: 24*60,
                            value: shift.workValue,
                            hideMin: true,
                            hideMax: true,
                            step: 1,
                            DisplayLabel: (val) => {
                                let hours = this.$helpers.pad2(Math.floor(val / 60));
                                let minutes = this.$helpers.pad2(val % 60);
                                return hours + ':' + minutes+"/"+(val/60).toFixed(2)+"h";
                            },
                            inputControl: true,
                            sliderInput: (x) => {return x * 60},
                            labelToInt: (x) => {return x.slice(0, -1)},
                            shorterDisplayLabel: (x) => {return (x / 60.0).toFixed(2)+'h'},
                        },
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                                let autoWorkValue = datafill.entries.find(i => i.key == 'autoWorkValue').value;

                                if(autoWorkValue && entryBeforeUpdate.value != -1){
                                    entryBeforeUpdate.value = -1;
                                    entryBeforeUpdate.slider.value = -1;
                                    entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                                }
                                if(!autoWorkValue && entryBeforeUpdate.value <= -1){
                                    entryBeforeUpdate.value = 0;
                                    entryBeforeUpdate.slider.value = 0;
                                    entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                                }

                                if(autoWorkValue){
                                    entryBeforeUpdate.hidden = true;
                                } else {
                                    entryBeforeUpdate.hidden = false;
                                }
                                return entryBeforeUpdate;
                        }

                });
                let workValueDefault = ((to - from) / 1000 / 60) - shift.breakValue;
                let hoursDefault = this.$helpers.pad2(Math.floor(workValueDefault / 60));
                let minutesDefault = this.$helpers.pad2(workValueDefault % 60);
                let workValueDefaultStr = hoursDefault + ':' + minutesDefault;
                let showDiffInitial = false;
                let diffStr = '';
                if(shift.workValue != -1){
                    showDiffInitial = true;
                    let diff = shift.workValue - workValueDefault;
                    console.log('Diff shift <--> workValue: ' + diff);
                    let prefix = diff < 0? '-' : '';
                    let hDiff = this.$helpers.pad2(Math.floor(Math.abs(diff) / 60));
                    let mDiff = this.$helpers.pad2(Math.abs(diff) % 60);
                    diffStr = prefix + hDiff + ':' + mDiff;
                }

                dataEntries.push({label: 'Normalzeit Beginn/Ende (abzgl. Pause)', key: 'workValueInfo', hidden: CheckDatafillKeysForHiddenInverted('autoWorkValue'), type: 'output', value: workValueDefaultStr});
                dataEntries.push({label: 'Arbeitszeit Zu/Abschlag', key: 'workValueInfoAdd', hidden: !showDiffInitial, type: 'output', value: diffStr, computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let autoWorkValue = datafill.entries.find(i => i.key == 'autoWorkValue').value;
                            let sfrom = datafill.entries.find(i => i.key == 'from').value;
                            let sto = datafill.entries.find(i => i.key == 'to').value;
                            let sbreakValue = datafill.entries.find(i => i.key == 'breakValue').value;
                            let sworkValue = datafill.entries.find(i => i.key == 'workValue').value;

                            let diffStr = '';
                            let showDiff = false;
                            if(sworkValue != -1){
                                let defaultWorkValue = ((to - from) / 1000 / 60) - sbreakValue;
                                let diff = sworkValue - defaultWorkValue;
                                if(diff != 0){
                                    let prefix = diff < 0? '-' : '';
                                    let hDiff = this.$helpers.pad2(Math.floor(Math.abs(diff) / 60));
                                    let mDiff = this.$helpers.pad2(Math.abs(diff) % 60);
                                    diffStr = prefix + hDiff + ':' + mDiff;
                                    showDiff = true;
                                }else{
                                    diffStr = '00:00';
                                }
                            }
                            entryBeforeUpdate.value = diffStr;

                            if(autoWorkValue){
                                entryBeforeUpdate.value = '';
                                entryBeforeUpdate.hidden = true;
                            } else {
                                entryBeforeUpdate.hidden = !showDiff;
                            }
                            return entryBeforeUpdate;
                    }});
                dataEntries.push({divider: true, hidden: CheckDatafillKeysForHiddenInverted('autoWorkValue')});
                dataEntries.push({label: this.$t('shift.template.automaticBreak'), key: 'autoBreak', hidden: false, type: 'bool', value: shift.breakFrom == null});
                dataEntries.push({label: this.$t('store.settings.breakTime'), key: 'breakValue', hidden: CheckDatafillKeysForHiddenInverted('autoBreak'),
                    type: 'slider', value: shift.breakValue, min: 0, max: 240, slider: {min: 0, max: 240, value: shift.breakValue,
                    step: 1, inputControl: true, sliderInput: (x) => {return x}}});
                dataEntries.push({label: this.$t('shift.template.breakFrom'), key: 'breakFrom', hidden: CheckDatafillKeysForHiddenInverted('autoBreak'), type: 'timeframe', value: breakFrom});
                dataEntries.push({divider: true});
                dataEntries.push({label: this.$t('shift.template.shiftTarget'), key: 'tasks', hidden: false, type: 'listentry', value: [], flexGroup: false, listEntryState:{
                        itemLabelMapping: [{key: "label", label: this.$t('roster.view.goal')}, {key: "value", label: this.$t('store.events.description')}],
                        items: shift.tasks ? shift.tasks : [],
                        maxItems: shift.tasks ? shift.tasks.length > 3 ? shift.tasks.length : 3 : 3,
                }});



                this.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        selectCallback: function (editShift) {


                            if(editShift.date != null){
                                let newFrom = editShift.date.clone().hours(editShift.from.hours()).minutes(editShift.from.minutes());
                                let newTo = editShift.date.clone().hours(editShift.to.hours()).minutes(editShift.to.minutes());
                                let newBreakFrom = null;
                                if(editShift.breakFrom != null){
                                    newBreakFrom = editShift.date.clone().hours(editShift.breakFrom.hours()).minutes(editShift.breakFrom.minutes());
                                }
                                editShift.from = newFrom;
                                editShift.to = newTo;
                                editShift.breakFrom = newBreakFrom
                            }

                            let fromMinutes = parseInt(dataEntries.find(e => e.key == 'from').minutes);
                            let fromHours = parseInt(dataEntries.find(e => e.key == 'from').hours);

                            let toMinutes = parseInt(dataEntries.find(e => e.key == 'to').minutes);
                            let toHours = parseInt(dataEntries.find(e => e.key == 'to').hours);

                            let to = editShift.from.clone();
                            if(toMinutes+toHours*60 <= fromMinutes+fromHours*60 ){
                                to = to.add(1, 'days').hours(toHours).minutes(toMinutes);
                            } else {
                                to = to.hours(toHours).minutes(toMinutes);
                            }
                            editShift.to = to;

                            if(editShift.to <= editShift.from){
                                editShift.to.add(1, 'days');
                            }
                            let breakValue = editShift.breakValue;
                            let breakFrom = editShift.breakFrom;
                            let invalidBreak = false;

                            if(editShift.autoBreak){

                                breakValue = view.$helpers.CalculateAutoBreakValueForPlanShift(editShift.employeeId != null ? view.$helpers.isUnderage(view.employeeMap[editShift.employeeId].dob, view.startOfMonth, true) : false, editShift.from, editShift.to, view.storeSettings);
                                breakFrom = null;
                            } else {
                                if(breakFrom < editShift.from){
                                    breakFrom.add(1, 'days');
                                }
                                if(breakFrom < editShift.from || breakFrom > editShift.to){
                                    invalidBreak = true;
                                }
                            }



                            if(invalidBreak){
                                view.$helpers.error(view.$t('global.notifications.error'),view.$t('shift.template.invalidBreak'))
                            } else {
                                let payload = {
                                    breakFrom: breakFrom ? breakFrom.format() : null,
                                    breakValue: breakValue,
                                    from: editShift.from.format(),
                                    to: editShift.to.format(),
                                    tasks: editShift.tasks,
                                    workValue: editShift.workValue,
                                    spotId: shift.templateId == null ? editShift.spotId : shift.spotId,
                                    projectId: editShift.projectId,
                                    fromLocationId: editShift.locationId,
                                    toLocationId: editShift.locationId,
                                    costCenterId: editShift.costCenterId,
                                }

                                // if showShiftSpots is active, we might need to resort the employee groups
                                if (view.rosterSortState.showShiftSpots && (shift.spotId !== editShift.spotId || shift.fromDate.toISOString() !== editShift.from.toISOString() || shift.toDate.toISOString() !== editShift.to.toISOString())) {
                                    if (responseCallback) {
                                        let responseCallbackTemp = responseCallback;
                                        responseCallback = () => {
                                            responseCallbackTemp();
                                            view.sortEmployeeGroups();
                                            view.RefreshRosterContentMap();
                                        }
                                    } else {
                                        responseCallback = () => {
                                            view.sortEmployeeGroups();
                                            this.RefreshRosterContentMap();
                                        }
                                    }
                                }
                                view.UpdateShift(shift, payload, responseCallback, errorCallback, daypopup);
                            }
                        }
                    },
                    header: this.$t('roster.comp.editShifts') + ': '+this.spotMap[shift.spotId].name,
                    pointerDirection: 1,
                    width: "800px",
                    expanded: true,
                    centered: true,
                });

            },
            OpenCreateShiftPopup($event, date, employeeId = null, daypopup = null){
                let view = this;
                let fromDate = date.clone().startOf('day');
                let toDate = date.clone().startOf('day');
                let currentWeekday = fromDate.isoWeekday();

                let from = date.clone().hours(8).minutes(0);
                let to = date.clone().hours(16).minutes(0);

                let CheckDatafillKeysForHiddenInverted = (...entryKeys) => {
                    if(!entryKeys.find) {
                        let temp = [];
                        temp.push(entryKeys);
                        entryKeys = temp;
                    }
                    return (entries, entry) => {
                        let value = false;
                        if(!entries){
                            return value;
                        }
                        if(!entries.length){
                            entries = Object.values(entries);
                        }
                        if(entries.length){
                            value = !entryKeys.every(k => entries.find(e => e.key === k && !e.value));
                        }
                        return value;
                    }
                };
                let spotItems = [];
                let selectedSpotItem = null;
                Object.values(view.customSpotMap).forEach(s => spotItems.push({label: s.name, value: s.id}));
                if(employeeId != null && view.employeeMap[employeeId].spotId != null){
                    let item = spotItems.find(i => i.value == view.employeeMap[employeeId].spotId);
                    if(item){
                        selectedSpotItem = item;
                        item.selected = true;
                    } else if(spotItems.length > 0) {
                        spotItems[0].selected = true;
                        selectedSpotItem = spotItems[0];
                    }


                } else if(spotItems.length > 0) {
                    spotItems[0].selected = true;
                    selectedSpotItem = spotItems[0];
                }

                let projectItems = [{ value: null, label: this.$t('shift.template.noProject') }];
                Object.values(view.projectMap).forEach(s => projectItems.push({label: s.name, value: s.id}));
                let locationItems = [{ value: null, label: this.$t('shift.template.ownStore') }];
                Object.values(view.locationMap).forEach(s => locationItems.push({label: s.name, value: s.id}));
                let costCenterItems = [{ value: null, label: this.$t('shift.template.ownStore') }];
                Object.values(view.mlCostCenterMap).filter(s => s.name != this.storeSettings.name).forEach(s => costCenterItems.push({label: s.name, value: s.id}));

                let defaultWorkValueRegular = null;
                if(view.storeSettings.autoResizeShifts && employeeId != null){
                    let employee = this.employeeMap[employeeId];

                    if(employee != null ){

                        let contract = this.employeeIdContractMap[employee.id] ? Object.values(this.employeeIdContractMap[employee.id]).find(contract => {
                            if(from >= this.employeeContractMomentMap[contract.id].fromDate && (this.employeeContractMomentMap[contract.id].toDate == null || to < this.employeeContractMomentMap[contract.id].toDate)){
                                return true;
                            } else {
                                return false;
                            }
                        }) : null;
                        if(contract != null && contract.weekWorkDaysRegular > 0 && contract.weekTimeRegular > 0){
                            defaultWorkValueRegular = contract.weekTimeRegular / contract.weekWorkDaysRegular;
                            if(defaultWorkValueRegular > 360){
                                defaultWorkValueRegular += 30;
                            }
                            to = from.clone().add(defaultWorkValueRegular, 'minutes');
                        }


                    }
                }

                let dataEntries = [
                  {label: this.$t('roster.view.employeeId'), key: 'employeeId', hidden: true, type: 'text', value: employeeId},
                  {label: this.$t('roster.view.dateFrom'), key: 'validFrom', hidden: false, type: 'date', value: fromDate,flexGroup: true},
                  {label: this.$t('roster.view.dateUntil'), key: 'validTo', hidden: false, type: 'date', value: toDate,flexGroup: true},
                  { label: this.$tc('store.settings.weekdays', 2),
                        key: 'weekDays', hidden: false, flexGroup: false, type: 'togglelist', toggleEntries: [
                            { label: this.$t('store.openingHours.weekDay1Short'), value: 1, selected: currentWeekday === 1 },
                            { label: this.$t('store.openingHours.weekDay2Short'), value: 2, selected: currentWeekday === 2 },
                            { label: this.$t('store.openingHours.weekDay3Short'), value: 3, selected: currentWeekday === 3 },
                            { label: this.$t('store.openingHours.weekDay4Short'), value: 4, selected: currentWeekday === 4 },
                            { label: this.$t('store.openingHours.weekDay5Short'), value: 5, selected: currentWeekday === 5 },
                            { label: this.$t('store.openingHours.weekDay6Short'), value: 6, selected: currentWeekday === 6 },
                            { label: this.$t('store.openingHours.weekDay7Short'), value: 7, selected: currentWeekday === 7 },
                        ]
                  },
                  {label: this.$t('global.general.from'), key: 'from', hidden: false, type: 'timeframe', value: from, focusProceedKey: 'to'},
                  {label: this.$t('shift.main.manuallySetTo'), key: 'manuallySetTo', hidden: !view.storeSettings.autoResizeShifts, type: 'bool', value: !view.storeSettings.autoResizeShifts},
                  {label: this.$t('global.general.to'), key: 'to', hidden: false, type: 'timeframe', value: to, focusProceedKey: 'from', disabled: view.storeSettings.autoResizeShifts,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let manuallySet = datafill.entries.find(i => i.key == 'manuallySetTo').value;
                        if(manuallySet || defaultWorkValueRegular == null){
                            entryBeforeUpdate.disabled = false;
                        } else {
                            let nFrom = datafill.entries.find(i => i.key == 'from').value;
                            let nTo = nFrom.clone().add(defaultWorkValueRegular, 'minutes');
                            entryBeforeUpdate.disabled = true;
                            entryBeforeUpdate.value = nTo;
                            entryBeforeUpdate.hours = nTo.hours();
                            if(entryBeforeUpdate.hours.toString().length < 2) {
                                entryBeforeUpdate.hours = '0' + entryBeforeUpdate.hours;
                            }
                            entryBeforeUpdate.minutes = nTo.minutes();
                            if(entryBeforeUpdate.minutes.toString().length < 2) {
                                entryBeforeUpdate.minutes = '0' + entryBeforeUpdate.minutes;
                            }


                        }
                        return entryBeforeUpdate;
                    }
                  },
                  {label: this.$tc('shift.main.position'), key: 'spotId', hidden: false, type: 'dropdownsearch', value: selectedSpotItem != null ? selectedSpotItem.value : null, selectMultiple: false,
                  dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: spotItems,
                    selectFirst: false,
                    selectMultiple: false,
                    selectedItems: [selectedSpotItem],
                    selectedItem: selectedSpotItem,
                    onceSelected: function ($event, item, searchbar){
                  },
                      styleLight: true,
                  }},
                  {label: this.$t('shift.plan.project'), key: 'projectId', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: projectItems,
                    selectFirst: false,
                    selectMultiple: false,
                    selectedItems: [],
                    onceSelected: function ($event, item, searchbar){
                  },
                      styleLight: true,
                  }},
                  {label: this.$t('store.settings.location'), key: 'locationId', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: locationItems,
                    selectFirst: false,
                    selectMultiple: false,
                    selectedItems: [],
                    onceSelected: function ($event, item, searchbar){
                  },
                      styleLight: true,
                  }},
                  {label: this.$t('store.settings.costCenter'), key: 'costCenterId', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: costCenterItems,
                    selectFirst: false,
                    selectMultiple: false,
                    selectedItems: [],
                    onceSelected: function ($event, item, searchbar){
                  },
                      styleLight: true,
                  }},
                  {label: this.$t('shift.template.automaticWorkTime'), key: 'autoWorkValue', hidden: false, type: 'bool', value: true},
                  {label: this.$t('shift.template.workTime'), key: 'workValue', hidden: true, value: -1,
                        slider: {
                            min: 0,
                            max: 24*60,
                            value: -1,
                            hideMin: true,
                            hideMax: true,
                            step: 1,
                            DisplayLabel: (val) => {
                                let hours = this.$helpers.pad2(Math.floor(val / 60));
                                let minutes = this.$helpers.pad2(val % 60);
                                return hours + ':' + minutes+"/"+(val/60).toFixed(2)+"h";
                            },
                            inputControl: true,
                            sliderInput: (x) => {return x * 60},
                            labelToInt: (x) => {return x.slice(0, -1)},
                            shorterDisplayLabel: (x) => {return (x / 60.0).toFixed(2)+'h'},
                        },
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                                let autoWorkValue = datafill.entries.find(i => i.key == 'autoWorkValue').value;

                                if(autoWorkValue && entryBeforeUpdate.value != -1){
                                    entryBeforeUpdate.value = -1;
                                    entryBeforeUpdate.slider.value = -1;
                                    entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                                }
                                if(!autoWorkValue && entryBeforeUpdate.value <= -1){
                                    entryBeforeUpdate.value = 0;
                                    entryBeforeUpdate.slider.value = 0;
                                    entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                                }

                                if(autoWorkValue){
                                    entryBeforeUpdate.hidden = true;
                                } else {
                                    entryBeforeUpdate.hidden = false;
                                }
                                return entryBeforeUpdate;
                        }

                  },
                  {label: this.$t('shift.template.automaticBreak'), key: 'autoBreak', hidden: false, type: 'bool', value: true},

                  {label: this.$t('store.settings.breakTime'), key: 'breakValue', hidden: CheckDatafillKeysForHiddenInverted('autoBreak'),
                      type: 'slider', value: 30, min: 0, max: 240, slider: {min: 0, max: 240, value: 30, step: 1,
                      inputControl: true, sliderInput: (x) => {return x}}},
                  {label: this.$t('shift.template.breakFrom'), key: 'breakFrom', hidden: CheckDatafillKeysForHiddenInverted('autoBreak'), type: 'timeframe', value: from.clone()},
                  {label: this.$t('shift.template.workValueMultiplier'), key: 'workValueMultiplier', hidden: true, type: '', value: 1},
                  {divider: true},
                    {label: this.$t('shift.template.shiftTarget'), key: 'tasks', hidden: false, type: 'listentry', value: [], flexGroup: false, listEntryState:{
                        itemLabelMapping: [{key: "label", label: this.$t('roster.view.goal')}, {key: "value", label: this.$t('store.events.description')}],
                    }},
                ];
                let target = $event.currentTarget;

                let rosterFrom = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.from);
                let rosterTo = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.to).add(-1,'days');

                this.$helpers.OpenPopup({
                    elRelative: target,
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        errorCheck: [

                            (entries) => {
                                if(entries['validFrom'].isAfter(entries['validTo'])){
                                    return {key: 'validTo', type: 'error', label: "Bis Datum", text: ' Darf nicht vor "Von Datum" liegen'}
                                } else {
                                    return null
                                }
                            },
                            (entries) => {
                                if(entries['validFrom'].isBefore(rosterFrom) || entries['validFrom'].isAfter(rosterTo)){
                                    return {key: 'validFrom', type: 'error', label: "Von Datum", text: ' Darf nicht außerhalb des Monats liegen'}
                                } else {
                                    return null
                                }
                            },
                            (entries) => {
                                if(entries['validTo'].isBefore(rosterFrom) || entries['validTo'].isAfter(rosterTo)){
                                    return {key: 'validTo', type: 'error', label: "Bis Datum", text: ' Darf nicht außerhalb des Monats liegen'}
                                } else {
                                    return null
                                }
                            },
                        ],
                        selectCallback: function (shift) {
                            let weekDays = shift.weekDays;
                            delete shift.weekDays;
                            let fromDate = shift.validFrom;
                            delete shift.validFrom;
                            let toDate = shift.validTo;
                            delete shift.validTo;

                            shift.fromLocationId = shift.locationId;
                            shift.toLocationId = shift.locationId;
                            delete shift.locationId;

                            let fromMinutes = parseInt(dataEntries.find(e => e.key == 'from').minutes);
                            let fromHours = parseInt(dataEntries.find(e => e.key == 'from').hours);

                            let toMinutes = parseInt(dataEntries.find(e => e.key == 'to').minutes);
                            let toHours = parseInt(dataEntries.find(e => e.key == 'to').hours);

                            if(fromDate.format() == toDate.format()){
                                let to = shift.from.clone();
                                if(toMinutes+toHours*60 <= fromMinutes+fromHours*60 ){
                                    to = to.add(1, 'days').hours(toHours).minutes(toMinutes);
                                } else {
                                    to = to.hours(toHours).minutes(toMinutes);
                                }
                                shift.to = to;
                                view.CreateShift(shift, daypopup);
                            } else {
                                let requests = [];
                                let employeeId = shift.employeeId;
                                let td =  toDate.add(1,'days')
                                while(fromDate < td){

                                    if(weekDays.includes(fromDate.isoWeekday())){
                                        let s = Object.assign({}, shift);
                                        let f = fromDate.clone().hours(fromHours).minutes(fromMinutes);
                                        let t = fromDate.clone().hours(toHours).minutes(toMinutes);
                                        if(t <= f){
                                            t.add(1, 'days');
                                        }
                                        s.from = f;
                                        s.to = t;
                                        if(s.breakFrom != null){
                                            s.breakFrom = fromDate.clone().hours(s.breakFrom.hours()).minutes(s.breakFrom.minutes());
                                        }

                                        let currentContract = employeeId && view.employeeIdContractMap[employeeId] ? Object.values(view.employeeIdContractMap[employeeId]).find(contract => {
                                            if(f >= view.employeeContractMomentMap[contract.id].fromDate && (view.employeeContractMomentMap[contract.id].toDate == null || f < view.employeeContractMomentMap[contract.id].toDate)){
                                                return true;
                                            } else {
                                                return false;
                                            }
                                        }) : null;

                                        if(currentContract || employeeId == null){
                                            requests.push(s);
                                        }
                                    }



                                    fromDate = fromDate.add(1, 'days');
                                }

                                view.CreateMultipleShifts(requests, daypopup);
                            }


                        }
                    },
                    header: this.$t('roster.view.createShift'),
                    pointerDirection: 1,
                    width: "800px",
                    expanded: true,
                    centered: true,
                });

            },

            OpenCopyShiftPopup(shift, daypopup = null){
                let view = this;
                window.app.popupalerts.push({header: this.$t('roster.comp.duplicateShift') + '?', description: this.$t('roster.comp.duplicateShiftQuery'), hidden: false, callbackAccept: function(popup){
                    popup.loading = false;
                    popup.hidden = true;
                    let copyShift = Object.assign({}, shift);
                    copyShift.from = view.$helpers.getMomentFromStringTZ(copyShift.from);
                    copyShift.to = view.$helpers.getMomentFromStringTZ(copyShift.to);
                    if(copyShift.breakFrom){
                        copyShift.breakFrom = view.$helpers.getMomentFromStringTZ(copyShift.breakFrom);
                    } else {
                        copyShift.breakFrom = null;
                        copyShift.autoBreak = true;
                    }
                    copyShift.templateId = null;
                    copyShift.historicFrom = null;
                    copyShift.historicTo = null;
                    copyShift.historicBreak = null;
                    copyShift.historicWorkValue = null;
                    copyShift.employeeId = null;
                    copyShift.id = null;
                    view.CreateShift(copyShift, daypopup);




                }, callbackCancel: function(popup){
                    popup.loading = false;
                    popup.hidden = true;

                }});
            },
            CreateShift(shift, daypopup = null){
                let view = this;
                if(!view.allowFutureAssignment){
                    if(shift.employeeId != null){
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.shiftPlanningDeactivated'));
                        return;
                    }
                }
                let url = '/api/sec/planshift';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planshift');
                if(shift.to <= shift.from){
                    shift.to.add(1, 'days');
                }
                let breakValue = shift.breakValue;
                let breakFrom = shift.breakFrom;
                let invalidBreak = false;
                let invalidSpot = shift.spotId ? false : true;



                if(shift.to.diff(shift.from, 'minutes') > 1440){
                    shift.to = shift.from.clone().add(1, 'days');
                }

                if(shift.autoBreak){

                    breakValue = view.$helpers.CalculateAutoBreakValueForPlanShift(shift.employeeId != null ? view.$helpers.isUnderage(view.employeeMap[shift.employeeId].dob, view.startOfMonth, true) : false, shift.from, shift.to, view.storeSettings);
                    breakFrom = null;
                } else {
                    if(breakFrom < shift.from){
                        breakFrom.add(1, 'days');
                    }
                    if(breakFrom < shift.from || breakFrom > shift.to){
                        invalidBreak = true;
                    }
                }

                if(invalidBreak){
                   view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.template.invalidBreak'))
                } else if(invalidSpot){
                   view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.template.invalidSpot'));
                } else {
                    let payload = {
                        storeId: this.$store.state.storeId,
                        skillMultiplier: 1,
                        workValueMultiplier:1,
                        from: shift.from.format(),
                        to: shift.to.format(),
                        breakFrom: breakFrom == null ? null : breakFrom.format(),
                        historicFrom: shift.historicFrom ? view.$helpers.extractDateStringTZ(shift.historicFrom, 'YYYY-MM-DDTHH:mmZ') : null,
                        historicTo: shift.historicTo ? view.$helpers.extractDateStringTZ(shift.historicTo, 'YYYY-MM-DDTHH:mmZ') : null,
                        employeeId: shift.employeeId ? shift.employeeId : null,
                        spotId: shift.spotId ? shift.spotId : null,
                        templateId: shift.templateId ? shift.templateId : null,
                        workValue: shift.workValue ? shift.workValue : -1,
                        historicWorkValue: shift.historicWorkValue ? shift.historicWorkValue : null,
                        breakValue: breakValue,
                        holidayWorkValue: -1,
                        projectId: shift.projectId ? shift.projectId : null,
                        fromLocationId: shift.fromLocationId ? shift.fromLocationId : null,
                        toLocationId: shift.toLocationId ? shift.toLocationId : null,
                        costCenterId: shift.costCenterId ? shift.costCenterId : null,
                        tasks: shift.tasks,
                    }
                    this.axios({
                        method: 'post',
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    }).then(response => {

                        view.refreshingDelta = true;
                        if(daypopup != null){
                            daypopup.Close();
                        }
                        view.$store.commit("setPlanShiftMapEntry",response.data.data);

                        view.$nextTick(()=>{
                            view.$helpers.success(view.$t('global.notifications.success'), view.$t('roster.view.shiftCreated'))
                            view.RefreshVeryImportantDataDelta(null, payload.employeeId, null, [shift.from.clone()]);
                            if(daypopup != null){
                                daypopup.showmode = 0;
                                daypopup.ReInit();
                            }

                        });

                    }).catch(function (error) {
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.createShiftError'))
                        console.log(error)
                    })
                }


            },
            CreateMultipleShifts(shifts, daypopup = null){
                let view = this;
                if(!view.allowFutureAssignment){

                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.shiftPlanningDeactivated'));
                    return;

                }
                let url = '/api/sec/planshift/multi';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planshift/multi');

                let requests = [];
                shifts.forEach(shift => {
                    if(shift.to <= shift.from){
                        shift.to.add(1, 'days');
                    }
                    let breakValue = shift.breakValue;
                    let breakFrom = shift.breakFrom;
                    let invalidBreak = false;
                    let invalidSpot = shift.spotId ? false : true;



                    if(shift.to.diff(shift.from, 'minutes') > 1440){
                        shift.to = shift.from.clone().add(1, 'days');
                    }

                    if(shift.autoBreak){

                        breakValue = view.$helpers.CalculateAutoBreakValueForPlanShift(shift.employeeId != null ? view.$helpers.isUnderage(view.employeeMap[shift.employeeId].dob, view.startOfMonth, true) : false, shift.from, shift.to, view.storeSettings);
                        breakFrom = null;
                    } else {
                        if(breakFrom < shift.from){
                            breakFrom.add(1, 'days');
                        }
                        if(breakFrom < shift.from || breakFrom > shift.to){
                            invalidBreak = true;
                        }
                    }

                    if(!invalidBreak && !invalidSpot){
                        let payload = {
                            storeId: this.$store.state.storeId,
                            skillMultiplier: 1,
                            workValueMultiplier:1,
                            from: shift.from.format(),
                            to: shift.to.format(),
                            breakFrom: breakFrom == null ? null : breakFrom.format(),
                            historicFrom: shift.historicFrom ? view.$helpers.extractDateStringTZ(shift.historicFrom, 'YYYY-MM-DDTHH:mmZ') : null,
                            historicTo: shift.historicTo ? view.$helpers.extractDateStringTZ(shift.historicTo, 'YYYY-MM-DDTHH:mmZ') : null,
                            employeeId: shift.employeeId ? shift.employeeId : null,
                            spotId: shift.spotId ? shift.spotId : null,
                            templateId: shift.templateId ? shift.templateId : null,
                            workValue: shift.workValue ? shift.workValue : -1,
                            historicWorkValue: shift.historicWorkValue ? shift.historicWorkValue : null,
                            breakValue: breakValue,
                            holidayWorkValue: -1,
                            projectId: shift.projectId ? shift.projectId : null,
                            fromLocationId: shift.fromLocationId ? shift.fromLocationId : null,
                            toLocationId: shift.toLocationId ? shift.toLocationId : null,
                            costCenterId: shift.costCenterId ? shift.costCenterId : null,
                            tasks: shift.tasks,
                        }

                        requests.push(payload);
                    }
                })
                if(requests.length > 0){
                    let payload = {
                        requests: requests
                    }
                    this.axios({
                        method: 'post',
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    }).then(response => {


                        if(daypopup != null){
                            daypopup.Close();
                        }
                        response.data.data.forEach(shift => {
                            view.$store.commit("setPlanShiftMapEntry",shift);
                        });


                        view.$nextTick(()=>{
                            view.$helpers.success("Erfolg", this.$t('shift.main.shiftsAdded'))
                            view.RefreshVeryImportantData();
                            if(daypopup != null){
                                daypopup.showmode = 0;
                                daypopup.ReInit();
                            }

                        });

                    }).catch(function (error) {
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.main.addShiftsError'))
                        console.log(error)
                    })
                } else {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.cantCreateShifts'))
                }





            },
            ToggleDropdownPickShift: function ($event, items, indexweek, index) {
                let view = this;
                let event = $event;
                let dropdown = {};

                dropdown.posx = event.pageX;
                dropdown.posy = event.pageY;
                dropdown.items = items;
                dropdown.parentCallback = function () {
                    requestAnimationFrame(function(){
                        view.ClearEmployeeFilter();
                    });
                };
                dropdown.onceSelected = function ($event, item, dropdownReturn) {
                    let employee = item.employee;
                    let shift = item.shift;
                    let dayDate = item.dayDate;
                    let employeePrev = view.employeeMap[shift.employeeId];
                    requestAnimationFrame(function(){
                        //window.roster.filterEmployees();
                    });
                    view.UpdateShift(shift, {employeeId: employee.id},
                    function(){
                        if(employeePrev)
                        {
                            employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')] = employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')].filter(s => s !== shift);
                            employeePrev.shifts = employeePrev.shifts.filter(s => s !== shift);
                        }
                        shift.employeeId = employee.id;

                        if(!employee.shiftsDate) employee.shiftsDate = {};
                        if(!employee.shifts) employee.shifts = [];
                        shift.fromDate = shift.fromDate.clone().date(dayDate.date()).month(dayDate.month()).year(dayDate.year());
                        shift.toDate = shift.toDate.clone().date(dayDate.date()).month(dayDate.month()).year(dayDate.year());
                        if(!employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')]) employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')] = [];
                        employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')].push(shift);
                        employee.shifts.push(shift);
                        view.UpdatePlannedActualMapEntry(employee,shift);

                        view.$forceUpdate()
                        view.dropdowns = view.dropdowns.filter(d => d !== dropdownReturn);
                    },
                    function(){
                        view.ClearEmployeeFilter();
                    },
                    null,
                    true);
                };
                dropdown.toggled = true;
                this.dropdowns.push(dropdown);
            },
            ToggleDropDown: function ($event, selection, offsetx, offsety) {
                if(this.dragging) return;
                let event = $event;
                let box = $event.currentTarget.getBoundingClientRect();
                let dropdowns = this.dropdowns;
                this.dropdowns.push({
                    items: selection,
                    el: event.currentTarget,
                    remainAfterSelect: true,
                    toggled: true,
                    offsetx: offsetx,
                    offsety: offsety,
                    posx: box.left + offsetx,
                    posy: box.bottom + offsety,
                    onceSelected: function ($eventInner, item, dropdown) {
                        let eventInner = $eventInner;
                        let boxInner = eventInner.currentTarget.getBoundingClientRect();
                        if (item.label !== 'Remove') item.employee.calendar.push({
                            day: parseInt(item.daynum),
                            month: parseInt(item.monthnum),
                            year: 2019,
                            status: item
                        });
                        if (!item.items) return;
                        let temp = {
                            items: item.items,
                            //el: event.currentTarget,
                            offsetx: offsetx + 130,
                            offsety: offsety,
                            posx: box.left + offsetx + 130,
                            toggled: true,
                            posy: boxInner.bottom - 30,
                            pointerDirection: 3,
                            parentCallback: function () {
                                dropdown.toggled = false
                            }
                        };
                        dropdowns.push(temp);
                    }
                });
            },
            ToggleDropDownContainer: function ($event, employee, type, offsetx, offsety, pointerOffset, pointerDirection, mode) {
                let el = $event.currentTarget;
                let date = this.$helpers.getMomentFromStringTZ(el.attributes['year'].value + '-' +el.attributes['month'].value + '-' +el.attributes['day'].value, 'YYYY-MM-DD');
                if(this.dragging || !this.HasShift(employee.id, date.format("YYYY-MM-DD"))) return;
                this.$refs.dropdowncontainer.Init({
                    elRelative: el,
                    remainAfterSelect: true,
                    eventProp: this.GetTimeBarProp(employee, date, true),
                    currentComponent: type,
                    mode: mode,
                    pointerDirection: pointerDirection,
                });
            },
            onTimebarUpdateShift(data){
                let view = this;
                if(data.clearEmployeeFilter){
                    this.UpdateShift(data.shift, data.fields, function(){setTimeout(function(){ view.ClearEmployeeFilter(); }, view.clearFilterDelay);}, function(){setTimeout(function(){ view.ClearEmployeeFilter(); }, view.clearFilterDelay);});
                } else {
                    if(data.id){
                        let shift = this.planShiftMap[data.id];
                        this.UpdateShift(shift, data.fields);
                    } else {
                        this.UpdateShift(data.shift, data.fields);
                    }

                }
            },
            UpdateShift(shift, fields, responseCallback, errorCallback, daypopup = null, adjustShiftTime = false){

                let view = this;
                if(!view.allowFutureAssignment){
                    if(fields.employeeId != null && shift.employeeId != fields.employeeId){
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.shiftPlanningDeactivated'));
                        if(errorCallback) {
                            errorCallback();
                        }
                        return;
                    }

                }

                //auto break calculation
                let planShift = this.planShiftMap[shift.id];
                if(fields.breakFrom === null || (shift.breakFrom == null && fields.breakFrom == null)){

                    let from = this.$helpers.getMomentFromStringTZ(planShift.from);
                    if(fields.from != null){
                        from = this.$helpers.getMomentFromStringTZ(fields.from);
                    }
                    let to = this.$helpers.getMomentFromStringTZ(planShift.to);
                    if(fields.to != null){
                        to = this.$helpers.getMomentFromStringTZ(fields.to);
                    }
                    let employeeId = fields.hasOwnProperty("employeeId") ? fields.employeeId : shift.employeeId;
                    let breakValue = view.$helpers.CalculateAutoBreakValueForPlanShift(employeeId != null ? view.$helpers.isUnderage(view.employeeMap[employeeId].dob, view.startOfMonth, true) : false, from, to, view.storeSettings);
                    fields.breakFrom = null;
                    fields.breakValue = breakValue;
                }

                //auto change shift time if setting is active and if work value is set to auto
                if(fields.employeeId != null && adjustShiftTime && this.storeSettings.autoResizeShifts && (shift.workValue == -1 || fields.workValue == -1)){
                    let employee = this.employeeMap[fields.employeeId];

                    if(employee != null ){
                        let currentFrom = this.$helpers.getMomentFromStringTZ(shift.from);
                        let currentTo = this.$helpers.getMomentFromStringTZ(shift.to);
                        let contract = this.employeeIdContractMap[employee.id] ? Object.values(this.employeeIdContractMap[employee.id]).find(contract => {
                            if(currentFrom >= this.employeeContractMomentMap[contract.id].fromDate && (this.employeeContractMomentMap[contract.id].toDate == null || currentTo < this.employeeContractMomentMap[contract.id].toDate)){
                                return true;
                            } else {
                                return false;
                            }
                        }) : null;
                        if(contract != null && contract.weekWorkDaysRegular > 0 && contract.weekTimeRegular > 0){
                            let regularTime = contract.weekTimeRegular / contract.weekWorkDaysRegular;
                            console.log(regularTime);
                            currentTo = currentFrom.clone().add(regularTime, 'minutes');
                            let breakValue = view.$helpers.CalculateAutoBreakValueForPlanShift(view.$helpers.isUnderage(employee.dob, view.startOfMonth, true), currentFrom, currentTo, view.storeSettings);
                            currentTo = currentTo.add(breakValue, 'minutes');

                            fields.breakFrom = null;
                            fields.breakValue = breakValue;
                            fields.from = currentFrom.format();
                            fields.to = currentTo.format();

                        }


                    }
                }

                this.error=false;

                let url = '/api/sec/planshift';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planshift');
                let payload = {
                  storeId: this.$store.state.storeId,
                  id: shift.id,
                  updateFields: []
                }
                for(let key in fields){
                    let value = fields[key];
                    payload[key] = value;
                    payload.updateFields.push(key);
                }
                if(fields["from"] != null || fields["to"] != null){
                    //updated time, check if breakFrom needs to be updated
                    let from = this.$helpers.getMomentFromStringTZ(fields["from"]);
                    let to = this.$helpers.getMomentFromStringTZ(fields["to"]);


                    let breakFrom = fields["breakFrom"] == null ? planShift.breakFrom : fields["breakFrom"];
                    if(breakFrom != null){
                        breakFrom = this.$helpers.getMomentFromStringTZ(breakFrom);

                        if(breakFrom < from || breakFrom > to){
                            breakFrom = from.clone().add('minutes', Math.floor(Math.abs(to.diff(from, 'minutes')/2)));
                            fields["breakFrom"] = breakFrom.format();
                            payload.updateFields.push("breakFrom");
                            payload.breakFrom = breakFrom.format();
                        }
                    }

                    if(to.diff(from, 'minutes') > 1440){
                        to = from.clone().add(1, 'days');
                        fields["to"] = to.format();
                        payload.to = fields["to"];
                        fields["from"] = from.format();
                        payload.from = fields["from"];
                        payload.updateFields.push("to");
                        payload.updateFields.push("from");
                    }

                }
                if(fields["employeeId"] != undefined && fields["employeeId"] == null){
                    payload.pinned = false;
                    payload.updateFields.push("pinned");
                    fields["pinned"] = false;
                }
                if(fields["projectId"] != undefined){
                    payload.projectId = fields["projectId"];
                    payload.updateFields.push("projectId");

                }
                if(fields["fromLocationId"] != undefined){
                    payload.fromLocationId = fields["fromLocationId"];
                    payload.updateFields.push("fromLocationId");

                }
                if(fields["toLocationId"] != undefined){
                    payload.toLocationId = fields["toLocationId"];
                    payload.updateFields.push("toLocationId");

                }
                this.axios({
                    method: 'put',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    const index = view.planshifts.findIndex(s => s.id === shift.id)
                    const index2 = view.shiftsSelected.findIndex(s => s.id === shift.id);

                    let shiftMapEntry = view.planShiftMap[shift.id];
                    let oldEmployeeId = shiftMapEntry.employeeId;
                    let oldDate = view.planShiftMomentMap[shiftMapEntry.id].fromDate.clone();

                    for(let key in fields){

                        shiftMapEntry[key] = fields[key];
                        view.$set(view.customPlanShiftMap[shift.id], key, fields[key]);
                        if (~index) {

                            view.$set(view.planshifts[index], key, fields[key]);

                        }
                        if (~index2) {

                            view.$set(view.shiftsSelected[index2], key, fields[key]);

                        }


                    }

                    let newEmployeeId = shiftMapEntry.employeeId;
                    let newDate = view.$helpers.getMomentFromStringTZ(shiftMapEntry.from);


                    view.refreshingDelta = true;
                    if(daypopup != null){
                        daypopup.ReInit();
                    }
                    view.$store.commit("setPlanShiftMapEntry",shiftMapEntry);
                    view.$nextTick(()=>{

                        view.$helpers.success(view.$t('global.notifications.success'), view.$t('roster.view.shiftUpdated'));
                        if (view.rosterSortState.showShiftSpots) {
                            this.updateSpots();
                            this.sortEmployeeGroups();
                            this.RefreshRosterContentMap();
                        }
                        view.RefreshVeryImportantDataDelta(oldEmployeeId, newEmployeeId == oldEmployeeId ? null : newEmployeeId, [oldDate], newDate.format("YYYY-MM-DD") == oldDate.format("YYYY-MM-DD") ? null : [newDate]);

                    })


                    if(responseCallback) {
                        responseCallback();
                    }

                }).catch(function (error) {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.main.editShiftsError'))
                    if(errorCallback) {
                        errorCallback();
                    }
                    view.error=true;
                    console.log(error)
                });

            },

            UpdateShiftMulti(requests, responseCallback, errorCallback, adjustShiftTime = false){


                this.error=false;
                let view = this;
                let url = '/api/sec/planshift/multi';


                let params = {
                    storeId: this.$store.state.storeId
                }
                let requestPayload = {
                    storeId: this.$store.state.storeId,
                    requests: [],
                }
                let requestMap = {};
                requests.forEach(request =>{
                    let shift = request.shift;
                    let fields = request.fields;

                    //auto break calculation
                    let planShift = this.planShiftMap[shift.id];
                    if(planShift.breakFrom == null || fields.breakFrom === null){
                        let from = this.$helpers.getMomentFromStringTZ(planShift.from);
                        if(fields.from != null){
                            from = this.$helpers.getMomentFromStringTZ(fields.from);
                        }
                        let to = this.$helpers.getMomentFromStringTZ(planShift.to);
                        if(fields.to != null){
                            to = this.$helpers.getMomentFromStringTZ(fields.to);
                        }
                        let employeeId = fields.hasOwnProperty("employeeId") ? fields.employeeId : shift.employeeId;
                        let breakValue = view.$helpers.CalculateAutoBreakValueForPlanShift(employeeId != null ? view.$helpers.isUnderage(view.employeeMap[employeeId].dob, view.startOfMonth, true) : false, from, to, view.storeSettings);
                        fields.breakFrom = null;
                        fields.breakValue = breakValue;
                    }

                    //auto change shift time if setting is active and if work value is set to auto
                    if(fields.employeeId != null && adjustShiftTime && this.storeSettings.autoResizeShifts && (shift.workValue == -1 || fields.workValue == -1)){
                        let employee = this.employeeMap[fields.employeeId];

                        if(employee != null ){
                            let currentFrom = this.$helpers.getMomentFromStringTZ(shift.from);
                            let currentTo = this.$helpers.getMomentFromStringTZ(shift.to);
                            let contract = this.employeeIdContractMap[employee.id] ? Object.values(this.employeeIdContractMap[employee.id]).find(contract => {
                                if(currentFrom >= this.employeeContractMomentMap[contract.id].fromDate && (this.employeeContractMomentMap[contract.id].toDate == null || currentTo < this.employeeContractMomentMap[contract.id].toDate)){
                                    return true;
                                } else {
                                    return false;
                                }
                            }) : null;
                            if(contract != null && contract.weekWorkDaysRegular > 0 && contract.weekTimeRegular > 0){
                                let regularTime = contract.weekTimeRegular / contract.weekWorkDaysRegular;
                                console.log(regularTime);
                                currentTo = currentFrom.clone().add(regularTime, 'minutes');
                                let breakValue = view.$helpers.CalculateAutoBreakValueForPlanShift(view.$helpers.isUnderage(employee.dob, view.startOfMonth, true), currentFrom, currentTo, view.storeSettings);
                                currentTo = currentTo.add(breakValue, 'minutes');

                                fields.breakFrom = null;
                                fields.breakValue = breakValue;
                                fields.from = currentFrom.format();
                                fields.to = currentTo.format();

                            }


                        }
                    }


                    let payload = {
                        storeId: this.$store.state.storeId,
                        id: shift.id,
                        updateFields: []
                    }
                    for(let key in fields){
                        let value = fields[key];
                        payload[key] = value;
                        payload.updateFields.push(key);
                    }
                    if(fields["from"] != null || fields["to"] != null){
                        //updated time, check if breakFrom needs to be updated
                        let from = this.$helpers.getMomentFromStringTZ(fields["from"]);
                        let to = this.$helpers.getMomentFromStringTZ(fields["to"]);
                        let planShift = this.planShiftMap[shift.id];
                        let breakFrom = fields["breakFrom"] == null ? planShift.breakFrom : fields["breakFrom"];
                        if(breakFrom != null){
                            breakFrom = this.$helpers.getMomentFromStringTZ(breakFrom);

                            if(breakFrom < from || breakFrom > to){
                                breakFrom = from.clone().add('minutes', Math.floor(Math.abs(to.diff(from, 'minutes')/2)));
                                fields["breakFrom"] = breakFrom.format();
                                payload.updateFields.push("breakFrom");
                                payload.breakFrom = breakFrom.format();
                            }
                        }

                        if(to.diff(from, 'minutes') > 1440){
                            to = from.clone().add(1, 'days');
                            fields["to"] = to.format();
                            payload.to = fields["to"];
                            fields["from"] = from.format();
                            payload.from = fields["from"];
                            payload.updateFields.push("to");
                            payload.updateFields.push("from");
                        }
                    }
                    requestMap[shift.id] = fields;
                    requestPayload.requests.push(payload);
                });

                this.axios({
                    method: 'put',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: requestPayload
                }).then(response => {
                    let mapUpdatePayload = [];
                    response.data.data.forEach(updatedShiftId => {
                        const index = view.planshifts.findIndex(s => s.id === updatedShiftId)
                        const index2 = view.shiftsSelected.findIndex(s => s.id === updatedShiftId);

                        let shiftMapEntry = view.planShiftMap[updatedShiftId];
                        let fields = requestMap[updatedShiftId];
                        for(let key in fields){

                            shiftMapEntry[key] = fields[key];
                            view.$set(view.customPlanShiftMap[updatedShiftId], key, fields[key]);
                            if (~index) {

                                view.$set(view.planshifts[index], key, fields[key]);

                            }
                            if (~index2) {

                                view.$set(view.shiftsSelected[index2], key, fields[key]);

                            }


                        }
                        mapUpdatePayload.push({mapName : 'planShiftMap', entity: shiftMapEntry });
                    })
                    view.$store.commit("updateMultiple", mapUpdatePayload);
                    view.$helpers.success(view.$t('global.notifications.success'), view.$t('roster.main.shiftsEdited'))
                    view.$forceUpdate();



                    if(responseCallback) {
                        responseCallback();
                    }

                }).catch(function (error) {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.main.editShiftError'))
                    if(errorCallback) {
                        errorCallback();
                    }
                    view.error=true;
                    console.log(error)
                });

            },
            GetMonthlyCompensationSum(){
                let sum = 0;
                Object.values(this.employeeMap).forEach((empl) => {
                    sum += this.GetCompensationForEmployee(empl);
                });
                return sum;
            },
            GetCompensationForEmployee(employee){
                let lower = this.dateSelectionStart;
                let upper = this.dateSelectionStart.clone().add(1, 'months');

                let compensation = 0;
                for(let i in this.currentMonthEmployeeContractMap /*this.employeeContractMap*/){
                    let contract = this.currentMonthEmployeeContractMap[i];
                    if(contract.employeeId == employee.id){

                        let contractFrom = this.$helpers.getMomentFromStringTZ(contract.from).clone();
                        if(contractFrom < lower) contractFrom = lower.clone();
                        let contractTo = contract.to == null ? upper : this.$helpers.getMomentFromStringTZ(contract.to).clone();
                        if(contractTo > upper) contractTo = upper.clone();
                        let ratio = contractTo.diff(contractFrom) / upper.diff(lower);

                        // previous checks ensured that from >= lower and to <= upper

                        // --> only proceed if from <= upper and to >= lower otherwise contract is out of our range of interest
                        if(contractFrom <= upper && contractTo >= lower){
                            if(contract.paymentType == 1){//Gehalt
                                compensation = compensation + (((contract.payment + contract.extraPayment) / 100) * ratio);
                            }
                            if(contract.paymentType == 2){//Lohn
                                if(contract.wageType == 4){ //MonatsLohn
                                    compensation = compensation + (((contract.payment + contract.extraPayment) / 100) * ratio);
                                }else if(contract.wageType == 3){ //WochenLohn
                                    compensation = compensation + (((contract.payment + contract.extraPayment) / 100) * 4.325 * ratio);
                                }else if(contract.wageType == 2){ //TagesLohn
                                    compensation = compensation + (((contract.payment + contract.extraPayment) / 100) * upper.diff(lower, 'days') * ratio);
                                }else if(contract.wageType == 1){ //StundenLohn

                                    compensation = compensation + (((contract.payment + contract.extraPayment) / 100) * (contract.weekTimeRegular / 60) * 4.325 * ratio);
                                }
                            }
                        }
                    }
                }
                return compensation;
            },
            checkIfConfirmedActual(employee, indexweek, index){
                let elem = this.rosterContentMap[employee.id][this.gridWeekInfo[indexweek+'-'+index].dateString];
                let confirmed = elem != null && elem != undefined && elem.confirmed != null && elem.confirmed;
                return confirmed;
            },
            OpenTransferShiftsPopup(){
                let view = this;


                let employees = Object.values(view.employeeMap).map(e => {
                    return {label: e.lastName + " "+e.firstName, value: e.id}
                });


                employees.sort((a,b)=> {
                    if(a.label.toLowerCase() < b.label.toLowerCase()){
                        return -1;
                    } else if (a.label.toLowerCase() < b.label.toLowerCase()){
                        return 1;
                    }
                    return 0;
                });

                let from = this.$helpers.getMomentTZ().year(this.$store.state.rosterFromTo.year).month(this.$store.state.rosterFromTo.month).startOf('month');
                let to = from.clone().add(1, 'month');
                let temp = from.clone();
                let dates = [];

                while(temp <= to){
                    dates.push(temp.clone());
                    temp.add(1, 'days');
                }

                let dataEntries = [];
                dataEntries.push({label: this.$t('global.general.from'), key: 'from', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: this.$t('global.general.from'),
                        items: dates.map(d => {
                            return {
                                label: d.format("DD.MM.YYYY dddd"),
                                value: d,
                                selected: d.unix() == from.unix()
                            }
                        }),
                        selectFirst: true,
                    }
                });
                let toItems = dates.map(d => {
                            return {
                                label: d.format("DD.MM.YYYY dddd"),
                                value: d,
                                selected: d.unix() == to.unix()
                            }
                        });
                dataEntries.push({label: this.$t('global.general.to'), key: 'to', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: this.$t('global.general.to'),
                        items: toItems,
                        selectedItem: toItems.find(i => i.selected),
                    }
                });
                dataEntries.push({ label: this.$tc('store.settings.weekdays', 2),
                        key: 'weekDays', hidden: false, flexGroup: false, type: 'togglelist', toggleEntries: [
                            { label: this.$t('store.openingHours.weekDay1Short'), value: 1, selected: true },
                            { label: this.$t('store.openingHours.weekDay2Short'), value: 2, selected: true },
                            { label: this.$t('store.openingHours.weekDay3Short'), value: 3, selected: true },
                            { label: this.$t('store.openingHours.weekDay4Short'), value: 4, selected: true },
                            { label: this.$t('store.openingHours.weekDay5Short'), value: 5, selected: true },
                            { label: this.$t('store.openingHours.weekDay6Short'), value: 6, selected: true },
                            { label: this.$t('store.openingHours.weekDay7Short'), value: 7, selected: true },
                        ]
                  })

                dataEntries.push({label: this.$tc('roster.main.sourceEmployee'), key: 'sourceEmployee', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: this.$t('global.ui.selectEmployee'),
                        items: employees.map(e => {
                            return {
                                label: e.label,
                                value: e.value,
                                selected: false
                            }
                        }),
                    }
                });

                dataEntries.push({label: this.$tc('roster.main.targetEmployee'), key: 'targetEmployee', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: this.$t('global.ui.selectEmployee'),
                        items: employees.map(e => {
                            return {
                                label: e.label,
                                value: e.value,
                                selected: false
                            }
                        }),
                    }
                });

                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        errorCheck: [
                            (entries) => {
                                if(entries['from'] == null){
                                    return {key: 'from', type: 'error', label: this.$t('global.general.from'), text: this.$t('roster.main.selectDateRange')}
                                } else {
                                    return null
                                }
                            },
                            (entries) => {
                                if(entries['to'] == null){
                                    return {key: 'to', type: 'error', label: this.$t('global.general.to'), text: this.$t('roster.main.selectDateRange')}
                                } else {
                                    return null
                                }
                            },
                            (entries) => {
                                if(entries['from'] != null && entries['from'] != null && entries['from'].isAfter(entries['to'])){
                                    return {key: 'to', type: 'error', label: this.$t('global.general.to'), text: this.$t('roster.view.chronologicalError')}
                                } else {
                                    return null
                                }
                            },
                            (entries) => {
                                if(entries.sourceEmployee == null){
                                    return {key: 'sourceEmployee', type: 'error', label: this.$t('roster.main.sourceEmployee'), text: this.$t('roster.main.selectEmployees')}
                                } else {
                                    return null
                                }
                            },
                            (entries) => {
                                if(entries.targetEmployee == null){
                                    return {key: 'targetEmployee', type: 'error', label: this.$t('roster.main.targetEmployee'), text: this.$t('roster.main.selectEmployees')}
                                } else {
                                    return null
                                }
                            },
                            (entries) => {
                                if(entries.targetEmployee == entries.sourceEmployee){
                                    return {key: 'targetEmployee', type: 'error', label: this.$t('roster.main.targetEmployee'), text: this.$t('roster.main.selectDifferenEmployees')}
                                } else {
                                    return null
                                }
                            },
                        ],
                        selectCallback: function (data) {
                            let sourceShifts = Object.values(view.planShiftMap).filter(s => {
                                let sFrom = view.planShiftMomentMap[s.id].fromDate;
                                let sTo = view.planShiftMomentMap[s.id].toDate;

                                if(s.employeeId == data.sourceEmployee && sFrom >= data.from && sFrom < data.to && !s.published && data.weekDays.includes(sFrom.isoWeekday())){
                                    //check if target employee has a shift or preference that overlaps with source shift
                                    let targetShifts = Object.values(view.planShiftMap).filter(t => {
                                        let tFrom = view.planShiftMomentMap[t.id].fromDate;
                                        let tTo = view.planShiftMomentMap[t.id].toDate;
                                        if(t.employeeId == data.targetEmployee && tFrom < sTo && tTo > sFrom){
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    });

                                    let targetPreferences = Object.values(view.employeePreferenceMap).filter(p => {
                                        let pFrom = view.employeePreferenceMomentMap[p.id].fromDate;
                                        let pTo = view.employeePreferenceMomentMap[p.id].toDate;
                                        if(p.state == 1 && p.employeeId == data.targetEmployee && pFrom < sTo && pTo > sFrom){
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    });
                                    if(targetShifts.length == 0 && targetPreferences.length == 0){
                                        return true;
                                    } else {
                                        return false;
                                    }
                                } else {
                                    return false;
                                }
                            })

                            let requests = [];
                            sourceShifts.forEach(shift => {
                                let fields = {
                                    employeeId: data.targetEmployee,
                                }
                                requests.push({shift: shift, fields: fields});
                            })
                            if(requests.length > 0){
                                view.UpdateShiftMulti(requests, function(){
                                    view.$helpers.success(view.$t('global.notifications.success'), view.$t('roster.main.shiftsTransferred'));
                                }, function(){
                                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.main.shiftTransferError'));
                                })
                            } else {
                                view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.main.noShiftsToTransfer'));
                            }
                        }
                    },
                    header: this.$t('roster.main.transferShifts'),
                    expanded: true,
                    centered: true,
                    width: '600px',
                });
            },
            OpenExportExternalServiceCSV($event) {
                let view = this;
                let description = "Welche Daten sollen für welchen Service exportiert werden? <br/>";

                let serviceItems = [];
                Object.values(this.externalApiAccessMap).forEach(i => {
                    let item = {label: view.externalServicesMap[i.externalServiceId].name, value: i.id};
                    serviceItems.push(item);
                })
                let dataItems = [
                    {label: this.$t('shift.plan.punchTimes'), value: 1},
                    {label: "Pausen", value: 2},
                    {label: this.$tc('global.general.absence', 2), value: 3},
                ]
                let dataEntries = [];
                dataEntries.push({label: this.$t('store.settings.data'), key: 'data', type: 'dropdownsearch',
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true, selectFirst: true,
                        items: dataItems
                    }

                });
                dataEntries.push({label: view.$t('pages.employeeContext.service'), key: 'service', type: 'dropdownsearch',
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        items: serviceItems
                    }

                });



                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: description,
                        selectCallback: function (data) {
                            if(data.service != null && data.data != null){
                                let url ="";
                                let name = ""
                                if(data.data == 1){
                                    url = "/api/external/actualshifts";
                                    name = "Stempelzeiten"
                                } else if(data.data == 2){
                                    url = "/api/external/actualbreaks";
                                    name = "Pausen"
                                } else if(data.data == 3){
                                    url = "/api/external/employeepreferences";
                                    name = "Abwesenheiten"
                                }
                                view.loadDataWithExternalAPIKey(url, view.externalApiAccessMap[data.service].apiKey).then(response => {
                                    view.exportDataToCsv(name, response.data);
                                }).catch(error => {
                                    console.log(error);
                                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'))
                                })
                            }
                        }
                    },
                    header: 'Daten exportieren',
                    expanded: true,
                    centered: true
                });

            },
            loadDataWithExternalAPIKey(url, apiKey){
                this.error=false;
                let view = this;

                let requestPayload = {
                    apiKey: apiKey,
                    from: this.rosterFromTo.from,
                    to: this.rosterFromTo.to,
                }

                return this.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: requestPayload
                })
            },
            OpenPlanshiftsByHourCSVPopup(){
                let view = this;
                let description = "Von wann bis wann soll der Export erstellen werden?<br/>";


                let dataItems = []
                let from = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
                let to = from.clone().add(1, 'months').add(1, 'days');
                while(from <= to){
                    dataItems.push({label: from.format("DD.MM.YYYY"), value: from.clone()});
                    from = from.add(1, 'days');
                }


                let dataEntries = [];
                dataEntries.push({label: this.$t('global.general.from'), key: 'from', type: 'dropdownsearch',
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true, selectFirst: true,
                        items: dataItems
                    }

                });
                dataEntries.push({label: this.$t('global.general.to'), key: 'to', type: 'dropdownsearch',
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true, selectFirst: false, selectIndex: dataItems.length -1,
                        items: dataItems
                    }

                });

                dataEntries.push({label: this.$t('roster.view.onlyPublishedShifts'), key: 'publishedOnly', hidden: false, type: 'bool', value: false});


                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: description,
                        selectCallback: function (data) {
                            view.exportPlanshiftsByHourAsCSV(data.from, data.to, data.publishedOnly);


                        }
                    },
                    header: this.$t('global.ui.csvExport'),
                    expanded: true,
                    centered: true
                });
            },
            exportPlanshiftsByHourAsCSV(from, to, publishedOnly = false){
                let map = this.$rosterhelper.GetPlannedHoursStatsMap(this.planShiftMap, this.planShiftMomentMap, publishedOnly);
                var date = new Date();
                let ts = from.format("DD-MM-YYYY") +"_"+to.format("DD-MM-YYYY");


                let csvPre = "data:text/csv;charset=utf-8,";
                let headers = ["Datum/Bereich"];
                for(let i = 0; i < 24; i++){
                    headers.push(this.$helpers.pad2(i)+":00");
                }
                headers.push(this.$t('global.ui.sum'));
                let csv = headers.join(";");
                csv += "\n";

                while(from < to){
                    let dateKey = from.format("DD-MM-YYYY");
                    let dateEntry = map[dateKey];
                    if(dateEntry){
                        //first the sum values
                        let csvValues = [from.format("DD.MM.YYYY")]
                        for(let i = 0; i < 24; i++){
                            let hourValue = ((dateEntry.hours[""+i] ? dateEntry.hours[""+i].sum : 0)/60.0).toFixed(2).replace('.',',');

                            csvValues.push(hourValue);
                        }
                        csvValues.push((dateEntry.sum/60.0).toFixed(2).replace('.',','));
                        csv+=csvValues.join(";");
                        csv += "\n";
                        //then the spot values
                        Object.values(this.spotMap).forEach(spot => {
                            if(dateEntry.spots[spot.id]){
                                let spotSum = dateEntry.spots[spot.id];
                                csvValues = [spot.name];
                                for(let i = 0; i < 24; i++){
                                    let hourValue = ((dateEntry.hours[""+i] ? (dateEntry.hours[""+i].spots[spot.id] ? dateEntry.hours[""+i].spots[spot.id] : 0) : 0)/60.0).toFixed(2).replace('.',',');
                                    csvValues.push(hourValue);
                                }
                                csvValues.push((spotSum/60.0).toFixed(2).replace('.',','));
                                csv+=csvValues.join(";");
                                csv += "\n";
                            }
                        })
                        //then an empty row for readability
                        csvValues = [''];
                        for(let i = 0; i < 24; i++){
                            csvValues.push('');
                        }
                        csvValues.push('');
                        csv+=csvValues.join(";");
                        csv += "\n";
                    }
                    from = from.add(1, 'days');
                }

                let encodedUri = encodeURI(csvPre) + "\uFEFF" +  encodeURIComponent(csv);
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", this.$t('roster.view.hourOverview') + ' - ' + ts + '.csv');
                document.body.appendChild(link); // Required for FF
                link.click();

            },

            OpenRosterToCSVPopup(){
                let view = this;
                let description = "Für welche Mitarbeiter soll der CSV Export erstellt werden?<br/>";

                let employees = Object.values(view.employeeMap).map(e => {

                    return {label: e.lastName + " "+e.firstName, value: e.id}
                });

                let spots = Object.values(view.spotMap).map(s => {
                    return {label: s.name, value: s.id};
                });




                employees.sort((a,b)=> {
                    if(a.label.toLowerCase() < b.label.toLowerCase()){
                        return -1;
                    } else if (a.label.toLowerCase() < b.label.toLowerCase()){
                        return 1;
                    }
                    return 0;
                });
                spots.sort((a,b) => {
                    if(a.label.toLowerCase() < b.label.toLowerCase()){
                        return -1;
                    } else if (a.label.toLowerCase() < b.label.toLowerCase()){
                        return 1;
                    }
                    return 0;
                });

                let from = view.$helpers.getMomentFromStringTZ(this.rosterFromTo.from);
                let to = view.$helpers.getMomentFromStringTZ(this.rosterFromTo.to);
                let temp = from.clone();
                let dates = [];
                while(temp <= to){
                    dates.push(temp.clone());
                    temp.add(1, 'days');
                }
                let dataEntries = [];
                dataEntries.push({label: this.$t('global.general.from'), key: 'from', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: this.$t('global.general.from'),
                        items: dates.map(d => {
                            return {
                                label: d.format("DD.MM.YYYY dddd"),
                                value: d,
                                selected: d.unix() == from.unix()
                            }
                        }),
                        selectFirst: true,
                    },
                });
                let toItems = dates.map(d => {
                            return {
                                label: d.format("DD.MM.YYYY dddd"),
                                value: d,
                                selected: d.unix() == to.unix()
                            }
                        });
                dataEntries.push({label: this.$t('global.general.to'), key: 'to', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: this.$t('global.general.to'),
                        items: toItems,
                        selectedItem: toItems.find(i => i.selected),
                    },
                });
                dataEntries.push({label: this.$t('global.ui.allEmployees'), key: 'employeeFlag', hidden: false, type: 'bool', value: true});
                dataEntries.push({label: this.$t('roster.view.selectByBusinessUnits'), key: 'selectSpot', type: 'bool', value: false, hidden: true,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag').value;
                        if(employeeFlag){
                            entryBeforeUpdate.hidden = true;
                        } else {
                            entryBeforeUpdate.hidden = false;
                        }

                        return entryBeforeUpdate;
                    }
                });
                dataEntries.push({label: this.$t('roster.view.selectBusinessUnits'), key: 'spot', type: 'dropdownsearch', hidden: true,
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        placeholder: this.$t('roster.view.selectBusinessUnits'),
                        items: spots.map(e => {
                            return {
                                label: e.label,
                                value: e.value,
                                selected: false
                            }
                        }),
                    },
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let selectSpot = datafill.entries.find(i => i.key == 'selectSpot').value;
                        if(selectSpot){
                            entryBeforeUpdate.hidden = false;
                        } else {
                            entryBeforeUpdate.hidden = true;
                        }

                        return entryBeforeUpdate;
                    }
                });
                dataEntries.push({label: this.$tc('global.general.employee'), key: 'employees', type: 'dropdownsearch', hidden: true,
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        placeholder: this.$t('global.ui.selectEmployee'),
                        items: employees.map(e => {
                            return {
                                label: e.label,
                                value: e.value,
                                selected: false
                            }
                        }),
                    },
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag').value;
                        let selectSpot = datafill.entries.find(i => i.key == 'selectSpot').value;
                        if(employeeFlag){
                            entryBeforeUpdate.hidden = true;
                        } else {
                            if(selectSpot){
                                entryBeforeUpdate.hidden = true;
                            }else{
                                entryBeforeUpdate.hidden = false;
                            }
                        }

                        return entryBeforeUpdate;
                    }
                });


                dataEntries.push({label: this.$t('roster.view.onlyPublishedShifts'), key: 'publishedOnly', hidden: false, type: 'bool', value: true});
                dataEntries.push({label: this.$t('roster.view.externalShiftsOnly'), key: 'externalOnly', hidden: false, type: 'bool', value: false});



                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        errorCheck: [

                            (entries) => {
                                if(entries['from'] != null && entries['from'] != null && entries['from'].isAfter(entries['to'])){
                                    return {key: 'to', type: 'error', label: this.$t('global.general.to'), text: this.$t('roster.view.chronologicalError')}
                                } else {
                                    return null
                                }
                            },
                        ],
                        description: description,
                        selectCallback: function (data) {
                            view.exportRosterAsCSV(data.from, data.to, data.employeeFlag, data.employees, data.spot, data.publishedOnly, data.externalOnly);
                        }
                    },
                    header: this.$t('global.ui.csvExport'),
                    expanded: true,
                    centered: true
                });
            },
            OpenRosterToPDFPopup(){
                let view = this;
                let description = "Zeitraum, Mitarbeiter und Sortierung für PDF Export festlegen:<br/>";

                let employees = Object.values(view.employeeMap).map(e => {

                    return {label: e.lastName + " "+e.firstName, value: e.id}
                });

                let spots = Object.values(view.spotMap).map(s => {
                    return {label: s.name, value: s.id};
                });
                let units = Object.values(view.businessUnitMap).map(u => {
                    return {label: u.name, value: u.id};
                });
                let dataItems = [
                    {label: this.$t('shift.main.planShifts'), value: 1},
                    //{label: "Stempelzeiten", value: 2},
                ]



                employees.sort((a,b)=> {
                    if(a.label.toLowerCase() < b.label.toLowerCase()){
                        return -1;
                    } else if (a.label.toLowerCase() < b.label.toLowerCase()){
                        return 1;
                    }
                    return 0;
                });
                spots.sort((a,b) => {
                    if(a.label.toLowerCase() < b.label.toLowerCase()){
                        return -1;
                    } else if (a.label.toLowerCase() < b.label.toLowerCase()){
                        return 1;
                    }
                    return 0;
                });

                units.sort((a,b) => {
                    if(a.label.toLowerCase() < b.label.toLowerCase()){
                        return -1;
                    } else if (a.label.toLowerCase() < b.label.toLowerCase()){
                        return 1;
                    }
                    return 0;
                });

                let dataEntries = [];
                dataEntries.push({divider: true});


                let from = this.$helpers.getMomentTZ().year(this.$store.state.rosterFromTo.year).month(this.$store.state.rosterFromTo.month).startOf('month');
                let to = from.clone().add(1, 'month');
                let temp = from.clone();
                let dates = [];

                dataEntries.push({label: "Ganzen Monat exportieren", key: 'fullMonth', type: 'bool', value: true, hidden: false});

                while(temp <= to){
                    dates.push(temp.clone());
                    temp.add(1, 'days');
                }
                dataEntries.push({label: this.$t('global.general.from'), key: 'from', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: this.$t('global.general.from'),
                        items: dates.map(d => {
                            return {
                                label: d.format("DD.MM.YYYY dddd"),
                                value: d,
                                selected: d.unix() == from.unix()
                            }
                        }),
                        selectFirst: true,
                    },computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let fullMonth = datafill.entries.find(i => i.key == 'fullMonth').value;
                            if(fullMonth){
                                entryBeforeUpdate.hidden = true;
                            } else {
                                entryBeforeUpdate.hidden = false;
                            }

                            return entryBeforeUpdate;
                        }
                });
                let toItems = dates.map(d => {
                            return {
                                label: d.format("DD.MM.YYYY dddd"),
                                value: d,
                                selected: d.unix() == to.unix()
                            }
                        });
                dataEntries.push({label: this.$t('global.general.to'), key: 'to', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: this.$t('global.general.to'),
                        items: toItems,
                        selectedItem: toItems.find(i => i.selected),
                    },computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let fullMonth = datafill.entries.find(i => i.key == 'fullMonth').value;
                            if(fullMonth){
                                entryBeforeUpdate.hidden = true;
                            } else {
                                entryBeforeUpdate.hidden = false;
                            }

                            return entryBeforeUpdate;
                        }
                });

                dataEntries.push({divider: true});

                dataEntries.push({label: this.$t('global.ui.allEmployees'), key: 'employeeFlag', hidden: false, type: 'bool', value: true});
                dataEntries.push({label: this.$tc('global.general.employee'), key: 'employees', type: 'dropdownsearch', hidden: true,
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        placeholder: this.$t('global.ui.selectEmployee'),
                        items: employees.map(e => {
                            return {
                                label: e.label,
                                value: e.value,
                                selected: false
                            }
                        }),
                    },
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag').value;
                        let selectSpot = datafill.entries.find(i => i.key == 'selectSpot').value;
                        let selectUnit = datafill.entries.find(i => i.key == 'selectUnit').value;
                        if(employeeFlag){
                            entryBeforeUpdate.hidden = true;
                        } else {
                            if(selectSpot || selectUnit){
                                entryBeforeUpdate.hidden = true;
                            }else{
                                entryBeforeUpdate.hidden = false;
                            }
                        }

                        return entryBeforeUpdate;
                    }
                });

                dataEntries.push({label: this.$t('roster.view.selectByPosition'), key: 'selectSpot', type: 'bool', value: false, hidden: true,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag').value;
                        let selectUnit = datafill.entries.find(i => i.key == 'selectUnit').value;
                        if(employeeFlag || selectUnit){
                            entryBeforeUpdate.hidden = true;
                        } else {
                            entryBeforeUpdate.hidden = false;
                        }

                        return entryBeforeUpdate;
                    }
                });
                dataEntries.push({label: this.$t('roster.view.selectPosition'), key: 'spot', type: 'dropdownsearch', hidden: true,
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        placeholder: this.$t('roster.view.selectPosition'),
                        items: spots.map(e => {
                            return {
                                label: e.label,
                                value: e.value,
                                selected: false
                            }
                        }),
                    },
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let selectSpot = datafill.entries.find(i => i.key == 'selectSpot').value;
                        if(selectSpot){
                            entryBeforeUpdate.hidden = false;
                        } else {
                            entryBeforeUpdate.hidden = true;
                        }

                        return entryBeforeUpdate;
                    }
                });

                dataEntries.push({label: this.$t('roster.view.selectByBusinessUnit'), key: 'selectUnit', type: 'bool', value: false, hidden: true,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag').value;
                        let selectSpot = datafill.entries.find(i => i.key == 'selectSpot').value;
                        if(employeeFlag || selectSpot){
                            entryBeforeUpdate.hidden = true;
                        } else {
                            entryBeforeUpdate.hidden = false;
                        }

                        return entryBeforeUpdate;
                    }
                });
                dataEntries.push({label: this.$t('roster.view.selectBusinessUnits'), key: 'unit', type: 'dropdownsearch', hidden: true,
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        placeholder: this.$t('roster.view.selectBusinessUnits'),
                        items: units.map(e => {
                            return {
                                label: e.label,
                                value: e.value,
                                selected: false
                            }
                        }),
                    },
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let selectUnit = datafill.entries.find(i => i.key == 'selectUnit').value;
                        if(selectUnit){
                            entryBeforeUpdate.hidden = false;
                        } else {
                            entryBeforeUpdate.hidden = true;
                        }

                        return entryBeforeUpdate;
                    }
                });

                dataEntries.push({divider: true,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag').value;

                        if(employeeFlag){
                            entryBeforeUpdate.hidden = true;
                        } else {
                            entryBeforeUpdate.hidden = false;
                        }

                        return entryBeforeUpdate;
                    }});



                dataEntries.push({label: this.$t('global.general.sorting'), key: 'sortType', type: 'dropdownsearch', hidden: false, value: 1,
                    dropdownSearchState: {
                        selectMultiple: false,
                        styleLight: true,
                        selectFirst: true,
                        placeholder: this.$t('global.general.to'),
                        items: [{value: 1, label: this.$t('workBalance.bonus.employeePosition')}, {value: 2, label: this.$t('workBalance.bonus.shiftPosition')}, {value: 3, label: this.$t('roster.view.employeeName')}],

                    }
                });
                dataEntries.push({label: '', value: this.$t('roster.view.employeeSortHelp'), type: 'output', key: "sortDesc",
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let sortType = datafill.entries.find(i => i.key == 'sortType').value;
                        if(sortType == 1){
                            entryBeforeUpdate.value = this.$t('roster.view.employeeSortHelp');
                        } else if(sortType == 2){
                            entryBeforeUpdate.value = this.$t('roster.view.employeeSortPositionHelp');
                        } else {
                            entryBeforeUpdate.value = this.$t('roster.view.employeeSortNameHelp');

                        }

                        return entryBeforeUpdate;
                    }
                });
                dataEntries.push({divider: true});

                dataEntries.push({label: this.$t('roster.view.exportPlannedShifts'), key: 'exportShifts', hidden: false, type: 'bool', value: true});
                dataEntries.push({label: this.$t('roster.view.onlyPublishedShifts'), key: 'publishedOnly', hidden: false, type: 'bool', value: true,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let dtype = datafill.entries.find(i => i.key == 'exportShifts').value;
                        if(dtype){
                            entryBeforeUpdate.hidden = false;
                        } else {
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = true;
                        }

                        return entryBeforeUpdate;
                    }
                });
                dataEntries.push({label: this.$t('roster.view.externalShiftsOnly'), key: 'externalOnly', hidden: false, type: 'bool', value: false,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let dtype = datafill.entries.find(i => i.key == 'exportShifts').value;
                        if(dtype){
                            entryBeforeUpdate.hidden = false;
                        } else {
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;
                        }

                        return entryBeforeUpdate;
                    }
                });
                dataEntries.push({divider: true});
                dataEntries.push({label: this.$t('roster.view.exportAbsences'), key: 'exportPreferences', hidden: false, type: 'bool', value: true});
                dataEntries.push({label: this.$t('roster.view.exportUnavailable'), key: 'exportUnavailable', hidden: false, type: 'bool', value: true});
                dataEntries.push({label: this.$t('roster.view.exportPunchTimes'), key: 'exportActualShifts', hidden: false, type: 'bool', value: false});
                dataEntries.push({divider: true});
                dataEntries.push({label: this.$t('roster.view.showHoursTotal'), key: 'showWorkTimeSum', hidden: false, type: 'bool', value: false,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let sortType = datafill.entries.find(i => i.key == 'sortType').value;
                        if(sortType == 1){
                            entryBeforeUpdate.hidden = false
                        } else if(sortType == 2){
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false
                        } else {
                            entryBeforeUpdate.hidden = false
                        }

                        return entryBeforeUpdate;
                    }
                })
                dataEntries.push({label: this.$t('roster.view.showColorLegend'), key: 'showLegend', hidden: false, type: 'bool', value: false});
                dataEntries.push({label: this.$t('roster.view.monochrome'), key: 'blackwhite', hidden: false, type: 'bool', value: false});
                /* dataEntries.push({label: "Detaillierter Export", key: 'detailed', hidden: false, type: 'bool', value: false,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let dtype = datafill.entries.find(i => i.key == 'data').value;
                        if(dtype == 1){
                            entryBeforeUpdate.hidden = false;
                        } else {
                            entryBeforeUpdate.hidden = true;
                        }

                        return entryBeforeUpdate;
                    }
                }); */
                console.log(this.rosterFromTo);

                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: description,
                        selectCallback: function (data) {
                            if(data.exportShifts || data.exportPreferences || data.exportActualShifts || data.exportUnavailable){
                                let spots = [];
                                let allSpots = Object.values(view.spotMap);
                                if(data.selectUnit){

                                    spots = [];
                                    allSpots.forEach((s) => {
                                        if(data.unit.includes(s.unitId)) spots.push(s.id);
                                    });
                                } else if(data.selectSpot){
                                    spots = [];
                                    allSpots.forEach((s) => {
                                        if(data.spot.includes(s.id)) spots.push(s.id);
                                    });
                                } else {
                                    allSpots.forEach((s) => {
                                        spots.push(s.id);
                                    });
                                }
                                let employees = data.employees;
                                if((data.selectUnit || data.selectSpot) && data.sortType != 2){
                                    employees = [];
                                    Object.values(view.employeeMap).forEach(emp => {
                                        if(emp.spotId != null && spots.includes(emp.spotId)){
                                            employees.push(emp.id);
                                        }
                                    })
                                }

                                view.exportRosterAsPDF(data.fullMonth, data.from, data.to, data.employeeFlag, employees,
                                                       data.sortType == 2, spots, data.publishedOnly, data.externalOnly, data.unit,
                                                       data.sortType, data.exportShifts, data.exportPreferences, data.exportUnavailable,
                                                       data.exportActualShifts, data.showLegend, data.blackwhite, data.showWorkTimeSum);
                            }else{
                                window.app.popupalerts.push(
                                    {
                                        header: this.$t('roster.view.noSelectionForExport'),
                                        description: this.$t('roster.view.noSelectionHelp'),
                                        hidden: false,
                                        callbackAccept: function(popup){
                                            popup.hidden = true;
                                        }
                                    }
                                );
                            }
                        }
                    },
                    header: this.$t('global.ui.pdfExport'),
                    expanded: true,
                    centered: true
                });
            },


            exportRosterAsPDF(fullMonth, from, to, allEmployees = true, employees = [],
                              displayByShiftSpot = false, spot = [], publishedOnly = true, externalOnly = false, unit = [],
                              sortType = 1, exportShifts = true, exportPreferences = true, exportUnavailable = true,
                              exportActualShifts = false, showLegend = true, blackwhite = false, showWorkTimeSum = false){
                let view = this;
                let defaultFrom = this.$helpers.getMomentTZ().year(this.$store.state.rosterFromTo.year).month(this.$store.state.rosterFromTo.month).startOf('month');
                let defaultTo = from.clone().add(1, 'month');
                let titlePrefix = exportShifts && exportPreferences? 'Dienstplan ' : exportShifts? 'Planschichten ' : exportPreferences? this.$t('global.menubar.preferences') + ' ' : 'Export ';
                let title = titlePrefix + this.dateSelectionStart.format('MMMM YYYY');
                if(fullMonth){
                    from = defaultFrom;
                    to = defaultTo;
                }else{
                    title = titlePrefix + from.format('DD.MM.YYYY') + ' - ' + to.format('DD.MM.YYYY');
                    to = to.add(1, "days"); // make last user selected day inclusive
                }
                let keys = ["Mitarbeiter"];
                let dateKeys = [];
                let weekdays = [""];

                let legendMap = {};

                if(this.dateSelectionStart != null){
                    let lower = this.dateSelectionStart.clone().date(1).hours(0).minutes(0).seconds(0).milliseconds(0);
                    let upper = lower.clone().date(1).hours(0).minutes(0).seconds(0).milliseconds(0).add(1, 'M');
                    let cnt = 0;
                    while(lower._d.getTime() < upper._d.getTime() && cnt < 33){
                        keys.push(lower.format("DD.MM."));
                        weekdays.push(lower.format("dddd").substring(0,2).toUpperCase()+ '\n' + lower.format("DD") /* + '\n' + lower.format("MMM").substring(0,3).toUpperCase() */);
                        dateKeys.push(lower.format("DD.MM."));
                        lower = lower.add(1, 'd');
                        cnt++;
                    }
                }
                let emplLines = {};
                let maxDateIndex = -1;
                let minDateIndex = null;
                let actualShiftAssignedMap = {};

                if(exportActualShifts){
                    let shifts = Object.values(this.actualShiftMap);
                    shifts.sort((a, b) => {
                        let d1 = this.actualShiftMomentMap[a.id].fromDate;
                        let d2 = this.actualShiftMomentMap[b.id].fromDate;
                        if(d1.year() == d2.year() && d1.month() == d2.month() && d1.date() == d2.date()
                            && a.employeeId != null && b.employeeId != null
                            && view.employeeMap[a.employeeId] != null && view.employeeMap[b.employeeId] != null){
                            return view.employeeMap[b.employeeId].lastName.localeCompare(view.employeeMap[a.employeeId].lastName)
                        } else {
                            return d1.unix() - d2.unix();
                        }
                    })
                    if(shifts.length > 0){
                        shifts.forEach((shift) => {
                            if(allEmployees || employees.includes(shift.employeeId) || (displayByShiftSpot && spot.length > 0)){
                                let startM = this.actualShiftMomentMap[shift.id].fromDate.clone();
                                let endM = this.actualShiftMomentMap[shift.id].toDate.clone();

                                if(endM > from && startM < to){
                                    let shiftSpot = view.planShiftMap[shift.planshiftId] ? view.planShiftMap[shift.planshiftId].spotId : null;
                                    let shiftSpotObj = {'name': 'Stempelzeit ohne Planschicht', 'color': "#e0a374"};
                                    let shiftColor = "#e0a374";
                                    if(shiftSpot && view.spotMap[shiftSpot]){
                                        shiftSpotObj = view.spotMap[shiftSpot];
                                        shiftColor = shiftSpotObj.color;
                                    }



                                    let empl = view.employeeMap[shift.employeeId];
                                    let assignedEmployee = '';
                                    if(empl != null && empl != undefined){
                                        let targetSpotId = sortType == 2 ? (shiftSpot != null ? shiftSpot : empl.spotId) : (sortType == 1 ? empl.spotId : '00000000-0000-0000-0000-000000000000');
                                        if(!displayByShiftSpot || (displayByShiftSpot && spot.includes(targetSpotId) )){
                                            assignedEmployee = empl.lastName.toUpperCase() + '\n' + empl.firstName;
                                            let lineMap = {};
                                            let line = [];
                                            if(!(shift.employeeId in  emplLines)){
                                                emplLines[shift.employeeId] = {};
                                            }
                                            lineMap = emplLines[shift.employeeId];

                                            if(!(targetSpotId in lineMap)){
                                                if(!sortType != 2 && showWorkTimeSum){
                                                    let sum = (publishedOnly ? this.employeePlannedActual[empl.id].sumWorkTimePublishedProduktiv : this.employeePlannedActual[empl.id].sumWorkTimeProduktiv) + (exportPreferences ? this.employeePlannedActual[empl.id].sumWorkTimeUnproduktiv : 0);
                                                    sum = (sum/(3600.0*1000.0)).toFixed(2)+'h';
                                                    assignedEmployee+= '\n'+sum;
                                                }
                                                let newline = [assignedEmployee];
                                                dateKeys.forEach((k) => {
                                                    newline.push({'shift': '', 'color': '#ffffff'});
                                                });
                                                lineMap[targetSpotId] = newline;
                                            }
                                            line = lineMap[targetSpotId];
                                            let currentKey = startM.format("DD.MM.");
                                            let index = keys.indexOf(currentKey);
                                            if(index != -1){
                                                let existingLine = line[index];
                                                if(index > maxDateIndex) maxDateIndex = index;
                                                if(minDateIndex == null || index < minDateIndex) minDateIndex = index;
                                                let shiftEntries = existingLine ? (existingLine.shiftEntries ? existingLine.shiftEntries : []) : [];
                                                shiftEntries.push(shift);
                                                let minDate = null;
                                                let maxDate = null;
                                                shiftEntries.forEach((e) => {
                                                        if(minDate == null || this.actualShiftMomentMap[e.id].fromDate < minDate) minDate = this.actualShiftMomentMap[e.id].fromDate;
                                                        if(maxDate == null || this.actualShiftMomentMap[e.id].toDate > maxDate) maxDate = this.actualShiftMomentMap[e.id].toDate;
                                                });

                                                let shiftAppendix = " \nSZ"
                                                if(shiftEntries.length > 1){
                                                    shiftAppendix = " ("+shiftEntries.length+")";
                                                }
                                                let shiftStr = minDate.format('HH:mm') + "\n" + maxDate.format('HH:mm') + shiftAppendix;

                                                line[index] = {'shift': shiftStr, 'color': shiftColor, shiftEntries: shiftEntries};
                                                if(!actualShiftAssignedMap[shift.employeeId]){
                                                    actualShiftAssignedMap[shift.employeeId] ={};

                                                }
                                                actualShiftAssignedMap[shift.employeeId][currentKey] = true;
                                            }
                                            if(!(shiftSpotObj.name in legendMap)){
                                                legendMap[shiftSpotObj.name] = shiftSpotObj.color;
                                            }
                                            lineMap[targetSpotId] = line;
                                            emplLines[shift.employeeId] = lineMap;
                                        }


                                    }
                                }
                            }
                        });
                    }
                }

                if(exportShifts){
                    let shifts = Object.values(this.planShiftMap);
                    shifts.sort((a, b) => {
                        let d1 = this.planShiftMomentMap[a.id].fromDate;
                        let d2 = this.planShiftMomentMap[b.id].fromDate;
                        if(d1.year() == d2.year() && d1.month() == d2.month() && d1.date() == d2.date()
                            && a.employeeId != null && b.employeeId != null
                            && view.employeeMap[a.employeeId] != null && view.employeeMap[b.employeeId] != null){
                            return view.employeeMap[b.employeeId].lastName.localeCompare(view.employeeMap[a.employeeId].lastName)
                        } else {
                            return d1.unix() - d2.unix();
                        }
                    })
                    if(shifts.length > 0){
                        shifts.forEach((shift) => {
                            if((!publishedOnly || shift.published) && (!externalOnly || shift.fromLocationId != null)){
                                if(allEmployees || employees.includes(shift.employeeId) || (displayByShiftSpot && spot.length > 0)){
                                    let startM = this.planShiftMomentMap[shift.id].fromDate.clone();
                                    let endM = this.planShiftMomentMap[shift.id].toDate.clone();

                                    if(endM > from && startM < to){
                                        let shiftSpot = shift.spotId;
                                        let shiftSpotObj = {'name': 'Nicht zugewiesen', 'color': '#666666'};
                                        let shiftColor = null;
                                        if(shiftSpot && view.spotMap[shiftSpot]){
                                            shiftSpotObj = view.spotMap[shiftSpot];
                                            shiftColor = shiftSpotObj.color;
                                        }



                                        let empl = view.employeeMap[shift.employeeId];
                                        let assignedEmployee = '';
                                        if(empl != null && empl != undefined){
                                            let currentKey = startM.format("DD.MM.");
                                            let alreadyActualShift = actualShiftAssignedMap[shift.employeeId] ? (actualShiftAssignedMap[shift.employeeId][currentKey] ? true : false) : false;
                                            if( !alreadyActualShift && (!displayByShiftSpot || (displayByShiftSpot && spot.includes(shift.spotId)))){
                                                assignedEmployee = empl.lastName.toUpperCase() + '\n' + empl.firstName;
                                                let lineMap = {};
                                                let line = [];
                                                if(!(shift.employeeId in  emplLines)){
                                                    emplLines[shift.employeeId] = {};
                                                }
                                                lineMap = emplLines[shift.employeeId];
                                                let targetSpotId = sortType == 2 ? shiftSpot : (sortType == 1 ? empl.spotId : '00000000-0000-0000-0000-000000000000');
                                                if(!(targetSpotId in lineMap)){
                                                    if(sortType != 2 && showWorkTimeSum){
                                                        let sum = (publishedOnly ? this.employeePlannedActual[empl.id].sumWorkTimePublishedProduktiv : this.employeePlannedActual[empl.id].sumWorkTimeProduktiv) + (exportPreferences ? this.employeePlannedActual[empl.id].sumWorkTimeUnproduktiv : 0);
                                                        sum = (sum/(3600.0*1000.0)).toFixed(2)+'h';
                                                        assignedEmployee+= '\n'+sum;
                                                    }
                                                    let newline = [assignedEmployee];
                                                    dateKeys.forEach((k) => {
                                                        newline.push({'shift': '', 'color': '#ffffff'});
                                                    });
                                                    lineMap[targetSpotId] = newline;
                                                }
                                                line = lineMap[targetSpotId];

                                                let index = keys.indexOf(currentKey);
                                                if(index != -1){
                                                    let existingLine = line[index];
                                                    if(index > maxDateIndex) maxDateIndex = index;
                                                    if(minDateIndex == null || index < minDateIndex) minDateIndex = index;
                                                    let shiftAppendix = "";


                                                    let shiftEntries = existingLine ? (existingLine.shiftEntries ? existingLine.shiftEntries : []) : [];
                                                    shiftEntries.push(shift);
                                                    let minDate = null;
                                                    let maxDate = null;
                                                    shiftEntries.forEach((e) => {
                                                        if(minDate == null || e.fromDate < minDate) minDate = e.fromDate;
                                                        if(maxDate == null || e.toDate > maxDate) maxDate = e.toDate;
                                                    });
                                                    if(shiftEntries.length > 1){
                                                        shiftAppendix = "\n("+shiftEntries.length+")";
                                                    } else if(shift.fromLocationId) {
                                                        shiftAppendix += " \nExtern"
                                                    }
                                                    let shiftStr = minDate.format('HH:mm') + "\n" + maxDate.format('HH:mm') + shiftAppendix;

                                                    line[index] = {'shift': shiftStr, 'color': shiftColor, shiftEntries: shiftEntries};
                                                }
                                                if(!(shiftSpotObj.name in legendMap)){
                                                    legendMap[shiftSpotObj.name] = shiftSpotObj.color;
                                                }
                                                lineMap[targetSpotId] = line;
                                                emplLines[shift.employeeId] = lineMap;
                                            }


                                        }
                                    }
                                }
                            }
                        });
                    }
                }


                let vacationCol = '#dec92f';
                let nursingVacCol = '#f99a86';
                let sicknessCol = '#e5154f';
                let schoolingCol = '#348feb';
                let lfzCol = '#eb7d34';
                let ftaCol = '#40eded';
                let miscCol = '#ffffff';

                let prefLegendMap = {};
                if(exportPreferences || exportUnavailable){
                    let prefs = Object.values(this.employeePreferenceMap);
                    prefs.sort((a, b) => {
                        let d1 = this.employeePreferenceMomentMap[a.id].fromDate;
                        let d2 = this.employeePreferenceMomentMap[b.id].fromDate;
                        if(d1.year() == d2.year() && d1.month() == d2.month() && d1.date() == d2.date()
                            && a.employeeId != null && b.employeeId != null
                            && view.employeeMap[a.employeeId] != null && view.employeeMap[b.employeeId] != null){
                            return view.employeeMap[b.employeeId].lastName.localeCompare(view.employeeMap[a.employeeId].lastName)
                        } else {
                            return d1.unix() - d2.unix();
                        }
                    });
                    if(prefs.length > 0){
                        prefs.forEach((pref) => {
                            if(allEmployees || employees.includes(pref.employeeId) || (displayByShiftSpot && spot.length > 0)){
                                let startM = this.employeePreferenceMomentMap[pref.id].fromDate.clone();
                                let endM = this.employeePreferenceMomentMap[pref.id].toDate.clone();

                                if(endM > from && startM < to){
                                    let curd = startM.clone();
                                    while(curd <= endM){
                                        let empl = view.employeeMap[pref['employeeId']];
                                        let assignedEmployee = '';
                                        if(empl != null && empl != undefined){
                                            let key = curd.format("YYYY-MM-DD");
                                            assignedEmployee = empl['lastName'].toUpperCase() + '\n' + empl['firstName'];
                                            let lineMap = {};
                                            let line = [];
                                            if(!(pref['employeeId'] in  emplLines)){
                                                emplLines[pref['employeeId']] = {};
                                            }
                                            lineMap = emplLines[pref['employeeId']];
                                            let targetSpotId = sortType == 2 ? 'preferences' : (sortType == 1 ? empl.spotId : '00000000-0000-0000-0000-000000000000');
                                            if(!(targetSpotId in lineMap)){
                                                if(sortType != 2 && showWorkTimeSum){
                                                    let sum = (publishedOnly ? this.employeePlannedActual[empl.id].sumWorkTimePublishedProduktiv : this.employeePlannedActual[empl.id].sumWorkTimeProduktiv) + (exportPreferences ? this.employeePlannedActual[empl.id].sumWorkTimeUnproduktiv : 0);
                                                    sum = (sum/(3600.0*1000.0)).toFixed(2)+'h';
                                                    assignedEmployee+= '\n'+sum;
                                                }
                                                let newline = [assignedEmployee];
                                                dateKeys.forEach((k) => {
                                                    newline.push({'shift': '', 'color': '#ffffff'});
                                                });
                                                lineMap[targetSpotId] = newline;
                                            }
                                            line = lineMap[targetSpotId];
                                            let currentKey = curd.format("DD.MM.");
                                            let index = keys.indexOf(currentKey);
                                            let shiftColor = 'transparent';
                                            let hasExportablePreference = false;
                                            if(index != -1){
                                                if(index > maxDateIndex) maxDateIndex = index;
                                                if(minDateIndex == null || index < minDateIndex) minDateIndex = index;
                                                //let shiftStr = pref['fromDate'].format('HH:mm') + "\n" + pref['toDate'].format('HH:mm');
                                                let shiftStr = "";
                                                if(this.HasSickness(empl.id, key) && exportPreferences){
                                                    shiftStr = "K";
                                                    shiftColor = sicknessCol;
                                                    if(!('Krankenstand (K)' in prefLegendMap)){
                                                        prefLegendMap['Krankenstand (K)'] = sicknessCol;
                                                    }
                                                    hasExportablePreference = true;
                                                }

                                                if(this.HasVacation(empl.id, key) && exportPreferences){
                                                    shiftStr = "U";
                                                    shiftColor = vacationCol;
                                                    if(!('Urlaub (U)' in prefLegendMap)){
                                                        prefLegendMap['Urlaub (U)'] = vacationCol;
                                                    }
                                                    hasExportablePreference = true;
                                                }

                                                if(this.HasNursingVacation(empl.id, key) && exportPreferences){
                                                    shiftStr = "PU";
                                                    shiftColor = nursingVacCol;
                                                    if(!('Pflegeurlaub (PU)' in prefLegendMap)){
                                                        prefLegendMap['Pflegeurlaub (PU)'] = nursingVacCol;
                                                    }
                                                    hasExportablePreference = true;
                                                }

                                                if(this.HasSchooling(empl.id, key) && exportPreferences){
                                                    shiftStr = "A";
                                                    shiftColor = schoolingCol;
                                                    if(!('Ausbildung (A)' in prefLegendMap)){
                                                        prefLegendMap['Ausbildung (A)'] = schoolingCol;
                                                    }
                                                    hasExportablePreference = true;
                                                }

                                                if(this.HasWageContinuation(empl.id, key) && exportPreferences){
                                                    shiftStr = "LFZ";
                                                    shiftColor = lfzCol;
                                                    if(!('Lohnfortzahlung (LFZ)' in prefLegendMap)){
                                                        prefLegendMap['Lohnfortzahlung (LFZ)'] = lfzCol;
                                                    }
                                                    hasExportablePreference = true;
                                                }

                                                if(this.HasHolidayAdjustment(empl.id, key) && exportPreferences){
                                                    shiftStr = "FTA";
                                                    shiftColor = ftaCol;
                                                    if(!('Feiertagsausgleich (FTA)' in prefLegendMap)){
                                                        prefLegendMap['Feiertagsausgleich (FTA)'] = ftaCol;
                                                    }
                                                    hasExportablePreference = true;
                                                }

                                                if(this.HasMiscUnavailable(empl.id, key) && exportUnavailable){
                                                    shiftStr = "X";
                                                    console.log(index)
                                                    shiftColor = index % 2 == 0?  '#eeeeee' : '#ffffff';
                                                    if(!('Nicht Verfügbar (X)' in prefLegendMap)){
                                                        prefLegendMap['Nicht Verfügbar (X)'] = miscCol;
                                                    }
                                                    hasExportablePreference = true;
                                                }

                                                if(hasExportablePreference)line[index] = {'shift': shiftStr, 'color': shiftColor, shiftEntries: []};
                                            }
                                            if(hasExportablePreference){
                                                lineMap[targetSpotId] = line;
                                                emplLines[pref['employeeId']] = lineMap;
                                            }
                                        }
                                        curd = curd.add(1, "days");
                                    }
                                }
                            }
                        });
                    }
                }


                if(maxDateIndex != -1 && maxDateIndex < keys.length) keys = keys.slice(0, maxDateIndex + 1);
                if(minDateIndex != null && minDateIndex < keys.length) keys.splice(1,minDateIndex-1);
                if(maxDateIndex != -1 && maxDateIndex < weekdays.length) weekdays = weekdays.slice(0, maxDateIndex + 1);
                if(minDateIndex != null && minDateIndex < weekdays.length) weekdays.splice(1,minDateIndex-1);

                //console.log(emplLines);
                let spotLines = {};
                Object.keys(emplLines).forEach((emplId) => {
                    let lineMap = emplLines[emplId];
                    Object.keys(lineMap).forEach((spotId) => {
                        let spotName = "Nicht zugewiesen";
                        let spotObj = {'name': 'Nicht zugewiesen', 'color': '#666666'};
                        if(spotId == "preferences"){
                            spotName = "Abwesenheiten";
                            spotObj = {'name': 'Abwesenheiten', 'color': '#666666'};
                        } else if(spotId == "00000000-0000-0000-0000-000000000000"){
                            spotName ="Mitarbeiter";
                            spotObj = {'name': this.$tc('global.general.employee'), 'color': '#666666'};
                        } else if(spotId){
                            spotObj = view.spotMap[spotId];
                            if(spotObj)spotName = spotObj.name;
                        }
                        if(!(spotName in spotLines)){
                            spotLines[spotName] = {'lines': [], 'spot': spotObj};
                        }
                        spotLines[spotName].lines.push(lineMap[spotId]);
                    });

                });
                //console.log(spotLines);
                let spotKeys = Object.keys(spotLines);
                spotKeys.sort((a,b) => {
                    if(a == "Abwesenheiten" && b != "Abwesenheiten") return 1;
                    if(a != "Abwesenheiten" && b == "Abwesenheiten") return -1;
                    if(a.toLowerCase() > b.toLowerCase()) return 1;
                    if(a.toLowerCase() < b.toLowerCase()) return -1;
                    return 0;
                });
                let body = [];

                spotKeys.forEach((key) => {
                    let spot = spotLines[key].spot;
                    let bgColor = blackwhite ? '#555555' : (spot? spot.color : '#666666');
                    let txtColor = this.GetContrastingColor(bgColor, 'white', '#444444', 50);
                    let sl = [{content: key, colSpan: dateKeys.length + 1, rowSpan: 1, styles: {fontSize: 9.0, fillColor: bgColor, textColor: txtColor}}];

                    if(key != 'Mitarbeiter'){
                        body.push(sl);
                    }

                    spotLines[key].lines.sort((a,b) => {
                        // sort by name at index 0
                        if(a[0] > b[0]) return 1;
                        if(a[0] < b[0]) return -1;
                        return 0;
                    });

                    spotLines[key].lines.forEach((line) => {
                        if(maxDateIndex != null && maxDateIndex < line.length) line = line.splice(0, maxDateIndex + 1);
                        if(minDateIndex != null && minDateIndex < line.length) line.splice(1,minDateIndex-1);
                        let sl = [];
                        for(var i = 0; i < line.length; i++){
                            let content = i == 0? line[i] : line[i].shift;
                            let shiftColor = blackwhite? ( i % 2 == 0? '#ffffff' : '#eeeeee') : (i == 0? '#ffffff' : line[i].color);
                            let fillColor = i > 0 && content.length > 0? shiftColor : i % 2 == 0? '#ffffff' : '#eeeeee';
                            let txtColor = i == 0? '#444444' : this.GetContrastingColor(fillColor, 'white', '#444444', 50);// 0x000000;
                            sl.push({content: content, colSpan: 1, rowSpan: 1, styles: {fillColor: fillColor, textColor: txtColor, fontStyle: i == 0? 'bold':'normal'}});
                        }
                        body.push(sl);
                    });
                });

                let emptyLine = [{content: '', styles: {fillColor: '#ffffff'}}];
                dateKeys.forEach((k) => {
                    emptyLine.push({content: '', styles: {fillColor: '#ffffff'}});
                });
                if(showLegend){
                    // legend
                    body.push(emptyLine);
                    body.push(emptyLine);
                    if(Object.keys(legendMap).length > 0){
                        let legendHeader = [{content: 'Bereiche/Positionen', colSpan: 3, rowSpan: 1, styles: {fontStyle: 'bold', fontSize: 6.0}}];
                        for(let i = 0; i < dateKeys.length - 2; i++){
                            legendHeader.push({content: '', colSpan: 1, rowSpan: 1, styles: {fillColor: '#ffffff'}});
                        }
                        body.push(legendHeader);
                        Object.keys(legendMap).forEach((spotName) => {
                            let col = blackwhite? '#ffffff' : legendMap[spotName];
                            let txtCol = this.GetContrastingColor(col, 'white', '#444444', 50);
                            let legendLine = [{content: spotName, colSpan: 3, rowSpan: 1, styles: {fillColor: col, textColor: txtCol, fontStyle: 'bold', fontSize: 6.0}}];
                            for(let i = 0; i < dateKeys.length - 2; i++){
                                legendLine.push({content: '', colSpan: 1, rowSpan: 1, styles: {fillColor: col, textColor: col}});
                            }
                            body.push(legendLine);
                        });
                        body.push(emptyLine);
                    }
                    if(Object.keys(prefLegendMap).length > 0){
                        let prefLegendHeader = [{content: 'Abwesenheiten', colSpan: 3, rowSpan: 1, styles: {fontStyle: 'bold', fontSize: 6.0}}];
                        for(let i = 0; i < dateKeys.length - 2; i++){
                            prefLegendHeader.push({content: '', colSpan: 1, rowSpan: 1, styles: {fillColor: '#ffffff'}});
                        }
                        body.push(prefLegendHeader);
                        Object.keys(prefLegendMap).forEach((p) => {
                            let col = blackwhite? '#ffffff' : prefLegendMap[p];
                            let txtCol = this.GetContrastingColor(col, 'white', '#444444', 50);
                            let legendLine = [{content: p, colSpan: 3, rowSpan: 1, styles: {fillColor: col, textColor: txtCol, fontStyle: 'bold', fontSize: 6.0}}];
                            for(let i = 0; i < dateKeys.length - 2; i++){
                                legendLine.push({content: '', colSpan: 1, rowSpan: 1, styles: {fillColor: col, textColor: col}});
                            }
                            body.push(legendLine);
                        });
                    }
                }



                let month = "";
                if(this.dateSelectionStart != null){
                    month = this.dateSelectionStart.format('YYYY_MMMM');
                }

                let spots = [];
                if(spot != null){
                    spot.forEach((s)=>{
                        spots.push(view.spotMap[s]['name']);

                    });
                }
                let spotsTxt = spots.join(", ");
                var date = new Date();
                let ts = ( date.getFullYear().toString() + this.$helpers.pad2(date.getMonth() + 1) + this.$helpers.pad2( date.getDate()) + '-' + this.$helpers.pad2( date.getHours() ) + this.$helpers.pad2( date.getMinutes() ) + this.$helpers.pad2( date.getSeconds() ) );
                let filename = "Dienstplan_" + month + "_" + this.storeSettings.name + '_' + ts;



                let subTitle = "";


                var repDoc = this.$helpers.tableReportDoc(
                    weekdays,
                    title,
                    subTitle,
                    this.storeSettings.name + ' ('+this.storeSettings.description+')',
                    this.userFullname,
                    15);
                var doc = repDoc.doc;
                let colStyles = {};
                let defaultFontSize = keys.length > 28? 6.8 : keys.length > 20? 7.0 : keys < 15? 8.0 : 7.0;
                for(let i = 0; i < keys.length; i++){
                    colStyles[i] = {
                        fillColor: i % 2 == 0? 0xffffff : 0xdddddd,
                        fontSize: i == 0? 5 : defaultFontSize,
                        fontStyle: i == 0? 'normal':'bold',
                        overflow: i == 0? 'ellipsize': 'clip',
                        halign: i == 0? 'center':'center'
                    }
                }
                let rowStyles = {};
                for(let i = 0; i < body.length; i++){
                    let fillColor = i % 2 == 0? 0xffffff : 0xeeeeee;
                    let txtColor = 0x000000;
                    let val = body[i][0];
                    if(spotKeys.includes(val)){
                        //fontSize = 9.0;
                        fillColor = 0x000000;
                        txtColor = 0xffffff;
                        /* rowStyles[i] = {
                            fillColor: fillColor,
                            textColor: txtColor,
                            fontSize: fontSize
                        } */
                    }else{
                        rowStyles[i] = {
                            fillColor: fillColor,
                            textColor: txtColor
                        }
                    }

                }

                var contentOffsetY = repDoc.contentOffsetY;
                doc.setFontSize(12);
                doc.autoTable({
                    startY:  contentOffsetY,
                    head: [weekdays],
                    body: body,
                    headStyles: {
                    fillColor: blackwhite ? [132, 132, 132] : [109,141,33],
                    fontSize: 6,
                    halign: 'center'
                    },
                    bodyStyles: {
                    fontSize: 1
                    },
                    columnStyles: colStyles,
                    alternateRowStyles: rowStyles,
                    horizontalPageBreak: keys.length > 32,
                    horizontalPageBreakRepeat: 0,
                    rowPageBreak: 'avoid'
                });
                doc.setProperties({
                    title: "Dienstplan PDF"
                });
                view.$helpers.previewPdf(doc, filename+ '.pdf');

            },
            exportRosterAsCSV(from, to, allEmployees, employees, spot, publishedOnly, externalOnly){

                let view = this;
                let csvPre = "data:text/csv;charset=utf-8,";
                let csv = "Mitarbeiter;Stammposition";//;Datum;Beginn;Ende;Arbeitszeit;Position;";
                let keys = ["Mitarbeiter", "Stammposition"];
                let dateKeys = [];
                let shifts = Object.values(this.planShiftMap);
                shifts.sort((a, b) => {
                    let d1 = this.planShiftMomentMap[a.id].fromDate;
                    let d2 = this.planShiftMomentMap[b.id].fromDate;
                    if(d1.year() == d2.year() && d1.month() == d2.month() && d1.date() == d2.date()
                        && a.employeeId != null && b.employeeId != null
                        && view.employeeMap[a.employeeId] != null && view.employeeMap[b.employeeId] != null){
                        return view.employeeMap[b.employeeId].lastName.localeCompare(view.employeeMap[a.employeeId].lastName)
                    } else {
                        return d1.unix() - d2.unix();
                    }
                })
                if(this.dateSelectionStart != null){
                    let lower = this.dateSelectionStart.clone().date(1).hours(0).minutes(0).seconds(0).milliseconds(0);
                    let upper = lower.clone().date(1).hours(0).minutes(0).seconds(0).milliseconds(0).add(1, 'M');
                    let cnt = 0;
                    while(lower._d.getTime() < upper._d.getTime() && cnt < 33){
                        csv += ";" + lower.format("DD.MM.");
                        keys.push(lower.format("DD.MM."));
                        dateKeys.push(lower.format("DD.MM."));
                        lower = lower.add(1, 'd');
                        cnt++;
                    }
                }
                let emplLines = {};
                let maxDateIndex = -1;
                if(shifts.length > 0){
                    csv += "\r\n";
                    shifts.forEach(shift => {
                        if((!publishedOnly || shift.published) && (!externalOnly || shift.fromLocationId != null)){
                            if(allEmployees || employees.includes(shift.employeeId) || spot.length != 0){
                                let startM = this.planShiftMomentMap[shift.id].fromDate.clone();
                                let endM = this.planShiftMomentMap[shift.id].toDate.clone();

                                if(endM > from && startM < to){
                                    let workValue = this.$helpers.getMomentDuration(startM,endM);
                                    let total = workValue.hours() * 60 + workValue.minutes();

                                    if(shift.workValue != -1){ //Do not calculate - take stored value (z.B. Schulung)
                                        total = shift.workValue;
                                    }

                                    if(shift.breakValue != -1 && shift.workValue == -1){
                                        total = total - shift.breakValue;
                                    }
                                    total = Math.max(0, total);
                                    shift.total = Math.max(0, total);

                                    let hours = Math.floor(total / 60);
                                    let minutes = total - (hours * 60);


                                    let empl = view.employeeMap[shift['employeeId']];
                                    let assignedEmployee = '';
                                    if(empl != null && empl != undefined){
                                        if(spot.length == 0 || spot.includes(empl['spotId'])){
                                            assignedEmployee = empl['lastName'].toUpperCase() + ' ' + empl['firstName'];
                                            let line = [];
                                            if(shift['employeeId'] in  emplLines){
                                                line = emplLines[shift['employeeId']];
                                            }else{
                                                line = [assignedEmployee];
                                                let emplSpot = empl['spotId'];
                                                let spotName = emplSpot != null? view.spotMap[empl['spotId']]['name'] : "Nicht zugewiesen";
                                                line.push(spotName);
                                                dateKeys.forEach((k) => {
                                                    line.push("");
                                                });
                                            }
                                            let currentKey = startM.format("DD.MM.");
                                            let index = keys.indexOf(currentKey);
                                            if(index != -1){
                                                if(index > maxDateIndex) maxDateIndex = index;
                                                let shiftStr = shift['fromDate'].format('HH:mm') + "-" + shift['toDate'].format('HH:mm') + " (" + view.spotMap[shift['spotId']]['name'];
                                                if(!shift['published']) shiftStr += ", " + this.$t('roster.comp.unpublished');
                                                if(shift.fromLocationId) shiftStr += ", "+view.locationMap[shift.fromLocationId].name
                                                shiftStr += ")";
                                                line[index] = shiftStr;
                                            }
                                            emplLines[shift['employeeId']] = line;
                                        }
                                    }
                                }


                            }
                        }
                    });
                    let csvLines = Object.values(emplLines);
                    csvLines.sort((a,b) => {
                        let sa = a[1];
                        let sb = b[1];
                        if(sa === sb){
                            // sort by name
                            if(a[0] > b[0]) return 1;
                            if(a[0] < b[0]) return -1;
                            return 0;
                        }

                        // sort by spot name, "Nicht zugewiesen" should be last element
                        if(sa == "Nicht zugewiesen" && sb != "Nicht zugewiesen") return 1;
                        if(sb == "Nicht zugewiesen" && sa != "Nicht zugewiesen") return -1;
                        if(sa > sb) return 1;
                        if(sa < sb) return -1;
                    });
                    if(maxDateIndex != -1 && maxDateIndex < keys.length) keys = keys.slice(0, maxDateIndex + 1);
                    csv = keys.join(";");
                    csv += "\r\n";
                    csvLines.forEach((line) => {
                        if(maxDateIndex != -1 && maxDateIndex < line.length) line = line.slice(0, maxDateIndex + 1);
                        csv += line.join(";");
                        csv += "\r\n";
                    });
                }

                let month = "";
                if(this.dateSelectionStart != null){
                    month = this.dateSelectionStart.format('YYYY_MMMM');
                }
                let spotFilter = "";
                if(spot != null){
                    spot.forEach((s)=>{
                        spotFilter += "_" + view.spotMap[s]['name'];
                    });
                }
                var date = new Date();
                let ts = ( date.getFullYear().toString() + this.$helpers.pad2(date.getMonth() + 1) + this.$helpers.pad2( date.getDate()) + '-' + this.$helpers.pad2( date.getHours() ) + this.$helpers.pad2( date.getMinutes() ) + this.$helpers.pad2( date.getSeconds() ) );
                let filename = "Planschichten_" + month + spotFilter + "_Export_" + this.storeSettings.name + '_' + ts + ".csv";
                let encodedUri = encodeURI(csvPre) + "\uFEFF" +  encodeURIComponent(csv);
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", filename);
                document.body.appendChild(link); // Required for FF

                link.click();
            },
            exportDataToCsv(name, data){
                let view = this;
                if(data.length > 0){
                    var date = new Date();
                    let ts = date.getFullYear().toString() +"-"+ this.$helpers.pad2(date.getMonth() + 1) +"-"+ this.$helpers.pad2( date.getDate());


                    let csvPre = "data:text/csv;charset=utf-8,";
                    let headers = [];
                    for(let x in data[0]){
                        headers.push(x);
                    }
                    let csv = headers.join(";");
                    csv += "\n";
                    data.forEach(i => {
                        let values = [];
                        headers.forEach(h => {
                            values.push(i[h]);
                        })
                        csv+=values.join(";");
                        csv += "\n";
                    })
                    let encodedUri = encodeURI(csvPre) + "\uFEFF" +  encodeURIComponent(csv);
                    var link = document.createElement("a");
                    link.setAttribute("href", encodedUri);
                    link.setAttribute("download", name + ' - ' + ts + '.csv');
                    document.body.appendChild(link); // Required for FF
                    link.click();
                } else {
                    view.$helpers.error(view.$t('global.notifications.error'), 'Keine Daten für den Export vorhanden!')
                }


            },
            OpenShiftCountReportPopup(){
                let view = this;
                let description = this.$t('roster.view.shiftOverviewHelp');

                let employees = Object.values(view.employeeMap).map(e => {

                    return {label: e.lastName + " "+e.firstName, value: e.id}
                });
                employees.sort((a,b)=> {
                    if(a.label.toLowerCase() < b.label.toLowerCase()){
                        return -1;
                    } else if (a.label.toLowerCase() < b.label.toLowerCase()){
                        return 1;
                    }
                    return 0;
                });

                let from = view.$helpers.getMomentFromStringTZ(this.rosterFromTo.from);
                let to = view.$helpers.getMomentFromStringTZ(this.rosterFromTo.to);
                let temp = from.clone();
                let dates = [];
                while(temp <= to){
                    dates.push(temp.clone());
                    temp.add(1, 'days');
                }
                let dataEntries = [];
                dataEntries.push({label: this.$t('global.general.from'), key: 'from', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: this.$t('global.general.from'),
                        items: dates.map(d => {
                            return {
                                label: d.format("DD.MM.YYYY"),
                                value: d,
                                selected: d.unix() == from.unix()
                            }
                        }),
                        selectFirst: true,
                    },
                });
                let toItems = dates.map(d => {
                            return {
                                label: d.format("DD.MM.YYYY"),
                                value: d,
                                selected: d.unix() == to.unix()
                            }
                        });
                dataEntries.push({label: this.$t('global.general.to'), key: 'to', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: this.$t('global.general.to'),
                        items: toItems,
                        selectedItem: toItems.find(i => i.selected),
                    },
                });
                dataEntries.push({label: this.$t('global.ui.allEmployees'), key: 'employeeFlag', hidden: false, type: 'bool', value: true});
                dataEntries.push({label: this.$tc('global.general.employee'), key: 'employees', type: 'dropdownsearch', hidden: true,
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        placeholder: this.$t('global.ui.selectEmployee'),
                        items: employees.map(e => {
                            return {
                                label: e.label,
                                value: e.value,
                                selected: false
                            }
                        }),
                    },
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag').value;
                        if(employeeFlag){
                            entryBeforeUpdate.hidden = true;
                        } else {
                            entryBeforeUpdate.hidden = false;
                        }

                        return entryBeforeUpdate;
                    }
                });

                // all shifts from shift templates grouped by description
                let dataItems = []
                let shiftDescriptions = [];

                Object.values(view.shiftTemplateMap).forEach(st => {
                    let desc = st.description;
                    if(desc){
                        if(shiftDescriptions.indexOf(desc) == -1){
                            shiftDescriptions.push(desc);
                            let item = dataItems.find(i => i.label == desc);
                            if(!item){
                                dataItems.push({label: desc, value: desc});
                            }
                        }

                    }
                });

                dataEntries.push({label: this.$t('roster.view.assignments'), key: 'data', type: 'dropdownsearch',
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true, placeholder: this.$t('roster.view.selectAssignments'),
                        items: dataItems
                    }
                });
                dataEntries.push({label: "CSV", key: 'csv', hidden: false, type: 'bool', value: false});

                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        errorCheck: [

                            (entries) => {
                                if(entries['from'] != null && entries['from'] != null && entries['from'].isAfter(entries['to'])){
                                    return {key: 'to', type: 'error', label: this.$t('global.general.to'), text: this.$t('roster.view.chronologicalError')}
                                } else if (entries['data'] == null || entries['data'].length == 0){
                                    return {key: 'data', type: 'error', label: this.$t('store.settings.data'), text: this.$t('store.settings.pleaseSelectAssignments')}
                                } else {
                                    return null
                                }
                            },
                        ],
                        description: description,
                        selectCallback: function (data) {
                            if(data.data != null){
                                view.exportShiftCountReport(data.from, data.to, data.employeeFlag, data.employees, data.data, data.csv);
                            }


                        }
                    },
                    header: this.$t('roster.view.shiftNumberReport'),
                    expanded: true,
                    width: "700px",
                    centered: true
                });
            },
            exportShiftCountReport(from, to, allEmployees, employees, data, csv){
                let view = this;
                let shifts = Object.values(this.planShiftMap);
                shifts.sort((a, b) => {
                    let d1 = this.planShiftMomentMap[a.id].fromDate;
                    let d2 = this.planShiftMomentMap[b.id].fromDate;
                    if(d1.year() == d2.year() && d1.month() == d2.month() && d1.date() == d2.date()
                        && a.employeeId != null && b.employeeId != null
                        && view.employeeMap[a.employeeId] != null && view.employeeMap[b.employeeId] != null){
                        return view.employeeMap[b.employeeId].lastName.localeCompare(view.employeeMap[a.employeeId].lastName)
                    } else {
                        return d1.unix() - d2.unix();
                    }
                })
                let taskKeys = [];
                let headers = [this.$t('pages.employeeCoreData.personnelNumber'), this.$tc('global.general.employee')];
                data.forEach(d => {
                    headers.push(d);
                });

                let month = "";
                if(this.dateSelectionStart != null){
                    month = this.dateSelectionStart.format('YYYY_MMMM');
                }
                let date = new Date();
                let ts = ( date.getFullYear().toString() + this.$helpers.pad2(date.getMonth() + 1) + this.$helpers.pad2( date.getDate()) + '-' + this.$helpers.pad2( date.getHours() ) + this.$helpers.pad2( date.getMinutes() ) + this.$helpers.pad2( date.getSeconds() ) );
                let filename = "Schichtanzahl_" + month + "_Report_" + this.storeSettings.name + '_' + ts;

                let toCheck = to.clone().add(1, 'days');

                let body = [];
                let employeeShiftCountMap = {};
                shifts.forEach(shift => {
                    let startM = this.planShiftMomentMap[shift.id].fromDate.clone();
                    let endM = this.planShiftMomentMap[shift.id].toDate.clone();
                    if(endM > from && startM < toCheck && shift.templateId != null && (allEmployees || employees.includes(shift.employeeId))){
                        let employeeId = shift['employeeId'];
                        let desc = view.shiftTemplateMap[shift.templateId].description;
                        if(desc && desc.length > 0 && data.includes(desc)){
                            if(!(employeeId in employeeShiftCountMap)){
                                employeeShiftCountMap[employeeId] = {};
                            }
                            if(!(desc in employeeShiftCountMap[employeeId])){
                                employeeShiftCountMap[employeeId][desc] = 0;
                            }
                            employeeShiftCountMap[employeeId][desc] += 1;
                        }
                    }
                });
                if(csv){
                    let csvPre = "data:text/csv;charset=utf-8,";
                    let csv = headers.join(";");
                    csv += "\r\n";
                    for(let employeeId in employeeShiftCountMap){
                        let employee = view.employeeMap[employeeId];
                        if(employee != null && employee != undefined){
                            let line = [
                                employee.personenelId != null ? employee.personenelId : '',
                                employee.lastName + " " + employee.firstName];
                            data.forEach(d => {
                                let count = 0;
                                if(d in employeeShiftCountMap[employeeId]){
                                    count = employeeShiftCountMap[employeeId][d];
                                }
                                line.push(count);
                            });
                            csv += line.join(";");
                            csv += "\r\n";
                        }
                    }
                    filename = filename+ ".csv";
                    let encodedUri = encodeURI(csvPre) + "\uFEFF" +  encodeURIComponent(csv);
                    var link = document.createElement("a");
                    link.setAttribute("href", encodedUri);
                    link.setAttribute("download", filename);
                    document.body.appendChild(link); // Required for FF

                    link.click();
                }else{
                    for(let employeeId in employeeShiftCountMap){
                        let employee = view.employeeMap[employeeId];
                        if(employee != null && employee != undefined){
                            let line = [
                                employee.personenelId != null ? employee.personenelId : '',
                                employee.lastName + " " + employee.firstName];
                            data.forEach(d => {
                                let count = 0;
                                if(d in employeeShiftCountMap[employeeId]){
                                    count = employeeShiftCountMap[employeeId][d];
                                }
                                line.push(count);
                            });
                            body.push(line);
                        }
                    }

                    let repDoc = this.$helpers.tableReportDoc(
                        headers,
                        this.$t('roster.view.shiftNumbers') + ' ' + from.format('DD.MM.YYYY') + ' - ' + to.format('DD.MM.YYYY'),
                        this.storeSettings.name + ' ('+this.storeSettings.description+')',
                        data.join(", "),
                        this.userFullname,
                        8);
                    var doc = repDoc.doc;
                    var contentOffsetY = repDoc.contentOffsetY;
                    doc.setFontSize(12);
                    doc.autoTable({
                        startY: contentOffsetY,
                        head: [headers],
                        body: body,
                        headStyles: {
                            fillColor: [109,141,33],
                            fontSize: 8
                        },
                        bodyStyles: {
                            fontSize: 8
                        },
                        columnStyles: {

                        }
                    })
                    doc.setProperties({
                        title: this.$t('roster.view.shiftNumbers') + " Report"
                    });

                    view.$helpers.previewPdf(doc, filename+ '.pdf');
                }
            },

            OpenShiftDataExportPopup(){
                let view = this;
                let description = "";

                let employees = Object.values(view.employeeMap).map(e => {

                    return {label: e.lastName + " "+e.firstName, value: e.id}
                });

                let spots = Object.values(view.spotMap).map(s => {
                    return {label: s.name, value: s.id};
                });
                let dataItems = [
                    {label: this.$t('shift.main.planShifts'), value: 1},
                    {label: this.$t('shift.plan.punchTimes'), value: 2},
                ]



                employees.sort((a,b)=> {
                    if(a.label.toLowerCase() < b.label.toLowerCase()){
                        return -1;
                    } else if (a.label.toLowerCase() < b.label.toLowerCase()){
                        return 1;
                    }
                    return 0;
                });
                spots.sort((a,b) => {
                    if(a.label.toLowerCase() < b.label.toLowerCase()){
                        return -1;
                    } else if (a.label.toLowerCase() < b.label.toLowerCase()){
                        return 1;
                    }
                    return 0;
                });


                let from = view.$helpers.getMomentFromStringTZ(this.rosterFromTo.from);
                let to = view.$helpers.getMomentFromStringTZ(this.rosterFromTo.to);
                let temp = from.clone();
                let dates = [];
                while(temp <= to){
                    dates.push(temp.clone());
                    temp.add(1, 'days');
                }
                let dataEntries = [];
                dataEntries.push({label: this.$t('global.general.from'), key: 'from', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: this.$t('global.general.from'),
                        items: dates.map(d => {
                            return {
                                label: d.format("DD.MM.YYYY"),
                                value: d,
                                selected: d.unix() == from.unix()
                            }
                        }),
                        selectFirst: true,
                    },
                });
                let toItems = dates.map(d => {
                            return {
                                label: d.format("DD.MM.YYYY"),
                                value: d,
                                selected: d.unix() == to.unix()
                            }
                        });
                dataEntries.push({label: this.$t('global.general.to'), key: 'to', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: this.$t('global.general.to'),
                        items: toItems,
                        selectedItem: toItems.find(i => i.selected),
                    },
                });
                dataEntries.push({label: this.$t('global.ui.allEmployees'), key: 'employeeFlag', hidden: false, type: 'bool', value: true});
                dataEntries.push({label: this.$t('roster.view.selectByBusinessUnits'), key: 'selectSpot', type: 'bool', value: false, hidden: true,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag').value;
                        if(employeeFlag){
                            entryBeforeUpdate.hidden = true;
                        } else {
                            entryBeforeUpdate.hidden = false;
                        }

                        return entryBeforeUpdate;
                    }
                });
                dataEntries.push({label: this.$t('roster.view.selectBusinessUnits'), key: 'spot', type: 'dropdownsearch', hidden: true,
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        placeholder: this.$t('roster.view.selectBusinessUnits'),
                        items: spots.map(e => {
                            return {
                                label: e.label,
                                value: e.value,
                                selected: false
                            }
                        }),
                    },
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let selectSpot = datafill.entries.find(i => i.key == 'selectSpot').value;
                        if(selectSpot){
                            entryBeforeUpdate.hidden = false;
                        } else {
                            entryBeforeUpdate.hidden = true;
                        }

                        return entryBeforeUpdate;
                    }
                });
                dataEntries.push({label: this.$tc('global.general.employee'), key: 'employees', type: 'dropdownsearch', hidden: true,
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        placeholder: this.$t('global.ui.selectEmployee'),
                        items: employees.map(e => {
                            return {
                                label: e.label,
                                value: e.value,
                                selected: false
                            }
                        }),
                    },
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag').value;
                        let selectSpot = datafill.entries.find(i => i.key == 'selectSpot').value;
                        if(employeeFlag){
                            entryBeforeUpdate.hidden = true;
                        } else {
                            if(selectSpot){
                                entryBeforeUpdate.hidden = true;
                            }else{
                                entryBeforeUpdate.hidden = false;
                            }
                        }

                        return entryBeforeUpdate;
                    }
                });
                dataEntries.push({label: this.$t('store.settings.data'), key: 'data', type: 'dropdownsearch',
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true, selectFirst: true,
                        items: dataItems
                    }

                });
                dataEntries.push({label: this.$t('roster.view.onlyAssignedShifts'), key: 'assignedOnly', hidden: false, type: 'bool', value: true,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let dtype = datafill.entries.find(i => i.key == 'data').value;
                        if(dtype == 1){
                            entryBeforeUpdate.hidden = false;
                        } else {
                            entryBeforeUpdate.hidden = true;
                        }

                        return entryBeforeUpdate;
                    }
                });
                dataEntries.push({label: this.$t('roster.view.onlyPublishedShifts'), key: 'publishedOnly', hidden: false, type: 'bool', value: false,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let dtype = datafill.entries.find(i => i.key == 'data').value;
                        if(dtype == 1){
                            let assignedOnly = datafill.entries.find(i => i.key == 'assignedOnly').value;
                            if(!assignedOnly){
                                entryBeforeUpdate.value = false;
                            }
                            entryBeforeUpdate.hidden = false;
                        } else {
                            entryBeforeUpdate.hidden = true;
                        }

                        return entryBeforeUpdate;
                    }
                });
                dataEntries.push({label: this.$t('roster.view.onlyOpenShifts'), key: 'unassignedOnly', hidden: false, type: 'bool', value: false,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let dtype = datafill.entries.find(i => i.key == 'data').value;
                        if(dtype == 1){
                            entryBeforeUpdate.hidden = false;
                            let publishedOnly = datafill.entries.find(i => i.key == 'publishedOnly').value;
                            let assignedOnly = datafill.entries.find(i => i.key == 'assignedOnly').value;
                            if(publishedOnly || assignedOnly){
                                entryBeforeUpdate.value = false;
                            }
                        } else {
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;
                        }

                        return entryBeforeUpdate;
                    }
                });
                dataEntries.push({label: this.$t('roster.view.onlyPunchTimesWithComment'), key: 'commentedOnly', hidden: true, type: 'bool', value: false,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let dtype = datafill.entries.find(i => i.key == 'data').value;
                        if(dtype == 2){
                            entryBeforeUpdate.hidden = false;
                        } else {
                            entryBeforeUpdate.hidden = true;
                        }

                        return entryBeforeUpdate;
                    }
                });
                dataEntries.push({label: this.$t('roster.view.externalShiftsOnly'), key: 'externalOnly', hidden: false, type: 'bool', value: false});
                dataEntries.push({label: "CSV", key: 'csv', hidden: false, type: 'bool', value: false});



                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        errorCheck: [

                            (entries) => {
                                if(entries['from'] != null && entries['from'] != null && entries['from'].isAfter(entries['to'])){
                                    return {key: 'to', type: 'error', label: this.$t('global.general.to'), text: this.$t('roster.view.chronologicalError')}
                                } else {
                                    return null
                                }
                            },
                        ],
                        description: description,
                        selectCallback: function (data) {
                            if(data.data != null){
                                if(data.data == 1){
                                   view.exportPlanShiftDataToFile(data.from, data.to, data.employeeFlag, data.employees, data.spot, data.assignedOnly, data.publishedOnly, data.unassignedOnly, data.externalOnly, data.csv);
                                } else if(data.data == 2){
                                    view.exportActualShiftDataToFile(data.from, data.to, data.employeeFlag, data.employees, data.spot, data.externalOnly, data.csv, data.commentedOnly);
                                }
                            }


                        }
                    },
                    header: this.$t('roster.view.shiftDataExport'),
                    expanded: true,
                    width: "700px",
                    centered: true
                });
            },
            exportTaskOverviewToFile(date, data) {
                let view = this;

                let headers = [view.$tc('global.general.employee'), view.$t('global.general.from'), view.$t('global.general.to'),  view.$tc('store.structure.spot'), view.$tc('pages.positionOverview.task')];
                
                let body = view.$rosterhelper.taskOverviewBody(view.spotMap, view.$rosterhelper.changeBySpotId(view.planShiftMap, date, view.spotMap, data), view.$rosterhelper.entriesBySpotIds(view.positioningEntryMap), view.employeeMap, view.positioningTaskMap, view.$rosterhelper.tasksByEntryId(view.positioningTaskMap, view.positioningTaskAssignmentMap));

                let repDoc = view.$helpers.tableReportDoc(
                    headers,
                    view.$t('roster.view.taskOverview') + ' ' + date.format('DD.MM.YYYY'),
                    view.storeSettings.name + ' ('+view.storeSettings.description+')',
                    '',
                    this.userFullname,
                    8);
                let doc = repDoc.doc;
                let contentOffsetY = repDoc.contentOffsetY;
                doc.setFontSize(12);
                doc.autoTable({
                    startY: contentOffsetY,
                    head: [headers],
                    body: view.$rosterhelper.joinSuccessiveEntriesWithSameTask(body, data),
                    headStyles: {
                        fillColor: [109,141,33],
                        fontSize: 8
                    },
                    bodyStyles: {
                        fontSize: 8
                    },
                    columnStyles: {

                    }
                })
                doc.setProperties({
                    title: view.$t('roster.view.taskOverview')
                });

                view.$helpers.previewPdf(doc, view.$t('roster.view.taskOverview') + '.pdf');
            },
            exportPlanShiftDataToFile(from, to, allEmployees, employees, spot, assignedOnly, publishedOnly, unassignedOnly, externalOnly, csv = true){
                let view = this;


                let shifts = Object.values(this.planShiftMap);
                shifts.sort((a, b) => {
                    let d1 = this.planShiftMomentMap[a.id].fromDate;
                    let d2 = this.planShiftMomentMap[b.id].fromDate;
                    if(d1.year() == d2.year() && d1.month() == d2.month() && d1.date() == d2.date()
                        && a.employeeId != null && b.employeeId != null
                        && view.employeeMap[a.employeeId] != null && view.employeeMap[b.employeeId] != null){
                        return view.employeeMap[b.employeeId].lastName.localeCompare(view.employeeMap[a.employeeId].lastName)
                    } else {
                        return d1.unix() - d2.unix();
                    }
                })
                let taskKeys = [];
                let headers = [this.$t('pages.employeeCoreData.personnelNumber'), this.$tc('global.general.employee'), this.$t('store.settings.location'),this.$t('store.settings.date'),  "Start", "Ende", this.$t('shift.template.workTime'), this.$tc('shift.main.position'), "veröffentlicht", "veröffentlicht am"];

                let month = "";
                if(this.dateSelectionStart != null){
                    month = this.dateSelectionStart.format('YYYY_MMMM');
                }
                let date = new Date();
                let ts = ( date.getFullYear().toString() + this.$helpers.pad2(date.getMonth() + 1) + this.$helpers.pad2( date.getDate()) + '-' + this.$helpers.pad2( date.getHours() ) + this.$helpers.pad2( date.getMinutes() ) + this.$helpers.pad2( date.getSeconds() ) );
                let filename = "Planschichten_" + month + "_Export_" + this.storeSettings.name + '_' + ts;

                let toCheck = to.clone().add(1, 'days');
                if(csv){
                    let csvPre = "data:text/csv;charset=utf-8,";
                    let csv = headers.join(";");
                    if(shifts.length > 0){
                        shifts.forEach(shift => {
                            if(allEmployees || employees.includes(shift.employeeId)){
                                if(shift.tasks != null){
                                    shift.tasks.forEach(t => {
                                        if(!taskKeys.includes(t.label)){
                                            taskKeys.push(t.label);
                                        }
                                    });
                                }
                            }

                        });
                        taskKeys.forEach(k => {
                            csv += ";" + k;
                        });
                        csv += "\r\n";

                        shifts.forEach(shift => {

                            if((!publishedOnly || shift.published) && (!externalOnly || shift.fromLocationId != null)){
                                if(allEmployees || employees.includes(shift.employeeId) || spot.length != 0){
                                    let startM = this.planShiftMomentMap[shift.id].fromDate.clone();
                                    let endM = this.planShiftMomentMap[shift.id].toDate.clone();
                                    if(endM > from && startM < toCheck){
                                        let workValue = this.$helpers.getMomentDuration(startM,endM);
                                        let total = workValue.hours() * 60 + workValue.minutes();

                                        if(shift.workValue != -1){ //Do not calculate - take stored value (z.B. Schulung)
                                            total = shift.workValue;
                                        }

                                        if(shift.breakValue != -1 && shift.workValue == -1){
                                            total = total - shift.breakValue;
                                        }
                                        total = (Math.max(0, total)/60.0).toFixed(2);


                                        let empl = view.employeeMap[shift['employeeId']];
                                        let allow = true;
                                        if(unassignedOnly && empl != null){
                                            allow = false;
                                        } else if (assignedOnly && empl == null){
                                            allow = false;
                                        }
                                        if(allow){

                                            if(spot.length == 0 || spot.includes(empl['spotId'])){
                                                let assignedEmployee = empl != null ? empl['lastName'].toUpperCase() + ' ' + empl['firstName'] : '';
                                                let personnelId = empl != null ? empl.personnelId : '';

                                                let todos = "";
                                                let curTasks = {};
                                                taskKeys.forEach(k => {
                                                    curTasks[k] = '';
                                                });
                                                if(shift.tasks != null){
                                                    let first = true;
                                                    shift.tasks.forEach((t) => {
                                                        if(first){
                                                            first = false;
                                                        }else{
                                                            todos += ', ';
                                                        }
                                                        todos += t.label + ': ' + t.value;
                                                        curTasks[t.label] = t.value;
                                                    });
                                                }
                                                let cur = [
                                                    personnelId,
                                                    assignedEmployee,
                                                    shift.fromLocationId == null ? view.storeSettings.name : view.locationMap[shift.fromLocationId].name,
                                                    startM.format('DD.MM.YYYY'),
                                                    startM.format('HH:mm'),
                                                    endM.format('HH:mm'),
                                                    shift['toDate'].format('HH:mm'),
                                                    total,
                                                    view.spotMap[shift['spotId']]['name'],

                                                    shift['published']? this.$t('global.ui.yes').toUpperCase():this.$t('global.ui.no').toUpperCase(),
                                                    shift.publishDate != null ? view.$helpers.extractDateStringTZ(shift.publishDate, 'DD.MM.YYYY') : ''

                                                ];
                                                taskKeys.forEach(k => {
                                                    cur.push(curTasks[k]);
                                                });
                                                csv += cur.join(";");
                                                csv += "\r\n";
                                            }
                                        }
                                    }
                                }
                            }
                        });
                    }



                    filename = filename+ ".csv";
                    let encodedUri = encodeURI(csvPre) + "\uFEFF" +  encodeURIComponent(csv);
                    var link = document.createElement("a");
                    link.setAttribute("href", encodedUri);
                    link.setAttribute("download", filename);
                    document.body.appendChild(link); // Required for FF

                    link.click();
                } else {
                    let headers = ["PN", "Mitarbeiter", this.$t('store.settings.location'), this.$t('store.settings.date'),  "Start", "Ende", this.$t('shift.template.workTime'), this.$tc('shift.main.position'), "veröffentlicht", "veröffentlicht\nam"];

                    let body = [];
                    let sumWorkTime = 0;
                    shifts.forEach(shift => {
                        if((!publishedOnly || shift.published) && (!externalOnly || shift.fromLocationId != null)){
                            if(allEmployees || employees.includes(shift.employeeId) || spot.length != 0){
                                let startM = this.planShiftMomentMap[shift.id].fromDate.clone();
                                let endM = this.planShiftMomentMap[shift.id].toDate.clone();
                                if(endM > from && startM < toCheck){
                                    let workValue = this.$helpers.getMomentDuration(startM,endM);
                                    let total = workValue.hours() * 60 + workValue.minutes();

                                    if(shift.workValue != -1){ //Do not calculate - take stored value (z.B. Schulung)
                                        total = shift.workValue;
                                    }

                                    if(shift.breakValue != -1 && shift.workValue == -1){
                                        total = total - shift.breakValue;
                                    }
                                    let wv = Math.max(0, total)/60.0;

                                    total = (Math.max(0, total)/60.0).toFixed(2);


                                    let empl = view.employeeMap[shift['employeeId']];
                                    let allow = true;
                                    if(unassignedOnly && empl != null){
                                        allow = false;
                                    } else if (assignedOnly && empl == null){
                                        allow = false;
                                     }
                                    if(allow){

                                        if(spot.length == 0 || spot.includes(empl['spotId'])){
                                            let assignedEmployee = empl != null ? empl['lastName'].toUpperCase() + ' ' + empl['firstName'] : '';
                                            let personnelId = empl != null ? empl.personnelId : '';

                                            let cur = [
                                                personnelId,
                                                assignedEmployee,
                                                shift.fromLocationId == null ? view.storeSettings.name : view.locationMap[shift.fromLocationId].name,
                                                    startM.format('DD.MM.YYYY'),
                                                    startM.format('HH:mm'),
                                                    endM.format('HH:mm'),
                                                    total,
                                                    view.spotMap[shift['spotId']]['name'],
                                                    shift['published']? this.$t('global.ui.yes').toUpperCase():this.$t('global.ui.no').toUpperCase(),
                                                    shift.publishDate != null ? view.$helpers.extractDateStringTZ(shift.publishDate, 'DD.MM.YYYY') : ''
                                            ];
                                            sumWorkTime += wv;
                                            body.push(cur);
                                        }
                                    }
                                }
                            }
                        }
                    });
                    body.push([this.$t('global.ui.sum'), "", "", "", "", "", sumWorkTime.toFixed(2)+'h', "", "", ""]);
                    let repDoc = this.$helpers.tableReportDoc(
                        headers,
                        'Planschichten ' + from.format('DD.MM.YYYY') + ' - ' + to.format('DD.MM.YYYY'),
                        this.storeSettings.name + ' ('+this.storeSettings.description+')',
                        '',
                        this.userFullname,
                        8);
                    var doc = repDoc.doc;
                    var contentOffsetY = repDoc.contentOffsetY;
                    doc.setFontSize(12);
                    doc.autoTable({
                        startY: contentOffsetY,
                        head: [headers],
                        body: body,
                        headStyles: {
                            fillColor: [109,141,33],
                            fontSize: 8
                        },
                        bodyStyles: {
                            fontSize: 8
                        },
                        columnStyles: {

                        }
                    })
                    doc.setProperties({
                        title: this.$t('shift.main.planShifts')
                    });

                    view.$helpers.previewPdf(doc, filename+ '.pdf');
                }

            },

            exportActualShiftDataToFile(from, to, allEmployees = true, employees = [], spot = [], externalOnly = false, csv = true, commentedOnly = false){
                let view = this;
                let csvPre = "data:text/csv;charset=utf-8,";

                let shifts = Object.values(this.actualShiftMap);
                shifts.sort((a, b) => {
                    let d1 = this.actualShiftMomentMap[a.id].fromDate;
                    let d2 = this.actualShiftMomentMap[b.id].fromDate;
                    if(d1.year() == d2.year() && d1.month() == d2.month() && d1.date() == d2.date()
                        && a.employeeId != null && b.employeeId != null
                        && view.employeeMap[a.employeeId] != null && view.employeeMap[b.employeeId] != null){
                        return view.employeeMap[b.employeeId].lastName.localeCompare(view.employeeMap[a.employeeId].lastName)
                    } else {
                        return d1.unix() - d2.unix();
                    }
                })

                let month = "";
                if(this.dateSelectionStart != null){
                    month = this.dateSelectionStart.format('YYYY_MMMM');
                }

                let date = new Date();
                let ts = ( date.getFullYear().toString() + this.$helpers.pad2(date.getMonth() + 1) + this.$helpers.pad2( date.getDate()) + '-' + this.$helpers.pad2( date.getHours() ) + this.$helpers.pad2( date.getMinutes() ) + this.$helpers.pad2( date.getSeconds() ) );
                let filename = "Stempelzeiten_" + month + "_Export_" + this.storeSettings.name + '_' + ts;
                let headers = [this.$t('pages.employeeCoreData.personnelNumber'), this.$tc('global.general.employee'), this.$t('store.settings.location'), this.$t('store.settings.date'),  "Start", "Ende", "gestempelte Pausen", "Pausendauer (Minuten)", "Arbeitszeit (h)", "Feiertags Arbeitszeit (h)", this.$t('global.general.comment'), this.$t('roster.comp.employeeComment')];
                let body = [];
                let checkTo = to.clone().add(1,'days');
                let sumBreakTime = 0;
                let sumWorkTime = 0;
                let sumHolidayWorkTime = 0;
                shifts.forEach(shift => {
                    if(!commentedOnly || shift.employeeComment != null && shift.employeeComment != ''){
                    let locationId = shift.planshiftId != null ? (view.planShiftMap[shift.planshiftId] ? view.planShiftMap[shift.planshiftId].fromLocationId : null) : null;
                    if(shift.planShiftId == null || !view.planShiftMap[shift.planShiftId]){
                        //find overlapping planshift and check for location
                        let overlappingPlanShift = Object.values(view.planShiftMap).find(ps => {
                            let psStart = view.planShiftMomentMap[ps.id].fromDate;
                            let psEnd = view.planShiftMomentMap[ps.id].toDate;
                            return ps.employeeId == shift.employeeId && psStart < view.actualShiftMomentMap[shift.id].toDate && psEnd > view.actualShiftMomentMap[shift.id].fromDate;
                         });
                        if(overlappingPlanShift){
                            locationId = overlappingPlanShift.fromLocationId;
                        }
                    }
                    if((allEmployees || employees.includes(shift.employeeId) || spot.length != 0) && (!externalOnly || locationId != null)){
                        let startM = view.actualShiftMomentMap[shift.id].fromDate;
                        let endM = view.actualShiftMomentMap[shift.id].toDate;
                        if(endM > from && startM < checkTo){
                            let empl = view.employeeMap[shift['employeeId']];
                            let assignedEmployee = '';
                            let personnelId = "";
                            if(empl != null && empl != undefined){
                                assignedEmployee = empl['lastName'].toUpperCase() + ' ' + empl['firstName'];
                                personnelId = empl['personnelId'];
                                if(spot.length == 0 || spot.includes(empl['spotId'])){

                                    let breakValue = 0;
                                    let pauseStr = "";
                                    let pauseDurStr = "";
                                    let breaks = [];
                                    if(this.actualBreakShiftIdMap[shift.id]){
                                        breaks = this.actualBreakShiftIdMap[shift.id];
                                        breakValue = this.$helpers.CalculateBreakValueForActualShift(breaks, startM, endM)
                                        for(let j = breaks.length - 1; j >= 0; j--){
                                            let br = breaks[j];
                                            let check = this.$helpers.CheckActualBreakFromToInActualShift(br, startM, endM);
                                            if(check.isNonZeroDiff){
                                                let startP = check.from;
                                                let endP = check.to;
                                                if(pauseStr.length > 0) pauseStr += ", ";
                                                pauseStr += (startP.format('HH:mm') + "-" + endP.format('HH:mm'));
                                                let curBreakValue = this.$helpers.CalculateBreakValueForActualShift([br], startM, endM)
                                                if(pauseDurStr.length > 0) pauseDurStr += ", ";
                                                pauseDurStr += (curBreakValue/60000).toFixed(0);
                                            }
                                        }
                                    }
                                    let worktime = this.$helpers.CalculateWorktime(startM, endM, startM, endM, breakValue);
                                    //calculate holiday worktime
                                    let holidayWorkTime = 0;
                                    let seenHolidays = [];
                                    Object.values(this.holidayMap)
                                    .filter(h => startM < this.holidayMomentMap[h.id].toDate && endM > this.holidayMomentMap[h.id].fromDate)
                                    .forEach(h => {
                                        let holidayKey = view.holidayMomentMap[h.id].fromDate.format("YYYY-MM-DD");
                                        let pHolidayFrom = view.holidayMomentMap[h.id].fromDate;
                                        let pHolidayTo = view.holidayMomentMap[h.id].toDate;
                                        if (!seenHolidays.includes(holidayKey)) {
                                            let holidayFrom = startM < pHolidayFrom ? pHolidayFrom : (startM > pHolidayTo ? pHolidayTo : startM);
                                            let holidayTo = endM > pHolidayTo ? pHolidayTo : (endM < pHolidayFrom ? pHolidayFrom : endM);


                                            let shiftHolidayTime = Math.max(0, holidayTo.diff(holidayFrom, 'minutes'));
                                            if (view.actualBreakShiftIdMap[shift.id] && view.actualBreakShiftIdMap[shift.id].length > 0) {
                                                let breaks = view.actualBreakShiftIdMap[shift.id];
                                                breaks.forEach(abreak => {
                                                    let check = view.$helpers.CheckActualBreakFromToInActualShift(abreak, startM, endM);
                                                    if (check.isNonZeroDiff) {
                                                        let breakFrom = check.from;
                                                        let breakTo = check.to;
                                                        if (breakFrom < pHolidayTo && breakTo > pHolidayFrom) {
                                                            let holidayBreakFrom = breakFrom < pHolidayFrom ? pHolidayFrom : (breakFrom > pHolidayTo ? pHolidayTo : breakFrom);
                                                            let holidayBreakTo = breakTo > pHolidayTo ? pHolidayTo : (breakTo < pHolidayFrom ? pHolidayFrom : breakTo);

                                                            shiftHolidayTime -= Math.max(0, holidayBreakTo.diff(holidayBreakFrom, 'minutes'));
                                                        }
                                                    }
                                                });
                                            }
                                            holidayWorkTime += shiftHolidayTime;
                                            seenHolidays.push(holidayKey);

                                        }
                                    });
                                    let cur = [
                                        personnelId,
                                        assignedEmployee,
                                        locationId == null ? view.storeSettings.name : view.locationMap[locationId].name,
                                        startM.format('DD.MM.YYYY'),
                                        startM.format('HH:mm'),
                                        endM.format('HH:mm'),
                                        pauseStr,
                                        pauseDurStr,
                                        (worktime/3600000).toFixed(2).replace(".", ","),
                                        (holidayWorkTime/60.0).toFixed(2).replace(".",","),
                                        shift.comment != null ? (csv ? shift.comment.replace(/(?:\r\n|\r|\n)/g, ' ') : shift.comment) : '',
                                        shift.employeeComment != null ? (csv ? shift.employeeComment.replace(/(?:\r\n|\r|\n)/g, ' ') : shift.employeeComment) : ''
                                    ];
                                    sumBreakTime += (breakValue/3600000);
                                    sumWorkTime += (worktime/3600000);
                                    sumHolidayWorkTime += (holidayWorkTime/60.0);

                                    body.push(cur);
                                }
                            }
                        }
                    }
                    }

                })
                if(csv){
                    let csv = headers.join(";");
                    if(body.length > 0){
                        csv += "\r\n";
                        body.forEach(row => {
                            csv += row.join(";");
                            csv += "\r\n";
                        })
                    }



                    filename = filename + ".csv";
                    let encodedUri = encodeURI(csvPre) + "\uFEFF" +  encodeURIComponent(csv);
                    var link = document.createElement("a");
                    link.setAttribute("href", encodedUri);
                    link.setAttribute("download", filename);
                    document.body.appendChild(link); // Required for FF

                    link.click();
                } else {
                    headers = ["PN", "Mitarbeiter", "Standort", this.$t('store.settings.date'),  "Start", "Ende", "gestempelte\nPausen", "Pausendauer\n(Minuten)", "Arbeitszeit\n(h)", "Feiertags\nArbeitszeit\n(h)", "Kommentar", "Mitarbeiter\nKommentar"];

                    body.push([this.$t('global.ui.sum'), "", "", "", "", "", "", sumBreakTime.toFixed(2)+'h', sumWorkTime.toFixed(2).replace(".",",")+'h', sumHolidayWorkTime.toFixed(2).replace(".",",")+'h']);
                    let repDoc = this.$helpers.tableReportDoc(
                        headers,
                        'Stempelzeiten ' + from.format('DD.MM.YYYY') + ' - ' + to.format('DD.MM.YYYY'),
                        this.storeSettings.name + ' ('+this.storeSettings.description+')',
                        '',
                        this.userFullname,
                        8);
                    var doc = repDoc.doc;
                    var contentOffsetY = repDoc.contentOffsetY;
                    doc.setFontSize(12);
                    doc.autoTable({
                        startY: contentOffsetY,
                        head: [headers],
                        body: body,
                        headStyles: {
                            fillColor: [109,141,33],
                            fontSize: 8
                        },
                        bodyStyles: {
                            fontSize: 8
                        },
                        columnStyles: {

                        }
                    })
                    doc.setProperties({
                        title: this.$t('shift.plan.punchTimes')
                    });

                    view.$helpers.previewPdf(doc, filename+ '.pdf');
                }



            },
            OpenCompanyRosterCSVPopup(){
                let view = this;

                view.$helpers.GetCompanySpotMap(view.storeSettings.companyId)
                .then(map => {
                    let spotsByNameMap = {};
                    Object.values(map).forEach(spot => {
                        let key = spot.name;
                        if(!spotsByNameMap[key]){
                            spotsByNameMap[key] = [];
                        }
                        spotsByNameMap[key].push(spot);
                    })

                    let dataItems = Object.entries(spotsByNameMap).sort((a, b) => a[0].localeCompare(b[0])).map(entry => {return {label: entry[0], value: entry[1]}});


                    let dataEntries = [];
                    dataEntries.push({label: this.$tc('store.structure.spot', 2), key: 'spots', type: 'dropdownsearch',
                        dropdownSearchState: {
                            selectMultiple: true, styleLight: true, selectFirst: false,
                            items: dataItems
                        }

                    });


                    dataEntries.push({label: this.$t('roster.view.onlyPublishedShifts'), key: 'publishedOnly', hidden: false, type: 'bool', value: false});

                    let description = "Für welche Mitarbeiter Positionen soll der Export erstellen werden?<br/>";
                    view.$helpers.OpenPopup({
                        type: 'datafill',
                        componentState: {
                            entries: dataEntries,
                            description: description,
                            selectCallback: function (data) {
                                //view.exportPlanshiftsByHourAsCSV(data.from, data.to, data.publishedOnly);
                                //build spot id array
                                let spotIds = [];
                                data.spots.forEach(spots => {
                                    spots.forEach(spot => {
                                        spotIds.push(spot.id);
                                    })
                                })
                                view.$helpers.GetCompanyPlanshiftMap(view.storeSettings.companyId, spotIds)
                                .then(map => {
                                    view.exportCompanyRosterAsCSV(Object.values(map), data.publishedOnly);
                                }).catch(error => {
                                    console.log(error)
                                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                                })

                            }
                        },
                        header: 'Firmen Dienstplan CSV Export',
                        expanded: true,
                        centered: true
                    });
                }).catch(error => {
                    console.log(error)
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                })




            },
            exportCompanyRosterAsCSV(shifts, publishedOnly){
                let view = this;
                let csvPre = "data:text/csv;charset=utf-8,";



                let curM = this.rosterFromTo.month;

                let csv = "Store; Position; Personalnummer;Mitarbeiter; ";
                let startDate = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
                let endDate = startDate.clone().add(1, 'month');

                let itd = startDate.clone();
                while(itd < endDate){
                    csv +=itd.format("DD.MM.YYYY ddd")+"; "
                    itd = itd.add(1, 'day');
                }

                if(shifts.length > 0){

                    csv += "\r\n";
                    let employeeShiftMap = {};
                    shifts.forEach(shift => {
                        if(!publishedOnly || shift.published){
                            if(!employeeShiftMap[shift.employeeId]){
                                employeeShiftMap[shift.employeeId] = {
                                    shiftDayMap: {},
                                }
                            }
                            let entry = employeeShiftMap[shift.employeeId]
                            entry.firstName = shift.firstName;
                            entry.lastName = shift.lastName;
                            entry.personnelId = shift.personnelId;
                            entry.storeId = shift.storeId;
                            entry.storeName = shift.storeName;
                            entry.spotName = shift.employeeSpotName;
                            entry.personnelId = shift.personnelId;

                            let dateKey = view.$helpers.getMomentFromStringTZ(shift.from).format("YYYY-MM-DD");
                            if(!entry.shiftDayMap[dateKey]){
                                entry.shiftDayMap[dateKey] = [];
                            }
                            entry.shiftDayMap[dateKey].push(shift);
                        }

                    })

                    let sortedEmployees = Object.values(employeeShiftMap).sort((a, b) => {
                        if(a.storeId != b.storeId){
                            return a.storeName.localeCompare(b.storeName);
                        } else {
                            return a.lastName.localeCompare(b.lastName);
                        }
                    });
                    sortedEmployees.forEach(emp => {
                        let cur = [emp.storeName, emp.spotName, emp.personnelId, emp.firstName +" "+emp.lastName.toUpperCase()];
                        let itd = startDate.clone();
                        while(itd < endDate){
                            let dateKey = itd.format("YYYY-MM-DD");
                            if(emp.shiftDayMap[dateKey]){
                                let from = null;
                                let to = null;
                                emp.shiftDayMap[dateKey].forEach(shift => {
                                    let f = view.$helpers.getMomentFromStringTZ(shift.from);
                                    let t = view.$helpers.getMomentFromStringTZ(shift.to);
                                    if(from == null || f < from){
                                        from = f;
                                    }
                                    if(to == null || t > to){
                                        to = t;
                                    }
                                })
                                cur.push(from.format("HH:mm")+" - "+to.format("HH:mm"));
                            } else {
                                cur.push("")
                            }

                            itd = itd.add(1, 'day');
                        }
                        csv += cur.join(";");
                        csv += "\r\n";
                    })

                }
                let month = "";
                if(this.dateSelectionStart != null){
                    month = this.dateSelectionStart.format('YYYY_MMMM');
                }


                var date = new Date();
                let ts = ( date.getFullYear().toString() + this.$helpers.pad2(date.getMonth() + 1) + this.$helpers.pad2( date.getDate()) + '-' + this.$helpers.pad2( date.getHours() ) + this.$helpers.pad2( date.getMinutes() ) + this.$helpers.pad2( date.getSeconds() ) );
                let filename = "Firmen DPL_" + month + "_Export_" + ts + ".csv";
                let encodedUri = encodeURI(csvPre) + "\uFEFF" +  encodeURIComponent(csv);
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", filename);
                document.body.appendChild(link); // Required for FF

                link.click();
            },

            OpenSaldoReportPopup(){
                let view = this;
                let description = "In welchem Format soll der Report erstellt werden?<br/>";

                let dataItems = [
                    {label: "PDF", value: 1},
                    {label: "CSV", value: 2},
                ]

                let dataEntries = [];

                dataEntries.push({label: 'Format', key: 'format', type: 'dropdownsearch',
                    dropdownSearchState: {
                        selectMultiple: false,
                        styleLight: true,
                        selectFirst: true,
                        items: dataItems,
                    }

                });

                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: description,
                        selectCallback: function (data) {
                            view.generateSaldoReport(data.format == 2);


                        }
                    },
                    header: 'Saldostunden Report',
                    expanded: true,
                    centered: true
                });
            },
            generateSaldoReport(exportCSV = false){
                console.log('Generating saldo report');
                var date = new Date();

                //loss report is a specific report, if full month is not enabled in plannedcalc settings we only want the inside range to be considered
                //and we want to use 100% of soll
                //first make copy of settins since we dont want to change actual settings
                let calcSettings = Object.assign({}, this.plannedActualCalculationSetting);
                calcSettings.contractPlannedPercentage = 100;
                if(!calcSettings.fullMonth){
                    calcSettings.saldoMode = 1;
                }

                let rangeFrom = null;
                let rangeTo = null;
                let workTimeMode = calcSettings.workTimeMode;
                if(workTimeMode == null || workTimeMode == undefined) workTimeMode = this.storeSettings.workTimeMode;
                if(!calcSettings.fullMonth){
                    rangeFrom = calcSettings.from.clone();
                    rangeTo = calcSettings.to.clone().add(1, 'days').startOf('day');
                }

                let ts = ( date.getFullYear().toString() + this.$helpers.pad2(date.getMonth() + 1) + this.$helpers.pad2( date.getDate()) + this.$helpers.pad2( date.getHours() ) + this.$helpers.pad2( date.getMinutes() ) + this.$helpers.pad2( date.getSeconds() ) );

                let view = this;
                let headers = [this.$t('pages.employeeData.name'), this.$t('pages.employeeContext.ssn'), 'AZ Vormonat', this.$t('workBalance.summary.target'), 'Produktiv IST', 'Unproduktiv IST', 'AZ Saldo', 'FT Vormonat', 'FT', 'FT Saldo'];
                let headersCsv = [this.$t('pages.employeeData.name'), this.$t('pages.employeeContext.ssn'), 'AZ Vormonat', this.$t('workBalance.summary.target'), 'Produktiv IST', 'Unproduktiv IST', 'AZ Saldo', 'FT Vormonat', 'FT', 'FT Saldo'];
                let reportDateStr = (rangeFrom != null && rangeTo != null)? (rangeFrom.format('DD.MM.YYYY') + '-' + rangeTo.clone().add(-1,'days').format('DD.MM.YYYY')) : (this.$helpers.getMomentTZ().month(this.rosterFromTo.month).year(this.rosterFromTo.year).format('MMMM YYYY'));
                let filename = 'Plan Saldostunden ' + this.storeSettings.name + ' ' + reportDateStr + ' (Stand ' + this.$helpers.getMomentTZ().format('DD.MM.YYYY') + ')';
                var body = [];


                let lossPlannedActual = this.$rosterhelper.calculatePlannedActualMap(view.employeeMap, view.planShiftMap, view.planShiftMomentMap,
                                                                       view.actualShiftMomentMap, view.actualBreakShiftIdMap, view.actualBreakMomentMap,
                                                                       view.employeeDatePlannedShiftMap, view.employeeDateActualShiftMap,
                                                                       view.employeeDateActualShiftMarkedMap, view.employeePreferenceAvailabilityMap,
                                                                       view.employeePreferenceMomentMap, view.customHolidayMap, view.employeeIdWorkBalanceMap,
                                                                       view.employeeIdContractMap, view.employeeContractMomentMap, view.allowedContractMap,
                                                                       view.rosterVisibilityState, calcSettings,
                                                                       view.storeSettings,
                                                                       view.employeeAvgWorktimeMap,
                                                                       view.$helpers);
                let showSaldoPreCSV = this.plannedActualCalculationSetting.considerPreviousMonth;


                let csvPre = "data:text/csv;charset=utf-8,";
                let csv = "";
                csv += headersCsv.join(";");
                csv += "\n";

                let calcMethod = '';
                switch(workTimeMode){
                    case 2:
                        calcMethod = this.$tc('store.settings.weekdays', 2);
                        break;
                    case 1:
                        calcMethod = this.$t('store.settings.workingDays');
                        break;
                    default:
                        calcMethod = this.$t('store.settings.average');
                }
                var repDoc = this.$helpers.tableReportDoc(
                    headers,
                    'Saldostunden ' + reportDateStr,
                    this.storeSettings.name + ' ('+this.storeSettings.description+')',
                    'Sollstunden Berechnungsmodell: ' + calcMethod,
                    this.userFullname,
                    12);
                var doc = repDoc.doc;
                var contentOffsetY = repDoc.contentOffsetY;
                doc.setFontSize(12);



                let selectedEmployees = this.plannedActualCalculationSetting.employees ? this.plannedActualCalculationSetting.employees : null;
                let reportEmployees = [];
                Object.values(view.employeeMap).forEach(i => {
                    if((selectedEmployees == null || selectedEmployees.length == 0 || selectedEmployees.includes(i.id))){
                        reportEmployees.push(i.id);
                    }
                });
                Object.values(this.employeeMap).sort((a, b) => {
                    let aLN = a.lastName ? a.lastName : "";
                    let bLN = b.lastName ? b.lastName : "";
                    let c = aLN.toLowerCase().localeCompare(bLN.toLowerCase());
                    if(c != 0){
                        return c;
                    } else {
                        let aFN = a.firstName ? a.firstName : "";
                        let bFN = b.firstName ? b.firstName : "";
                        return aFN.toLowerCase().localeCompare(bFN.toLowerCase());
                    }
                }).forEach((e) => {

                    if(reportEmployees.includes(e.id) && e.id in lossPlannedActual){
                        let saldoPre = showSaldoPreCSV? (lossPlannedActual[e.id].unmodifiedDeltaWorkTime) : 0;
                        if(saldoPre != 0) saldoPre = saldoPre / 1000 / 3600;
                        let soll = lossPlannedActual[e.id].sollWorkTime / 1000 / 3600;
                        let sumProduktiv = lossPlannedActual[e.id].sumWorkTimeProduktiv / 1000 / 3600;
                        let sumUnproduktiv = lossPlannedActual[e.id].sumWorkTimeUnproduktiv / 1000 / 3600;

                        let workTimeSaldo = lossPlannedActual[e.id].total / 1000 / 3600;
                        let ftPre = lossPlannedActual[e.id].deltaFtWorkTime/ 1000 / 3600
                        let ftWorkTime = lossPlannedActual[e.id].sumFtWorkTime/ 1000 / 3600;

                        let ftSaldo = (lossPlannedActual[e.id].sumFtWorkTime + lossPlannedActual[e.id].deltaFtWorkTime) / 1000 / 3600;

                        let line = [
                            e.lastName + ' ' + e.firstName,
                            e.socialsecurity,
                            saldoPre.toFixed(2),
                            soll.toFixed(2),
                            sumProduktiv.toFixed(2),
                            sumUnproduktiv.toFixed(2),
                            workTimeSaldo.toFixed(2),
                            ftPre.toFixed(2),
                            ftWorkTime.toFixed(2),
                            ftSaldo.toFixed(2)

                        ]
                        body.push(line);

                        csv += line.join(";");
                        csv += "\n";
                    }
                });




                doc.autoTable({
                    startY: contentOffsetY,
                    head: [headers],
                    body: body,
                    headStyles: {
                        fillColor: [109,141,33],
                        fontSize: 7
                    },
                    bodyStyles: {
                        fontSize: 7
                    },
                    columnStyles: {

                    }
                })
                if(exportCSV){
                    let s = csv.split(".");
                    csv = s.join(",");
                    let encodedUri = encodeURI(csvPre) + "\uFEFF" + encodeURIComponent(csv);
                    var link = document.createElement("a");
                    link.setAttribute("href", encodedUri);
                    link.setAttribute("download", filename + ' - ' + ts + '.csv');
                    document.body.appendChild(link); // Required for FF
                    link.click();
                }else{
                    doc.setProperties({
                        title: "Saldostunden Report"
                    });
                    view.$helpers.previewPdf(doc, filename+ '.pdf');
                }
            },
            OpenEmployeeBreakReportPopup(date){
                let view = this;

                let dataEntries = [
                    { label: 'Detaillierter Pausenplan', key: 'detailed', hidden: false, type: 'bool', value: true },

                    { label: 'Nach Schicht Start sortieren', key: 'sortByShiftStart', hidden: this.$helpers.CheckDatafillKeysForHidden('detailed'), type: 'bool', value: true },
                    { label: 'Hochformat', key: 'vertical', hidden: this.$helpers.CheckDatafillKeysForHidden('detailed'), type: 'bool', value: false },
                    { label: 'Position anzeigen', key: 'showSpot', hidden: this.$helpers.CheckDatafillKeysForHidden('detailed'), type: 'bool', value: true },

                ];


                this.$helpers.OpenPopup({
                    elRelative: null,
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,

                    selectCallback: async (data) => {
                        this.generateEmployeeBreakReport(date, data);
                    },
                    },
                    header: 'Pausenplan PDF',
                    remainAfterSelect: false,
                    width: "600px",
                    expanded: true,
                    centered: true
                });
            },
            generateEmployeeBreakReport(date, data){
                console.log('Generating pause report template');

                let view = this;
                if(data.detailed){
                    let headers = [this.$t('pages.employeeData.name'), 'Schicht\r\nVon', 'Schicht\r\nBis', 'GesStd.', 'Pause\r\nVon', 'Pause\r\nBis', 'Pause\r\nVon', 'Pause\r\nBis', 'Unterschrift'];
                    if(data.showSpot){
                        headers.splice(1, 0, 'Pos.');
                    }
                    let reportDateStr = date.format('DD.MM.YYYY');
                    let filename = 'Pausenplan ' + this.storeSettings.name + ' ' + reportDateStr;
                    let body = [];
                    let dateKey = date.format('YYYY-MM-DD');

                    let planshifts = Object.values(this.planShiftMap).filter(s => {
                        let fromDate = this.$helpers.getMomentFromStringTZ(s.from);

                        return dateKey == fromDate.format('YYYY-MM-DD') && s.employeeId != null && this.employeeMap[s.employeeId] != null && s.published;
                    });

                    if(data.sortByShiftStart){
                        planshifts.sort((a, b) => {
                            let aFrom = this.$helpers.getMomentFromStringTZ(a.from);
                            let bFrom = this.$helpers.getMomentFromStringTZ(b.from);
                            return aFrom.unix() - bFrom.unix();
                        });
                    } else {
                        //sort by employee name
                        planshifts.sort((a, b) => {
                            let aEmp = this.employeeMap[a.employeeId];
                            let bEmp = this.employeeMap[b.employeeId];
                            let aName = aEmp.lastName + ' ' + aEmp.firstName;
                            let bName = bEmp.lastName + ' ' + bEmp.firstName;
                            return aName.localeCompare(bName);
                        });
                    }



                    let repDoc = this.$helpers.tableReportDoc(
                        headers,
                        'Pausenplan ' + reportDateStr,
                        this.storeSettings.name + ' ('+this.storeSettings.description+')', null, null, data.vertical ? 11 : 8);
                    let doc = repDoc.doc;
                    let contentOffsetY = repDoc.contentOffsetY;
                    doc.setFontSize(18);
                    if(data.vertical){
                        doc.setFontSize(14)
                    }

                    planshifts.forEach(s => {
                        let fromDate = this.$helpers.getMomentFromStringTZ(s.from);
                        let toDate = this.$helpers.getMomentFromStringTZ(s.to);
                        let totalWorkValue = 0;
                        if (s.workValue == null || s.workValue <= -1) {
                            let breakValue = this.$helpers.CalculateBreakValueForPlanShift(s, fromDate, toDate)

                            totalWorkValue = Math.max(0, toDate.diff(fromDate, 'minutes') - (breakValue / (60 * 1000)));
                        } else {
                            totalWorkValue = s.workValue;
                        }

                        let line = [
                            this.employeeMap[s.employeeId].lastName + ' ' + this.employeeMap[s.employeeId].firstName,

                            fromDate.format('HH:mm'),
                            toDate.format('HH:mm'),
                            (totalWorkValue/60.0).toFixed(2),
                            s.breakValue != null && s.breakValue > 0 ? '' : '/',
                            s.breakValue != null && s.breakValue > 0 ? '' : '/',
                            s.breakValue != null && s.breakValue > 0 ? '' : '/',
                            s.breakValue != null && s.breakValue > 0 ? '' : '/',
                            ''
                        ]
                        if(data.showSpot){
                            line.splice(1, 0, s.spotId != null && this.spotMap[s.spotId] != null ? this.spotMap[s.spotId].name : '');
                        }
                        body.push(line);
                    });

                    let colStyles = {};
                    for(let i = 0; i < headers.length; i++){
                        colStyles[i] = {
                            overflow: i == 0 || i == 1? 'ellipsize': 'clip',
                            minCellHeight: data.vertical ? 6 : 8,
                            fontSize: data.vertical ? 8 : 12,
                            cellWidth: data.vertical ? 12 : 15,
                            halign: 'center'
                        }
                    }
                    colStyles[0].cellWidth = data.vertical ? 40 : 60;
                    colStyles[0].halign = 'left';
                    if(data.showSpot){
                        colStyles[1].cellWidth = data.vertical ? 20 : 30;
                        colStyles[9].cellWidth = data.vertical ? 40 : 60;
                    } else {
                        colStyles[8].cellWidth = data.vertical ? 40 : 60;
                    }





                    let rowStyles = {};
                    for(let i = 0; i <= body.length; i++){
                        rowStyles[i] = {
                            fontSize: data.vertical ? 6 : 8,
                        }
                    }

                    doc.autoTable({
                        startY: contentOffsetY,
                        head: [headers],
                        body: body,
                        theme: 'grid',
                        headStyles: {
                            fillColor: [255,255,255],
                            textColor: [0,0,0],
                            fontSize: data.vertical ? 6 : 8
                        },
                        //alternateRowStyles: rowStyles,
                        columnStyles: colStyles,
                        bodyStyles: {lineColor: [0, 0, 0], lineWidth: 0.3}
                    })


                    let externalStoreMap = {};
                    Object.values(this.externalShiftMap).forEach(s => {
                        let fromDate = this.$helpers.getMomentFromStringTZ(s.from);
                        if(dateKey == fromDate.format('YYYY-MM-DD') && s.published){
                            if(!externalStoreMap[s.sourceStoreName]){
                                externalStoreMap[s.sourceStoreName] = [];
                            }
                            externalStoreMap[s.sourceStoreName].push(s);
                        }


                    });
                    Object.keys(externalStoreMap).forEach(k => {
                        let externalshifts = externalStoreMap[k];

                        if(data.sortByShiftStart){
                            externalshifts.sort((a, b) => {
                                let aFrom = this.$helpers.getMomentFromStringTZ(a.from);
                                let bFrom = this.$helpers.getMomentFromStringTZ(b.from);
                                return aFrom.unix() - bFrom.unix();
                            });
                        } else {
                            //sort by employee name
                            externalshifts.sort((a, b) => {

                                let aName = a.employeeLastName + ' ' + a.employeeFirstName;
                                let bName = b.employeeLastName + ' ' + b.employeeFirstName;
                                return aName.localeCompare(bName);
                            });
                        }
                        let body = [];
                        externalshifts.forEach(s => {
                            let fromDate = this.$helpers.getMomentFromStringTZ(s.from);
                            let toDate = this.$helpers.getMomentFromStringTZ(s.to);
                            let totalWorkValue = 0;
                            if (s.workValue == null || s.workValue <= -1) {
                                let breakValue = this.$helpers.CalculateBreakValueForPlanShift(s, fromDate, toDate)

                                totalWorkValue = Math.max(0, toDate.diff(fromDate, 'minutes') - (breakValue / (60 * 1000)));
                            } else {
                                totalWorkValue = s.workValue;
                            }

                            let line = [
                                s.employeeLastName + ' ' + s.employeeFirstName,

                                fromDate.format('HH:mm'),
                                toDate.format('HH:mm'),
                                (totalWorkValue/60.0).toFixed(2),
                                s.breakValue != null && s.breakValue > 0 ? '' : '/',
                                s.breakValue != null && s.breakValue > 0 ? '' : '/',
                                s.breakValue != null && s.breakValue > 0 ? '' : '/',
                                s.breakValue != null && s.breakValue > 0 ? '' : '/',
                                ''
                            ]
                            if(data.showSpot){
                                line.splice(1, 0, s.spotName != null != null ? s.spotName : '');
                            }
                            body.push(line);
                        });

                        let finalY = doc.lastAutoTable.finalY || 10
                        //let pageSize = doc.internal.pageSize
                        //let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()

                        let offset = finalY //+ (pageHeight - (finalY % pageHeight))
                        doc.setFontSize(14);
                        doc.text("Extern aus: "+k, 15, offset+15);
                        doc.setFontSize(18);
                        doc.autoTable({
                            startY: offset + 20,
                            head: [headers],
                            body: body,
                            theme: 'grid',
                            headStyles: {
                                fillColor: [255,255,255],
                                textColor: [0,0,0],
                                fontSize: data.vertical ? 6 : 8
                            },
                            //alternateRowStyles: rowStyles,
                            columnStyles: colStyles,
                            bodyStyles: {lineColor: [0, 0, 0], lineWidth: 0.3}
                        })
                    });

                    doc.setProperties({
                        title: "Pausen Report"
                    });
                    view.$helpers.previewPdf(doc, filename+ '.pdf');
                } else {
                    let headers = [this.$t('pages.employeeData.name'), 'Pause Start', 'Pause Ende', 'Unterschrift'];
                    let reportDateStr = date.format('DD.MM.YYYY');
                    let filename = 'Pausen ' + this.storeSettings.name + ' ' + reportDateStr;
                    let body = [];
                    let dateKey = date.format('YYYY-MM-DD');

                    let assignedEmployees = new Set();
                    let externalStoreMap = {};


                    Object.values(this.planShiftMap).forEach(s => {
                        let fromDate = this.$helpers.getMomentFromStringTZ(s.from);

                        if(dateKey == fromDate.format('YYYY-MM-DD')){
                            if(!view.unassigned && s.employeeId != null && this.employeeMap[s.employeeId] != null){
                                assignedEmployees.add(this.employeeMap[s.employeeId].lastName + ' ' + this.employeeMap[s.employeeId].firstName);
                            }
                        }
                    });

                    Object.values(this.externalShiftMap).forEach(s => {
                        let fromDate = this.$helpers.getMomentFromStringTZ(s.from);

                        if(dateKey == fromDate.format('YYYY-MM-DD')){
                            if(!externalStoreMap[s.sourceStoreName]){
                                externalStoreMap[s.sourceStoreName] = new Set();
                            }
                            externalStoreMap[s.sourceStoreName].add(s.employeeLastName + ' ' + s.employeeFirstName);
                        }
                    });

                    let repDoc = this.$helpers.tableReportDoc(
                        headers,
                        'Pausen ' + reportDateStr,
                        this.storeSettings.name + ' ('+this.storeSettings.description+')');
                    let doc = repDoc.doc;
                    let contentOffsetY = repDoc.contentOffsetY;
                    doc.setFontSize(18);

                    Array.from(assignedEmployees).sort((a,b) => a.localeCompare(b)).forEach(e => {
                        let line = [
                            e,
                            '',
                            '',
                            ''
                        ]
                        body.push(line);
                    });

                    let colStyles = {};
                    for(let i = 0; i < headers.length; i++){
                        colStyles[i] = {
                            overflow: i == 0? 'ellipsize': 'clip',
                            minCellHeight: 10,
                            fontSize: 12,
                        }
                    }
                    colStyles[0].cellWidth = 60;
                    colStyles[1].cellWidth = 30;
                    colStyles[2].cellWidth = 30;

                    let rowStyles = {};
                    for(let i = 0; i <= body.length; i++){
                        rowStyles[i] = {
                            fontSize: 8,
                        }
                    }

                    doc.autoTable({
                        startY: contentOffsetY,
                        head: [headers],
                        body: body,
                        theme: 'grid',
                        headStyles: {
                            fillColor: [255,255,255],
                            textColor: [0,0,0],
                            fontSize: 8
                        },
                        //alternateRowStyles: rowStyles,
                        columnStyles: colStyles,
                        bodyStyles: {lineColor: [0, 0, 0], lineWidth: 0.3}
                    })

                    Object.keys(externalStoreMap).forEach(k => {
                        let externalEmployees = Array.from(externalStoreMap[k]).sort((a,b) => a.localeCompare(b));
                        let body = [];
                        externalEmployees.forEach(e => {
                            let line = [
                                e,
                                '',
                                '',
                                ''
                            ]
                            body.push(line);
                        });

                        let finalY = doc.lastAutoTable.finalY || 10
                        //let pageSize = doc.internal.pageSize
                        //let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()

                        let offset = finalY //+ (pageHeight - (finalY % pageHeight))
                        doc.setFontSize(14);
                        doc.text("Extern aus: "+k, 15, offset+15);
                        doc.setFontSize(18);
                        doc.autoTable({
                            startY: offset + 20,
                            head: [headers],
                            body: body,
                            theme: 'grid',
                            headStyles: {
                                fillColor: [255,255,255],
                                textColor: [0,0,0],
                                fontSize: 8
                            },
                            //alternateRowStyles: rowStyles,
                            columnStyles: colStyles,
                            bodyStyles: {lineColor: [0, 0, 0], lineWidth: 0.3}
                        })
                    });

                    doc.setProperties({
                        title: "Pausen Report"
                    });
                    view.$helpers.previewPdf(doc, filename+ '.pdf');
                }

            },
            generateEmployeeMealCostsReport(date){
                console.log('Generating meal costs report');

                let view = this;
                let headers = [this.$t('pages.employeeData.name'), 'Nummer', 'Stk.', this.$t('roster.comp.staffMeal'), 'Unterschrift'];
                let reportDateStr = date.format('DD.MM.YYYY');
                let filename = this.$t('roster.comp.staffMeal') + ' ' + this.storeSettings.name + ' ' + reportDateStr;
                var body = [];
                var dateKey = date.format('YYYY-MM-DD');
                let assignedEmployees = new Set();
                let externalStoreMap = {};


                Object.values(this.planShiftMap).forEach(s => {
                    let fromDate = this.$helpers.getMomentFromStringTZ(s.from);

                    if(dateKey == fromDate.format('YYYY-MM-DD')){
                        if(!view.unassigned && s.employeeId != null && this.employeeMap[s.employeeId] != null){
                            assignedEmployees.add(this.employeeMap[s.employeeId].lastName + ' ' + this.employeeMap[s.employeeId].firstName);
                        }
                    }
                });
                Object.values(this.externalShiftMap).forEach(s => {
                    let fromDate = this.$helpers.getMomentFromStringTZ(s.from);

                    if(dateKey == fromDate.format('YYYY-MM-DD')){
                        if(!externalStoreMap[s.sourceStoreName]){
                            externalStoreMap[s.sourceStoreName] = new Set();
                        }
                        externalStoreMap[s.sourceStoreName].add(s.employeeLastName + ' ' + s.employeeFirstName);
                    }
                });

                var repDoc = this.$helpers.tableReportDoc(
                    headers,
                    this.$t('roster.comp.staffMeal') + ' ' + reportDateStr,
                    this.storeSettings.name + ' ('+this.storeSettings.description+')');
                var doc = repDoc.doc;
                var contentOffsetY = repDoc.contentOffsetY;
                doc.setFontSize(18);

                Array.from(assignedEmployees).sort((a,b) => a.localeCompare(b)).forEach(e => {
                    let line = [
                        e,
                        '',
                        '',
                        ''
                    ]
                    body.push(line);
                });



                let colStyles = {};
                for(let i = 0; i < headers.length; i++){
                    colStyles[i] = {
                        overflow: i == 0? 'ellipsize': 'clip',
                        minCellHeight: body.length <= 24 ? 10 : 8,
                        fontSize: body.length <= 24 ? 12 : 10,
                    }
                }
                colStyles[0].cellWidth = 60;
                colStyles[1].cellWidth = 15;
                colStyles[2].cellWidth = 15;

                let rowStyles = {};
                for(let i = 0; i <= body.length; i++){
                    rowStyles[i] = {
                        fontSize: body.length <= 24 ? 8 : 6,
                    }
                }

                doc.autoTable({
                    startY: contentOffsetY,
                    head: [headers],
                    body: body,
                    theme: 'grid',
                    headStyles: {
                        fillColor: [255,255,255],
                        textColor: [0,0,0],
                        fontSize: 8
                    },
                    //alternateRowStyles: rowStyles,
                    columnStyles: colStyles,
                    bodyStyles: {lineColor: [0, 0, 0], lineWidth: 0.3}
                })

                Object.keys(externalStoreMap).forEach(k => {
                    let externalEmployees = Array.from(externalStoreMap[k]).sort((a,b) => a.localeCompare(b));
                    let body = [];
                    externalEmployees.forEach(e => {
                        let line = [
                            e,
                            '',
                            '',
                            ''
                        ]
                        body.push(line);
                    });

                    let finalY = doc.lastAutoTable.finalY || 10
                    //let pageSize = doc.internal.pageSize
                    //let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()

                    let offset = finalY //+ (pageHeight - (finalY % pageHeight))
                    doc.setFontSize(14);
                    doc.text("Extern aus: "+k, 15, offset+15);
                    doc.setFontSize(18);
                    doc.autoTable({
                        startY: offset + 20,
                        head: [headers],
                        body: body,
                        theme: 'grid',
                        headStyles: {
                            fillColor: [255,255,255],
                            textColor: [0,0,0],
                            fontSize: 8
                        },
                        //alternateRowStyles: rowStyles,
                        columnStyles: colStyles,
                        bodyStyles: {lineColor: [0, 0, 0], lineWidth: 0.3}
                    })
                });

                doc.setProperties({
                    title: this.$t('roster.comp.staffMeal') + " Report"
                });
                view.$helpers.previewPdf(doc, filename+ '.pdf');
            },
            OpenLossReportPopup(){
                let view = this;
                let description = "In welchem Format soll der Report erstellt werden?<br/>";

                let dataItems = [
                    {label: "PDF", value: 1},
                    {label: "CSV", value: 2},
                ]

                let dataEntries = [];

                dataEntries.push({label: 'Format', key: 'format', type: 'dropdownsearch',
                    dropdownSearchState: {
                        selectMultiple: false,
                        styleLight: true,
                        selectFirst: true,
                        items: dataItems,
                    }

                });

                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: description,
                        selectCallback: function (data) {
                            view.generateLossReport(data.format == 2);


                        }
                    },
                    header: 'Ausfallstunden Report',
                    expanded: true,
                    centered: true
                });
            },
            generateLossReport(exportCSV = false){
                console.log('Generating loss report');
                var date = new Date();

                //loss report is a specific report, if full month is not enabled in plannedcalc settings we only want the inside range to be considered
                //and we want to use 100% of soll
                //first make copy of settins since we dont want to change actual settings
                let calcSettings = Object.assign({}, this.plannedActualCalculationSetting);
                calcSettings.contractPlannedPercentage = 100;
                calcSettings.considerPreviousMonth = false;
                if(!calcSettings.fullMonth){
                    calcSettings.saldoMode = 1;
                }

                let rangeFrom = null;
                let rangeTo = null;
                let workTimeMode = calcSettings.workTimeMode;
                if(workTimeMode == null || workTimeMode == undefined) workTimeMode = this.storeSettings.workTimeMode;
                if(!calcSettings.fullMonth){
                    rangeFrom = calcSettings.from.clone();
                    rangeTo = calcSettings.to.clone().add(1, 'days').startOf('day');
                }

                let ts = ( date.getFullYear().toString() + this.$helpers.pad2(date.getMonth() + 1) + this.$helpers.pad2( date.getDate()) + this.$helpers.pad2( date.getHours() ) + this.$helpers.pad2( date.getMinutes() ) + this.$helpers.pad2( date.getSeconds() ) );

                let view = this;
                let headers = [this.$t('pages.employeeData.name'), this.$t('pages.employeeContext.ssn'), this.$t('workBalance.summary.target'), '', 'Produktiv IST', '', 'Unproduktiv IST', '', 'IST %', '', 'Ausfallstunden'];
                let headersCsv = [this.$t('pages.employeeData.name'), this.$t('pages.employeeContext.ssn'), this.$t('workBalance.summary.target'), 'Produktiv IST', 'Unproduktiv IST', 'IST gesamt', 'Differenz', 'IST %', 'Ausfallstunden'];
                let reportDateStr = (rangeFrom != null && rangeTo != null)? (rangeFrom.format('DD.MM.YYYY') + '-' + rangeTo.clone().add(-1,'days').format('DD.MM.YYYY')) : (this.$helpers.getMomentTZ().month(this.rosterFromTo.month).year(this.rosterFromTo.year).format('MMMM YYYY'));
                let filename = 'Ausfallstunden ' + this.storeSettings.name + ' ' + reportDateStr + ' (Stand ' + this.$helpers.getMomentTZ().format('DD.MM.YYYY') + ')';
                var body = [];


                let lossPlannedActual = this.$rosterhelper.calculatePlannedActualMap(view.employeeMap, view.planShiftMap, view.planShiftMomentMap,
                                                                       view.actualShiftMomentMap, view.actualBreakShiftIdMap, view.actualBreakMomentMap,
                                                                       view.employeeDatePlannedShiftMap, view.employeeDateActualShiftMap,
                                                                       view.employeeDateActualShiftMarkedMap, view.employeePreferenceAvailabilityMap,
                                                                       view.employeePreferenceMomentMap, view.customHolidayMap, view.employeeIdWorkBalanceMap,
                                                                       view.employeeIdContractMap, view.employeeContractMomentMap, view.allowedContractMap,
                                                                       view.rosterVisibilityState, calcSettings,
                                                                       view.storeSettings,
                                                                       view.employeeAvgWorktimeMap,
                                                                       view.$helpers);

                let showSaldoPreCSV = this.plannedActualCalculationSetting.considerPreviousMonth;
                if(showSaldoPreCSV){
                    headersCsv.splice(2,0,'Delta Vormonat');
                }

                let csvPre = "data:text/csv;charset=utf-8,";
                let csv = "";
                csv += headersCsv.join(";");
                csv += "\n";

                let calcMethod = '';
                switch(workTimeMode){
                    case 2:
                        calcMethod = this.$tc('store.settings.weekdays', 2);
                        break;
                    case 1:
                        calcMethod = this.$t('store.settings.workingDays');
                        break;
                    default:
                        calcMethod = this.$t('store.settings.average');
                }
                var repDoc = this.$helpers.tableReportDoc(
                    headers,
                    'Ausfallstunden ' + reportDateStr,
                    this.storeSettings.name + ' ('+this.storeSettings.description+')',
                    'Sollstunden Berechnungsmodell: ' + calcMethod,
                    this.userFullname,
                    12);
                var doc = repDoc.doc;
                var contentOffsetY = repDoc.contentOffsetY;
                doc.setFontSize(12);

                var lossHours = 0;
                let selectedEmployees = this.plannedActualCalculationSetting.employees ? this.plannedActualCalculationSetting.employees : null;
                let reportEmployees = [];
                Object.values(view.employeeMap).forEach(i => {
                    if((selectedEmployees == null || selectedEmployees.length == 0 || selectedEmployees.includes(i.id))){
                        reportEmployees.push(i.id);
                    }
                });
                Object.values(this.employeeMap).sort((a, b) => {
                    let aLN = a.lastName ? a.lastName : "";
                    let bLN = b.lastName ? b.lastName : "";
                    let c = aLN.toLowerCase().localeCompare(bLN.toLowerCase());
                    if(c != 0){
                        return c;
                    } else {
                        let aFN = a.firstName ? a.firstName : "";
                        let bFN = b.firstName ? b.firstName : "";
                        return aFN.toLowerCase().localeCompare(bFN.toLowerCase());
                    }
                }).forEach((e) => {
                    /*
                    employeePlannedActual[employee.id].sumSollWorkTime/1000/3600).toFixed(2)
                    employeePlannedActual[employee.id].sumWorkTimeProduktiv/1000/3600).toFixed(2)
                    employeePlannedActual[employee.id].sumWorkTimeUnproduktiv/1000/3600).toFixed(2)
                    */
                    if(reportEmployees.includes(e.id) && e.id in lossPlannedActual){
                        let soll = lossPlannedActual[e.id].sollWorkTime / 1000 / 3600;
                        let sumProduktiv = lossPlannedActual[e.id].sumWorkTimeProduktiv / 1000 / 3600;
                        let sumUnproduktiv = lossPlannedActual[e.id].sumWorkTimeUnproduktiv / 1000 / 3600;
                        let p = soll > 0? (100 * (sumProduktiv + sumUnproduktiv)) / soll : 0;
                        let loss = soll - sumProduktiv - sumUnproduktiv;
                        let saldoPre = showSaldoPreCSV? (lossPlannedActual[e.id].unmodifiedDeltaWorkTime) : 0;
                        if(saldoPre != 0) saldoPre = saldoPre / 1000 / 3600;
                        if(loss > 0) lossHours += loss;
                        body.push([
                            e.lastName + ' ' + e.firstName,
                            e.socialsecurity,
                            soll.toFixed(2),
                            '',
                            sumProduktiv.toFixed(2),
                            '',
                            sumUnproduktiv.toFixed(2),
                            '',
                            p.toFixed(0) + '%',
                            '',
                            loss > 0? loss.toFixed(2) : ''
                        ]);
                        let lineFields = [e.lastName + ' ' + e.firstName,e.socialsecurity,soll.toFixed(2),sumProduktiv.toFixed(2),sumUnproduktiv.toFixed(2), (sumProduktiv + sumUnproduktiv).toFixed(2),(sumProduktiv + sumUnproduktiv - soll + saldoPre).toFixed(2),p.toFixed(0) + '%',loss > 0? loss.toFixed(2) : ''];
                        if(showSaldoPreCSV){
                            lineFields.splice(2, 0, saldoPre.toFixed(2));
                        }
                        csv += lineFields.join(";");
                        csv += "\n";
                    }
                });

                body.push(['','','','','','','','','','','']);
                body.push(['Ausfallstunden gesamt','','','','','','','','','',lossHours.toFixed(2)]);


                doc.autoTable({
                    startY: contentOffsetY,
                    head: [headers],
                    body: body,
                    headStyles: {
                        fillColor: [109,141,33],
                        fontSize: 7
                    },
                    bodyStyles: {
                        fontSize: 7
                    },
                    columnStyles: {
                        2: {
                            halign: 'right',
                            cellWidth: 11
                        },
                        3: {
                            halign: 'right',
                            cellWidth: 3
                        },
                        4: {
                            halign: 'right',
                            cellWidth: 20
                        },
                        5: {
                            halign: 'right',
                            cellWidth: 3
                        },
                        6: {
                            halign: 'right',
                            cellWidth: 23
                        },
                        7: {
                            halign: 'right',
                            cellWidth: 3
                        },
                        8: {
                            halign: 'right',
                            cellWidth: 11
                        },
                        9: {
                            halign: 'right',
                            cellWidth: 3
                        },
                        10: {
                            halign: 'right',
                            cellWidth: 21
                        },
                    }
                })
                if(exportCSV){
                    let s = csv.split(".");
                    csv = s.join(",");
                    let encodedUri = encodeURI(csvPre) + "\uFEFF" + encodeURIComponent(csv);
                    var link = document.createElement("a");
                    link.setAttribute("href", encodedUri);
                    link.setAttribute("download", filename + ' - ' + ts + '.csv');
                    document.body.appendChild(link); // Required for FF
                    link.click();
                }else{

                    doc.setProperties({
                        title: "Ausfallstunden Report"
                    });
                    view.$helpers.previewPdf(doc, filename+ '.pdf');
                }
            },
            OpenWeekWorkTimeReportPopup() {
                let view = this;
                let description = "In welchem Format soll der Report erstellt werden?<br/>";

                let dataItems = [
                    {label: "PDF", value: 1},
                    {label: "CSV", value: 2},
                ]

                let dataEntries = [];

                dataEntries.push({label: 'Format', key: 'format', type: 'dropdownsearch',
                    dropdownSearchState: {
                        selectMultiple: false,
                        styleLight: true,
                        selectFirst: true,
                        items: dataItems,
                    }

                });
                let weekItems = [];
                let from = view.$helpers.getMomentFromStringTZ(this.rosterFromTo.from);
                let to = view.$helpers.getMomentFromStringTZ(this.rosterFromTo.to);
                while(from < to){
                    let weekFrom = from.clone();
                    let weekTo = from.clone().add(7, 'days');
                    let monthFrom = this.startOfMonth.clone();
                    let monthTo = monthFrom.clone().endOf('month').add(1, 'days').startOf('day');
                    if(weekTo < monthTo){
                        monthTo = weekTo;
                    }
                    weekItems.push({label: weekFrom.format('DD.MM.YYYY')+' -'+weekTo.format('DD.MM.YYYY'),
                    value: {isoWeek: weekFrom.isoWeek(), weekFrom: weekFrom, weekTo: weekTo, monthFrom: monthFrom, monthTo: monthTo},
                    selected: true});
                    from = from.add(7, 'days');
                }
                dataEntries.push({label: this.$t('indicator.eval.weekS'), key: 'weeks', type: 'dropdownsearch',
                    dropdownSearchState: {
                        selectMultiple: true,
                        styleLight: true,
                        selectedItems: weekItems.filter(i => i.selected),
                        items: weekItems,
                    }

                });
                dataEntries.push({label: 'Einträge ohne Arbeitszeit inkludieren', key: 'includeAll', type: 'bool', value: false});
                dataEntries.push({label: 'Detaillierte Auftrennung der Arbeitszeit', key: 'detailedSplit', type: 'bool', value: false});
                dataEntries.push({label: 'Kumulierte Monats Arbeitszeit', key: 'includeMonthly', type: 'bool', value: true});


                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: description,
                        selectCallback: function (data) {
                            view.generateWeekWorkTimeReport(weekItems.map(i => i.value), data.weeks, data.includeAll, data.detailedSplit, data.includeMonthly, data.format == 2);


                        }
                    },
                    header: 'Wochenstunden Report',
                    expanded: true,
                    centered: true,
                    width: '700px'
                });
            },
            generateWeekWorkTimeReport(weekItems, weeks, includeAll = false, detailedSplit = false, includeMonthly = true, exportCSV = false){
                let weekWorkTimeMap = this.$rosterhelper.calculateWeekWorkMap(this.employeeDateCombinedShiftMap,
                                                                                this.employeePreferenceAvailabilityMap,
                                                                                this.planShiftMomentMap,
                                                                                this.actualShiftMomentMap,
                                                                                this.actualBreakShiftIdMap,
                                                                                this.actualBreakMomentMap,
                                                                                this.employeePreferenceMomentMap,
                                                                                this.employeeIdContractMap,
                                                                                this.employeeContractMomentMap,
                                                                                this.storeSettings,
                                                                                this.employeeMap,
                                                                                this.employeeAvgWorktimeMap,
                                                                                this.$helpers);

                console.log('Generating saldo report');

                var date = new Date();


                let rangeFrom = null;
                let rangeTo = null;


                let ts = ( date.getFullYear().toString() + this.$helpers.pad2(date.getMonth() + 1) + this.$helpers.pad2( date.getDate()) + this.$helpers.pad2( date.getHours() ) + this.$helpers.pad2( date.getMinutes() ) + this.$helpers.pad2( date.getSeconds() ) );

                let view = this;
                let headers = [this.$t('pages.employeeData.name'), this.$t('pages.employeeCoreData.personnelNumber'), this.$t('roster.comp.week'), 'Wochen\nSoll\nArbeitszeit', 'Wochen\nIst\nArbeitszeit', 'Wochen\nArbeitszeit\nSaldo'];
                let headersCsv = [this.$t('pages.employeeData.name'), this.$t('pages.employeeCoreData.personnelNumber'), this.$t('roster.comp.week'), 'Wochen Soll-Arbeitszeit', 'Wochen Ist-Arbeitszeit', 'Wochen Arbeitszeit-Saldo'];
                if(detailedSplit){
                    headers = headers.concat(['Arbeitszeit\nStempelzeiten', 'Arbeitszeit\nPlan', 'Arbeitszeit\nAbwesenheiten'])
                    headersCsv = headersCsv.concat(['Arbeitszeit Stempelzeiten', 'Arbeitszeit Plan', 'Arbeitszeit Abwesenheiten'])
                }
                if(includeMonthly){
                    headers = headers.concat(['Soll\nArbeitszeit\n'+this.startOfMonth.format("MMMM"),
                                              'Ist\nArbeitszeit\n'+this.startOfMonth.format("MMMM"),
                                              'Arbeitszeit\nSaldo\n'+this.startOfMonth.format("MMMM")])
                    headersCsv = headersCsv.concat(['Soll-Arbeitszeit '+this.startOfMonth.format("MMMM"),
                                                    'Ist-Arbeitszeit '+this.startOfMonth.format("MMMM"),
                                                    'Arbeitszeit-Saldo '+this.startOfMonth.format("MMMM")])
                }
                let reportDateStr = (this.$helpers.getMomentTZ().month(this.rosterFromTo.month).year(this.rosterFromTo.year).format('MMMM YYYY'));
                let filename = 'Wochenstunden ' + this.storeSettings.name + ' ' + reportDateStr + ' (Stand ' + this.$helpers.getMomentTZ().format('DD.MM.YYYY') + ')';
                var body = [];




                let csvPre = "data:text/csv;charset=utf-8,";
                let csv = "";
                csv += headersCsv.join(";");
                csv += "\n";


                var repDoc = this.$helpers.tableReportDoc(
                    headers,
                    'Wochenstunden ' + reportDateStr,
                    this.storeSettings.name + ' ('+this.storeSettings.description+')',
                    '',
                    this.userFullname,
                    12);
                var doc = repDoc.doc;
                var contentOffsetY = repDoc.contentOffsetY;
                doc.setFontSize(12);


                let reportEmployees = [];
                Object.values(view.employeeMap).forEach(i => {
                    reportEmployees.push(i.id);

                });
                Object.values(this.employeeMap).sort((a, b) => {
                    let aLN = a.lastName ? a.lastName : "";
                    let bLN = b.lastName ? b.lastName : "";
                    let c = aLN.toLowerCase().localeCompare(bLN.toLowerCase());
                    if(c != 0){
                        return c;
                    } else {
                        let aFN = a.firstName ? a.firstName : "";
                        let bFN = b.firstName ? b.firstName : "";
                        return aFN.toLowerCase().localeCompare(bFN.toLowerCase());
                    }
                }).forEach((e) => {

                    if(reportEmployees.includes(e.id)){
                        let contracts = this.employeeIdContractMap[e.id];


                        let weekValues = weekWorkTimeMap[e.id] ? Object.values(weekWorkTimeMap[e.id]) : [];
                        let addName = true;
                        let cumulatedMonthWorkTimeRegular = 0 - (this.employeePlannedActual[e.id].deltaWorkTime /(60.0*1000));
                        for(let i = 0; i< weekItems.length; i++){
                            let week = weekItems[i];
                            let weekValue = weekValues.find(i => i.weekId == week.isoWeek);
                            let weekFrom = week.weekFrom;
                            let weekTo = week.weekTo;

                            let monthFrom = week.monthFrom;
                            let monthTo = week.monthTo;

                            let cumulatedMonthWorkTime = this.$rosterhelper.getTimeFrameWorkTime(e, monthFrom, monthTo,
                                                                                this.employeeDateCombinedShiftMap,
                                                                                this.employeePreferenceAvailabilityMap,
                                                                                this.planShiftMomentMap,
                                                                                this.actualShiftMomentMap,
                                                                                this.actualBreakShiftIdMap,
                                                                                this.actualBreakMomentMap,
                                                                                this.employeePreferenceMomentMap,
                                                                                this.employeeIdContractMap,
                                                                                this.employeeContractMomentMap,
                                                                                this.storeSettings,
                                                                                this.employeeMap);

                            let holidays = Object.values(this.holidayMap).filter(h => h.federalHoliday && h.active).map(h => view.holidayMomentMap[h.id].fromDate);
                            let includingContractHolidays = Object.values(this.holidayMap).filter(h => h.active && (h.federalHoliday || h.contractHoliday )).map(h => view.holidayMomentMap[h.id].fromDate);
                            let cWorkTimeData = view.$rosterhelper.GetWorktimeData(this.startOfMonth, weekFrom, weekTo, contracts, this.allowedContractMap, this.storeSettings, this.storeSettings.workTimeMode, null, this.storeSettings.exitFactoring, this.$helpers, false, holidays, includingContractHolidays)

                            let workTimeRegular = cWorkTimeData.workTime

                            cumulatedMonthWorkTimeRegular += workTimeRegular

                            let weekWorkTimeRegular = view.$rosterhelper.getWeekWorkValueRegular(e.id, view.employeeIdContractMap, view.employeeContractMomentMap, weekFrom, weekTo)
                            let line = null;
                            if(weeks.includes(week)){
                                if(weekValue && weekValue.combinedWorkTime > 0){
                                    line = [
                                        addName ? e.lastName + ' ' + e.firstName : '',
                                        addName ? (e.personnelId ? e.personnelId : '-') : '',
                                        weekFrom.format("DD.MM.YYYY")+" - \n"+weekTo.clone().add(-1,'days').format('DD.MM.YYYY'),
                                        (weekWorkTimeRegular/60.0).toFixed(2),
                                        (weekValue.combinedWorkTime/3600.0).toFixed(2),
                                        (((weekValue.combinedWorkTime/60.0) - weekWorkTimeRegular)/60.0).toFixed(2)
                                    ]
                                    if(detailedSplit){
                                        line = line.concat([
                                            (weekValue.actualShiftWorkTime/3600.0).toFixed(2),
                                            (weekValue.planShiftWorkTime/3600.0).toFixed(2),
                                            (weekValue.preferenceWorkTime/3600.0).toFixed(2)]);
                                    }
                                    if(includeMonthly){
                                        line = line.concat([
                                            (cumulatedMonthWorkTimeRegular/60.0).toFixed(2),
                                            (cumulatedMonthWorkTime/60.0).toFixed(2),
                                            ((cumulatedMonthWorkTime - cumulatedMonthWorkTimeRegular)/60.0).toFixed(2),
                                        ])
                                    }
                                } else if(includeAll){
                                    line = [
                                        addName ? e.lastName + ' ' + e.firstName : '',
                                        addName ? (e.personnelId ? e.personnelId : '-') : '',
                                        weekFrom.format("DD.MM.YYYY")+" - \n"+weekTo.clone().add(-1,'days').format('DD.MM.YYYY'),
                                        (weekWorkTimeRegular/60.0).toFixed(2),
                                        (0).toFixed(2),
                                        ((0 - weekWorkTimeRegular)/60.0).toFixed(2)
                                    ]
                                    if(detailedSplit){
                                        line = line.concat([
                                            (0).toFixed(2),
                                            (0).toFixed(2),
                                            (0).toFixed(2),]);
                                    }
                                    if(includeMonthly){
                                        line = line.concat([
                                            (cumulatedMonthWorkTimeRegular/60.0).toFixed(2),
                                            (cumulatedMonthWorkTime/60.0).toFixed(2),
                                            ((cumulatedMonthWorkTime - cumulatedMonthWorkTimeRegular)/60.0).toFixed(2),

                                        ])
                                    }
                                }
                                if(line != null){
                                    addName = false;
                                    body.push(line);

                                    csv += line.join(";");
                                    csv += "\n";
                                }
                            }


                        }


                    }
                });

                doc.autoTable({
                    startY: contentOffsetY,
                    head: [headers],
                    body: body,
                    headStyles: {
                        fillColor: [109,141,33],
                        fontSize: 7
                    },
                    bodyStyles: {
                        fontSize: 7
                    },
                    columnStyles: {

                    }
                })
                if(exportCSV){
                    let s = csv.split(".");
                    csv = s.join(",");
                    let encodedUri = encodeURI(csvPre) + "\uFEFF" + encodeURIComponent(csv);
                    var link = document.createElement("a");
                    link.setAttribute("href", encodedUri);
                    link.setAttribute("download", filename + ' - ' + ts + '.csv');

                    document.body.appendChild(link); // Required for FF
                    link.click();
                }else{

                    doc.setProperties({
                        title: "Wochenstunden Report"
                    });
                    view.$helpers.previewPdf(doc, filename+ '.pdf');


                }

            },
            OpenDayCrewLaborReportPopup(){
                let view = this;

                let dataEntries = [];

                let from = this.$helpers.getMomentTZ().year(this.$store.state.rosterFromTo.year).month(this.$store.state.rosterFromTo.month).startOf('month');
                let to = from.clone().add(1, 'month');


                let now = this.$helpers.getMomentTZ().startOf('day');
                if(now < to){
                    to = now;
                }
                let temp = from.clone();
                let dates = [];

                while(temp <= to){
                    dates.push(temp.clone());
                    temp.add(1, 'days');
                }

                let dateItems = dates.map(d => {
                            return {
                                label: d.format("DD.MM.YYYY"),
                                value: d,
                                selected: d.unix() == now.unix()
                            }
                        });
                dataEntries.push({label: this.$tc('global.general.day'), key: 'date', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: this.$t('roster.view.pleaseSelectDay'),
                        items: dateItems,
                        selectedItem: dateItems.find(i => i.selected),
                        selectedItems: dateItems.filter(i => i.selected),
                        selectFirst: false,
                    }
                });

                let fromHourItems = [
                    {label: "00:00", value: 0, selected: true},
                    {label: "01:00", value: 1, selected: false},
                    {label: "02:00", value: 2, selected: false},
                    {label: "03:00", value: 3, selected: false},
                    {label: "04:00", value: 4, selected: false},
                    {label: "05:00", value: 5, selected: false},
                    {label: "06:00", value: 6, selected: false},
                    {label: "07:00", value: 7, selected: false},
                    {label: "08:00", value: 8, selected: false},
                    {label: "09:00", value: 9, selected: false},
                    {label: "10:00", value: 10, selected: false},
                    {label: "11:00", value: 11, selected: false},
                    {label: "12:00", value: 12, selected: false},
                    {label: "13:00", value: 13, selected: false},
                    {label: "14:00", value: 14, selected: false},
                    {label: "15:00", value: 15, selected: false},
                    {label: "16:00", value: 16, selected: false},
                    {label: "17:00", value: 17, selected: false},
                    {label: "18:00", value: 18, selected: false},
                    {label: "19:00", value: 19, selected: false},
                    {label: "20:00", value: 20, selected: false},
                    {label: "21:00", value: 21, selected: false},
                    {label: "22:00", value: 22, selected: false},
                    {label: "23:00", value: 23, selected: false}
                ];
                dataEntries.push({label: this.$t('roster.view.fromHour'), key: 'fromHour', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: this.$t('roster.view.pleaseSelectHour'),
                        items: fromHourItems,
                        selectedItem: fromHourItems.find(i => i.selected),
                        selectedItems: fromHourItems.filter(i => i.selected),
                        selectFirst: false,
                    }
                });

                let toHourItems = [
                    {label: "00:00", value: 0, selected: true},
                    {label: "01:00", value: 1, selected: false},
                    {label: "02:00", value: 2, selected: false},
                    {label: "03:00", value: 3, selected: false},
                    {label: "04:00", value: 4, selected: false},
                    {label: "05:00", value: 5, selected: false},
                    {label: "06:00", value: 6, selected: false},
                    {label: "07:00", value: 7, selected: false},
                    {label: "08:00", value: 8, selected: false},
                    {label: "09:00", value: 9, selected: false},
                    {label: "10:00", value: 10, selected: false},
                    {label: "11:00", value: 11, selected: false},
                    {label: "12:00", value: 12, selected: false},
                    {label: "13:00", value: 13, selected: false},
                    {label: "14:00", value: 14, selected: false},
                    {label: "15:00", value: 15, selected: false},
                    {label: "16:00", value: 16, selected: false},
                    {label: "17:00", value: 17, selected: false},
                    {label: "18:00", value: 18, selected: false},
                    {label: "19:00", value: 19, selected: false},
                    {label: "20:00", value: 20, selected: false},
                    {label: "21:00", value: 21, selected: false},
                    {label: "22:00", value: 22, selected: false},
                    {label: "23:00", value: 23, selected: false}
                ];
                dataEntries.push({label: this.$t('roster.view.untilHour'), key: 'toHour', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: this.$t('roster.view.pleaseSelectHour'),
                        items: toHourItems,
                        selectedItem: toHourItems.find(i => i.selected),
                        selectedItems: toHourItems.filter(i => i.selected),
                        selectFirst: false,
                    }
                });

                let employeeLevelItems = [{label: this.$t('workBalance.payroll.crew'), value: 1, selected: true}, {label: 'Management', value: 2, selected: false}];
                dataEntries.push({label: this.$tc('store.structure.employeeLevel'), key: 'employeeLevel', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: '',
                        items: employeeLevelItems,
                        selectedItem: employeeLevelItems.find(i => i.selected),
                        selectedItems: employeeLevelItems.filter(i => i.selected),
                        selectFirst: true,
                    }
                });
                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                         errorCheck: [
                            (entries) => {
                                if(entries['date'] == null){
                                    return {key: 'date', type: 'error', label: this.$tc('global.general.day'), text: this.$t('roster.view.pleaseSelectDay')}
                                } else {
                                    return null
                                }
                            },
                            (entries) => {
                                if(entries['fromHour'] == null){
                                    return {key: 'fromHour', type: 'error', label: this.$t('roster.view.fromHour'), text: this.$t('roster.view.pleaseSelectHour')}
                                } else {
                                    return null
                                }
                            },
                            (entries) => {
                                if(entries['toHour'] == null){
                                    return {key: 'toHour', type: 'error', label: this.$t('roster.view.untilHour'), text: this.$t('roster.view.Bitte wählen Sie eine Stunde aus')}
                                } else {
                                    return null
                                }
                            },


                        ],
                        selectCallback: function (data) {
                            let from = data.date;

                            let config = view.crewLaborConfig;
                            let importPromise = new Promise((resolve, reject) => {
                                if(from.unix() == view.$helpers.getMomentTZ().startOf('day').unix()){
                                    view.$helpers.DoSotecLiveDataImport()
                                    .then(() => {

                                        resolve(true)
                                    })
                                    .catch(error => {
                                        resolve(false);
                                    })
                                } else {
                                    resolve(false);
                                }

                            });

                            importPromise
                            .then((res) => {
                                if(res){
                                    view.loading = true;
                                    view.RefreshPlanningIndicator()
                                    .then(() => {
                                        view.loading = false;
                                        view.RefreshVeryImportantData();
                                    }).catch(error => {
                                        console.log(error);
                                        view.loading = false;
                                    });
                                }
                                return view.$helpers.GetStatisticsSetting();
                            })
                            .then((c) => {

                                config = c;
                                let resultdata = [];

                                let type = Object.values(view.planningIndicatorTypeMap).find(t => t.isDefault)
                                let typeId = type ? type.id : null;

                                let dataFrom = from.clone().hour(data.fromHour);
                                let dataTo = from.clone().hour(data.toHour);
                                if(data.toHour <= data.fromHour){
                                    dataTo = dataTo.add(1, 'days');
                                }


                                let spotIds = Object.values(view.spotMap).filter(s => s.employeeLevel == data.employeeLevel).map(s => s.id);


                                view.$helpers.loadHourStatisticsFully(dataFrom, dataTo, spotIds, data.employeeLevel == 1, typeId, [data.employeeLevel], resultdata)
                                .then((rdata) => {
                                    resultdata = rdata;
                                    view.generateDayCrewLaborReport(dataFrom, dataTo, resultdata, data.employeeLevel, type, config)
                                })
                            }).catch(error => {

                                console.log(error)
                                view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.view.createReportError'));
                            })

                        }
                    },
                    header: this.$t('roster.view.crewLaborHours'),
                    width: "700px",
                    expanded: true,
                    centered: true
                });



            },
            generateDayCrewLaborReport(from, to, crewData, employeeLevel, type, config){
                let now = this.$helpers.getMomentTZ().startOf('hour');
                if(now < to){
                    to = now;
                }
                let headers = [this.$t('store.settings.date'), type.name, "Produktive\r\nArbeitszeit", "Unproduktive\r\nArbeitszeit", this.$t('indicator.crew.crewLabor'), this.$t('indicator.crew.crewLabor') + "%"]
                let reportDateStr = from.format('DD.MM.YYYY');
                let filename = 'Crew Labor ' + +(employeeLevel == 1 ? 'Crew - ' : 'Management - ')+this.storeSettings.name + ' ' + reportDateStr + ' (Stand ' + this.$helpers.getMomentTZ().format('DD.MM.YYYY') + ')';
                var body = [];


                var repDoc = this.$helpers.tableReportDoc(
                    headers,
                    'Crew Labor ' + reportDateStr+" - "+(employeeLevel == 1 ? 'Crew' : 'Management'),
                    this.storeSettings.name + ' ('+this.storeSettings.description+')',
                    '',
                    this.userFullname,
                    12);
                var doc = repDoc.doc;
                var contentOffsetY = repDoc.contentOffsetY;
                doc.setFontSize(12);
                let crewMap = {}
                crewData.forEach(d => {
                    let date = this.$helpers.getMomentFromStringTZ(d.from);
                    let key = date.format('DD.MM.YYYY HH:mm');
                    if(!crewMap[key]){
                        crewMap[key] = d
                    }
                })

                let iter = from.clone();
                let indicatorSum = 0;
                let workTimeSum = 0;
                let workValueSum = 0;
                let unprodWorkTimeSum = 0;
                let unprodWorkValueSum = 0;
                let clSum = 0;

                while(iter < to){
                    let key = iter.format('DD.MM.YYYY HH:mm');
                    let item = crewMap[key];
                    let line = [];
                    if(item){
                        let indValue = item ? item.actualIndicatorValue : 0;
                        let workTime = this.$helpers.calculateCLWorkTimeSum(item, config);
                        let workValue = this.$helpers.calculateCLWorkValueSum(item, config);
                        let unprodWorkTime = this.$helpers.calculateCLUnproductiveWorkTimeSum(item, config);
                        let unprodWorkValue = this.$helpers.calculateCLUnproductiveWorkValueSum(item, config);
                        let cl = this.$helpers.calculateCLCrewLaborSum(item, config);
                        let clPercentage = indValue > 0 ? ((cl/100.0)/indValue* 100) : null;

                        indicatorSum += indValue;
                        workTimeSum += workTime;
                        workValueSum += workValue;
                        unprodWorkTimeSum += unprodWorkTime;
                        unprodWorkValueSum += unprodWorkValue;
                        clSum += cl;

                        line = [key, indValue.toFixed(2), (workTime/3600.0).toFixed(2), (unprodWorkTime/3600.0).toFixed(2), (cl/100.0).toFixed(2), clPercentage ? clPercentage.toFixed(2)+'%' : '-'];
                    } else {
                        line = [key, '-', '-', '-', '-', '-']
                    }

                    body.push(line);
                    iter = iter.add(1, 'hour');
                }
                let sumCLPercentage = indicatorSum > 0 ? ((clSum/100.0)/indicatorSum * 100) : null;
                let sumLine = [this.$t('global.ui.sum'), indicatorSum.toFixed(2), (workTimeSum/3600.0).toFixed(2), (unprodWorkTimeSum/3600.0).toFixed(2), (clSum/100.0).toFixed(2), sumCLPercentage ? sumCLPercentage.toFixed(2)+'%' : '-'];
                body.push(sumLine);

                doc.autoTable({
                    startY: contentOffsetY,
                    head: [headers],
                    body: body,
                    headStyles: {
                        fillColor: [109,141,33],
                        fontSize: 7
                    },
                    bodyStyles: {
                        fontSize: 7
                    },
                    columnStyles: {

                    }
                })

                doc.setProperties({
                    title: "Crew Labor Report"
                });
                this.$helpers.previewPdf(doc, filename+ '.pdf');
            },

            OpenKPIExportPopup(){
                let view = this;




                let employeeLevelItems = [
                    {label: this.$t('workBalance.payroll.crew'), value: 1, selected: true},
                    {label: this.$t('shift.template.management'), value: 2},
                ]

                let exportTypeItems = [
                    {label: "Soll Daten", value: 1, selected: true},
                    {label: "Ist Daten", value: 2, selected: true},
                ]
                let pallas = [136, 137].includes(view.storeSettings.companyId);
                let planningIndicatorTypes = []
                Object.values(this.planningIndicatorTypeMap).forEach(type => {
                    planningIndicatorTypes.push({label: type.name, value: type.id, selected: type.isDefault || (pallas && (type.name == 'OEPE' || type.name == 'R2P'))})
                })
                let meoTypes = []
                Object.values(this.planningIndicatorTypeMap).forEach(type => {
                    meoTypes.push({label: type.name, value: type.id, selected: type.isDefault})
                })
                let selectedMeoType = meoTypes.find(i => i.selected)


                let dataEntries = [];



                let from = this.$helpers.getMomentTZ().year(this.$store.state.rosterFromTo.year).month(this.$store.state.rosterFromTo.month).startOf('month');
                let to = from.clone().add(1, 'month');
                let temp = from.clone();
                let dates = [];



                while(temp <= to){
                    dates.push(temp.clone());
                    temp.add(1, 'days');
                }
                dataEntries.push({label: this.$tc('global.general.day'), key: 'date', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: this.$t('global.general.from'),
                        items: dates.map(d => {
                            return {
                                label: d.format("DD.MM.YYYY"),
                                value: d,
                                selected: d.unix() == from.unix()
                            }
                        }),
                        selectFirst: true,
                    }
                });








                dataEntries.push({label: this.$tc('store.structure.employeeLevel'), key: 'employeeLevels', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        placeholder: this.$t('shift.template.selectEmployeeLevel'),
                        items: employeeLevelItems
                    }

                });

                dataEntries.push({label: this.$t('roster.view.keyFigures'), key: 'planningIndicatorTypes', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        placeholder: 'Kennzahlen wählen',
                        items: planningIndicatorTypes
                    }

                });



                dataEntries.push({label: "Daten Typ", key: 'exportTypes', type: 'dropdownsearch', hidden: false,
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        placeholder: 'Daten Typ wählen',
                        items: exportTypeItems
                    }

                });

                dataEntries.push({label: this.$t('shift.template.workTime'), key: 'includeWorkTime', type: 'bool', value: true, disabled: pallas});
                dataEntries.push({label: this.$t('global.general.employeeCount'), key: 'includeEmployeeCount', type: 'bool', value: false});

                let enableVlh = this.storeSettings.enableVlh;
                let enableMeo = this.storeSettings.enableMeo;

                dataEntries.push({label: 'MEO Vorgabe', hidden: !enableMeo, key: 'includeMEO', type: 'bool', value: enableMeo});
                dataEntries.push({label: 'VLH Vorgabe', hidden: !enableVlh, key: 'includeVLH', type: 'bool', value: enableVlh && !enableMeo,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let includeMeo = datafill.entries.find(i => i.key == 'includeMEO').value;

                        if (includeMeo ){
                            entryBeforeUpdate.value = false;
                        }
                        return entryBeforeUpdate;
                    }
                });
                dataEntries.push({label: 'Nur Vorgabe Positionen', hidden: !enableMeo && !enableVlh, key: 'onlyMEOSpots', type: 'bool', value: false});
                dataEntries.push({label: "Kennzahl für Vorgabe", hidden: !enableMeo && !enableVlh, key: 'meoType', type: 'dropdownsearch',
                    dropdownSearchState: {
                        selectMultiple: false, styleLight: true,
                        placeholder: 'Kennzahl wählen',
                        items: meoTypes,
                        selectedItem: selectedMeoType
                    },
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let includeMeo = datafill.entries.find(i => i.key == 'includeMEO').value;
                        let includeVlh = datafill.entries.find(i => i.key == 'includeVLH').value;
                        if (!includeMeo && !includeVlh){
                            entryBeforeUpdate.hidden = true;
                        } else {
                            entryBeforeUpdate.hidden = false;
                        }

                        return entryBeforeUpdate;
                    }

                });
                dataEntries.push({label: this.$t('roster.view.productivity'), key: 'includeProductivity', type: 'bool', value: true});
                dataEntries.push({label: 'Arbeitszeit Kosten Betrag', key: 'includeCrewLaborSum', type: 'bool', value: false});
                dataEntries.push({label: 'Arbeitszeit Kosten %', key: 'includeCrewLaborPercentage', type: 'bool', value: true});

                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,

                        selectCallback: function (data) {

                            let checkDate =  data.date.clone().startOf('day');
                            view.loading=true;
                            let importPromise = new Promise((resolve, reject) => {
                                if(checkDate.unix() == view.$helpers.getMomentTZ().startOf('day').unix()){
                                    view.$helpers.DoSotecLiveDataImport()
                                    .then(() => {
                                        resolve(true)
                                    })
                                    .catch(error => {
                                        resolve(false);
                                    })
                                } else {
                                    resolve(false);
                                }

                            });

                            importPromise.then(res => {
                                if(res){

                                    view.RefreshPlanningIndicator()
                                    .then(() => {

                                        view.RefreshVeryImportantData();
                                    }).catch(error => {
                                        console.log(error);

                                    });
                                }
                                let meoType = data.meoType;
                                let plannedET = [];
                                let actualET = [];

                                let meoSpots = new Set();

                                let p1;
                                let p2;
                                let p3;
                                if(meoType && (data.includeMEO || data.includeVLH)){
                                    let from =  data.date.clone().startOf('day');
                                    let to = data.date.clone().startOf('day').add(1,'days');

                                    p1 = new Promise((resolve, reject) => {
                                        let p;
                                        if(data.includeVLH){
                                            p = view.$helpers.GetVlhThresholdCurve(from, to, meoType, true, 'hourly')
                                        } else {
                                            p = view.$helpers.GetPlanningEmployeeThresholdCurve(from, to, meoType, true, 'hourly')
                                        }
                                        p.then(response => {
                                            resolve(response.data);
                                        }).catch(error => {
                                            console.log(error);
                                            resolve([]);
                                        })

                                    })
                                    p2 = new Promise((resolve, reject) => {
                                        let p;
                                        if(data.includeVLH){
                                            p = view.$helpers.GetVlhThresholdCurve(from, to, meoType, false, 'hourly')
                                        } else {
                                            p = view.$helpers.GetPlanningEmployeeThresholdCurve(from, to, meoType, false, 'hourly')
                                        }
                                        p.then(response => {
                                            resolve(response.data);
                                        }).catch(error => {
                                            console.log(error);
                                            resolve([]);
                                        })
                                    })
                                    p3 = new Promise((resolve, reject) => {
                                        let p;
                                        if(data.includeVLH){
                                            p = view.$helpers.GetVlhEmployeeThresholdMap()
                                        } else {
                                            p = view.$helpers.GetPlanningEmployeeThresholdMap()
                                        }
                                        p.then(map => {
                                            Object.values(map).forEach(et => {
                                                if(et.typeId == meoType){
                                                    meoSpots.add(et.spotId);
                                                }

                                            });

                                            resolve(meoSpots);
                                        }).catch(error => {
                                            console.log(error);
                                            resolve(meoSpots);
                                        })
                                    })
                                } else {
                                    p1 = new Promise((resolve, reject) => {
                                        resolve([]);

                                    })
                                    p2 = new Promise((resolve, reject) => {
                                    resolve([]);
                                    })
                                    p3 = new Promise((resolve, reject) => {
                                        Object.values(view.spotMap).forEach(s => {
                                            meoSpots.add(s.id);
                                        })
                                    resolve(meoSpots);
                                    })
                                }





                                p1.then(result => {
                                    plannedET = result;
                                    return p2;
                                }).then(result => {
                                    actualET = result;
                                    return p3;
                                }).then(result => {
                                    meoSpots = result;

                                    return view.loadPlanningIndicatorGroupedByHour(data.date);
                                }).then(response => {
                                    view.loading=false;
                                    let includeStats = {
                                        workTime: data.includeWorkTime,
                                        employeeCount: data.includeEmployeeCount,
                                        meo: data.includeMEO,
                                        productivity: data.includeProductivity,
                                        crewLaborSum: data.includeCrewLaborSum,
                                        crewLaborPercentage: data.includeCrewLaborPercentage,
                                        meoType: meoType,
                                        onlyMEOSpots: data.onlyMEOSpots,
                                        meoSpots: meoSpots,
                                        vlh: data.includeVLH
                                    }


                                    //console.log("planningIndicatorTypeMap", view.planningIndicatorTypeMap);
                                    //console.log("meoType", includeStats.meoType);
                                    view.generateKPIReport(data.date, response.data, data.planningIndicatorTypes, data.employeeLevels, data.exportTypes, plannedET, actualET, includeStats)
                                }).catch(error => {
                                    view.loading=false;
                                    console.log(error)
                                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                                })
                            })

                        }
                    },
                    header: 'KPI PDF Export',
                    width: "700px",
                    expanded: true,
                    centered: true
                });
            },
            generateKPIReport(date, planningindicators, piTypes, employeeLevels, exportTypes, plannedET, actualET, includeStats){
                let view = this;
                let from = date.clone();
                let to = from.clone().add(1, 'days')
                let planShifts = Object.values(this.planShiftMap).filter(s => s.employeeId != null && view.employeeMap[s.employeeId] && view.planShiftMomentMap[s.id].fromDate < to && view.planShiftMomentMap[s.id].toDate > from);
                let actualShifts = Object.values(this.actualShiftMap).filter(s => s.employeeId != null && view.employeeMap[s.employeeId] && view.actualShiftMomentMap[s.id].fromDate < to && view.actualShiftMomentMap[s.id].toDate > from);


                let tsd = new Date();
                let ts = ( tsd.getFullYear().toString() + this.$helpers.pad2(tsd.getMonth() + 1) + this.$helpers.pad2( tsd.getDate()) + '-' + this.$helpers.pad2( tsd.getHours() ) + this.$helpers.pad2( tsd.getMinutes() ) + this.$helpers.pad2( tsd.getSeconds() ) );


                let filename = 'Kennzahlen Report ' + this.storeSettings.name + '_' + date.format('DD.MM.YYYY') + '_'+ts;
                let headers = [this.$t('store.settings.date')]
                let firstIndicators = [];
                let otherIndicators = [];
                piTypes.forEach(t => {
                    if(includeStats.meo && view.planningIndicatorTypeMap[t].id == includeStats.meoType){
                        headers.push(view.planningIndicatorTypeMap[t].name);
                        firstIndicators.push(t);
                    } else if(!includeStats.meo && view.planningIndicatorTypeMap[t].isDefault){
                        headers.push(view.planningIndicatorTypeMap[t].name);
                        firstIndicators.push(t);
                    }else {
                        otherIndicators.push(t);
                    }

                })
                let meoOrVlh = includeStats.meo || includeStats.vlh;
                if(includeStats.workTime){
                    headers.push(this.$t('shift.template.workTime'));
                }
                if(includeStats.employeeCount){
                    headers.push("Mitarbeiter");
                }
                if(meoOrVlh){
                    if(includeStats.vlh){
                        headers.push(this.$t('shift.main.vlh'));
                    } else {
                        headers.push(this.$t('shift.main.meo'));
                    }

                }
                if(meoOrVlh && includeStats.workTime){
                    if(includeStats.vlh){
                        headers.push("Diff. VLH");
                    } else {
                        headers.push("Diff. MEO");
                    }
                }
                otherIndicators.forEach(t => {
                    headers.push(view.planningIndicatorTypeMap[t].name);


                })
                if(includeStats.productivity){
                    headers.push(this.$t('roster.view.productivity'));
                }
                if(includeStats.crewLaborSum){
                    headers.push(this.$t('indicator.eval.workTimeCosts'));
                }
                if(includeStats.crewLaborPercentage){
                    headers.push("Arbeitszeit Kosten %");
                }





                let repDoc = this.$helpers.tableReportDoc(
                    headers,
                    'Kennzahlen ' + date.format('DD.MM.YYYY'),
                    this.storeSettings.name + ' ('+this.storeSettings.description+')',
                    '',
                    this.userFullname,
                    12);
                let doc = repDoc.doc;
                let contentOffsetY = repDoc.contentOffsetY;
                doc.setFontSize(12);




                let planBody = [];
                if(exportTypes.includes(1)){
                    let headers = [this.$t('store.settings.date')]
                    firstIndicators.forEach(t => {
                        headers.push(view.planningIndicatorTypeMap[t].name+"\n(Soll)")
                    })

                    if(includeStats.workTime){
                        headers.push("Arbeitszeit\n(Soll)");
                    }
                    if(includeStats.employeeCount){
                        headers.push("Mitarbeiter\n(Soll)");
                    }
                    if(meoOrVlh){
                        if(includeStats.vlh){
                            headers.push("VLH\n(Soll)");
                        } else {
                            headers.push("MEO\n(Soll)");
                        }

                    }
                    if(meoOrVlh && includeStats.workTime){
                        if(includeStats.vlh){
                            headers.push("Diff. VLH\n(Soll)");
                        } else {
                            headers.push("Diff. MEO\n(Soll)");
                        }

                    }
                    otherIndicators.forEach(t => {
                        headers.push(view.planningIndicatorTypeMap[t].name+"\n(Soll)")
                    })
                    if(includeStats.productivity){
                        headers.push("Produktivität\n(Soll)");
                    }
                    if(includeStats.crewLaborSum){
                        headers.push("Arbeitszeit Kosten\n(Soll)");
                    }
                    if(includeStats.crewLaborPercentage){
                        headers.push("Arbeitszeit Kosten %\n(Soll)");
                    }


                    let d = from.clone();

                    let sumLine =[this.$t('global.ui.sum')]
                    let sums =  {}
                    let counts = {}
                    let isDefaultIncome = false;
                    let sumDefaultIV = 0;
                    while (d < to){
                        let checkTo = d.clone().add(60, 'minutes');
                        let line = [d.format('DD.MM.YYYY HH:mm')];

                        let defaultIV = 0;

                        firstIndicators.forEach(t => {
                             let type = view.planningIndicatorTypeMap[t]
                            if(!sums[t+'-soll']){
                                sums[t+'-soll'] = 0;
                            }
                            if(!counts [t+'-soll']){
                                counts [t+'-soll'] = 0;
                            }
                            let iv = 0;

                            planningindicators.forEach(pi => {
                                if(pi.planned && pi.typeId == t){
                                    let iFrom = view.$helpers.getMomentFromStringTZ(pi.date);
                                    if(iFrom >= d && iFrom < checkTo){
                                        let v = pi.sumAmount / Math.pow(10, type.fractional);
                                        iv += v
                                        if(v > 0){
                                            counts [t+'-soll']+=1;
                                        }
                                    }
                                }
                             })
                            sums[t+'-soll']+=iv;

                            if(type.isDefault){
                                defaultIV += iv;
                                sumDefaultIV += iv;
                                if(type.category == 1 || type.category == 2){
                                    isDefaultIncome = true;
                                }
                            }
                            line.push((iv).toFixed(2));
                        })
                        if(!sums.planWorkTime){
                            sums.planWorkTime = 0
                        }
                        if(!sums.planEmployeeTime){
                            sums.planEmployeeTime = 0
                        }
                        if(!sums.productivePlanWorkTime){
                            sums.productivePlanWorkTime = 0
                        }
                        if(!sums.planCl){
                            sums.planCl = 0
                        }
                        let wt = 0;
                        let pwt = 0;
                        let et = 0;
                        let cl = 0;
                        planShifts.forEach(s => {
                                let sFrom = view.planShiftMomentMap[s.id].fromDate
                                let sTo = view.planShiftMomentMap[s.id].toDate
                                let employeeLevel = 1;
                                let productive = true;

                                let spotId = s.spotId

                                if(view.employeeMap[s.employeeId].spotId != null){
                                    employeeLevel = view.spotMap[view.employeeMap[s.employeeId].spotId].employeeLevel;
                                    productive = view.spotMap[view.employeeMap[s.employeeId].spotId].productive
                                }
                                if(sFrom < checkTo && sTo > d && employeeLevels.includes(employeeLevel) && (!includeStats.onlyMEOSpots || includeStats.meoSpots.has(spotId))){
                                    let cFrom = d > sFrom ? d : sFrom;
                                    let cTo = checkTo < sTo ? checkTo: sTo;
                                    let wv = cTo.diff(cFrom, 'minutes');
                                    et += wv;
                                    if(s.breakValue > 0){
                                        if(s.breakFrom == null){


                                            wv -= s.breakValue * (cTo.diff(cFrom)/sTo.diff(sFrom))
                                        } else {

                                            let breakFrom = view.$helpers.getMomentFromStringTZ(s.breakFrom)
                                            let breakTo = breakFrom.clone().add(s.breakValue, 'minutes');
                                            if(breakFrom < checkTo && breakTo > d){
                                                breakFrom = d > breakFrom ? d : breakFrom;
                                                breakTo = checkTo < breakTo ? checkTo : breakTo;
                                                wv -= Math.max(0, breakTo.diff(breakFrom, 'minutes'));
                                            }
                                        }
                                    }
                                    wt += wv;
                                    if(productive){
                                        pwt+=wv;
                                    }
                                    if(view.employeeIdContractMap[s.employeeId]){
                                        let c = view.employeeIdContractMap[s.employeeId].find(con => {
                                            let conFrom = view.employeeContractMomentMap[con.id].fromDate;
                                            let conTo = view.employeeContractMomentMap[con.id].toDate;
                                            if(conFrom < cTo && (conTo == null || conTo > cFrom)){
                                                return true;
                                            } else {
                                                return false;
                                            }
                                        });
                                        let hWage = 0;
                                        if(c != null){
                                            if(c.paymentType == 2 && c.wageType == 1){
                                                hWage = (c.payment + c.extraPayment);
                                            } else if(c.paymentType == 2 && c.wageType == 2){
                                                hWage = (c.payment + c.extraPayment)/((c.weekTimeRegular/60.0)/c.workDaysRegular);
                                            } else if(c.paymentType == 2 && c.wageType == 3){
                                                hWage = (c.payment + c.extraPayment)/(c.weekTimeRegular/60.0);
                                            } else {
                                                let factor = (c.collectiveContractId != null && view.allowedContractMap[c.collectiveContractId]) ? view.allowedContractMap[c.collectiveContractId].workTimeFactor : view.storeSettings.workTimeFactor;
                                                hWage = (c.payment + c.extraPayment)/((c.weekTimeRegular/60.0)*(factor/Math.pow(10,7)))
                                            }
                                        }

                                        cl += ((wv/60.0) * hWage);
                                    }


                                }
                        })
                        sums.planWorkTime += wt;
                        sums.productivePlanWorkTime += pwt;
                        sums.planEmployeeTime +=et;
                        sums.planCl += cl;

                        if(!sums.planETCurve){
                            sums.planETCurve = 0;
                        }
                        let etv = 0;
                        plannedET.forEach(etc => {

                            let etFrom = view.$helpers.getMomentFromStringTZ(etc.date);
                            let employeeLevel = view.spotMap[etc.spotId] ? view.spotMap[etc.spotId].employeeLevel : 1;
                            if(etFrom >= d && etFrom < checkTo && employeeLevels.includes(employeeLevel)){
                                etv += etc.workTime;
                            }
                        })
                        sums.planETCurve += etv;

                        if(includeStats.workTime){
                            line.push((wt/60.0).toFixed(2));
                        }
                        if(includeStats.employeeCount){
                            line.push((et/60.0).toFixed(2));
                        }
                        if(meoOrVlh){
                            line.push((etv/60.0).toFixed(2));
                        }
                        if(meoOrVlh && includeStats.workTime){
                            line.push(((wt-etv)/60.0).toFixed(2));
                        }
                        otherIndicators.forEach(t => {
                             let type = view.planningIndicatorTypeMap[t]
                            if(!sums[t+'-soll']){
                                sums[t+'-soll'] = 0;
                            }
                            if(!counts [t+'-soll']){
                                counts [t+'-soll'] = 0;
                            }
                            let iv = 0;

                            planningindicators.forEach(pi => {
                                if(pi.planned && pi.typeId == t){
                                    let iFrom = view.$helpers.getMomentFromStringTZ(pi.date);
                                    if(iFrom >= d && iFrom < checkTo){
                                        let v = pi.sumAmount / Math.pow(10, type.fractional);
                                        iv += v
                                        if(v > 0){
                                            counts [t+'-soll']+=1;
                                        }
                                    }
                                }
                             })
                            sums[t+'-soll']+=iv;

                            if(type.isDefault){
                                defaultIV += iv;
                                sumDefaultIV += iv;
                                if(type.category == 1 || type.category == 2){
                                    isDefaultIncome = true;
                                }
                            }
                            line.push((iv).toFixed(2));
                        })

                        if(includeStats.productivity){
                            if(pwt > 0){
                                line.push((defaultIV/(pwt/60)).toFixed(2));
                            } else {
                                    line.push('-')
                            }
                        }
                        if(includeStats.crewLaborSum){
                            line.push((cl/100.0).toFixed(2));
                        }
                        if(includeStats.crewLaborPercentage){
                            if(defaultIV > 0 && isDefaultIncome){
                                line.push(( (cl/100.0) / defaultIV *100).toFixed(2))
                            } else {
                                line.push("-")
                            }
                        }

                        planBody.push(line)

                        d = d.add(60, 'minutes');
                    }
                    firstIndicators.forEach(t => {
                        let type = view.planningIndicatorTypeMap[t]
                        if(type.sumBehavior == 1){
                            sumLine.push((sums[t+'-soll']).toFixed(2));
                        } else {
                            if(counts[t+'-soll'] > 0){
                                sumLine.push((sums[t+'-soll']/counts[t+'-soll']).toFixed(2));
                            } else {
                                sumLine.push('-')
                            }
                        }
                    })
                    if(includeStats.workTime){
                        sumLine.push((sums.planWorkTime/60.0).toFixed(2));
                    }
                    if(includeStats.employeeCount){
                        sumLine.push((sums.planEmployeeTime/60.0).toFixed(2));
                    }
                    if(meoOrVlh){
                        sumLine.push((sums.planETCurve/60.0).toFixed(2));
                    }
                    if(meoOrVlh && includeStats.workTime){
                        sumLine.push(( (sums.planWorkTime - sums.planETCurve)/60.0).toFixed(2));
                    }
                    otherIndicators.forEach(t => {
                        let type = view.planningIndicatorTypeMap[t]
                        if(type.sumBehavior == 1){
                            sumLine.push((sums[t+'-soll']).toFixed(2));
                        } else {
                            if(counts[t+'-soll'] > 0){
                                sumLine.push((sums[t+'-soll']/counts[t+'-soll']).toFixed(2));
                            } else {
                                sumLine.push('-')
                            }
                        }
                    })
                    if(includeStats.productivity){
                        piTypes.forEach(t => {
                            let type = view.planningIndicatorTypeMap[t]
                            if(type.isDefault){
                                if(sums.productivePlanWorkTime > 0 && type.sumBehavior == 1){
                                    sumLine.push((sums[t+'-soll'] / (sums.productivePlanWorkTime/60.0)).toFixed(2));
                                } else {
                                    sumLine.push("-")
                                }

                            }
                        })
                    }
                    if(includeStats.crewLaborSum){
                        sumLine.push((sums.planCl/100.0).toFixed(2));
                    }
                    if(includeStats.crewLaborPercentage){
                        if(sumDefaultIV > 0 && isDefaultIncome){
                            sumLine.push(((sums.planCl/100.0) /sumDefaultIV *100 ).toFixed(2))
                        } else {
                            sumLine.push("-")
                        }
                    }


                    planBody.push(sumLine)




                    doc.autoTable({
                        startY: contentOffsetY,
                        head: [headers],
                        body: planBody,
                        headStyles: {
                            fillColor: [109,141,33],
                            fontSize: 7
                        },
                        bodyStyles: {
                            fontSize: 7
                        },
                        columnStyles: {

                        },
                        horizontalPageBreak: headers.length > 15,
                        horizontalPageBreakRepeat: 0,
                    })

                }

                let actualBody = []
                if(exportTypes.includes(2)){
                    let headers = [this.$t('store.settings.date')]
                    firstIndicators.forEach(t => {
                        headers.push(view.planningIndicatorTypeMap[t].name+"\n(Ist)")
                    })
                    if(includeStats.workTime){
                        headers.push("Arbeitszeit\n(Ist)");
                    }
                    if(includeStats.employeeCount){
                        headers.push("Mitarbeiter\n(Ist)");
                    }
                    if(meoOrVlh){
                        if(includeStats.vlh){
                            headers.push("VLH\n(Ist)");
                        } else {
                            headers.push("MEO\n(Ist)");
                        }

                    }
                    if(meoOrVlh && includeStats.workTime){
                        if(includeStats.vlh){
                            headers.push("Diff. VLH\n(Ist)");
                        } else {
                            headers.push("Diff. MEO\n(Ist)");
                        }

                    }
                    otherIndicators.forEach(t => {
                        headers.push(view.planningIndicatorTypeMap[t].name+"\n(Ist)")
                    })
                    if(includeStats.productivity){
                        headers.push("Produktivität\n(Ist)");
                    }
                    if(includeStats.crewLaborSum){
                        headers.push("Arbeitszeit Kosten\n(Ist)");
                    }
                    if(includeStats.crewLaborPercentage){
                        headers.push("Arbeitszeit Kosten %\n(Ist)");
                    }


                    let d = from.clone();

                    let sumLine =[this.$t('global.ui.sum')]
                    let sums =  {}
                    let counts = {}
                    let isDefaultIncome = false;
                    let sumDefaultIV = 0;
                    while (d < to){
                        let checkTo = d.clone().add(60, 'minutes');
                        let line = [d.format('DD.MM.YYYY HH:mm')];

                        let defaultIV = 0;

                        firstIndicators.forEach(t => {
                            let type = view.planningIndicatorTypeMap[t]
                                if(!sums[t+'-ist']){
                                    sums[t+'-ist'] = 0;
                                }
                                if(!counts [t+'-ist']){
                                    counts [t+'-ist'] = 0;
                                }
                                let iv = 0;

                                planningindicators.forEach(pi => {
                                    if(!pi.planned && pi.typeId == t){
                                        let iFrom = view.$helpers.getMomentFromStringTZ(pi.date);
                                        if(iFrom >= d && iFrom < checkTo){
                                            let v = pi.sumAmount / Math.pow(10, type.fractional);
                                            iv += v;
                                            if(v > 0){
                                                counts [t+'-ist']+=1;
                                            }
                                        }
                                    }
                                })
                                sums[t+'-ist']+=iv;

                                if(type.isDefault){
                                    defaultIV += iv;
                                    sumDefaultIV += iv;
                                    if(type.category == 1 || type.category == 2){
                                        isDefaultIncome = true;
                                    }
                                }
                                line.push((iv).toFixed(2));
                        })
                        if(!sums.actualWorkTime){
                            sums.actualWorkTime = 0
                        }
                        if(!sums.actualEmployeeTime){
                            sums.actualEmployeeTime = 0
                        }
                        if(!sums.productiveActualWorkTime){
                            sums.productiveActualWorkTime = 0
                        }
                        if(!sums.actualCl){
                            sums.actualCl = 0
                        }
                        let wt = 0;
                        let et = 0;
                        let pwt = 0;
                        let cl = 0;
                        actualShifts.forEach(s => {
                                let sFrom = view.actualShiftMomentMap[s.id].fromDate
                                let sTo = view.actualShiftMomentMap[s.id].toDate
                                let employeeLevel = 1;
                                let productive = true;
                                let spotId = s.planshiftId != null ? (view.planShiftMap[s.planshiftId] != null ? view.planShiftMap[s.planshiftId] .spotId: null) : null;

                                if(view.employeeMap[s.employeeId].spotId != null){
                                    employeeLevel = view.spotMap[view.employeeMap[s.employeeId].spotId].employeeLevel;
                                    productive = view.spotMap[view.employeeMap[s.employeeId].spotId].productive;
                                    if(spotId == null){
                                        spotId = view.employeeMap[s.employeeId].spotId;
                                    }
                                }
                                if(sFrom < checkTo && sTo > d && employeeLevels.includes(employeeLevel) && (!includeStats.onlyMEOSpots || includeStats.meoSpots.has(spotId))){
                                    let cFrom = d > sFrom ? d : sFrom;
                                    let cTo = checkTo < sTo ? checkTo: sTo;
                                    let wv = cTo.diff(cFrom, 'minutes');
                                    et += wv;
                                    if (view.actualBreakShiftIdMap[s.id] && view.actualBreakShiftIdMap[s.id].length > 0){
                                        let breaks = view.actualBreakShiftIdMap[s.id];
                                        breaks.forEach(b => {
                                            let breakMoment = view.actualBreakMomentMap[b.id];
                                            let breakFrom = breakMoment.fromDate;
                                            let breakTo = breakMoment.toDate;
                                            if(breakFrom < checkTo && breakTo > d){
                                                breakFrom = d > breakFrom ? d : breakFrom;
                                                breakTo = checkTo < breakTo ? checkTo : breakTo;
                                                wv -= Math.max(0, breakTo.diff(breakFrom, 'minutes'));
                                            }


                                        });


                                    }
                                    wt += wv;
                                    if(productive){
                                        pwt+=wv;
                                    }
                                    if(view.employeeIdContractMap[s.employeeId]){
                                        let c = view.employeeIdContractMap[s.employeeId].find(con => {
                                            let conFrom = view.employeeContractMomentMap[con.id].fromDate;
                                            let conTo = view.employeeContractMomentMap[con.id].toDate;
                                            if(conFrom < cTo && (conTo == null || conTo > cFrom)){
                                                return true;
                                            } else {
                                                return false;
                                            }
                                        });

                                        let hWage = 0;
                                        if(c != null){
                                            if(c.paymentType == 2 && c.wageType == 1){
                                                hWage = (c.payment + c.extraPayment);
                                            } else if(c.paymentType == 2 && c.wageType == 2){
                                                hWage = (c.payment + c.extraPayment)/((c.weekTimeRegular/60.0)/c.workDaysRegular);
                                            } else if(c.paymentType == 2 && c.wageType == 3){
                                                hWage = (c.payment + c.extraPayment)/(c.weekTimeRegular/60.0);
                                            } else {
                                                let factor = (c.collectiveContractId != null && view.allowedContractMap[c.collectiveContractId]) ? view.allowedContractMap[c.collectiveContractId].workTimeFactor : view.storeSettings.workTimeFactor;
                                                hWage = (c.payment + c.extraPayment)/((c.weekTimeRegular/60.0)*(factor/Math.pow(10,7)))
                                            }
                                        }

                                        cl += ((wv/60.0) * hWage);
                                    }


                                } /*else  if(sFrom < checkTo && sTo > d && employeeLevels.includes(employeeLevel) && !includeStats.meoSpots.has(spotId)){
                                    console.log("SHIFT: "+view.employeeMap[s.employeeId].lastName+" "+view.employeeMap[s.employeeId].firstName+" "+view.spotMap[spotId].name+" "+s.from+" "+s.planshiftId);
                                } */
                        })
                        sums.actualWorkTime += wt;
                        sums.productiveActualWorkTime += pwt;
                        sums.actualEmployeeTime += et;
                        sums.actualCl += cl;

                        if(!sums.actualETCurve){
                            sums.actualETCurve = 0;
                        }
                        let etv = 0;
                        actualET.forEach(etc => {

                            let etFrom = view.$helpers.getMomentFromStringTZ(etc.date);
                            let employeeLevel = view.spotMap[etc.spotId] ? view.spotMap[etc.spotId].employeeLevel : 1;
                            if(etFrom >= d && etFrom < checkTo && employeeLevels.includes(employeeLevel)){
                                etv += etc.workTime;
                            }
                        })
                        sums.actualETCurve += etv;

                        if(includeStats.workTime){
                            line.push((wt/60.0).toFixed(2));
                        }
                        if(includeStats.employeeCount){
                            line.push((et/60.0).toFixed(2));
                        }
                        if(meoOrVlh){
                            line.push((etv/60.0).toFixed(2));
                        }
                        if(meoOrVlh && includeStats.workTime){
                            line.push(((wt-etv)/60.0).toFixed(2));
                        }
                        otherIndicators.forEach(t => {
                            let type = view.planningIndicatorTypeMap[t]
                                if(!sums[t+'-ist']){
                                    sums[t+'-ist'] = 0;
                                }
                                if(!counts [t+'-ist']){
                                    counts [t+'-ist'] = 0;
                                }
                                let iv = 0;

                                planningindicators.forEach(pi => {
                                    if(!pi.planned && pi.typeId == t){
                                        let iFrom = view.$helpers.getMomentFromStringTZ(pi.date);
                                        if(iFrom >= d && iFrom < checkTo){
                                            let v = pi.sumAmount / Math.pow(10, type.fractional);
                                            iv += v;
                                            if(v > 0){
                                                counts [t+'-ist']+=1;
                                            }
                                        }
                                    }
                                })
                                sums[t+'-ist']+=iv;

                                if(type.isDefault){
                                    defaultIV += iv;
                                    sumDefaultIV += iv;
                                    if(type.category == 1 || type.category == 2){
                                        isDefaultIncome = true;
                                    }
                                }
                                line.push((iv).toFixed(2));
                        })
                        if(includeStats.productivity){
                            if(pwt > 0){
                                line.push((defaultIV/(pwt/60)).toFixed(2));
                            } else {
                                line.push('-')
                            }
                        }
                        if(includeStats.crewLaborSum){
                            line.push((cl/100.0).toFixed(2));
                        }
                        if(includeStats.crewLaborPercentage){
                            if(defaultIV > 0 && isDefaultIncome){
                                line.push(( (cl/100.0) / defaultIV *100).toFixed(2))
                            } else {
                                line.push("-")
                            }
                        }



                        actualBody.push(line)

                        d = d.add(60, 'minutes');
                    }


                    firstIndicators.forEach(t => {
                        let type = view.planningIndicatorTypeMap[t]
                        if(type.sumBehavior == 1){
                            sumLine.push((sums[t+'-ist']).toFixed(2));
                        } else {
                            if(counts[t+'-ist'] > 0){
                                sumLine.push((sums[t+'-ist']/counts[t+'-ist']).toFixed(2));
                            } else {
                                sumLine.push('-')
                            }
                        }
                    })
                    if(includeStats.workTime){
                        sumLine.push((sums.actualWorkTime/60.0).toFixed(2));
                    }
                    if(includeStats.employeeCount){
                        sumLine.push((sums.actualEmployeeTime/60.0).toFixed(2));
                    }
                    if(meoOrVlh){
                        sumLine.push((sums.actualETCurve/60.0).toFixed(2));
                    }
                    if(meoOrVlh && includeStats.workTime){
                        sumLine.push(( (sums.actualWorkTime -sums.actualETCurve)/60.0).toFixed(2));
                    }
                    otherIndicators.forEach(t => {
                        let type = view.planningIndicatorTypeMap[t]
                        if(type.sumBehavior == 1){
                            sumLine.push((sums[t+'-ist']).toFixed(2));
                        } else {
                            if(counts[t+'-ist'] > 0){
                                sumLine.push((sums[t+'-ist']/counts[t+'-ist']).toFixed(2));
                            } else {
                                sumLine.push('-')
                            }
                        }
                    })
                    if(includeStats.productivity){
                        piTypes.forEach(t => {
                            let type = view.planningIndicatorTypeMap[t]
                            if(type.isDefault){
                                if(sums.productiveActualWorkTime > 0 && type.sumBehavior == 1){
                                    sumLine.push((sums[t+'-ist'] / (sums.productiveActualWorkTime/60.0)).toFixed(2));
                                } else {
                                    sumLine.push("-")
                                }

                            }
                        })
                    }
                    if(includeStats.crewLaborSum){
                        sumLine.push((sums.actualCl/100.0).toFixed(2));
                    }
                    if(includeStats.crewLaborPercentage){
                        if(sumDefaultIV > 0 && isDefaultIncome){
                            sumLine.push(((sums.actualCl/100.0) /sumDefaultIV *100 ).toFixed(2))
                        } else {
                            sumLine.push("-")
                        }
                    }


                    actualBody.push(sumLine)

                    let finalY = doc.lastAutoTable.finalY || 10
                    let pageSize = doc.internal.pageSize
                    let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()

                    let offset = finalY + (pageHeight - (finalY % pageHeight))



                    doc.autoTable({
                        startY:  exportTypes.includes(1) ? offset + 20 : contentOffsetY,
                        head: [headers],
                        body: actualBody,
                        headStyles: {
                            fillColor: [109,141,33],
                            fontSize: 7
                        },
                        bodyStyles: {
                            fontSize: 7
                        },
                        columnStyles: {

                        },
                        horizontalPageBreak: headers.length > 15,
                        horizontalPageBreakRepeat: 0,
                    })

                }

                if(exportTypes.includes(1) && exportTypes.includes(2)){
                    let headers = [this.$t('store.settings.date')]
                    firstIndicators.forEach(t => {
                        headers.push(view.planningIndicatorTypeMap[t].name+"\n(Diff)")
                    })
                    if(includeStats.workTime){
                        headers.push("Arbeitszeit\n(Diff)");
                    }
                    if(includeStats.employeeCount){
                        headers.push("Mitarbeiter\n(Diff)");
                    }
                    if(meoOrVlh){
                        if(includeStats.vlh){
                            headers.push("VLH\n(Diff)");
                        } else {
                            headers.push("MEO\n(Diff)");
                        }

                    }
                    if(meoOrVlh && includeStats.workTime){
                        if(includeStats.vlh){
                            headers.push("Diff. VLH\n(Diff)");
                        } else {
                            headers.push("Diff. MEO\n(Diff)");
                        }

                    }
                    otherIndicators.forEach(t => {
                        headers.push(view.planningIndicatorTypeMap[t].name+"\n(Diff)")
                    })
                    if(includeStats.productivity){
                        headers.push("Produktivität\n(Diff)");
                    }

                    if(includeStats.crewLaborSum){
                        headers.push("Arbeitszeit Kosten\n(Diff)");
                    }
                    if(includeStats.crewLaborPercentage){
                        headers.push("Arbeitszeit Kosten %\n(Diff)");
                    }




                    let finalY = doc.lastAutoTable.finalY || 10
                    let pageSize = doc.internal.pageSize
                    let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()

                    let offset = finalY + (pageHeight - (finalY % pageHeight))
                    let diffBody = []
                    for( let i = 0; i < Math.max(planBody.length, actualBody.length); i++){
                        let line = [];
                        let planLine = i < planBody.length ? planBody[i] : [];
                        let actualLine = i < actualBody.length ? actualBody[i] : [];
                        for(let j = 0; j < Math.max(planLine.length, actualLine.length); j++){
                            if (j == 0){
                                if(j < planLine.length){
                                    line.push(planLine[j])
                                } else {
                                    line.push(actualLine[j])
                                }
                            } else {
                                let planValue = j < planLine.length ? (isNaN(parseFloat(planLine[j])) ? 0.0 : parseFloat(planLine[j])) : 0.0;
                                let actualValue = j < actualLine.length ? (isNaN(parseFloat(actualLine[j])) ? 0.0 : parseFloat(actualLine[j])) : 0.0;
                                let val = actualValue - planValue
                                line.push( val >= 0 ? ('+'+val.toFixed(2)) : val.toFixed(2));
                            }

                        }
                        diffBody.push(line)
                    }


                    doc.autoTable({
                        startY: offset + 20,
                        head: [headers],
                        body: diffBody,
                        headStyles: {
                            fillColor: [109,141,33],
                            fontSize: 7
                        },
                        bodyStyles: {
                            fontSize: 7
                        },
                        columnStyles: {

                        },
                        horizontalPageBreak: headers.length > 15,
                        horizontalPageBreakRepeat: 0,
                    })

                }

                doc.setProperties({
                    title: "Kennzahlen Stunden Report"
                });
                view.$helpers.previewPdf(doc, filename+ '.pdf');


            },

            loadVlhAndMeoData(date, planned = true) {
                let view = this;

                console.log('date', date);

                return new Promise((resolve, reject) => {

                    // load data based on planing indicator
                    let meoType = view.selectedPlanningIndicator.id; // Umsatz, Umsatz (Netto), Transaktionen, Items/Order

                    // load data for 2 days for 36 hour view
                    let from =  date.clone().startOf('day');
                    let to = date.clone().startOf('day').add(2,'days');

                    let fromText = from.format('YYYY-MM-DDTHH:mm');
                    let fromPlusOneText = from.clone().add(1, 'days').format('YYYY-MM-DDTHH:mm');


                    // check if data is already loaded
                    if (view.storeSettings.enableVlh && view.useVlhForForecast) {
                        if (planned) {
                            if (view.forecastData[fromText] && view.forecastData[fromText][view.selectedPlanningIndicator.id]['vlh'] && view.forecastData[fromText][view.selectedPlanningIndicator.id]['vlh']['planned'] && view.forecastData[fromText][view.selectedPlanningIndicator.id]['vlh']['planned'].loaded
                                && view.forecastData[fromPlusOneText] && view.forecastData[fromPlusOneText][view.selectedPlanningIndicator.id]['vlh'] && view.forecastData[fromPlusOneText][view.selectedPlanningIndicator.id]['vlh']['planned'] && view.forecastData[fromPlusOneText][view.selectedPlanningIndicator.id]['vlh']['planned'].loaded) {
                                    resolve(true);
                                    return;
                            }
                        } else {
                            if (view.forecastData[fromText] && view.forecastData[fromText][view.selectedPlanningIndicator.id]['vlh'] && view.forecastData[fromText][view.selectedPlanningIndicator.id]['vlh']['actual'] && view.forecastData[fromText][view.selectedPlanningIndicator.id]['vlh']['actual'].loaded
                                && view.forecastData[fromPlusOneText] && view.forecastData[fromPlusOneText][view.selectedPlanningIndicator.id]['vlh'] && view.forecastData[fromPlusOneText][view.selectedPlanningIndicator.id]['vlh']['actual'] && view.forecastData[fromPlusOneText][view.selectedPlanningIndicator.id]['vlh']['actual'].loaded) {
                                    resolve(true);
                                    return;
                            }
                        }
                    } else {
                        if (planned) {
                            if (view.forecastData[fromText] && view.forecastData[fromText][view.selectedPlanningIndicator.id]['meo'] && view.forecastData[fromText][view.selectedPlanningIndicator.id]['meo']['planned'] && view.forecastData[fromText][view.selectedPlanningIndicator.id]['meo']['planned'].loaded
                                && view.forecastData[fromPlusOneText] && view.forecastData[fromPlusOneText][view.selectedPlanningIndicator.id]['meo'] && view.forecastData[fromPlusOneText][view.selectedPlanningIndicator.id]['meo']['planned'] && view.forecastData[fromPlusOneText][view.selectedPlanningIndicator.id]['meo']['planned'].loaded) {
                                    resolve(true);
                                    return;
                            }
                        } else {
                            if (view.forecastData[fromText] && view.forecastData[fromText][view.selectedPlanningIndicator.id]['meo'] && view.forecastData[fromText][view.selectedPlanningIndicator.id]['meo']['actual'] && view.forecastData[fromText][view.selectedPlanningIndicator.id]['meo']['actual'].loaded
                                && view.forecastData[fromPlusOneText] && view.forecastData[fromPlusOneText][view.selectedPlanningIndicator.id]['meo'] && view.forecastData[fromPlusOneText][view.selectedPlanningIndicator.id]['meo']['actual'] && view.forecastData[fromPlusOneText][view.selectedPlanningIndicator.id]['meo']['actual'].loaded) {
                                    resolve(true);
                                    return;
                            }
                        }
                    }

                    // load data based on selected forecast setting
                    let p = null;
                    if (view.storeSettings.enableVlh && view.useVlhForForecast) {
                        if (planned) {
                            p = view.$helpers.GetVlhThresholdCurvePaged(from, to, meoType, true, 'hourly');
                        } else {
                            p = view.$helpers.GetVlhThresholdCurvePaged(from, to, meoType, false, 'hourly');
                        }
                    } else if (view.storeSettings.enableMeo) {
                        if (planned) {
                            p = view.$helpers.GetPlanningEmployeeThresholdCurvePaged(from, to, meoType, true, 'hourly');
                        } else {
                            p = view.$helpers.GetPlanningEmployeeThresholdCurvePaged(from, to, meoType, false, 'hourly');
                        }
                    }

                    if (p != null) {
                        p.then(result => {
                                // console.log('result', result);
                                let tmp = {};

                                // merge result entries by date
                                result.forEach(item => {
                                    item.dateParsed = view.$helpers.getMomentFromStringTZ(item.date).format('YYYY-MM-DDTHH:mm');

                                    if (!tmp[item.dateParsed]) {
                                        tmp[item.dateParsed] = {
                                            date: item.dateParsed,
                                            totalWorktime: 0,
                                            spots: []
                                        };
                                    }
                                    tmp[item.dateParsed].totalWorktime += item.workTime;
                                    tmp[item.dateParsed].spots.push(item);
                                });
                                // make sure to fill fromText and fromPlusOneText in case of missing data
                                if (!tmp[fromText]) {
                                    tmp[fromText] = {
                                        date: fromText,
                                        totalWorktime: 0,
                                        spots: []
                                    };
                                }
                                if (!tmp[fromPlusOneText]) {
                                    tmp[fromPlusOneText] = {
                                        date: fromPlusOneText,
                                        totalWorktime: 0,
                                        spots: []
                                    };
                                }


                                // insert into forecastData based on selected forecast settings


                                Object.values(tmp).forEach(t => {

                                    if (!view.forecastData[t.date]) {
                                        //IT IS IMPORTANT TO DEEP CLONE THE OBJECT, OTHERWISE WE OVERWRITE THE INTERNAL VALUES OF THE SAME OBJECT DURING THE ITERATION!
                                        let dateObject = {};
                                        Object.values(view.planningIndicatorTypeMap).forEach(t => {
                                            dateObject[t.id] = {
                                                meo: {
                                                    planned: {
                                                        loaded: false,
                                                        totalWorktime: 0,
                                                        spots: []
                                                    },
                                                    actual: {
                                                        loaded: false,
                                                        totalWorktime: 0,
                                                        spots: []
                                                    },
                                                },
                                                vlh: {
                                                    planned: {
                                                        loaded: false,
                                                        totalWorktime: 0,
                                                        spots: []
                                                    },
                                                    actual: {
                                                        loaded: false,
                                                        totalWorktime: 0,
                                                        spots: []
                                                    },
                                                }
                                            };
                                        });
                                        view.forecastData[t.date] = dateObject;
                                    }
                                    let entry = view.forecastData[t.date];
                                    if (view.storeSettings.enableVlh && view.useVlhForForecast) {
                                        if (planned) {
                                            entry[view.selectedPlanningIndicator.id]['vlh']['planned'].totalWorktime = t.totalWorktime;
                                            entry[view.selectedPlanningIndicator.id]['vlh']['planned'].spots = t.spots;
                                            entry[view.selectedPlanningIndicator.id]['vlh']['planned'].loaded = true;
                                        } else {
                                            entry[view.selectedPlanningIndicator.id]['vlh']['actual'].totalWorktime = t.totalWorktime;
                                            entry[view.selectedPlanningIndicator.id]['vlh']['actual'].spots = t.spots;
                                            entry[view.selectedPlanningIndicator.id]['vlh']['actual'].loaded = true;
                                        }
                                    } else {
                                        if (planned) {
                                            entry[view.selectedPlanningIndicator.id]['meo']['planned'].totalWorktime = t.totalWorktime;
                                            entry[view.selectedPlanningIndicator.id]['meo']['planned'].spots = t.spots;
                                            entry[view.selectedPlanningIndicator.id]['meo']['planned'].loaded = true;
                                        } else {
                                            entry[view.selectedPlanningIndicator.id]['meo']['actual'].totalWorktime = t.totalWorktime;
                                            entry[view.selectedPlanningIndicator.id]['meo']['actual'].spots = t.spots;
                                            entry[view.selectedPlanningIndicator.id]['meo']['actual'].loaded = true;
                                        }
                                    }
                                });

                                // refresh key to refresh computed property "dayModePlanningInfoMap"
                                view.refreshDayModePlanningInfoMap++;

                                resolve(true);
                            }).catch(error => {
                                console.log(error)
                                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                                resolve(false);
                            });
                    } else {
                        resolve(true);
                    }
                });
            },


            OpenSpareTimeViolationsReportPopup() {
                let view = this;

                // there are no settings for this report -> generate report directly
                view.generateSpareTimeViolationsReport();

                // let dataEntries = [];
                //
                // view.$helpers.OpenPopup({
                //     type: 'datafill',
                //     componentState: {
                //         entries: dataEntries,
                //
                //         selectCallback: function (data) {
                //             view.generateSpareTimeViolationsReport(data);
                //         }
                //     },
                //     header: 'Ersatzruhezeit Report',
                //     width: "700px",
                //     expanded: true,
                //     centered: true
                // });
            },
            generateSpareTimeViolationsReport() {
                let view = this;

                let objects = {};
                Object.values(this.employees).forEach(emp => {
                    let isoWeeks = {};
                    let violationsObject = {};
                    violationsObject = {};
                    violationsObject.empId = emp.id;

                    violationsObject.restViolations = 0;
                    violationsObject.restSpareTimeMissing = 0;
                    violationsObject.restWeekViolations = 0;
                    violationsObject.restWeekSpareTimeMissing = 0;
                    violationsObject.restWeekSpareDaysMissing = 0;
                    violationsObject.restWeekViolationsRumpWeek = 0;
                    violationsObject.restWeekSpareTimeMissingRumpWeek = 0;
                    violationsObject.restWeekSpareDaysMissingRumpWeek = 0;

                    for (const [key, value] of Object.entries(this.legalErrorMap[emp.id])) {
                        let dayStart = this.$rosterhelper.getMomentFromStringTZ(key);

                        // only check days is current month
                        if (dayStart.month() == this.rosterFromTo.month) {
                            let tweekKey = dayStart.isoWeek();

                            // rest week violation is saved to both days; rest spare time missing only to the second day
                            // we check rest spare time to avoid duplicated calculation
                            if (value.restSpareTimeMissing > 0) {
                                violationsObject.restViolations += 1;
                                violationsObject.restSpareTimeMissing += value.restSpareTimeMissing;
                            }
                            // rest week violation is saved to every day equally. only add first occurrence
                            if (value.restWeekError && (value.restWeekSpareTimeMissing > 0 || value.restWeekSpareDaysMissing > 0)
                                && !isoWeeks.hasOwnProperty(tweekKey)) {
                                isoWeeks[tweekKey] = {};

                                // if day is not start of week, the week started in the previous month
                                if (dayStart.toString() == dayStart.startOf('week').toString()) {
                                    violationsObject.restWeekViolations += 1;
                                    violationsObject.restWeekSpareTimeMissing += value.restWeekSpareTimeMissing;
                                    violationsObject.restWeekSpareDaysMissing += value.restWeekSpareDaysMissing;
                                } else {
                                    violationsObject.restWeekViolationsRumpWeek += 1;
                                    violationsObject.restWeekSpareTimeMissingRumpWeek += value.restWeekSpareTimeMissing;
                                    violationsObject.restWeekSpareDaysMissingRumpWeek += value.restWeekSpareDaysMissing;
                                }

                            }
                        }
                    }
                    if (violationsObject.restViolations > 0 || violationsObject.restWeekViolations > 0 || violationsObject.restWeekViolationsRumpWeek > 0) {
                        objects[emp.id] = violationsObject;
                    }
                });


                let headers = [this.$t('pages.employeeData.name'), this.$t('pages.employeeCoreData.personnelNumber'), '', 'Wochenruhezeit\nVerletzungen', 'Summe Ersatz\nWochenruhezeit\nStunden', 'Summe Ersatz\nWochenruhe\nTage', 'Tagesruhezeit\nVerletzungen', 'Summe Ersatz\nTagesruhezeit\nStunden'];
                let reportDateStr = (this.$helpers.getMomentTZ().month(this.rosterFromTo.month).year(this.rosterFromTo.year).format('MMMM YYYY'));
                let filename = 'Ersatzruhezeit ' + this.storeSettings.name + ' ' + reportDateStr + ' (Stand ' + this.$helpers.getMomentTZ().format('DD.MM.YYYY') + ')';
                var body = [];


                var repDoc = this.$helpers.tableReportDoc(
                    headers,
                    'Ersatzruhezeit ' + reportDateStr,
                    this.storeSettings.name + ' ('+this.storeSettings.description+')',
                    '',
                    this.userFullname,
                    12);
                var doc = repDoc.doc;
                var contentOffsetY = repDoc.contentOffsetY;
                doc.setFontSize(12);

                let reportEmployees = [];
                Object.values(objects).forEach(o => {
                    reportEmployees.push(o.empId);
                });
                Object.values(this.employeeMap).sort((a, b) => {
                    let aLN = a.lastName ? a.lastName : "";
                    let bLN = b.lastName ? b.lastName : "";
                    let c = aLN.toLowerCase().localeCompare(bLN.toLowerCase());
                    if(c != 0){
                        return c;
                    } else {
                        let aFN = a.firstName ? a.firstName : "";
                        let bFN = b.firstName ? b.firstName : "";
                        return aFN.toLowerCase().localeCompare(bFN.toLowerCase());
                    }
                }).forEach((e) => {

                    if(reportEmployees.includes(e.id)){

                        let object = objects[e.id];
                        let line = [
                            e.lastName + ' ' + e.firstName,
                            (e.personnelId ? e.personnelId : '-'),
                            'Rumpfwoche',
                            object.restWeekViolationsRumpWeek,
                            this.$helpers.GetHourMinuteFormatFromMilliseconds(object.restWeekSpareTimeMissingRumpWeek * 1000),
                            object.restWeekSpareDaysMissingRumpWeek,
                            '-',
                            '-',
                        ];
                        body.push(line);

                        line = [
                            '',
                            '',
                            'aktuelles Monat',
                            object.restWeekViolations,
                            this.$helpers.GetHourMinuteFormatFromMilliseconds(object.restWeekSpareTimeMissing * 1000),
                            object.restWeekSpareDaysMissing,
                            object.restViolations,
                            this.$helpers.GetHourMinuteFormatFromMilliseconds(object.restSpareTimeMissing * 1000),
                        ];
                        body.push(line);
                    }
                });


                doc.autoTable({
                    startY: contentOffsetY,
                    head: [headers],
                    body: body,
                    headStyles: {
                        fillColor: [109,141,33],
                        fontSize: 7
                    },
                    bodyStyles: {
                        fontSize: 7
                    },
                    columnStyles: {

                    }
                })

                doc.setProperties({
                    title: "Ersatzruhezeit Report"
                });
                view.$helpers.previewPdf(doc, filename+ '.pdf');
            },
            OpenRosterLogPopup(){
                let view = this;
                let description = this.$t('roster.view.rosterPeriodQuery') + "<br/>";



                let dataEntries = [
                    {label: this.$tc('global.general.day'), key: 'cutoffDate', hidden: false, type: 'date', value: view.$helpers.getMomentTZ()},
                    {label: this.$t('roster.view.time'), key: 'cutoffTime', hidden: false, type: 'timeframe', value: view.$helpers.getMomentTZ().endOf('day')},
                    {label: this.$t('global.ui.selectEmployee'), key: 'selectByEmployee', hidden: false, type: 'bool', value: false},
                    {label: this.$tc('global.general.employee'), key: 'employees', type: 'dropdownsearch', hidden: this.$helpers.CheckDatafillKeysForHidden('selectByEmployee'),
                                        dropdownSearchState: {
                                            selectMultiple: true, styleLight: true,
                                            items: Object.values(this.employeeMap).sort((a, b) => a.lastName.localeCompare(b.lastName)).map(e => {
                                                return {
                                                    label: e.lastName+" "+e.firstName,
                                                    value: e.id,
                                                    selected: false
                                                }
                                            }),
                                        },

                    }
                ];



                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: description,
                        selectCallback: function (data) {

                            let cutoffDate = data.cutoffTime.year(data.cutoffDate.year()).month(data.cutoffDate.month()).date(data.cutoffDate.date());


                            view.$helpers.GetRosterFromLogs(cutoffDate)
                            .then(logdata => {
                                view.generateRosterLogReport(logdata, cutoffDate, data.selectByEmployee, data.employees)
                            }).catch(error => {
                                console.log(error)
                                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                            })


                        }
                    },
                    header: this.$t('roster.view.timeOfRosterReport'),
                    expanded: true,
                    centered: true
                });
            },
            generateRosterLogReport(data, cutoffDate, selectByEmployee = false, employees =[]) {
                let view = this;
                let typeMap = {};
                if(this.uiDataMap.employeeAvailabilityTypes){
                    this.uiDataMap.employeeAvailabilityTypes.forEach(type => {
                        typeMap[type.id] = type;
                    });
                }


                let headers = [this.$tc('global.general.employee'), this.$t('global.general.from'),  this.$t('global.general.to'), this.$tc('shift.main.position'), this.$tc('global.general.type'), this.$t('pages.employeeContract.changeDate'), this.$tc('roster.view.responsible')];
                let reportDateStr = (this.$helpers.getMomentTZ().month(this.rosterFromTo.month).year(this.rosterFromTo.year).format('MMMM YYYY'));
                let filename = this.$t('global.menubar.roster') + ' ' + this.storeSettings.name + ' ' + reportDateStr + ' (Stand ' + cutoffDate.format('DD.MM.YYYY-HH:mm') + ')';
                var body = [];
                data.sort((a, b) => {
                    let nameSort = a.employeeName.localeCompare(b.employeeName);
                    if(nameSort == 0){
                        let aFrom = view.$helpers.getMomentFromStringTZ(a.from);
                        let bFrom = view.$helpers.getMomentFromStringTZ(b.from);
                        return aFrom.unix() - bFrom.unix();
                    } else {
                        return nameSort;
                    }
                }).forEach(d => {
                    if((d.entityType == 1 || d.prefState == 1) && (selectByEmployee == false || employees.includes(d.employeeId))){
                        let from = view.$helpers.getMomentFromStringTZ(d.from);
                        let to = view.$helpers.getMomentFromStringTZ(d.to);
                        let cd = view.$helpers.getMomentFromStringTZ(d.changeDate);
                        body.push([
                            d.employeeName,
                            from.format('DD.MM.YYYY HH:mm'),
                            to.format('DD.MM.YYYY HH:mm'),
                            d.spotId != null && view.spotMap[d.spotId] ? view.spotMap[d.spotId].name : '-',
                            d.entityType == 1 ? this.$t('shifts.main.planShift') : typeMap[''+d.prefType].label_de,
                            cd.format('DD.MM.YYYY HH:mm'),
                            d.responsibleName != null ? d.responsibleName : '-'
                        ])
                    }

                })


                var repDoc = this.$helpers.tableReportDoc(
                    headers,
                    'Dienstplan ' + reportDateStr,
                    this.storeSettings.name + ' ('+this.storeSettings.description+')',
                    'Zeitpunkt: '+cutoffDate.format('DD.MM.YYYY HH:mm'),
                    this.userFullname,
                    12);
                var doc = repDoc.doc;
                var contentOffsetY = repDoc.contentOffsetY;
                doc.setFontSize(12);




                doc.autoTable({
                    startY: contentOffsetY,
                    head: [headers],
                    body: body,
                    headStyles: {
                        fillColor: [109,141,33],
                        fontSize: 10
                    },
                    bodyStyles: {
                        fontSize: 10
                    },
                    columnStyles: {

                    }
                })

                doc.setProperties({
                    title: "Dienstplan zum Zeitpunkt Report"
                });
                view.$helpers.previewPdf(doc, filename+ '.pdf');
            },
            OpenRosterLogDeltaPopup(){
                let view = this;
                let description = "Für welchen Zeitraum sollen Änderungen abgefragt werden?<br/>";



                let dataEntries = [
                    {label: this.$t('global.general.fromDay'), key: 'cutoffDateFrom', hidden: false, type: 'date', value: view.$helpers.getMomentTZ().add(-1, 'days')},
                    {label: 'Von Uhrzeit', key: 'cutoffTimeFrom', hidden: false, type: 'timeframe', value: view.$helpers.getMomentTZ().add(-1, 'days').endOf('day')},
                    {label: this.$t('global.general.toDay'), key: 'cutoffDateTo', hidden: false, type: 'date', value: view.$helpers.getMomentTZ()},
                    {label: 'Bis Uhrzeit', key: 'cutoffTimeTo', hidden: false, type: 'timeframe', value: view.$helpers.getMomentTZ().endOf('day')},

                    {label: this.$t('global.ui.selectEmployee'), key: 'selectByEmployee', hidden: false, type: 'bool', value: false},
                    {label: this.$tc('global.general.employee'), key: 'employees', type: 'dropdownsearch', hidden: this.$helpers.CheckDatafillKeysForHidden('selectByEmployee'),
                                        dropdownSearchState: {
                                            selectMultiple: true, styleLight: true,
                                            items: Object.values(this.employeeMap).sort((a, b) => a.lastName.localeCompare(b.lastName)).map(e => {
                                                return {
                                                    label: e.lastName+" "+e.firstName,
                                                    value: e.id,
                                                    selected: false
                                                }
                                            }),
                                        },

                    }
                ];



                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        errorCheck: [
                                    (entries) => {
                                        if(entries.cutoffDateFrom.isAfter(entries.cutoffDateTo)){
                                            return {key: 'cutoffDateFrom', type: 'error', label: this.$t('global.general.fromDay'), text: 'Von Tag muss vor Bis Tag liegen'}
                                        } else {
                                            return null
                                        }
                                    },
                                    (entries) => {
                                        if(entries.cutoffDateTo.diff(entries.cutoffDateFrom, 'days') > 7){
                                            return {key: 'cutoffDateTo', type: 'error', label: this.$t('global.general.toDay'), text: 'Zeitraum darf maximal 7 Tage lang sein'}
                                        } else {
                                            return null
                                        }
                                    }

                                ],
                        description: description,
                        selectCallback: function (data) {

                            let cutoffDateFrom = data.cutoffTimeFrom.year(data.cutoffDateFrom.year()).month(data.cutoffDateFrom.month()).date(data.cutoffDateFrom.date());
                            let cutoffDateTo = data.cutoffTimeTo.year(data.cutoffDateTo.year()).month(data.cutoffDateTo.month()).date(data.cutoffDateTo.date());

                            console.log(cutoffDateFrom.format('DD.MM.YYYY HH:mm') + ' - ' + cutoffDateTo.format('DD.MM.YYYY HH:mm'));

                            view.$helpers.GetRosterLogs(cutoffDateFrom, cutoffDateTo)
                            .then(logdata => {
                                view.generateRosterLogDeltaReport(logdata, cutoffDateFrom, cutoffDateTo, data.selectByEmployee, data.employees)
                            }).catch(error => {
                                console.log(error)
                                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                            })


                        }
                    },
                    header: 'Dienstplan Änderungen',
                    expanded: true,
                    centered: true
                });
            },
            generateRosterLogDeltaReport(data, cutoffDateFrom, cutoffDateTo, selectByEmployee = false, employees =[]) {
                let view = this;

                let typeMap = {};
                if(this.uiDataMap.employeeAvailabilityTypes){
                    this.uiDataMap.employeeAvailabilityTypes.forEach(type => {
                        typeMap[type.id] = type;
                    });
                }


                let headers = [this.$tc('global.general.employee'), this.$t('global.general.from'),  this.$t('global.general.to'), this.$tc('shift.main.position'), this.$tc('global.general.type'), this.$t('pages.employeeContract.changeDate'), this.$tc('roster.view.action'), this.$tc('roster.view.responsible')];
                let reportDateStr = "";
                let filename = 'Dienstplan Änderungen' + this.storeSettings.name + ' ' + reportDateStr + ' (Von ' + cutoffDateFrom.format('DD.MM.YYYY-HH:mm') +' Bis ' + cutoffDateTo.format('DD.MM.YYYY-HH:mm')+ ')';
                var body = [];
                data.sort((a, b) => {
                    let aFrom = view.$helpers.getMomentFromStringTZ(a.changeDate, 'YYYY-MM-DDTHH:mm:ssZ');
                    let bFrom = view.$helpers.getMomentFromStringTZ(b.changeDate, 'YYYY-MM-DDTHH:mm:ssZ');
                    return aFrom.unix() - bFrom.unix();

                }).forEach(d => {
                    if((d.entityType == 1 || d.prefState == 1) && (selectByEmployee == false || employees.includes(d.employeeId))){
                        let from = view.$helpers.getMomentFromStringTZ(d.from);
                        let to = view.$helpers.getMomentFromStringTZ(d.to);
                        let cd = view.$helpers.getMomentFromStringTZ(d.changeDate, 'YYYY-MM-DDTHH:mm:ssZ');
                        body.push([
                            d.employeeName,
                            from.format('DD.MM.YYYY HH:mm'),
                            to.format('DD.MM.YYYY HH:mm'),
                            d.spotId != null && view.spotMap[d.spotId] ? view.spotMap[d.spotId].name : '-',
                            d.entityType == 1 ? this.$t('shifts.main.planShift') : typeMap[''+d.prefType].label_de,
                            cd.format('DD.MM.YYYY HH:mm:ss'),
                            d.active ? 'Veröffentlicht' : 'Veröffentlichung aufgehoben',
                            d.responsibleName != null ? d.responsibleName : '-'
                        ])
                    }

                })


                var repDoc = this.$helpers.tableReportDoc(
                    headers,
                    'Dienstplan Änderungen ' + reportDateStr,
                    this.storeSettings.name + ' ('+this.storeSettings.description+')',
                    'Von: '+cutoffDateFrom.format('DD.MM.YYYY HH:mm')+' Bis: '+cutoffDateTo.format('DD.MM.YYYY HH:mm'),
                    this.userFullname,
                    7);
                var doc = repDoc.doc;
                var contentOffsetY = repDoc.contentOffsetY;
                doc.setFontSize(12);




                doc.autoTable({
                    startY: contentOffsetY,
                    head: [headers],
                    body: body,
                    headStyles: {
                        fillColor: [109,141,33],
                        fontSize: 10
                    },
                    bodyStyles: {
                        fontSize: 10
                    },
                    columnStyles: {

                    }
                })

                doc.setProperties({
                    title: "Dienstplan Änderungen"
                });
                view.$helpers.previewPdf(doc, filename+ '.pdf');
            },

            //
            // personnel deployment methods
            togglePDSection() {
                this.$store.commit('setDisplayPdChart', {displayPdChart: !this.displayPdChart});
                this.selectedPDIndex = null;
                // Recalculate barWidth after toggle
                if (this.dayMode && this.displayPdChart) {
                  this.$nextTick(() => {
                    this.$refs.pdChart.refresh().then(() => {
                      this.$refs.pdChart.updateBarWidth();
                    });
                  });
                }
            },
            getPDBarWidth() {
                return this.dayMode ? null : 51;
            },
            onChartDayDblClick(day/*, index, event*/) {
                this.ToggleDayModeWithDate(day, false);
                this.ChangeTimeBarLength();
            },
        },
    }
</script>

<style scoped>
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        cursor: default;
        user-select: none;
        /*opacity: 1!important;*/
    }

    .blink_me {
        animation: blinker 1s linear infinite;
    }

    @keyframes blinker {
        50% {
            box-shadow: inset 0 0 1px 1px #e3c423;
        }
    }

    .has-header > .has-header > .scrollbar-container{
        height: calc(100% - (1 * var(--header-height)) - var(--tab-menu-height)) !important;
        transition: height 250ms ease-in-out;
        top:  calc((1 * var(--header-height)));
        /* overflow-x: hidden; */
    }

    .has-header > .has-header > .scrollbar-container.pd-minimized {
        height: calc(100% - 40px - (1 * var(--header-height)) - var(--tab-menu-height)) !important;
    }

    .has-header > .has-header > .scrollbar-container.pd-expanded {
        height: calc(100% - 20rem - (1 * var(--header-height)) - var(--tab-menu-height)) !important;
    }

    input.field{
        margin: initial;
        padding: initial;
        cursor: initial;
        user-select: initial;
        box-sizing: initial;
    }

    html {
        height: 100%;
        width: 100%;
        /*
        transform: scale(0.8) translateX(-6%) translateY(-6%);*/
    }

    body {
        margin: 0;
        padding: 0;
        height: 100%;
        width: 100%;
        overflow: hidden;
    }

    .icon-main {
        background: var(--contrast-2) url('~@/assets/icon.png');
        background-size: 100%;
        float: left;
        margin: 5px 0 0 0 !important;
        height: 70px;
        width: 70px;
        border-radius: 15px;
        margin-right: 60px !important;
    }

    .icons-left {
        width: 566px;
        text-align: left;
    }

    .icons-left > *:nth-child(1), .icons-left > *:nth-child(2), .icons-left > *:nth-child(3) {

        background: var(--contrast-2) url('~@/assets/icon.png') !important;
        background-size: 60% !important;
        background-position: 50% !important;
        background-repeat: no-repeat !important;
        filter: saturate(0%);
    }

    .icons-left > * {

        width: 35px !important;
        height: 35px !important;
        margin: 0 5px !important;
    }

    .icons-left > .divider {

        width: 1px !important;
        height: 35px !important;
        margin: 0 5px !important;
        background: none;
        border-right: 1px solid var(--contrast-5);
        border-radius: 0;
    }

    .icons-calender {
        width: 190px;
        margin-top: -8px !important;
        margin-left: 0px;
    }


    .icons-calender * {
        cursor: pointer;
    }
    .icons-calender * > .fas {
        color: var(--color-button);
    }
    .nightmode .icons-calender .fas {
        color: var(--contrast-4) !important;
    }
    .nightmode .icons-calender .fa-circle,.icons-calender .fa-circle {
        color: var(--contrast-2) !important;
    }

    .week-days {

    position: absolute;
    left: 10px;
    top: 15px;
    }
    .week-days > *{
        float: left;
        width: 40px;
        line-height: 190%;
        font-size: 12px;
        border: 1px solid var(--contrast-5) !important;
        color: var(--contrast-4);
        font-weight: 800;
        text-align: center;
        border-radius: 0 !important;
        margin: 0 !important;
        border-right: none !important;
        height: 27px !important;
        cursor: pointer;
        transition: .2s;
    }

    .week-days > *.toggled, .week-days > *:hover {
        background: #6d8d23 !important;
        color: var(--bg);
    }
    .week-days > *:last-child{

        border-radius: 0 5px 5px 0 !important;
        border-right: 1px solid var(--contrast-5) !important;
    }
    .week-days > *:first-child{
        border-radius: 5px 0 0 5px !important;
    }

    .icons-weekly {
        width: 285px;
    }

    .icons-weekly > * {
        margin: 0 !important;
        border-radius: 0 !important;
        height: 20px !important;
        padding-top: 3px;
        font-weight: 800;
        color: var(--color-button);
        font-size: 9px;
        text-align: center;
        width: 35px !important;
        cursor: pointer;
    }



    .icons-weekly > *:nth-child(1) {
        margin: 0 !important;
        border-top-left-radius: 5px !important;
        border-bottom-left-radius: 5px !important;
    }

    .icons-weekly > *:nth-child(1), .icons-weekly > *:nth-child(2), .icons-weekly > *:nth-child(3), .icons-weekly > *:nth-child(4) {
        border-right: 1px solid var(--contrast-5) !important;
    }
    .header.day-mode .icons-weekly > * {
        border: 1px solid var(--contrast-5) !important;
        color: var(--contrast-4);
    }
    .header.day-mode .icons-weekly > .toggled {
        background: #6d8d23;
        color: var(--bg);
    }
    .header.day-mode .icons-weekly > *:nth-child(1), .header.day-mode .icons-weekly > *:nth-child(2), .header.day-mode .icons-weekly > *:nth-child(3){
        border-right: none !important;
    }

    .icons-weekly > *:nth-child(4){
        margin: 0 !important;
        border-top-right-radius: 5px !important;
        border-bottom-right-radius: 5px !important;
    }

    .header:not(.day-mode) .icons-weekly > *:last-child {
        margin-left: 10px !important;
        border-radius: 5px !important;
        background: var(--contrast-4) !important;
    }

    .icons-right {
        float: right;
        width: 11%;
        padding-left: 15px;

    }

    .icons-right > * {
        color: var(--bg);
        width: 80px !important;
        background: var(--contrast-5) !important;
        height: 20px !important;
        margin-top: 15px !important;
        font-size: 10px;
        font-weight: 600;
        text-align: center;
        padding-top: 2px;
    }

    .icons-right > .selected {
        color: var(--bg);
        background: var(--contrast-3) !important;
    }


    .employees {
        position: absolute;
        height: calc(100vh - 115px);
        border-right: 1px solid var(--sub-menu);
        padding: 5px;
        padding-top: 13px;
        width: 140px;
        height: calc(100vh - 145px);
        overflow: hidden;
        z-index: 2;
        background: var(--bg);
    }

    .employees .scrollbar-container {
        overflow: scroll !important;
        width: calc(100% + 16px) !important;
        padding: 0 5px;
    }
    .employee:first-child {
        margin-top:1px;
    }
    .employee.showSpotPlanningNumbers:first-child {
        margin-top:51px;
    }

    .employee {
        width: 100%;
        box-shadow: inset 0 -.60px 0 -.50px var(--sub-menu);
        /*height: 60px;*/
        height: 4.380px;
        display: inline-block;
        position: relative;
        margin-bottom: 10px;
        cursor: pointer;
        transition: .2s;
        padding: 10px;
        padding-bottom: 30px;
        padding-top: 0;
        padding-left: 40px;
        border-radius: 5px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        opacity: 1;
    }

    .show  *{
        transition: 0s;
    }

    .indentationLevelEmployee0{
        width: 255px;
        margin-left: 0px;
    }
    .indentationLevelEmployee1{
        width: 235px;
        margin-left: 20px;
    }

/*
    .indentationLevelEmployee0.show{
        width: 460px;
        margin-left: 0px;
    }
    .indentationLevelEmployee1.show{
        width: 440px;
        margin-left: 20px;
    }*/

    .grid .employee{
        margin-top: -1px;
        position: absolute;
        left: -45px;
        z-index: 10;
        transition: 0s;
        background: var(--bg);
        border-radius: 0;
    }

    .grid .group .entry:nth-child(2) .employee{
        box-shadow: none;
    }

    .grid .group .entry:last-child .employee{
        height: 49px;
        margin-bottom: -5px;
        /* box-shadow: none; */
    }

    .grid .group:last-child .employee{
        box-shadow: inset 0 -3px 0 -1px var(--grid-shadow);
    }

    .grid .group:last-child .entry:last-child .employee{
        box-shadow: inset 0 -2px 0 -1px var(--grid-shadow) !important;
    }

    .grid .group:last-child .employee:hover, .grid .group:last-child .entry:last-child .employee:hover{
        box-shadow: none !important;
    }

    .day-mode .grid .employee{
        z-index: 2;
        background: var(--bg);
        transition: 0s;
    }

    .day-mode .grid .week{
        border: none;
    }

    .employees .employee:last-child{
        margin-bottom: 20px;
    }



    .grid .employee{
        height: 50px;
        margin-bottom: 5px;
        box-shadow: 0 -2px 0 -1px var(--grid-shadow);
    }

    .grid .employee:hover {
        background: var(--contrast-1);
        border-radius: 0;
        border-top-left-radius: 100px;
        border-bottom-left-radius: 100px;
        box-shadow: none;
    }

    .grid .employee:hover .fa-stack.detail{
        display: block;
    }

    .grid .employee:hover .fa-stack.skill{
        display: none;
    }

    .grid .employee * {
        cursor: pointer;
    }

    .employee .picture {
        background-size: 100%;
        position: absolute;
        height: 30px;
        width: 30px;
        left: 10px;
        top: 10px;
        border-radius: 33px;
        cursor:  grab !important;
    }

    .employee .namefirst,.employee .namefirst.shadow {
        font-size: 13px;
        color: var(--contrast-5);
        text-align: left;
        height: 18px;
        white-space: nowrap;
        font-weight: 800;
        margin-top: 5px;
        margin-left: 5px;
        font-family: DistrictProBold;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 120px;
    }

    .employee .namefirst.shadow {
        color: transparent;
        box-shadow: inset -20px 0 5px -10px var(--bg) !important;
        position: absolute;
        top: 0px;
    }

    .employee.hovered .namefirst.shadow, .employee:hover .namefirst.shadow {
        color: transparent;
        box-shadow: inset -20px 0 5px -10px var(--contrast-1) !important;
        position: absolute;
        top: 0px;
    }

    .employee .namelast {
        font-size: 11px;
        color: var(--contrast-4);
        text-align: left;
		height: 15px;
        white-space: nowrap;
    }

    .employee .externalstore {
        font-size: 11px;
        color: var(--contrast-4);
        text-align: left;
        height: 18px;
        white-space: nowrap;
        font-weight: 800;
        margin-left: 5px;
        bottom: 5px;
        font-family: DistrictProBold;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 120px;
    }

    .employee .progressbar {
        position: absolute;
        width: calc(100% - 10px);
        right: 0;
        margin: auto;
        bottom: 5px;
        height: 6px;
        border-radius: 100px;
        background: var(--contrast-6);
        left: 0;
        overflow: hidden;
    }

    .employee .progressbar .progressfill {
        position: absolute;
        width: 50%;
        bottom: 00px;
        height: 100%;
        border-radius: 100px;
        background: var(--contrast-5);
        left: 0;
    }

    .has-header .grid:not(.preload) .entry.header{
        top: calc(-1px + 2*var(--header-height));
    }

    .has-header > .has-header .grid:not(.preload) .entry.header{
        top: calc(-1px + (2 * var(--header-height)) + var(--tab-menu-height));
    }
    .grid:not(.preload) .entry.header{
        position: fixed;
        z-index: 1;
        top: calc(1* var(--header-height));
        background: var(--bg);
        left: 260px;
        width: calc(100% - 277px);
        overflow: hidden;
    }
    .grid:not(.preload) .entry.header.borders{
        overflow: visible;
        background: none;
        pointer-events: none;
    }

    .grid:not(.preload) .entry.header .week{
        margin-top: -10px;
    }
    .grid.preload .entry .week{

        transform: translateY(0px);
    }
    .grid.preload .entry .date{
    display: none;
    }


    .grid:not(.preload) .entry.header .day{
        margin-top: 32px;
    }

    .grid .entry.header .day {
        position: relative;
		opacity: 1 !important;
        padding-bottom: 0;
        height: 40px;
        width: 40px;
        /*margin: 5px; */
        cursor: pointer !important;
    }
    .grid .entry.header .day:not(:last-child) .border-day{
        position:absolute;
        width: 1px;
        top: 4px !important;
        right: -6px;
        height: calc(100vh - 210px);
        border-right: 1px solid var(--contrast-1);
    }
    .grid .entry.header .day:last-child .border-day{
        position:absolute;
        width: 1px;
        top: 4px !important;
        right: -7px;
        height: calc(100vh - 190px);
        border-right: 1px solid var(--contrast-1) ;
    }

    .day .border-day.light{
        border-right: none !important;

    }

    .day-mode .grid .entry.header .day .border-day{
        opacity: 0;
    }
    .grid .entry.header .day *{
        cursor: pointer !important;
    }

    .grid .entry.header .name {
        position: absolute;
        height: 50%;
        width: 100%;
        left: 0;
        bottom: 0;
        right: 0;
        top: -10px;
        margin: auto;
        text-align: center;
        font-size: 13px;
        font-weight: 600;
        color: var(--contrast-4);
        border-radius: 0 !important;
        padding-top: 0 !important;
        background: none !important;
    }
    .grid .entry.header .income {
        width: calc(100% + 10px);
        position: absolute;
        bottom: -30px;
        font-size: 10px;
        background: transparent;
        border-top: 1px solid var(--contrast-3);
        height: 25px;
        left: -5px;
        text-align: center;
        z-index: -1;
    }
    .grid .entry.header .weather {
        width: calc(100% + 14px);
        position: absolute;
        top: -22px;
        font-size: 10px;
        background: var(--bg);
        height: 25px;
        left: -6px;
        padding: 3px 2px 0.5rem;
        text-align: center;
        z-index: 1;
    }
    .grid .entry.header .weather .label{
        font-family: DistrictProLight;
        pointer-events: none;
        font-weight: 200;
        color: var(--contrast-4);
    }
    .grid .entry.header .weather .picture{

        width: 15px;
        margin-top: 2px;
        margin-left: 5px;
        height: 15px;
        display: inline-block;
        pointer-events: none;
        float: left;
    }
    .grid .entry.header .day:first-child .income {
        width: calc(100% + 13px);
        left: -7px;
    }
    .grid .entry.header .day .income .income-bar {
        position: absolute;
        border-radius: 100px;
        height: 8px;
        left: 5px;
        top: 6px;
    }
    .grid .entry.header .day .income .income-bar.red{
        background: #e51c50;
    }
    .grid .entry.header .day .income .income-bar.gray{
        background: var(--contrast-3);
    }

    .grid .entry.header .day .income .income-bar.green{
        background: #6d8d23;
    }


    .grid .entry.header .day .total-unassigned-hours {
        position: absolute;
        border-radius: 100px;
        height: 15px;
        /* left: 5px; */
        bottom: -40px;
        font-size: 10px;
        text-align: center;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--contrast-4);
    }

    .grid .entry.header .day .total-productivity {
        position: absolute;
        border-radius: 100px;
        height: 15px;
        /* left: 5px; */
        bottom: -40px;
        font-size: 10px;
        text-align: center;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--contrast-4);
    }

    .grid .entry.header .day .total-unassigned-hours.actual {
        color: #bc6c2c;
    }

    .daymode-hourinfo.actual{
        color: #bc6c2c;
    }

    .daymode-hourinfo.planned{
        color: #6d8d23;
    }

    .daymode-hourinfo.indicator{
        color: #428aff;
    }

    .grid .entry.header .date {

        position: absolute;
        height: 50%;
        width: 100%;
        left: 0;
        bottom: -20px;
        right: 0;
        top: 0;
        margin: auto;
        text-align: center;
        font-size: 10px;
        padding-top: 0 !important;
        border-radius: 0 !important;
        background: none !important;
        color: var(--contrast-4);
    }



    .grid {
        position: absolute;
        padding-left: 260px;
        /*margin-top: -5px;*/
        /* overflow: scroll; */
        text-align: left;
        width: 100%;
        height: 100%;
        padding-top: 107px;
    }

    .grid.show{
        width: calc(100%);
        left: 20px;
        padding-left: calc(230px + 237px + (10px * 2));
    }


    .show .entry.group{


        margin-left: calc(-1 * (230px + 237px + (10px * -1)));
    }
    /*
    .show .entry.group > .header{
        margin-left: calc(-1 * (230px + (10px * .5) + 237px + (10px * 0)));


    } */

    .sub-header-button-container {
        width: 260px;
        z-index: 20;
        position: fixed;
        background: var(--bg);
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
    }

    .sub-header-button-container > .sub-header-row > .button{
        margin: 0 0 0 15px !important;
        height: 25px !important;
        width: 25px !important;
        float: left;
        cursor: pointer;
        //border-radius: 5px;
        font-size: 17px;
        color: var(--contrast-4);
    }
    .sub-header-button-container > .sub-header-row > .button:first-of-type{
       float: left !important;
    }
    .sub-header-button-container > .sub-header-row > .button:last-of-type{
       float: right;
    }

    .sub-header-row.expand-productivity {
        /* height: 30px; */
        background-color: var(--contrast-1);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 0.25rem 0.75rem;
        margin-left: 0;
        margin-top: 0.3rem;
    }

    .productivity-header {
        font-family: DistrictProBold, sans-serif;
        font-size: 0.75rem;
        color: var(--contrast-4);
    }

    .productivity-expand-icon {
        font-size: 1rem;
        color: var(--contrast-4);
        cursor: pointer;
        transform: rotate(0);
        transition: transform 125ms ease-in-out;
    }

    .productivity-expand-icon.expanded {
        transform: rotate(90deg);
    }

    .grid .week {
        float: left;
        height: 100%;
        /*width: calc(100% / 4);*/
        margin-right: 1px;
    }


    .grid .day-outer {
        float: left;
        position: relative;
        transition: .2s;
        transform: scale(1);
        padding:5px;
        height: 50px;
        width: 50px;
        margin-left: 1px;
    }



    .grid .day-outer:last-child {
        margin-right: 1px;
    }

    .grid .day {
        opacity: 0;
        /*border-radius: 10px; */
        transition: .2s;
        transform: scale(1);
        cursor: pointer;
        height: 40px;
        width: 40px;
        margin: 0px;
        /*margin-left: 1px !important; */
    }

    .grid .day .day-text{
        transform: scale(1) translateY(2px);
        transition: .2s;
        height: 37px;
    }

    .grid .day .day-text.colored .name, .grid .day .day-text.colored .date{
        color: var(--col-planned-actual-calculation);
        font-style: italic;
        font-weight: bold;
    }

    .grid .day .day-text:hover {
        transform: scale(1.3) translateY(1px);
    }

    .grid .day .day-text * {
        pointer-events: none;
    }

    .grid .entry,.grid .entry .week{
        float: none;
        width: initial;
        display: inline-block;
        white-space: nowrap;
        height: 50px;
        margin-bottom: -6px;

    }

    .grid .entry{
        display: block;
        margin-bottom: 0px;
    }

    .entry:not(.header) .day {
        background: var(--contrast-0);
    }

    .day-spot-icon-switch .day.Desired .spot-icon{
        background: #efefefcd !important;
    }

    .day * {

        cursor: pointer;
    }

    .grid .entry:not(.header) .day:hover {
        transform: scale(1.2);
        /*background: lightgray;*/
        z-index: 10;
        background: var(--contrast-1);
    }

    .grid .entry.header .day {
        cursor: default;
    }
    .grid .entry.header .day * {
        cursor: default;
    }

    .grid .entry:not(.header) .day {
        transform: scale(1.1);
    }


    .grid .day.Desired {
        background: rgb(187, 187, 187);
        transform: scale(1.1);
    }
    .grid .day.Desired * {
        background: #dddddd !important;
    }

    .day-spot-icon-switch .day.Desired .spot-icon{
        background: #dddddd !important;
    }

    .grid .day.Desired *.date {
        background: #dddddd !important; /*#bebebe*/
    }
    .grid .day.Undesired {
        background: rgb(187, 187, 187);
        transform: scale(1.1);
    }
    .grid .day.Undesired * {
        background: #dddddd !important;
    }
    .grid .day.Undesired *.date {
        background: #dddddd !important; /*#bebebe*/
    }



    .grid .day.Green {
        background: #6d8d23;
        transform: scale(1.1);
    }

    .grid .day.Green * {
        background: #c1e077 !important;
    }

    .day-spot-icon-switch .day.Green .spot-icon{
        background: #c1e077 !important;
    }

    .grid .day.Green *.date {
        background: #879d53!important;
    }

    .grid .day.Yellow {
        transform: scale(1.1);
    }
    .grid .day.Yellow * {
        background: #e3c423 !important;
    }

    .day-spot-icon-switch .day.Yellow .spot-icon{
        background: #e3c423 !important;
    }

    .grid .day.Yellow *.date {
        background: #9f8918 !important;
    }

    .grid .day.Orange {
        background: #8d5822;
        transform: scale(1.1);
    }

    .grid .day.Orange * {
        background: #e0a374 !important;
    }

    .day-spot-icon-switch .day.Orange .spot-icon{
        background: #e0a374 !important;
    }

    .grid .day.Orange *.date {
        background: #e86e13!important;
    }


    .grid .day.Sick {
        background: var(--contrast-1) url('~@/assets/sick.png');
        background-size: 60%;
        background-position: 50%;
        background-repeat: no-repeat;
        box-shadow: inset 0 0 00px 5px #e5154f;
        transform: scale(1.1);
    }

    .grid .day.Sick * {
        display: none;
    }

    .grid .day.Vacations {
        background: var(--contrast-1) url('~@/assets/vacation.png');
        background-size: 60%;
        background-position: 50%;
        background-repeat: no-repeat;
        box-shadow: inset 0 0 00px 5px #e76e13;
        transform: scale(1.25);
    }

    .grid .day.Vacations * {
        display: none;
    }

    .grid .day.Remove {
        background: var(--contrast-3);
    }

    .grid .entry .name {
        float: left;
        height: calc(50% + 1px);
        width: 100%;
        left: 0;
        margin-bottom: -1px;
        bottom: 0;
        right: 0;
        text-align: center;
        font-size: 10px;
        background: var(--contrast-6);
        /*border-top-right-radius: 10px;
        border-top-left-radius: 10px; */
        padding-top: 3px !important;
    }

    .grid .entry .date {
        float: left;
        height: 50%;
        width: 100%;
        left: 0;
        right: 0;
        top: 0;
        margin: auto;
        text-align: center;
        font-size: 10px;
        background: var(--sub-menu);
        /*border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px; */
        padding-top: 3px !important;
    }


    .grid .entry:not(.header) .name{
        position: absolute;
        top: 0;
        bottom: initial;
        height: 50%;
        line-height: 14px;
    }

    .grid .entry:not(.header) .date{
        position: absolute;
        height: 50%;
        bottom: 0;
        top: initial;
        line-height: 14px;
    }

    .employee-data {
        position: absolute;
        left: calc(-1 * (230px + 10px));
        padding: 15px;
        padding-top: 5px;
        width: 237px;
        background: var(--bg);
        border-left: 1px solid var(--contrast-5);
        -webkit-transition: .2s;
        transition: .2s;
        opacity: 0;
        /* bottom: 0; */
        top: 0;
        overflow-y: scroll;
        z-index: 3;
        pointer-events: none;
    }

    .employee-hours{
        position: absolute;
        width: 237px;
        background: var(--bg);
        border-left: 1px solid var(--contrast-5);
        border-right: 1px solid var(--contrast-5);
        top: 0;
        overflow-y: hidden;
        z-index: 3;
    }

    .employee-hours.interactive{
        position: absolute;
        width: 237px;
        background: var(--bg);
        border-left: 1px solid var(--contrast-5);
        border-right: 1px solid var(--contrast-5);
        top: 0;
        overflow-y: hidden;
        z-index: 10;
        height: 115px;
    }

    .employee-hours.interactive strong{
        color: var(--contrast-4);
    }

    .entry.group > .entry:nth-child(3) .employee-hours.entry{
    }

    .entry.group > .entry:nth-child(3) .employee-hours.entry .full.hourstableentry{
        box-shadow: 0 2px 0px -1px var(--contrast-3), 0 -2px 0px -1px var(--contrast-3);
    }

    .entry.group:last-child > .entry .employee-hours.entry .full.hourstableentry {
        top: -1px !important;
    }

    .entry.group > .entry:nth-child(3) .employee-hours.entry .full.hourstableentry .exact.hourstableentry{

        height: 110px;
        margin-top: -30px;
    }

    .exact.hourstableentry .label{
        pointer-events: none;
    }

    .employee-hours.entry{
        margin-left: -10px;
        margin-top: 5px;
        padding: 0px 0px 0px 0px;
        position: absolute;
        width: 237px;
        background: var(--bg);
        border-left: 1px solid var(--contrast-5);
        border-right: 1px solid var(--contrast-5);
        top: 0;
        overflow-y: visible;
        z-index: 3;
    }

    .employee-hours.buheader{
        margin-left: -50px;
        position: absolute;
        width: 237px;
        background: var(--bg);
        border-left: 1px solid var(--contrast-5);
        border-right: 1px solid var(--contrast-5);
        opacity: 0;
        top: -20px;
        height: calc(100% + 20px);
        overflow-y: hidden;
        z-index: 2;
    }

    .employee-hours.show {
        left: calc((230px + 30px));
        opacity: 1;
    }

    .show .employee-data {
        transition: 0s;
        pointer-events: initial;
    }
    .time-table {
        position: fixed;
        left: calc(100vw);
        height: calc(100vh - 115px);
        padding: 15px 0;
        padding-top: 5px;
        width: 237px;
        background: var(--bg);
        border-left: 1px solid var(--contrast-5);
        -webkit-transition: .2s;
        transition: .2s;
        opacity: 0;
        /* bottom: 0; */
        top: 144px;
        overflow-y: scroll;
        z-index: 2;
    }

    .time-table{
        width: calc(100vw - 200px);
        background: var(--bg);
        opacity: 1;
        padding-bottom: 70px;
    }

    .time-table .table{
        position: relative;
        width: calc(100%);
        float: left;
        height: 50px;
        top: 40px;
        overflow: hidden;
    }
    .show-unassigned .time-table .table{
        width: calc(100% - 300px);
    }

    .time-table .table:last-child{
        margin-bottom: 20px;
    }


    .employee-data.show {
        left: calc((230px + 10px));
        opacity: 1;
    }


    .time-table.show
    {

        left: calc(200px);
    }

    .employee-data > * {
        border-bottom: 1px solid var(--contrast-5);
    }

    .employee-data > *:first-child {
        border-bottom: none;
    }

    .employee-data > .employee {
        height: 90px;
        padding-left: 75px;
        opacity: 1 !important;
    }

    .employee-data > .employee .picture {

        height: 65px;
        width: 65px;
        border-radius: 12px;
        left: -1px;
    }

    .employee-data > .employee .progressbar {
        width: 115px;
        left: initial;
        top: 60px;
    }

    .employee-data > .employee .bonus {
        position: absolute;
        top: 43px;
        left: 73px;
    }

    .employee-data > .employee .bonus .entry {
        margin: 0;
        height: 10px
    }

    .employee-data > .employee .bonus .left {
        font-size: 10px;
        width: 60px;
        float: left;
        text-align: left;
    }

    .employee-data > .employee .bonus .right {
        font-size: 10px;
        float: right;
        width: 44px;
        text-align: left;
    }

    .employee-data > .employee .slideshow {
        position: absolute;
        text-align: center;
        top: 61px;
        left: 17px;
    }

    .employee-data > .employee .slideshow .marker {
        background: var(--contrast-2);
        position: relative;
        display: inline-block;
        border-radius: 100px;
        height: 5px;
        width: 5px;
        margin: 0 2px;

    }

    .employee-data > .employee .slideshow .marker.selected {
        background: #6d8d23;
    }

    .employee-data > .employee .namefirst {

        font-size: 17px;
    }

    .employee-data > .employee .namelast {

        font-size: 18px;
    }

    .employee-data .entry .label {
        float: left;
        color: var(--contrast-5);
        font-size: 11px;
        padding-top: 3px;
    }

    .employee-data .entry .icon {
        float: right;
        background: var(--contrast-4);
        height: 15px;
        width: 15px;
        margin-top: 2px;
        border-radius: 100px;
        margin-right: 2px;
    }

    .employee-data .entry .icon.send {
        height: initial;
        width: initial;
        border-radius: 100px;
        color: var(--bg);
        font-size: 12px;
        padding: 3px 8px;
    }

    .employee-data .entry > .fas, .employee-data .entry > .fa-stack{
        margin-top: 4px;
        margin-right: 5px;
    }

    .employee-data .entry > .fas, .employee-data .entry > .fa-stack{
        float: right;
    }

    .employee-data .store .entry > .fas, .employee-data .store .entry > .fa-stack{
        float: left;
    }

    .checkbox.false:before{
        content: "\f111";
    }

    .employee-data .entry {
        margin: 1px 0;
    }

    .employee-data .section {
        margin-bottom: 5px;
    }

    .employee-data > .title .label {
        font-weight: 700;
        font-size: 14px;
        color: #6d8d23;
        float: right;
        transform: translateY(2px);
    }



    .disabled {
        cursor: none !important;
        pointer-events: none !important;
        opacity: .3 !important;
    }

    .entry {

        float: left;
        width: 100%;
        display: inline-block;
    }


    .section .entry {
        float: none;
    }

    .icon.dropdownmarker:after {
        display: inline-block;
        content: '\276F';
        transform: rotate(90deg) translateX(-20%) translateY(-4%);
        color: var(--bg);
        font-size: 11px;
    }

    .icon.leftmarker:after {
        display: inline-block;
        content: '\276F';
        transform: scaleX(-1) translateX(0%) translateY(-16%);
        color: var(--bg);
        font-size: 11px;
    }

    .icon.rightmarker:after {
        display: inline-block;
        content: '\276F';
        transform: translateX(0%) translateY(-16%);
        color: var(--bg);
        font-size: 11px;
    }

    .icon.plus:after {
        display: inline-block;
        content: '+';
        color: var(--bg);
        font-weight: 400;
        transform: translateX(-7%) translateY(-8%);
        font-size: 15px;
    }

    .icon.ticked:after {
        display: inline-block;
        content: '✔';
        color: var(--bg);
        font-weight: 400;
        transform: translateX(-0%) translateY(-20%);
        font-size: 11px;
    }

    .icon.menu {

        background: none !important;
    }

    .icon.menu:after {
        display: inline-block;
        content: '☰';
        color: var(--contrast-6);
        font-weight: 800;
        transform: translateX(-0%) translateY(-25%);
        font-size: 19px;
    }


    .mockup {
        position: fixed;
        top: 0;
        left: 0;
        height: 1080px;
        width: 1920px;
        background-size: 100%;
        opacity: .5;
        z-index: 10000;
        pointer-events: none;
        display: none;
    }

    .drag.Green {
        background: #6d8d23;
    }

    .drag.Yellow {
        background: #e3c423;
    }

    .drag.Sick {
        background: var(--contrast-1) url('~@/assets/sick.png');
        background-size: 60%;
        background-position: 50%;
        background-repeat: no-repeat;
        box-shadow: inset 0 0 00px 5px #e5154f;
    }

    .drag.Sick * {
        display: none;
    }

    .drag.Vacations {
        background: var(--contrast-1) url('~@/assets/vacation.png');
        background-size: 60%;
        background-position: 50%;
        background-repeat: no-repeat;
        box-shadow: inset 0 0 00px 5px #e76e13;
    }

    .drag.Vacations * {
        display: none;
    }

    .drag.Remove {
        background: var(--contrast-3);
    }
    .entry.half {
        width: 50%;
    }

    .entry.half .label {
        float: left;
        text-align: left;
    }

    .entry.half .label:nth-child(3) {
        padding-left: 10px;
    }

    .entry.half .icon {
        float: left;
    }

    .entry.half .icon:nth-child(4), .entry.half .send {
        float: right;
    }

    .entry.half .fa-stack{
        float: right;
    }

    .icon.left {
        float: left !important;
    }


    .icon.right {
        float: right !important;
    }

    .addperson {
        background: var(--contrast-2) !important;
        background: url('~@/assets/addperson.png') !important;
        background-size: 85% !important;
        background-position: 50% 50% !important;
    }

    .graph {
        background: var(--contrast-2) !important;
        background: url('~@/assets/graph.png') !important;
        background-size: 85% !important;
        background-position: 50% 50% !important;
    }

    .calendar {
        background: var(--contrast-4) url('~@/assets/calendar.png') !important;
        background-size: 60% !important;
        background-position: 50% !important;
        background-repeat: no-repeat !important;

    }

    .addtimeslot {
        background: var(--contrast-2) url('~@/assets/addtimeslot.png') !important;
        background-size: 85% !important;
        background-position: 50% 50% !important;
        background-repeat: no-repeat !important;
    }

    .managetimeslots {
        background: var(--contrast-2) !important;
        background: var(--contrast-2) url('~@/assets/managetimeslots.png') !important;
        background-size: 85% !important;
        background-position: 50% 50% !important;
        background-repeat: no-repeat !important;
    }

    .scanid {
        background: var(--contrast-2) !important;
        background: var(--contrast-2) url('~@/assets/scanid.png') !important;
        background-size: 75% !important;
        background-position: 50% 50% !important;
        background-repeat: no-repeat !important;
    }

    .vacation {
        background-size: 80% !important;
        background-position: 50% !important;
        background-repeat: no-repeat !important;
    }

    .icons-calender .calendar {
        filter: saturate(0%);
        transition: .2s;
        width: 25px !Important;
        height: 25px !Important;
        margin-top: 00px !important;
        margin-bottom: 5px !important;
        margin-left: 4px !important;
        margin-right: 3px !important;

        border-radius: 3px !important;
    }

    .icons-calender .calendar:hover {
        filter: saturate(100%);
    }

    .icons-calender .dropdownmarker {

        width: 15px !important;
        height: 15px !important;
        border-radius: 100px !important;
        position: absolute;
        margin-top: 8px !important;
        margin-left: -17px !important;
        background: var(--contrast-5);
    }

    .icons-calender .leftmarker, .icons-calender .rightmarker {

        width: 20px !important;
        height: 20px !important;
        border-radius: 100px !important;
        background: var(--contrast-5);
    }

    .icons-calender .leftmarker:after {

        transform: translateX(55%) translateY(-09%) scaleX(-1) !important;
    }

    .icons-calender .rightmarker:after {

        transform: translateX(55%) translateY(-10%) !important;
    }

    .icons-calender .dropdownmarker:after {

        display: inline-block;
        content: '\276F';
        -webkit-transform: rotate(90deg) translateX(-40%) translateY(-1%);
        transform: rotate(90deg) translateX(-65%) translateY(-23%);
        color: var(--bg);
        font-size: 11px;
    }




    .fa-stack {
        cursor: pointer;
        width: 15px;
        height: 15px;
    }
    .fa-stack.add {
        cursor: pointer;
        width: 15px;
        height: 15px;
    }

    .fa-stack.time-pick {
        position: absolute;
        margin-top: 21px;
        margin-left: -18px;
        width: 15px;
        height: 15px;
    }

    .fa-stack * {
        font-size: 16px;
    }
    .fa-stack.add * {
        font-size: 16px;
    }


    .fa-stack.time-pick * {
        font-size: 14px;
    }

    .fa-stack .fa-circle {
        color: var(--contrast-5);
    }
    .fa-stack.add .fa-circle {
        color: var(--contrast-5);
    }

    .fa-stack .fa-plus{
        transform: scale(.7) translateX(1px);
    }
    .fa-stack.add .fa-plus{
        transform: scale(.7) translateX(1px);
    }

    .entry.half .icon.send{
        margin-top: 4px;
        margin-bottom: -4px;
    }

    .app {
    }


    .app .scrollbar-container{
        top: initial;
        height: 100%;
        width: calc(100vw);
    }


    .app .scrollbar-container.show{
        width: calc(100vw - 1px);
        /*left: 88px;*/
    }

	.app.loading-roster > *{
		filter: blur(1px);
	}
  @keyframes spin {
    from {
      transform:rotate(0deg);
    }
    to {
      transform:rotate(360deg);
    }
  }

  .day.fade-in,.employee.fade-in{
  opacity: 1;
    /*animation-name: fade-in;
    animation-duration: 200ms;
    animation-timing-function: ease-out;*/
  }

    .employees.faded-in .employee{
        opacity: 1;
    }

  .preload{
    pointer-events: none;
  }
  .grid.preload{
    overflow:hidden;
    opacity: 0;
  }


  .preload .day, .preload .employee{
	opacity: 1;
  }

  .preload .entry:not(.header) .day{

	/*background: rgb(169, 169, 169);*/
	}

	.preload .employee{
		margin: 0;

    margin-top: -1px;
    transform: translateY(1px);
	}

  /*.preload .fade-out,.preload .fade-out{
  opacity: 0;
    animation-name: fade-out;
    animation-duration: 200ms;
    animation-timing-function: ease-out;
  }*/
  .preload .day.fade-out{

    opacity: 0;
    animation-name: fade-out !important;
    animation-duration: 200ms !important;
    animation-timing-function: ease-out !important;
  }


  .preload .fade-out .header .label{
    animation: fade-out-label forwards;
        animation-delay: 100ms;
        animation-duration: 500ms;
    animation-timing-function: ease-out;
  }
  .preload .fade-out .header .fa-stack{
        animation: fade-out-label-stack forwards;
        animation-delay:100ms;
        animation-duration: 500ms;
        animation-timing-function: ease-out;
     }

  @keyframes fade-out-label {
    from {
       opacity: 1;
       transform: translateX(0px);
    }
    to {
       transform: translateX(300px);
       opacity: 0;
    }
  }

  @keyframes fade-out-label-stack {
    from {
       opacity: 1;
        right: 5px;
    }
    to {
        right: -100px;
       opacity: 0;
    }
  }

  @keyframes fade-in {
    from {
	opacity: 0;
      transform:translateX(-30px) translateY(-30px);
    }
    to {
	opacity: 1;
      transform:translateX(0px) translateY(0px);
    }
  }
  @keyframes fade-out {
    from {
	opacity: 1;
    }
    to {
	opacity: 0;
    }
  }

  .day.out-of-range{
    opacity: .5 !important;
    /*pointer-events: none; */
  }
  .day.unavailable{
    opacity: .5 !important;
    pointer-events: none;
  }
  .day.in-range{
    opacity: 1 !important;
  }

    .day i{
        position: absolute;
        font-size: 12px;
        right: -3px;
        bottom: -3px;
        z-index: 1;
        border-radius: 100px;
    }
    .day .spot-icon{
        position: absolute;
        font-size: 12px;
        left: -1px;
        bottom: -1px;
        z-index: 1;
        height: 8px;
        width: 8px;
        border-radius: 100px;
        border: 1px solid #6d8d23;
    }
    .day .pin-icon{
        position: absolute;
        font-size: 12px;
        left: -5px;
        top: -5px !important;
        padding: 2px;
        width: 13px;
        height: 14px !important;
        z-index: 1;
        border-radius: 100px;
        transform: scale(0.7);

    }
    .day .fa-eye-slash{
        position: absolute;
        font-size: 12px !important;
        right: -5px !important;
        top: -5px !important;
        padding: 1px;
        width: 16px;
        height: 16px !important;
        z-index: 1;
        border-radius: 100px;
        transform: scale(0.7);
    }
    .day .exclamation{
        position: absolute;
        font-size: 10px !important;
        right: -5px !important;
        top: -5px !important;
        padding: 1px;
        width: 14px;
        height: 14px !important;
        z-index: 1;
        border-radius: 100px;
        transform: scale(0.7);
    }
    .day .fa-exclamation:before{
        position: absolute;
        left: 5px;
    }
    .day .confirmed.fa-lock{
        position: absolute;
        font-size: 12px !important;
        right: -7px !important;
        top: -7px !important;
        padding: 2px 0px 0px 3px;
        width: 20px;
        height: 20px !important;
        color: var(--col-label-default);
        border: 2px solid var(--md);
        background: var(--bg) !important;
        z-index: 1;
        border-radius: 100px;
        transform: scale(0.7);
    }
    .day .bottom-right.fa-thumbs-up{
        position: absolute;
        font-size: 12px !important;
        right: -6px !important;
        bottom: -6px !important;
        padding: 2px 0px 0px 3px;
        width: 18px;
        height: 18px !important;
        background: #879d53 !important;
        z-index: 1;
        border-radius: 100px;
        transform: scale(0.7);
    }
    .day .bottom-right.fa-tilde{
        position: absolute;
        font-size: 12px !important;
        right: -6px !important;
        bottom: -6px !important;
        padding: 2px 0px 0px 3px;
        width: 18px;
        height: 18px !important;
        background: #879d53 !important;
        z-index: 1;
        border-radius: 100px;
        transform: scale(0.7);
    }
    .day .bottom-right.fa-thumbs-down{
        position: absolute;
        font-size: 12px !important;
        right: -6px !important;
        bottom: -6px !important;
        padding: 4px 0px 0px 3px;
        width: 18px;
        height: 18px !important;
        background: #879d53 !important;
        z-index: 1;
        border-radius: 100px;
        transform: scale(0.7);
    }
    .day .bottom-right.fa-birthday-cake{
        position: absolute;
        font-size: 12px !important;
        right: -6px !important;
        bottom: -6px !important;
        padding: 2px 0px 0px 3px;
        width: 18px;
        height: 18px !important;
        background: #879d53 !important;
        z-index: 1;
        border-radius: 100px;
        transform: scale(0.7);
    }
    .day .bottom-right.fa-sack{
        position: absolute;
        font-size: 12px !important;
        right: -6px !important;
        bottom: -6px !important;
        padding: 2px 0px 0px 3px;
        width: 18px;
        height: 18px !important;
        background: #879d53 !important;
        z-index: 1;
        border-radius: 100px;
        transform: scale(0.7);
    }
    .day .lock-icon{
        position: absolute;
        font-size: 9px !important;
        left: -4px;
        top: -5px !important;
        width: 13px;
        height: 14px !important;
        padding-left: 3px;
        padding-top: 1px;
        z-index: 1;
        border-radius: 100px;
        transform: scale(0.7);
    }

    .header .spot-icon{
        position: absolute;
        font-size: 12px;
        right: 37px;
        top: 2px;
        z-index: 1;
        height: 14px;
        width: 14px;
        transform: scale(0.95);
        border-radius: 100px;
    }


    .helper-badge{
        position: absolute;
        left: 0px !important;
        margin-left: -1px;
        top: 29px;
        width: 11px !important;
        height: 11px !important;
        z-index: 1;
        background-color: #c1c1c1 !important;
        color: #fff;
        font-size: 7px;
        font-weight: bold;
        line-height: 11px;
        text-align: center !important;
        border-radius: 30px;
    }

    .day .desired-icon{
        position: absolute;
        font-size: 10px;
        left: -1px;
        bottom: -1px;
        z-index: 1;
        height: 10px;
        width: 10px;
        border-radius: 0px;
        border: none;
        color: #5f5f5f;
    }
    .day .undesired-icon{
        position: absolute;
        font-size: 10px;
        left: -1px;
        bottom: -1px;
        z-index: 1;
        height: 10px;
        width: 10px;
        border-radius: 0px;
        border: none;
        color: #5f5f5f;
    }


    .day.Green i{
    position: absolute;
    font-size: 12px;
    right: -3px;
    top: -3px;
    z-index: 1;
    height: 12px;
    border-radius: 100px;
    }


    .day i:nth-child(2){
    top: 8px;
    }
    .day i:nth-child(3){
    top: -3px;
    }


    .time-table .time-bar-new{
    top: -10px;
    overflow: hidden;
    height: 57px;
    width: calc(100% - 10px);
    z-index: initial;
    }

    .shifts .time-bar-new{
    top: 0;
    overflow: hidden;
    width: 100%;
    border-radius: 10px;
    height: 60px;
    padding-top: 10px;
      background: var(--bg);
    }
    .shifts .shift.selected .time-bar-new{
        box-shadow: 4px 4px 5px 3px rgba(0,80,0,0.2);
    }
    .has-header .shifts{
        height: calc(100% - 2* var(--header-height));
        top: calc(2* var(--header-height));
    }
    .has-header > .has-header .shifts{
        height: calc(100% - 3* var(--header-height));
        top: calc((2* var(--header-height)) + var(--tab-menu-height));
    }
    .shifts{
        position: fixed;
        right: -300px;
        width: 300px;
        height: 100%;
        top: 0px;
        background: var(--bg);
        z-index: 10;
        padding: 10px 0;
        transition: .2s;
    }
    .shifts .scroll-list{
        height: calc( 100% - 75px);
        margin-top: 50px;
        overflow-y: auto;
        padding: 0 10px;
    }

    .show-unassigned .shifts{
    right: 15px;
    }

    .shifts-toggle{
    width: 30px;
    height: 30px;
    position: fixed;
    right: 15px;
    cursor: pointer;
    font-weight: 600;
    color: rgba(0,0,0,.3);
    transition: .2s;
    margin-top: -3px;
    }

    .show-unassigned .shifts-toggle{
    right: 285px;
    transform: scaleX(-1);
    }

    .shifts .label{
    width: calc(100% - 10px);
    text-align: center;
    font-size: 16px;
    height: 36px;
    box-shadow: inset 0 -2px 0 -1px rgba(0,0,0,.3);
    }

    .shifts .shift{
        position: relative;
        /* width: 100%; */
        float: left;
        margin-top: 5px;
        margin-right: 5px;
    }

    .shifts .shift.add{
        cursor: pointer;
        width: calc(100% - 10px);
        margin-left: 5px;
        margin-bottom: 20px;
    }

    .shifts .shift > .label{
    background: var(--bg);
    -webkit-box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
    box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
    border-radius: 10px;
    font-weight: 200;
    line-height: 210%;
    pointer-events: none;
    }

    .event-marker{

                                    display: inline-block;
                                    height: 0;
                                    width: 0;
                                    font-size: 9px;
                                    text-align: center;
                                    padding-top: 2px;
        bottom: 2px;
        left: -2px;
        position: absolute;
        line-height: 110%;
        cursor: default;
        height: 13px;
        width: 10px;
        z-index: 1;
    }


    .header .day.unnassigned
    {
/*background: rgb(255, 255, 185);*/
  }

  .today-box{
    display: none;
  }

  .header .day.today .today-box
  {
    display: initial;
    position: absolute;
    background: #6d8d23;
    bottom: 2px;
    right: -6px;
    height: calc(100% + 4px);
    width: calc(100% + 12px);
    z-index: -1;
    border-radius: 0;
  }

  .header .day.hovered {
    margin-bottom: 4px;
    background: var(--contrast-1) !important;
  }

  .header .day.today *:not(.income) :not(.key-figure)
  {
    color: white;
  }
  .header .day .unnassigned-marker
  {
    display: none;
  }
  .header .day.unnassigned .unnassigned-marker
  {
      display: inline-flex;
      background: rgb(238, 238, 59);
      border-radius: 50px;
      height: 14px;
      width: 14px;
      font-size: 8px;
      text-align: center;
      padding-top: 2px;
      top: 5px;
      right: -2px;
      position: absolute;
      line-height: 10px;
      z-index: 10;
      justify-content: center;
  }
  .header .day.today.unnassigned .unnassigned-marker
  {
    background: rgb(193, 224, 119);
    color: black;
  }

  .day.border-red{
    box-shadow: 0 0 0 2px rgba(155, 0, 0, .5);
  }
  .day.border-green{
    box-shadow: 0 0 0 2px rgba(0, 180, 0, .3);
  }
  .day.border-yellow{
    box-shadow: 0 0 0 2px rgba(220, 200, 0, .7);
  }

  .table.border-red{
    box-shadow: inset 0 0 0 100px rgba(155, 0, 0, .5);
  }
  .table.border-green{
    box-shadow: inset 0 0 0 100px rgba(155, 0, 0, .5);
  }
  .table.border-yellow{
    box-shadow: inset 0 0 0 100px rgba(155, 0, 0, .5);
  }
    .grid .table{
        display: none;

        left: 0px;
    }

    .grid .table .time-bar-new{
        height: 50px;
        margin-top: -9px;
    }

    .day-mode .grid .table{
        position: absolute;
        left: 280px;
        display: initial;
        overflow: hidden;
        background: var(--bg);
        margin-top: 0px;
        box-shadow: inset 0 2px 0 -1px var(--grid-shadow);
    }
    .day-mode .grid .entry:not(.header){
        /* box-shadow: inset 0 2px 0 -1px var(--grid-shadow); */
    }
    .day-mode .grid .entry:last-child{
        /* box-shadow: inset 0 2px 0 -1px var(--grid-shadow), inset 0 -2px 0 -1px var(--grid-shadow); */
    }
    .day-mode .grid .entry:last-child .table{
        box-shadow: inset 0 2px 0 -1px var(--grid-shadow), inset 0 -2px 0 -1px var(--grid-shadow);
        height: 50px;
    }
    .day-mode .grid .entry.group{
        box-shadow: none;
    }

    .has-header .hour-grid{
        top: calc(20px + 2*var(--header-height));
    }

    .has-header > .has-header .hour-grid{
        top: calc(20px + (2* var(--header-height)) + var(--tab-menu-height));
    }

    .hour-grid{
        position: fixed;
        right: 10px;
        top: 20px;
        width: calc(100vw - (240px + 10px + 10px));
        height: 100%;
        z-index: 1;
        padding: 30px 10px 0;
    }

    .hour-grid.labels{
        z-index: 10;
        height: 90px !important;
    }

    .show .hour-grid{
        width: calc(100vw - (240px + 10px + 237px + 10px));
        right: 10px;
    }
    .show.show-unassigned .hour-grid{
        width: calc(100vw - (240px + 10px + 300px + 10px + 237px));
        right: calc(300px + 10px);
    }
    .show-unassigned .hour-grid{
        width: calc(100vw - (240px + 10px + 300px + 10px));
        right: calc(300px + 10px);
    }
    .day-mode .grid .table{
        width: calc(100vw - (240px + (10px * 4)));
        left: calc(220px + (10px * -1));
    }
    .day-mode .grid.show .table{
        width: calc(100vw - (240px + (10px * 4) + 237px));
        left: calc(220px + (10px * -1) + 237px);
    }
    .day-mode .show-unassigned .grid.show .table{
        width: calc(100vw - (230px + (10px * 4) + 237px + 300px + 10px));
        left: calc(220px + (10px * -1) + 237px);
    }
    .day-mode .show-unassigned .grid .table{
        width: calc(100vw - (220px + (10px * 4) + 300px + 20px));
        left: calc(220px + (10px * -1));
    }

    .show-unassigned.hour-grid-group{
        width: calc(100vw - (280px + 300px));
    }
    .hour-grid-group{
        position: absolute;
        width: calc(100vw - (280px));
        height: 70px;
        z-index: 5;
        margin-top: -18px;
        /* padding-left: 260px; */
    }
    .hour-grid-group > .time-marks{
        height: 100%;
    }

    .time-marks{
        width: 100%;
        height: calc(100% - 180px);
        display: inline-block;
    }

    .hour-grid.labels .time-marks{
        height: 100% !important;
    }

    .time-marks .group{
        position: absolute;
        top: -20px;
        left: -15px;
        width: 30px;
        text-align: center;
    }

    .time-marks .label{
        position: absolute;
        top: -20px;
        left: -15px;
        width: 30px;
        text-align: center;
    }

    .time-marks .mark{
        text-align: center;
        position: relative;
        float: left;
        width: calc(100% / 24);
        height: 100%;
        display: inline-block;
        box-shadow: inset 2px 0px 0 -1px var(--contrast-1);
        background: none;
        white-space: nowrap;
    }

    .time-marks .mark.day-split{
        box-shadow: inset 3px 0px 0 -1px  var(--contrast-4);
    }

    .hour-grid.full-two .time-marks .mark{
        width: calc(100% / 48);
    }
    .hour-grid.full-half .time-marks .mark{
        width: calc(100% / 36);
    }
    .hour-grid.full .time-marks .mark{
        width: calc(100% / 24);
    }
    .hour-grid.half .time-marks .mark{
        width: calc(100% / 12);
    }
    .hour-grid.quarter .time-marks .mark{
        width: calc(100% / 6);
    }

    .hour-grid-group.full-two .time-marks .mark{
        width: calc(100% / 48);
    }
    .hour-grid-group.full-half .time-marks .mark{
        width: calc(100% / 36);
    }
    .hour-grid-group.full .time-marks .mark{
        width: calc(100% / 24);
    }
    .hour-grid-group.half .time-marks .mark{
        width: calc(100% / 12);
    }
    .hour-grid-group.quarter .time-marks .mark{
        width: calc(100% / 6);
    }
    /* .hour-grid-group.full-two .time-marks .mark:last-child{
        width: calc((100% / 48) - 1px);
    }
    .hour-grid-group.full-half .time-marks .mark:last-child{
        width: calc((100% / 36) - 1px);
    }
    .hour-grid-group.full .time-marks .mark:last-child{
        width: calc((100% / 24) - 1px);
    }
    .hour-grid-group.half .time-marks .mark:last-child{
        width: calc((100% / 12) - 1px);
    }
    .hour-grid-group.quarter .time-marks .mark:last-child{
        width: calc((100% / 6) - 1px);
    } */

    .time-marks .mark.am{
    }
    .time-marks .mark .quarter{
        position: relative;
        display: inline-block;
        width: 8px;
        border-radius: 100px;
        height: 8px;
        margin: 0 1px;
    }
    .full-half .mark .quarter{
        width: 6px;
        height: 6px;
        margin: 0 1px;
    }
    .full-two .mark .quarter{
        width: 5px;
        height: 5px;
        margin: 0 1px;
    }


    .hour-grid.labels .mark{
        box-shadow: inset 2px 0px 0 -1px var(--contrast-1);
        background: var(--bg);
    }

    .red{
        background: #e51c50;
    }

    .orange{
        background: #e86d1d;
    }

    .green{
        background: #6d8d23;
    }

    .gray{
        background: #ccc;
    }

    .entry.group{
        height: initial;
        width: 100vw;
        position: relative;
        margin-left: -210px;
        padding-left: 210px;
        padding-bottom: 05px;
        /*transition: .2s;*/
        top: 25px;
    }

    .entry.group.collapsed{
        height: 25px;
        padding-bottom: 0px;
    }
    .entry.group > .header{
        width: 255px;
        height: 40px;
        margin-bottom: -16px;
        -webkit-transform: translateY(4px);
        transform: translateY(4px);
        overflow: hidden;
        position: absolute;
        left: -45px;
        z-index: 10;
        margin-left: 0;
        margin-top: -24px;
        transition: 0s;

    }

    .business-sort .entry.group:not(.business) > .header{
        height: 40px;
        margin-left: -230px;
    }

    .entry.group.collapsed > .header{
    }

    .indentationLevel0{
        width: 100%;
    }
    .indentationLevel1{
        width: 90%;
        margin-left: 10%;
    }
    .entry.group > .header .label{
        /* h-employee-groups */
        color: #efefef;
        background: #6d8d23;
        font-size: 13px;
        border-top-left-radius: 100px;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
        border-bottom-left-radius: 100px;
        padding: 0 20px;
        height: 19px;
        margin-top: 0px;
        transition: .2s;
    }
    .entry.group.collapsed > .header .label{
        background: var(--contrast-6);
    }

    .entry.group.collapsed > .header .helper{
        background: var(--bg);
        border: dashed 1px var(--contrast-5);
        margin-top: 0px;
        color: var(--contrast-4);
    }
    .entry.group.collapsed > .header .helperDroppable{
        background: var(--contrast-2);
        border: solid 1px var(--contrast-5);
        margin-top: 0px;
        color: var(--contrast-4);
    }

    .entry.group > .entry{
    }
    .entry.group.collapsed > .entry{
    }

    .entry.group > .header .fa-stack.add{
        position: absolute;
        bottom: 24px;
        right: 13px;
        transform: scale(0.8);
        transition: .4s;
    }

    .entry.group > .header .fa-stack.add .fa-circle{
        color: #efefef;
    }
    .entry.group > .header .fa-stack.add .fa-plus{
        color: #6d8d23;
    }
    .entry.group.collapsed > .header .fa-stack.add .fa-circle{
        color: #efefef;
    }
    .entry.group.collapsed > .header .fa-stack.add .fa-plus{
        color: #898989;
    }


    .entry.group > .header .fa-stack{
        position: absolute;
        bottom: 9px;
        right: 5px;
        transform: scale(0.8);
        transition: .4s;
    }
    .entry.group > .header .fa-stack.new{
        right: 22px;
    }
    .entry.group > .header .fa-stack .fa-circle{
        color: #efefef;
    }
    .entry.group > .header .fa-stack .fa-angle-down, .entry.group > .header .fa-stack .fa-angle-up, .entry.group > .header .fa-stack .fa-plus{
        color: #6d8d23;
    }
    .entry.group.collapsed > .header .fa-stack .fa-circle{
        color: #efefef;
    }
    .entry.group.collapsed > .header .fa-stack .fa-angle-down, .entry.group.collapsed > .header .fa-stack .fa-angle-up, .entry.group > .header .fa-stack .fa-plus{
        color: #898989;
    }
    .grid:not(.preload) .entry.group > .entry{
        /*animation-name: unfold;
        animation-duration: 300ms;
        animation-timing-function: ease-out;*/
    }

    .entry.group > .header > .label .fa-stack{
        position: absolute;
        left: 2px;
        bottom: 7px;
        transition: .4s;
        cursor:grab;
    }
    .entry.group > .header > .label.indentationLevel1 .fa-stack{
        left: 5px;
    }
    .entry.group > .header > .label  .fa-stack .fa-circle{
        color: transparent;
    }
    .entry.group > .header > .label  .fa-stack .fa-arrows-alt{
        font-size: 14px;
        color: #efefef;
    }
    .entry.group.collapsed > .header > .label  .fa-stack .fa-circle{
        color: var(--contrast-6);
    }
    .entry.group.collapsed > .header > .label  .fa-stack .fa-arrows-alt{
        color: #898989;
    }

  @keyframes unfold {
    from {
        margin-top: -50px;
    }
    to {
      margin-top: 0px;
    }
  }

    .return{
        position: fixed;
        left: 270px;
        margin-top: -5px;
        z-index: 4;
    }
    .return.forward{
        position: absolute;
        right: 360px;
        margin-top: 0;
        top: 5px;
        left: initial;
    }
    .show-unassigned .return.forward{
        right: 320px;
    }

    .return .fa-stack{
        transform: scale(1.5);
        transition: .2s;
    }
    .return .fa-stack .fa-circle{
        color: var(--contrast-6);
    }

    .fa-refresh:before{
        content: '\f021';
    }
    .header.day-mode{
        background: var(--contrast-1);
        padding-left: 100px;
    }
    .header.day-mode .icons-weekly{
        font-size: 18px;
    }
    .header.day-mode .icons-weekly .icon{
        font-size: 12px;
        height: 27px !important;
        width: 43px !important;
        display: inline-block;
    }
    .header.day-mode .icons-weekly .icon:hover{
        color: var(--bg);
        background: #6d8d23;
    }
    .header.day-mode .user{

    }
    .header.day-mode .refresh{

    }
    .header.day-mode .fas{

        color: var(--contrast-5);
    }
    .header.day-mode .fa-stack:hover .fa-circle{
        color: #6d8d23 !important;
    }
    .header.day-mode .fa-stack:hover{
        background: #6d8d23 !important;
    }
    .header.day-mode .fa-circle{
        font-size: 30px;
        color: var(--contrast-2);
        opacity: 0;
    }

    .loading-roster .dropdown-search.employee-sort{
        z-index: 0;
    }

    .employee-filter{
        display: inline-block;
        text-align: center;
        width: 32px;
        cursor: pointer;
        top: -5px;
        margin-left: -240px;
        margin-right: 37px;
        z-index: 3;
    }
    .plannedActual-switcher{
        display: inline-block;
        text-align: center;
        width: 32px;
        cursor: pointer;
        top: -5px;
        z-index: 3;
        margin-left: 120px;
    }
    .plannedActual-switcher-aktuell{
        display: inline-block;
        text-align: center;
        width: 60px;
        cursor: pointer;
        font-size:9px;
        font-weight: 200;
        top: -11px;
        z-index: 3;
        margin-left: 0px;
        line-height: 20px;
        height: 20px;
    }
    .plannedActual-switcher-aktuell .label{
        font-size:9px !important;
    }


    .first-button{
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        width: 90px;
        cursor: pointer;
        top: -12px;
        z-index: 3;
        margin-left: -27px;
        line-height: 20px;
        font-size:9px;
        height: 20px;
        font-weight: 200;
    }
    .first-button .label{
        font-size:9px !important;
        vertical-align: middle;
        height: 20px !important;
        line-height: 19px !important;
        width: 80px !important;
    }


    .second-button{
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        width: 90px;
        cursor: pointer;
        top: -12px;
        z-index: 3;
        margin-left: 3px;
        line-height: 20px;
        font-size:9px;
        height: 20px;
        font-weight: 200;
    }
    .second-button .label{
        font-size:9px !important;
        vertical-align: middle;
        height: 20px !important;
        line-height: 19px !important;
        width: 80px !important;
    }

    .plannedActual-active {
        background: #6d8d23;
    }
    .plannedActual-active * {
        color: var(--bg);
    }


    .loading-roster .employee-filter, .loading-roster .positions-filter, .loading-roster .plannedActual-switcher{
        z-index: -1;
    }

    .dropdown-search.employee-sort{
        position: absolute;
        width: 200px;
        left: 10px;
        margin-top: 10px;
    }
    .dropdown-search:not(.employee-sort){
        opacity: 0;
        pointer-events: none;
    }

    .button.month-only.toggled {
        background: #6d8d23 !important;
    }
    .button.month-only.toggled .label{
        color: white !important;
    }
    .button.month-only.toggled:hover {
        background: #efefef !important;
    }
    .button.month-only.toggled:active {
        background: #6d8d23 !important;
    }
    .button.month-only.toggled:hover  .label{
        color: #404040 !important;
    }

    .entry > .table.border-red{

        box-shadow: inset 0 0 1px 2px rgb(229, 28, 80);
        background: rgba(229, 28, 80, .4);
    }
    .entry > .table.border-yellow{

        box-shadow: inset 0 0 1px 2px rgb(232, 109, 29);
        background: rgba(232, 109, 29, 0.5);
    }
    .entry > .table.border-green{

        box-shadow: inset 0 0 1px 2px rgb(108, 141, 37);
        background: rgba(108, 141, 37, 0.5);
    }

    .hour-grid.labels .amount{
        position: fixed;
        margin: auto;
        height: 30px;
        display: inline-block;
        background: var(--bg);
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,.2);
        color: var(--contrast-4);
        pointer-events: none;
        width: fit-content;
        padding: 5px;
        border-radius: 5px;
        opacity: 0;
    }


    .shift-template .entry.group .employee{
        left: 0px;
        width: 210px
    }
    .shift-template .entry.group .employee.template{
        left: -20px;
        width: 230px
    }

    .entry.group:last-child > .entry{
        margin-bottom: -1px !important;
    }

    .fa-stack.refresh.selected{
        background: #6d8d23;
        color: white;
    }
    .fa-stack.refresh.selected .fa-refresh{
        color: white;
    }

    .day-mode .grid .entry.header .day-outer{
        position: fixed;
        top: 62px;
        left: 0px;
        margin: 0;
        z-index: 10000 !important;
        background: var(--bg);
        border-radius: 0;
        width: 90px;
    }
    .day-mode .grid .entry.header .day-outer .day{
        position: fixed;
        left: 0px;
        margin: 0;
        margin-top: -5px;
        z-index: 10000 !important;
        background: var(--bg);
        border-radius: 0;
        width: 90px;
    }
    .day-mode .grid .entry.header .day-outer .day.today{

        width: 90px;
        background: #6d8d23;
        box-shadow: none;
    }

    .shift-template .entry.header .day-outer .day{
        display:none !important;
    }

    .day-mode .grid .entry.header .day-outer .day .shadow{
        position: absolute;
        height: 40px;
        width: 140px;
        -webkit-box-shadow: 0 0 1px 0 #808080;
        box-shadow: 0 0 1px 0 #808080;
        left: -50px;
        top: 0;
    }


    .day-mode .grid .entry.header .day-outer .day .weather{
        top: 0px;
        font-size: 10px;
        background: var(--bg);
        height: 25px;
        left: -50px;
        padding-top: 3px;
        padding-left: 1px;
        text-align: center;
        z-index: 1;
        display:none;
    }

    .day-mode .grid .entry.header .day-outer .day .income{
        bottom: 0px;
        left: -50px;
        background: var(--bg);
        display:none
    }

    .employee .fa-stack{
        position: absolute;
        right: 10px;
        top: 0;
        bottom: 0;
        margin: auto;
    }

    .employee .fa-stack.detail{
        cursor: pointer;
        font-size:25px;
        width:25px;
        height:25px;
        right:5px;
    }

    .employee .fa-stack.skill{
        cursor: pointer;
        font-size:25px;
        width:25px;
        height:25px;
        right:5px;
    }

    .employee .fa-stack.detail:hover .fa-circle{
        color: #6d8d23 !important;
    }

    .employee .fa-stack.detail:hover .fa-tasks-alt{
        color: #404040 !important;
    }


    .employee .fa-stack.user{
        position: absolute;
        right: 30px;
        top: 0;
        bottom: 0;
        margin: auto;
    }
    .employee .fa-stack > .fas:not(.fa-circle){
        transform: scale(.6);
    }
    .employee .fa-stack > .fa-user{
        transform: scale(.55) !important;
    }

    .grid .employee.hovered {
        background: var(--contrast-1);
        border-radius: 0;
        /* border-top-left-radius: 100px;
        border-bottom-left-radius: 100px; */
        /* box-shadow: none; */
    }

    .fa-stack.new, .fa-stack.add{
        cursor: pointer;
    }
    .fa-stack.new, .fa-stack.add > *{
        pointer-events: none;
    }

    .template .fa-stack.new{
        pointer-events: initial;
    }
    .template .fa-stack.new .fa-plus{
        transform: scale(0.4) translate(9px, -8px);
    }
    .template .fa-stack.new .fa-user{
        transform: scale(.5) translate(-1px, 0px) !important
    }

    .grid-header-backdrop{
        background: var(--bg);

        position: absolute;
        width: calc(230px + 10px);
        left: 0;
        /* margin-top: 10px; */
        cursor: pointer;
        z-index: 3;
        height: 45px;
    }
    .shift-template .grid-header-backdrop,.day-mode .grid-header-backdrop{
        width: calc(100vw);
    }

    .loading-roster .grid-header-backdrop{
        display: none;
    }

    .app > .navigate{
        position: absolute;
        top: 68px;
        left: 30px;
        z-index: 10;
        border: 1px solid var(--contrast-5);
        border-radius: 100px;
        height: 30px;
        width: 30px;
        cursor: pointer;
    }
    .app > .navigate *{
        color: var(--contrast-5);
        font-size: 25px;
        transform: translate(-1px, 1px);
        pointer-events: none;
    }

    .navigate:hover *{
        color: white;
    }

    .navigate:hover{
        background: #6d8d23;
    }

    .header > .preference{
        box-shadow: 0 0 0 1.4px  var(--contrast-5);
        border-radius: 100px;
        height: 30px;
        width: 30px;
        margin-right: 30px;
        margin-top: 3px;
    }
    .header > .preference *{
        color: var(--contrast-5);
        font-size: 18px;
        transform: translate(0px, 4px) rotate(90deg);
    }

    .header > .preference:hover *{
        color: white;
    }

    .header > .preference:hover{
        background: #6d8d23;
    }

    .employee-preference-view{

    }

    .hide{
        display: none !important;
    }

    .shift-template > *:not(.template-view){
        display: none;
    }
    .app > .template-view{
        display: none;
    }
    .shift-template > .template-view{
        display: inline-block;
        width: 100%;
        height: 100%;
    }

    .button.change-month{
        border: none;
        transform: scale(.6);
        box-shadow: none;
        margin-left: 3px;
        margin-right: 3px;
    }
    .button.reset-date{
        padding-left: 10px;
        padding-right: 10px;
    }

    .button.set-date{
        margin-left: 0px;
        margin-right: 0px;
    }

    .icon-counter{

    }

    .day .icon-container{
        position: absolute;
        left: 0;
        top: 0;
        height: 40px;
        width: 40px;
        overflow: hidden;
    }

    .day .icon-container .slot-bg{
        background:var(--contrast-1) !important;

    }

    .day .icon-container .clear-bg{
        background:var(--bg) !important;
    }

    .weekend-shadow{
        display:none;
    }

    .holiday-bg{
        display: none;
    }

    .day-outer[weekday="6"] .weekend-shadow, .day-outer[weekday="7"] .weekend-shadow{
        display: block;
        position: absolute;
        top: 0px;
        left: 0px;
        height: 75px;
        width: 51px;
        background: var(--contrast-2);
        /* opacity: .5; */
        z-index: -1;
    }

    .h-employee-groups[groupindex="0"] > :nth-child(2) > .week > .day-outer[weekday="6"] > .weekend-shadow,
    .h-employee-groups[groupindex="0"] > :nth-child(2) > .week > .day-outer[weekday="7"] > .weekend-shadow {
    /* .h-employee-groups .entry:first-of-type > .week > .day-outer[weekday="6"] > .weekend-shadow {*/
        top: -20px;
    }

    .day-outer .holiday-bg{
        display: block;
        position: absolute;
        top: 0px;
        left: 0px;
        height: 75px;
        width: 50px;
        background: var(--col-holiday-bg);
        /* opacity: .5; */
        z-index: -1;
    }

    .h-employee-groups[groupindex="0"] > :nth-child(2) > .week > .day-outer > .holiday-bg {
        top: -20px;
    }

    .day-outer .legal-check{
        display: block;
        position: absolute;
        top: 0px;
        left: 0px;
        height: 50px;
        width: 50px;
        /* opacity: .5; */
        z-index: -1;
    }

    .day-outer[weekday="6"] .day .icon-container .clear-bg, .day-outer[weekday="7"] .day .icon-container .clear-bg{
        background: var(--contrast-3) !important;
    }

    .entry:not(.header) .day-outer[weekday="6"] .day,.entry:not(.header) .day-outer[weekday="7"] .day{
        background: var(--contrast-0) !important;
     }

    .day-outer[weekday="6"] .day .icon-container .contains i,.day-outer[weekday="7"] .day .icon-container .contains i{
        color: white;
    }

    .nightmode .day-outer[weekday="6"] .day .icon-container .clear-bg,.nightmode  .day-outer[weekday="7"] .day .icon-container .clear-bg{
        background: #333 !important;
    }


    .nightmode .day-outer[weekday="6"] .weekend-shadow,.nightmode  .day-outer[weekday="7"] .weekend-shadow{

        background:  #333;
    }

    .nightmode .day-outer .holiday-bg{

        display: block;
        position: absolute;
        top: 0px;
        left: 0px;
        height: 75px;
        width: 51px;
        background: var(--col-holiday-bg);
        /* opacity: .5; */
        z-index: -1;
    }


    .weekend-cell:not(.today):before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 2rem;
        background: var(--contrast-2);
        box-shadow: 1px 0 0 0.37rem var(--contrast-2);
    }

    .nightmode .weekend-cell:not(.today):before {
        background: #333;
        box-shadow: 1px 0 0 0.37rem #333;
    }

    .day .icon-container div{
        display: none;
        float: left;
        width: 40px;
        height: 40px;
        left: 0;
        bottom:0;
        right:0;
        text-align:center;
        font-size: 10;
        padding-top:3px important;
        /*border-radius: 10px;*/
    }

    .day .icon-container .contains{
        display: inline-block;
    }

    .day .icon-container .contains i{
        display: inline-block;
        position:relative;
        top:0;
        left:0;
        bottom:0;
        right:0;
        font-size:25px;
        padding-top:8px;
        color: #ccc;
    }

    .day .icon-container .vacation i{
        display: inline-block;
        color:#dec92f !important;

    }

    .day .icon-container .holidayvacation i{
        display: inline-block;
        color:#f8eb73 !important;

    }

    .day .icon-container .nursingvacation i{
        display: inline-block;
        color:rgb(249, 154, 134) !important;

    }

    .day .icon-container .contract i{
        display: inline-block;
    }

    .day .icon-container .sickness i{
        display: inline-block;
        color:#e5154f !important;
    }

    .day .icon-container .schooling i{
        display: inline-block;
        color:#348feb !important;
    }

    .day .icon-container .wagecontinuation i{
        display: inline-block;
        color:#eb7d34 !important;
    }

    .day .icon-container .holidayadjustment i{
        display: inline-block;
        color:#40eded !important;
    }

    .day .icon-container .miscunavailable i{
        display: inline-block;
        color:#e5154f !important;
    }

    .day .icon-container .birthday i{
        display: inline-block;
        color: rgb(250, 102, 213) !important;
    }

    .day .icon-container .extrapayment i{
        display: inline-block;
        color: #eb7d34 !important;
    }

    .day .icon-container .unavailable i{
        display: inline-block;
    }

    .day .icon-container .undesired i{
        display: inline-block;
        color:#cecece !important;
    }

    .day .icon-container .desired i{
        display: inline-block;
        color:#cecece !important;
    }

    .fa-tasks-alt{
        transform: scale(0.4) !important;
    }

    .logbutton-div {
        display: inline-block;
        position: fixed;

    }
    .logbutton-container {
        z-index: 10000;
        top: auto;
        left: auto;
        bottom: 200px;
        right: 36px;
    }
    .square-button {
        height: 52px !important;
        width: 52px !important;
        padding-top: 0rem;
        padding-right: 0rem;
        padding-bottom:0rem;
        padding-left: 0rem;
        background-color: #c1c1c1;
        border-color: #c1c1c1;
    }

    .square-button.active {
        height: 52px !important;
        width: 52px !important;
        padding-top: 0rem;
        padding-right: 0rem;
        padding-bottom:0rem;
        padding-left: 0rem;
        background-color: var(--col-ok) !important;
        border-color: var(--col-ok) !important;
    }
    .align-middle{
        justify-self: center;
    }


    .day-mode .header>.button {
        padding-left: 9px;
        padding-right: 9px;
    }

    .day-mode.header .align-middle .button.big{
        margin-right: 30px;
    }

    .day-mode.header .align-middle .options.big{
        margin-right: 145px;
    }

    .day-mode.header .align-middle.left{
        margin-left: 10px;
        margin-right: -370px;
        /*margin-left: 200px;*/
    }


    @media (max-width: 1400px) {
        .day-mode.header .align-middle.left{
            margin-left: 10px;
            margin-right: -370px;
        }
        .day-mode.header .align-middle.right{
            margin-left: 250px;
        }
    }

    @media (max-width: 950px) {
        .header.buttonheader:not(.day-mode) .align-middle{
            /*margin-left: 300px;*/
        }
        .header.buttonheader:not(.day-mode) .align-right{
            flex: 0 !important;
        }
    }
    @media (max-width: 800px) {

        .header.buttonheader:not(.day-mode) .align-middle{
            display: none;
        }
    }
    @media (max-width: 800px) {

        .header.buttonheader .align-middle.right{
            display: none;
        }
        .day-mode.header .align-middle.left {
            margin-right: auto;
            margin-left: auto;
        }
    }


    @media (min-width: 700px) {

        .header.buttonheader:not(.day-mode) .align-right.list{
            display:none;
        }
    }
    @media (min-width: 800px) {

        .day-mode .align-right.list{
            display:none;
        }
    }



    .sub-header{
        display: flex;
        height: 50px;
        z-index: 6;
        justify-content: left;
        position: fixed;
        /*top: 5px;*/
        width: calc(100vw - 275px);
        left: 260px;
        pointer-events: none;
        background: var(--bg);
    }

    .show-unassigned .sub-header{
        width: calc(100vw - 567px);
    }
    .sub-header .title{
        position: relative;
        display: flex;
        align-self: flex-start;
        justify-content: center;
        padding: 0;
        top: 1px;
    }

    .sub-header .title .label{
        font-size: 16px;
        font-weight: 500;
    }

    .sub-header .title .label.year{
        color: #6d8d23;;
        margin-right: 5px;
        font-weight: 800;
    }


    .entry.group > .header > .fa-stack{
        opacity: 0;
        right: 3px;
        transition: .0s;
    }

    .entry.group > .header > .fa-stack.add{
        right: 3px;
        transition: .0s;
    }
    .entry.group > .header > .spot-icon{
        transition: .0s;
        right: 3px;
    }
    .entry.group > .header:hover > .fa-stack{
        opacity: 1;
        right: 5px;
    }
    .entry.group > .header:hover > .fa-stack.add{
        right: 13px;
    }
    .entry.group > .header:hover > .spot-icon{
        right: 37px;
    }

    .fa-stack.detail{
        display: none;
        transition: .2s;
    }

    .fa-stack.skill{
        display: block;
    }

    .day .shift-count{

        right: -3px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        background: #bebebe !important;
        position: absolute;
        font-size: 7px;
        bottom: -3px;
        z-index: 1;
        height: 11px;
        width: 11px;
        border-radius: 100px;
    }

    .day.Green .shift-count{
        background: #6d8d23 !important;
        color: white;
    }

    .day.Orange .shift-count{
        background: #eba767 !important;
        color: white;
    }

    .template-flag{
        left: -3px;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background: var(--contrast-1) !important;
        position: absolute;
        font-size: 6px;
        top: -3px;
        z-index: 1;
        height: 10px;
        width: 10px;
        border-radius: 100px;
        padding-top: 2px;
    }

    .dragged-shift {
        background: rgba(0,0,0,.3) !important;
        opacity: 0.2 !important;
        box-shadow: 0 0 3px 0px rgba(0,0,0,.3) !important;
        transform: scale(.95) !important;
    }
    .dragged-shift > *{
        opacity: 0;
    }

    .shift-drag-overlay{
        opacity: .2;
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height: 1000vh;
        display: none;
        background: black;

    }

    .mdcontext {
        z-index: 1000001;
    }

    .loading-md.snapshots{
        background: rgba(0,0,0,.4) !important;
    }
    .loading-md.snapshots * {
        color: white !important;
    }



</style>

<!-- PersonnelDeployment styles -->
<style scoped>
.pd-container {
  position: absolute;
  left: 0;
  bottom: calc(2rem + 4px);
  width: 100%;
  height: 100%;
  max-height: 20rem;
  transition: max-height 250ms ease-in-out;
  /*background-color: var(--bg);*/
  z-index: 10;
}

.pd-container.pd-collapsed {
  max-height: 40px;
  background-color: var(--contrast-1);
}

.pd-container > .pd-detail {
  position: absolute;
  left: 0;
  width: 265px;
  height: 20rem;
  max-height: 20rem;
  transition: max-height 250ms ease-in-out;
  z-index: 2;
}

.pd-container.pd-collapsed > .pd-detail {
  max-height: 40px;
  overflow-y: hidden;
}

.pd-container > .pd-chart {
  position: absolute;
  left: 265px;
  right: 0;
  height: 20rem;
  max-width: 500%;
  max-height: 20rem;
  transition: max-width 175ms ease-in-out 75ms;
}

.pd-container.pd-collapsed > .pd-chart {
  max-width: 0;
  overflow: hidden;
}

.pd-section-toggle {
  cursor: pointer;
  padding: 0.25rem;
  margin-right: 0.25em;
  transform: rotate(0deg);
  transition: transform 750ms ease-in-out;
}

.pd-section-toggle.pd-toggle-up {
  transform: rotate(180deg);
}


.info-video-container {
    position: fixed;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0,0,0,0.5);
    z-index: 1001;
}

.info-video-sheet {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    background-color: var(--bg);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.5);
    padding: 0.5rem 1rem 1rem;
    width: min(95%, 720px);
    aspect-ratio: 16 / 9;
}

.close-video-button {
    /* position: absolute; */
    background-color: transparent;
    margin: 0.25rem;
    border: none;
    outline: none;
    box-shadow: none;
    color: var(--contrast-5);
    font-size: 1rem;
}

.key-figure {
    pointer-events: none;
    font-size: 0.65rem;
    font-family: DistrictProBold, serif;
    border-bottom: 1px solid var(--col-label-default);
}

.key-figure-table {
    position: absolute;
    line-height: 1.42;
    top: 65px;
    left: 130px;
    font-size: 0.65rem;
    font-family: DistrictProBold, serif;
    text-align: left;
    color: var(--col-label-default)
}

.orange-c {
    color: #e86e13;
}

.green-c {
    color: #879d53;
}

.md-card {
    position: fixed;
    z-index: 1000000;
    width: calc(60% - 18px);
    padding-bottom: 10px;
    top: 135px;
    left: 20%;
    right: auto;
    resize: both;
    overflow: hidden;
}

.md-card-header {
    background: var(--contrast-4);
    color: var(--contrast-0);
    padding: 10px 30px 10px;
    font-weight: bold;
}

.md-card-body {
    padding: 0 15px 0;
    max-height: 389px;
    overflow-y: auto;
    overflow-x: auto;
    min-height: 50px;
}

</style>
